var DU = Object.defineProperty;
var gU = (l, u, T) => u in l ? DU(l, u, { enumerable: !0, configurable: !0, writable: !0, value: T }) : l[u] = T;
var Yn = (l, u, T) => (gU(l, typeof u != "symbol" ? u + "" : u, T), T);
function PU(l, u) {
  for (var T = 0; T < u.length; T++) {
    const N = u[T];
    if (typeof N != "string" && !Array.isArray(N)) {
      for (const O in N)
        if (O !== "default" && !(O in l)) {
          const h = Object.getOwnPropertyDescriptor(N, O);
          h && Object.defineProperty(l, O, h.get ? h : {
            enumerable: !0,
            get: () => N[O]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }));
}
var YS = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _A(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var II = { exports: {} }, hA = {}, DS = { exports: {} }, bt = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var um;
function MU() {
  if (um)
    return bt;
  um = 1;
  var l = Symbol.for("react.element"), u = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), N = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), d = Symbol.for("react.context"), G = Symbol.for("react.forward_ref"), D = Symbol.for("react.suspense"), v = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), g = Symbol.iterator;
  function w(U) {
    return U === null || typeof U != "object" ? null : (U = g && U[g] || U["@@iterator"], typeof U == "function" ? U : null);
  }
  var Y = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, j = Object.assign, oe = {};
  function me(U, q, Ie) {
    this.props = U, this.context = q, this.refs = oe, this.updater = Ie || Y;
  }
  me.prototype.isReactComponent = {}, me.prototype.setState = function(U, q) {
    if (typeof U != "object" && typeof U != "function" && U != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, U, q, "setState");
  }, me.prototype.forceUpdate = function(U) {
    this.updater.enqueueForceUpdate(this, U, "forceUpdate");
  };
  function Le() {
  }
  Le.prototype = me.prototype;
  function Oe(U, q, Ie) {
    this.props = U, this.context = q, this.refs = oe, this.updater = Ie || Y;
  }
  var he = Oe.prototype = new Le();
  he.constructor = Oe, j(he, me.prototype), he.isPureReactComponent = !0;
  var Fe = Array.isArray, ye = Object.prototype.hasOwnProperty, je = { current: null }, Xe = { key: !0, ref: !0, __self: !0, __source: !0 };
  function yt(U, q, Ie) {
    var Ye, We = {}, vt = null, ut = null;
    if (q != null)
      for (Ye in q.ref !== void 0 && (ut = q.ref), q.key !== void 0 && (vt = "" + q.key), q)
        ye.call(q, Ye) && !Xe.hasOwnProperty(Ye) && (We[Ye] = q[Ye]);
    var Ot = arguments.length - 2;
    if (Ot === 1)
      We.children = Ie;
    else if (1 < Ot) {
      for (var lt = Array(Ot), At = 0; At < Ot; At++)
        lt[At] = arguments[At + 2];
      We.children = lt;
    }
    if (U && U.defaultProps)
      for (Ye in Ot = U.defaultProps, Ot)
        We[Ye] === void 0 && (We[Ye] = Ot[Ye]);
    return { $$typeof: l, type: U, key: vt, ref: ut, props: We, _owner: je.current };
  }
  function ht(U, q) {
    return { $$typeof: l, type: U.type, key: q, ref: U.ref, props: U.props, _owner: U._owner };
  }
  function Qe(U) {
    return typeof U == "object" && U !== null && U.$$typeof === l;
  }
  function gt(U) {
    var q = { "=": "=0", ":": "=2" };
    return "$" + U.replace(/[=:]/g, function(Ie) {
      return q[Ie];
    });
  }
  var Rn = /\/+/g;
  function Se(U, q) {
    return typeof U == "object" && U !== null && U.key != null ? gt("" + U.key) : q.toString(36);
  }
  function le(U, q, Ie, Ye, We) {
    var vt = typeof U;
    (vt === "undefined" || vt === "boolean") && (U = null);
    var ut = !1;
    if (U === null)
      ut = !0;
    else
      switch (vt) {
        case "string":
        case "number":
          ut = !0;
          break;
        case "object":
          switch (U.$$typeof) {
            case l:
            case u:
              ut = !0;
          }
      }
    if (ut)
      return ut = U, We = We(ut), U = Ye === "" ? "." + Se(ut, 0) : Ye, Fe(We) ? (Ie = "", U != null && (Ie = U.replace(Rn, "$&/") + "/"), le(We, q, Ie, "", function(At) {
        return At;
      })) : We != null && (Qe(We) && (We = ht(We, Ie + (!We.key || ut && ut.key === We.key ? "" : ("" + We.key).replace(Rn, "$&/") + "/") + U)), q.push(We)), 1;
    if (ut = 0, Ye = Ye === "" ? "." : Ye + ":", Fe(U))
      for (var Ot = 0; Ot < U.length; Ot++) {
        vt = U[Ot];
        var lt = Ye + Se(vt, Ot);
        ut += le(vt, q, Ie, lt, We);
      }
    else if (lt = w(U), typeof lt == "function")
      for (U = lt.call(U), Ot = 0; !(vt = U.next()).done; )
        vt = vt.value, lt = Ye + Se(vt, Ot++), ut += le(vt, q, Ie, lt, We);
    else if (vt === "object")
      throw q = String(U), Error("Objects are not valid as a React child (found: " + (q === "[object Object]" ? "object with keys {" + Object.keys(U).join(", ") + "}" : q) + "). If you meant to render a collection of children, use an array instead.");
    return ut;
  }
  function ce(U, q, Ie) {
    if (U == null)
      return U;
    var Ye = [], We = 0;
    return le(U, Ye, "", "", function(vt) {
      return q.call(Ie, vt, We++);
    }), Ye;
  }
  function ve(U) {
    if (U._status === -1) {
      var q = U._result;
      q = q(), q.then(function(Ie) {
        (U._status === 0 || U._status === -1) && (U._status = 1, U._result = Ie);
      }, function(Ie) {
        (U._status === 0 || U._status === -1) && (U._status = 2, U._result = Ie);
      }), U._status === -1 && (U._status = 0, U._result = q);
    }
    if (U._status === 1)
      return U._result.default;
    throw U._result;
  }
  var ee = { current: null }, te = { transition: null }, Ae = { ReactCurrentDispatcher: ee, ReactCurrentBatchConfig: te, ReactCurrentOwner: je };
  return bt.Children = { map: ce, forEach: function(U, q, Ie) {
    ce(U, function() {
      q.apply(this, arguments);
    }, Ie);
  }, count: function(U) {
    var q = 0;
    return ce(U, function() {
      q++;
    }), q;
  }, toArray: function(U) {
    return ce(U, function(q) {
      return q;
    }) || [];
  }, only: function(U) {
    if (!Qe(U))
      throw Error("React.Children.only expected to receive a single React element child.");
    return U;
  } }, bt.Component = me, bt.Fragment = T, bt.Profiler = O, bt.PureComponent = Oe, bt.StrictMode = N, bt.Suspense = D, bt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ae, bt.cloneElement = function(U, q, Ie) {
    if (U == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + U + ".");
    var Ye = j({}, U.props), We = U.key, vt = U.ref, ut = U._owner;
    if (q != null) {
      if (q.ref !== void 0 && (vt = q.ref, ut = je.current), q.key !== void 0 && (We = "" + q.key), U.type && U.type.defaultProps)
        var Ot = U.type.defaultProps;
      for (lt in q)
        ye.call(q, lt) && !Xe.hasOwnProperty(lt) && (Ye[lt] = q[lt] === void 0 && Ot !== void 0 ? Ot[lt] : q[lt]);
    }
    var lt = arguments.length - 2;
    if (lt === 1)
      Ye.children = Ie;
    else if (1 < lt) {
      Ot = Array(lt);
      for (var At = 0; At < lt; At++)
        Ot[At] = arguments[At + 2];
      Ye.children = Ot;
    }
    return { $$typeof: l, type: U.type, key: We, ref: vt, props: Ye, _owner: ut };
  }, bt.createContext = function(U) {
    return U = { $$typeof: d, _currentValue: U, _currentValue2: U, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, U.Provider = { $$typeof: h, _context: U }, U.Consumer = U;
  }, bt.createElement = yt, bt.createFactory = function(U) {
    var q = yt.bind(null, U);
    return q.type = U, q;
  }, bt.createRef = function() {
    return { current: null };
  }, bt.forwardRef = function(U) {
    return { $$typeof: G, render: U };
  }, bt.isValidElement = Qe, bt.lazy = function(U) {
    return { $$typeof: M, _payload: { _status: -1, _result: U }, _init: ve };
  }, bt.memo = function(U, q) {
    return { $$typeof: v, type: U, compare: q === void 0 ? null : q };
  }, bt.startTransition = function(U) {
    var q = te.transition;
    te.transition = {};
    try {
      U();
    } finally {
      te.transition = q;
    }
  }, bt.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
  }, bt.useCallback = function(U, q) {
    return ee.current.useCallback(U, q);
  }, bt.useContext = function(U) {
    return ee.current.useContext(U);
  }, bt.useDebugValue = function() {
  }, bt.useDeferredValue = function(U) {
    return ee.current.useDeferredValue(U);
  }, bt.useEffect = function(U, q) {
    return ee.current.useEffect(U, q);
  }, bt.useId = function() {
    return ee.current.useId();
  }, bt.useImperativeHandle = function(U, q, Ie) {
    return ee.current.useImperativeHandle(U, q, Ie);
  }, bt.useInsertionEffect = function(U, q) {
    return ee.current.useInsertionEffect(U, q);
  }, bt.useLayoutEffect = function(U, q) {
    return ee.current.useLayoutEffect(U, q);
  }, bt.useMemo = function(U, q) {
    return ee.current.useMemo(U, q);
  }, bt.useReducer = function(U, q, Ie) {
    return ee.current.useReducer(U, q, Ie);
  }, bt.useRef = function(U) {
    return ee.current.useRef(U);
  }, bt.useState = function(U) {
    return ee.current.useState(U);
  }, bt.useSyncExternalStore = function(U, q, Ie) {
    return ee.current.useSyncExternalStore(U, q, Ie);
  }, bt.useTransition = function() {
    return ee.current.useTransition();
  }, bt.version = "18.2.0", bt;
}
var DA = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
DA.exports;
var Em;
function UU() {
  return Em || (Em = 1, function(l, u) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var T = "18.2.0", N = Symbol.for("react.element"), O = Symbol.for("react.portal"), h = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), G = Symbol.for("react.profiler"), D = Symbol.for("react.provider"), v = Symbol.for("react.context"), M = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), Y = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), oe = Symbol.for("react.offscreen"), me = Symbol.iterator, Le = "@@iterator";
      function Oe(I) {
        if (I === null || typeof I != "object")
          return null;
        var _ = me && I[me] || I[Le];
        return typeof _ == "function" ? _ : null;
      }
      var he = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Fe = {
        transition: null
      }, ye = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, je = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Xe = {}, yt = null;
      function ht(I) {
        yt = I;
      }
      Xe.setExtraStackFrame = function(I) {
        yt = I;
      }, Xe.getCurrentStack = null, Xe.getStackAddendum = function() {
        var I = "";
        yt && (I += yt);
        var _ = Xe.getCurrentStack;
        return _ && (I += _() || ""), I;
      };
      var Qe = !1, gt = !1, Rn = !1, Se = !1, le = !1, ce = {
        ReactCurrentDispatcher: he,
        ReactCurrentBatchConfig: Fe,
        ReactCurrentOwner: je
      };
      ce.ReactDebugCurrentFrame = Xe, ce.ReactCurrentActQueue = ye;
      function ve(I) {
        {
          for (var _ = arguments.length, J = new Array(_ > 1 ? _ - 1 : 0), $ = 1; $ < _; $++)
            J[$ - 1] = arguments[$];
          te("warn", I, J);
        }
      }
      function ee(I) {
        {
          for (var _ = arguments.length, J = new Array(_ > 1 ? _ - 1 : 0), $ = 1; $ < _; $++)
            J[$ - 1] = arguments[$];
          te("error", I, J);
        }
      }
      function te(I, _, J) {
        {
          var $ = ce.ReactDebugCurrentFrame, Ce = $.getStackAddendum();
          Ce !== "" && (_ += "%s", J = J.concat([Ce]));
          var at = J.map(function(Me) {
            return String(Me);
          });
          at.unshift("Warning: " + _), Function.prototype.apply.call(console[I], console, at);
        }
      }
      var Ae = {};
      function U(I, _) {
        {
          var J = I.constructor, $ = J && (J.displayName || J.name) || "ReactClass", Ce = $ + "." + _;
          if (Ae[Ce])
            return;
          ee("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", _, $), Ae[Ce] = !0;
        }
      }
      var q = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(I) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(I, _, J) {
          U(I, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(I, _, J, $) {
          U(I, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(I, _, J, $) {
          U(I, "setState");
        }
      }, Ie = Object.assign, Ye = {};
      Object.freeze(Ye);
      function We(I, _, J) {
        this.props = I, this.context = _, this.refs = Ye, this.updater = J || q;
      }
      We.prototype.isReactComponent = {}, We.prototype.setState = function(I, _) {
        if (typeof I != "object" && typeof I != "function" && I != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, I, _, "setState");
      }, We.prototype.forceUpdate = function(I) {
        this.updater.enqueueForceUpdate(this, I, "forceUpdate");
      };
      {
        var vt = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, ut = function(I, _) {
          Object.defineProperty(We.prototype, I, {
            get: function() {
              ve("%s(...) is deprecated in plain JavaScript React classes. %s", _[0], _[1]);
            }
          });
        };
        for (var Ot in vt)
          vt.hasOwnProperty(Ot) && ut(Ot, vt[Ot]);
      }
      function lt() {
      }
      lt.prototype = We.prototype;
      function At(I, _, J) {
        this.props = I, this.context = _, this.refs = Ye, this.updater = J || q;
      }
      var Cn = At.prototype = new lt();
      Cn.constructor = At, Ie(Cn, We.prototype), Cn.isPureReactComponent = !0;
      function gn() {
        var I = {
          current: null
        };
        return Object.seal(I), I;
      }
      var Jn = Array.isArray;
      function hn(I) {
        return Jn(I);
      }
      function nr(I) {
        {
          var _ = typeof Symbol == "function" && Symbol.toStringTag, J = _ && I[Symbol.toStringTag] || I.constructor.name || "Object";
          return J;
        }
      }
      function Qn(I) {
        try {
          return Zn(I), !1;
        } catch {
          return !0;
        }
      }
      function Zn(I) {
        return "" + I;
      }
      function Gn(I) {
        if (Qn(I))
          return ee("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nr(I)), Zn(I);
      }
      function Zr(I, _, J) {
        var $ = I.displayName;
        if ($)
          return $;
        var Ce = _.displayName || _.name || "";
        return Ce !== "" ? J + "(" + Ce + ")" : J;
      }
      function qr(I) {
        return I.displayName || "Context";
      }
      function rr(I) {
        if (I == null)
          return null;
        if (typeof I.tag == "number" && ee("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof I == "function")
          return I.displayName || I.name || null;
        if (typeof I == "string")
          return I;
        switch (I) {
          case h:
            return "Fragment";
          case O:
            return "Portal";
          case G:
            return "Profiler";
          case d:
            return "StrictMode";
          case g:
            return "Suspense";
          case w:
            return "SuspenseList";
        }
        if (typeof I == "object")
          switch (I.$$typeof) {
            case v:
              var _ = I;
              return qr(_) + ".Consumer";
            case D:
              var J = I;
              return qr(J._context) + ".Provider";
            case M:
              return Zr(I, I.render, "ForwardRef");
            case Y:
              var $ = I.displayName || null;
              return $ !== null ? $ : rr(I.type) || "Memo";
            case j: {
              var Ce = I, at = Ce._payload, Me = Ce._init;
              try {
                return rr(Me(at));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Ir = Object.prototype.hasOwnProperty, $r = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Cr, Oa, ur;
      ur = {};
      function ea(I) {
        if (Ir.call(I, "ref")) {
          var _ = Object.getOwnPropertyDescriptor(I, "ref").get;
          if (_ && _.isReactWarning)
            return !1;
        }
        return I.ref !== void 0;
      }
      function vn(I) {
        if (Ir.call(I, "key")) {
          var _ = Object.getOwnPropertyDescriptor(I, "key").get;
          if (_ && _.isReactWarning)
            return !1;
        }
        return I.key !== void 0;
      }
      function Pr(I, _) {
        var J = function() {
          Cr || (Cr = !0, ee("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        J.isReactWarning = !0, Object.defineProperty(I, "key", {
          get: J,
          configurable: !0
        });
      }
      function Ci(I, _) {
        var J = function() {
          Oa || (Oa = !0, ee("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        J.isReactWarning = !0, Object.defineProperty(I, "ref", {
          get: J,
          configurable: !0
        });
      }
      function Ia(I) {
        if (typeof I.ref == "string" && je.current && I.__self && je.current.stateNode !== I.__self) {
          var _ = rr(je.current.type);
          ur[_] || (ee('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _, I.ref), ur[_] = !0);
        }
      }
      var De = function(I, _, J, $, Ce, at, Me) {
        var nt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: N,
          // Built-in properties that belong on the element
          type: I,
          key: _,
          ref: J,
          props: Me,
          // Record the component responsible for creating this element.
          _owner: at
        };
        return nt._store = {}, Object.defineProperty(nt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(nt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: $
        }), Object.defineProperty(nt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ce
        }), Object.freeze && (Object.freeze(nt.props), Object.freeze(nt)), nt;
      };
      function Ze(I, _, J) {
        var $, Ce = {}, at = null, Me = null, nt = null, Lt = null;
        if (_ != null) {
          ea(_) && (Me = _.ref, Ia(_)), vn(_) && (Gn(_.key), at = "" + _.key), nt = _.__self === void 0 ? null : _.__self, Lt = _.__source === void 0 ? null : _.__source;
          for ($ in _)
            Ir.call(_, $) && !$r.hasOwnProperty($) && (Ce[$] = _[$]);
        }
        var Ft = arguments.length - 2;
        if (Ft === 1)
          Ce.children = J;
        else if (Ft > 1) {
          for (var sn = Array(Ft), nn = 0; nn < Ft; nn++)
            sn[nn] = arguments[nn + 2];
          Object.freeze && Object.freeze(sn), Ce.children = sn;
        }
        if (I && I.defaultProps) {
          var un = I.defaultProps;
          for ($ in un)
            Ce[$] === void 0 && (Ce[$] = un[$]);
        }
        if (at || Me) {
          var An = typeof I == "function" ? I.displayName || I.name || "Unknown" : I;
          at && Pr(Ce, An), Me && Ci(Ce, An);
        }
        return De(I, at, Me, nt, Lt, je.current, Ce);
      }
      function mt(I, _) {
        var J = De(I.type, _, I.ref, I._self, I._source, I._owner, I.props);
        return J;
      }
      function Kt(I, _, J) {
        if (I == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + I + ".");
        var $, Ce = Ie({}, I.props), at = I.key, Me = I.ref, nt = I._self, Lt = I._source, Ft = I._owner;
        if (_ != null) {
          ea(_) && (Me = _.ref, Ft = je.current), vn(_) && (Gn(_.key), at = "" + _.key);
          var sn;
          I.type && I.type.defaultProps && (sn = I.type.defaultProps);
          for ($ in _)
            Ir.call(_, $) && !$r.hasOwnProperty($) && (_[$] === void 0 && sn !== void 0 ? Ce[$] = sn[$] : Ce[$] = _[$]);
        }
        var nn = arguments.length - 2;
        if (nn === 1)
          Ce.children = J;
        else if (nn > 1) {
          for (var un = Array(nn), An = 0; An < nn; An++)
            un[An] = arguments[An + 2];
          Ce.children = un;
        }
        return De(I.type, at, Me, nt, Lt, Ft, Ce);
      }
      function zt(I) {
        return typeof I == "object" && I !== null && I.$$typeof === N;
      }
      var xn = ".", mn = ":";
      function hr(I) {
        var _ = /[=:]/g, J = {
          "=": "=0",
          ":": "=2"
        }, $ = I.replace(_, function(Ce) {
          return J[Ce];
        });
        return "$" + $;
      }
      var tn = !1, Mr = /\/+/g;
      function Jt(I) {
        return I.replace(Mr, "$&/");
      }
      function Qt(I, _) {
        return typeof I == "object" && I !== null && I.key != null ? (Gn(I.key), hr("" + I.key)) : _.toString(36);
      }
      function ni(I, _, J, $, Ce) {
        var at = typeof I;
        (at === "undefined" || at === "boolean") && (I = null);
        var Me = !1;
        if (I === null)
          Me = !0;
        else
          switch (at) {
            case "string":
            case "number":
              Me = !0;
              break;
            case "object":
              switch (I.$$typeof) {
                case N:
                case O:
                  Me = !0;
              }
          }
        if (Me) {
          var nt = I, Lt = Ce(nt), Ft = $ === "" ? xn + Qt(nt, 0) : $;
          if (hn(Lt)) {
            var sn = "";
            Ft != null && (sn = Jt(Ft) + "/"), ni(Lt, _, sn, "", function(dT) {
              return dT;
            });
          } else
            Lt != null && (zt(Lt) && (Lt.key && (!nt || nt.key !== Lt.key) && Gn(Lt.key), Lt = mt(
              Lt,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              J + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (Lt.key && (!nt || nt.key !== Lt.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                Jt("" + Lt.key) + "/"
              ) : "") + Ft
            )), _.push(Lt));
          return 1;
        }
        var nn, un, An = 0, Ut = $ === "" ? xn : $ + mn;
        if (hn(I))
          for (var ji = 0; ji < I.length; ji++)
            nn = I[ji], un = Ut + Qt(nn, ji), An += ni(nn, _, J, un, Ce);
        else {
          var ps = Oe(I);
          if (typeof ps == "function") {
            var Au = I;
            ps === Au.entries && (tn || ve("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), tn = !0);
            for (var RT = ps.call(Au), oi, Ru = 0; !(oi = RT.next()).done; )
              nn = oi.value, un = Ut + Qt(nn, Ru++), An += ni(nn, _, J, un, Ce);
          } else if (at === "object") {
            var du = String(I);
            throw new Error("Objects are not valid as a React child (found: " + (du === "[object Object]" ? "object with keys {" + Object.keys(I).join(", ") + "}" : du) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return An;
      }
      function Ba(I, _, J) {
        if (I == null)
          return I;
        var $ = [], Ce = 0;
        return ni(I, $, "", "", function(at) {
          return _.call(J, at, Ce++);
        }), $;
      }
      function Do(I) {
        var _ = 0;
        return Ba(I, function() {
          _++;
        }), _;
      }
      function hl(I, _, J) {
        Ba(I, function() {
          _.apply(this, arguments);
        }, J);
      }
      function ls(I) {
        return Ba(I, function(_) {
          return _;
        }) || [];
      }
      function Xi(I) {
        if (!zt(I))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return I;
      }
      function go(I) {
        var _ = {
          $$typeof: v,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: I,
          _currentValue2: I,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        _.Provider = {
          $$typeof: D,
          _context: _
        };
        var J = !1, $ = !1, Ce = !1;
        {
          var at = {
            $$typeof: v,
            _context: _
          };
          Object.defineProperties(at, {
            Provider: {
              get: function() {
                return $ || ($ = !0, ee("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), _.Provider;
              },
              set: function(Me) {
                _.Provider = Me;
              }
            },
            _currentValue: {
              get: function() {
                return _._currentValue;
              },
              set: function(Me) {
                _._currentValue = Me;
              }
            },
            _currentValue2: {
              get: function() {
                return _._currentValue2;
              },
              set: function(Me) {
                _._currentValue2 = Me;
              }
            },
            _threadCount: {
              get: function() {
                return _._threadCount;
              },
              set: function(Me) {
                _._threadCount = Me;
              }
            },
            Consumer: {
              get: function() {
                return J || (J = !0, ee("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), _.Consumer;
              }
            },
            displayName: {
              get: function() {
                return _.displayName;
              },
              set: function(Me) {
                Ce || (ve("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Me), Ce = !0);
              }
            }
          }), _.Consumer = at;
        }
        return _._currentRenderer = null, _._currentRenderer2 = null, _;
      }
      var Ca = -1, hi = 0, ha = 1, vi = 2;
      function Ur(I) {
        if (I._status === Ca) {
          var _ = I._result, J = _();
          if (J.then(function(at) {
            if (I._status === hi || I._status === Ca) {
              var Me = I;
              Me._status = ha, Me._result = at;
            }
          }, function(at) {
            if (I._status === hi || I._status === Ca) {
              var Me = I;
              Me._status = vi, Me._result = at;
            }
          }), I._status === Ca) {
            var $ = I;
            $._status = hi, $._result = J;
          }
        }
        if (I._status === ha) {
          var Ce = I._result;
          return Ce === void 0 && ee(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Ce), "default" in Ce || ee(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Ce), Ce.default;
        } else
          throw I._result;
      }
      function va(I) {
        var _ = {
          // We use these fields to store the result.
          _status: Ca,
          _result: I
        }, J = {
          $$typeof: j,
          _payload: _,
          _init: Ur
        };
        {
          var $, Ce;
          Object.defineProperties(J, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return $;
              },
              set: function(at) {
                ee("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), $ = at, Object.defineProperty(J, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Ce;
              },
              set: function(at) {
                ee("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ce = at, Object.defineProperty(J, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return J;
      }
      function mi(I) {
        I != null && I.$$typeof === Y ? ee("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof I != "function" ? ee("forwardRef requires a render function but was given %s.", I === null ? "null" : typeof I) : I.length !== 0 && I.length !== 2 && ee("forwardRef render functions accept exactly two parameters: props and ref. %s", I.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), I != null && (I.defaultProps != null || I.propTypes != null) && ee("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var _ = {
          $$typeof: M,
          render: I
        };
        {
          var J;
          Object.defineProperty(_, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return J;
            },
            set: function($) {
              J = $, !I.name && !I.displayName && (I.displayName = $);
            }
          });
        }
        return _;
      }
      var x;
      x = Symbol.for("react.module.reference");
      function Ee(I) {
        return !!(typeof I == "string" || typeof I == "function" || I === h || I === G || le || I === d || I === g || I === w || Se || I === oe || Qe || gt || Rn || typeof I == "object" && I !== null && (I.$$typeof === j || I.$$typeof === Y || I.$$typeof === D || I.$$typeof === v || I.$$typeof === M || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        I.$$typeof === x || I.getModuleId !== void 0));
      }
      function ge(I, _) {
        Ee(I) || ee("memo: The first argument must be a component. Instead received: %s", I === null ? "null" : typeof I);
        var J = {
          $$typeof: Y,
          type: I,
          compare: _ === void 0 ? null : _
        };
        {
          var $;
          Object.defineProperty(J, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return $;
            },
            set: function(Ce) {
              $ = Ce, !I.name && !I.displayName && (I.displayName = Ce);
            }
          });
        }
        return J;
      }
      function be() {
        var I = he.current;
        return I === null && ee(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), I;
      }
      function dt(I) {
        var _ = be();
        if (I._context !== void 0) {
          var J = I._context;
          J.Consumer === I ? ee("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : J.Provider === I && ee("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return _.useContext(I);
      }
      function _t(I) {
        var _ = be();
        return _.useState(I);
      }
      function It(I, _, J) {
        var $ = be();
        return $.useReducer(I, _, J);
      }
      function et(I) {
        var _ = be();
        return _.useRef(I);
      }
      function Vn(I, _) {
        var J = be();
        return J.useEffect(I, _);
      }
      function Tn(I, _) {
        var J = be();
        return J.useInsertionEffect(I, _);
      }
      function fn(I, _) {
        var J = be();
        return J.useLayoutEffect(I, _);
      }
      function Er(I, _) {
        var J = be();
        return J.useCallback(I, _);
      }
      function Li(I, _) {
        var J = be();
        return J.useMemo(I, _);
      }
      function ss(I, _, J) {
        var $ = be();
        return $.useImperativeHandle(I, _, J);
      }
      function Ht(I, _) {
        {
          var J = be();
          return J.useDebugValue(I, _);
        }
      }
      function fT() {
        var I = be();
        return I.useTransition();
      }
      function ri(I) {
        var _ = be();
        return _.useDeferredValue(I);
      }
      function Dt() {
        var I = be();
        return I.useId();
      }
      function yi(I, _, J) {
        var $ = be();
        return $.useSyncExternalStore(I, _, J);
      }
      var Po = 0, us, Mo, ta, Eu, _r, cu, Tu;
      function GE() {
      }
      GE.__reactDisabledLog = !0;
      function Es() {
        {
          if (Po === 0) {
            us = console.log, Mo = console.info, ta = console.warn, Eu = console.error, _r = console.group, cu = console.groupCollapsed, Tu = console.groupEnd;
            var I = {
              configurable: !0,
              enumerable: !0,
              value: GE,
              writable: !0
            };
            Object.defineProperties(console, {
              info: I,
              log: I,
              warn: I,
              error: I,
              group: I,
              groupCollapsed: I,
              groupEnd: I
            });
          }
          Po++;
        }
      }
      function Uo() {
        {
          if (Po--, Po === 0) {
            var I = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: Ie({}, I, {
                value: us
              }),
              info: Ie({}, I, {
                value: Mo
              }),
              warn: Ie({}, I, {
                value: ta
              }),
              error: Ie({}, I, {
                value: Eu
              }),
              group: Ie({}, I, {
                value: _r
              }),
              groupCollapsed: Ie({}, I, {
                value: cu
              }),
              groupEnd: Ie({}, I, {
                value: Tu
              })
            });
          }
          Po < 0 && ee("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ai = ce.ReactCurrentDispatcher, Gr;
      function _o(I, _, J) {
        {
          if (Gr === void 0)
            try {
              throw Error();
            } catch (Ce) {
              var $ = Ce.stack.trim().match(/\n( *(at )?)/);
              Gr = $ && $[1] || "";
            }
          return `
` + Gr + I;
        }
      }
      var Go = !1, xo;
      {
        var cs = typeof WeakMap == "function" ? WeakMap : Map;
        xo = new cs();
      }
      function Ts(I, _) {
        if (!I || Go)
          return "";
        {
          var J = xo.get(I);
          if (J !== void 0)
            return J;
        }
        var $;
        Go = !0;
        var Ce = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var at;
        at = ai.current, ai.current = null, Es();
        try {
          if (_) {
            var Me = function() {
              throw Error();
            };
            if (Object.defineProperty(Me.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Me, []);
              } catch (Ut) {
                $ = Ut;
              }
              Reflect.construct(I, [], Me);
            } else {
              try {
                Me.call();
              } catch (Ut) {
                $ = Ut;
              }
              I.call(Me.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Ut) {
              $ = Ut;
            }
            I();
          }
        } catch (Ut) {
          if (Ut && $ && typeof Ut.stack == "string") {
            for (var nt = Ut.stack.split(`
`), Lt = $.stack.split(`
`), Ft = nt.length - 1, sn = Lt.length - 1; Ft >= 1 && sn >= 0 && nt[Ft] !== Lt[sn]; )
              sn--;
            for (; Ft >= 1 && sn >= 0; Ft--, sn--)
              if (nt[Ft] !== Lt[sn]) {
                if (Ft !== 1 || sn !== 1)
                  do
                    if (Ft--, sn--, sn < 0 || nt[Ft] !== Lt[sn]) {
                      var nn = `
` + nt[Ft].replace(" at new ", " at ");
                      return I.displayName && nn.includes("<anonymous>") && (nn = nn.replace("<anonymous>", I.displayName)), typeof I == "function" && xo.set(I, nn), nn;
                    }
                  while (Ft >= 1 && sn >= 0);
                break;
              }
          }
        } finally {
          Go = !1, ai.current = at, Uo(), Error.prepareStackTrace = Ce;
        }
        var un = I ? I.displayName || I.name : "", An = un ? _o(un) : "";
        return typeof I == "function" && xo.set(I, An), An;
      }
      function ki(I, _, J) {
        return Ts(I, !1);
      }
      function AT(I) {
        var _ = I.prototype;
        return !!(_ && _.isReactComponent);
      }
      function Di(I, _, J) {
        if (I == null)
          return "";
        if (typeof I == "function")
          return Ts(I, AT(I));
        if (typeof I == "string")
          return _o(I);
        switch (I) {
          case g:
            return _o("Suspense");
          case w:
            return _o("SuspenseList");
        }
        if (typeof I == "object")
          switch (I.$$typeof) {
            case M:
              return ki(I.render);
            case Y:
              return Di(I.type, _, J);
            case j: {
              var $ = I, Ce = $._payload, at = $._init;
              try {
                return Di(at(Ce), _, J);
              } catch {
              }
            }
          }
        return "";
      }
      var Vt = {}, fs = ce.ReactDebugCurrentFrame;
      function vl(I) {
        if (I) {
          var _ = I._owner, J = Di(I.type, I._source, _ ? _.type : null);
          fs.setExtraStackFrame(J);
        } else
          fs.setExtraStackFrame(null);
      }
      function As(I, _, J, $, Ce) {
        {
          var at = Function.call.bind(Ir);
          for (var Me in I)
            if (at(I, Me)) {
              var nt = void 0;
              try {
                if (typeof I[Me] != "function") {
                  var Lt = Error(($ || "React class") + ": " + J + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Lt.name = "Invariant Violation", Lt;
                }
                nt = I[Me](_, Me, $, J, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Ft) {
                nt = Ft;
              }
              nt && !(nt instanceof Error) && (vl(Ce), ee("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", $ || "React class", J, Me, typeof nt), vl(null)), nt instanceof Error && !(nt.message in Vt) && (Vt[nt.message] = !0, vl(Ce), ee("Failed %s type: %s", J, nt.message), vl(null));
            }
        }
      }
      function Bt(I) {
        if (I) {
          var _ = I._owner, J = Di(I.type, I._source, _ ? _.type : null);
          ht(J);
        } else
          ht(null);
      }
      var Rs;
      Rs = !1;
      function ds() {
        if (je.current) {
          var I = rr(je.current.type);
          if (I)
            return `

Check the render method of \`` + I + "`.";
        }
        return "";
      }
      function ct(I) {
        if (I !== void 0) {
          var _ = I.fileName.replace(/^.*[\\\/]/, ""), J = I.lineNumber;
          return `

Check your code at ` + _ + ":" + J + ".";
        }
        return "";
      }
      function ml(I) {
        return I != null ? ct(I.__source) : "";
      }
      var Ln = {};
      function na(I) {
        var _ = ds();
        if (!_) {
          var J = typeof I == "string" ? I : I.displayName || I.name;
          J && (_ = `

Check the top-level render call using <` + J + ">.");
        }
        return _;
      }
      function xr(I, _) {
        if (!(!I._store || I._store.validated || I.key != null)) {
          I._store.validated = !0;
          var J = na(_);
          if (!Ln[J]) {
            Ln[J] = !0;
            var $ = "";
            I && I._owner && I._owner !== je.current && ($ = " It was passed a child from " + rr(I._owner.type) + "."), Bt(I), ee('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', J, $), Bt(null);
          }
        }
      }
      function bo(I, _) {
        if (typeof I == "object") {
          if (hn(I))
            for (var J = 0; J < I.length; J++) {
              var $ = I[J];
              zt($) && xr($, _);
            }
          else if (zt(I))
            I._store && (I._store.validated = !0);
          else if (I) {
            var Ce = Oe(I);
            if (typeof Ce == "function" && Ce !== I.entries)
              for (var at = Ce.call(I), Me; !(Me = at.next()).done; )
                zt(Me.value) && xr(Me.value, _);
          }
        }
      }
      function Pn(I) {
        {
          var _ = I.type;
          if (_ == null || typeof _ == "string")
            return;
          var J;
          if (typeof _ == "function")
            J = _.propTypes;
          else if (typeof _ == "object" && (_.$$typeof === M || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          _.$$typeof === Y))
            J = _.propTypes;
          else
            return;
          if (J) {
            var $ = rr(_);
            As(J, I.props, "prop", $, I);
          } else if (_.PropTypes !== void 0 && !Rs) {
            Rs = !0;
            var Ce = rr(_);
            ee("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ce || "Unknown");
          }
          typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && ee("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Zt(I) {
        {
          for (var _ = Object.keys(I.props), J = 0; J < _.length; J++) {
            var $ = _[J];
            if ($ !== "children" && $ !== "key") {
              Bt(I), ee("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", $), Bt(null);
              break;
            }
          }
          I.ref !== null && (Bt(I), ee("Invalid attribute `ref` supplied to `React.Fragment`."), Bt(null));
        }
      }
      function xE(I, _, J) {
        var $ = Ee(I);
        if (!$) {
          var Ce = "";
          (I === void 0 || typeof I == "object" && I !== null && Object.keys(I).length === 0) && (Ce += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var at = ml(_);
          at ? Ce += at : Ce += ds();
          var Me;
          I === null ? Me = "null" : hn(I) ? Me = "array" : I !== void 0 && I.$$typeof === N ? (Me = "<" + (rr(I.type) || "Unknown") + " />", Ce = " Did you accidentally export a JSX literal instead of a component?") : Me = typeof I, ee("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Me, Ce);
        }
        var nt = Ze.apply(this, arguments);
        if (nt == null)
          return nt;
        if ($)
          for (var Lt = 2; Lt < arguments.length; Lt++)
            bo(arguments[Lt], I);
        return I === h ? Zt(nt) : Pn(nt), nt;
      }
      var ra = !1;
      function ar(I) {
        var _ = xE.bind(null, I);
        return _.type = I, ra || (ra = !0, ve("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(_, "type", {
          enumerable: !1,
          get: function() {
            return ve("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: I
            }), I;
          }
        }), _;
      }
      function gi(I, _, J) {
        for (var $ = Kt.apply(this, arguments), Ce = 2; Ce < arguments.length; Ce++)
          bo(arguments[Ce], $.type);
        return Pn($), $;
      }
      function bE(I, _) {
        var J = Fe.transition;
        Fe.transition = {};
        var $ = Fe.transition;
        Fe.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          I();
        } finally {
          if (Fe.transition = J, J === null && $._updatedFibers) {
            var Ce = $._updatedFibers.size;
            Ce > 10 && ve("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), $._updatedFibers.clear();
          }
        }
      }
      var Ki = !1, Ho = null;
      function HE(I) {
        if (Ho === null)
          try {
            var _ = ("require" + Math.random()).slice(0, 7), J = l && l[_];
            Ho = J.call(l, "timers").setImmediate;
          } catch {
            Ho = function(Ce) {
              Ki === !1 && (Ki = !0, typeof MessageChannel > "u" && ee("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var at = new MessageChannel();
              at.port1.onmessage = Ce, at.port2.postMessage(void 0);
            };
          }
        return Ho(I);
      }
      var Fa = 0, Bo = !1;
      function Fo(I) {
        {
          var _ = Fa;
          Fa++, ye.current === null && (ye.current = []);
          var J = ye.isBatchingLegacy, $;
          try {
            if (ye.isBatchingLegacy = !0, $ = I(), !J && ye.didScheduleLegacyUpdate) {
              var Ce = ye.current;
              Ce !== null && (ye.didScheduleLegacyUpdate = !1, Yo(Ce));
            }
          } catch (un) {
            throw wa(_), un;
          } finally {
            ye.isBatchingLegacy = J;
          }
          if ($ !== null && typeof $ == "object" && typeof $.then == "function") {
            var at = $, Me = !1, nt = {
              then: function(un, An) {
                Me = !0, at.then(function(Ut) {
                  wa(_), Fa === 0 ? Ss(Ut, un, An) : un(Ut);
                }, function(Ut) {
                  wa(_), An(Ut);
                });
              }
            };
            return !Bo && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              Me || (Bo = !0, ee("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), nt;
          } else {
            var Lt = $;
            if (wa(_), Fa === 0) {
              var Ft = ye.current;
              Ft !== null && (Yo(Ft), ye.current = null);
              var sn = {
                then: function(un, An) {
                  ye.current === null ? (ye.current = [], Ss(Lt, un, An)) : un(Lt);
                }
              };
              return sn;
            } else {
              var nn = {
                then: function(un, An) {
                  un(Lt);
                }
              };
              return nn;
            }
          }
        }
      }
      function wa(I) {
        I !== Fa - 1 && ee("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Fa = I;
      }
      function Ss(I, _, J) {
        {
          var $ = ye.current;
          if ($ !== null)
            try {
              Yo($), HE(function() {
                $.length === 0 ? (ye.current = null, _(I)) : Ss(I, _, J);
              });
            } catch (Ce) {
              J(Ce);
            }
          else
            _(I);
        }
      }
      var wo = !1;
      function Yo(I) {
        if (!wo) {
          wo = !0;
          var _ = 0;
          try {
            for (; _ < I.length; _++) {
              var J = I[_];
              do
                J = J(!0);
              while (J !== null);
            }
            I.length = 0;
          } catch ($) {
            throw I = I.slice(_ + 1), $;
          } finally {
            wo = !1;
          }
        }
      }
      var Ll = xE, Ns = gi, fu = ar, ii = {
        map: Ba,
        forEach: hl,
        count: Do,
        toArray: ls,
        only: Xi
      };
      u.Children = ii, u.Component = We, u.Fragment = h, u.Profiler = G, u.PureComponent = At, u.StrictMode = d, u.Suspense = g, u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ce, u.cloneElement = Ns, u.createContext = go, u.createElement = Ll, u.createFactory = fu, u.createRef = gn, u.forwardRef = mi, u.isValidElement = zt, u.lazy = va, u.memo = ge, u.startTransition = bE, u.unstable_act = Fo, u.useCallback = Er, u.useContext = dt, u.useDebugValue = Ht, u.useDeferredValue = ri, u.useEffect = Vn, u.useId = Dt, u.useImperativeHandle = ss, u.useInsertionEffect = Tn, u.useLayoutEffect = fn, u.useMemo = Li, u.useReducer = It, u.useRef = et, u.useState = _t, u.useSyncExternalStore = yi, u.useTransition = fT, u.version = T, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(DA, DA.exports)), DA.exports;
}
var cm;
function GA() {
  return cm || (cm = 1, process.env.NODE_ENV === "production" ? DS.exports = MU() : DS.exports = UU()), DS.exports;
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tm;
function _U() {
  if (Tm)
    return hA;
  Tm = 1;
  var l = GA(), u = Symbol.for("react.element"), T = Symbol.for("react.fragment"), N = Object.prototype.hasOwnProperty, O = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(G, D, v) {
    var M, g = {}, w = null, Y = null;
    v !== void 0 && (w = "" + v), D.key !== void 0 && (w = "" + D.key), D.ref !== void 0 && (Y = D.ref);
    for (M in D)
      N.call(D, M) && !h.hasOwnProperty(M) && (g[M] = D[M]);
    if (G && G.defaultProps)
      for (M in D = G.defaultProps, D)
        g[M] === void 0 && (g[M] = D[M]);
    return { $$typeof: u, type: G, key: w, ref: Y, props: g, _owner: O.current };
  }
  return hA.Fragment = T, hA.jsx = d, hA.jsxs = d, hA;
}
var vA = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fm;
function GU() {
  return fm || (fm = 1, process.env.NODE_ENV !== "production" && function() {
    var l = GA(), u = Symbol.for("react.element"), T = Symbol.for("react.portal"), N = Symbol.for("react.fragment"), O = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), G = Symbol.for("react.context"), D = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), M = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), Y = Symbol.for("react.offscreen"), j = Symbol.iterator, oe = "@@iterator";
    function me(x) {
      if (x === null || typeof x != "object")
        return null;
      var Ee = j && x[j] || x[oe];
      return typeof Ee == "function" ? Ee : null;
    }
    var Le = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Oe(x) {
      {
        for (var Ee = arguments.length, ge = new Array(Ee > 1 ? Ee - 1 : 0), be = 1; be < Ee; be++)
          ge[be - 1] = arguments[be];
        he("error", x, ge);
      }
    }
    function he(x, Ee, ge) {
      {
        var be = Le.ReactDebugCurrentFrame, dt = be.getStackAddendum();
        dt !== "" && (Ee += "%s", ge = ge.concat([dt]));
        var _t = ge.map(function(It) {
          return String(It);
        });
        _t.unshift("Warning: " + Ee), Function.prototype.apply.call(console[x], console, _t);
      }
    }
    var Fe = !1, ye = !1, je = !1, Xe = !1, yt = !1, ht;
    ht = Symbol.for("react.module.reference");
    function Qe(x) {
      return !!(typeof x == "string" || typeof x == "function" || x === N || x === h || yt || x === O || x === v || x === M || Xe || x === Y || Fe || ye || je || typeof x == "object" && x !== null && (x.$$typeof === w || x.$$typeof === g || x.$$typeof === d || x.$$typeof === G || x.$$typeof === D || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      x.$$typeof === ht || x.getModuleId !== void 0));
    }
    function gt(x, Ee, ge) {
      var be = x.displayName;
      if (be)
        return be;
      var dt = Ee.displayName || Ee.name || "";
      return dt !== "" ? ge + "(" + dt + ")" : ge;
    }
    function Rn(x) {
      return x.displayName || "Context";
    }
    function Se(x) {
      if (x == null)
        return null;
      if (typeof x.tag == "number" && Oe("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof x == "function")
        return x.displayName || x.name || null;
      if (typeof x == "string")
        return x;
      switch (x) {
        case N:
          return "Fragment";
        case T:
          return "Portal";
        case h:
          return "Profiler";
        case O:
          return "StrictMode";
        case v:
          return "Suspense";
        case M:
          return "SuspenseList";
      }
      if (typeof x == "object")
        switch (x.$$typeof) {
          case G:
            var Ee = x;
            return Rn(Ee) + ".Consumer";
          case d:
            var ge = x;
            return Rn(ge._context) + ".Provider";
          case D:
            return gt(x, x.render, "ForwardRef");
          case g:
            var be = x.displayName || null;
            return be !== null ? be : Se(x.type) || "Memo";
          case w: {
            var dt = x, _t = dt._payload, It = dt._init;
            try {
              return Se(It(_t));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var le = Object.assign, ce = 0, ve, ee, te, Ae, U, q, Ie;
    function Ye() {
    }
    Ye.__reactDisabledLog = !0;
    function We() {
      {
        if (ce === 0) {
          ve = console.log, ee = console.info, te = console.warn, Ae = console.error, U = console.group, q = console.groupCollapsed, Ie = console.groupEnd;
          var x = {
            configurable: !0,
            enumerable: !0,
            value: Ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: x,
            log: x,
            warn: x,
            error: x,
            group: x,
            groupCollapsed: x,
            groupEnd: x
          });
        }
        ce++;
      }
    }
    function vt() {
      {
        if (ce--, ce === 0) {
          var x = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: le({}, x, {
              value: ve
            }),
            info: le({}, x, {
              value: ee
            }),
            warn: le({}, x, {
              value: te
            }),
            error: le({}, x, {
              value: Ae
            }),
            group: le({}, x, {
              value: U
            }),
            groupCollapsed: le({}, x, {
              value: q
            }),
            groupEnd: le({}, x, {
              value: Ie
            })
          });
        }
        ce < 0 && Oe("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ut = Le.ReactCurrentDispatcher, Ot;
    function lt(x, Ee, ge) {
      {
        if (Ot === void 0)
          try {
            throw Error();
          } catch (dt) {
            var be = dt.stack.trim().match(/\n( *(at )?)/);
            Ot = be && be[1] || "";
          }
        return `
` + Ot + x;
      }
    }
    var At = !1, Cn;
    {
      var gn = typeof WeakMap == "function" ? WeakMap : Map;
      Cn = new gn();
    }
    function Jn(x, Ee) {
      if (!x || At)
        return "";
      {
        var ge = Cn.get(x);
        if (ge !== void 0)
          return ge;
      }
      var be;
      At = !0;
      var dt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _t;
      _t = ut.current, ut.current = null, We();
      try {
        if (Ee) {
          var It = function() {
            throw Error();
          };
          if (Object.defineProperty(It.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(It, []);
            } catch (Ht) {
              be = Ht;
            }
            Reflect.construct(x, [], It);
          } else {
            try {
              It.call();
            } catch (Ht) {
              be = Ht;
            }
            x.call(It.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ht) {
            be = Ht;
          }
          x();
        }
      } catch (Ht) {
        if (Ht && be && typeof Ht.stack == "string") {
          for (var et = Ht.stack.split(`
`), Vn = be.stack.split(`
`), Tn = et.length - 1, fn = Vn.length - 1; Tn >= 1 && fn >= 0 && et[Tn] !== Vn[fn]; )
            fn--;
          for (; Tn >= 1 && fn >= 0; Tn--, fn--)
            if (et[Tn] !== Vn[fn]) {
              if (Tn !== 1 || fn !== 1)
                do
                  if (Tn--, fn--, fn < 0 || et[Tn] !== Vn[fn]) {
                    var Er = `
` + et[Tn].replace(" at new ", " at ");
                    return x.displayName && Er.includes("<anonymous>") && (Er = Er.replace("<anonymous>", x.displayName)), typeof x == "function" && Cn.set(x, Er), Er;
                  }
                while (Tn >= 1 && fn >= 0);
              break;
            }
        }
      } finally {
        At = !1, ut.current = _t, vt(), Error.prepareStackTrace = dt;
      }
      var Li = x ? x.displayName || x.name : "", ss = Li ? lt(Li) : "";
      return typeof x == "function" && Cn.set(x, ss), ss;
    }
    function hn(x, Ee, ge) {
      return Jn(x, !1);
    }
    function nr(x) {
      var Ee = x.prototype;
      return !!(Ee && Ee.isReactComponent);
    }
    function Qn(x, Ee, ge) {
      if (x == null)
        return "";
      if (typeof x == "function")
        return Jn(x, nr(x));
      if (typeof x == "string")
        return lt(x);
      switch (x) {
        case v:
          return lt("Suspense");
        case M:
          return lt("SuspenseList");
      }
      if (typeof x == "object")
        switch (x.$$typeof) {
          case D:
            return hn(x.render);
          case g:
            return Qn(x.type, Ee, ge);
          case w: {
            var be = x, dt = be._payload, _t = be._init;
            try {
              return Qn(_t(dt), Ee, ge);
            } catch {
            }
          }
        }
      return "";
    }
    var Zn = Object.prototype.hasOwnProperty, Gn = {}, Zr = Le.ReactDebugCurrentFrame;
    function qr(x) {
      if (x) {
        var Ee = x._owner, ge = Qn(x.type, x._source, Ee ? Ee.type : null);
        Zr.setExtraStackFrame(ge);
      } else
        Zr.setExtraStackFrame(null);
    }
    function rr(x, Ee, ge, be, dt) {
      {
        var _t = Function.call.bind(Zn);
        for (var It in x)
          if (_t(x, It)) {
            var et = void 0;
            try {
              if (typeof x[It] != "function") {
                var Vn = Error((be || "React class") + ": " + ge + " type `" + It + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof x[It] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Vn.name = "Invariant Violation", Vn;
              }
              et = x[It](Ee, It, be, ge, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Tn) {
              et = Tn;
            }
            et && !(et instanceof Error) && (qr(dt), Oe("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", be || "React class", ge, It, typeof et), qr(null)), et instanceof Error && !(et.message in Gn) && (Gn[et.message] = !0, qr(dt), Oe("Failed %s type: %s", ge, et.message), qr(null));
          }
      }
    }
    var Ir = Array.isArray;
    function $r(x) {
      return Ir(x);
    }
    function Cr(x) {
      {
        var Ee = typeof Symbol == "function" && Symbol.toStringTag, ge = Ee && x[Symbol.toStringTag] || x.constructor.name || "Object";
        return ge;
      }
    }
    function Oa(x) {
      try {
        return ur(x), !1;
      } catch {
        return !0;
      }
    }
    function ur(x) {
      return "" + x;
    }
    function ea(x) {
      if (Oa(x))
        return Oe("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Cr(x)), ur(x);
    }
    var vn = Le.ReactCurrentOwner, Pr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ci, Ia, De;
    De = {};
    function Ze(x) {
      if (Zn.call(x, "ref")) {
        var Ee = Object.getOwnPropertyDescriptor(x, "ref").get;
        if (Ee && Ee.isReactWarning)
          return !1;
      }
      return x.ref !== void 0;
    }
    function mt(x) {
      if (Zn.call(x, "key")) {
        var Ee = Object.getOwnPropertyDescriptor(x, "key").get;
        if (Ee && Ee.isReactWarning)
          return !1;
      }
      return x.key !== void 0;
    }
    function Kt(x, Ee) {
      if (typeof x.ref == "string" && vn.current && Ee && vn.current.stateNode !== Ee) {
        var ge = Se(vn.current.type);
        De[ge] || (Oe('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Se(vn.current.type), x.ref), De[ge] = !0);
      }
    }
    function zt(x, Ee) {
      {
        var ge = function() {
          Ci || (Ci = !0, Oe("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ee));
        };
        ge.isReactWarning = !0, Object.defineProperty(x, "key", {
          get: ge,
          configurable: !0
        });
      }
    }
    function xn(x, Ee) {
      {
        var ge = function() {
          Ia || (Ia = !0, Oe("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ee));
        };
        ge.isReactWarning = !0, Object.defineProperty(x, "ref", {
          get: ge,
          configurable: !0
        });
      }
    }
    var mn = function(x, Ee, ge, be, dt, _t, It) {
      var et = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: u,
        // Built-in properties that belong on the element
        type: x,
        key: Ee,
        ref: ge,
        props: It,
        // Record the component responsible for creating this element.
        _owner: _t
      };
      return et._store = {}, Object.defineProperty(et._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(et, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: be
      }), Object.defineProperty(et, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: dt
      }), Object.freeze && (Object.freeze(et.props), Object.freeze(et)), et;
    };
    function hr(x, Ee, ge, be, dt) {
      {
        var _t, It = {}, et = null, Vn = null;
        ge !== void 0 && (ea(ge), et = "" + ge), mt(Ee) && (ea(Ee.key), et = "" + Ee.key), Ze(Ee) && (Vn = Ee.ref, Kt(Ee, dt));
        for (_t in Ee)
          Zn.call(Ee, _t) && !Pr.hasOwnProperty(_t) && (It[_t] = Ee[_t]);
        if (x && x.defaultProps) {
          var Tn = x.defaultProps;
          for (_t in Tn)
            It[_t] === void 0 && (It[_t] = Tn[_t]);
        }
        if (et || Vn) {
          var fn = typeof x == "function" ? x.displayName || x.name || "Unknown" : x;
          et && zt(It, fn), Vn && xn(It, fn);
        }
        return mn(x, et, Vn, dt, be, vn.current, It);
      }
    }
    var tn = Le.ReactCurrentOwner, Mr = Le.ReactDebugCurrentFrame;
    function Jt(x) {
      if (x) {
        var Ee = x._owner, ge = Qn(x.type, x._source, Ee ? Ee.type : null);
        Mr.setExtraStackFrame(ge);
      } else
        Mr.setExtraStackFrame(null);
    }
    var Qt;
    Qt = !1;
    function ni(x) {
      return typeof x == "object" && x !== null && x.$$typeof === u;
    }
    function Ba() {
      {
        if (tn.current) {
          var x = Se(tn.current.type);
          if (x)
            return `

Check the render method of \`` + x + "`.";
        }
        return "";
      }
    }
    function Do(x) {
      {
        if (x !== void 0) {
          var Ee = x.fileName.replace(/^.*[\\\/]/, ""), ge = x.lineNumber;
          return `

Check your code at ` + Ee + ":" + ge + ".";
        }
        return "";
      }
    }
    var hl = {};
    function ls(x) {
      {
        var Ee = Ba();
        if (!Ee) {
          var ge = typeof x == "string" ? x : x.displayName || x.name;
          ge && (Ee = `

Check the top-level render call using <` + ge + ">.");
        }
        return Ee;
      }
    }
    function Xi(x, Ee) {
      {
        if (!x._store || x._store.validated || x.key != null)
          return;
        x._store.validated = !0;
        var ge = ls(Ee);
        if (hl[ge])
          return;
        hl[ge] = !0;
        var be = "";
        x && x._owner && x._owner !== tn.current && (be = " It was passed a child from " + Se(x._owner.type) + "."), Jt(x), Oe('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ge, be), Jt(null);
      }
    }
    function go(x, Ee) {
      {
        if (typeof x != "object")
          return;
        if ($r(x))
          for (var ge = 0; ge < x.length; ge++) {
            var be = x[ge];
            ni(be) && Xi(be, Ee);
          }
        else if (ni(x))
          x._store && (x._store.validated = !0);
        else if (x) {
          var dt = me(x);
          if (typeof dt == "function" && dt !== x.entries)
            for (var _t = dt.call(x), It; !(It = _t.next()).done; )
              ni(It.value) && Xi(It.value, Ee);
        }
      }
    }
    function Ca(x) {
      {
        var Ee = x.type;
        if (Ee == null || typeof Ee == "string")
          return;
        var ge;
        if (typeof Ee == "function")
          ge = Ee.propTypes;
        else if (typeof Ee == "object" && (Ee.$$typeof === D || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ee.$$typeof === g))
          ge = Ee.propTypes;
        else
          return;
        if (ge) {
          var be = Se(Ee);
          rr(ge, x.props, "prop", be, x);
        } else if (Ee.PropTypes !== void 0 && !Qt) {
          Qt = !0;
          var dt = Se(Ee);
          Oe("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", dt || "Unknown");
        }
        typeof Ee.getDefaultProps == "function" && !Ee.getDefaultProps.isReactClassApproved && Oe("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function hi(x) {
      {
        for (var Ee = Object.keys(x.props), ge = 0; ge < Ee.length; ge++) {
          var be = Ee[ge];
          if (be !== "children" && be !== "key") {
            Jt(x), Oe("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", be), Jt(null);
            break;
          }
        }
        x.ref !== null && (Jt(x), Oe("Invalid attribute `ref` supplied to `React.Fragment`."), Jt(null));
      }
    }
    function ha(x, Ee, ge, be, dt, _t) {
      {
        var It = Qe(x);
        if (!It) {
          var et = "";
          (x === void 0 || typeof x == "object" && x !== null && Object.keys(x).length === 0) && (et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Vn = Do(dt);
          Vn ? et += Vn : et += Ba();
          var Tn;
          x === null ? Tn = "null" : $r(x) ? Tn = "array" : x !== void 0 && x.$$typeof === u ? (Tn = "<" + (Se(x.type) || "Unknown") + " />", et = " Did you accidentally export a JSX literal instead of a component?") : Tn = typeof x, Oe("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tn, et);
        }
        var fn = hr(x, Ee, ge, dt, _t);
        if (fn == null)
          return fn;
        if (It) {
          var Er = Ee.children;
          if (Er !== void 0)
            if (be)
              if ($r(Er)) {
                for (var Li = 0; Li < Er.length; Li++)
                  go(Er[Li], x);
                Object.freeze && Object.freeze(Er);
              } else
                Oe("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              go(Er, x);
        }
        return x === N ? hi(fn) : Ca(fn), fn;
      }
    }
    function vi(x, Ee, ge) {
      return ha(x, Ee, ge, !0);
    }
    function Ur(x, Ee, ge) {
      return ha(x, Ee, ge, !1);
    }
    var va = Ur, mi = vi;
    vA.Fragment = N, vA.jsx = va, vA.jsxs = mi;
  }()), vA;
}
process.env.NODE_ENV === "production" ? II.exports = _U() : II.exports = GU();
var m = II.exports;
const xU = `@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0100-02AF,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
`;
var gA = {}, CI = { exports: {} }, ei = {}, gS = { exports: {} }, cI = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Am;
function bU() {
  return Am || (Am = 1, function(l) {
    function u(te, Ae) {
      var U = te.length;
      te.push(Ae);
      e:
        for (; 0 < U; ) {
          var q = U - 1 >>> 1, Ie = te[q];
          if (0 < O(Ie, Ae))
            te[q] = Ae, te[U] = Ie, U = q;
          else
            break e;
        }
    }
    function T(te) {
      return te.length === 0 ? null : te[0];
    }
    function N(te) {
      if (te.length === 0)
        return null;
      var Ae = te[0], U = te.pop();
      if (U !== Ae) {
        te[0] = U;
        e:
          for (var q = 0, Ie = te.length, Ye = Ie >>> 1; q < Ye; ) {
            var We = 2 * (q + 1) - 1, vt = te[We], ut = We + 1, Ot = te[ut];
            if (0 > O(vt, U))
              ut < Ie && 0 > O(Ot, vt) ? (te[q] = Ot, te[ut] = U, q = ut) : (te[q] = vt, te[We] = U, q = We);
            else if (ut < Ie && 0 > O(Ot, U))
              te[q] = Ot, te[ut] = U, q = ut;
            else
              break e;
          }
      }
      return Ae;
    }
    function O(te, Ae) {
      var U = te.sortIndex - Ae.sortIndex;
      return U !== 0 ? U : te.id - Ae.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var h = performance;
      l.unstable_now = function() {
        return h.now();
      };
    } else {
      var d = Date, G = d.now();
      l.unstable_now = function() {
        return d.now() - G;
      };
    }
    var D = [], v = [], M = 1, g = null, w = 3, Y = !1, j = !1, oe = !1, me = typeof setTimeout == "function" ? setTimeout : null, Le = typeof clearTimeout == "function" ? clearTimeout : null, Oe = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function he(te) {
      for (var Ae = T(v); Ae !== null; ) {
        if (Ae.callback === null)
          N(v);
        else if (Ae.startTime <= te)
          N(v), Ae.sortIndex = Ae.expirationTime, u(D, Ae);
        else
          break;
        Ae = T(v);
      }
    }
    function Fe(te) {
      if (oe = !1, he(te), !j)
        if (T(D) !== null)
          j = !0, ve(ye);
        else {
          var Ae = T(v);
          Ae !== null && ee(Fe, Ae.startTime - te);
        }
    }
    function ye(te, Ae) {
      j = !1, oe && (oe = !1, Le(yt), yt = -1), Y = !0;
      var U = w;
      try {
        for (he(Ae), g = T(D); g !== null && (!(g.expirationTime > Ae) || te && !gt()); ) {
          var q = g.callback;
          if (typeof q == "function") {
            g.callback = null, w = g.priorityLevel;
            var Ie = q(g.expirationTime <= Ae);
            Ae = l.unstable_now(), typeof Ie == "function" ? g.callback = Ie : g === T(D) && N(D), he(Ae);
          } else
            N(D);
          g = T(D);
        }
        if (g !== null)
          var Ye = !0;
        else {
          var We = T(v);
          We !== null && ee(Fe, We.startTime - Ae), Ye = !1;
        }
        return Ye;
      } finally {
        g = null, w = U, Y = !1;
      }
    }
    var je = !1, Xe = null, yt = -1, ht = 5, Qe = -1;
    function gt() {
      return !(l.unstable_now() - Qe < ht);
    }
    function Rn() {
      if (Xe !== null) {
        var te = l.unstable_now();
        Qe = te;
        var Ae = !0;
        try {
          Ae = Xe(!0, te);
        } finally {
          Ae ? Se() : (je = !1, Xe = null);
        }
      } else
        je = !1;
    }
    var Se;
    if (typeof Oe == "function")
      Se = function() {
        Oe(Rn);
      };
    else if (typeof MessageChannel < "u") {
      var le = new MessageChannel(), ce = le.port2;
      le.port1.onmessage = Rn, Se = function() {
        ce.postMessage(null);
      };
    } else
      Se = function() {
        me(Rn, 0);
      };
    function ve(te) {
      Xe = te, je || (je = !0, Se());
    }
    function ee(te, Ae) {
      yt = me(function() {
        te(l.unstable_now());
      }, Ae);
    }
    l.unstable_IdlePriority = 5, l.unstable_ImmediatePriority = 1, l.unstable_LowPriority = 4, l.unstable_NormalPriority = 3, l.unstable_Profiling = null, l.unstable_UserBlockingPriority = 2, l.unstable_cancelCallback = function(te) {
      te.callback = null;
    }, l.unstable_continueExecution = function() {
      j || Y || (j = !0, ve(ye));
    }, l.unstable_forceFrameRate = function(te) {
      0 > te || 125 < te ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : ht = 0 < te ? Math.floor(1e3 / te) : 5;
    }, l.unstable_getCurrentPriorityLevel = function() {
      return w;
    }, l.unstable_getFirstCallbackNode = function() {
      return T(D);
    }, l.unstable_next = function(te) {
      switch (w) {
        case 1:
        case 2:
        case 3:
          var Ae = 3;
          break;
        default:
          Ae = w;
      }
      var U = w;
      w = Ae;
      try {
        return te();
      } finally {
        w = U;
      }
    }, l.unstable_pauseExecution = function() {
    }, l.unstable_requestPaint = function() {
    }, l.unstable_runWithPriority = function(te, Ae) {
      switch (te) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          te = 3;
      }
      var U = w;
      w = te;
      try {
        return Ae();
      } finally {
        w = U;
      }
    }, l.unstable_scheduleCallback = function(te, Ae, U) {
      var q = l.unstable_now();
      switch (typeof U == "object" && U !== null ? (U = U.delay, U = typeof U == "number" && 0 < U ? q + U : q) : U = q, te) {
        case 1:
          var Ie = -1;
          break;
        case 2:
          Ie = 250;
          break;
        case 5:
          Ie = 1073741823;
          break;
        case 4:
          Ie = 1e4;
          break;
        default:
          Ie = 5e3;
      }
      return Ie = U + Ie, te = { id: M++, callback: Ae, priorityLevel: te, startTime: U, expirationTime: Ie, sortIndex: -1 }, U > q ? (te.sortIndex = U, u(v, te), T(D) === null && te === T(v) && (oe ? (Le(yt), yt = -1) : oe = !0, ee(Fe, U - q))) : (te.sortIndex = Ie, u(D, te), j || Y || (j = !0, ve(ye))), te;
    }, l.unstable_shouldYield = gt, l.unstable_wrapCallback = function(te) {
      var Ae = w;
      return function() {
        var U = w;
        w = Ae;
        try {
          return te.apply(this, arguments);
        } finally {
          w = U;
        }
      };
    };
  }(cI)), cI;
}
var TI = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rm;
function HU() {
  return Rm || (Rm = 1, function(l) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var u = !1, T = !1, N = 5;
      function O(De, Ze) {
        var mt = De.length;
        De.push(Ze), G(De, Ze, mt);
      }
      function h(De) {
        return De.length === 0 ? null : De[0];
      }
      function d(De) {
        if (De.length === 0)
          return null;
        var Ze = De[0], mt = De.pop();
        return mt !== Ze && (De[0] = mt, D(De, mt, 0)), Ze;
      }
      function G(De, Ze, mt) {
        for (var Kt = mt; Kt > 0; ) {
          var zt = Kt - 1 >>> 1, xn = De[zt];
          if (v(xn, Ze) > 0)
            De[zt] = Ze, De[Kt] = xn, Kt = zt;
          else
            return;
        }
      }
      function D(De, Ze, mt) {
        for (var Kt = mt, zt = De.length, xn = zt >>> 1; Kt < xn; ) {
          var mn = (Kt + 1) * 2 - 1, hr = De[mn], tn = mn + 1, Mr = De[tn];
          if (v(hr, Ze) < 0)
            tn < zt && v(Mr, hr) < 0 ? (De[Kt] = Mr, De[tn] = Ze, Kt = tn) : (De[Kt] = hr, De[mn] = Ze, Kt = mn);
          else if (tn < zt && v(Mr, Ze) < 0)
            De[Kt] = Mr, De[tn] = Ze, Kt = tn;
          else
            return;
        }
      }
      function v(De, Ze) {
        var mt = De.sortIndex - Ze.sortIndex;
        return mt !== 0 ? mt : De.id - Ze.id;
      }
      var M = 1, g = 2, w = 3, Y = 4, j = 5;
      function oe(De, Ze) {
      }
      var me = typeof performance == "object" && typeof performance.now == "function";
      if (me) {
        var Le = performance;
        l.unstable_now = function() {
          return Le.now();
        };
      } else {
        var Oe = Date, he = Oe.now();
        l.unstable_now = function() {
          return Oe.now() - he;
        };
      }
      var Fe = 1073741823, ye = -1, je = 250, Xe = 5e3, yt = 1e4, ht = Fe, Qe = [], gt = [], Rn = 1, Se = null, le = w, ce = !1, ve = !1, ee = !1, te = typeof setTimeout == "function" ? setTimeout : null, Ae = typeof clearTimeout == "function" ? clearTimeout : null, U = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function q(De) {
        for (var Ze = h(gt); Ze !== null; ) {
          if (Ze.callback === null)
            d(gt);
          else if (Ze.startTime <= De)
            d(gt), Ze.sortIndex = Ze.expirationTime, O(Qe, Ze);
          else
            return;
          Ze = h(gt);
        }
      }
      function Ie(De) {
        if (ee = !1, q(De), !ve)
          if (h(Qe) !== null)
            ve = !0, ea(Ye);
          else {
            var Ze = h(gt);
            Ze !== null && vn(Ie, Ze.startTime - De);
          }
      }
      function Ye(De, Ze) {
        ve = !1, ee && (ee = !1, Pr()), ce = !0;
        var mt = le;
        try {
          var Kt;
          if (!T)
            return We(De, Ze);
        } finally {
          Se = null, le = mt, ce = !1;
        }
      }
      function We(De, Ze) {
        var mt = Ze;
        for (q(mt), Se = h(Qe); Se !== null && !u && !(Se.expirationTime > mt && (!De || qr())); ) {
          var Kt = Se.callback;
          if (typeof Kt == "function") {
            Se.callback = null, le = Se.priorityLevel;
            var zt = Se.expirationTime <= mt, xn = Kt(zt);
            mt = l.unstable_now(), typeof xn == "function" ? Se.callback = xn : Se === h(Qe) && d(Qe), q(mt);
          } else
            d(Qe);
          Se = h(Qe);
        }
        if (Se !== null)
          return !0;
        var mn = h(gt);
        return mn !== null && vn(Ie, mn.startTime - mt), !1;
      }
      function vt(De, Ze) {
        switch (De) {
          case M:
          case g:
          case w:
          case Y:
          case j:
            break;
          default:
            De = w;
        }
        var mt = le;
        le = De;
        try {
          return Ze();
        } finally {
          le = mt;
        }
      }
      function ut(De) {
        var Ze;
        switch (le) {
          case M:
          case g:
          case w:
            Ze = w;
            break;
          default:
            Ze = le;
            break;
        }
        var mt = le;
        le = Ze;
        try {
          return De();
        } finally {
          le = mt;
        }
      }
      function Ot(De) {
        var Ze = le;
        return function() {
          var mt = le;
          le = Ze;
          try {
            return De.apply(this, arguments);
          } finally {
            le = mt;
          }
        };
      }
      function lt(De, Ze, mt) {
        var Kt = l.unstable_now(), zt;
        if (typeof mt == "object" && mt !== null) {
          var xn = mt.delay;
          typeof xn == "number" && xn > 0 ? zt = Kt + xn : zt = Kt;
        } else
          zt = Kt;
        var mn;
        switch (De) {
          case M:
            mn = ye;
            break;
          case g:
            mn = je;
            break;
          case j:
            mn = ht;
            break;
          case Y:
            mn = yt;
            break;
          case w:
          default:
            mn = Xe;
            break;
        }
        var hr = zt + mn, tn = {
          id: Rn++,
          callback: Ze,
          priorityLevel: De,
          startTime: zt,
          expirationTime: hr,
          sortIndex: -1
        };
        return zt > Kt ? (tn.sortIndex = zt, O(gt, tn), h(Qe) === null && tn === h(gt) && (ee ? Pr() : ee = !0, vn(Ie, zt - Kt))) : (tn.sortIndex = hr, O(Qe, tn), !ve && !ce && (ve = !0, ea(Ye))), tn;
      }
      function At() {
      }
      function Cn() {
        !ve && !ce && (ve = !0, ea(Ye));
      }
      function gn() {
        return h(Qe);
      }
      function Jn(De) {
        De.callback = null;
      }
      function hn() {
        return le;
      }
      var nr = !1, Qn = null, Zn = -1, Gn = N, Zr = -1;
      function qr() {
        var De = l.unstable_now() - Zr;
        return !(De < Gn);
      }
      function rr() {
      }
      function Ir(De) {
        if (De < 0 || De > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        De > 0 ? Gn = Math.floor(1e3 / De) : Gn = N;
      }
      var $r = function() {
        if (Qn !== null) {
          var De = l.unstable_now();
          Zr = De;
          var Ze = !0, mt = !0;
          try {
            mt = Qn(Ze, De);
          } finally {
            mt ? Cr() : (nr = !1, Qn = null);
          }
        } else
          nr = !1;
      }, Cr;
      if (typeof U == "function")
        Cr = function() {
          U($r);
        };
      else if (typeof MessageChannel < "u") {
        var Oa = new MessageChannel(), ur = Oa.port2;
        Oa.port1.onmessage = $r, Cr = function() {
          ur.postMessage(null);
        };
      } else
        Cr = function() {
          te($r, 0);
        };
      function ea(De) {
        Qn = De, nr || (nr = !0, Cr());
      }
      function vn(De, Ze) {
        Zn = te(function() {
          De(l.unstable_now());
        }, Ze);
      }
      function Pr() {
        Ae(Zn), Zn = -1;
      }
      var Ci = rr, Ia = null;
      l.unstable_IdlePriority = j, l.unstable_ImmediatePriority = M, l.unstable_LowPriority = Y, l.unstable_NormalPriority = w, l.unstable_Profiling = Ia, l.unstable_UserBlockingPriority = g, l.unstable_cancelCallback = Jn, l.unstable_continueExecution = Cn, l.unstable_forceFrameRate = Ir, l.unstable_getCurrentPriorityLevel = hn, l.unstable_getFirstCallbackNode = gn, l.unstable_next = ut, l.unstable_pauseExecution = At, l.unstable_requestPaint = Ci, l.unstable_runWithPriority = vt, l.unstable_scheduleCallback = lt, l.unstable_shouldYield = qr, l.unstable_wrapCallback = Ot, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(TI)), TI;
}
var dm;
function rL() {
  return dm || (dm = 1, process.env.NODE_ENV === "production" ? gS.exports = bU() : gS.exports = HU()), gS.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sm;
function BU() {
  if (Sm)
    return ei;
  Sm = 1;
  var l = GA(), u = rL();
  function T(n) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, o = 1; o < arguments.length; o++)
      r += "&args[]=" + encodeURIComponent(arguments[o]);
    return "Minified React error #" + n + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var N = /* @__PURE__ */ new Set(), O = {};
  function h(n, r) {
    d(n, r), d(n + "Capture", r);
  }
  function d(n, r) {
    for (O[n] = r, n = 0; n < r.length; n++)
      N.add(r[n]);
  }
  var G = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), D = Object.prototype.hasOwnProperty, v = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, M = {}, g = {};
  function w(n) {
    return D.call(g, n) ? !0 : D.call(M, n) ? !1 : v.test(n) ? g[n] = !0 : (M[n] = !0, !1);
  }
  function Y(n, r, o, E) {
    if (o !== null && o.type === 0)
      return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return E ? !1 : o !== null ? !o.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function j(n, r, o, E) {
    if (r === null || typeof r > "u" || Y(n, r, o, E))
      return !0;
    if (E)
      return !1;
    if (o !== null)
      switch (o.type) {
        case 3:
          return !r;
        case 4:
          return r === !1;
        case 5:
          return isNaN(r);
        case 6:
          return isNaN(r) || 1 > r;
      }
    return !1;
  }
  function oe(n, r, o, E, f, R, C) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = E, this.attributeNamespace = f, this.mustUseProperty = o, this.propertyName = n, this.type = r, this.sanitizeURL = R, this.removeEmptyString = C;
  }
  var me = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    me[n] = new oe(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var r = n[0];
    me[r] = new oe(r, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    me[n] = new oe(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    me[n] = new oe(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    me[n] = new oe(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    me[n] = new oe(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    me[n] = new oe(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    me[n] = new oe(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    me[n] = new oe(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var Le = /[\-:]([a-z])/g;
  function Oe(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var r = n.replace(
      Le,
      Oe
    );
    me[r] = new oe(r, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var r = n.replace(Le, Oe);
    me[r] = new oe(r, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var r = n.replace(Le, Oe);
    me[r] = new oe(r, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    me[n] = new oe(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), me.xlinkHref = new oe("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    me[n] = new oe(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function he(n, r, o, E) {
    var f = me.hasOwnProperty(r) ? me[r] : null;
    (f !== null ? f.type !== 0 : E || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (j(r, o, f, E) && (o = null), E || f === null ? w(r) && (o === null ? n.removeAttribute(r) : n.setAttribute(r, "" + o)) : f.mustUseProperty ? n[f.propertyName] = o === null ? f.type === 3 ? !1 : "" : o : (r = f.attributeName, E = f.attributeNamespace, o === null ? n.removeAttribute(r) : (f = f.type, o = f === 3 || f === 4 && o === !0 ? "" : "" + o, E ? n.setAttributeNS(E, r, o) : n.setAttribute(r, o))));
  }
  var Fe = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ye = Symbol.for("react.element"), je = Symbol.for("react.portal"), Xe = Symbol.for("react.fragment"), yt = Symbol.for("react.strict_mode"), ht = Symbol.for("react.profiler"), Qe = Symbol.for("react.provider"), gt = Symbol.for("react.context"), Rn = Symbol.for("react.forward_ref"), Se = Symbol.for("react.suspense"), le = Symbol.for("react.suspense_list"), ce = Symbol.for("react.memo"), ve = Symbol.for("react.lazy"), ee = Symbol.for("react.offscreen"), te = Symbol.iterator;
  function Ae(n) {
    return n === null || typeof n != "object" ? null : (n = te && n[te] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var U = Object.assign, q;
  function Ie(n) {
    if (q === void 0)
      try {
        throw Error();
      } catch (o) {
        var r = o.stack.trim().match(/\n( *(at )?)/);
        q = r && r[1] || "";
      }
    return `
` + q + n;
  }
  var Ye = !1;
  function We(n, r) {
    if (!n || Ye)
      return "";
    Ye = !0;
    var o = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r)
        if (r = function() {
          throw Error();
        }, Object.defineProperty(r.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(r, []);
          } catch (Z) {
            var E = Z;
          }
          Reflect.construct(n, [], r);
        } else {
          try {
            r.call();
          } catch (Z) {
            E = Z;
          }
          n.call(r.prototype);
        }
      else {
        try {
          throw Error();
        } catch (Z) {
          E = Z;
        }
        n();
      }
    } catch (Z) {
      if (Z && E && typeof Z.stack == "string") {
        for (var f = Z.stack.split(`
`), R = E.stack.split(`
`), C = f.length - 1, P = R.length - 1; 1 <= C && 0 <= P && f[C] !== R[P]; )
          P--;
        for (; 1 <= C && 0 <= P; C--, P--)
          if (f[C] !== R[P]) {
            if (C !== 1 || P !== 1)
              do
                if (C--, P--, 0 > P || f[C] !== R[P]) {
                  var b = `
` + f[C].replace(" at new ", " at ");
                  return n.displayName && b.includes("<anonymous>") && (b = b.replace("<anonymous>", n.displayName)), b;
                }
              while (1 <= C && 0 <= P);
            break;
          }
      }
    } finally {
      Ye = !1, Error.prepareStackTrace = o;
    }
    return (n = n ? n.displayName || n.name : "") ? Ie(n) : "";
  }
  function vt(n) {
    switch (n.tag) {
      case 5:
        return Ie(n.type);
      case 16:
        return Ie("Lazy");
      case 13:
        return Ie("Suspense");
      case 19:
        return Ie("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = We(n.type, !1), n;
      case 11:
        return n = We(n.type.render, !1), n;
      case 1:
        return n = We(n.type, !0), n;
      default:
        return "";
    }
  }
  function ut(n) {
    if (n == null)
      return null;
    if (typeof n == "function")
      return n.displayName || n.name || null;
    if (typeof n == "string")
      return n;
    switch (n) {
      case Xe:
        return "Fragment";
      case je:
        return "Portal";
      case ht:
        return "Profiler";
      case yt:
        return "StrictMode";
      case Se:
        return "Suspense";
      case le:
        return "SuspenseList";
    }
    if (typeof n == "object")
      switch (n.$$typeof) {
        case gt:
          return (n.displayName || "Context") + ".Consumer";
        case Qe:
          return (n._context.displayName || "Context") + ".Provider";
        case Rn:
          var r = n.render;
          return n = n.displayName, n || (n = r.displayName || r.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
        case ce:
          return r = n.displayName || null, r !== null ? r : ut(n.type) || "Memo";
        case ve:
          r = n._payload, n = n._init;
          try {
            return ut(n(r));
          } catch {
          }
      }
    return null;
  }
  function Ot(n) {
    var r = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = r.render, n = n.displayName || n.name || "", r.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return ut(r);
      case 8:
        return r === yt ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function")
          return r.displayName || r.name || null;
        if (typeof r == "string")
          return r;
    }
    return null;
  }
  function lt(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function At(n) {
    var r = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function Cn(n) {
    var r = At(n) ? "checked" : "value", o = Object.getOwnPropertyDescriptor(n.constructor.prototype, r), E = "" + n[r];
    if (!n.hasOwnProperty(r) && typeof o < "u" && typeof o.get == "function" && typeof o.set == "function") {
      var f = o.get, R = o.set;
      return Object.defineProperty(n, r, { configurable: !0, get: function() {
        return f.call(this);
      }, set: function(C) {
        E = "" + C, R.call(this, C);
      } }), Object.defineProperty(n, r, { enumerable: o.enumerable }), { getValue: function() {
        return E;
      }, setValue: function(C) {
        E = "" + C;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[r];
      } };
    }
  }
  function gn(n) {
    n._valueTracker || (n._valueTracker = Cn(n));
  }
  function Jn(n) {
    if (!n)
      return !1;
    var r = n._valueTracker;
    if (!r)
      return !0;
    var o = r.getValue(), E = "";
    return n && (E = At(n) ? n.checked ? "true" : "false" : n.value), n = E, n !== o ? (r.setValue(n), !0) : !1;
  }
  function hn(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u")
      return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  function nr(n, r) {
    var o = r.checked;
    return U({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: o ?? n._wrapperState.initialChecked });
  }
  function Qn(n, r) {
    var o = r.defaultValue == null ? "" : r.defaultValue, E = r.checked != null ? r.checked : r.defaultChecked;
    o = lt(r.value != null ? r.value : o), n._wrapperState = { initialChecked: E, initialValue: o, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function Zn(n, r) {
    r = r.checked, r != null && he(n, "checked", r, !1);
  }
  function Gn(n, r) {
    Zn(n, r);
    var o = lt(r.value), E = r.type;
    if (o != null)
      E === "number" ? (o === 0 && n.value === "" || n.value != o) && (n.value = "" + o) : n.value !== "" + o && (n.value = "" + o);
    else if (E === "submit" || E === "reset") {
      n.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? qr(n, r.type, o) : r.hasOwnProperty("defaultValue") && qr(n, r.type, lt(r.defaultValue)), r.checked == null && r.defaultChecked != null && (n.defaultChecked = !!r.defaultChecked);
  }
  function Zr(n, r, o) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var E = r.type;
      if (!(E !== "submit" && E !== "reset" || r.value !== void 0 && r.value !== null))
        return;
      r = "" + n._wrapperState.initialValue, o || r === n.value || (n.value = r), n.defaultValue = r;
    }
    o = n.name, o !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, o !== "" && (n.name = o);
  }
  function qr(n, r, o) {
    (r !== "number" || hn(n.ownerDocument) !== n) && (o == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + o && (n.defaultValue = "" + o));
  }
  var rr = Array.isArray;
  function Ir(n, r, o, E) {
    if (n = n.options, r) {
      r = {};
      for (var f = 0; f < o.length; f++)
        r["$" + o[f]] = !0;
      for (o = 0; o < n.length; o++)
        f = r.hasOwnProperty("$" + n[o].value), n[o].selected !== f && (n[o].selected = f), f && E && (n[o].defaultSelected = !0);
    } else {
      for (o = "" + lt(o), r = null, f = 0; f < n.length; f++) {
        if (n[f].value === o) {
          n[f].selected = !0, E && (n[f].defaultSelected = !0);
          return;
        }
        r !== null || n[f].disabled || (r = n[f]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function $r(n, r) {
    if (r.dangerouslySetInnerHTML != null)
      throw Error(T(91));
    return U({}, r, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function Cr(n, r) {
    var o = r.value;
    if (o == null) {
      if (o = r.children, r = r.defaultValue, o != null) {
        if (r != null)
          throw Error(T(92));
        if (rr(o)) {
          if (1 < o.length)
            throw Error(T(93));
          o = o[0];
        }
        r = o;
      }
      r == null && (r = ""), o = r;
    }
    n._wrapperState = { initialValue: lt(o) };
  }
  function Oa(n, r) {
    var o = lt(r.value), E = lt(r.defaultValue);
    o != null && (o = "" + o, o !== n.value && (n.value = o), r.defaultValue == null && n.defaultValue !== o && (n.defaultValue = o)), E != null && (n.defaultValue = "" + E);
  }
  function ur(n) {
    var r = n.textContent;
    r === n._wrapperState.initialValue && r !== "" && r !== null && (n.value = r);
  }
  function ea(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function vn(n, r) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? ea(r) : n === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var Pr, Ci = function(n) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, o, E, f) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(r, o, E, f);
      });
    } : n;
  }(function(n, r) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n)
      n.innerHTML = r;
    else {
      for (Pr = Pr || document.createElement("div"), Pr.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Pr.firstChild; n.firstChild; )
        n.removeChild(n.firstChild);
      for (; r.firstChild; )
        n.appendChild(r.firstChild);
    }
  });
  function Ia(n, r) {
    if (r) {
      var o = n.firstChild;
      if (o && o === n.lastChild && o.nodeType === 3) {
        o.nodeValue = r;
        return;
      }
    }
    n.textContent = r;
  }
  var De = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Ze = ["Webkit", "ms", "Moz", "O"];
  Object.keys(De).forEach(function(n) {
    Ze.forEach(function(r) {
      r = r + n.charAt(0).toUpperCase() + n.substring(1), De[r] = De[n];
    });
  });
  function mt(n, r, o) {
    return r == null || typeof r == "boolean" || r === "" ? "" : o || typeof r != "number" || r === 0 || De.hasOwnProperty(n) && De[n] ? ("" + r).trim() : r + "px";
  }
  function Kt(n, r) {
    n = n.style;
    for (var o in r)
      if (r.hasOwnProperty(o)) {
        var E = o.indexOf("--") === 0, f = mt(o, r[o], E);
        o === "float" && (o = "cssFloat"), E ? n.setProperty(o, f) : n[o] = f;
      }
  }
  var zt = U({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function xn(n, r) {
    if (r) {
      if (zt[n] && (r.children != null || r.dangerouslySetInnerHTML != null))
        throw Error(T(137, n));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null)
          throw Error(T(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML))
          throw Error(T(61));
      }
      if (r.style != null && typeof r.style != "object")
        throw Error(T(62));
    }
  }
  function mn(n, r) {
    if (n.indexOf("-") === -1)
      return typeof r.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var hr = null;
  function tn(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var Mr = null, Jt = null, Qt = null;
  function ni(n) {
    if (n = yu(n)) {
      if (typeof Mr != "function")
        throw Error(T(280));
      var r = n.stateNode;
      r && (r = qe(r), Mr(n.stateNode, n.type, r));
    }
  }
  function Ba(n) {
    Jt ? Qt ? Qt.push(n) : Qt = [n] : Jt = n;
  }
  function Do() {
    if (Jt) {
      var n = Jt, r = Qt;
      if (Qt = Jt = null, ni(n), r)
        for (n = 0; n < r.length; n++)
          ni(r[n]);
    }
  }
  function hl(n, r) {
    return n(r);
  }
  function ls() {
  }
  var Xi = !1;
  function go(n, r, o) {
    if (Xi)
      return n(r, o);
    Xi = !0;
    try {
      return hl(n, r, o);
    } finally {
      Xi = !1, (Jt !== null || Qt !== null) && (ls(), Do());
    }
  }
  function Ca(n, r) {
    var o = n.stateNode;
    if (o === null)
      return null;
    var E = qe(o);
    if (E === null)
      return null;
    o = E[r];
    e:
      switch (r) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (E = !E.disabled) || (n = n.type, E = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !E;
          break e;
        default:
          n = !1;
      }
    if (n)
      return null;
    if (o && typeof o != "function")
      throw Error(T(231, r, typeof o));
    return o;
  }
  var hi = !1;
  if (G)
    try {
      var ha = {};
      Object.defineProperty(ha, "passive", { get: function() {
        hi = !0;
      } }), window.addEventListener("test", ha, ha), window.removeEventListener("test", ha, ha);
    } catch {
      hi = !1;
    }
  function vi(n, r, o, E, f, R, C, P, b) {
    var Z = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(o, Z);
    } catch (Te) {
      this.onError(Te);
    }
  }
  var Ur = !1, va = null, mi = !1, x = null, Ee = { onError: function(n) {
    Ur = !0, va = n;
  } };
  function ge(n, r, o, E, f, R, C, P, b) {
    Ur = !1, va = null, vi.apply(Ee, arguments);
  }
  function be(n, r, o, E, f, R, C, P, b) {
    if (ge.apply(this, arguments), Ur) {
      if (Ur) {
        var Z = va;
        Ur = !1, va = null;
      } else
        throw Error(T(198));
      mi || (mi = !0, x = Z);
    }
  }
  function dt(n) {
    var r = n, o = n;
    if (n.alternate)
      for (; r.return; )
        r = r.return;
    else {
      n = r;
      do
        r = n, r.flags & 4098 && (o = r.return), n = r.return;
      while (n);
    }
    return r.tag === 3 ? o : null;
  }
  function _t(n) {
    if (n.tag === 13) {
      var r = n.memoizedState;
      if (r === null && (n = n.alternate, n !== null && (r = n.memoizedState)), r !== null)
        return r.dehydrated;
    }
    return null;
  }
  function It(n) {
    if (dt(n) !== n)
      throw Error(T(188));
  }
  function et(n) {
    var r = n.alternate;
    if (!r) {
      if (r = dt(n), r === null)
        throw Error(T(188));
      return r !== n ? null : n;
    }
    for (var o = n, E = r; ; ) {
      var f = o.return;
      if (f === null)
        break;
      var R = f.alternate;
      if (R === null) {
        if (E = f.return, E !== null) {
          o = E;
          continue;
        }
        break;
      }
      if (f.child === R.child) {
        for (R = f.child; R; ) {
          if (R === o)
            return It(f), n;
          if (R === E)
            return It(f), r;
          R = R.sibling;
        }
        throw Error(T(188));
      }
      if (o.return !== E.return)
        o = f, E = R;
      else {
        for (var C = !1, P = f.child; P; ) {
          if (P === o) {
            C = !0, o = f, E = R;
            break;
          }
          if (P === E) {
            C = !0, E = f, o = R;
            break;
          }
          P = P.sibling;
        }
        if (!C) {
          for (P = R.child; P; ) {
            if (P === o) {
              C = !0, o = R, E = f;
              break;
            }
            if (P === E) {
              C = !0, E = R, o = f;
              break;
            }
            P = P.sibling;
          }
          if (!C)
            throw Error(T(189));
        }
      }
      if (o.alternate !== E)
        throw Error(T(190));
    }
    if (o.tag !== 3)
      throw Error(T(188));
    return o.stateNode.current === o ? n : r;
  }
  function Vn(n) {
    return n = et(n), n !== null ? Tn(n) : null;
  }
  function Tn(n) {
    if (n.tag === 5 || n.tag === 6)
      return n;
    for (n = n.child; n !== null; ) {
      var r = Tn(n);
      if (r !== null)
        return r;
      n = n.sibling;
    }
    return null;
  }
  var fn = u.unstable_scheduleCallback, Er = u.unstable_cancelCallback, Li = u.unstable_shouldYield, ss = u.unstable_requestPaint, Ht = u.unstable_now, fT = u.unstable_getCurrentPriorityLevel, ri = u.unstable_ImmediatePriority, Dt = u.unstable_UserBlockingPriority, yi = u.unstable_NormalPriority, Po = u.unstable_LowPriority, us = u.unstable_IdlePriority, Mo = null, ta = null;
  function Eu(n) {
    if (ta && typeof ta.onCommitFiberRoot == "function")
      try {
        ta.onCommitFiberRoot(Mo, n, void 0, (n.current.flags & 128) === 128);
      } catch {
      }
  }
  var _r = Math.clz32 ? Math.clz32 : GE, cu = Math.log, Tu = Math.LN2;
  function GE(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (cu(n) / Tu | 0) | 0;
  }
  var Es = 64, Uo = 4194304;
  function ai(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function Gr(n, r) {
    var o = n.pendingLanes;
    if (o === 0)
      return 0;
    var E = 0, f = n.suspendedLanes, R = n.pingedLanes, C = o & 268435455;
    if (C !== 0) {
      var P = C & ~f;
      P !== 0 ? E = ai(P) : (R &= C, R !== 0 && (E = ai(R)));
    } else
      C = o & ~f, C !== 0 ? E = ai(C) : R !== 0 && (E = ai(R));
    if (E === 0)
      return 0;
    if (r !== 0 && r !== E && !(r & f) && (f = E & -E, R = r & -r, f >= R || f === 16 && (R & 4194240) !== 0))
      return r;
    if (E & 4 && (E |= o & 16), r = n.entangledLanes, r !== 0)
      for (n = n.entanglements, r &= E; 0 < r; )
        o = 31 - _r(r), f = 1 << o, E |= n[o], r &= ~f;
    return E;
  }
  function _o(n, r) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Go(n, r) {
    for (var o = n.suspendedLanes, E = n.pingedLanes, f = n.expirationTimes, R = n.pendingLanes; 0 < R; ) {
      var C = 31 - _r(R), P = 1 << C, b = f[C];
      b === -1 ? (!(P & o) || P & E) && (f[C] = _o(P, r)) : b <= r && (n.expiredLanes |= P), R &= ~P;
    }
  }
  function xo(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function cs() {
    var n = Es;
    return Es <<= 1, !(Es & 4194240) && (Es = 64), n;
  }
  function Ts(n) {
    for (var r = [], o = 0; 31 > o; o++)
      r.push(n);
    return r;
  }
  function ki(n, r, o) {
    n.pendingLanes |= r, r !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, r = 31 - _r(r), n[r] = o;
  }
  function AT(n, r) {
    var o = n.pendingLanes & ~r;
    n.pendingLanes = r, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r, r = n.entanglements;
    var E = n.eventTimes;
    for (n = n.expirationTimes; 0 < o; ) {
      var f = 31 - _r(o), R = 1 << f;
      r[f] = 0, E[f] = -1, n[f] = -1, o &= ~R;
    }
  }
  function Di(n, r) {
    var o = n.entangledLanes |= r;
    for (n = n.entanglements; o; ) {
      var E = 31 - _r(o), f = 1 << E;
      f & r | n[E] & r && (n[E] |= r), o &= ~f;
    }
  }
  var Vt = 0;
  function fs(n) {
    return n &= -n, 1 < n ? 4 < n ? n & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var vl, As, Bt, Rs, ds, ct = !1, ml = [], Ln = null, na = null, xr = null, bo = /* @__PURE__ */ new Map(), Pn = /* @__PURE__ */ new Map(), Zt = [], xE = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function ra(n, r) {
    switch (n) {
      case "focusin":
      case "focusout":
        Ln = null;
        break;
      case "dragenter":
      case "dragleave":
        na = null;
        break;
      case "mouseover":
      case "mouseout":
        xr = null;
        break;
      case "pointerover":
      case "pointerout":
        bo.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Pn.delete(r.pointerId);
    }
  }
  function ar(n, r, o, E, f, R) {
    return n === null || n.nativeEvent !== R ? (n = { blockedOn: r, domEventName: o, eventSystemFlags: E, nativeEvent: R, targetContainers: [f] }, r !== null && (r = yu(r), r !== null && As(r)), n) : (n.eventSystemFlags |= E, r = n.targetContainers, f !== null && r.indexOf(f) === -1 && r.push(f), n);
  }
  function gi(n, r, o, E, f) {
    switch (r) {
      case "focusin":
        return Ln = ar(Ln, n, r, o, E, f), !0;
      case "dragenter":
        return na = ar(na, n, r, o, E, f), !0;
      case "mouseover":
        return xr = ar(xr, n, r, o, E, f), !0;
      case "pointerover":
        var R = f.pointerId;
        return bo.set(R, ar(bo.get(R) || null, n, r, o, E, f)), !0;
      case "gotpointercapture":
        return R = f.pointerId, Pn.set(R, ar(Pn.get(R) || null, n, r, o, E, f)), !0;
    }
    return !1;
  }
  function bE(n) {
    var r = Va(n.target);
    if (r !== null) {
      var o = dt(r);
      if (o !== null) {
        if (r = o.tag, r === 13) {
          if (r = _t(o), r !== null) {
            n.blockedOn = r, ds(n.priority, function() {
              Bt(o);
            });
            return;
          }
        } else if (r === 3 && o.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = o.tag === 3 ? o.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function Ki(n) {
    if (n.blockedOn !== null)
      return !1;
    for (var r = n.targetContainers; 0 < r.length; ) {
      var o = Ns(n.domEventName, n.eventSystemFlags, r[0], n.nativeEvent);
      if (o === null) {
        o = n.nativeEvent;
        var E = new o.constructor(o.type, o);
        hr = E, o.target.dispatchEvent(E), hr = null;
      } else
        return r = yu(o), r !== null && As(r), n.blockedOn = o, !1;
      r.shift();
    }
    return !0;
  }
  function Ho(n, r, o) {
    Ki(n) && o.delete(r);
  }
  function HE() {
    ct = !1, Ln !== null && Ki(Ln) && (Ln = null), na !== null && Ki(na) && (na = null), xr !== null && Ki(xr) && (xr = null), bo.forEach(Ho), Pn.forEach(Ho);
  }
  function Fa(n, r) {
    n.blockedOn === r && (n.blockedOn = null, ct || (ct = !0, u.unstable_scheduleCallback(u.unstable_NormalPriority, HE)));
  }
  function Bo(n) {
    function r(f) {
      return Fa(f, n);
    }
    if (0 < ml.length) {
      Fa(ml[0], n);
      for (var o = 1; o < ml.length; o++) {
        var E = ml[o];
        E.blockedOn === n && (E.blockedOn = null);
      }
    }
    for (Ln !== null && Fa(Ln, n), na !== null && Fa(na, n), xr !== null && Fa(xr, n), bo.forEach(r), Pn.forEach(r), o = 0; o < Zt.length; o++)
      E = Zt[o], E.blockedOn === n && (E.blockedOn = null);
    for (; 0 < Zt.length && (o = Zt[0], o.blockedOn === null); )
      bE(o), o.blockedOn === null && Zt.shift();
  }
  var Fo = Fe.ReactCurrentBatchConfig, wa = !0;
  function Ss(n, r, o, E) {
    var f = Vt, R = Fo.transition;
    Fo.transition = null;
    try {
      Vt = 1, Yo(n, r, o, E);
    } finally {
      Vt = f, Fo.transition = R;
    }
  }
  function wo(n, r, o, E) {
    var f = Vt, R = Fo.transition;
    Fo.transition = null;
    try {
      Vt = 4, Yo(n, r, o, E);
    } finally {
      Vt = f, Fo.transition = R;
    }
  }
  function Yo(n, r, o, E) {
    if (wa) {
      var f = Ns(n, r, o, E);
      if (f === null)
        KE(n, r, E, Ll, o), ra(n, E);
      else if (gi(f, n, r, o, E))
        E.stopPropagation();
      else if (ra(n, E), r & 4 && -1 < xE.indexOf(n)) {
        for (; f !== null; ) {
          var R = yu(f);
          if (R !== null && vl(R), R = Ns(n, r, o, E), R === null && KE(n, r, E, Ll, o), R === f)
            break;
          f = R;
        }
        f !== null && E.stopPropagation();
      } else
        KE(n, r, E, null, o);
    }
  }
  var Ll = null;
  function Ns(n, r, o, E) {
    if (Ll = null, n = tn(E), n = Va(n), n !== null)
      if (r = dt(n), r === null)
        n = null;
      else if (o = r.tag, o === 13) {
        if (n = _t(r), n !== null)
          return n;
        n = null;
      } else if (o === 3) {
        if (r.stateNode.current.memoizedState.isDehydrated)
          return r.tag === 3 ? r.stateNode.containerInfo : null;
        n = null;
      } else
        r !== n && (n = null);
    return Ll = n, null;
  }
  function fu(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (fT()) {
          case ri:
            return 1;
          case Dt:
            return 4;
          case yi:
          case Po:
            return 16;
          case us:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var ii = null, I = null, _ = null;
  function J() {
    if (_)
      return _;
    var n, r = I, o = r.length, E, f = "value" in ii ? ii.value : ii.textContent, R = f.length;
    for (n = 0; n < o && r[n] === f[n]; n++)
      ;
    var C = o - n;
    for (E = 1; E <= C && r[o - E] === f[R - E]; E++)
      ;
    return _ = f.slice(n, 1 < E ? 1 - E : void 0);
  }
  function $(n) {
    var r = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && r === 13 && (n = 13)) : n = r, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function Ce() {
    return !0;
  }
  function at() {
    return !1;
  }
  function Me(n) {
    function r(o, E, f, R, C) {
      this._reactName = o, this._targetInst = f, this.type = E, this.nativeEvent = R, this.target = C, this.currentTarget = null;
      for (var P in n)
        n.hasOwnProperty(P) && (o = n[P], this[P] = o ? o(R) : R[P]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? Ce : at, this.isPropagationStopped = at, this;
    }
    return U(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var o = this.nativeEvent;
      o && (o.preventDefault ? o.preventDefault() : typeof o.returnValue != "unknown" && (o.returnValue = !1), this.isDefaultPrevented = Ce);
    }, stopPropagation: function() {
      var o = this.nativeEvent;
      o && (o.stopPropagation ? o.stopPropagation() : typeof o.cancelBubble != "unknown" && (o.cancelBubble = !0), this.isPropagationStopped = Ce);
    }, persist: function() {
    }, isPersistent: Ce }), r;
  }
  var nt = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Lt = Me(nt), Ft = U({}, nt, { view: 0, detail: 0 }), sn = Me(Ft), nn, un, An, Ut = U({}, Ft, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: pT, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== An && (An && n.type === "mousemove" ? (nn = n.screenX - An.screenX, un = n.screenY - An.screenY) : un = nn = 0, An = n), nn);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : un;
  } }), ji = Me(Ut), ps = U({}, Ut, { dataTransfer: 0 }), Au = Me(ps), RT = U({}, Ft, { relatedTarget: 0 }), oi = Me(RT), Ru = U({}, nt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), du = Me(Ru), dT = U({}, nt, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), kS = Me(dT), KS = U({}, nt, { data: 0 }), ST = Me(KS), NT = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, YA = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, VA = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function WA(n) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(n) : (n = VA[n]) ? !!r[n] : !1;
  }
  function pT() {
    return WA;
  }
  var zi = U({}, Ft, { key: function(n) {
    if (n.key) {
      var r = NT[n.key] || n.key;
      if (r !== "Unidentified")
        return r;
    }
    return n.type === "keypress" ? (n = $(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? YA[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: pT, charCode: function(n) {
    return n.type === "keypress" ? $(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? $(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), jS = Me(zi), OT = U({}, Ut, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), BE = Me(OT), IT = U({}, Ft, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: pT }), zS = Me(IT), FE = U({}, nt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), XA = Me(FE), aa = U({}, Ut, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Ji = Me(aa), Wn = [9, 13, 27, 32], li = G && "CompositionEvent" in window, yl = null;
  G && "documentMode" in document && (yl = document.documentMode);
  var wE = G && "TextEvent" in window && !yl, kA = G && (!li || yl && 8 < yl && 11 >= yl), Os = String.fromCharCode(32), KA = !1;
  function jA(n, r) {
    switch (n) {
      case "keyup":
        return Wn.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function YE(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var Is = !1;
  function JS(n, r) {
    switch (n) {
      case "compositionend":
        return YE(r);
      case "keypress":
        return r.which !== 32 ? null : (KA = !0, Os);
      case "textInput":
        return n = r.data, n === Os && KA ? null : n;
      default:
        return null;
    }
  }
  function QS(n, r) {
    if (Is)
      return n === "compositionend" || !li && jA(n, r) ? (n = J(), _ = I = ii = null, Is = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length)
            return r.char;
          if (r.which)
            return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return kA && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var zA = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function JA(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r === "input" ? !!zA[n.type] : r === "textarea";
  }
  function QA(n, r, o, E) {
    Ba(E), r = vu(r, "onChange"), 0 < r.length && (o = new Lt("onChange", "change", null, o, E), n.push({ event: o, listeners: r }));
  }
  var Su = null, Cs = null;
  function hs(n) {
    kE(n, 0);
  }
  function vs(n) {
    var r = Ls(n);
    if (Jn(r))
      return n;
  }
  function ZA(n, r) {
    if (n === "change")
      return r;
  }
  var CT = !1;
  if (G) {
    var hT;
    if (G) {
      var vT = "oninput" in document;
      if (!vT) {
        var qA = document.createElement("div");
        qA.setAttribute("oninput", "return;"), vT = typeof qA.oninput == "function";
      }
      hT = vT;
    } else
      hT = !1;
    CT = hT && (!document.documentMode || 9 < document.documentMode);
  }
  function $A() {
    Su && (Su.detachEvent("onpropertychange", eR), Cs = Su = null);
  }
  function eR(n) {
    if (n.propertyName === "value" && vs(Cs)) {
      var r = [];
      QA(r, Cs, n, tn(n)), go(hs, r);
    }
  }
  function ZS(n, r, o) {
    n === "focusin" ? ($A(), Su = r, Cs = o, Su.attachEvent("onpropertychange", eR)) : n === "focusout" && $A();
  }
  function qS(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown")
      return vs(Cs);
  }
  function $S(n, r) {
    if (n === "click")
      return vs(r);
  }
  function tR(n, r) {
    if (n === "input" || n === "change")
      return vs(r);
  }
  function eN(n, r) {
    return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
  }
  var Ya = typeof Object.is == "function" ? Object.is : eN;
  function Nu(n, r) {
    if (Ya(n, r))
      return !0;
    if (typeof n != "object" || n === null || typeof r != "object" || r === null)
      return !1;
    var o = Object.keys(n), E = Object.keys(r);
    if (o.length !== E.length)
      return !1;
    for (E = 0; E < o.length; E++) {
      var f = o[E];
      if (!D.call(r, f) || !Ya(n[f], r[f]))
        return !1;
    }
    return !0;
  }
  function nR(n) {
    for (; n && n.firstChild; )
      n = n.firstChild;
    return n;
  }
  function rR(n, r) {
    var o = nR(n);
    n = 0;
    for (var E; o; ) {
      if (o.nodeType === 3) {
        if (E = n + o.textContent.length, n <= r && E >= r)
          return { node: o, offset: r - n };
        n = E;
      }
      e: {
        for (; o; ) {
          if (o.nextSibling) {
            o = o.nextSibling;
            break e;
          }
          o = o.parentNode;
        }
        o = void 0;
      }
      o = nR(o);
    }
  }
  function aR(n, r) {
    return n && r ? n === r ? !0 : n && n.nodeType === 3 ? !1 : r && r.nodeType === 3 ? aR(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function VE() {
    for (var n = window, r = hn(); r instanceof n.HTMLIFrameElement; ) {
      try {
        var o = typeof r.contentWindow.location.href == "string";
      } catch {
        o = !1;
      }
      if (o)
        n = r.contentWindow;
      else
        break;
      r = hn(n.document);
    }
    return r;
  }
  function Qi(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
  }
  function WE(n) {
    var r = VE(), o = n.focusedElem, E = n.selectionRange;
    if (r !== o && o && o.ownerDocument && aR(o.ownerDocument.documentElement, o)) {
      if (E !== null && Qi(o)) {
        if (r = E.start, n = E.end, n === void 0 && (n = r), "selectionStart" in o)
          o.selectionStart = r, o.selectionEnd = Math.min(n, o.value.length);
        else if (n = (r = o.ownerDocument || document) && r.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var f = o.textContent.length, R = Math.min(E.start, f);
          E = E.end === void 0 ? R : Math.min(E.end, f), !n.extend && R > E && (f = E, E = R, R = f), f = rR(o, R);
          var C = rR(
            o,
            E
          );
          f && C && (n.rangeCount !== 1 || n.anchorNode !== f.node || n.anchorOffset !== f.offset || n.focusNode !== C.node || n.focusOffset !== C.offset) && (r = r.createRange(), r.setStart(f.node, f.offset), n.removeAllRanges(), R > E ? (n.addRange(r), n.extend(C.node, C.offset)) : (r.setEnd(C.node, C.offset), n.addRange(r)));
        }
      }
      for (r = [], n = o; n = n.parentNode; )
        n.nodeType === 1 && r.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof o.focus == "function" && o.focus(), o = 0; o < r.length; o++)
        n = r[o], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var iR = G && "documentMode" in document && 11 >= document.documentMode, si = null, mT = null, pu = null, LT = !1;
  function oR(n, r, o) {
    var E = o.window === o ? o.document : o.nodeType === 9 ? o : o.ownerDocument;
    LT || si == null || si !== hn(E) || (E = si, "selectionStart" in E && Qi(E) ? E = { start: E.selectionStart, end: E.selectionEnd } : (E = (E.ownerDocument && E.ownerDocument.defaultView || window).getSelection(), E = { anchorNode: E.anchorNode, anchorOffset: E.anchorOffset, focusNode: E.focusNode, focusOffset: E.focusOffset }), pu && Nu(pu, E) || (pu = E, E = vu(mT, "onSelect"), 0 < E.length && (r = new Lt("onSelect", "select", null, r, o), n.push({ event: r, listeners: E }), r.target = si)));
  }
  function XE(n, r) {
    var o = {};
    return o[n.toLowerCase()] = r.toLowerCase(), o["Webkit" + n] = "webkit" + r, o["Moz" + n] = "moz" + r, o;
  }
  var Dl = { animationend: XE("Animation", "AnimationEnd"), animationiteration: XE("Animation", "AnimationIteration"), animationstart: XE("Animation", "AnimationStart"), transitionend: XE("Transition", "TransitionEnd") }, yT = {}, DT = {};
  G && (DT = document.createElement("div").style, "AnimationEvent" in window || (delete Dl.animationend.animation, delete Dl.animationiteration.animation, delete Dl.animationstart.animation), "TransitionEvent" in window || delete Dl.transitionend.transition);
  function ir(n) {
    if (yT[n])
      return yT[n];
    if (!Dl[n])
      return n;
    var r = Dl[n], o;
    for (o in r)
      if (r.hasOwnProperty(o) && o in DT)
        return yT[n] = r[o];
    return n;
  }
  var gT = ir("animationend"), lR = ir("animationiteration"), sR = ir("animationstart"), uR = ir("transitionend"), ER = /* @__PURE__ */ new Map(), cR = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Zi(n, r) {
    ER.set(n, r), h(r, [n]);
  }
  for (var Ou = 0; Ou < cR.length; Ou++) {
    var gl = cR[Ou], tN = gl.toLowerCase(), Iu = gl[0].toUpperCase() + gl.slice(1);
    Zi(tN, "on" + Iu);
  }
  Zi(gT, "onAnimationEnd"), Zi(lR, "onAnimationIteration"), Zi(sR, "onAnimationStart"), Zi("dblclick", "onDoubleClick"), Zi("focusin", "onFocus"), Zi("focusout", "onBlur"), Zi(uR, "onTransitionEnd"), d("onMouseEnter", ["mouseout", "mouseover"]), d("onMouseLeave", ["mouseout", "mouseover"]), d("onPointerEnter", ["pointerout", "pointerover"]), d("onPointerLeave", ["pointerout", "pointerover"]), h("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), h("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), h("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), h("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), h("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), h("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Cu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nN = new Set("cancel close invalid load scroll toggle".split(" ").concat(Cu));
  function TR(n, r, o) {
    var E = n.type || "unknown-event";
    n.currentTarget = o, be(E, r, void 0, n), n.currentTarget = null;
  }
  function kE(n, r) {
    r = (r & 4) !== 0;
    for (var o = 0; o < n.length; o++) {
      var E = n[o], f = E.event;
      E = E.listeners;
      e: {
        var R = void 0;
        if (r)
          for (var C = E.length - 1; 0 <= C; C--) {
            var P = E[C], b = P.instance, Z = P.currentTarget;
            if (P = P.listener, b !== R && f.isPropagationStopped())
              break e;
            TR(f, P, Z), R = b;
          }
        else
          for (C = 0; C < E.length; C++) {
            if (P = E[C], b = P.instance, Z = P.currentTarget, P = P.listener, b !== R && f.isPropagationStopped())
              break e;
            TR(f, P, Z), R = b;
          }
      }
    }
    if (mi)
      throw n = x, mi = !1, x = null, n;
  }
  function En(n, r) {
    var o = r[bT];
    o === void 0 && (o = r[bT] = /* @__PURE__ */ new Set());
    var E = n + "__bubble";
    o.has(E) || (fR(r, n, 2, !1), o.add(E));
  }
  function Vo(n, r, o) {
    var E = 0;
    r && (E |= 4), fR(o, n, E, r);
  }
  var qi = "_reactListening" + Math.random().toString(36).slice(2);
  function ms(n) {
    if (!n[qi]) {
      n[qi] = !0, N.forEach(function(o) {
        o !== "selectionchange" && (nN.has(o) || Vo(o, !1, n), Vo(o, !0, n));
      });
      var r = n.nodeType === 9 ? n : n.ownerDocument;
      r === null || r[qi] || (r[qi] = !0, Vo("selectionchange", !1, r));
    }
  }
  function fR(n, r, o, E) {
    switch (fu(r)) {
      case 1:
        var f = Ss;
        break;
      case 4:
        f = wo;
        break;
      default:
        f = Yo;
    }
    o = f.bind(null, r, o, n), f = void 0, !hi || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (f = !0), E ? f !== void 0 ? n.addEventListener(r, o, { capture: !0, passive: f }) : n.addEventListener(r, o, !0) : f !== void 0 ? n.addEventListener(r, o, { passive: f }) : n.addEventListener(r, o, !1);
  }
  function KE(n, r, o, E, f) {
    var R = E;
    if (!(r & 1) && !(r & 2) && E !== null)
      e:
        for (; ; ) {
          if (E === null)
            return;
          var C = E.tag;
          if (C === 3 || C === 4) {
            var P = E.stateNode.containerInfo;
            if (P === f || P.nodeType === 8 && P.parentNode === f)
              break;
            if (C === 4)
              for (C = E.return; C !== null; ) {
                var b = C.tag;
                if ((b === 3 || b === 4) && (b = C.stateNode.containerInfo, b === f || b.nodeType === 8 && b.parentNode === f))
                  return;
                C = C.return;
              }
            for (; P !== null; ) {
              if (C = Va(P), C === null)
                return;
              if (b = C.tag, b === 5 || b === 6) {
                E = R = C;
                continue e;
              }
              P = P.parentNode;
            }
          }
          E = E.return;
        }
    go(function() {
      var Z = R, Te = tn(o), fe = [];
      e: {
        var ue = ER.get(n);
        if (ue !== void 0) {
          var Ue = Lt, we = n;
          switch (n) {
            case "keypress":
              if ($(o) === 0)
                break e;
            case "keydown":
            case "keyup":
              Ue = jS;
              break;
            case "focusin":
              we = "focus", Ue = oi;
              break;
            case "focusout":
              we = "blur", Ue = oi;
              break;
            case "beforeblur":
            case "afterblur":
              Ue = oi;
              break;
            case "click":
              if (o.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ue = ji;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ue = Au;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ue = zS;
              break;
            case gT:
            case lR:
            case sR:
              Ue = du;
              break;
            case uR:
              Ue = XA;
              break;
            case "scroll":
              Ue = sn;
              break;
            case "wheel":
              Ue = Ji;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ue = kS;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ue = BE;
          }
          var ke = (r & 4) !== 0, Fn = !ke && n === "scroll", V = ke ? ue !== null ? ue + "Capture" : null : ue;
          ke = [];
          for (var B = Z, K; B !== null; ) {
            K = B;
            var Ne = K.stateNode;
            if (K.tag === 5 && Ne !== null && (K = Ne, V !== null && (Ne = Ca(B, V), Ne != null && ke.push(hu(B, Ne, K)))), Fn)
              break;
            B = B.return;
          }
          0 < ke.length && (ue = new Ue(ue, we, null, o, Te), fe.push({ event: ue, listeners: ke }));
        }
      }
      if (!(r & 7)) {
        e: {
          if (ue = n === "mouseover" || n === "pointerover", Ue = n === "mouseout" || n === "pointerout", ue && o !== hr && (we = o.relatedTarget || o.fromElement) && (Va(we) || we[$i]))
            break e;
          if ((Ue || ue) && (ue = Te.window === Te ? Te : (ue = Te.ownerDocument) ? ue.defaultView || ue.parentWindow : window, Ue ? (we = o.relatedTarget || o.toElement, Ue = Z, we = we ? Va(we) : null, we !== null && (Fn = dt(we), we !== Fn || we.tag !== 5 && we.tag !== 6) && (we = null)) : (Ue = null, we = Z), Ue !== we)) {
            if (ke = ji, Ne = "onMouseLeave", V = "onMouseEnter", B = "mouse", (n === "pointerout" || n === "pointerover") && (ke = BE, Ne = "onPointerLeave", V = "onPointerEnter", B = "pointer"), Fn = Ue == null ? ue : Ls(Ue), K = we == null ? ue : Ls(we), ue = new ke(Ne, B + "leave", Ue, o, Te), ue.target = Fn, ue.relatedTarget = K, Ne = null, Va(Te) === Z && (ke = new ke(V, B + "enter", we, o, Te), ke.target = K, ke.relatedTarget = Fn, Ne = ke), Fn = Ne, Ue && we)
              t: {
                for (ke = Ue, V = we, B = 0, K = ke; K; K = Pl(K))
                  B++;
                for (K = 0, Ne = V; Ne; Ne = Pl(Ne))
                  K++;
                for (; 0 < B - K; )
                  ke = Pl(ke), B--;
                for (; 0 < K - B; )
                  V = Pl(V), K--;
                for (; B--; ) {
                  if (ke === V || V !== null && ke === V.alternate)
                    break t;
                  ke = Pl(ke), V = Pl(V);
                }
                ke = null;
              }
            else
              ke = null;
            Ue !== null && PT(fe, ue, Ue, ke, !1), we !== null && Fn !== null && PT(fe, Fn, we, ke, !0);
          }
        }
        e: {
          if (ue = Z ? Ls(Z) : window, Ue = ue.nodeName && ue.nodeName.toLowerCase(), Ue === "select" || Ue === "input" && ue.type === "file")
            var Ke = ZA;
          else if (JA(ue))
            if (CT)
              Ke = tR;
            else {
              Ke = qS;
              var rt = ZS;
            }
          else
            (Ue = ue.nodeName) && Ue.toLowerCase() === "input" && (ue.type === "checkbox" || ue.type === "radio") && (Ke = $S);
          if (Ke && (Ke = Ke(n, Z))) {
            QA(fe, Ke, o, Te);
            break e;
          }
          rt && rt(n, ue, Z), n === "focusout" && (rt = ue._wrapperState) && rt.controlled && ue.type === "number" && qr(ue, "number", ue.value);
        }
        switch (rt = Z ? Ls(Z) : window, n) {
          case "focusin":
            (JA(rt) || rt.contentEditable === "true") && (si = rt, mT = Z, pu = null);
            break;
          case "focusout":
            pu = mT = si = null;
            break;
          case "mousedown":
            LT = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            LT = !1, oR(fe, o, Te);
            break;
          case "selectionchange":
            if (iR)
              break;
          case "keydown":
          case "keyup":
            oR(fe, o, Te);
        }
        var $e;
        if (li)
          e: {
            switch (n) {
              case "compositionstart":
                var Et = "onCompositionStart";
                break e;
              case "compositionend":
                Et = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Et = "onCompositionUpdate";
                break e;
            }
            Et = void 0;
          }
        else
          Is ? jA(n, o) && (Et = "onCompositionEnd") : n === "keydown" && o.keyCode === 229 && (Et = "onCompositionStart");
        Et && (kA && o.locale !== "ko" && (Is || Et !== "onCompositionStart" ? Et === "onCompositionEnd" && Is && ($e = J()) : (ii = Te, I = "value" in ii ? ii.value : ii.textContent, Is = !0)), rt = vu(Z, Et), 0 < rt.length && (Et = new ST(Et, n, null, o, Te), fe.push({ event: Et, listeners: rt }), $e ? Et.data = $e : ($e = YE(o), $e !== null && (Et.data = $e)))), ($e = wE ? JS(n, o) : QS(n, o)) && (Z = vu(Z, "onBeforeInput"), 0 < Z.length && (Te = new ST("onBeforeInput", "beforeinput", null, o, Te), fe.push({ event: Te, listeners: Z }), Te.data = $e));
      }
      kE(fe, r);
    });
  }
  function hu(n, r, o) {
    return { instance: n, listener: r, currentTarget: o };
  }
  function vu(n, r) {
    for (var o = r + "Capture", E = []; n !== null; ) {
      var f = n, R = f.stateNode;
      f.tag === 5 && R !== null && (f = R, R = Ca(n, o), R != null && E.unshift(hu(n, R, f)), R = Ca(n, r), R != null && E.push(hu(n, R, f))), n = n.return;
    }
    return E;
  }
  function Pl(n) {
    if (n === null)
      return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function PT(n, r, o, E, f) {
    for (var R = r._reactName, C = []; o !== null && o !== E; ) {
      var P = o, b = P.alternate, Z = P.stateNode;
      if (b !== null && b === E)
        break;
      P.tag === 5 && Z !== null && (P = Z, f ? (b = Ca(o, R), b != null && C.unshift(hu(o, b, P))) : f || (b = Ca(o, R), b != null && C.push(hu(o, b, P)))), o = o.return;
    }
    C.length !== 0 && n.push({ event: r, listeners: C });
  }
  var MT = /\r\n?/g, rN = /\u0000|\uFFFD/g;
  function UT(n) {
    return (typeof n == "string" ? n : "" + n).replace(MT, `
`).replace(rN, "");
  }
  function jE(n, r, o) {
    if (r = UT(r), UT(n) !== r && o)
      throw Error(T(425));
  }
  function zE() {
  }
  var _T = null, Ml = null;
  function mu(n, r) {
    return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var Ul = typeof setTimeout == "function" ? setTimeout : void 0, AR = typeof clearTimeout == "function" ? clearTimeout : void 0, GT = typeof Promise == "function" ? Promise : void 0, xT = typeof queueMicrotask == "function" ? queueMicrotask : typeof GT < "u" ? function(n) {
    return GT.resolve(null).then(n).catch(aN);
  } : Ul;
  function aN(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function Wo(n, r) {
    var o = r, E = 0;
    do {
      var f = o.nextSibling;
      if (n.removeChild(o), f && f.nodeType === 8)
        if (o = f.data, o === "/$") {
          if (E === 0) {
            n.removeChild(f), Bo(r);
            return;
          }
          E--;
        } else
          o !== "$" && o !== "$?" && o !== "$!" || E++;
      o = f;
    } while (o);
    Bo(r);
  }
  function ui(n) {
    for (; n != null; n = n.nextSibling) {
      var r = n.nodeType;
      if (r === 1 || r === 3)
        break;
      if (r === 8) {
        if (r = n.data, r === "$" || r === "$!" || r === "$?")
          break;
        if (r === "/$")
          return null;
      }
    }
    return n;
  }
  function Lu(n) {
    n = n.previousSibling;
    for (var r = 0; n; ) {
      if (n.nodeType === 8) {
        var o = n.data;
        if (o === "$" || o === "$!" || o === "$?") {
          if (r === 0)
            return n;
          r--;
        } else
          o === "/$" && r++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var Xo = Math.random().toString(36).slice(2), Pi = "__reactFiber$" + Xo, _l = "__reactProps$" + Xo, $i = "__reactContainer$" + Xo, bT = "__reactEvents$" + Xo, iN = "__reactListeners$" + Xo, HT = "__reactHandles$" + Xo;
  function Va(n) {
    var r = n[Pi];
    if (r)
      return r;
    for (var o = n.parentNode; o; ) {
      if (r = o[$i] || o[Pi]) {
        if (o = r.alternate, r.child !== null || o !== null && o.child !== null)
          for (n = Lu(n); n !== null; ) {
            if (o = n[Pi])
              return o;
            n = Lu(n);
          }
        return r;
      }
      n = o, o = n.parentNode;
    }
    return null;
  }
  function yu(n) {
    return n = n[Pi] || n[$i], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function Ls(n) {
    if (n.tag === 5 || n.tag === 6)
      return n.stateNode;
    throw Error(T(33));
  }
  function qe(n) {
    return n[_l] || null;
  }
  var ko = [], dn = -1;
  function Ct(n) {
    return { current: n };
  }
  function jt(n) {
    0 > dn || (n.current = ko[dn], ko[dn] = null, dn--);
  }
  function qt(n, r) {
    dn++, ko[dn] = n.current, n.current = r;
  }
  var Mi = {}, Tt = Ct(Mi), Mn = Ct(!1), ia = Mi;
  function Wa(n, r) {
    var o = n.type.contextTypes;
    if (!o)
      return Mi;
    var E = n.stateNode;
    if (E && E.__reactInternalMemoizedUnmaskedChildContext === r)
      return E.__reactInternalMemoizedMaskedChildContext;
    var f = {}, R;
    for (R in o)
      f[R] = r[R];
    return E && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = r, n.__reactInternalMemoizedMaskedChildContext = f), f;
  }
  function In(n) {
    return n = n.childContextTypes, n != null;
  }
  function Xa() {
    jt(Mn), jt(Tt);
  }
  function Ko(n, r, o) {
    if (Tt.current !== Mi)
      throw Error(T(168));
    qt(Tt, r), qt(Mn, o);
  }
  function Du(n, r, o) {
    var E = n.stateNode;
    if (r = r.childContextTypes, typeof E.getChildContext != "function")
      return o;
    E = E.getChildContext();
    for (var f in E)
      if (!(f in r))
        throw Error(T(108, Ot(n) || "Unknown", f));
    return U({}, o, E);
  }
  function JE(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || Mi, ia = Tt.current, qt(Tt, n), qt(Mn, Mn.current), !0;
  }
  function RR(n, r, o) {
    var E = n.stateNode;
    if (!E)
      throw Error(T(169));
    o ? (n = Du(n, r, ia), E.__reactInternalMemoizedMergedChildContext = n, jt(Mn), jt(Tt), qt(Tt, n)) : jt(Mn), qt(Mn, o);
  }
  var ma = null, or = !1, gu = !1;
  function BT(n) {
    ma === null ? ma = [n] : ma.push(n);
  }
  function FT(n) {
    or = !0, BT(n);
  }
  function oa() {
    if (!gu && ma !== null) {
      gu = !0;
      var n = 0, r = Vt;
      try {
        var o = ma;
        for (Vt = 1; n < o.length; n++) {
          var E = o[n];
          do
            E = E(!0);
          while (E !== null);
        }
        ma = null, or = !1;
      } catch (f) {
        throw ma !== null && (ma = ma.slice(n + 1)), fn(ri, oa), f;
      } finally {
        Vt = r, gu = !1;
      }
    }
    return null;
  }
  var jo = [], la = 0, Gl = null, ys = 0, sa = [], vr = 0, ka = null, cr = 1, eo = "";
  function La(n, r) {
    jo[la++] = ys, jo[la++] = Gl, Gl = n, ys = r;
  }
  function wT(n, r, o) {
    sa[vr++] = cr, sa[vr++] = eo, sa[vr++] = ka, ka = n;
    var E = cr;
    n = eo;
    var f = 32 - _r(E) - 1;
    E &= ~(1 << f), o += 1;
    var R = 32 - _r(r) + f;
    if (30 < R) {
      var C = f - f % 5;
      R = (E & (1 << C) - 1).toString(32), E >>= C, f -= C, cr = 1 << 32 - _r(r) + f | o << f | E, eo = R + n;
    } else
      cr = 1 << R | o << f | E, eo = n;
  }
  function QE(n) {
    n.return !== null && (La(n, 1), wT(n, 1, 0));
  }
  function YT(n) {
    for (; n === Gl; )
      Gl = jo[--la], jo[la] = null, ys = jo[--la], jo[la] = null;
    for (; n === ka; )
      ka = sa[--vr], sa[vr] = null, eo = sa[--vr], sa[vr] = null, cr = sa[--vr], sa[vr] = null;
  }
  var ya = null, ua = null, Sn = !1, Ka = null;
  function VT(n, r) {
    var o = Ma(5, null, null, 0);
    o.elementType = "DELETED", o.stateNode = r, o.return = n, r = n.deletions, r === null ? (n.deletions = [o], n.flags |= 16) : r.push(o);
  }
  function dR(n, r) {
    switch (n.tag) {
      case 5:
        var o = n.type;
        return r = r.nodeType !== 1 || o.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (n.stateNode = r, ya = n, ua = ui(r.firstChild), !0) : !1;
      case 6:
        return r = n.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (n.stateNode = r, ya = n, ua = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (o = ka !== null ? { id: cr, overflow: eo } : null, n.memoizedState = { dehydrated: r, treeContext: o, retryLane: 1073741824 }, o = Ma(18, null, null, 0), o.stateNode = r, o.return = n, n.child = o, ya = n, ua = null, !0) : !1;
      default:
        return !1;
    }
  }
  function ZE(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function qE(n) {
    if (Sn) {
      var r = ua;
      if (r) {
        var o = r;
        if (!dR(n, r)) {
          if (ZE(n))
            throw Error(T(418));
          r = ui(o.nextSibling);
          var E = ya;
          r && dR(n, r) ? VT(E, o) : (n.flags = n.flags & -4097 | 2, Sn = !1, ya = n);
        }
      } else {
        if (ZE(n))
          throw Error(T(418));
        n.flags = n.flags & -4097 | 2, Sn = !1, ya = n;
      }
    }
  }
  function SR(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; )
      n = n.return;
    ya = n;
  }
  function $E(n) {
    if (n !== ya)
      return !1;
    if (!Sn)
      return SR(n), Sn = !0, !1;
    var r;
    if ((r = n.tag !== 3) && !(r = n.tag !== 5) && (r = n.type, r = r !== "head" && r !== "body" && !mu(n.type, n.memoizedProps)), r && (r = ua)) {
      if (ZE(n))
        throw NR(), Error(T(418));
      for (; r; )
        VT(n, r), r = ui(r.nextSibling);
    }
    if (SR(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n)
        throw Error(T(317));
      e: {
        for (n = n.nextSibling, r = 0; n; ) {
          if (n.nodeType === 8) {
            var o = n.data;
            if (o === "/$") {
              if (r === 0) {
                ua = ui(n.nextSibling);
                break e;
              }
              r--;
            } else
              o !== "$" && o !== "$!" && o !== "$?" || r++;
          }
          n = n.nextSibling;
        }
        ua = null;
      }
    } else
      ua = ya ? ui(n.stateNode.nextSibling) : null;
    return !0;
  }
  function NR() {
    for (var n = ua; n; )
      n = ui(n.nextSibling);
  }
  function yn() {
    ua = ya = null, Sn = !1;
  }
  function WT(n) {
    Ka === null ? Ka = [n] : Ka.push(n);
  }
  var XT = Fe.ReactCurrentBatchConfig;
  function ja(n, r) {
    if (n && n.defaultProps) {
      r = U({}, r), n = n.defaultProps;
      for (var o in n)
        r[o] === void 0 && (r[o] = n[o]);
      return r;
    }
    return r;
  }
  var zo = Ct(null), ec = null, xl = null, kT = null;
  function KT() {
    kT = xl = ec = null;
  }
  function Da(n) {
    var r = zo.current;
    jt(zo), n._currentValue = r;
  }
  function jT(n, r, o) {
    for (; n !== null; ) {
      var E = n.alternate;
      if ((n.childLanes & r) !== r ? (n.childLanes |= r, E !== null && (E.childLanes |= r)) : E !== null && (E.childLanes & r) !== r && (E.childLanes |= r), n === o)
        break;
      n = n.return;
    }
  }
  function Pu(n, r) {
    ec = n, kT = xl = null, n = n.dependencies, n !== null && n.firstContext !== null && (n.lanes & r && (mr = !0), n.firstContext = null);
  }
  function rn(n) {
    var r = n._currentValue;
    if (kT !== n)
      if (n = { context: n, memoizedValue: r, next: null }, xl === null) {
        if (ec === null)
          throw Error(T(308));
        xl = n, ec.dependencies = { lanes: 0, firstContext: n };
      } else
        xl = xl.next = n;
    return r;
  }
  var Ds = null;
  function pR(n) {
    Ds === null ? Ds = [n] : Ds.push(n);
  }
  function oN(n, r, o, E) {
    var f = r.interleaved;
    return f === null ? (o.next = o, pR(r)) : (o.next = f.next, f.next = o), r.interleaved = o, ze(n, E);
  }
  function ze(n, r) {
    n.lanes |= r;
    var o = n.alternate;
    for (o !== null && (o.lanes |= r), o = n, n = n.return; n !== null; )
      n.childLanes |= r, o = n.alternate, o !== null && (o.childLanes |= r), o = n, n = n.return;
    return o.tag === 3 ? o.stateNode : null;
  }
  var St = !1;
  function Wt(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function bn(n, r) {
    n = n.updateQueue, r.updateQueue === n && (r.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function lr(n, r) {
    return { eventTime: n, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function to(n, r, o) {
    var E = n.updateQueue;
    if (E === null)
      return null;
    if (E = E.shared, wt & 2) {
      var f = E.pending;
      return f === null ? r.next = r : (r.next = f.next, f.next = r), E.pending = r, ze(n, o);
    }
    return f = E.interleaved, f === null ? (r.next = r, pR(E)) : (r.next = f.next, f.next = r), E.interleaved = r, ze(n, o);
  }
  function tc(n, r, o) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (o & 4194240) !== 0)) {
      var E = r.lanes;
      E &= n.pendingLanes, o |= E, r.lanes = o, Di(n, o);
    }
  }
  function IR(n, r) {
    var o = n.updateQueue, E = n.alternate;
    if (E !== null && (E = E.updateQueue, o === E)) {
      var f = null, R = null;
      if (o = o.firstBaseUpdate, o !== null) {
        do {
          var C = { eventTime: o.eventTime, lane: o.lane, tag: o.tag, payload: o.payload, callback: o.callback, next: null };
          R === null ? f = R = C : R = R.next = C, o = o.next;
        } while (o !== null);
        R === null ? f = R = r : R = R.next = r;
      } else
        f = R = r;
      o = { baseState: E.baseState, firstBaseUpdate: f, lastBaseUpdate: R, shared: E.shared, effects: E.effects }, n.updateQueue = o;
      return;
    }
    n = o.lastBaseUpdate, n === null ? o.firstBaseUpdate = r : n.next = r, o.lastBaseUpdate = r;
  }
  function nc(n, r, o, E) {
    var f = n.updateQueue;
    St = !1;
    var R = f.firstBaseUpdate, C = f.lastBaseUpdate, P = f.shared.pending;
    if (P !== null) {
      f.shared.pending = null;
      var b = P, Z = b.next;
      b.next = null, C === null ? R = Z : C.next = Z, C = b;
      var Te = n.alternate;
      Te !== null && (Te = Te.updateQueue, P = Te.lastBaseUpdate, P !== C && (P === null ? Te.firstBaseUpdate = Z : P.next = Z, Te.lastBaseUpdate = b));
    }
    if (R !== null) {
      var fe = f.baseState;
      C = 0, Te = Z = b = null, P = R;
      do {
        var ue = P.lane, Ue = P.eventTime;
        if ((E & ue) === ue) {
          Te !== null && (Te = Te.next = {
            eventTime: Ue,
            lane: 0,
            tag: P.tag,
            payload: P.payload,
            callback: P.callback,
            next: null
          });
          e: {
            var we = n, ke = P;
            switch (ue = r, Ue = o, ke.tag) {
              case 1:
                if (we = ke.payload, typeof we == "function") {
                  fe = we.call(Ue, fe, ue);
                  break e;
                }
                fe = we;
                break e;
              case 3:
                we.flags = we.flags & -65537 | 128;
              case 0:
                if (we = ke.payload, ue = typeof we == "function" ? we.call(Ue, fe, ue) : we, ue == null)
                  break e;
                fe = U({}, fe, ue);
                break e;
              case 2:
                St = !0;
            }
          }
          P.callback !== null && P.lane !== 0 && (n.flags |= 64, ue = f.effects, ue === null ? f.effects = [P] : ue.push(P));
        } else
          Ue = { eventTime: Ue, lane: ue, tag: P.tag, payload: P.payload, callback: P.callback, next: null }, Te === null ? (Z = Te = Ue, b = fe) : Te = Te.next = Ue, C |= ue;
        if (P = P.next, P === null) {
          if (P = f.shared.pending, P === null)
            break;
          ue = P, P = ue.next, ue.next = null, f.lastBaseUpdate = ue, f.shared.pending = null;
        }
      } while (1);
      if (Te === null && (b = fe), f.baseState = b, f.firstBaseUpdate = Z, f.lastBaseUpdate = Te, r = f.shared.interleaved, r !== null) {
        f = r;
        do
          C |= f.lane, f = f.next;
        while (f !== r);
      } else
        R === null && (f.shared.lanes = 0);
      Xl |= C, n.lanes = C, n.memoizedState = fe;
    }
  }
  function zT(n, r, o) {
    if (n = r.effects, r.effects = null, n !== null)
      for (r = 0; r < n.length; r++) {
        var E = n[r], f = E.callback;
        if (f !== null) {
          if (E.callback = null, E = o, typeof f != "function")
            throw Error(T(191, f));
          f.call(E);
        }
      }
  }
  var se = new l.Component().refs;
  function Xn(n, r, o, E) {
    r = n.memoizedState, o = o(E, r), o = o == null ? r : U({}, r, o), n.memoizedState = o, n.lanes === 0 && (n.updateQueue.baseState = o);
  }
  var ot = { isMounted: function(n) {
    return (n = n._reactInternals) ? dt(n) === n : !1;
  }, enqueueSetState: function(n, r, o) {
    n = n._reactInternals;
    var E = Br(), f = co(n), R = lr(E, f);
    R.payload = r, o != null && (R.callback = o), r = to(n, R, f), r !== null && (Ai(r, n, f, E), tc(r, n, f));
  }, enqueueReplaceState: function(n, r, o) {
    n = n._reactInternals;
    var E = Br(), f = co(n), R = lr(E, f);
    R.tag = 1, R.payload = r, o != null && (R.callback = o), r = to(n, R, f), r !== null && (Ai(r, n, f, E), tc(r, n, f));
  }, enqueueForceUpdate: function(n, r) {
    n = n._reactInternals;
    var o = Br(), E = co(n), f = lr(o, E);
    f.tag = 2, r != null && (f.callback = r), r = to(n, f, E), r !== null && (Ai(r, n, E, o), tc(r, n, E));
  } };
  function gs(n, r, o, E, f, R, C) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(E, R, C) : r.prototype && r.prototype.isPureReactComponent ? !Nu(o, E) || !Nu(f, R) : !0;
  }
  function no(n, r, o) {
    var E = !1, f = Mi, R = r.contextType;
    return typeof R == "object" && R !== null ? R = rn(R) : (f = In(r) ? ia : Tt.current, E = r.contextTypes, R = (E = E != null) ? Wa(n, f) : Mi), r = new r(o, R), n.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = ot, n.stateNode = r, r._reactInternals = n, E && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = f, n.__reactInternalMemoizedMaskedChildContext = R), r;
  }
  function bl(n, r, o, E) {
    n = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(o, E), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(o, E), r.state !== n && ot.enqueueReplaceState(r, r.state, null);
  }
  function Ei(n, r, o, E) {
    var f = n.stateNode;
    f.props = o, f.state = n.memoizedState, f.refs = se, Wt(n);
    var R = r.contextType;
    typeof R == "object" && R !== null ? f.context = rn(R) : (R = In(r) ? ia : Tt.current, f.context = Wa(n, R)), f.state = n.memoizedState, R = r.getDerivedStateFromProps, typeof R == "function" && (Xn(n, r, R, o), f.state = n.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof f.getSnapshotBeforeUpdate == "function" || typeof f.UNSAFE_componentWillMount != "function" && typeof f.componentWillMount != "function" || (r = f.state, typeof f.componentWillMount == "function" && f.componentWillMount(), typeof f.UNSAFE_componentWillMount == "function" && f.UNSAFE_componentWillMount(), r !== f.state && ot.enqueueReplaceState(f, f.state, null), nc(n, o, f, E), f.state = n.memoizedState), typeof f.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function Jo(n, r, o) {
    if (n = o.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (o._owner) {
        if (o = o._owner, o) {
          if (o.tag !== 1)
            throw Error(T(309));
          var E = o.stateNode;
        }
        if (!E)
          throw Error(T(147, n));
        var f = E, R = "" + n;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === R ? r.ref : (r = function(C) {
          var P = f.refs;
          P === se && (P = f.refs = {}), C === null ? delete P[R] : P[R] = C;
        }, r._stringRef = R, r);
      }
      if (typeof n != "string")
        throw Error(T(284));
      if (!o._owner)
        throw Error(T(290, n));
    }
    return n;
  }
  function Qo(n, r) {
    throw n = Object.prototype.toString.call(r), Error(T(31, n === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : n));
  }
  function Ps(n) {
    var r = n._init;
    return r(n._payload);
  }
  function rc(n) {
    function r(V, B) {
      if (n) {
        var K = V.deletions;
        K === null ? (V.deletions = [B], V.flags |= 16) : K.push(B);
      }
    }
    function o(V, B) {
      if (!n)
        return null;
      for (; B !== null; )
        r(V, B), B = B.sibling;
      return null;
    }
    function E(V, B) {
      for (V = /* @__PURE__ */ new Map(); B !== null; )
        B.key !== null ? V.set(B.key, B) : V.set(B.index, B), B = B.sibling;
      return V;
    }
    function f(V, B) {
      return V = El(V, B), V.index = 0, V.sibling = null, V;
    }
    function R(V, B, K) {
      return V.index = K, n ? (K = V.alternate, K !== null ? (K = K.index, K < B ? (V.flags |= 2, B) : K) : (V.flags |= 2, B)) : (V.flags |= 1048576, B);
    }
    function C(V) {
      return n && V.alternate === null && (V.flags |= 2), V;
    }
    function P(V, B, K, Ne) {
      return B === null || B.tag !== 6 ? (B = hf(K, V.mode, Ne), B.return = V, B) : (B = f(B, K), B.return = V, B);
    }
    function b(V, B, K, Ne) {
      var Ke = K.type;
      return Ke === Xe ? Te(V, B, K.props.children, Ne, K.key) : B !== null && (B.elementType === Ke || typeof Ke == "object" && Ke !== null && Ke.$$typeof === ve && Ps(Ke) === B.type) ? (Ne = f(B, K.props), Ne.ref = Jo(V, B, K), Ne.return = V, Ne) : (Ne = gc(K.type, K.key, K.props, null, V.mode, Ne), Ne.ref = Jo(V, B, K), Ne.return = V, Ne);
    }
    function Z(V, B, K, Ne) {
      return B === null || B.tag !== 4 || B.stateNode.containerInfo !== K.containerInfo || B.stateNode.implementation !== K.implementation ? (B = Pc(K, V.mode, Ne), B.return = V, B) : (B = f(B, K.children || []), B.return = V, B);
    }
    function Te(V, B, K, Ne, Ke) {
      return B === null || B.tag !== 7 ? (B = Kl(K, V.mode, Ne, Ke), B.return = V, B) : (B = f(B, K), B.return = V, B);
    }
    function fe(V, B, K) {
      if (typeof B == "string" && B !== "" || typeof B == "number")
        return B = hf("" + B, V.mode, K), B.return = V, B;
      if (typeof B == "object" && B !== null) {
        switch (B.$$typeof) {
          case ye:
            return K = gc(B.type, B.key, B.props, null, V.mode, K), K.ref = Jo(V, null, B), K.return = V, K;
          case je:
            return B = Pc(B, V.mode, K), B.return = V, B;
          case ve:
            var Ne = B._init;
            return fe(V, Ne(B._payload), K);
        }
        if (rr(B) || Ae(B))
          return B = Kl(B, V.mode, K, null), B.return = V, B;
        Qo(V, B);
      }
      return null;
    }
    function ue(V, B, K, Ne) {
      var Ke = B !== null ? B.key : null;
      if (typeof K == "string" && K !== "" || typeof K == "number")
        return Ke !== null ? null : P(V, B, "" + K, Ne);
      if (typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case ye:
            return K.key === Ke ? b(V, B, K, Ne) : null;
          case je:
            return K.key === Ke ? Z(V, B, K, Ne) : null;
          case ve:
            return Ke = K._init, ue(
              V,
              B,
              Ke(K._payload),
              Ne
            );
        }
        if (rr(K) || Ae(K))
          return Ke !== null ? null : Te(V, B, K, Ne, null);
        Qo(V, K);
      }
      return null;
    }
    function Ue(V, B, K, Ne, Ke) {
      if (typeof Ne == "string" && Ne !== "" || typeof Ne == "number")
        return V = V.get(K) || null, P(B, V, "" + Ne, Ke);
      if (typeof Ne == "object" && Ne !== null) {
        switch (Ne.$$typeof) {
          case ye:
            return V = V.get(Ne.key === null ? K : Ne.key) || null, b(B, V, Ne, Ke);
          case je:
            return V = V.get(Ne.key === null ? K : Ne.key) || null, Z(B, V, Ne, Ke);
          case ve:
            var rt = Ne._init;
            return Ue(V, B, K, rt(Ne._payload), Ke);
        }
        if (rr(Ne) || Ae(Ne))
          return V = V.get(K) || null, Te(B, V, Ne, Ke, null);
        Qo(B, Ne);
      }
      return null;
    }
    function we(V, B, K, Ne) {
      for (var Ke = null, rt = null, $e = B, Et = B = 0, er = null; $e !== null && Et < K.length; Et++) {
        $e.index > Et ? (er = $e, $e = null) : er = $e.sibling;
        var Yt = ue(V, $e, K[Et], Ne);
        if (Yt === null) {
          $e === null && ($e = er);
          break;
        }
        n && $e && Yt.alternate === null && r(V, $e), B = R(Yt, B, Et), rt === null ? Ke = Yt : rt.sibling = Yt, rt = Yt, $e = er;
      }
      if (Et === K.length)
        return o(V, $e), Sn && La(V, Et), Ke;
      if ($e === null) {
        for (; Et < K.length; Et++)
          $e = fe(V, K[Et], Ne), $e !== null && (B = R($e, B, Et), rt === null ? Ke = $e : rt.sibling = $e, rt = $e);
        return Sn && La(V, Et), Ke;
      }
      for ($e = E(V, $e); Et < K.length; Et++)
        er = Ue($e, V, Et, K[Et], Ne), er !== null && (n && er.alternate !== null && $e.delete(er.key === null ? Et : er.key), B = R(er, B, Et), rt === null ? Ke = er : rt.sibling = er, rt = er);
      return n && $e.forEach(function(To) {
        return r(V, To);
      }), Sn && La(V, Et), Ke;
    }
    function ke(V, B, K, Ne) {
      var Ke = Ae(K);
      if (typeof Ke != "function")
        throw Error(T(150));
      if (K = Ke.call(K), K == null)
        throw Error(T(151));
      for (var rt = Ke = null, $e = B, Et = B = 0, er = null, Yt = K.next(); $e !== null && !Yt.done; Et++, Yt = K.next()) {
        $e.index > Et ? (er = $e, $e = null) : er = $e.sibling;
        var To = ue(V, $e, Yt.value, Ne);
        if (To === null) {
          $e === null && ($e = er);
          break;
        }
        n && $e && To.alternate === null && r(V, $e), B = R(To, B, Et), rt === null ? Ke = To : rt.sibling = To, rt = To, $e = er;
      }
      if (Yt.done)
        return o(
          V,
          $e
        ), Sn && La(V, Et), Ke;
      if ($e === null) {
        for (; !Yt.done; Et++, Yt = K.next())
          Yt = fe(V, Yt.value, Ne), Yt !== null && (B = R(Yt, B, Et), rt === null ? Ke = Yt : rt.sibling = Yt, rt = Yt);
        return Sn && La(V, Et), Ke;
      }
      for ($e = E(V, $e); !Yt.done; Et++, Yt = K.next())
        Yt = Ue($e, V, Et, Yt.value, Ne), Yt !== null && (n && Yt.alternate !== null && $e.delete(Yt.key === null ? Et : Yt.key), B = R(Yt, B, Et), rt === null ? Ke = Yt : rt.sibling = Yt, rt = Yt);
      return n && $e.forEach(function($R) {
        return r(V, $R);
      }), Sn && La(V, Et), Ke;
    }
    function Fn(V, B, K, Ne) {
      if (typeof K == "object" && K !== null && K.type === Xe && K.key === null && (K = K.props.children), typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case ye:
            e: {
              for (var Ke = K.key, rt = B; rt !== null; ) {
                if (rt.key === Ke) {
                  if (Ke = K.type, Ke === Xe) {
                    if (rt.tag === 7) {
                      o(V, rt.sibling), B = f(rt, K.props.children), B.return = V, V = B;
                      break e;
                    }
                  } else if (rt.elementType === Ke || typeof Ke == "object" && Ke !== null && Ke.$$typeof === ve && Ps(Ke) === rt.type) {
                    o(V, rt.sibling), B = f(rt, K.props), B.ref = Jo(V, rt, K), B.return = V, V = B;
                    break e;
                  }
                  o(V, rt);
                  break;
                } else
                  r(V, rt);
                rt = rt.sibling;
              }
              K.type === Xe ? (B = Kl(K.props.children, V.mode, Ne, K.key), B.return = V, V = B) : (Ne = gc(K.type, K.key, K.props, null, V.mode, Ne), Ne.ref = Jo(V, B, K), Ne.return = V, V = Ne);
            }
            return C(V);
          case je:
            e: {
              for (rt = K.key; B !== null; ) {
                if (B.key === rt)
                  if (B.tag === 4 && B.stateNode.containerInfo === K.containerInfo && B.stateNode.implementation === K.implementation) {
                    o(V, B.sibling), B = f(B, K.children || []), B.return = V, V = B;
                    break e;
                  } else {
                    o(V, B);
                    break;
                  }
                else
                  r(V, B);
                B = B.sibling;
              }
              B = Pc(K, V.mode, Ne), B.return = V, V = B;
            }
            return C(V);
          case ve:
            return rt = K._init, Fn(V, B, rt(K._payload), Ne);
        }
        if (rr(K))
          return we(V, B, K, Ne);
        if (Ae(K))
          return ke(V, B, K, Ne);
        Qo(V, K);
      }
      return typeof K == "string" && K !== "" || typeof K == "number" ? (K = "" + K, B !== null && B.tag === 6 ? (o(V, B.sibling), B = f(B, K), B.return = V, V = B) : (o(V, B), B = hf(K, V.mode, Ne), B.return = V, V = B), C(V)) : o(V, B);
    }
    return Fn;
  }
  var Zo = rc(!0), ac = rc(!1), Hl = {}, za = Ct(Hl), Bl = Ct(Hl), Fl = Ct(Hl);
  function ro(n) {
    if (n === Hl)
      throw Error(T(174));
    return n;
  }
  function Mu(n, r) {
    switch (qt(Fl, r), qt(Bl, n), qt(za, Hl), n = r.nodeType, n) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : vn(null, "");
        break;
      default:
        n = n === 8 ? r.parentNode : r, r = n.namespaceURI || null, n = n.tagName, r = vn(r, n);
    }
    jt(za), qt(za, r);
  }
  function qo() {
    jt(za), jt(Bl), jt(Fl);
  }
  function ic(n) {
    ro(Fl.current);
    var r = ro(za.current), o = vn(r, n.type);
    r !== o && (qt(Bl, n), qt(za, o));
  }
  function Uu(n) {
    Bl.current === n && (jt(za), jt(Bl));
  }
  var Nn = Ct(0);
  function Ms(n) {
    for (var r = n; r !== null; ) {
      if (r.tag === 13) {
        var o = r.memoizedState;
        if (o !== null && (o = o.dehydrated, o === null || o.data === "$?" || o.data === "$!"))
          return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if (r.flags & 128)
          return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === n)
        break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === n)
          return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var _u = [];
  function Gu() {
    for (var n = 0; n < _u.length; n++)
      _u[n]._workInProgressVersionPrimary = null;
    _u.length = 0;
  }
  var ao = Fe.ReactCurrentDispatcher, xu = Fe.ReactCurrentBatchConfig, io = 0, pn = null, Hn = null, qn = null, wl = !1, Us = !1, $o = 0, _s = 0;
  function cn() {
    throw Error(T(321));
  }
  function an(n, r) {
    if (r === null)
      return !1;
    for (var o = 0; o < r.length && o < n.length; o++)
      if (!Ya(n[o], r[o]))
        return !1;
    return !0;
  }
  function Gs(n, r, o, E, f, R) {
    if (io = R, pn = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, ao.current = n === null || n.memoizedState === null ? yR : DR, n = o(E, f), Us) {
      R = 0;
      do {
        if (Us = !1, $o = 0, 25 <= R)
          throw Error(T(301));
        R += 1, qn = Hn = null, r.updateQueue = null, ao.current = gR, n = o(E, f);
      } while (Us);
    }
    if (ao.current = Tc, r = Hn !== null && Hn.next !== null, io = 0, qn = Hn = pn = null, wl = !1, r)
      throw Error(T(300));
    return n;
  }
  function xs() {
    var n = $o !== 0;
    return $o = 0, n;
  }
  function Ea() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return qn === null ? pn.memoizedState = qn = n : qn = qn.next = n, qn;
  }
  function br() {
    if (Hn === null) {
      var n = pn.alternate;
      n = n !== null ? n.memoizedState : null;
    } else
      n = Hn.next;
    var r = qn === null ? pn.memoizedState : qn.next;
    if (r !== null)
      qn = r, Hn = n;
    else {
      if (n === null)
        throw Error(T(310));
      Hn = n, n = { memoizedState: Hn.memoizedState, baseState: Hn.baseState, baseQueue: Hn.baseQueue, queue: Hn.queue, next: null }, qn === null ? pn.memoizedState = qn = n : qn = qn.next = n;
    }
    return qn;
  }
  function bu(n, r) {
    return typeof r == "function" ? r(n) : r;
  }
  function JT(n) {
    var r = br(), o = r.queue;
    if (o === null)
      throw Error(T(311));
    o.lastRenderedReducer = n;
    var E = Hn, f = E.baseQueue, R = o.pending;
    if (R !== null) {
      if (f !== null) {
        var C = f.next;
        f.next = R.next, R.next = C;
      }
      E.baseQueue = f = R, o.pending = null;
    }
    if (f !== null) {
      R = f.next, E = E.baseState;
      var P = C = null, b = null, Z = R;
      do {
        var Te = Z.lane;
        if ((io & Te) === Te)
          b !== null && (b = b.next = { lane: 0, action: Z.action, hasEagerState: Z.hasEagerState, eagerState: Z.eagerState, next: null }), E = Z.hasEagerState ? Z.eagerState : n(E, Z.action);
        else {
          var fe = {
            lane: Te,
            action: Z.action,
            hasEagerState: Z.hasEagerState,
            eagerState: Z.eagerState,
            next: null
          };
          b === null ? (P = b = fe, C = E) : b = b.next = fe, pn.lanes |= Te, Xl |= Te;
        }
        Z = Z.next;
      } while (Z !== null && Z !== R);
      b === null ? C = E : b.next = P, Ya(E, r.memoizedState) || (mr = !0), r.memoizedState = E, r.baseState = C, r.baseQueue = b, o.lastRenderedState = E;
    }
    if (n = o.interleaved, n !== null) {
      f = n;
      do
        R = f.lane, pn.lanes |= R, Xl |= R, f = f.next;
      while (f !== n);
    } else
      f === null && (o.lanes = 0);
    return [r.memoizedState, o.dispatch];
  }
  function QT(n) {
    var r = br(), o = r.queue;
    if (o === null)
      throw Error(T(311));
    o.lastRenderedReducer = n;
    var E = o.dispatch, f = o.pending, R = r.memoizedState;
    if (f !== null) {
      o.pending = null;
      var C = f = f.next;
      do
        R = n(R, C.action), C = C.next;
      while (C !== f);
      Ya(R, r.memoizedState) || (mr = !0), r.memoizedState = R, r.baseQueue === null && (r.baseState = R), o.lastRenderedState = R;
    }
    return [R, E];
  }
  function CR() {
  }
  function oc(n, r) {
    var o = pn, E = br(), f = r(), R = !Ya(E.memoizedState, f);
    if (R && (E.memoizedState = f, mr = !0), E = E.queue, Yl(ZT.bind(null, o, E, n), [n]), E.getSnapshot !== r || R || qn !== null && qn.memoizedState.tag & 1) {
      if (o.flags |= 2048, Bu(9, lc.bind(null, o, E, f, r), void 0, null), Kn === null)
        throw Error(T(349));
      io & 30 || hR(o, r, f);
    }
    return f;
  }
  function hR(n, r, o) {
    n.flags |= 16384, n = { getSnapshot: r, value: o }, r = pn.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, pn.updateQueue = r, r.stores = [n]) : (o = r.stores, o === null ? r.stores = [n] : o.push(n));
  }
  function lc(n, r, o, E) {
    r.value = o, r.getSnapshot = E, vR(r) && mR(n);
  }
  function ZT(n, r, o) {
    return o(function() {
      vR(r) && mR(n);
    });
  }
  function vR(n) {
    var r = n.getSnapshot;
    n = n.value;
    try {
      var o = r();
      return !Ya(n, o);
    } catch {
      return !0;
    }
  }
  function mR(n) {
    var r = ze(n, 1);
    r !== null && Ai(r, n, 1, -1);
  }
  function Hu(n) {
    var r = Ea();
    return typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: bu, lastRenderedState: n }, r.queue = n, n = n.dispatch = uN.bind(null, pn, n), [r.memoizedState, n];
  }
  function Bu(n, r, o, E) {
    return n = { tag: n, create: r, destroy: o, deps: E, next: null }, r = pn.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, pn.updateQueue = r, r.lastEffect = n.next = n) : (o = r.lastEffect, o === null ? r.lastEffect = n.next = n : (E = o.next, o.next = n, n.next = E, r.lastEffect = n)), n;
  }
  function qT() {
    return br().memoizedState;
  }
  function Fu(n, r, o, E) {
    var f = Ea();
    pn.flags |= n, f.memoizedState = Bu(1 | r, o, void 0, E === void 0 ? null : E);
  }
  function sc(n, r, o, E) {
    var f = br();
    E = E === void 0 ? null : E;
    var R = void 0;
    if (Hn !== null) {
      var C = Hn.memoizedState;
      if (R = C.destroy, E !== null && an(E, C.deps)) {
        f.memoizedState = Bu(r, o, R, E);
        return;
      }
    }
    pn.flags |= n, f.memoizedState = Bu(1 | r, o, R, E);
  }
  function el(n, r) {
    return Fu(8390656, 8, n, r);
  }
  function Yl(n, r) {
    return sc(2048, 8, n, r);
  }
  function tl(n, r) {
    return sc(4, 2, n, r);
  }
  function uc(n, r) {
    return sc(4, 4, n, r);
  }
  function ca(n, r) {
    if (typeof r == "function")
      return n = n(), r(n), function() {
        r(null);
      };
    if (r != null)
      return n = n(), r.current = n, function() {
        r.current = null;
      };
  }
  function Vl(n, r, o) {
    return o = o != null ? o.concat([n]) : null, sc(4, 4, ca.bind(null, r, n), o);
  }
  function Nt() {
  }
  function wu(n, r) {
    var o = br();
    r = r === void 0 ? null : r;
    var E = o.memoizedState;
    return E !== null && r !== null && an(r, E[1]) ? E[0] : (o.memoizedState = [n, r], n);
  }
  function $T(n, r) {
    var o = br();
    r = r === void 0 ? null : r;
    var E = o.memoizedState;
    return E !== null && r !== null && an(r, E[1]) ? E[0] : (n = n(), o.memoizedState = [n, r], n);
  }
  function lN(n, r, o) {
    return io & 21 ? (Ya(o, r) || (o = cs(), pn.lanes |= o, Xl |= o, n.baseState = !0), r) : (n.baseState && (n.baseState = !1, mr = !0), n.memoizedState = o);
  }
  function sN(n, r) {
    var o = Vt;
    Vt = o !== 0 && 4 > o ? o : 4, n(!0);
    var E = xu.transition;
    xu.transition = {};
    try {
      n(!1), r();
    } finally {
      Vt = o, xu.transition = E;
    }
  }
  function Ec() {
    return br().memoizedState;
  }
  function Yu(n, r, o) {
    var E = co(n);
    if (o = { lane: E, action: o, hasEagerState: !1, eagerState: null, next: null }, ef(n))
      LR(r, o);
    else if (o = oN(n, r, o, E), o !== null) {
      var f = Br();
      Ai(o, n, E, f), cc(o, r, E);
    }
  }
  function uN(n, r, o) {
    var E = co(n), f = { lane: E, action: o, hasEagerState: !1, eagerState: null, next: null };
    if (ef(n))
      LR(r, f);
    else {
      var R = n.alternate;
      if (n.lanes === 0 && (R === null || R.lanes === 0) && (R = r.lastRenderedReducer, R !== null))
        try {
          var C = r.lastRenderedState, P = R(C, o);
          if (f.hasEagerState = !0, f.eagerState = P, Ya(P, C)) {
            var b = r.interleaved;
            b === null ? (f.next = f, pR(r)) : (f.next = b.next, b.next = f), r.interleaved = f;
            return;
          }
        } catch {
        } finally {
        }
      o = oN(n, r, f, E), o !== null && (f = Br(), Ai(o, n, E, f), cc(o, r, E));
    }
  }
  function ef(n) {
    var r = n.alternate;
    return n === pn || r !== null && r === pn;
  }
  function LR(n, r) {
    Us = wl = !0;
    var o = n.pending;
    o === null ? r.next = r : (r.next = o.next, o.next = r), n.pending = r;
  }
  function cc(n, r, o) {
    if (o & 4194240) {
      var E = r.lanes;
      E &= n.pendingLanes, o |= E, r.lanes = o, Di(n, o);
    }
  }
  var Tc = { readContext: rn, useCallback: cn, useContext: cn, useEffect: cn, useImperativeHandle: cn, useInsertionEffect: cn, useLayoutEffect: cn, useMemo: cn, useReducer: cn, useRef: cn, useState: cn, useDebugValue: cn, useDeferredValue: cn, useTransition: cn, useMutableSource: cn, useSyncExternalStore: cn, useId: cn, unstable_isNewReconciler: !1 }, yR = { readContext: rn, useCallback: function(n, r) {
    return Ea().memoizedState = [n, r === void 0 ? null : r], n;
  }, useContext: rn, useEffect: el, useImperativeHandle: function(n, r, o) {
    return o = o != null ? o.concat([n]) : null, Fu(
      4194308,
      4,
      ca.bind(null, r, n),
      o
    );
  }, useLayoutEffect: function(n, r) {
    return Fu(4194308, 4, n, r);
  }, useInsertionEffect: function(n, r) {
    return Fu(4, 2, n, r);
  }, useMemo: function(n, r) {
    var o = Ea();
    return r = r === void 0 ? null : r, n = n(), o.memoizedState = [n, r], n;
  }, useReducer: function(n, r, o) {
    var E = Ea();
    return r = o !== void 0 ? o(r) : r, E.memoizedState = E.baseState = r, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: r }, E.queue = n, n = n.dispatch = Yu.bind(null, pn, n), [E.memoizedState, n];
  }, useRef: function(n) {
    var r = Ea();
    return n = { current: n }, r.memoizedState = n;
  }, useState: Hu, useDebugValue: Nt, useDeferredValue: function(n) {
    return Ea().memoizedState = n;
  }, useTransition: function() {
    var n = Hu(!1), r = n[0];
    return n = sN.bind(null, n[1]), Ea().memoizedState = n, [r, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, r, o) {
    var E = pn, f = Ea();
    if (Sn) {
      if (o === void 0)
        throw Error(T(407));
      o = o();
    } else {
      if (o = r(), Kn === null)
        throw Error(T(349));
      io & 30 || hR(E, r, o);
    }
    f.memoizedState = o;
    var R = { value: o, getSnapshot: r };
    return f.queue = R, el(ZT.bind(
      null,
      E,
      R,
      n
    ), [n]), E.flags |= 2048, Bu(9, lc.bind(null, E, R, o, r), void 0, null), o;
  }, useId: function() {
    var n = Ea(), r = Kn.identifierPrefix;
    if (Sn) {
      var o = eo, E = cr;
      o = (E & ~(1 << 32 - _r(E) - 1)).toString(32) + o, r = ":" + r + "R" + o, o = $o++, 0 < o && (r += "H" + o.toString(32)), r += ":";
    } else
      o = _s++, r = ":" + r + "r" + o.toString(32) + ":";
    return n.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, DR = {
    readContext: rn,
    useCallback: wu,
    useContext: rn,
    useEffect: Yl,
    useImperativeHandle: Vl,
    useInsertionEffect: tl,
    useLayoutEffect: uc,
    useMemo: $T,
    useReducer: JT,
    useRef: qT,
    useState: function() {
      return JT(bu);
    },
    useDebugValue: Nt,
    useDeferredValue: function(n) {
      var r = br();
      return lN(r, Hn.memoizedState, n);
    },
    useTransition: function() {
      var n = JT(bu)[0], r = br().memoizedState;
      return [n, r];
    },
    useMutableSource: CR,
    useSyncExternalStore: oc,
    useId: Ec,
    unstable_isNewReconciler: !1
  }, gR = { readContext: rn, useCallback: wu, useContext: rn, useEffect: Yl, useImperativeHandle: Vl, useInsertionEffect: tl, useLayoutEffect: uc, useMemo: $T, useReducer: QT, useRef: qT, useState: function() {
    return QT(bu);
  }, useDebugValue: Nt, useDeferredValue: function(n) {
    var r = br();
    return Hn === null ? r.memoizedState = n : lN(r, Hn.memoizedState, n);
  }, useTransition: function() {
    var n = QT(bu)[0], r = br().memoizedState;
    return [n, r];
  }, useMutableSource: CR, useSyncExternalStore: oc, useId: Ec, unstable_isNewReconciler: !1 };
  function Tr(n, r) {
    try {
      var o = "", E = r;
      do
        o += vt(E), E = E.return;
      while (E);
      var f = o;
    } catch (R) {
      f = `
Error generating stack: ` + R.message + `
` + R.stack;
    }
    return { value: n, source: r, stack: f, digest: null };
  }
  function Ui(n, r, o) {
    return { value: n, source: null, stack: o ?? null, digest: r ?? null };
  }
  function _i(n, r) {
    try {
      console.error(r.value);
    } catch (o) {
      setTimeout(function() {
        throw o;
      });
    }
  }
  var tf = typeof WeakMap == "function" ? WeakMap : Map;
  function bs(n, r, o) {
    o = lr(-1, o), o.tag = 3, o.payload = { element: null };
    var E = r.value;
    return o.callback = function() {
      $u || ($u = !0, ff = E), _i(n, r);
    }, o;
  }
  function Ja(n, r, o) {
    o = lr(-1, o), o.tag = 3;
    var E = n.type.getDerivedStateFromError;
    if (typeof E == "function") {
      var f = r.value;
      o.payload = function() {
        return E(f);
      }, o.callback = function() {
        _i(n, r);
      };
    }
    var R = n.stateNode;
    return R !== null && typeof R.componentDidCatch == "function" && (o.callback = function() {
      _i(n, r), typeof E != "function" && (il === null ? il = /* @__PURE__ */ new Set([this]) : il.add(this));
      var C = r.stack;
      this.componentDidCatch(r.value, { componentStack: C !== null ? C : "" });
    }), o;
  }
  function $n(n, r, o) {
    var E = n.pingCache;
    if (E === null) {
      E = n.pingCache = new tf();
      var f = /* @__PURE__ */ new Set();
      E.set(r, f);
    } else
      f = E.get(r), f === void 0 && (f = /* @__PURE__ */ new Set(), E.set(r, f));
    f.has(o) || (f.add(o), n = dN.bind(null, n, r, o), r.then(n, n));
  }
  function PR(n) {
    do {
      var r;
      if ((r = n.tag === 13) && (r = n.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r)
        return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function MR(n, r, o, E, f) {
    return n.mode & 1 ? (n.flags |= 65536, n.lanes = f, n) : (n === r ? n.flags |= 65536 : (n.flags |= 128, o.flags |= 131072, o.flags &= -52805, o.tag === 1 && (o.alternate === null ? o.tag = 17 : (r = lr(-1, 1), r.tag = 2, to(o, r, 1))), o.lanes |= 1), n);
  }
  var EN = Fe.ReactCurrentOwner, mr = !1;
  function Lr(n, r, o, E) {
    r.child = n === null ? ac(r, null, o, E) : Zo(r, n.child, o, E);
  }
  function Vu(n, r, o, E, f) {
    o = o.render;
    var R = r.ref;
    return Pu(r, f), E = Gs(n, r, o, E, R, f), o = xs(), n !== null && !mr ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~f, lo(n, r, f)) : (Sn && o && QE(r), r.flags |= 1, Lr(n, r, E, f), r.child);
  }
  function nf(n, r, o, E, f) {
    if (n === null) {
      var R = o.type;
      return typeof R == "function" && !kl(R) && R.defaultProps === void 0 && o.compare === null && o.defaultProps === void 0 ? (r.tag = 15, r.type = R, UR(n, r, R, E, f)) : (n = gc(o.type, null, E, r, r.mode, f), n.ref = r.ref, n.return = r, r.child = n);
    }
    if (R = n.child, !(n.lanes & f)) {
      var C = R.memoizedProps;
      if (o = o.compare, o = o !== null ? o : Nu, o(C, E) && n.ref === r.ref)
        return lo(n, r, f);
    }
    return r.flags |= 1, n = El(R, E), n.ref = r.ref, n.return = r, r.child = n;
  }
  function UR(n, r, o, E, f) {
    if (n !== null) {
      var R = n.memoizedProps;
      if (Nu(R, E) && n.ref === r.ref)
        if (mr = !1, r.pendingProps = E = R, (n.lanes & f) !== 0)
          n.flags & 131072 && (mr = !0);
        else
          return r.lanes = n.lanes, lo(n, r, f);
    }
    return rf(n, r, o, E, f);
  }
  function _R(n, r, o) {
    var E = r.pendingProps, f = E.children, R = n !== null ? n.memoizedState : null;
    if (E.mode === "hidden")
      if (!(r.mode & 1))
        r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, qt(uo, Pa), Pa |= o;
      else {
        if (!(o & 1073741824))
          return n = R !== null ? R.baseLanes | o : o, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, r.updateQueue = null, qt(uo, Pa), Pa |= n, null;
        r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, E = R !== null ? R.baseLanes : o, qt(uo, Pa), Pa |= E;
      }
    else
      R !== null ? (E = R.baseLanes | o, r.memoizedState = null) : E = o, qt(uo, Pa), Pa |= E;
    return Lr(n, r, f, o), r.child;
  }
  function fc(n, r) {
    var o = r.ref;
    (n === null && o !== null || n !== null && n.ref !== o) && (r.flags |= 512, r.flags |= 2097152);
  }
  function rf(n, r, o, E, f) {
    var R = In(o) ? ia : Tt.current;
    return R = Wa(r, R), Pu(r, f), o = Gs(n, r, o, E, R, f), E = xs(), n !== null && !mr ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~f, lo(n, r, f)) : (Sn && E && QE(r), r.flags |= 1, Lr(n, r, o, f), r.child);
  }
  function af(n, r, o, E, f) {
    if (In(o)) {
      var R = !0;
      JE(r);
    } else
      R = !1;
    if (Pu(r, f), r.stateNode === null)
      Ti(n, r), no(r, o, E), Ei(r, o, E, f), E = !0;
    else if (n === null) {
      var C = r.stateNode, P = r.memoizedProps;
      C.props = P;
      var b = C.context, Z = o.contextType;
      typeof Z == "object" && Z !== null ? Z = rn(Z) : (Z = In(o) ? ia : Tt.current, Z = Wa(r, Z));
      var Te = o.getDerivedStateFromProps, fe = typeof Te == "function" || typeof C.getSnapshotBeforeUpdate == "function";
      fe || typeof C.UNSAFE_componentWillReceiveProps != "function" && typeof C.componentWillReceiveProps != "function" || (P !== E || b !== Z) && bl(r, C, E, Z), St = !1;
      var ue = r.memoizedState;
      C.state = ue, nc(r, E, C, f), b = r.memoizedState, P !== E || ue !== b || Mn.current || St ? (typeof Te == "function" && (Xn(r, o, Te, E), b = r.memoizedState), (P = St || gs(r, o, P, E, ue, b, Z)) ? (fe || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount()), typeof C.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof C.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = E, r.memoizedState = b), C.props = E, C.state = b, C.context = Z, E = P) : (typeof C.componentDidMount == "function" && (r.flags |= 4194308), E = !1);
    } else {
      C = r.stateNode, bn(n, r), P = r.memoizedProps, Z = r.type === r.elementType ? P : ja(r.type, P), C.props = Z, fe = r.pendingProps, ue = C.context, b = o.contextType, typeof b == "object" && b !== null ? b = rn(b) : (b = In(o) ? ia : Tt.current, b = Wa(r, b));
      var Ue = o.getDerivedStateFromProps;
      (Te = typeof Ue == "function" || typeof C.getSnapshotBeforeUpdate == "function") || typeof C.UNSAFE_componentWillReceiveProps != "function" && typeof C.componentWillReceiveProps != "function" || (P !== fe || ue !== b) && bl(r, C, E, b), St = !1, ue = r.memoizedState, C.state = ue, nc(r, E, C, f);
      var we = r.memoizedState;
      P !== fe || ue !== we || Mn.current || St ? (typeof Ue == "function" && (Xn(r, o, Ue, E), we = r.memoizedState), (Z = St || gs(r, o, Z, E, ue, we, b) || !1) ? (Te || typeof C.UNSAFE_componentWillUpdate != "function" && typeof C.componentWillUpdate != "function" || (typeof C.componentWillUpdate == "function" && C.componentWillUpdate(E, we, b), typeof C.UNSAFE_componentWillUpdate == "function" && C.UNSAFE_componentWillUpdate(E, we, b)), typeof C.componentDidUpdate == "function" && (r.flags |= 4), typeof C.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof C.componentDidUpdate != "function" || P === n.memoizedProps && ue === n.memoizedState || (r.flags |= 4), typeof C.getSnapshotBeforeUpdate != "function" || P === n.memoizedProps && ue === n.memoizedState || (r.flags |= 1024), r.memoizedProps = E, r.memoizedState = we), C.props = E, C.state = we, C.context = b, E = Z) : (typeof C.componentDidUpdate != "function" || P === n.memoizedProps && ue === n.memoizedState || (r.flags |= 4), typeof C.getSnapshotBeforeUpdate != "function" || P === n.memoizedProps && ue === n.memoizedState || (r.flags |= 1024), E = !1);
    }
    return of(n, r, o, E, R, f);
  }
  function of(n, r, o, E, f, R) {
    fc(n, r);
    var C = (r.flags & 128) !== 0;
    if (!E && !C)
      return f && RR(r, o, !1), lo(n, r, R);
    E = r.stateNode, EN.current = r;
    var P = C && typeof o.getDerivedStateFromError != "function" ? null : E.render();
    return r.flags |= 1, n !== null && C ? (r.child = Zo(r, n.child, null, R), r.child = Zo(r, null, P, R)) : Lr(n, r, P, R), r.memoizedState = E.state, f && RR(r, o, !0), r.child;
  }
  function lf(n) {
    var r = n.stateNode;
    r.pendingContext ? Ko(n, r.pendingContext, r.pendingContext !== r.context) : r.context && Ko(n, r.context, !1), Mu(n, r.containerInfo);
  }
  function GR(n, r, o, E, f) {
    return yn(), WT(f), r.flags |= 256, Lr(n, r, o, E), r.child;
  }
  var Ac = { dehydrated: null, treeContext: null, retryLane: 0 };
  function sf(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function Rc(n, r, o) {
    var E = r.pendingProps, f = Nn.current, R = !1, C = (r.flags & 128) !== 0, P;
    if ((P = C) || (P = n !== null && n.memoizedState === null ? !1 : (f & 2) !== 0), P ? (R = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (f |= 1), qt(Nn, f & 1), n === null)
      return qE(r), n = r.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? (r.mode & 1 ? n.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824 : r.lanes = 1, null) : (C = E.children, n = E.fallback, R ? (E = r.mode, R = r.child, C = { mode: "hidden", children: C }, !(E & 1) && R !== null ? (R.childLanes = 0, R.pendingProps = C) : R = jl(C, E, 0, null), n = Kl(n, E, o, null), R.return = r, n.return = r, R.sibling = n, r.child = R, r.child.memoizedState = sf(o), r.memoizedState = Ac, n) : Hs(r, C));
    if (f = n.memoizedState, f !== null && (P = f.dehydrated, P !== null))
      return nl(n, r, C, E, P, f, o);
    if (R) {
      R = E.fallback, C = r.mode, f = n.child, P = f.sibling;
      var b = { mode: "hidden", children: E.children };
      return !(C & 1) && r.child !== f ? (E = r.child, E.childLanes = 0, E.pendingProps = b, r.deletions = null) : (E = El(f, b), E.subtreeFlags = f.subtreeFlags & 14680064), P !== null ? R = El(P, R) : (R = Kl(R, C, o, null), R.flags |= 2), R.return = r, E.return = r, E.sibling = R, r.child = E, E = R, R = r.child, C = n.child.memoizedState, C = C === null ? sf(o) : { baseLanes: C.baseLanes | o, cachePool: null, transitions: C.transitions }, R.memoizedState = C, R.childLanes = n.childLanes & ~o, r.memoizedState = Ac, E;
    }
    return R = n.child, n = R.sibling, E = El(R, { mode: "visible", children: E.children }), !(r.mode & 1) && (E.lanes = o), E.return = r, E.sibling = null, n !== null && (o = r.deletions, o === null ? (r.deletions = [n], r.flags |= 16) : o.push(n)), r.child = E, r.memoizedState = null, E;
  }
  function Hs(n, r) {
    return r = jl({ mode: "visible", children: r }, n.mode, 0, null), r.return = n, n.child = r;
  }
  function ci(n, r, o, E) {
    return E !== null && WT(E), Zo(r, n.child, null, o), n = Hs(r, r.pendingProps.children), n.flags |= 2, r.memoizedState = null, n;
  }
  function nl(n, r, o, E, f, R, C) {
    if (o)
      return r.flags & 256 ? (r.flags &= -257, E = Ui(Error(T(422))), ci(n, r, C, E)) : r.memoizedState !== null ? (r.child = n.child, r.flags |= 128, null) : (R = E.fallback, f = r.mode, E = jl({ mode: "visible", children: E.children }, f, 0, null), R = Kl(R, f, C, null), R.flags |= 2, E.return = r, R.return = r, E.sibling = R, r.child = E, r.mode & 1 && Zo(r, n.child, null, C), r.child.memoizedState = sf(C), r.memoizedState = Ac, R);
    if (!(r.mode & 1))
      return ci(n, r, C, null);
    if (f.data === "$!") {
      if (E = f.nextSibling && f.nextSibling.dataset, E)
        var P = E.dgst;
      return E = P, R = Error(T(419)), E = Ui(R, E, void 0), ci(n, r, C, E);
    }
    if (P = (C & n.childLanes) !== 0, mr || P) {
      if (E = Kn, E !== null) {
        switch (C & -C) {
          case 4:
            f = 2;
            break;
          case 16:
            f = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            f = 32;
            break;
          case 536870912:
            f = 268435456;
            break;
          default:
            f = 0;
        }
        f = f & (E.suspendedLanes | C) ? 0 : f, f !== 0 && f !== R.retryLane && (R.retryLane = f, ze(n, f), Ai(E, n, f, -1));
      }
      return Of(), E = Ui(Error(T(421))), ci(n, r, C, E);
    }
    return f.data === "$?" ? (r.flags |= 128, r.child = n.child, r = SN.bind(null, n), f._reactRetry = r, null) : (n = R.treeContext, ua = ui(f.nextSibling), ya = r, Sn = !0, Ka = null, n !== null && (sa[vr++] = cr, sa[vr++] = eo, sa[vr++] = ka, cr = n.id, eo = n.overflow, ka = r), r = Hs(r, E.children), r.flags |= 4096, r);
  }
  function oo(n, r, o) {
    n.lanes |= r;
    var E = n.alternate;
    E !== null && (E.lanes |= r), jT(n.return, r, o);
  }
  function Wl(n, r, o, E, f) {
    var R = n.memoizedState;
    R === null ? n.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: E, tail: o, tailMode: f } : (R.isBackwards = r, R.rendering = null, R.renderingStartTime = 0, R.last = E, R.tail = o, R.tailMode = f);
  }
  function Bs(n, r, o) {
    var E = r.pendingProps, f = E.revealOrder, R = E.tail;
    if (Lr(n, r, E.children, o), E = Nn.current, E & 2)
      E = E & 1 | 2, r.flags |= 128;
    else {
      if (n !== null && n.flags & 128)
        e:
          for (n = r.child; n !== null; ) {
            if (n.tag === 13)
              n.memoizedState !== null && oo(n, o, r);
            else if (n.tag === 19)
              oo(n, o, r);
            else if (n.child !== null) {
              n.child.return = n, n = n.child;
              continue;
            }
            if (n === r)
              break e;
            for (; n.sibling === null; ) {
              if (n.return === null || n.return === r)
                break e;
              n = n.return;
            }
            n.sibling.return = n.return, n = n.sibling;
          }
      E &= 1;
    }
    if (qt(Nn, E), !(r.mode & 1))
      r.memoizedState = null;
    else
      switch (f) {
        case "forwards":
          for (o = r.child, f = null; o !== null; )
            n = o.alternate, n !== null && Ms(n) === null && (f = o), o = o.sibling;
          o = f, o === null ? (f = r.child, r.child = null) : (f = o.sibling, o.sibling = null), Wl(r, !1, f, o, R);
          break;
        case "backwards":
          for (o = null, f = r.child, r.child = null; f !== null; ) {
            if (n = f.alternate, n !== null && Ms(n) === null) {
              r.child = f;
              break;
            }
            n = f.sibling, f.sibling = o, o = f, f = n;
          }
          Wl(r, !0, o, null, R);
          break;
        case "together":
          Wl(r, !1, null, null, void 0);
          break;
        default:
          r.memoizedState = null;
      }
    return r.child;
  }
  function Ti(n, r) {
    !(r.mode & 1) && n !== null && (n.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function lo(n, r, o) {
    if (n !== null && (r.dependencies = n.dependencies), Xl |= r.lanes, !(o & r.childLanes))
      return null;
    if (n !== null && r.child !== n.child)
      throw Error(T(153));
    if (r.child !== null) {
      for (n = r.child, o = El(n, n.pendingProps), r.child = o, o.return = r; n.sibling !== null; )
        n = n.sibling, o = o.sibling = El(n, n.pendingProps), o.return = r;
      o.sibling = null;
    }
    return r.child;
  }
  function cN(n, r, o) {
    switch (r.tag) {
      case 3:
        lf(r), yn();
        break;
      case 5:
        ic(r);
        break;
      case 1:
        In(r.type) && JE(r);
        break;
      case 4:
        Mu(r, r.stateNode.containerInfo);
        break;
      case 10:
        var E = r.type._context, f = r.memoizedProps.value;
        qt(zo, E._currentValue), E._currentValue = f;
        break;
      case 13:
        if (E = r.memoizedState, E !== null)
          return E.dehydrated !== null ? (qt(Nn, Nn.current & 1), r.flags |= 128, null) : o & r.child.childLanes ? Rc(n, r, o) : (qt(Nn, Nn.current & 1), n = lo(n, r, o), n !== null ? n.sibling : null);
        qt(Nn, Nn.current & 1);
        break;
      case 19:
        if (E = (o & r.childLanes) !== 0, n.flags & 128) {
          if (E)
            return Bs(n, r, o);
          r.flags |= 128;
        }
        if (f = r.memoizedState, f !== null && (f.rendering = null, f.tail = null, f.lastEffect = null), qt(Nn, Nn.current), E)
          break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, _R(n, r, o);
    }
    return lo(n, r, o);
  }
  var xR, dc, Fs, bR;
  xR = function(n, r) {
    for (var o = r.child; o !== null; ) {
      if (o.tag === 5 || o.tag === 6)
        n.appendChild(o.stateNode);
      else if (o.tag !== 4 && o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === r)
        break;
      for (; o.sibling === null; ) {
        if (o.return === null || o.return === r)
          return;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
  }, dc = function() {
  }, Fs = function(n, r, o, E) {
    var f = n.memoizedProps;
    if (f !== E) {
      n = r.stateNode, ro(za.current);
      var R = null;
      switch (o) {
        case "input":
          f = nr(n, f), E = nr(n, E), R = [];
          break;
        case "select":
          f = U({}, f, { value: void 0 }), E = U({}, E, { value: void 0 }), R = [];
          break;
        case "textarea":
          f = $r(n, f), E = $r(n, E), R = [];
          break;
        default:
          typeof f.onClick != "function" && typeof E.onClick == "function" && (n.onclick = zE);
      }
      xn(o, E);
      var C;
      o = null;
      for (Z in f)
        if (!E.hasOwnProperty(Z) && f.hasOwnProperty(Z) && f[Z] != null)
          if (Z === "style") {
            var P = f[Z];
            for (C in P)
              P.hasOwnProperty(C) && (o || (o = {}), o[C] = "");
          } else
            Z !== "dangerouslySetInnerHTML" && Z !== "children" && Z !== "suppressContentEditableWarning" && Z !== "suppressHydrationWarning" && Z !== "autoFocus" && (O.hasOwnProperty(Z) ? R || (R = []) : (R = R || []).push(Z, null));
      for (Z in E) {
        var b = E[Z];
        if (P = f != null ? f[Z] : void 0, E.hasOwnProperty(Z) && b !== P && (b != null || P != null))
          if (Z === "style")
            if (P) {
              for (C in P)
                !P.hasOwnProperty(C) || b && b.hasOwnProperty(C) || (o || (o = {}), o[C] = "");
              for (C in b)
                b.hasOwnProperty(C) && P[C] !== b[C] && (o || (o = {}), o[C] = b[C]);
            } else
              o || (R || (R = []), R.push(
                Z,
                o
              )), o = b;
          else
            Z === "dangerouslySetInnerHTML" ? (b = b ? b.__html : void 0, P = P ? P.__html : void 0, b != null && P !== b && (R = R || []).push(Z, b)) : Z === "children" ? typeof b != "string" && typeof b != "number" || (R = R || []).push(Z, "" + b) : Z !== "suppressContentEditableWarning" && Z !== "suppressHydrationWarning" && (O.hasOwnProperty(Z) ? (b != null && Z === "onScroll" && En("scroll", n), R || P === b || (R = [])) : (R = R || []).push(Z, b));
      }
      o && (R = R || []).push("style", o);
      var Z = R;
      (r.updateQueue = Z) && (r.flags |= 4);
    }
  }, bR = function(n, r, o, E) {
    o !== E && (r.flags |= 4);
  };
  function ws(n, r) {
    if (!Sn)
      switch (n.tailMode) {
        case "hidden":
          r = n.tail;
          for (var o = null; r !== null; )
            r.alternate !== null && (o = r), r = r.sibling;
          o === null ? n.tail = null : o.sibling = null;
          break;
        case "collapsed":
          o = n.tail;
          for (var E = null; o !== null; )
            o.alternate !== null && (E = o), o = o.sibling;
          E === null ? r || n.tail === null ? n.tail = null : n.tail.sibling = null : E.sibling = null;
      }
  }
  function yr(n) {
    var r = n.alternate !== null && n.alternate.child === n.child, o = 0, E = 0;
    if (r)
      for (var f = n.child; f !== null; )
        o |= f.lanes | f.childLanes, E |= f.subtreeFlags & 14680064, E |= f.flags & 14680064, f.return = n, f = f.sibling;
    else
      for (f = n.child; f !== null; )
        o |= f.lanes | f.childLanes, E |= f.subtreeFlags, E |= f.flags, f.return = n, f = f.sibling;
    return n.subtreeFlags |= E, n.childLanes = o, r;
  }
  function Sc(n, r, o) {
    var E = r.pendingProps;
    switch (YT(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return yr(r), null;
      case 1:
        return In(r.type) && Xa(), yr(r), null;
      case 3:
        return E = r.stateNode, qo(), jt(Mn), jt(Tt), Gu(), E.pendingContext && (E.context = E.pendingContext, E.pendingContext = null), (n === null || n.child === null) && ($E(r) ? r.flags |= 4 : n === null || n.memoizedState.isDehydrated && !(r.flags & 256) || (r.flags |= 1024, Ka !== null && (Rf(Ka), Ka = null))), dc(n, r), yr(r), null;
      case 5:
        Uu(r);
        var f = ro(Fl.current);
        if (o = r.type, n !== null && r.stateNode != null)
          Fs(n, r, o, E, f), n.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!E) {
            if (r.stateNode === null)
              throw Error(T(166));
            return yr(r), null;
          }
          if (n = ro(za.current), $E(r)) {
            E = r.stateNode, o = r.type;
            var R = r.memoizedProps;
            switch (E[Pi] = r, E[_l] = R, n = (r.mode & 1) !== 0, o) {
              case "dialog":
                En("cancel", E), En("close", E);
                break;
              case "iframe":
              case "object":
              case "embed":
                En("load", E);
                break;
              case "video":
              case "audio":
                for (f = 0; f < Cu.length; f++)
                  En(Cu[f], E);
                break;
              case "source":
                En("error", E);
                break;
              case "img":
              case "image":
              case "link":
                En(
                  "error",
                  E
                ), En("load", E);
                break;
              case "details":
                En("toggle", E);
                break;
              case "input":
                Qn(E, R), En("invalid", E);
                break;
              case "select":
                E._wrapperState = { wasMultiple: !!R.multiple }, En("invalid", E);
                break;
              case "textarea":
                Cr(E, R), En("invalid", E);
            }
            xn(o, R), f = null;
            for (var C in R)
              if (R.hasOwnProperty(C)) {
                var P = R[C];
                C === "children" ? typeof P == "string" ? E.textContent !== P && (R.suppressHydrationWarning !== !0 && jE(E.textContent, P, n), f = ["children", P]) : typeof P == "number" && E.textContent !== "" + P && (R.suppressHydrationWarning !== !0 && jE(
                  E.textContent,
                  P,
                  n
                ), f = ["children", "" + P]) : O.hasOwnProperty(C) && P != null && C === "onScroll" && En("scroll", E);
              }
            switch (o) {
              case "input":
                gn(E), Zr(E, R, !0);
                break;
              case "textarea":
                gn(E), ur(E);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof R.onClick == "function" && (E.onclick = zE);
            }
            E = f, r.updateQueue = E, E !== null && (r.flags |= 4);
          } else {
            C = f.nodeType === 9 ? f : f.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = ea(o)), n === "http://www.w3.org/1999/xhtml" ? o === "script" ? (n = C.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof E.is == "string" ? n = C.createElement(o, { is: E.is }) : (n = C.createElement(o), o === "select" && (C = n, E.multiple ? C.multiple = !0 : E.size && (C.size = E.size))) : n = C.createElementNS(n, o), n[Pi] = r, n[_l] = E, xR(n, r, !1, !1), r.stateNode = n;
            e: {
              switch (C = mn(o, E), o) {
                case "dialog":
                  En("cancel", n), En("close", n), f = E;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  En("load", n), f = E;
                  break;
                case "video":
                case "audio":
                  for (f = 0; f < Cu.length; f++)
                    En(Cu[f], n);
                  f = E;
                  break;
                case "source":
                  En("error", n), f = E;
                  break;
                case "img":
                case "image":
                case "link":
                  En(
                    "error",
                    n
                  ), En("load", n), f = E;
                  break;
                case "details":
                  En("toggle", n), f = E;
                  break;
                case "input":
                  Qn(n, E), f = nr(n, E), En("invalid", n);
                  break;
                case "option":
                  f = E;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!E.multiple }, f = U({}, E, { value: void 0 }), En("invalid", n);
                  break;
                case "textarea":
                  Cr(n, E), f = $r(n, E), En("invalid", n);
                  break;
                default:
                  f = E;
              }
              xn(o, f), P = f;
              for (R in P)
                if (P.hasOwnProperty(R)) {
                  var b = P[R];
                  R === "style" ? Kt(n, b) : R === "dangerouslySetInnerHTML" ? (b = b ? b.__html : void 0, b != null && Ci(n, b)) : R === "children" ? typeof b == "string" ? (o !== "textarea" || b !== "") && Ia(n, b) : typeof b == "number" && Ia(n, "" + b) : R !== "suppressContentEditableWarning" && R !== "suppressHydrationWarning" && R !== "autoFocus" && (O.hasOwnProperty(R) ? b != null && R === "onScroll" && En("scroll", n) : b != null && he(n, R, b, C));
                }
              switch (o) {
                case "input":
                  gn(n), Zr(n, E, !1);
                  break;
                case "textarea":
                  gn(n), ur(n);
                  break;
                case "option":
                  E.value != null && n.setAttribute("value", "" + lt(E.value));
                  break;
                case "select":
                  n.multiple = !!E.multiple, R = E.value, R != null ? Ir(n, !!E.multiple, R, !1) : E.defaultValue != null && Ir(
                    n,
                    !!E.multiple,
                    E.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof f.onClick == "function" && (n.onclick = zE);
              }
              switch (o) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  E = !!E.autoFocus;
                  break e;
                case "img":
                  E = !0;
                  break e;
                default:
                  E = !1;
              }
            }
            E && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return yr(r), null;
      case 6:
        if (n && r.stateNode != null)
          bR(n, r, n.memoizedProps, E);
        else {
          if (typeof E != "string" && r.stateNode === null)
            throw Error(T(166));
          if (o = ro(Fl.current), ro(za.current), $E(r)) {
            if (E = r.stateNode, o = r.memoizedProps, E[Pi] = r, (R = E.nodeValue !== o) && (n = ya, n !== null))
              switch (n.tag) {
                case 3:
                  jE(E.nodeValue, o, (n.mode & 1) !== 0);
                  break;
                case 5:
                  n.memoizedProps.suppressHydrationWarning !== !0 && jE(E.nodeValue, o, (n.mode & 1) !== 0);
              }
            R && (r.flags |= 4);
          } else
            E = (o.nodeType === 9 ? o : o.ownerDocument).createTextNode(E), E[Pi] = r, r.stateNode = E;
        }
        return yr(r), null;
      case 13:
        if (jt(Nn), E = r.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (Sn && ua !== null && r.mode & 1 && !(r.flags & 128))
            NR(), yn(), r.flags |= 98560, R = !1;
          else if (R = $E(r), E !== null && E.dehydrated !== null) {
            if (n === null) {
              if (!R)
                throw Error(T(318));
              if (R = r.memoizedState, R = R !== null ? R.dehydrated : null, !R)
                throw Error(T(317));
              R[Pi] = r;
            } else
              yn(), !(r.flags & 128) && (r.memoizedState = null), r.flags |= 4;
            yr(r), R = !1;
          } else
            Ka !== null && (Rf(Ka), Ka = null), R = !0;
          if (!R)
            return r.flags & 65536 ? r : null;
        }
        return r.flags & 128 ? (r.lanes = o, r) : (E = E !== null, E !== (n !== null && n.memoizedState !== null) && E && (r.child.flags |= 8192, r.mode & 1 && (n === null || Nn.current & 1 ? jn === 0 && (jn = 3) : Of())), r.updateQueue !== null && (r.flags |= 4), yr(r), null);
      case 4:
        return qo(), dc(n, r), n === null && ms(r.stateNode.containerInfo), yr(r), null;
      case 10:
        return Da(r.type._context), yr(r), null;
      case 17:
        return In(r.type) && Xa(), yr(r), null;
      case 19:
        if (jt(Nn), R = r.memoizedState, R === null)
          return yr(r), null;
        if (E = (r.flags & 128) !== 0, C = R.rendering, C === null)
          if (E)
            ws(R, !1);
          else {
            if (jn !== 0 || n !== null && n.flags & 128)
              for (n = r.child; n !== null; ) {
                if (C = Ms(n), C !== null) {
                  for (r.flags |= 128, ws(R, !1), E = C.updateQueue, E !== null && (r.updateQueue = E, r.flags |= 4), r.subtreeFlags = 0, E = o, o = r.child; o !== null; )
                    R = o, n = E, R.flags &= 14680066, C = R.alternate, C === null ? (R.childLanes = 0, R.lanes = n, R.child = null, R.subtreeFlags = 0, R.memoizedProps = null, R.memoizedState = null, R.updateQueue = null, R.dependencies = null, R.stateNode = null) : (R.childLanes = C.childLanes, R.lanes = C.lanes, R.child = C.child, R.subtreeFlags = 0, R.deletions = null, R.memoizedProps = C.memoizedProps, R.memoizedState = C.memoizedState, R.updateQueue = C.updateQueue, R.type = C.type, n = C.dependencies, R.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), o = o.sibling;
                  return qt(Nn, Nn.current & 1 | 2), r.child;
                }
                n = n.sibling;
              }
            R.tail !== null && Ht() > Vs && (r.flags |= 128, E = !0, ws(R, !1), r.lanes = 4194304);
          }
        else {
          if (!E)
            if (n = Ms(C), n !== null) {
              if (r.flags |= 128, E = !0, o = n.updateQueue, o !== null && (r.updateQueue = o, r.flags |= 4), ws(R, !0), R.tail === null && R.tailMode === "hidden" && !C.alternate && !Sn)
                return yr(r), null;
            } else
              2 * Ht() - R.renderingStartTime > Vs && o !== 1073741824 && (r.flags |= 128, E = !0, ws(R, !1), r.lanes = 4194304);
          R.isBackwards ? (C.sibling = r.child, r.child = C) : (o = R.last, o !== null ? o.sibling = C : r.child = C, R.last = C);
        }
        return R.tail !== null ? (r = R.tail, R.rendering = r, R.tail = r.sibling, R.renderingStartTime = Ht(), r.sibling = null, o = Nn.current, qt(Nn, E ? o & 1 | 2 : o & 1), r) : (yr(r), null);
      case 22:
      case 23:
        return Sf(), E = r.memoizedState !== null, n !== null && n.memoizedState !== null !== E && (r.flags |= 8192), E && r.mode & 1 ? Pa & 1073741824 && (yr(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : yr(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(T(156, r.tag));
  }
  function HR(n, r) {
    switch (YT(r), r.tag) {
      case 1:
        return In(r.type) && Xa(), n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 3:
        return qo(), jt(Mn), jt(Tt), Gu(), n = r.flags, n & 65536 && !(n & 128) ? (r.flags = n & -65537 | 128, r) : null;
      case 5:
        return Uu(r), null;
      case 13:
        if (jt(Nn), n = r.memoizedState, n !== null && n.dehydrated !== null) {
          if (r.alternate === null)
            throw Error(T(340));
          yn();
        }
        return n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 19:
        return jt(Nn), null;
      case 4:
        return qo(), null;
      case 10:
        return Da(r.type._context), null;
      case 22:
      case 23:
        return Sf(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Nc = !1, kn = !1, Wu = typeof WeakSet == "function" ? WeakSet : Set, Ge = null;
  function rl(n, r) {
    var o = n.ref;
    if (o !== null)
      if (typeof o == "function")
        try {
          o(null);
        } catch (E) {
          _n(n, r, E);
        }
      else
        o.current = null;
  }
  function pc(n, r, o) {
    try {
      o();
    } catch (E) {
      _n(n, r, E);
    }
  }
  var BR = !1;
  function TN(n, r) {
    if (_T = wa, n = VE(), Qi(n)) {
      if ("selectionStart" in n)
        var o = { start: n.selectionStart, end: n.selectionEnd };
      else
        e: {
          o = (o = n.ownerDocument) && o.defaultView || window;
          var E = o.getSelection && o.getSelection();
          if (E && E.rangeCount !== 0) {
            o = E.anchorNode;
            var f = E.anchorOffset, R = E.focusNode;
            E = E.focusOffset;
            try {
              o.nodeType, R.nodeType;
            } catch {
              o = null;
              break e;
            }
            var C = 0, P = -1, b = -1, Z = 0, Te = 0, fe = n, ue = null;
            t:
              for (; ; ) {
                for (var Ue; fe !== o || f !== 0 && fe.nodeType !== 3 || (P = C + f), fe !== R || E !== 0 && fe.nodeType !== 3 || (b = C + E), fe.nodeType === 3 && (C += fe.nodeValue.length), (Ue = fe.firstChild) !== null; )
                  ue = fe, fe = Ue;
                for (; ; ) {
                  if (fe === n)
                    break t;
                  if (ue === o && ++Z === f && (P = C), ue === R && ++Te === E && (b = C), (Ue = fe.nextSibling) !== null)
                    break;
                  fe = ue, ue = fe.parentNode;
                }
                fe = Ue;
              }
            o = P === -1 || b === -1 ? null : { start: P, end: b };
          } else
            o = null;
        }
      o = o || { start: 0, end: 0 };
    } else
      o = null;
    for (Ml = { focusedElem: n, selectionRange: o }, wa = !1, Ge = r; Ge !== null; )
      if (r = Ge, n = r.child, (r.subtreeFlags & 1028) !== 0 && n !== null)
        n.return = r, Ge = n;
      else
        for (; Ge !== null; ) {
          r = Ge;
          try {
            var we = r.alternate;
            if (r.flags & 1024)
              switch (r.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (we !== null) {
                    var ke = we.memoizedProps, Fn = we.memoizedState, V = r.stateNode, B = V.getSnapshotBeforeUpdate(r.elementType === r.type ? ke : ja(r.type, ke), Fn);
                    V.__reactInternalSnapshotBeforeUpdate = B;
                  }
                  break;
                case 3:
                  var K = r.stateNode.containerInfo;
                  K.nodeType === 1 ? K.textContent = "" : K.nodeType === 9 && K.documentElement && K.removeChild(K.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(T(163));
              }
          } catch (Ne) {
            _n(r, r.return, Ne);
          }
          if (n = r.sibling, n !== null) {
            n.return = r.return, Ge = n;
            break;
          }
          Ge = r.return;
        }
    return we = BR, BR = !1, we;
  }
  function Xu(n, r, o) {
    var E = r.updateQueue;
    if (E = E !== null ? E.lastEffect : null, E !== null) {
      var f = E = E.next;
      do {
        if ((f.tag & n) === n) {
          var R = f.destroy;
          f.destroy = void 0, R !== void 0 && pc(r, o, R);
        }
        f = f.next;
      } while (f !== E);
    }
  }
  function Oc(n, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var o = r = r.next;
      do {
        if ((o.tag & n) === n) {
          var E = o.create;
          o.destroy = E();
        }
        o = o.next;
      } while (o !== r);
    }
  }
  function ku(n) {
    var r = n.ref;
    if (r !== null) {
      var o = n.stateNode;
      switch (n.tag) {
        case 5:
          n = o;
          break;
        default:
          n = o;
      }
      typeof r == "function" ? r(n) : r.current = n;
    }
  }
  function FR(n) {
    var r = n.alternate;
    r !== null && (n.alternate = null, FR(r)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (r = n.stateNode, r !== null && (delete r[Pi], delete r[_l], delete r[bT], delete r[iN], delete r[HT])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function Ku(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function Ic(n) {
    e:
      for (; ; ) {
        for (; n.sibling === null; ) {
          if (n.return === null || Ku(n.return))
            return null;
          n = n.return;
        }
        for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
          if (n.flags & 2 || n.child === null || n.tag === 4)
            continue e;
          n.child.return = n, n = n.child;
        }
        if (!(n.flags & 2))
          return n.stateNode;
      }
  }
  function Cc(n, r, o) {
    var E = n.tag;
    if (E === 5 || E === 6)
      n = n.stateNode, r ? o.nodeType === 8 ? o.parentNode.insertBefore(n, r) : o.insertBefore(n, r) : (o.nodeType === 8 ? (r = o.parentNode, r.insertBefore(n, o)) : (r = o, r.appendChild(n)), o = o._reactRootContainer, o != null || r.onclick !== null || (r.onclick = zE));
    else if (E !== 4 && (n = n.child, n !== null))
      for (Cc(n, r, o), n = n.sibling; n !== null; )
        Cc(n, r, o), n = n.sibling;
  }
  function uf(n, r, o) {
    var E = n.tag;
    if (E === 5 || E === 6)
      n = n.stateNode, r ? o.insertBefore(n, r) : o.appendChild(n);
    else if (E !== 4 && (n = n.child, n !== null))
      for (uf(n, r, o), n = n.sibling; n !== null; )
        uf(n, r, o), n = n.sibling;
  }
  var fr = null, fi = !1;
  function al(n, r, o) {
    for (o = o.child; o !== null; )
      Ys(n, r, o), o = o.sibling;
  }
  function Ys(n, r, o) {
    if (ta && typeof ta.onCommitFiberUnmount == "function")
      try {
        ta.onCommitFiberUnmount(Mo, o);
      } catch {
      }
    switch (o.tag) {
      case 5:
        kn || rl(o, r);
      case 6:
        var E = fr, f = fi;
        fr = null, al(n, r, o), fr = E, fi = f, fr !== null && (fi ? (n = fr, o = o.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(o) : n.removeChild(o)) : fr.removeChild(o.stateNode));
        break;
      case 18:
        fr !== null && (fi ? (n = fr, o = o.stateNode, n.nodeType === 8 ? Wo(n.parentNode, o) : n.nodeType === 1 && Wo(n, o), Bo(n)) : Wo(fr, o.stateNode));
        break;
      case 4:
        E = fr, f = fi, fr = o.stateNode.containerInfo, fi = !0, al(n, r, o), fr = E, fi = f;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!kn && (E = o.updateQueue, E !== null && (E = E.lastEffect, E !== null))) {
          f = E = E.next;
          do {
            var R = f, C = R.destroy;
            R = R.tag, C !== void 0 && (R & 2 || R & 4) && pc(o, r, C), f = f.next;
          } while (f !== E);
        }
        al(n, r, o);
        break;
      case 1:
        if (!kn && (rl(o, r), E = o.stateNode, typeof E.componentWillUnmount == "function"))
          try {
            E.props = o.memoizedProps, E.state = o.memoizedState, E.componentWillUnmount();
          } catch (P) {
            _n(o, r, P);
          }
        al(n, r, o);
        break;
      case 21:
        al(n, r, o);
        break;
      case 22:
        o.mode & 1 ? (kn = (E = kn) || o.memoizedState !== null, al(n, r, o), kn = E) : al(n, r, o);
        break;
      default:
        al(n, r, o);
    }
  }
  function hc(n) {
    var r = n.updateQueue;
    if (r !== null) {
      n.updateQueue = null;
      var o = n.stateNode;
      o === null && (o = n.stateNode = new Wu()), r.forEach(function(E) {
        var f = NN.bind(null, n, E);
        o.has(E) || (o.add(E), E.then(f, f));
      });
    }
  }
  function Hr(n, r) {
    var o = r.deletions;
    if (o !== null)
      for (var E = 0; E < o.length; E++) {
        var f = o[E];
        try {
          var R = n, C = r, P = C;
          e:
            for (; P !== null; ) {
              switch (P.tag) {
                case 5:
                  fr = P.stateNode, fi = !1;
                  break e;
                case 3:
                  fr = P.stateNode.containerInfo, fi = !0;
                  break e;
                case 4:
                  fr = P.stateNode.containerInfo, fi = !0;
                  break e;
              }
              P = P.return;
            }
          if (fr === null)
            throw Error(T(160));
          Ys(R, C, f), fr = null, fi = !1;
          var b = f.alternate;
          b !== null && (b.return = null), f.return = null;
        } catch (Z) {
          _n(f, r, Z);
        }
      }
    if (r.subtreeFlags & 12854)
      for (r = r.child; r !== null; )
        wR(r, n), r = r.sibling;
  }
  function wR(n, r) {
    var o = n.alternate, E = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Hr(r, n), Gi(n), E & 4) {
          try {
            Xu(3, n, n.return), Oc(3, n);
          } catch (ke) {
            _n(n, n.return, ke);
          }
          try {
            Xu(5, n, n.return);
          } catch (ke) {
            _n(n, n.return, ke);
          }
        }
        break;
      case 1:
        Hr(r, n), Gi(n), E & 512 && o !== null && rl(o, o.return);
        break;
      case 5:
        if (Hr(r, n), Gi(n), E & 512 && o !== null && rl(o, o.return), n.flags & 32) {
          var f = n.stateNode;
          try {
            Ia(f, "");
          } catch (ke) {
            _n(n, n.return, ke);
          }
        }
        if (E & 4 && (f = n.stateNode, f != null)) {
          var R = n.memoizedProps, C = o !== null ? o.memoizedProps : R, P = n.type, b = n.updateQueue;
          if (n.updateQueue = null, b !== null)
            try {
              P === "input" && R.type === "radio" && R.name != null && Zn(f, R), mn(P, C);
              var Z = mn(P, R);
              for (C = 0; C < b.length; C += 2) {
                var Te = b[C], fe = b[C + 1];
                Te === "style" ? Kt(f, fe) : Te === "dangerouslySetInnerHTML" ? Ci(f, fe) : Te === "children" ? Ia(f, fe) : he(f, Te, fe, Z);
              }
              switch (P) {
                case "input":
                  Gn(f, R);
                  break;
                case "textarea":
                  Oa(f, R);
                  break;
                case "select":
                  var ue = f._wrapperState.wasMultiple;
                  f._wrapperState.wasMultiple = !!R.multiple;
                  var Ue = R.value;
                  Ue != null ? Ir(f, !!R.multiple, Ue, !1) : ue !== !!R.multiple && (R.defaultValue != null ? Ir(
                    f,
                    !!R.multiple,
                    R.defaultValue,
                    !0
                  ) : Ir(f, !!R.multiple, R.multiple ? [] : "", !1));
              }
              f[_l] = R;
            } catch (ke) {
              _n(n, n.return, ke);
            }
        }
        break;
      case 6:
        if (Hr(r, n), Gi(n), E & 4) {
          if (n.stateNode === null)
            throw Error(T(162));
          f = n.stateNode, R = n.memoizedProps;
          try {
            f.nodeValue = R;
          } catch (ke) {
            _n(n, n.return, ke);
          }
        }
        break;
      case 3:
        if (Hr(r, n), Gi(n), E & 4 && o !== null && o.memoizedState.isDehydrated)
          try {
            Bo(r.containerInfo);
          } catch (ke) {
            _n(n, n.return, ke);
          }
        break;
      case 4:
        Hr(r, n), Gi(n);
        break;
      case 13:
        Hr(r, n), Gi(n), f = n.child, f.flags & 8192 && (R = f.memoizedState !== null, f.stateNode.isHidden = R, !R || f.alternate !== null && f.alternate.memoizedState !== null || (Tf = Ht())), E & 4 && hc(n);
        break;
      case 22:
        if (Te = o !== null && o.memoizedState !== null, n.mode & 1 ? (kn = (Z = kn) || Te, Hr(r, n), kn = Z) : Hr(r, n), Gi(n), E & 8192) {
          if (Z = n.memoizedState !== null, (n.stateNode.isHidden = Z) && !Te && n.mode & 1)
            for (Ge = n, Te = n.child; Te !== null; ) {
              for (fe = Ge = Te; Ge !== null; ) {
                switch (ue = Ge, Ue = ue.child, ue.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Xu(4, ue, ue.return);
                    break;
                  case 1:
                    rl(ue, ue.return);
                    var we = ue.stateNode;
                    if (typeof we.componentWillUnmount == "function") {
                      E = ue, o = ue.return;
                      try {
                        r = E, we.props = r.memoizedProps, we.state = r.memoizedState, we.componentWillUnmount();
                      } catch (ke) {
                        _n(E, o, ke);
                      }
                    }
                    break;
                  case 5:
                    rl(ue, ue.return);
                    break;
                  case 22:
                    if (ue.memoizedState !== null) {
                      zu(fe);
                      continue;
                    }
                }
                Ue !== null ? (Ue.return = ue, Ge = Ue) : zu(fe);
              }
              Te = Te.sibling;
            }
          e:
            for (Te = null, fe = n; ; ) {
              if (fe.tag === 5) {
                if (Te === null) {
                  Te = fe;
                  try {
                    f = fe.stateNode, Z ? (R = f.style, typeof R.setProperty == "function" ? R.setProperty("display", "none", "important") : R.display = "none") : (P = fe.stateNode, b = fe.memoizedProps.style, C = b != null && b.hasOwnProperty("display") ? b.display : null, P.style.display = mt("display", C));
                  } catch (ke) {
                    _n(n, n.return, ke);
                  }
                }
              } else if (fe.tag === 6) {
                if (Te === null)
                  try {
                    fe.stateNode.nodeValue = Z ? "" : fe.memoizedProps;
                  } catch (ke) {
                    _n(n, n.return, ke);
                  }
              } else if ((fe.tag !== 22 && fe.tag !== 23 || fe.memoizedState === null || fe === n) && fe.child !== null) {
                fe.child.return = fe, fe = fe.child;
                continue;
              }
              if (fe === n)
                break e;
              for (; fe.sibling === null; ) {
                if (fe.return === null || fe.return === n)
                  break e;
                Te === fe && (Te = null), fe = fe.return;
              }
              Te === fe && (Te = null), fe.sibling.return = fe.return, fe = fe.sibling;
            }
        }
        break;
      case 19:
        Hr(r, n), Gi(n), E & 4 && hc(n);
        break;
      case 21:
        break;
      default:
        Hr(
          r,
          n
        ), Gi(n);
    }
  }
  function Gi(n) {
    var r = n.flags;
    if (r & 2) {
      try {
        e: {
          for (var o = n.return; o !== null; ) {
            if (Ku(o)) {
              var E = o;
              break e;
            }
            o = o.return;
          }
          throw Error(T(160));
        }
        switch (E.tag) {
          case 5:
            var f = E.stateNode;
            E.flags & 32 && (Ia(f, ""), E.flags &= -33);
            var R = Ic(n);
            uf(n, R, f);
            break;
          case 3:
          case 4:
            var C = E.stateNode.containerInfo, P = Ic(n);
            Cc(n, P, C);
            break;
          default:
            throw Error(T(161));
        }
      } catch (b) {
        _n(n, n.return, b);
      }
      n.flags &= -3;
    }
    r & 4096 && (n.flags &= -4097);
  }
  function YR(n, r, o) {
    Ge = n, Ef(n);
  }
  function Ef(n, r, o) {
    for (var E = (n.mode & 1) !== 0; Ge !== null; ) {
      var f = Ge, R = f.child;
      if (f.tag === 22 && E) {
        var C = f.memoizedState !== null || Nc;
        if (!C) {
          var P = f.alternate, b = P !== null && P.memoizedState !== null || kn;
          P = Nc;
          var Z = kn;
          if (Nc = C, (kn = b) && !Z)
            for (Ge = f; Ge !== null; )
              C = Ge, b = C.child, C.tag === 22 && C.memoizedState !== null ? cf(f) : b !== null ? (b.return = C, Ge = b) : cf(f);
          for (; R !== null; )
            Ge = R, Ef(R), R = R.sibling;
          Ge = f, Nc = P, kn = Z;
        }
        ju(n);
      } else
        f.subtreeFlags & 8772 && R !== null ? (R.return = f, Ge = R) : ju(n);
    }
  }
  function ju(n) {
    for (; Ge !== null; ) {
      var r = Ge;
      if (r.flags & 8772) {
        var o = r.alternate;
        try {
          if (r.flags & 8772)
            switch (r.tag) {
              case 0:
              case 11:
              case 15:
                kn || Oc(5, r);
                break;
              case 1:
                var E = r.stateNode;
                if (r.flags & 4 && !kn)
                  if (o === null)
                    E.componentDidMount();
                  else {
                    var f = r.elementType === r.type ? o.memoizedProps : ja(r.type, o.memoizedProps);
                    E.componentDidUpdate(f, o.memoizedState, E.__reactInternalSnapshotBeforeUpdate);
                  }
                var R = r.updateQueue;
                R !== null && zT(r, R, E);
                break;
              case 3:
                var C = r.updateQueue;
                if (C !== null) {
                  if (o = null, r.child !== null)
                    switch (r.child.tag) {
                      case 5:
                        o = r.child.stateNode;
                        break;
                      case 1:
                        o = r.child.stateNode;
                    }
                  zT(r, C, o);
                }
                break;
              case 5:
                var P = r.stateNode;
                if (o === null && r.flags & 4) {
                  o = P;
                  var b = r.memoizedProps;
                  switch (r.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      b.autoFocus && o.focus();
                      break;
                    case "img":
                      b.src && (o.src = b.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (r.memoizedState === null) {
                  var Z = r.alternate;
                  if (Z !== null) {
                    var Te = Z.memoizedState;
                    if (Te !== null) {
                      var fe = Te.dehydrated;
                      fe !== null && Bo(fe);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(T(163));
            }
          kn || r.flags & 512 && ku(r);
        } catch (ue) {
          _n(r, r.return, ue);
        }
      }
      if (r === n) {
        Ge = null;
        break;
      }
      if (o = r.sibling, o !== null) {
        o.return = r.return, Ge = o;
        break;
      }
      Ge = r.return;
    }
  }
  function zu(n) {
    for (; Ge !== null; ) {
      var r = Ge;
      if (r === n) {
        Ge = null;
        break;
      }
      var o = r.sibling;
      if (o !== null) {
        o.return = r.return, Ge = o;
        break;
      }
      Ge = r.return;
    }
  }
  function cf(n) {
    for (; Ge !== null; ) {
      var r = Ge;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var o = r.return;
            try {
              Oc(4, r);
            } catch (b) {
              _n(r, o, b);
            }
            break;
          case 1:
            var E = r.stateNode;
            if (typeof E.componentDidMount == "function") {
              var f = r.return;
              try {
                E.componentDidMount();
              } catch (b) {
                _n(r, f, b);
              }
            }
            var R = r.return;
            try {
              ku(r);
            } catch (b) {
              _n(r, R, b);
            }
            break;
          case 5:
            var C = r.return;
            try {
              ku(r);
            } catch (b) {
              _n(r, C, b);
            }
        }
      } catch (b) {
        _n(r, r.return, b);
      }
      if (r === n) {
        Ge = null;
        break;
      }
      var P = r.sibling;
      if (P !== null) {
        P.return = r.return, Ge = P;
        break;
      }
      Ge = r.return;
    }
  }
  var ga = Math.ceil, so = Fe.ReactCurrentDispatcher, Ju = Fe.ReactCurrentOwner, Dr = Fe.ReactCurrentBatchConfig, wt = 0, Kn = null, Un = null, Bn = 0, Pa = 0, uo = Ct(0), jn = 0, Qu = null, Xl = 0, vc = 0, Zu = 0, qu = null, Ta = null, Tf = 0, Vs = 1 / 0, Eo = null, $u = !1, ff = null, il = null, mc = !1, ol = null, Lc = 0, eE = 0, tE = null, yc = -1, Dc = 0;
  function Br() {
    return wt & 6 ? Ht() : yc !== -1 ? yc : yc = Ht();
  }
  function co(n) {
    return n.mode & 1 ? wt & 2 && Bn !== 0 ? Bn & -Bn : XT.transition !== null ? (Dc === 0 && (Dc = cs()), Dc) : (n = Vt, n !== 0 || (n = window.event, n = n === void 0 ? 16 : fu(n.type)), n) : 1;
  }
  function Ai(n, r, o, E) {
    if (50 < eE)
      throw eE = 0, tE = null, Error(T(185));
    ki(n, o, E), (!(wt & 2) || n !== Kn) && (n === Kn && (!(wt & 2) && (vc |= o), jn === 4 && ll(n, Bn)), fa(n, E), o === 1 && wt === 0 && !(r.mode & 1) && (Vs = Ht() + 500, or && oa()));
  }
  function fa(n, r) {
    var o = n.callbackNode;
    Go(n, r);
    var E = Gr(n, n === Kn ? Bn : 0);
    if (E === 0)
      o !== null && Er(o), n.callbackNode = null, n.callbackPriority = 0;
    else if (r = E & -E, n.callbackPriority !== r) {
      if (o != null && Er(o), r === 1)
        n.tag === 0 ? FT(df.bind(null, n)) : BT(df.bind(null, n)), xT(function() {
          !(wt & 6) && oa();
        }), o = null;
      else {
        switch (fs(E)) {
          case 1:
            o = ri;
            break;
          case 4:
            o = Dt;
            break;
          case 16:
            o = yi;
            break;
          case 536870912:
            o = us;
            break;
          default:
            o = yi;
        }
        o = jR(o, VR.bind(null, n));
      }
      n.callbackPriority = r, n.callbackNode = o;
    }
  }
  function VR(n, r) {
    if (yc = -1, Dc = 0, wt & 6)
      throw Error(T(327));
    var o = n.callbackNode;
    if (di() && n.callbackNode !== o)
      return null;
    var E = Gr(n, n === Kn ? Bn : 0);
    if (E === 0)
      return null;
    if (E & 30 || E & n.expiredLanes || r)
      r = rE(n, E);
    else {
      r = E;
      var f = wt;
      wt |= 2;
      var R = pf();
      (Kn !== n || Bn !== r) && (Eo = null, Vs = Ht() + 500, sl(n, r));
      do
        try {
          RN();
          break;
        } catch (P) {
          Nf(n, P);
        }
      while (1);
      KT(), so.current = R, wt = f, Un !== null ? r = 0 : (Kn = null, Bn = 0, r = jn);
    }
    if (r !== 0) {
      if (r === 2 && (f = xo(n), f !== 0 && (E = f, r = Af(n, f))), r === 1)
        throw o = Qu, sl(n, 0), ll(n, E), fa(n, Ht()), o;
      if (r === 6)
        ll(n, E);
      else {
        if (f = n.current.alternate, !(E & 30) && !fN(f) && (r = rE(n, E), r === 2 && (R = xo(n), R !== 0 && (E = R, r = Af(n, R))), r === 1))
          throw o = Qu, sl(n, 0), ll(n, E), fa(n, Ht()), o;
        switch (n.finishedWork = f, n.finishedLanes = E, r) {
          case 0:
          case 1:
            throw Error(T(345));
          case 2:
            ul(n, Ta, Eo);
            break;
          case 3:
            if (ll(n, E), (E & 130023424) === E && (r = Tf + 500 - Ht(), 10 < r)) {
              if (Gr(n, 0) !== 0)
                break;
              if (f = n.suspendedLanes, (f & E) !== E) {
                Br(), n.pingedLanes |= n.suspendedLanes & f;
                break;
              }
              n.timeoutHandle = Ul(ul.bind(null, n, Ta, Eo), r);
              break;
            }
            ul(n, Ta, Eo);
            break;
          case 4:
            if (ll(n, E), (E & 4194240) === E)
              break;
            for (r = n.eventTimes, f = -1; 0 < E; ) {
              var C = 31 - _r(E);
              R = 1 << C, C = r[C], C > f && (f = C), E &= ~R;
            }
            if (E = f, E = Ht() - E, E = (120 > E ? 120 : 480 > E ? 480 : 1080 > E ? 1080 : 1920 > E ? 1920 : 3e3 > E ? 3e3 : 4320 > E ? 4320 : 1960 * ga(E / 1960)) - E, 10 < E) {
              n.timeoutHandle = Ul(ul.bind(null, n, Ta, Eo), E);
              break;
            }
            ul(n, Ta, Eo);
            break;
          case 5:
            ul(n, Ta, Eo);
            break;
          default:
            throw Error(T(329));
        }
      }
    }
    return fa(n, Ht()), n.callbackNode === o ? VR.bind(null, n) : null;
  }
  function Af(n, r) {
    var o = qu;
    return n.current.memoizedState.isDehydrated && (sl(n, r).flags |= 256), n = rE(n, r), n !== 2 && (r = Ta, Ta = o, r !== null && Rf(r)), n;
  }
  function Rf(n) {
    Ta === null ? Ta = n : Ta.push.apply(Ta, n);
  }
  function fN(n) {
    for (var r = n; ; ) {
      if (r.flags & 16384) {
        var o = r.updateQueue;
        if (o !== null && (o = o.stores, o !== null))
          for (var E = 0; E < o.length; E++) {
            var f = o[E], R = f.getSnapshot;
            f = f.value;
            try {
              if (!Ya(R(), f))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (o = r.child, r.subtreeFlags & 16384 && o !== null)
        o.return = r, r = o;
      else {
        if (r === n)
          break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n)
            return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function ll(n, r) {
    for (r &= ~Zu, r &= ~vc, n.suspendedLanes |= r, n.pingedLanes &= ~r, n = n.expirationTimes; 0 < r; ) {
      var o = 31 - _r(r), E = 1 << o;
      n[o] = -1, r &= ~E;
    }
  }
  function df(n) {
    if (wt & 6)
      throw Error(T(327));
    di();
    var r = Gr(n, 0);
    if (!(r & 1))
      return fa(n, Ht()), null;
    var o = rE(n, r);
    if (n.tag !== 0 && o === 2) {
      var E = xo(n);
      E !== 0 && (r = E, o = Af(n, E));
    }
    if (o === 1)
      throw o = Qu, sl(n, 0), ll(n, r), fa(n, Ht()), o;
    if (o === 6)
      throw Error(T(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = r, ul(n, Ta, Eo), fa(n, Ht()), null;
  }
  function nE(n, r) {
    var o = wt;
    wt |= 1;
    try {
      return n(r);
    } finally {
      wt = o, wt === 0 && (Vs = Ht() + 500, or && oa());
    }
  }
  function Ri(n) {
    ol !== null && ol.tag === 0 && !(wt & 6) && di();
    var r = wt;
    wt |= 1;
    var o = Dr.transition, E = Vt;
    try {
      if (Dr.transition = null, Vt = 1, n)
        return n();
    } finally {
      Vt = E, Dr.transition = o, wt = r, !(wt & 6) && oa();
    }
  }
  function Sf() {
    Pa = uo.current, jt(uo);
  }
  function sl(n, r) {
    n.finishedWork = null, n.finishedLanes = 0;
    var o = n.timeoutHandle;
    if (o !== -1 && (n.timeoutHandle = -1, AR(o)), Un !== null)
      for (o = Un.return; o !== null; ) {
        var E = o;
        switch (YT(E), E.tag) {
          case 1:
            E = E.type.childContextTypes, E != null && Xa();
            break;
          case 3:
            qo(), jt(Mn), jt(Tt), Gu();
            break;
          case 5:
            Uu(E);
            break;
          case 4:
            qo();
            break;
          case 13:
            jt(Nn);
            break;
          case 19:
            jt(Nn);
            break;
          case 10:
            Da(E.type._context);
            break;
          case 22:
          case 23:
            Sf();
        }
        o = o.return;
      }
    if (Kn = n, Un = n = El(n.current, null), Bn = Pa = r, jn = 0, Qu = null, Zu = vc = Xl = 0, Ta = qu = null, Ds !== null) {
      for (r = 0; r < Ds.length; r++)
        if (o = Ds[r], E = o.interleaved, E !== null) {
          o.interleaved = null;
          var f = E.next, R = o.pending;
          if (R !== null) {
            var C = R.next;
            R.next = f, E.next = C;
          }
          o.pending = E;
        }
      Ds = null;
    }
    return n;
  }
  function Nf(n, r) {
    do {
      var o = Un;
      try {
        if (KT(), ao.current = Tc, wl) {
          for (var E = pn.memoizedState; E !== null; ) {
            var f = E.queue;
            f !== null && (f.pending = null), E = E.next;
          }
          wl = !1;
        }
        if (io = 0, qn = Hn = pn = null, Us = !1, $o = 0, Ju.current = null, o === null || o.return === null) {
          jn = 1, Qu = r, Un = null;
          break;
        }
        e: {
          var R = n, C = o.return, P = o, b = r;
          if (r = Bn, P.flags |= 32768, b !== null && typeof b == "object" && typeof b.then == "function") {
            var Z = b, Te = P, fe = Te.tag;
            if (!(Te.mode & 1) && (fe === 0 || fe === 11 || fe === 15)) {
              var ue = Te.alternate;
              ue ? (Te.updateQueue = ue.updateQueue, Te.memoizedState = ue.memoizedState, Te.lanes = ue.lanes) : (Te.updateQueue = null, Te.memoizedState = null);
            }
            var Ue = PR(C);
            if (Ue !== null) {
              Ue.flags &= -257, MR(Ue, C, P, R, r), Ue.mode & 1 && $n(R, Z, r), r = Ue, b = Z;
              var we = r.updateQueue;
              if (we === null) {
                var ke = /* @__PURE__ */ new Set();
                ke.add(b), r.updateQueue = ke;
              } else
                we.add(b);
              break e;
            } else {
              if (!(r & 1)) {
                $n(R, Z, r), Of();
                break e;
              }
              b = Error(T(426));
            }
          } else if (Sn && P.mode & 1) {
            var Fn = PR(C);
            if (Fn !== null) {
              !(Fn.flags & 65536) && (Fn.flags |= 256), MR(Fn, C, P, R, r), WT(Tr(b, P));
              break e;
            }
          }
          R = b = Tr(b, P), jn !== 4 && (jn = 2), qu === null ? qu = [R] : qu.push(R), R = C;
          do {
            switch (R.tag) {
              case 3:
                R.flags |= 65536, r &= -r, R.lanes |= r;
                var V = bs(R, b, r);
                IR(R, V);
                break e;
              case 1:
                P = b;
                var B = R.type, K = R.stateNode;
                if (!(R.flags & 128) && (typeof B.getDerivedStateFromError == "function" || K !== null && typeof K.componentDidCatch == "function" && (il === null || !il.has(K)))) {
                  R.flags |= 65536, r &= -r, R.lanes |= r;
                  var Ne = Ja(R, P, r);
                  IR(R, Ne);
                  break e;
                }
            }
            R = R.return;
          } while (R !== null);
        }
        If(o);
      } catch (Ke) {
        r = Ke, Un === o && o !== null && (Un = o = o.return);
        continue;
      }
      break;
    } while (1);
  }
  function pf() {
    var n = so.current;
    return so.current = Tc, n === null ? Tc : n;
  }
  function Of() {
    (jn === 0 || jn === 3 || jn === 2) && (jn = 4), Kn === null || !(Xl & 268435455) && !(vc & 268435455) || ll(Kn, Bn);
  }
  function rE(n, r) {
    var o = wt;
    wt |= 2;
    var E = pf();
    (Kn !== n || Bn !== r) && (Eo = null, sl(n, r));
    do
      try {
        AN();
        break;
      } catch (f) {
        Nf(n, f);
      }
    while (1);
    if (KT(), wt = o, so.current = E, Un !== null)
      throw Error(T(261));
    return Kn = null, Bn = 0, jn;
  }
  function AN() {
    for (; Un !== null; )
      WR(Un);
  }
  function RN() {
    for (; Un !== null && !Li(); )
      WR(Un);
  }
  function WR(n) {
    var r = Cf(n.alternate, n, Pa);
    n.memoizedProps = n.pendingProps, r === null ? If(n) : Un = r, Ju.current = null;
  }
  function If(n) {
    var r = n;
    do {
      var o = r.alternate;
      if (n = r.return, r.flags & 32768) {
        if (o = HR(o, r), o !== null) {
          o.flags &= 32767, Un = o;
          return;
        }
        if (n !== null)
          n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          jn = 6, Un = null;
          return;
        }
      } else if (o = Sc(o, r, Pa), o !== null) {
        Un = o;
        return;
      }
      if (r = r.sibling, r !== null) {
        Un = r;
        return;
      }
      Un = r = n;
    } while (r !== null);
    jn === 0 && (jn = 5);
  }
  function ul(n, r, o) {
    var E = Vt, f = Dr.transition;
    try {
      Dr.transition = null, Vt = 1, XR(n, r, o, E);
    } finally {
      Dr.transition = f, Vt = E;
    }
    return null;
  }
  function XR(n, r, o, E) {
    do
      di();
    while (ol !== null);
    if (wt & 6)
      throw Error(T(327));
    o = n.finishedWork;
    var f = n.finishedLanes;
    if (o === null)
      return null;
    if (n.finishedWork = null, n.finishedLanes = 0, o === n.current)
      throw Error(T(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var R = o.lanes | o.childLanes;
    if (AT(n, R), n === Kn && (Un = Kn = null, Bn = 0), !(o.subtreeFlags & 2064) && !(o.flags & 2064) || mc || (mc = !0, jR(yi, function() {
      return di(), null;
    })), R = (o.flags & 15990) !== 0, o.subtreeFlags & 15990 || R) {
      R = Dr.transition, Dr.transition = null;
      var C = Vt;
      Vt = 1;
      var P = wt;
      wt |= 4, Ju.current = null, TN(n, o), wR(o, n), WE(Ml), wa = !!_T, Ml = _T = null, n.current = o, YR(o), ss(), wt = P, Vt = C, Dr.transition = R;
    } else
      n.current = o;
    if (mc && (mc = !1, ol = n, Lc = f), R = n.pendingLanes, R === 0 && (il = null), Eu(o.stateNode), fa(n, Ht()), r !== null)
      for (E = n.onRecoverableError, o = 0; o < r.length; o++)
        f = r[o], E(f.value, { componentStack: f.stack, digest: f.digest });
    if ($u)
      throw $u = !1, n = ff, ff = null, n;
    return Lc & 1 && n.tag !== 0 && di(), R = n.pendingLanes, R & 1 ? n === tE ? eE++ : (eE = 0, tE = n) : eE = 0, oa(), null;
  }
  function di() {
    if (ol !== null) {
      var n = fs(Lc), r = Dr.transition, o = Vt;
      try {
        if (Dr.transition = null, Vt = 16 > n ? 16 : n, ol === null)
          var E = !1;
        else {
          if (n = ol, ol = null, Lc = 0, wt & 6)
            throw Error(T(331));
          var f = wt;
          for (wt |= 4, Ge = n.current; Ge !== null; ) {
            var R = Ge, C = R.child;
            if (Ge.flags & 16) {
              var P = R.deletions;
              if (P !== null) {
                for (var b = 0; b < P.length; b++) {
                  var Z = P[b];
                  for (Ge = Z; Ge !== null; ) {
                    var Te = Ge;
                    switch (Te.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Xu(8, Te, R);
                    }
                    var fe = Te.child;
                    if (fe !== null)
                      fe.return = Te, Ge = fe;
                    else
                      for (; Ge !== null; ) {
                        Te = Ge;
                        var ue = Te.sibling, Ue = Te.return;
                        if (FR(Te), Te === Z) {
                          Ge = null;
                          break;
                        }
                        if (ue !== null) {
                          ue.return = Ue, Ge = ue;
                          break;
                        }
                        Ge = Ue;
                      }
                  }
                }
                var we = R.alternate;
                if (we !== null) {
                  var ke = we.child;
                  if (ke !== null) {
                    we.child = null;
                    do {
                      var Fn = ke.sibling;
                      ke.sibling = null, ke = Fn;
                    } while (ke !== null);
                  }
                }
                Ge = R;
              }
            }
            if (R.subtreeFlags & 2064 && C !== null)
              C.return = R, Ge = C;
            else
              e:
                for (; Ge !== null; ) {
                  if (R = Ge, R.flags & 2048)
                    switch (R.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Xu(9, R, R.return);
                    }
                  var V = R.sibling;
                  if (V !== null) {
                    V.return = R.return, Ge = V;
                    break e;
                  }
                  Ge = R.return;
                }
          }
          var B = n.current;
          for (Ge = B; Ge !== null; ) {
            C = Ge;
            var K = C.child;
            if (C.subtreeFlags & 2064 && K !== null)
              K.return = C, Ge = K;
            else
              e:
                for (C = B; Ge !== null; ) {
                  if (P = Ge, P.flags & 2048)
                    try {
                      switch (P.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Oc(9, P);
                      }
                    } catch (Ke) {
                      _n(P, P.return, Ke);
                    }
                  if (P === C) {
                    Ge = null;
                    break e;
                  }
                  var Ne = P.sibling;
                  if (Ne !== null) {
                    Ne.return = P.return, Ge = Ne;
                    break e;
                  }
                  Ge = P.return;
                }
          }
          if (wt = f, oa(), ta && typeof ta.onPostCommitFiberRoot == "function")
            try {
              ta.onPostCommitFiberRoot(Mo, n);
            } catch {
            }
          E = !0;
        }
        return E;
      } finally {
        Vt = o, Dr.transition = r;
      }
    }
    return !1;
  }
  function kR(n, r, o) {
    r = Tr(o, r), r = bs(n, r, 1), n = to(n, r, 1), r = Br(), n !== null && (ki(n, 1, r), fa(n, r));
  }
  function _n(n, r, o) {
    if (n.tag === 3)
      kR(n, n, o);
    else
      for (; r !== null; ) {
        if (r.tag === 3) {
          kR(r, n, o);
          break;
        } else if (r.tag === 1) {
          var E = r.stateNode;
          if (typeof r.type.getDerivedStateFromError == "function" || typeof E.componentDidCatch == "function" && (il === null || !il.has(E))) {
            n = Tr(o, n), n = Ja(r, n, 1), r = to(r, n, 1), n = Br(), r !== null && (ki(r, 1, n), fa(r, n));
            break;
          }
        }
        r = r.return;
      }
  }
  function dN(n, r, o) {
    var E = n.pingCache;
    E !== null && E.delete(r), r = Br(), n.pingedLanes |= n.suspendedLanes & o, Kn === n && (Bn & o) === o && (jn === 4 || jn === 3 && (Bn & 130023424) === Bn && 500 > Ht() - Tf ? sl(n, 0) : Zu |= o), fa(n, r);
  }
  function KR(n, r) {
    r === 0 && (n.mode & 1 ? (r = Uo, Uo <<= 1, !(Uo & 130023424) && (Uo = 4194304)) : r = 1);
    var o = Br();
    n = ze(n, r), n !== null && (ki(n, r, o), fa(n, o));
  }
  function SN(n) {
    var r = n.memoizedState, o = 0;
    r !== null && (o = r.retryLane), KR(n, o);
  }
  function NN(n, r) {
    var o = 0;
    switch (n.tag) {
      case 13:
        var E = n.stateNode, f = n.memoizedState;
        f !== null && (o = f.retryLane);
        break;
      case 19:
        E = n.stateNode;
        break;
      default:
        throw Error(T(314));
    }
    E !== null && E.delete(r), KR(n, o);
  }
  var Cf;
  Cf = function(n, r, o) {
    if (n !== null)
      if (n.memoizedProps !== r.pendingProps || Mn.current)
        mr = !0;
      else {
        if (!(n.lanes & o) && !(r.flags & 128))
          return mr = !1, cN(n, r, o);
        mr = !!(n.flags & 131072);
      }
    else
      mr = !1, Sn && r.flags & 1048576 && wT(r, ys, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var E = r.type;
        Ti(n, r), n = r.pendingProps;
        var f = Wa(r, Tt.current);
        Pu(r, o), f = Gs(null, r, E, n, f, o);
        var R = xs();
        return r.flags |= 1, typeof f == "object" && f !== null && typeof f.render == "function" && f.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, In(E) ? (R = !0, JE(r)) : R = !1, r.memoizedState = f.state !== null && f.state !== void 0 ? f.state : null, Wt(r), f.updater = ot, r.stateNode = f, f._reactInternals = r, Ei(r, E, n, o), r = of(null, r, E, !0, R, o)) : (r.tag = 0, Sn && R && QE(r), Lr(null, r, f, o), r = r.child), r;
      case 16:
        E = r.elementType;
        e: {
          switch (Ti(n, r), n = r.pendingProps, f = E._init, E = f(E._payload), r.type = E, f = r.tag = aE(E), n = ja(E, n), f) {
            case 0:
              r = rf(null, r, E, n, o);
              break e;
            case 1:
              r = af(null, r, E, n, o);
              break e;
            case 11:
              r = Vu(null, r, E, n, o);
              break e;
            case 14:
              r = nf(null, r, E, ja(E.type, n), o);
              break e;
          }
          throw Error(T(
            306,
            E,
            ""
          ));
        }
        return r;
      case 0:
        return E = r.type, f = r.pendingProps, f = r.elementType === E ? f : ja(E, f), rf(n, r, E, f, o);
      case 1:
        return E = r.type, f = r.pendingProps, f = r.elementType === E ? f : ja(E, f), af(n, r, E, f, o);
      case 3:
        e: {
          if (lf(r), n === null)
            throw Error(T(387));
          E = r.pendingProps, R = r.memoizedState, f = R.element, bn(n, r), nc(r, E, null, o);
          var C = r.memoizedState;
          if (E = C.element, R.isDehydrated)
            if (R = { element: E, isDehydrated: !1, cache: C.cache, pendingSuspenseBoundaries: C.pendingSuspenseBoundaries, transitions: C.transitions }, r.updateQueue.baseState = R, r.memoizedState = R, r.flags & 256) {
              f = Tr(Error(T(423)), r), r = GR(n, r, E, o, f);
              break e;
            } else if (E !== f) {
              f = Tr(Error(T(424)), r), r = GR(n, r, E, o, f);
              break e;
            } else
              for (ua = ui(r.stateNode.containerInfo.firstChild), ya = r, Sn = !0, Ka = null, o = ac(r, null, E, o), r.child = o; o; )
                o.flags = o.flags & -3 | 4096, o = o.sibling;
          else {
            if (yn(), E === f) {
              r = lo(n, r, o);
              break e;
            }
            Lr(n, r, E, o);
          }
          r = r.child;
        }
        return r;
      case 5:
        return ic(r), n === null && qE(r), E = r.type, f = r.pendingProps, R = n !== null ? n.memoizedProps : null, C = f.children, mu(E, f) ? C = null : R !== null && mu(E, R) && (r.flags |= 32), fc(n, r), Lr(n, r, C, o), r.child;
      case 6:
        return n === null && qE(r), null;
      case 13:
        return Rc(n, r, o);
      case 4:
        return Mu(r, r.stateNode.containerInfo), E = r.pendingProps, n === null ? r.child = Zo(r, null, E, o) : Lr(n, r, E, o), r.child;
      case 11:
        return E = r.type, f = r.pendingProps, f = r.elementType === E ? f : ja(E, f), Vu(n, r, E, f, o);
      case 7:
        return Lr(n, r, r.pendingProps, o), r.child;
      case 8:
        return Lr(n, r, r.pendingProps.children, o), r.child;
      case 12:
        return Lr(n, r, r.pendingProps.children, o), r.child;
      case 10:
        e: {
          if (E = r.type._context, f = r.pendingProps, R = r.memoizedProps, C = f.value, qt(zo, E._currentValue), E._currentValue = C, R !== null)
            if (Ya(R.value, C)) {
              if (R.children === f.children && !Mn.current) {
                r = lo(n, r, o);
                break e;
              }
            } else
              for (R = r.child, R !== null && (R.return = r); R !== null; ) {
                var P = R.dependencies;
                if (P !== null) {
                  C = R.child;
                  for (var b = P.firstContext; b !== null; ) {
                    if (b.context === E) {
                      if (R.tag === 1) {
                        b = lr(-1, o & -o), b.tag = 2;
                        var Z = R.updateQueue;
                        if (Z !== null) {
                          Z = Z.shared;
                          var Te = Z.pending;
                          Te === null ? b.next = b : (b.next = Te.next, Te.next = b), Z.pending = b;
                        }
                      }
                      R.lanes |= o, b = R.alternate, b !== null && (b.lanes |= o), jT(
                        R.return,
                        o,
                        r
                      ), P.lanes |= o;
                      break;
                    }
                    b = b.next;
                  }
                } else if (R.tag === 10)
                  C = R.type === r.type ? null : R.child;
                else if (R.tag === 18) {
                  if (C = R.return, C === null)
                    throw Error(T(341));
                  C.lanes |= o, P = C.alternate, P !== null && (P.lanes |= o), jT(C, o, r), C = R.sibling;
                } else
                  C = R.child;
                if (C !== null)
                  C.return = R;
                else
                  for (C = R; C !== null; ) {
                    if (C === r) {
                      C = null;
                      break;
                    }
                    if (R = C.sibling, R !== null) {
                      R.return = C.return, C = R;
                      break;
                    }
                    C = C.return;
                  }
                R = C;
              }
          Lr(n, r, f.children, o), r = r.child;
        }
        return r;
      case 9:
        return f = r.type, E = r.pendingProps.children, Pu(r, o), f = rn(f), E = E(f), r.flags |= 1, Lr(n, r, E, o), r.child;
      case 14:
        return E = r.type, f = ja(E, r.pendingProps), f = ja(E.type, f), nf(n, r, E, f, o);
      case 15:
        return UR(n, r, r.type, r.pendingProps, o);
      case 17:
        return E = r.type, f = r.pendingProps, f = r.elementType === E ? f : ja(E, f), Ti(n, r), r.tag = 1, In(E) ? (n = !0, JE(r)) : n = !1, Pu(r, o), no(r, E, f), Ei(r, E, f, o), of(null, r, E, !0, n, o);
      case 19:
        return Bs(n, r, o);
      case 22:
        return _R(n, r, o);
    }
    throw Error(T(156, r.tag));
  };
  function jR(n, r) {
    return fn(n, r);
  }
  function pN(n, r, o, E) {
    this.tag = n, this.key = o, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = E, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ma(n, r, o, E) {
    return new pN(n, r, o, E);
  }
  function kl(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function aE(n) {
    if (typeof n == "function")
      return kl(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === Rn)
        return 11;
      if (n === ce)
        return 14;
    }
    return 2;
  }
  function El(n, r) {
    var o = n.alternate;
    return o === null ? (o = Ma(n.tag, r, n.key, n.mode), o.elementType = n.elementType, o.type = n.type, o.stateNode = n.stateNode, o.alternate = n, n.alternate = o) : (o.pendingProps = r, o.type = n.type, o.flags = 0, o.subtreeFlags = 0, o.deletions = null), o.flags = n.flags & 14680064, o.childLanes = n.childLanes, o.lanes = n.lanes, o.child = n.child, o.memoizedProps = n.memoizedProps, o.memoizedState = n.memoizedState, o.updateQueue = n.updateQueue, r = n.dependencies, o.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, o.sibling = n.sibling, o.index = n.index, o.ref = n.ref, o;
  }
  function gc(n, r, o, E, f, R) {
    var C = 2;
    if (E = n, typeof n == "function")
      kl(n) && (C = 1);
    else if (typeof n == "string")
      C = 5;
    else
      e:
        switch (n) {
          case Xe:
            return Kl(o.children, f, R, r);
          case yt:
            C = 8, f |= 8;
            break;
          case ht:
            return n = Ma(12, o, r, f | 2), n.elementType = ht, n.lanes = R, n;
          case Se:
            return n = Ma(13, o, r, f), n.elementType = Se, n.lanes = R, n;
          case le:
            return n = Ma(19, o, r, f), n.elementType = le, n.lanes = R, n;
          case ee:
            return jl(o, f, R, r);
          default:
            if (typeof n == "object" && n !== null)
              switch (n.$$typeof) {
                case Qe:
                  C = 10;
                  break e;
                case gt:
                  C = 9;
                  break e;
                case Rn:
                  C = 11;
                  break e;
                case ce:
                  C = 14;
                  break e;
                case ve:
                  C = 16, E = null;
                  break e;
              }
            throw Error(T(130, n == null ? n : typeof n, ""));
        }
    return r = Ma(C, o, r, f), r.elementType = n, r.type = E, r.lanes = R, r;
  }
  function Kl(n, r, o, E) {
    return n = Ma(7, n, E, r), n.lanes = o, n;
  }
  function jl(n, r, o, E) {
    return n = Ma(22, n, E, r), n.elementType = ee, n.lanes = o, n.stateNode = { isHidden: !1 }, n;
  }
  function hf(n, r, o) {
    return n = Ma(6, n, null, r), n.lanes = o, n;
  }
  function Pc(n, r, o) {
    return r = Ma(4, n.children !== null ? n.children : [], n.key, r), r.lanes = o, r.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, r;
  }
  function ON(n, r, o, E, f) {
    this.tag = r, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Ts(0), this.expirationTimes = Ts(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ts(0), this.identifierPrefix = E, this.onRecoverableError = f, this.mutableSourceEagerHydrationData = null;
  }
  function Mc(n, r, o, E, f, R, C, P, b) {
    return n = new ON(n, r, o, P, b), r === 1 ? (r = 1, R === !0 && (r |= 8)) : r = 0, R = Ma(3, null, null, r), n.current = R, R.stateNode = n, R.memoizedState = { element: E, isDehydrated: o, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Wt(R), n;
  }
  function zR(n, r, o) {
    var E = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: je, key: E == null ? null : "" + E, children: n, containerInfo: r, implementation: o };
  }
  function JR(n) {
    if (!n)
      return Mi;
    n = n._reactInternals;
    e: {
      if (dt(n) !== n || n.tag !== 1)
        throw Error(T(170));
      var r = n;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (In(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(T(171));
    }
    if (n.tag === 1) {
      var o = n.type;
      if (In(o))
        return Du(n, o, r);
    }
    return r;
  }
  function QR(n, r, o, E, f, R, C, P, b) {
    return n = Mc(o, E, !0, n, f, R, C, P, b), n.context = JR(null), o = n.current, E = Br(), f = co(o), R = lr(E, f), R.callback = r ?? null, to(o, R, f), n.current.lanes = f, ki(n, f, E), fa(n, E), n;
  }
  function Uc(n, r, o, E) {
    var f = r.current, R = Br(), C = co(f);
    return o = JR(o), r.context === null ? r.context = o : r.pendingContext = o, r = lr(R, C), r.payload = { element: n }, E = E === void 0 ? null : E, E !== null && (r.callback = E), n = to(f, r, C), n !== null && (Ai(n, f, C, R), tc(n, f, C)), C;
  }
  function _c(n) {
    if (n = n.current, !n.child)
      return null;
    switch (n.child.tag) {
      case 5:
        return n.child.stateNode;
      default:
        return n.child.stateNode;
    }
  }
  function ZR(n, r) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var o = n.retryLane;
      n.retryLane = o !== 0 && o < r ? o : r;
    }
  }
  function vf(n, r) {
    ZR(n, r), (n = n.alternate) && ZR(n, r);
  }
  function IN() {
    return null;
  }
  var qR = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function mf(n) {
    this._internalRoot = n;
  }
  Gc.prototype.render = mf.prototype.render = function(n) {
    var r = this._internalRoot;
    if (r === null)
      throw Error(T(409));
    Uc(n, r, null, null);
  }, Gc.prototype.unmount = mf.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var r = n.containerInfo;
      Ri(function() {
        Uc(null, n, null, null);
      }), r[$i] = null;
    }
  };
  function Gc(n) {
    this._internalRoot = n;
  }
  Gc.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var r = Rs();
      n = { blockedOn: null, target: n, priority: r };
      for (var o = 0; o < Zt.length && r !== 0 && r < Zt[o].priority; o++)
        ;
      Zt.splice(o, 0, n), o === 0 && bE(n);
    }
  };
  function Fr(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function cl(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function Lf() {
  }
  function CN(n, r, o, E, f) {
    if (f) {
      if (typeof E == "function") {
        var R = E;
        E = function() {
          var Z = _c(C);
          R.call(Z);
        };
      }
      var C = QR(r, E, n, 0, null, !1, !1, "", Lf);
      return n._reactRootContainer = C, n[$i] = C.current, ms(n.nodeType === 8 ? n.parentNode : n), Ri(), C;
    }
    for (; f = n.lastChild; )
      n.removeChild(f);
    if (typeof E == "function") {
      var P = E;
      E = function() {
        var Z = _c(b);
        P.call(Z);
      };
    }
    var b = Mc(n, 0, !1, null, null, !1, !1, "", Lf);
    return n._reactRootContainer = b, n[$i] = b.current, ms(n.nodeType === 8 ? n.parentNode : n), Ri(function() {
      Uc(r, b, o, E);
    }), b;
  }
  function iE(n, r, o, E, f) {
    var R = o._reactRootContainer;
    if (R) {
      var C = R;
      if (typeof f == "function") {
        var P = f;
        f = function() {
          var b = _c(C);
          P.call(b);
        };
      }
      Uc(r, C, n, f);
    } else
      C = CN(o, r, n, f, E);
    return _c(C);
  }
  vl = function(n) {
    switch (n.tag) {
      case 3:
        var r = n.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var o = ai(r.pendingLanes);
          o !== 0 && (Di(r, o | 1), fa(r, Ht()), !(wt & 6) && (Vs = Ht() + 500, oa()));
        }
        break;
      case 13:
        Ri(function() {
          var E = ze(n, 1);
          if (E !== null) {
            var f = Br();
            Ai(E, n, 1, f);
          }
        }), vf(n, 1);
    }
  }, As = function(n) {
    if (n.tag === 13) {
      var r = ze(n, 134217728);
      if (r !== null) {
        var o = Br();
        Ai(r, n, 134217728, o);
      }
      vf(n, 134217728);
    }
  }, Bt = function(n) {
    if (n.tag === 13) {
      var r = co(n), o = ze(n, r);
      if (o !== null) {
        var E = Br();
        Ai(o, n, r, E);
      }
      vf(n, r);
    }
  }, Rs = function() {
    return Vt;
  }, ds = function(n, r) {
    var o = Vt;
    try {
      return Vt = n, r();
    } finally {
      Vt = o;
    }
  }, Mr = function(n, r, o) {
    switch (r) {
      case "input":
        if (Gn(n, o), r = o.name, o.type === "radio" && r != null) {
          for (o = n; o.parentNode; )
            o = o.parentNode;
          for (o = o.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < o.length; r++) {
            var E = o[r];
            if (E !== n && E.form === n.form) {
              var f = qe(E);
              if (!f)
                throw Error(T(90));
              Jn(E), Gn(E, f);
            }
          }
        }
        break;
      case "textarea":
        Oa(n, o);
        break;
      case "select":
        r = o.value, r != null && Ir(n, !!o.multiple, r, !1);
    }
  }, hl = nE, ls = Ri;
  var hN = { usingClientEntryPoint: !1, Events: [yu, Ls, qe, Ba, Do, nE] }, oE = { findFiberByHostInstance: Va, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, vN = { bundleType: oE.bundleType, version: oE.version, rendererPackageName: oE.rendererPackageName, rendererConfig: oE.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Fe.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = Vn(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: oE.findFiberByHostInstance || IN, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof { isDisabled: !0 } < "u") {
    var lE = { isDisabled: !0 };
    if (!lE.isDisabled && lE.supportsFiber)
      try {
        Mo = lE.inject(vN), ta = lE;
      } catch {
      }
  }
  return ei.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = hN, ei.createPortal = function(n, r) {
    var o = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Fr(r))
      throw Error(T(200));
    return zR(n, r, null, o);
  }, ei.createRoot = function(n, r) {
    if (!Fr(n))
      throw Error(T(299));
    var o = !1, E = "", f = qR;
    return r != null && (r.unstable_strictMode === !0 && (o = !0), r.identifierPrefix !== void 0 && (E = r.identifierPrefix), r.onRecoverableError !== void 0 && (f = r.onRecoverableError)), r = Mc(n, 1, !1, null, null, o, !1, E, f), n[$i] = r.current, ms(n.nodeType === 8 ? n.parentNode : n), new mf(r);
  }, ei.findDOMNode = function(n) {
    if (n == null)
      return null;
    if (n.nodeType === 1)
      return n;
    var r = n._reactInternals;
    if (r === void 0)
      throw typeof n.render == "function" ? Error(T(188)) : (n = Object.keys(n).join(","), Error(T(268, n)));
    return n = Vn(r), n = n === null ? null : n.stateNode, n;
  }, ei.flushSync = function(n) {
    return Ri(n);
  }, ei.hydrate = function(n, r, o) {
    if (!cl(r))
      throw Error(T(200));
    return iE(null, n, r, !0, o);
  }, ei.hydrateRoot = function(n, r, o) {
    if (!Fr(n))
      throw Error(T(405));
    var E = o != null && o.hydratedSources || null, f = !1, R = "", C = qR;
    if (o != null && (o.unstable_strictMode === !0 && (f = !0), o.identifierPrefix !== void 0 && (R = o.identifierPrefix), o.onRecoverableError !== void 0 && (C = o.onRecoverableError)), r = QR(r, null, n, 1, o ?? null, f, !1, R, C), n[$i] = r.current, ms(n), E)
      for (n = 0; n < E.length; n++)
        o = E[n], f = o._getVersion, f = f(o._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [o, f] : r.mutableSourceEagerHydrationData.push(
          o,
          f
        );
    return new Gc(r);
  }, ei.render = function(n, r, o) {
    if (!cl(r))
      throw Error(T(200));
    return iE(null, n, r, !1, o);
  }, ei.unmountComponentAtNode = function(n) {
    if (!cl(n))
      throw Error(T(40));
    return n._reactRootContainer ? (Ri(function() {
      iE(null, null, n, !1, function() {
        n._reactRootContainer = null, n[$i] = null;
      });
    }), !0) : !1;
  }, ei.unstable_batchedUpdates = nE, ei.unstable_renderSubtreeIntoContainer = function(n, r, o, E) {
    if (!cl(o))
      throw Error(T(200));
    if (n == null || n._reactInternals === void 0)
      throw Error(T(38));
    return iE(n, r, o, !1, E);
  }, ei.version = "18.2.0-next-9e3b772b8-20220608", ei;
}
var ti = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nm;
function FU() {
  return Nm || (Nm = 1, process.env.NODE_ENV !== "production" && function() {
    typeof { isDisabled: !0 } < "u" && typeof { isDisabled: !0 }.registerInternalModuleStart == "function" && { isDisabled: !0 }.registerInternalModuleStart(new Error());
    var l = GA(), u = rL(), T = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, N = !1;
    function O(e) {
      N = e;
    }
    function h(e) {
      if (!N) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        G("warn", e, a);
      }
    }
    function d(e) {
      if (!N) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        G("error", e, a);
      }
    }
    function G(e, t, a) {
      {
        var i = T.ReactDebugCurrentFrame, s = i.getStackAddendum();
        s !== "" && (t += "%s", a = a.concat([s]));
        var c = a.map(function(A) {
          return String(A);
        });
        c.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, c);
      }
    }
    var D = 0, v = 1, M = 2, g = 3, w = 4, Y = 5, j = 6, oe = 7, me = 8, Le = 9, Oe = 10, he = 11, Fe = 12, ye = 13, je = 14, Xe = 15, yt = 16, ht = 17, Qe = 18, gt = 19, Rn = 21, Se = 22, le = 23, ce = 24, ve = 25, ee = !0, te = !1, Ae = !1, U = !1, q = !1, Ie = !0, Ye = !1, We = !1, vt = !0, ut = !0, Ot = !0, lt = /* @__PURE__ */ new Set(), At = {}, Cn = {};
    function gn(e, t) {
      Jn(e, t), Jn(e + "Capture", t);
    }
    function Jn(e, t) {
      At[e] && d("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), At[e] = t;
      {
        var a = e.toLowerCase();
        Cn[a] = e, e === "onDoubleClick" && (Cn.ondblclick = e);
      }
      for (var i = 0; i < t.length; i++)
        lt.add(t[i]);
    }
    var hn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", nr = Object.prototype.hasOwnProperty;
    function Qn(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, a = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function Zn(e) {
      try {
        return Gn(e), !1;
      } catch {
        return !0;
      }
    }
    function Gn(e) {
      return "" + e;
    }
    function Zr(e, t) {
      if (Zn(e))
        return d("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Qn(e)), Gn(e);
    }
    function qr(e) {
      if (Zn(e))
        return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qn(e)), Gn(e);
    }
    function rr(e, t) {
      if (Zn(e))
        return d("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Qn(e)), Gn(e);
    }
    function Ir(e, t) {
      if (Zn(e))
        return d("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Qn(e)), Gn(e);
    }
    function $r(e) {
      if (Zn(e))
        return d("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Qn(e)), Gn(e);
    }
    function Cr(e) {
      if (Zn(e))
        return d("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Qn(e)), Gn(e);
    }
    var Oa = 0, ur = 1, ea = 2, vn = 3, Pr = 4, Ci = 5, Ia = 6, De = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Ze = De + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", mt = new RegExp("^[" + De + "][" + Ze + "]*$"), Kt = {}, zt = {};
    function xn(e) {
      return nr.call(zt, e) ? !0 : nr.call(Kt, e) ? !1 : mt.test(e) ? (zt[e] = !0, !0) : (Kt[e] = !0, d("Invalid attribute name: `%s`", e), !1);
    }
    function mn(e, t, a) {
      return t !== null ? t.type === Oa : a ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function hr(e, t, a, i) {
      if (a !== null && a.type === Oa)
        return !1;
      switch (typeof t) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (i)
            return !1;
          if (a !== null)
            return !a.acceptsBooleans;
          var s = e.toLowerCase().slice(0, 5);
          return s !== "data-" && s !== "aria-";
        }
        default:
          return !1;
      }
    }
    function tn(e, t, a, i) {
      if (t === null || typeof t > "u" || hr(e, t, a, i))
        return !0;
      if (i)
        return !1;
      if (a !== null)
        switch (a.type) {
          case vn:
            return !t;
          case Pr:
            return t === !1;
          case Ci:
            return isNaN(t);
          case Ia:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function Mr(e) {
      return Qt.hasOwnProperty(e) ? Qt[e] : null;
    }
    function Jt(e, t, a, i, s, c, A) {
      this.acceptsBooleans = t === ea || t === vn || t === Pr, this.attributeName = i, this.attributeNamespace = s, this.mustUseProperty = a, this.propertyName = e, this.type = t, this.sanitizeURL = c, this.removeEmptyString = A;
    }
    var Qt = {}, ni = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    ni.forEach(function(e) {
      Qt[e] = new Jt(
        e,
        Oa,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], a = e[1];
      Qt[t] = new Jt(
        t,
        ur,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        ea,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        ea,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        vn,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        vn,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        Pr,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        Ia,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        Ci,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Ba = /[\-\:]([a-z])/g, Do = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Ba, Do);
      Qt[t] = new Jt(
        t,
        ur,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Ba, Do);
      Qt[t] = new Jt(
        t,
        ur,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Ba, Do);
      Qt[t] = new Jt(
        t,
        ur,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        ur,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var hl = "xlinkHref";
    Qt[hl] = new Jt(
      "xlinkHref",
      ur,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      Qt[e] = new Jt(
        e,
        ur,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var ls = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Xi = !1;
    function go(e) {
      !Xi && ls.test(e) && (Xi = !0, d("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function Ca(e, t, a, i) {
      if (i.mustUseProperty) {
        var s = i.propertyName;
        return e[s];
      } else {
        Zr(a, t), i.sanitizeURL && go("" + a);
        var c = i.attributeName, A = null;
        if (i.type === Pr) {
          if (e.hasAttribute(c)) {
            var S = e.getAttribute(c);
            return S === "" ? !0 : tn(t, a, i, !1) ? S : S === "" + a ? a : S;
          }
        } else if (e.hasAttribute(c)) {
          if (tn(t, a, i, !1))
            return e.getAttribute(c);
          if (i.type === vn)
            return a;
          A = e.getAttribute(c);
        }
        return tn(t, a, i, !1) ? A === null ? a : A : A === "" + a ? a : A;
      }
    }
    function hi(e, t, a, i) {
      {
        if (!xn(t))
          return;
        if (!e.hasAttribute(t))
          return a === void 0 ? void 0 : null;
        var s = e.getAttribute(t);
        return Zr(a, t), s === "" + a ? a : s;
      }
    }
    function ha(e, t, a, i) {
      var s = Mr(t);
      if (!mn(t, s, i)) {
        if (tn(t, a, s, i) && (a = null), i || s === null) {
          if (xn(t)) {
            var c = t;
            a === null ? e.removeAttribute(c) : (Zr(a, t), e.setAttribute(c, "" + a));
          }
          return;
        }
        var A = s.mustUseProperty;
        if (A) {
          var S = s.propertyName;
          if (a === null) {
            var p = s.type;
            e[S] = p === vn ? !1 : "";
          } else
            e[S] = a;
          return;
        }
        var L = s.attributeName, y = s.attributeNamespace;
        if (a === null)
          e.removeAttribute(L);
        else {
          var F = s.type, H;
          F === vn || F === Pr && a === !0 ? H = "" : (Zr(a, L), H = "" + a, s.sanitizeURL && go(H.toString())), y ? e.setAttributeNS(y, L, H) : e.setAttribute(L, H);
        }
      }
    }
    var vi = Symbol.for("react.element"), Ur = Symbol.for("react.portal"), va = Symbol.for("react.fragment"), mi = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), Ee = Symbol.for("react.provider"), ge = Symbol.for("react.context"), be = Symbol.for("react.forward_ref"), dt = Symbol.for("react.suspense"), _t = Symbol.for("react.suspense_list"), It = Symbol.for("react.memo"), et = Symbol.for("react.lazy"), Vn = Symbol.for("react.scope"), Tn = Symbol.for("react.debug_trace_mode"), fn = Symbol.for("react.offscreen"), Er = Symbol.for("react.legacy_hidden"), Li = Symbol.for("react.cache"), ss = Symbol.for("react.tracing_marker"), Ht = Symbol.iterator, fT = "@@iterator";
    function ri(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Ht && e[Ht] || e[fT];
      return typeof t == "function" ? t : null;
    }
    var Dt = Object.assign, yi = 0, Po, us, Mo, ta, Eu, _r, cu;
    function Tu() {
    }
    Tu.__reactDisabledLog = !0;
    function GE() {
      {
        if (yi === 0) {
          Po = console.log, us = console.info, Mo = console.warn, ta = console.error, Eu = console.group, _r = console.groupCollapsed, cu = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Tu,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        yi++;
      }
    }
    function Es() {
      {
        if (yi--, yi === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Dt({}, e, {
              value: Po
            }),
            info: Dt({}, e, {
              value: us
            }),
            warn: Dt({}, e, {
              value: Mo
            }),
            error: Dt({}, e, {
              value: ta
            }),
            group: Dt({}, e, {
              value: Eu
            }),
            groupCollapsed: Dt({}, e, {
              value: _r
            }),
            groupEnd: Dt({}, e, {
              value: cu
            })
          });
        }
        yi < 0 && d("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Uo = T.ReactCurrentDispatcher, ai;
    function Gr(e, t, a) {
      {
        if (ai === void 0)
          try {
            throw Error();
          } catch (s) {
            var i = s.stack.trim().match(/\n( *(at )?)/);
            ai = i && i[1] || "";
          }
        return `
` + ai + e;
      }
    }
    var _o = !1, Go;
    {
      var xo = typeof WeakMap == "function" ? WeakMap : Map;
      Go = new xo();
    }
    function cs(e, t) {
      if (!e || _o)
        return "";
      {
        var a = Go.get(e);
        if (a !== void 0)
          return a;
      }
      var i;
      _o = !0;
      var s = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = Uo.current, Uo.current = null, GE();
      try {
        if (t) {
          var A = function() {
            throw Error();
          };
          if (Object.defineProperty(A.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(A, []);
            } catch (Q) {
              i = Q;
            }
            Reflect.construct(e, [], A);
          } else {
            try {
              A.call();
            } catch (Q) {
              i = Q;
            }
            e.call(A.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            i = Q;
          }
          e();
        }
      } catch (Q) {
        if (Q && i && typeof Q.stack == "string") {
          for (var S = Q.stack.split(`
`), p = i.stack.split(`
`), L = S.length - 1, y = p.length - 1; L >= 1 && y >= 0 && S[L] !== p[y]; )
            y--;
          for (; L >= 1 && y >= 0; L--, y--)
            if (S[L] !== p[y]) {
              if (L !== 1 || y !== 1)
                do
                  if (L--, y--, y < 0 || S[L] !== p[y]) {
                    var F = `
` + S[L].replace(" at new ", " at ");
                    return e.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", e.displayName)), typeof e == "function" && Go.set(e, F), F;
                  }
                while (L >= 1 && y >= 0);
              break;
            }
        }
      } finally {
        _o = !1, Uo.current = c, Es(), Error.prepareStackTrace = s;
      }
      var H = e ? e.displayName || e.name : "", z = H ? Gr(H) : "";
      return typeof e == "function" && Go.set(e, z), z;
    }
    function Ts(e, t, a) {
      return cs(e, !0);
    }
    function ki(e, t, a) {
      return cs(e, !1);
    }
    function AT(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function Di(e, t, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return cs(e, AT(e));
      if (typeof e == "string")
        return Gr(e);
      switch (e) {
        case dt:
          return Gr("Suspense");
        case _t:
          return Gr("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case be:
            return ki(e.render);
          case It:
            return Di(e.type, t, a);
          case et: {
            var i = e, s = i._payload, c = i._init;
            try {
              return Di(c(s), t, a);
            } catch {
            }
          }
        }
      return "";
    }
    function Vt(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case Y:
          return Gr(e.type);
        case yt:
          return Gr("Lazy");
        case ye:
          return Gr("Suspense");
        case gt:
          return Gr("SuspenseList");
        case D:
        case M:
        case Xe:
          return ki(e.type);
        case he:
          return ki(e.type.render);
        case v:
          return Ts(e.type);
        default:
          return "";
      }
    }
    function fs(e) {
      try {
        var t = "", a = e;
        do
          t += Vt(a), a = a.return;
        while (a);
        return t;
      } catch (i) {
        return `
Error generating stack: ` + i.message + `
` + i.stack;
      }
    }
    function vl(e, t, a) {
      var i = e.displayName;
      if (i)
        return i;
      var s = t.displayName || t.name || "";
      return s !== "" ? a + "(" + s + ")" : a;
    }
    function As(e) {
      return e.displayName || "Context";
    }
    function Bt(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case va:
          return "Fragment";
        case Ur:
          return "Portal";
        case x:
          return "Profiler";
        case mi:
          return "StrictMode";
        case dt:
          return "Suspense";
        case _t:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case ge:
            var t = e;
            return As(t) + ".Consumer";
          case Ee:
            var a = e;
            return As(a._context) + ".Provider";
          case be:
            return vl(e, e.render, "ForwardRef");
          case It:
            var i = e.displayName || null;
            return i !== null ? i : Bt(e.type) || "Memo";
          case et: {
            var s = e, c = s._payload, A = s._init;
            try {
              return Bt(A(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Rs(e, t, a) {
      var i = t.displayName || t.name || "";
      return e.displayName || (i !== "" ? a + "(" + i + ")" : a);
    }
    function ds(e) {
      return e.displayName || "Context";
    }
    function ct(e) {
      var t = e.tag, a = e.type;
      switch (t) {
        case ce:
          return "Cache";
        case Le:
          var i = a;
          return ds(i) + ".Consumer";
        case Oe:
          var s = a;
          return ds(s._context) + ".Provider";
        case Qe:
          return "DehydratedFragment";
        case he:
          return Rs(a, a.render, "ForwardRef");
        case oe:
          return "Fragment";
        case Y:
          return a;
        case w:
          return "Portal";
        case g:
          return "Root";
        case j:
          return "Text";
        case yt:
          return Bt(a);
        case me:
          return a === mi ? "StrictMode" : "Mode";
        case Se:
          return "Offscreen";
        case Fe:
          return "Profiler";
        case Rn:
          return "Scope";
        case ye:
          return "Suspense";
        case gt:
          return "SuspenseList";
        case ve:
          return "TracingMarker";
        case v:
        case D:
        case ht:
        case M:
        case je:
        case Xe:
          if (typeof a == "function")
            return a.displayName || a.name || null;
          if (typeof a == "string")
            return a;
          break;
      }
      return null;
    }
    var ml = T.ReactDebugCurrentFrame, Ln = null, na = !1;
    function xr() {
      {
        if (Ln === null)
          return null;
        var e = Ln._debugOwner;
        if (e !== null && typeof e < "u")
          return ct(e);
      }
      return null;
    }
    function bo() {
      return Ln === null ? "" : fs(Ln);
    }
    function Pn() {
      ml.getCurrentStack = null, Ln = null, na = !1;
    }
    function Zt(e) {
      ml.getCurrentStack = e === null ? null : bo, Ln = e, na = !1;
    }
    function xE() {
      return Ln;
    }
    function ra(e) {
      na = e;
    }
    function ar(e) {
      return "" + e;
    }
    function gi(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return Cr(e), e;
        default:
          return "";
      }
    }
    var bE = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ki(e, t) {
      bE[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || d("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || d("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Ho(e) {
      var t = e.type, a = e.nodeName;
      return a && a.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function HE(e) {
      return e._valueTracker;
    }
    function Fa(e) {
      e._valueTracker = null;
    }
    function Bo(e) {
      var t = "";
      return e && (Ho(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function Fo(e) {
      var t = Ho(e) ? "checked" : "value", a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      Cr(e[t]);
      var i = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof a > "u" || typeof a.get != "function" || typeof a.set != "function")) {
        var s = a.get, c = a.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return s.call(this);
          },
          set: function(S) {
            Cr(S), i = "" + S, c.call(this, S);
          }
        }), Object.defineProperty(e, t, {
          enumerable: a.enumerable
        });
        var A = {
          getValue: function() {
            return i;
          },
          setValue: function(S) {
            Cr(S), i = "" + S;
          },
          stopTracking: function() {
            Fa(e), delete e[t];
          }
        };
        return A;
      }
    }
    function wa(e) {
      HE(e) || (e._valueTracker = Fo(e));
    }
    function Ss(e) {
      if (!e)
        return !1;
      var t = HE(e);
      if (!t)
        return !0;
      var a = t.getValue(), i = Bo(e);
      return i !== a ? (t.setValue(i), !0) : !1;
    }
    function wo(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var Yo = !1, Ll = !1, Ns = !1, fu = !1;
    function ii(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function I(e, t) {
      var a = e, i = t.checked, s = Dt({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: i ?? a._wrapperState.initialChecked
      });
      return s;
    }
    function _(e, t) {
      Ki("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !Ll && (d("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", xr() || "A component", t.type), Ll = !0), t.value !== void 0 && t.defaultValue !== void 0 && !Yo && (d("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", xr() || "A component", t.type), Yo = !0);
      var a = e, i = t.defaultValue == null ? "" : t.defaultValue;
      a._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: gi(t.value != null ? t.value : i),
        controlled: ii(t)
      };
    }
    function J(e, t) {
      var a = e, i = t.checked;
      i != null && ha(a, "checked", i, !1);
    }
    function $(e, t) {
      var a = e;
      {
        var i = ii(t);
        !a._wrapperState.controlled && i && !fu && (d("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), fu = !0), a._wrapperState.controlled && !i && !Ns && (d("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Ns = !0);
      }
      J(e, t);
      var s = gi(t.value), c = t.type;
      if (s != null)
        c === "number" ? (s === 0 && a.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        a.value != s) && (a.value = ar(s)) : a.value !== ar(s) && (a.value = ar(s));
      else if (c === "submit" || c === "reset") {
        a.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? nt(a, t.type, s) : t.hasOwnProperty("defaultValue") && nt(a, t.type, gi(t.defaultValue)), t.checked == null && t.defaultChecked != null && (a.defaultChecked = !!t.defaultChecked);
    }
    function Ce(e, t, a) {
      var i = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var s = t.type, c = s === "submit" || s === "reset";
        if (c && (t.value === void 0 || t.value === null))
          return;
        var A = ar(i._wrapperState.initialValue);
        a || A !== i.value && (i.value = A), i.defaultValue = A;
      }
      var S = i.name;
      S !== "" && (i.name = ""), i.defaultChecked = !i.defaultChecked, i.defaultChecked = !!i._wrapperState.initialChecked, S !== "" && (i.name = S);
    }
    function at(e, t) {
      var a = e;
      $(a, t), Me(a, t);
    }
    function Me(e, t) {
      var a = t.name;
      if (t.type === "radio" && a != null) {
        for (var i = e; i.parentNode; )
          i = i.parentNode;
        Zr(a, "name");
        for (var s = i.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), c = 0; c < s.length; c++) {
          var A = s[c];
          if (!(A === e || A.form !== e.form)) {
            var S = Ad(A);
            if (!S)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Ss(A), $(A, S);
          }
        }
      }
    }
    function nt(e, t, a) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (t !== "number" || wo(e.ownerDocument) !== e) && (a == null ? e.defaultValue = ar(e._wrapperState.initialValue) : e.defaultValue !== ar(a) && (e.defaultValue = ar(a)));
    }
    var Lt = !1, Ft = !1, sn = !1;
    function nn(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? l.Children.forEach(t.children, function(a) {
        a != null && (typeof a == "string" || typeof a == "number" || Ft || (Ft = !0, d("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (sn || (sn = !0, d("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !Lt && (d("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Lt = !0);
    }
    function un(e, t) {
      t.value != null && e.setAttribute("value", ar(gi(t.value)));
    }
    var An = Array.isArray;
    function Ut(e) {
      return An(e);
    }
    var ji;
    ji = !1;
    function ps() {
      var e = xr();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var Au = ["value", "defaultValue"];
    function RT(e) {
      {
        Ki("select", e);
        for (var t = 0; t < Au.length; t++) {
          var a = Au[t];
          if (e[a] != null) {
            var i = Ut(e[a]);
            e.multiple && !i ? d("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", a, ps()) : !e.multiple && i && d("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", a, ps());
          }
        }
      }
    }
    function oi(e, t, a, i) {
      var s = e.options;
      if (t) {
        for (var c = a, A = {}, S = 0; S < c.length; S++)
          A["$" + c[S]] = !0;
        for (var p = 0; p < s.length; p++) {
          var L = A.hasOwnProperty("$" + s[p].value);
          s[p].selected !== L && (s[p].selected = L), L && i && (s[p].defaultSelected = !0);
        }
      } else {
        for (var y = ar(gi(a)), F = null, H = 0; H < s.length; H++) {
          if (s[H].value === y) {
            s[H].selected = !0, i && (s[H].defaultSelected = !0);
            return;
          }
          F === null && !s[H].disabled && (F = s[H]);
        }
        F !== null && (F.selected = !0);
      }
    }
    function Ru(e, t) {
      return Dt({}, t, {
        value: void 0
      });
    }
    function du(e, t) {
      var a = e;
      RT(t), a._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !ji && (d("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), ji = !0);
    }
    function dT(e, t) {
      var a = e;
      a.multiple = !!t.multiple;
      var i = t.value;
      i != null ? oi(a, !!t.multiple, i, !1) : t.defaultValue != null && oi(a, !!t.multiple, t.defaultValue, !0);
    }
    function kS(e, t) {
      var a = e, i = a._wrapperState.wasMultiple;
      a._wrapperState.wasMultiple = !!t.multiple;
      var s = t.value;
      s != null ? oi(a, !!t.multiple, s, !1) : i !== !!t.multiple && (t.defaultValue != null ? oi(a, !!t.multiple, t.defaultValue, !0) : oi(a, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function KS(e, t) {
      var a = e, i = t.value;
      i != null && oi(a, !!t.multiple, i, !1);
    }
    var ST = !1;
    function NT(e, t) {
      var a = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var i = Dt({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: ar(a._wrapperState.initialValue)
      });
      return i;
    }
    function YA(e, t) {
      var a = e;
      Ki("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !ST && (d("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", xr() || "A component"), ST = !0);
      var i = t.value;
      if (i == null) {
        var s = t.children, c = t.defaultValue;
        if (s != null) {
          d("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (c != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Ut(s)) {
              if (s.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              s = s[0];
            }
            c = s;
          }
        }
        c == null && (c = ""), i = c;
      }
      a._wrapperState = {
        initialValue: gi(i)
      };
    }
    function VA(e, t) {
      var a = e, i = gi(t.value), s = gi(t.defaultValue);
      if (i != null) {
        var c = ar(i);
        c !== a.value && (a.value = c), t.defaultValue == null && a.defaultValue !== c && (a.defaultValue = c);
      }
      s != null && (a.defaultValue = ar(s));
    }
    function WA(e, t) {
      var a = e, i = a.textContent;
      i === a._wrapperState.initialValue && i !== "" && i !== null && (a.value = i);
    }
    function pT(e, t) {
      VA(e, t);
    }
    var zi = "http://www.w3.org/1999/xhtml", jS = "http://www.w3.org/1998/Math/MathML", OT = "http://www.w3.org/2000/svg";
    function BE(e) {
      switch (e) {
        case "svg":
          return OT;
        case "math":
          return jS;
        default:
          return zi;
      }
    }
    function IT(e, t) {
      return e == null || e === zi ? BE(t) : e === OT && t === "foreignObject" ? zi : e;
    }
    var zS = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, a, i, s) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, a, i, s);
        });
      } : e;
    }, FE, XA = zS(function(e, t) {
      if (e.namespaceURI === OT && !("innerHTML" in e)) {
        FE = FE || document.createElement("div"), FE.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var a = FE.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; a.firstChild; )
          e.appendChild(a.firstChild);
        return;
      }
      e.innerHTML = t;
    }), aa = 1, Ji = 3, Wn = 8, li = 9, yl = 11, wE = function(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === Ji) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, kA = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Os = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function KA(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var jA = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Os).forEach(function(e) {
      jA.forEach(function(t) {
        Os[KA(t, e)] = Os[e];
      });
    });
    function YE(e, t, a) {
      var i = t == null || typeof t == "boolean" || t === "";
      return i ? "" : !a && typeof t == "number" && t !== 0 && !(Os.hasOwnProperty(e) && Os[e]) ? t + "px" : (Ir(t, e), ("" + t).trim());
    }
    var Is = /([A-Z])/g, JS = /^ms-/;
    function QS(e) {
      return e.replace(Is, "-$1").toLowerCase().replace(JS, "-ms-");
    }
    var zA = function() {
    };
    {
      var JA = /^(?:webkit|moz|o)[A-Z]/, QA = /^-ms-/, Su = /-(.)/g, Cs = /;\s*$/, hs = {}, vs = {}, ZA = !1, CT = !1, hT = function(e) {
        return e.replace(Su, function(t, a) {
          return a.toUpperCase();
        });
      }, vT = function(e) {
        hs.hasOwnProperty(e) && hs[e] || (hs[e] = !0, d(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          hT(e.replace(QA, "ms-"))
        ));
      }, qA = function(e) {
        hs.hasOwnProperty(e) && hs[e] || (hs[e] = !0, d("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, $A = function(e, t) {
        vs.hasOwnProperty(t) && vs[t] || (vs[t] = !0, d(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(Cs, "")));
      }, eR = function(e, t) {
        ZA || (ZA = !0, d("`NaN` is an invalid value for the `%s` css style property.", e));
      }, ZS = function(e, t) {
        CT || (CT = !0, d("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      zA = function(e, t) {
        e.indexOf("-") > -1 ? vT(e) : JA.test(e) ? qA(e) : Cs.test(t) && $A(e, t), typeof t == "number" && (isNaN(t) ? eR(e, t) : isFinite(t) || ZS(e, t));
      };
    }
    var qS = zA;
    function $S(e) {
      {
        var t = "", a = "";
        for (var i in e)
          if (e.hasOwnProperty(i)) {
            var s = e[i];
            if (s != null) {
              var c = i.indexOf("--") === 0;
              t += a + (c ? i : QS(i)) + ":", t += YE(i, s, c), a = ";";
            }
          }
        return t || null;
      }
    }
    function tR(e, t) {
      var a = e.style;
      for (var i in t)
        if (t.hasOwnProperty(i)) {
          var s = i.indexOf("--") === 0;
          s || qS(i, t[i]);
          var c = YE(i, t[i], s);
          i === "float" && (i = "cssFloat"), s ? a.setProperty(i, c) : a[i] = c;
        }
    }
    function eN(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function Ya(e) {
      var t = {};
      for (var a in e)
        for (var i = kA[a] || [a], s = 0; s < i.length; s++)
          t[i[s]] = a;
      return t;
    }
    function Nu(e, t) {
      {
        if (!t)
          return;
        var a = Ya(e), i = Ya(t), s = {};
        for (var c in a) {
          var A = a[c], S = i[c];
          if (S && A !== S) {
            var p = A + "," + S;
            if (s[p])
              continue;
            s[p] = !0, d("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", eN(e[A]) ? "Removing" : "Updating", A, S);
          }
        }
      }
    }
    var nR = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, rR = Dt({
      menuitem: !0
    }, nR), aR = "__html";
    function VE(e, t) {
      if (t) {
        if (rR[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(aR in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && d("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Qi(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var WE = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, iR = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, si = {}, mT = new RegExp("^(aria)-[" + Ze + "]*$"), pu = new RegExp("^(aria)[A-Z][" + Ze + "]*$");
    function LT(e, t) {
      {
        if (nr.call(si, t) && si[t])
          return !0;
        if (pu.test(t)) {
          var a = "aria-" + t.slice(4).toLowerCase(), i = iR.hasOwnProperty(a) ? a : null;
          if (i == null)
            return d("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), si[t] = !0, !0;
          if (t !== i)
            return d("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, i), si[t] = !0, !0;
        }
        if (mT.test(t)) {
          var s = t.toLowerCase(), c = iR.hasOwnProperty(s) ? s : null;
          if (c == null)
            return si[t] = !0, !1;
          if (t !== c)
            return d("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, c), si[t] = !0, !0;
        }
      }
      return !0;
    }
    function oR(e, t) {
      {
        var a = [];
        for (var i in t) {
          var s = LT(e, i);
          s || a.push(i);
        }
        var c = a.map(function(A) {
          return "`" + A + "`";
        }).join(", ");
        a.length === 1 ? d("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", c, e) : a.length > 1 && d("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", c, e);
      }
    }
    function XE(e, t) {
      Qi(e, t) || oR(e, t);
    }
    var Dl = !1;
    function yT(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !Dl && (Dl = !0, e === "select" && t.multiple ? d("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : d("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var DT = function() {
    };
    {
      var ir = {}, gT = /^on./, lR = /^on[^A-Z]/, sR = new RegExp("^(aria)-[" + Ze + "]*$"), uR = new RegExp("^(aria)[A-Z][" + Ze + "]*$");
      DT = function(e, t, a, i) {
        if (nr.call(ir, t) && ir[t])
          return !0;
        var s = t.toLowerCase();
        if (s === "onfocusin" || s === "onfocusout")
          return d("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ir[t] = !0, !0;
        if (i != null) {
          var c = i.registrationNameDependencies, A = i.possibleRegistrationNames;
          if (c.hasOwnProperty(t))
            return !0;
          var S = A.hasOwnProperty(s) ? A[s] : null;
          if (S != null)
            return d("Invalid event handler property `%s`. Did you mean `%s`?", t, S), ir[t] = !0, !0;
          if (gT.test(t))
            return d("Unknown event handler property `%s`. It will be ignored.", t), ir[t] = !0, !0;
        } else if (gT.test(t))
          return lR.test(t) && d("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), ir[t] = !0, !0;
        if (sR.test(t) || uR.test(t))
          return !0;
        if (s === "innerhtml")
          return d("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ir[t] = !0, !0;
        if (s === "aria")
          return d("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ir[t] = !0, !0;
        if (s === "is" && a !== null && a !== void 0 && typeof a != "string")
          return d("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof a), ir[t] = !0, !0;
        if (typeof a == "number" && isNaN(a))
          return d("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), ir[t] = !0, !0;
        var p = Mr(t), L = p !== null && p.type === Oa;
        if (WE.hasOwnProperty(s)) {
          var y = WE[s];
          if (y !== t)
            return d("Invalid DOM property `%s`. Did you mean `%s`?", t, y), ir[t] = !0, !0;
        } else if (!L && t !== s)
          return d("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, s), ir[t] = !0, !0;
        return typeof a == "boolean" && hr(t, a, p, !1) ? (a ? d('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', a, t, t, a, t) : d('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', a, t, t, a, t, t, t), ir[t] = !0, !0) : L ? !0 : hr(t, a, p, !1) ? (ir[t] = !0, !1) : ((a === "false" || a === "true") && p !== null && p.type === vn && (d("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", a, t, a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, a), ir[t] = !0), !0);
      };
    }
    var ER = function(e, t, a) {
      {
        var i = [];
        for (var s in t) {
          var c = DT(e, s, t[s], a);
          c || i.push(s);
        }
        var A = i.map(function(S) {
          return "`" + S + "`";
        }).join(", ");
        i.length === 1 ? d("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", A, e) : i.length > 1 && d("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", A, e);
      }
    };
    function cR(e, t, a) {
      Qi(e, t) || ER(e, t, a);
    }
    var Zi = 1, Ou = 2, gl = 4, tN = Zi | Ou | gl, Iu = null;
    function Cu(e) {
      Iu !== null && d("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Iu = e;
    }
    function nN() {
      Iu === null && d("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Iu = null;
    }
    function TR(e) {
      return e === Iu;
    }
    function kE(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === Ji ? t.parentNode : t;
    }
    var En = null, Vo = null, qi = null;
    function ms(e) {
      var t = ks(e);
      if (t) {
        if (typeof En != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var a = t.stateNode;
        if (a) {
          var i = Ad(a);
          En(t.stateNode, t.type, i);
        }
      }
    }
    function fR(e) {
      En = e;
    }
    function KE(e) {
      Vo ? qi ? qi.push(e) : qi = [e] : Vo = e;
    }
    function hu() {
      return Vo !== null || qi !== null;
    }
    function vu() {
      if (Vo) {
        var e = Vo, t = qi;
        if (Vo = null, qi = null, ms(e), t)
          for (var a = 0; a < t.length; a++)
            ms(t[a]);
      }
    }
    var Pl = function(e, t) {
      return e(t);
    }, PT = function() {
    }, MT = !1;
    function rN() {
      var e = hu();
      e && (PT(), vu());
    }
    function UT(e, t, a) {
      if (MT)
        return e(t, a);
      MT = !0;
      try {
        return Pl(e, t, a);
      } finally {
        MT = !1, rN();
      }
    }
    function jE(e, t, a) {
      Pl = e, PT = a;
    }
    function zE(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function _T(e, t, a) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(a.disabled && zE(t));
        default:
          return !1;
      }
    }
    function Ml(e, t) {
      var a = e.stateNode;
      if (a === null)
        return null;
      var i = Ad(a);
      if (i === null)
        return null;
      var s = i[t];
      if (_T(t, e.type, i))
        return null;
      if (s && typeof s != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof s + "` type.");
      return s;
    }
    var mu = !1;
    if (hn)
      try {
        var Ul = {};
        Object.defineProperty(Ul, "passive", {
          get: function() {
            mu = !0;
          }
        }), window.addEventListener("test", Ul, Ul), window.removeEventListener("test", Ul, Ul);
      } catch {
        mu = !1;
      }
    function AR(e, t, a, i, s, c, A, S, p) {
      var L = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(a, L);
      } catch (y) {
        this.onError(y);
      }
    }
    var GT = AR;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var xT = document.createElement("react");
      GT = function(t, a, i, s, c, A, S, p, L) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var y = document.createEvent("Event"), F = !1, H = !0, z = window.event, Q = Object.getOwnPropertyDescriptor(window, "event");
        function ne() {
          xT.removeEventListener(re, tt, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = z);
        }
        var He = Array.prototype.slice.call(arguments, 3);
        function tt() {
          F = !0, ne(), a.apply(i, He), H = !1;
        }
        var Je, xt = !1, Pt = !1;
        function X(k) {
          if (Je = k.error, xt = !0, Je === null && k.colno === 0 && k.lineno === 0 && (Pt = !0), k.defaultPrevented && Je != null && typeof Je == "object")
            try {
              Je._suppressLogging = !0;
            } catch {
            }
        }
        var re = "react-" + (t || "invokeguardedcallback");
        if (window.addEventListener("error", X), xT.addEventListener(re, tt, !1), y.initEvent(re, !1, !1), xT.dispatchEvent(y), Q && Object.defineProperty(window, "event", Q), F && H && (xt ? Pt && (Je = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Je = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Je)), window.removeEventListener("error", X), !F)
          return ne(), AR.apply(this, arguments);
      };
    }
    var aN = GT, Wo = !1, ui = null, Lu = !1, Xo = null, Pi = {
      onError: function(e) {
        Wo = !0, ui = e;
      }
    };
    function _l(e, t, a, i, s, c, A, S, p) {
      Wo = !1, ui = null, aN.apply(Pi, arguments);
    }
    function $i(e, t, a, i, s, c, A, S, p) {
      if (_l.apply(this, arguments), Wo) {
        var L = HT();
        Lu || (Lu = !0, Xo = L);
      }
    }
    function bT() {
      if (Lu) {
        var e = Xo;
        throw Lu = !1, Xo = null, e;
      }
    }
    function iN() {
      return Wo;
    }
    function HT() {
      if (Wo) {
        var e = ui;
        return Wo = !1, ui = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Va(e) {
      return e._reactInternals;
    }
    function yu(e) {
      return e._reactInternals !== void 0;
    }
    function Ls(e, t) {
      e._reactInternals = t;
    }
    var qe = (
      /*                      */
      0
    ), ko = (
      /*                */
      1
    ), dn = (
      /*                    */
      2
    ), Ct = (
      /*                       */
      4
    ), jt = (
      /*                */
      16
    ), qt = (
      /*                 */
      32
    ), Mi = (
      /*                     */
      64
    ), Tt = (
      /*                   */
      128
    ), Mn = (
      /*            */
      256
    ), ia = (
      /*                          */
      512
    ), Wa = (
      /*                     */
      1024
    ), In = (
      /*                      */
      2048
    ), Xa = (
      /*                    */
      4096
    ), Ko = (
      /*                   */
      8192
    ), Du = (
      /*             */
      16384
    ), JE = In | Ct | Mi | ia | Wa | Du, RR = (
      /*               */
      32767
    ), ma = (
      /*                   */
      32768
    ), or = (
      /*                */
      65536
    ), gu = (
      /* */
      131072
    ), BT = (
      /*                       */
      1048576
    ), FT = (
      /*                    */
      2097152
    ), oa = (
      /*                 */
      4194304
    ), jo = (
      /*                */
      8388608
    ), la = (
      /*               */
      16777216
    ), Gl = (
      /*              */
      33554432
    ), ys = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Ct | Wa | 0
    ), sa = dn | Ct | jt | qt | ia | Xa | Ko, vr = Ct | Mi | ia | Ko, ka = In | jt, cr = oa | jo | FT, eo = T.ReactCurrentOwner;
    function La(e) {
      var t = e, a = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var i = t;
        do
          t = i, (t.flags & (dn | Xa)) !== qe && (a = t.return), i = t.return;
        while (i);
      }
      return t.tag === g ? a : null;
    }
    function wT(e) {
      if (e.tag === ye) {
        var t = e.memoizedState;
        if (t === null) {
          var a = e.alternate;
          a !== null && (t = a.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function QE(e) {
      return e.tag === g ? e.stateNode.containerInfo : null;
    }
    function YT(e) {
      return La(e) === e;
    }
    function ya(e) {
      {
        var t = eo.current;
        if (t !== null && t.tag === v) {
          var a = t, i = a.stateNode;
          i._warnedAboutRefsInRender || d("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", ct(a) || "A component"), i._warnedAboutRefsInRender = !0;
        }
      }
      var s = Va(e);
      return s ? La(s) === s : !1;
    }
    function ua(e) {
      if (La(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Sn(e) {
      var t = e.alternate;
      if (!t) {
        var a = La(e);
        if (a === null)
          throw new Error("Unable to find node on an unmounted component.");
        return a !== e ? null : e;
      }
      for (var i = e, s = t; ; ) {
        var c = i.return;
        if (c === null)
          break;
        var A = c.alternate;
        if (A === null) {
          var S = c.return;
          if (S !== null) {
            i = s = S;
            continue;
          }
          break;
        }
        if (c.child === A.child) {
          for (var p = c.child; p; ) {
            if (p === i)
              return ua(c), e;
            if (p === s)
              return ua(c), t;
            p = p.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== s.return)
          i = c, s = A;
        else {
          for (var L = !1, y = c.child; y; ) {
            if (y === i) {
              L = !0, i = c, s = A;
              break;
            }
            if (y === s) {
              L = !0, s = c, i = A;
              break;
            }
            y = y.sibling;
          }
          if (!L) {
            for (y = A.child; y; ) {
              if (y === i) {
                L = !0, i = A, s = c;
                break;
              }
              if (y === s) {
                L = !0, s = A, i = c;
                break;
              }
              y = y.sibling;
            }
            if (!L)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (i.alternate !== s)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (i.tag !== g)
        throw new Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function Ka(e) {
      var t = Sn(e);
      return t !== null ? VT(t) : null;
    }
    function VT(e) {
      if (e.tag === Y || e.tag === j)
        return e;
      for (var t = e.child; t !== null; ) {
        var a = VT(t);
        if (a !== null)
          return a;
        t = t.sibling;
      }
      return null;
    }
    function dR(e) {
      var t = Sn(e);
      return t !== null ? ZE(t) : null;
    }
    function ZE(e) {
      if (e.tag === Y || e.tag === j)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== w) {
          var a = ZE(t);
          if (a !== null)
            return a;
        }
        t = t.sibling;
      }
      return null;
    }
    var qE = u.unstable_scheduleCallback, SR = u.unstable_cancelCallback, $E = u.unstable_shouldYield, NR = u.unstable_requestPaint, yn = u.unstable_now, WT = u.unstable_getCurrentPriorityLevel, XT = u.unstable_ImmediatePriority, ja = u.unstable_UserBlockingPriority, zo = u.unstable_NormalPriority, ec = u.unstable_LowPriority, xl = u.unstable_IdlePriority, kT = u.unstable_yieldValue, KT = u.unstable_setDisableYieldValue, Da = typeof { isDisabled: !0 } < "u";
    function jT(e) {
      return !(typeof { isDisabled: !0 } > "u");
    }
    function Pu(e, t) {
    }
    function rn(e) {
      typeof kT == "function" && (KT(e), O(e));
    }
    function Ds() {
    }
    function pR(e, t, a) {
    }
    function oN(e, t, a) {
    }
    var ze = (
      /*                         */
      0
    ), St = (
      /*                 */
      1
    ), Wt = (
      /*                    */
      2
    ), bn = (
      /*               */
      8
    ), lr = (
      /*              */
      16
    ), to = Math.clz32 ? Math.clz32 : nc, tc = Math.log, IR = Math.LN2;
    function nc(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (tc(t) / IR | 0) | 0;
    }
    var zT = 31, se = (
      /*                        */
      0
    ), Xn = (
      /*                          */
      0
    ), ot = (
      /*                        */
      1
    ), gs = (
      /*    */
      2
    ), no = (
      /*             */
      4
    ), bl = (
      /*            */
      8
    ), Ei = (
      /*                     */
      16
    ), Jo = (
      /*                */
      32
    ), Qo = (
      /*                       */
      4194240
    ), Ps = (
      /*                        */
      64
    ), rc = (
      /*                        */
      128
    ), Zo = (
      /*                        */
      256
    ), ac = (
      /*                        */
      512
    ), Hl = (
      /*                        */
      1024
    ), za = (
      /*                        */
      2048
    ), Bl = (
      /*                        */
      4096
    ), Fl = (
      /*                        */
      8192
    ), ro = (
      /*                        */
      16384
    ), Mu = (
      /*                       */
      32768
    ), qo = (
      /*                       */
      65536
    ), ic = (
      /*                       */
      131072
    ), Uu = (
      /*                       */
      262144
    ), Nn = (
      /*                       */
      524288
    ), Ms = (
      /*                       */
      1048576
    ), _u = (
      /*                       */
      2097152
    ), Gu = (
      /*                            */
      130023424
    ), ao = (
      /*                             */
      4194304
    ), xu = (
      /*                             */
      8388608
    ), io = (
      /*                             */
      16777216
    ), pn = (
      /*                             */
      33554432
    ), Hn = (
      /*                             */
      67108864
    ), qn = ao, wl = (
      /*          */
      134217728
    ), Us = (
      /*                          */
      268435455
    ), $o = (
      /*               */
      268435456
    ), _s = (
      /*                        */
      536870912
    ), cn = (
      /*                   */
      1073741824
    ), an = -1, Gs = Ps, xs = ao;
    function Ea(e) {
      switch (el(e)) {
        case ot:
          return ot;
        case gs:
          return gs;
        case no:
          return no;
        case bl:
          return bl;
        case Ei:
          return Ei;
        case Jo:
          return Jo;
        case Ps:
        case rc:
        case Zo:
        case ac:
        case Hl:
        case za:
        case Bl:
        case Fl:
        case ro:
        case Mu:
        case qo:
        case ic:
        case Uu:
        case Nn:
        case Ms:
        case _u:
          return e & Qo;
        case ao:
        case xu:
        case io:
        case pn:
        case Hn:
          return e & Gu;
        case wl:
          return wl;
        case $o:
          return $o;
        case _s:
          return _s;
        case cn:
          return cn;
        default:
          return d("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function br(e, t) {
      var a = e.pendingLanes;
      if (a === se)
        return se;
      var i = se, s = e.suspendedLanes, c = e.pingedLanes, A = a & Us;
      if (A !== se) {
        var S = A & ~s;
        if (S !== se)
          i = Ea(S);
        else {
          var p = A & c;
          p !== se && (i = Ea(p));
        }
      } else {
        var L = a & ~s;
        L !== se ? i = Ea(L) : c !== se && (i = Ea(c));
      }
      if (i === se)
        return se;
      if (t !== se && t !== i && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & s) === se) {
        var y = el(i), F = el(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          y >= F || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          y === Ei && (F & Qo) !== se
        )
          return t;
      }
      (i & no) !== se && (i |= a & Ei);
      var H = e.entangledLanes;
      if (H !== se)
        for (var z = e.entanglements, Q = i & H; Q > 0; ) {
          var ne = tl(Q), He = 1 << ne;
          i |= z[ne], Q &= ~He;
        }
      return i;
    }
    function bu(e, t) {
      for (var a = e.eventTimes, i = an; t > 0; ) {
        var s = tl(t), c = 1 << s, A = a[s];
        A > i && (i = A), t &= ~c;
      }
      return i;
    }
    function JT(e, t) {
      switch (e) {
        case ot:
        case gs:
        case no:
          return t + 250;
        case bl:
        case Ei:
        case Jo:
        case Ps:
        case rc:
        case Zo:
        case ac:
        case Hl:
        case za:
        case Bl:
        case Fl:
        case ro:
        case Mu:
        case qo:
        case ic:
        case Uu:
        case Nn:
        case Ms:
        case _u:
          return t + 5e3;
        case ao:
        case xu:
        case io:
        case pn:
        case Hn:
          return an;
        case wl:
        case $o:
        case _s:
        case cn:
          return an;
        default:
          return d("Should have found matching lanes. This is a bug in React."), an;
      }
    }
    function QT(e, t) {
      for (var a = e.pendingLanes, i = e.suspendedLanes, s = e.pingedLanes, c = e.expirationTimes, A = a; A > 0; ) {
        var S = tl(A), p = 1 << S, L = c[S];
        L === an ? ((p & i) === se || (p & s) !== se) && (c[S] = JT(p, t)) : L <= t && (e.expiredLanes |= p), A &= ~p;
      }
    }
    function CR(e) {
      return Ea(e.pendingLanes);
    }
    function oc(e) {
      var t = e.pendingLanes & ~cn;
      return t !== se ? t : t & cn ? cn : se;
    }
    function hR(e) {
      return (e & ot) !== se;
    }
    function lc(e) {
      return (e & Us) !== se;
    }
    function ZT(e) {
      return (e & Gu) === e;
    }
    function vR(e) {
      var t = ot | no | Ei;
      return (e & t) === se;
    }
    function mR(e) {
      return (e & Qo) === e;
    }
    function Hu(e, t) {
      var a = gs | no | bl | Ei;
      return (t & a) !== se;
    }
    function Bu(e, t) {
      return (t & e.expiredLanes) !== se;
    }
    function qT(e) {
      return (e & Qo) !== se;
    }
    function Fu() {
      var e = Gs;
      return Gs <<= 1, (Gs & Qo) === se && (Gs = Ps), e;
    }
    function sc() {
      var e = xs;
      return xs <<= 1, (xs & Gu) === se && (xs = ao), e;
    }
    function el(e) {
      return e & -e;
    }
    function Yl(e) {
      return el(e);
    }
    function tl(e) {
      return 31 - to(e);
    }
    function uc(e) {
      return tl(e);
    }
    function ca(e, t) {
      return (e & t) !== se;
    }
    function Vl(e, t) {
      return (e & t) === t;
    }
    function Nt(e, t) {
      return e | t;
    }
    function wu(e, t) {
      return e & ~t;
    }
    function $T(e, t) {
      return e & t;
    }
    function lN(e) {
      return e;
    }
    function sN(e, t) {
      return e !== Xn && e < t ? e : t;
    }
    function Ec(e) {
      for (var t = [], a = 0; a < zT; a++)
        t.push(e);
      return t;
    }
    function Yu(e, t, a) {
      e.pendingLanes |= t, t !== _s && (e.suspendedLanes = se, e.pingedLanes = se);
      var i = e.eventTimes, s = uc(t);
      i[s] = a;
    }
    function uN(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var a = e.expirationTimes, i = t; i > 0; ) {
        var s = tl(i), c = 1 << s;
        a[s] = an, i &= ~c;
      }
    }
    function ef(e, t, a) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function LR(e, t) {
      var a = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = se, e.pingedLanes = se, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var i = e.entanglements, s = e.eventTimes, c = e.expirationTimes, A = a; A > 0; ) {
        var S = tl(A), p = 1 << S;
        i[S] = se, s[S] = an, c[S] = an, A &= ~p;
      }
    }
    function cc(e, t) {
      for (var a = e.entangledLanes |= t, i = e.entanglements, s = a; s; ) {
        var c = tl(s), A = 1 << c;
        // Is this one of the newly entangled lanes?
        A & t | // Is this lane transitively entangled with the newly entangled lanes?
        i[c] & t && (i[c] |= t), s &= ~A;
      }
    }
    function Tc(e, t) {
      var a = el(t), i;
      switch (a) {
        case no:
          i = gs;
          break;
        case Ei:
          i = bl;
          break;
        case Ps:
        case rc:
        case Zo:
        case ac:
        case Hl:
        case za:
        case Bl:
        case Fl:
        case ro:
        case Mu:
        case qo:
        case ic:
        case Uu:
        case Nn:
        case Ms:
        case _u:
        case ao:
        case xu:
        case io:
        case pn:
        case Hn:
          i = Jo;
          break;
        case _s:
          i = $o;
          break;
        default:
          i = Xn;
          break;
      }
      return (i & (e.suspendedLanes | t)) !== Xn ? Xn : i;
    }
    function yR(e, t, a) {
      if (Da)
        for (var i = e.pendingUpdatersLaneMap; a > 0; ) {
          var s = uc(a), c = 1 << s, A = i[s];
          A.add(t), a &= ~c;
        }
    }
    function DR(e, t) {
      if (Da)
        for (var a = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; t > 0; ) {
          var s = uc(t), c = 1 << s, A = a[s];
          A.size > 0 && (A.forEach(function(S) {
            var p = S.alternate;
            (p === null || !i.has(p)) && i.add(S);
          }), A.clear()), t &= ~c;
        }
    }
    function gR(e, t) {
      return null;
    }
    var Tr = ot, Ui = no, _i = Ei, tf = _s, bs = Xn;
    function Ja() {
      return bs;
    }
    function $n(e) {
      bs = e;
    }
    function PR(e, t) {
      var a = bs;
      try {
        return bs = e, t();
      } finally {
        bs = a;
      }
    }
    function MR(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function EN(e, t) {
      return e === 0 || e > t ? e : t;
    }
    function mr(e, t) {
      return e !== 0 && e < t;
    }
    function Lr(e) {
      var t = el(e);
      return mr(Tr, t) ? mr(Ui, t) ? lc(t) ? _i : tf : Ui : Tr;
    }
    function Vu(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var nf;
    function UR(e) {
      nf = e;
    }
    function _R(e) {
      nf(e);
    }
    var fc;
    function rf(e) {
      fc = e;
    }
    var af;
    function of(e) {
      af = e;
    }
    var lf;
    function GR(e) {
      lf = e;
    }
    var Ac;
    function sf(e) {
      Ac = e;
    }
    var Rc = !1, Hs = [], ci = null, nl = null, oo = null, Wl = /* @__PURE__ */ new Map(), Bs = /* @__PURE__ */ new Map(), Ti = [], lo = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function cN(e) {
      return lo.indexOf(e) > -1;
    }
    function xR(e, t, a, i, s) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: a,
        nativeEvent: s,
        targetContainers: [i]
      };
    }
    function dc(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          ci = null;
          break;
        case "dragenter":
        case "dragleave":
          nl = null;
          break;
        case "mouseover":
        case "mouseout":
          oo = null;
          break;
        case "pointerover":
        case "pointerout": {
          var a = t.pointerId;
          Wl.delete(a);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var i = t.pointerId;
          Bs.delete(i);
          break;
        }
      }
    }
    function Fs(e, t, a, i, s, c) {
      if (e === null || e.nativeEvent !== c) {
        var A = xR(t, a, i, s, c);
        if (t !== null) {
          var S = ks(t);
          S !== null && fc(S);
        }
        return A;
      }
      e.eventSystemFlags |= i;
      var p = e.targetContainers;
      return s !== null && p.indexOf(s) === -1 && p.push(s), e;
    }
    function bR(e, t, a, i, s) {
      switch (t) {
        case "focusin": {
          var c = s;
          return ci = Fs(ci, e, t, a, i, c), !0;
        }
        case "dragenter": {
          var A = s;
          return nl = Fs(nl, e, t, a, i, A), !0;
        }
        case "mouseover": {
          var S = s;
          return oo = Fs(oo, e, t, a, i, S), !0;
        }
        case "pointerover": {
          var p = s, L = p.pointerId;
          return Wl.set(L, Fs(Wl.get(L) || null, e, t, a, i, p)), !0;
        }
        case "gotpointercapture": {
          var y = s, F = y.pointerId;
          return Bs.set(F, Fs(Bs.get(F) || null, e, t, a, i, y)), !0;
        }
      }
      return !1;
    }
    function ws(e) {
      var t = EE(e.target);
      if (t !== null) {
        var a = La(t);
        if (a !== null) {
          var i = a.tag;
          if (i === ye) {
            var s = wT(a);
            if (s !== null) {
              e.blockedOn = s, Ac(e.priority, function() {
                af(a);
              });
              return;
            }
          } else if (i === g) {
            var c = a.stateNode;
            if (Vu(c)) {
              e.blockedOn = QE(a);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function yr(e) {
      for (var t = lf(), a = {
        blockedOn: null,
        target: e,
        priority: t
      }, i = 0; i < Ti.length && mr(t, Ti[i].priority); i++)
        ;
      Ti.splice(i, 0, a), i === 0 && ws(a);
    }
    function Sc(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var a = t[0], i = Ic(e.domEventName, e.eventSystemFlags, a, e.nativeEvent);
        if (i === null) {
          var s = e.nativeEvent, c = new s.constructor(s.type, s);
          Cu(c), s.target.dispatchEvent(c), nN();
        } else {
          var A = ks(i);
          return A !== null && fc(A), e.blockedOn = i, !1;
        }
        t.shift();
      }
      return !0;
    }
    function HR(e, t, a) {
      Sc(e) && a.delete(t);
    }
    function Nc() {
      Rc = !1, ci !== null && Sc(ci) && (ci = null), nl !== null && Sc(nl) && (nl = null), oo !== null && Sc(oo) && (oo = null), Wl.forEach(HR), Bs.forEach(HR);
    }
    function kn(e, t) {
      e.blockedOn === t && (e.blockedOn = null, Rc || (Rc = !0, u.unstable_scheduleCallback(u.unstable_NormalPriority, Nc)));
    }
    function Wu(e) {
      if (Hs.length > 0) {
        kn(Hs[0], e);
        for (var t = 1; t < Hs.length; t++) {
          var a = Hs[t];
          a.blockedOn === e && (a.blockedOn = null);
        }
      }
      ci !== null && kn(ci, e), nl !== null && kn(nl, e), oo !== null && kn(oo, e);
      var i = function(S) {
        return kn(S, e);
      };
      Wl.forEach(i), Bs.forEach(i);
      for (var s = 0; s < Ti.length; s++) {
        var c = Ti[s];
        c.blockedOn === e && (c.blockedOn = null);
      }
      for (; Ti.length > 0; ) {
        var A = Ti[0];
        if (A.blockedOn !== null)
          break;
        ws(A), A.blockedOn === null && Ti.shift();
      }
    }
    var Ge = T.ReactCurrentBatchConfig, rl = !0;
    function pc(e) {
      rl = !!e;
    }
    function BR() {
      return rl;
    }
    function TN(e, t, a) {
      var i = Cc(t), s;
      switch (i) {
        case Tr:
          s = Xu;
          break;
        case Ui:
          s = Oc;
          break;
        case _i:
        default:
          s = ku;
          break;
      }
      return s.bind(null, t, a, e);
    }
    function Xu(e, t, a, i) {
      var s = Ja(), c = Ge.transition;
      Ge.transition = null;
      try {
        $n(Tr), ku(e, t, a, i);
      } finally {
        $n(s), Ge.transition = c;
      }
    }
    function Oc(e, t, a, i) {
      var s = Ja(), c = Ge.transition;
      Ge.transition = null;
      try {
        $n(Ui), ku(e, t, a, i);
      } finally {
        $n(s), Ge.transition = c;
      }
    }
    function ku(e, t, a, i) {
      rl && FR(e, t, a, i);
    }
    function FR(e, t, a, i) {
      var s = Ic(e, t, a, i);
      if (s === null) {
        yN(e, t, i, Ku, a), dc(e, i);
        return;
      }
      if (bR(s, e, t, a, i)) {
        i.stopPropagation();
        return;
      }
      if (dc(e, i), t & gl && cN(e)) {
        for (; s !== null; ) {
          var c = ks(s);
          c !== null && _R(c);
          var A = Ic(e, t, a, i);
          if (A === null && yN(e, t, i, Ku, a), A === s)
            break;
          s = A;
        }
        s !== null && i.stopPropagation();
        return;
      }
      yN(e, t, i, null, a);
    }
    var Ku = null;
    function Ic(e, t, a, i) {
      Ku = null;
      var s = kE(i), c = EE(s);
      if (c !== null) {
        var A = La(c);
        if (A === null)
          c = null;
        else {
          var S = A.tag;
          if (S === ye) {
            var p = wT(A);
            if (p !== null)
              return p;
            c = null;
          } else if (S === g) {
            var L = A.stateNode;
            if (Vu(L))
              return QE(A);
            c = null;
          } else
            A !== c && (c = null);
        }
      }
      return Ku = c, null;
    }
    function Cc(e) {
      switch (e) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Tr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ui;
        case "message": {
          var t = WT();
          switch (t) {
            case XT:
              return Tr;
            case ja:
              return Ui;
            case zo:
            case ec:
              return _i;
            case xl:
              return tf;
            default:
              return _i;
          }
        }
        default:
          return _i;
      }
    }
    function uf(e, t, a) {
      return e.addEventListener(t, a, !1), a;
    }
    function fr(e, t, a) {
      return e.addEventListener(t, a, !0), a;
    }
    function fi(e, t, a, i) {
      return e.addEventListener(t, a, {
        capture: !0,
        passive: i
      }), a;
    }
    function al(e, t, a, i) {
      return e.addEventListener(t, a, {
        passive: i
      }), a;
    }
    var Ys = null, hc = null, Hr = null;
    function wR(e) {
      return Ys = e, hc = Ef(), !0;
    }
    function Gi() {
      Ys = null, hc = null, Hr = null;
    }
    function YR() {
      if (Hr)
        return Hr;
      var e, t = hc, a = t.length, i, s = Ef(), c = s.length;
      for (e = 0; e < a && t[e] === s[e]; e++)
        ;
      var A = a - e;
      for (i = 1; i <= A && t[a - i] === s[c - i]; i++)
        ;
      var S = i > 1 ? 1 - i : void 0;
      return Hr = s.slice(e, S), Hr;
    }
    function Ef() {
      return "value" in Ys ? Ys.value : Ys.textContent;
    }
    function ju(e) {
      var t, a = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && a === 13 && (t = 13)) : t = a, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function zu() {
      return !0;
    }
    function cf() {
      return !1;
    }
    function ga(e) {
      function t(a, i, s, c, A) {
        this._reactName = a, this._targetInst = s, this.type = i, this.nativeEvent = c, this.target = A, this.currentTarget = null;
        for (var S in e)
          if (e.hasOwnProperty(S)) {
            var p = e[S];
            p ? this[S] = p(c) : this[S] = c[S];
          }
        var L = c.defaultPrevented != null ? c.defaultPrevented : c.returnValue === !1;
        return L ? this.isDefaultPrevented = zu : this.isDefaultPrevented = cf, this.isPropagationStopped = cf, this;
      }
      return Dt(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = zu);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = zu);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: zu
      }), t;
    }
    var so = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Ju = ga(so), Dr = Dt({}, so, {
      view: 0,
      detail: 0
    }), wt = ga(Dr), Kn, Un, Bn;
    function Pa(e) {
      e !== Bn && (Bn && e.type === "mousemove" ? (Kn = e.screenX - Bn.screenX, Un = e.screenY - Bn.screenY) : (Kn = 0, Un = 0), Bn = e);
    }
    var uo = Dt({}, Dr, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: tE,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (Pa(e), Kn);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : Un;
      }
    }), jn = ga(uo), Qu = Dt({}, uo, {
      dataTransfer: 0
    }), Xl = ga(Qu), vc = Dt({}, Dr, {
      relatedTarget: 0
    }), Zu = ga(vc), qu = Dt({}, so, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ta = ga(qu), Tf = Dt({}, so, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), Vs = ga(Tf), Eo = Dt({}, so, {
      data: 0
    }), $u = ga(Eo), ff = $u, il = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, mc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function ol(e) {
      if (e.key) {
        var t = il[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var a = ju(e);
        return a === 13 ? "Enter" : String.fromCharCode(a);
      }
      return e.type === "keydown" || e.type === "keyup" ? mc[e.keyCode] || "Unidentified" : "";
    }
    var Lc = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function eE(e) {
      var t = this, a = t.nativeEvent;
      if (a.getModifierState)
        return a.getModifierState(e);
      var i = Lc[e];
      return i ? !!a[i] : !1;
    }
    function tE(e) {
      return eE;
    }
    var yc = Dt({}, Dr, {
      key: ol,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: tE,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? ju(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? ju(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), Dc = ga(yc), Br = Dt({}, uo, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), co = ga(Br), Ai = Dt({}, Dr, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: tE
    }), fa = ga(Ai), VR = Dt({}, so, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Af = ga(VR), Rf = Dt({}, uo, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), fN = ga(Rf), ll = [9, 13, 27, 32], df = 229, nE = hn && "CompositionEvent" in window, Ri = null;
    hn && "documentMode" in document && (Ri = document.documentMode);
    var Sf = hn && "TextEvent" in window && !Ri, sl = hn && (!nE || Ri && Ri > 8 && Ri <= 11), Nf = 32, pf = String.fromCharCode(Nf);
    function Of() {
      gn("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), gn("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), gn("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), gn("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var rE = !1;
    function AN(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function RN(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function WR(e, t) {
      return e === "keydown" && t.keyCode === df;
    }
    function If(e, t) {
      switch (e) {
        case "keyup":
          return ll.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== df;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function ul(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function XR(e) {
      return e.locale === "ko";
    }
    var di = !1;
    function kR(e, t, a, i, s) {
      var c, A;
      if (nE ? c = RN(t) : di ? If(t, i) && (c = "onCompositionEnd") : WR(t, i) && (c = "onCompositionStart"), !c)
        return null;
      sl && !XR(i) && (!di && c === "onCompositionStart" ? di = wR(s) : c === "onCompositionEnd" && di && (A = YR()));
      var S = td(a, c);
      if (S.length > 0) {
        var p = new $u(c, t, null, i, s);
        if (e.push({
          event: p,
          listeners: S
        }), A)
          p.data = A;
        else {
          var L = ul(i);
          L !== null && (p.data = L);
        }
      }
    }
    function _n(e, t) {
      switch (e) {
        case "compositionend":
          return ul(t);
        case "keypress":
          var a = t.which;
          return a !== Nf ? null : (rE = !0, pf);
        case "textInput":
          var i = t.data;
          return i === pf && rE ? null : i;
        default:
          return null;
      }
    }
    function dN(e, t) {
      if (di) {
        if (e === "compositionend" || !nE && If(e, t)) {
          var a = YR();
          return Gi(), di = !1, a;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!AN(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return sl && !XR(t) ? null : t.data;
        default:
          return null;
      }
    }
    function KR(e, t, a, i, s) {
      var c;
      if (Sf ? c = _n(t, i) : c = dN(t, i), !c)
        return null;
      var A = td(a, "onBeforeInput");
      if (A.length > 0) {
        var S = new ff("onBeforeInput", "beforeinput", null, i, s);
        e.push({
          event: S,
          listeners: A
        }), S.data = c;
      }
    }
    function SN(e, t, a, i, s, c, A) {
      kR(e, t, a, i, s), KR(e, t, a, i, s);
    }
    var NN = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Cf(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!NN[e.type] : t === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function jR(e) {
      if (!hn)
        return !1;
      var t = "on" + e, a = t in document;
      if (!a) {
        var i = document.createElement("div");
        i.setAttribute(t, "return;"), a = typeof i[t] == "function";
      }
      return a;
    }
    function pN() {
      gn("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Ma(e, t, a, i) {
      KE(i);
      var s = td(t, "onChange");
      if (s.length > 0) {
        var c = new Ju("onChange", "change", null, a, i);
        e.push({
          event: c,
          listeners: s
        });
      }
    }
    var kl = null, aE = null;
    function El(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function gc(e) {
      var t = [];
      Ma(t, aE, e, kE(e)), UT(Kl, t);
    }
    function Kl(e) {
      VI(e, 0);
    }
    function jl(e) {
      var t = Bc(e);
      if (Ss(t))
        return e;
    }
    function hf(e, t) {
      if (e === "change")
        return t;
    }
    var Pc = !1;
    hn && (Pc = jR("input") && (!document.documentMode || document.documentMode > 9));
    function ON(e, t) {
      kl = e, aE = t, kl.attachEvent("onpropertychange", zR);
    }
    function Mc() {
      kl && (kl.detachEvent("onpropertychange", zR), kl = null, aE = null);
    }
    function zR(e) {
      e.propertyName === "value" && jl(aE) && gc(e);
    }
    function JR(e, t, a) {
      e === "focusin" ? (Mc(), ON(t, a)) : e === "focusout" && Mc();
    }
    function QR(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return jl(aE);
    }
    function Uc(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function _c(e, t) {
      if (e === "click")
        return jl(t);
    }
    function ZR(e, t) {
      if (e === "input" || e === "change")
        return jl(t);
    }
    function vf(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || nt(e, "number", e.value);
    }
    function IN(e, t, a, i, s, c, A) {
      var S = a ? Bc(a) : window, p, L;
      if (El(S) ? p = hf : Cf(S) ? Pc ? p = ZR : (p = QR, L = JR) : Uc(S) && (p = _c), p) {
        var y = p(t, a);
        if (y) {
          Ma(e, y, i, s);
          return;
        }
      }
      L && L(t, S, a), t === "focusout" && vf(S);
    }
    function qR() {
      Jn("onMouseEnter", ["mouseout", "mouseover"]), Jn("onMouseLeave", ["mouseout", "mouseover"]), Jn("onPointerEnter", ["pointerout", "pointerover"]), Jn("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function mf(e, t, a, i, s, c, A) {
      var S = t === "mouseover" || t === "pointerover", p = t === "mouseout" || t === "pointerout";
      if (S && !TR(i)) {
        var L = i.relatedTarget || i.fromElement;
        if (L && (EE(L) || Ff(L)))
          return;
      }
      if (!(!p && !S)) {
        var y;
        if (s.window === s)
          y = s;
        else {
          var F = s.ownerDocument;
          F ? y = F.defaultView || F.parentWindow : y = window;
        }
        var H, z;
        if (p) {
          var Q = i.relatedTarget || i.toElement;
          if (H = a, z = Q ? EE(Q) : null, z !== null) {
            var ne = La(z);
            (z !== ne || z.tag !== Y && z.tag !== j) && (z = null);
          }
        } else
          H = null, z = a;
        if (H !== z) {
          var He = jn, tt = "onMouseLeave", Je = "onMouseEnter", xt = "mouse";
          (t === "pointerout" || t === "pointerover") && (He = co, tt = "onPointerLeave", Je = "onPointerEnter", xt = "pointer");
          var Pt = H == null ? y : Bc(H), X = z == null ? y : Bc(z), re = new He(tt, xt + "leave", H, i, s);
          re.target = Pt, re.relatedTarget = X;
          var k = null, de = EE(s);
          if (de === a) {
            var Be = new He(Je, xt + "enter", z, i, s);
            Be.target = X, Be.relatedTarget = Pt, k = Be;
          }
          ly(e, re, k, H, z);
        }
      }
    }
    function Gc(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var Fr = typeof Object.is == "function" ? Object.is : Gc;
    function cl(e, t) {
      if (Fr(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), i = Object.keys(t);
      if (a.length !== i.length)
        return !1;
      for (var s = 0; s < a.length; s++) {
        var c = a[s];
        if (!nr.call(t, c) || !Fr(e[c], t[c]))
          return !1;
      }
      return !0;
    }
    function Lf(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function CN(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function iE(e, t) {
      for (var a = Lf(e), i = 0, s = 0; a; ) {
        if (a.nodeType === Ji) {
          if (s = i + a.textContent.length, i <= t && s >= t)
            return {
              node: a,
              offset: t - i
            };
          i = s;
        }
        a = Lf(CN(a));
      }
    }
    function hN(e) {
      var t = e.ownerDocument, a = t && t.defaultView || window, i = a.getSelection && a.getSelection();
      if (!i || i.rangeCount === 0)
        return null;
      var s = i.anchorNode, c = i.anchorOffset, A = i.focusNode, S = i.focusOffset;
      try {
        s.nodeType, A.nodeType;
      } catch {
        return null;
      }
      return oE(e, s, c, A, S);
    }
    function oE(e, t, a, i, s) {
      var c = 0, A = -1, S = -1, p = 0, L = 0, y = e, F = null;
      e:
        for (; ; ) {
          for (var H = null; y === t && (a === 0 || y.nodeType === Ji) && (A = c + a), y === i && (s === 0 || y.nodeType === Ji) && (S = c + s), y.nodeType === Ji && (c += y.nodeValue.length), (H = y.firstChild) !== null; )
            F = y, y = H;
          for (; ; ) {
            if (y === e)
              break e;
            if (F === t && ++p === a && (A = c), F === i && ++L === s && (S = c), (H = y.nextSibling) !== null)
              break;
            y = F, F = y.parentNode;
          }
          y = H;
        }
      return A === -1 || S === -1 ? null : {
        start: A,
        end: S
      };
    }
    function vN(e, t) {
      var a = e.ownerDocument || document, i = a && a.defaultView || window;
      if (i.getSelection) {
        var s = i.getSelection(), c = e.textContent.length, A = Math.min(t.start, c), S = t.end === void 0 ? A : Math.min(t.end, c);
        if (!s.extend && A > S) {
          var p = S;
          S = A, A = p;
        }
        var L = iE(e, A), y = iE(e, S);
        if (L && y) {
          if (s.rangeCount === 1 && s.anchorNode === L.node && s.anchorOffset === L.offset && s.focusNode === y.node && s.focusOffset === y.offset)
            return;
          var F = a.createRange();
          F.setStart(L.node, L.offset), s.removeAllRanges(), A > S ? (s.addRange(F), s.extend(y.node, y.offset)) : (F.setEnd(y.node, y.offset), s.addRange(F));
        }
      }
    }
    function lE(e) {
      return e && e.nodeType === Ji;
    }
    function n(e, t) {
      return !e || !t ? !1 : e === t ? !0 : lE(e) ? !1 : lE(t) ? n(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function r(e) {
      return e && e.ownerDocument && n(e.ownerDocument.documentElement, e);
    }
    function o(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function E() {
      for (var e = window, t = wo(); t instanceof e.HTMLIFrameElement; ) {
        if (o(t))
          e = t.contentWindow;
        else
          return t;
        t = wo(e.document);
      }
      return t;
    }
    function f(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function R() {
      var e = E();
      return {
        focusedElem: e,
        selectionRange: f(e) ? P(e) : null
      };
    }
    function C(e) {
      var t = E(), a = e.focusedElem, i = e.selectionRange;
      if (t !== a && r(a)) {
        i !== null && f(a) && b(a, i);
        for (var s = [], c = a; c = c.parentNode; )
          c.nodeType === aa && s.push({
            element: c,
            left: c.scrollLeft,
            top: c.scrollTop
          });
        typeof a.focus == "function" && a.focus();
        for (var A = 0; A < s.length; A++) {
          var S = s[A];
          S.element.scrollLeft = S.left, S.element.scrollTop = S.top;
        }
      }
    }
    function P(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = hN(e), t || {
        start: 0,
        end: 0
      };
    }
    function b(e, t) {
      var a = t.start, i = t.end;
      i === void 0 && (i = a), "selectionStart" in e ? (e.selectionStart = a, e.selectionEnd = Math.min(i, e.value.length)) : vN(e, t);
    }
    var Z = hn && "documentMode" in document && document.documentMode <= 11;
    function Te() {
      gn("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var fe = null, ue = null, Ue = null, we = !1;
    function ke(e) {
      if ("selectionStart" in e && f(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, a = t.getSelection();
      return {
        anchorNode: a.anchorNode,
        anchorOffset: a.anchorOffset,
        focusNode: a.focusNode,
        focusOffset: a.focusOffset
      };
    }
    function Fn(e) {
      return e.window === e ? e.document : e.nodeType === li ? e : e.ownerDocument;
    }
    function V(e, t, a) {
      var i = Fn(a);
      if (!(we || fe == null || fe !== wo(i))) {
        var s = ke(fe);
        if (!Ue || !cl(Ue, s)) {
          Ue = s;
          var c = td(ue, "onSelect");
          if (c.length > 0) {
            var A = new Ju("onSelect", "select", null, t, a);
            e.push({
              event: A,
              listeners: c
            }), A.target = fe;
          }
        }
      }
    }
    function B(e, t, a, i, s, c, A) {
      var S = a ? Bc(a) : window;
      switch (t) {
        case "focusin":
          (Cf(S) || S.contentEditable === "true") && (fe = S, ue = a, Ue = null);
          break;
        case "focusout":
          fe = null, ue = null, Ue = null;
          break;
        case "mousedown":
          we = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          we = !1, V(e, i, s);
          break;
        case "selectionchange":
          if (Z)
            break;
        case "keydown":
        case "keyup":
          V(e, i, s);
      }
    }
    function K(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    var Ne = {
      animationend: K("Animation", "AnimationEnd"),
      animationiteration: K("Animation", "AnimationIteration"),
      animationstart: K("Animation", "AnimationStart"),
      transitionend: K("Transition", "TransitionEnd")
    }, Ke = {}, rt = {};
    hn && (rt = document.createElement("div").style, "AnimationEvent" in window || (delete Ne.animationend.animation, delete Ne.animationiteration.animation, delete Ne.animationstart.animation), "TransitionEvent" in window || delete Ne.transitionend.transition);
    function $e(e) {
      if (Ke[e])
        return Ke[e];
      if (!Ne[e])
        return e;
      var t = Ne[e];
      for (var a in t)
        if (t.hasOwnProperty(a) && a in rt)
          return Ke[e] = t[a];
      return e;
    }
    var Et = $e("animationend"), er = $e("animationiteration"), Yt = $e("animationstart"), To = $e("transitionend"), $R = /* @__PURE__ */ new Map(), wI = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Ws(e, t) {
      $R.set(e, t), gn(t, [e]);
    }
    function ey() {
      for (var e = 0; e < wI.length; e++) {
        var t = wI[e], a = t.toLowerCase(), i = t[0].toUpperCase() + t.slice(1);
        Ws(a, "on" + i);
      }
      Ws(Et, "onAnimationEnd"), Ws(er, "onAnimationIteration"), Ws(Yt, "onAnimationStart"), Ws("dblclick", "onDoubleClick"), Ws("focusin", "onFocus"), Ws("focusout", "onBlur"), Ws(To, "onTransitionEnd");
    }
    function ty(e, t, a, i, s, c, A) {
      var S = $R.get(t);
      if (S !== void 0) {
        var p = Ju, L = t;
        switch (t) {
          case "keypress":
            if (ju(i) === 0)
              return;
          case "keydown":
          case "keyup":
            p = Dc;
            break;
          case "focusin":
            L = "focus", p = Zu;
            break;
          case "focusout":
            L = "blur", p = Zu;
            break;
          case "beforeblur":
          case "afterblur":
            p = Zu;
            break;
          case "click":
            if (i.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            p = jn;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            p = Xl;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            p = fa;
            break;
          case Et:
          case er:
          case Yt:
            p = Ta;
            break;
          case To:
            p = Af;
            break;
          case "scroll":
            p = wt;
            break;
          case "wheel":
            p = fN;
            break;
          case "copy":
          case "cut":
          case "paste":
            p = Vs;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            p = co;
            break;
        }
        var y = (c & gl) !== 0;
        {
          var F = !y && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", H = iy(a, S, i.type, y, F);
          if (H.length > 0) {
            var z = new p(S, L, null, i, s);
            e.push({
              event: z,
              listeners: H
            });
          }
        }
      }
    }
    ey(), qR(), pN(), Te(), Of();
    function ny(e, t, a, i, s, c, A) {
      ty(e, t, a, i, s, c);
      var S = (c & tN) === 0;
      S && (mf(e, t, a, i, s), IN(e, t, a, i, s), B(e, t, a, i, s), SN(e, t, a, i, s));
    }
    var yf = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], mN = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(yf));
    function YI(e, t, a) {
      var i = e.type || "unknown-event";
      e.currentTarget = a, $i(i, t, void 0, e), e.currentTarget = null;
    }
    function ry(e, t, a) {
      var i;
      if (a)
        for (var s = t.length - 1; s >= 0; s--) {
          var c = t[s], A = c.instance, S = c.currentTarget, p = c.listener;
          if (A !== i && e.isPropagationStopped())
            return;
          YI(e, p, S), i = A;
        }
      else
        for (var L = 0; L < t.length; L++) {
          var y = t[L], F = y.instance, H = y.currentTarget, z = y.listener;
          if (F !== i && e.isPropagationStopped())
            return;
          YI(e, z, H), i = F;
        }
    }
    function VI(e, t) {
      for (var a = (t & gl) !== 0, i = 0; i < e.length; i++) {
        var s = e[i], c = s.event, A = s.listeners;
        ry(c, A, a);
      }
      bT();
    }
    function ay(e, t, a, i, s) {
      var c = kE(a), A = [];
      ny(A, e, i, a, c, t), VI(A, t);
    }
    function Dn(e, t) {
      mN.has(e) || d('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var a = !1, i = GD(t), s = sy(e, a);
      i.has(s) || (WI(t, e, Ou, a), i.add(s));
    }
    function LN(e, t, a) {
      mN.has(e) && !t && d('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var i = 0;
      t && (i |= gl), WI(a, e, i, t);
    }
    var ed = "_reactListening" + Math.random().toString(36).slice(2);
    function Df(e) {
      if (!e[ed]) {
        e[ed] = !0, lt.forEach(function(a) {
          a !== "selectionchange" && (mN.has(a) || LN(a, !1, e), LN(a, !0, e));
        });
        var t = e.nodeType === li ? e : e.ownerDocument;
        t !== null && (t[ed] || (t[ed] = !0, LN("selectionchange", !1, t)));
      }
    }
    function WI(e, t, a, i, s) {
      var c = TN(e, t, a), A = void 0;
      mu && (t === "touchstart" || t === "touchmove" || t === "wheel") && (A = !0), e = e, i ? A !== void 0 ? fi(e, t, c, A) : fr(e, t, c) : A !== void 0 ? al(e, t, c, A) : uf(e, t, c);
    }
    function XI(e, t) {
      return e === t || e.nodeType === Wn && e.parentNode === t;
    }
    function yN(e, t, a, i, s) {
      var c = i;
      if (!(t & Zi) && !(t & Ou)) {
        var A = s;
        if (i !== null) {
          var S = i;
          e:
            for (; ; ) {
              if (S === null)
                return;
              var p = S.tag;
              if (p === g || p === w) {
                var L = S.stateNode.containerInfo;
                if (XI(L, A))
                  break;
                if (p === w)
                  for (var y = S.return; y !== null; ) {
                    var F = y.tag;
                    if (F === g || F === w) {
                      var H = y.stateNode.containerInfo;
                      if (XI(H, A))
                        return;
                    }
                    y = y.return;
                  }
                for (; L !== null; ) {
                  var z = EE(L);
                  if (z === null)
                    return;
                  var Q = z.tag;
                  if (Q === Y || Q === j) {
                    S = c = z;
                    continue e;
                  }
                  L = L.parentNode;
                }
              }
              S = S.return;
            }
        }
      }
      UT(function() {
        return ay(e, t, a, c);
      });
    }
    function gf(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function iy(e, t, a, i, s, c) {
      for (var A = t !== null ? t + "Capture" : null, S = i ? A : t, p = [], L = e, y = null; L !== null; ) {
        var F = L, H = F.stateNode, z = F.tag;
        if (z === Y && H !== null && (y = H, S !== null)) {
          var Q = Ml(L, S);
          Q != null && p.push(gf(L, Q, y));
        }
        if (s)
          break;
        L = L.return;
      }
      return p;
    }
    function td(e, t) {
      for (var a = t + "Capture", i = [], s = e; s !== null; ) {
        var c = s, A = c.stateNode, S = c.tag;
        if (S === Y && A !== null) {
          var p = A, L = Ml(s, a);
          L != null && i.unshift(gf(s, L, p));
          var y = Ml(s, t);
          y != null && i.push(gf(s, y, p));
        }
        s = s.return;
      }
      return i;
    }
    function xc(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== Y);
      return e || null;
    }
    function oy(e, t) {
      for (var a = e, i = t, s = 0, c = a; c; c = xc(c))
        s++;
      for (var A = 0, S = i; S; S = xc(S))
        A++;
      for (; s - A > 0; )
        a = xc(a), s--;
      for (; A - s > 0; )
        i = xc(i), A--;
      for (var p = s; p--; ) {
        if (a === i || i !== null && a === i.alternate)
          return a;
        a = xc(a), i = xc(i);
      }
      return null;
    }
    function kI(e, t, a, i, s) {
      for (var c = t._reactName, A = [], S = a; S !== null && S !== i; ) {
        var p = S, L = p.alternate, y = p.stateNode, F = p.tag;
        if (L !== null && L === i)
          break;
        if (F === Y && y !== null) {
          var H = y;
          if (s) {
            var z = Ml(S, c);
            z != null && A.unshift(gf(S, z, H));
          } else if (!s) {
            var Q = Ml(S, c);
            Q != null && A.push(gf(S, Q, H));
          }
        }
        S = S.return;
      }
      A.length !== 0 && e.push({
        event: t,
        listeners: A
      });
    }
    function ly(e, t, a, i, s) {
      var c = i && s ? oy(i, s) : null;
      i !== null && kI(e, t, i, c, !1), s !== null && a !== null && kI(e, a, s, c, !0);
    }
    function sy(e, t) {
      return e + "__" + (t ? "capture" : "bubble");
    }
    var Qa = !1, Pf = "dangerouslySetInnerHTML", nd = "suppressContentEditableWarning", Xs = "suppressHydrationWarning", KI = "autoFocus", sE = "children", uE = "style", rd = "__html", DN, ad, Mf, jI, id, zI, JI;
    DN = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, ad = function(e, t) {
      XE(e, t), yT(e, t), cR(e, t, {
        registrationNameDependencies: At,
        possibleRegistrationNames: Cn
      });
    }, zI = hn && !document.documentMode, Mf = function(e, t, a) {
      if (!Qa) {
        var i = od(a), s = od(t);
        s !== i && (Qa = !0, d("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(s), JSON.stringify(i)));
      }
    }, jI = function(e) {
      if (!Qa) {
        Qa = !0;
        var t = [];
        e.forEach(function(a) {
          t.push(a);
        }), d("Extra attributes from the server: %s", t);
      }
    }, id = function(e, t) {
      t === !1 ? d("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : d("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, JI = function(e, t) {
      var a = e.namespaceURI === zi ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return a.innerHTML = t, a.innerHTML;
    };
    var uy = /\r\n?/g, Ey = /\u0000|\uFFFD/g;
    function od(e) {
      $r(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(uy, `
`).replace(Ey, "");
    }
    function ld(e, t, a, i) {
      var s = od(t), c = od(e);
      if (c !== s && (i && (Qa || (Qa = !0, d('Text content did not match. Server: "%s" Client: "%s"', c, s))), a && ee))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function QI(e) {
      return e.nodeType === li ? e : e.ownerDocument;
    }
    function cy() {
    }
    function sd(e) {
      e.onclick = cy;
    }
    function Ty(e, t, a, i, s) {
      for (var c in i)
        if (i.hasOwnProperty(c)) {
          var A = i[c];
          if (c === uE)
            A && Object.freeze(A), tR(t, A);
          else if (c === Pf) {
            var S = A ? A[rd] : void 0;
            S != null && XA(t, S);
          } else if (c === sE)
            if (typeof A == "string") {
              var p = e !== "textarea" || A !== "";
              p && wE(t, A);
            } else
              typeof A == "number" && wE(t, "" + A);
          else
            c === nd || c === Xs || c === KI || (At.hasOwnProperty(c) ? A != null && (typeof A != "function" && id(c, A), c === "onScroll" && Dn("scroll", t)) : A != null && ha(t, c, A, s));
        }
    }
    function fy(e, t, a, i) {
      for (var s = 0; s < t.length; s += 2) {
        var c = t[s], A = t[s + 1];
        c === uE ? tR(e, A) : c === Pf ? XA(e, A) : c === sE ? wE(e, A) : ha(e, c, A, i);
      }
    }
    function Ay(e, t, a, i) {
      var s, c = QI(a), A, S = i;
      if (S === zi && (S = BE(e)), S === zi) {
        if (s = Qi(e, t), !s && e !== e.toLowerCase() && d("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var p = c.createElement("div");
          p.innerHTML = "<script><\/script>";
          var L = p.firstChild;
          A = p.removeChild(L);
        } else if (typeof t.is == "string")
          A = c.createElement(e, {
            is: t.is
          });
        else if (A = c.createElement(e), e === "select") {
          var y = A;
          t.multiple ? y.multiple = !0 : t.size && (y.size = t.size);
        }
      } else
        A = c.createElementNS(S, e);
      return S === zi && !s && Object.prototype.toString.call(A) === "[object HTMLUnknownElement]" && !nr.call(DN, e) && (DN[e] = !0, d("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), A;
    }
    function Ry(e, t) {
      return QI(t).createTextNode(e);
    }
    function dy(e, t, a, i) {
      var s = Qi(t, a);
      ad(t, a);
      var c;
      switch (t) {
        case "dialog":
          Dn("cancel", e), Dn("close", e), c = a;
          break;
        case "iframe":
        case "object":
        case "embed":
          Dn("load", e), c = a;
          break;
        case "video":
        case "audio":
          for (var A = 0; A < yf.length; A++)
            Dn(yf[A], e);
          c = a;
          break;
        case "source":
          Dn("error", e), c = a;
          break;
        case "img":
        case "image":
        case "link":
          Dn("error", e), Dn("load", e), c = a;
          break;
        case "details":
          Dn("toggle", e), c = a;
          break;
        case "input":
          _(e, a), c = I(e, a), Dn("invalid", e);
          break;
        case "option":
          nn(e, a), c = a;
          break;
        case "select":
          du(e, a), c = Ru(e, a), Dn("invalid", e);
          break;
        case "textarea":
          YA(e, a), c = NT(e, a), Dn("invalid", e);
          break;
        default:
          c = a;
      }
      switch (VE(t, c), Ty(t, e, i, c, s), t) {
        case "input":
          wa(e), Ce(e, a, !1);
          break;
        case "textarea":
          wa(e), WA(e);
          break;
        case "option":
          un(e, a);
          break;
        case "select":
          dT(e, a);
          break;
        default:
          typeof c.onClick == "function" && sd(e);
          break;
      }
    }
    function Sy(e, t, a, i, s) {
      ad(t, i);
      var c = null, A, S;
      switch (t) {
        case "input":
          A = I(e, a), S = I(e, i), c = [];
          break;
        case "select":
          A = Ru(e, a), S = Ru(e, i), c = [];
          break;
        case "textarea":
          A = NT(e, a), S = NT(e, i), c = [];
          break;
        default:
          A = a, S = i, typeof A.onClick != "function" && typeof S.onClick == "function" && sd(e);
          break;
      }
      VE(t, S);
      var p, L, y = null;
      for (p in A)
        if (!(S.hasOwnProperty(p) || !A.hasOwnProperty(p) || A[p] == null))
          if (p === uE) {
            var F = A[p];
            for (L in F)
              F.hasOwnProperty(L) && (y || (y = {}), y[L] = "");
          } else
            p === Pf || p === sE || p === nd || p === Xs || p === KI || (At.hasOwnProperty(p) ? c || (c = []) : (c = c || []).push(p, null));
      for (p in S) {
        var H = S[p], z = A != null ? A[p] : void 0;
        if (!(!S.hasOwnProperty(p) || H === z || H == null && z == null))
          if (p === uE)
            if (H && Object.freeze(H), z) {
              for (L in z)
                z.hasOwnProperty(L) && (!H || !H.hasOwnProperty(L)) && (y || (y = {}), y[L] = "");
              for (L in H)
                H.hasOwnProperty(L) && z[L] !== H[L] && (y || (y = {}), y[L] = H[L]);
            } else
              y || (c || (c = []), c.push(p, y)), y = H;
          else if (p === Pf) {
            var Q = H ? H[rd] : void 0, ne = z ? z[rd] : void 0;
            Q != null && ne !== Q && (c = c || []).push(p, Q);
          } else
            p === sE ? (typeof H == "string" || typeof H == "number") && (c = c || []).push(p, "" + H) : p === nd || p === Xs || (At.hasOwnProperty(p) ? (H != null && (typeof H != "function" && id(p, H), p === "onScroll" && Dn("scroll", e)), !c && z !== H && (c = [])) : (c = c || []).push(p, H));
      }
      return y && (Nu(y, S[uE]), (c = c || []).push(uE, y)), c;
    }
    function Ny(e, t, a, i, s) {
      a === "input" && s.type === "radio" && s.name != null && J(e, s);
      var c = Qi(a, i), A = Qi(a, s);
      switch (fy(e, t, c, A), a) {
        case "input":
          $(e, s);
          break;
        case "textarea":
          VA(e, s);
          break;
        case "select":
          kS(e, s);
          break;
      }
    }
    function py(e) {
      {
        var t = e.toLowerCase();
        return WE.hasOwnProperty(t) && WE[t] || null;
      }
    }
    function Oy(e, t, a, i, s, c, A) {
      var S, p;
      switch (S = Qi(t, a), ad(t, a), t) {
        case "dialog":
          Dn("cancel", e), Dn("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          Dn("load", e);
          break;
        case "video":
        case "audio":
          for (var L = 0; L < yf.length; L++)
            Dn(yf[L], e);
          break;
        case "source":
          Dn("error", e);
          break;
        case "img":
        case "image":
        case "link":
          Dn("error", e), Dn("load", e);
          break;
        case "details":
          Dn("toggle", e);
          break;
        case "input":
          _(e, a), Dn("invalid", e);
          break;
        case "option":
          nn(e, a);
          break;
        case "select":
          du(e, a), Dn("invalid", e);
          break;
        case "textarea":
          YA(e, a), Dn("invalid", e);
          break;
      }
      VE(t, a);
      {
        p = /* @__PURE__ */ new Set();
        for (var y = e.attributes, F = 0; F < y.length; F++) {
          var H = y[F].name.toLowerCase();
          switch (H) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              p.add(y[F].name);
          }
        }
      }
      var z = null;
      for (var Q in a)
        if (a.hasOwnProperty(Q)) {
          var ne = a[Q];
          if (Q === sE)
            typeof ne == "string" ? e.textContent !== ne && (a[Xs] !== !0 && ld(e.textContent, ne, c, A), z = [sE, ne]) : typeof ne == "number" && e.textContent !== "" + ne && (a[Xs] !== !0 && ld(e.textContent, ne, c, A), z = [sE, "" + ne]);
          else if (At.hasOwnProperty(Q))
            ne != null && (typeof ne != "function" && id(Q, ne), Q === "onScroll" && Dn("scroll", e));
          else if (A && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof S == "boolean") {
            var He = void 0, tt = S && Ye ? null : Mr(Q);
            if (a[Xs] !== !0) {
              if (!(Q === nd || Q === Xs || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Q === "value" || Q === "checked" || Q === "selected")) {
                if (Q === Pf) {
                  var Je = e.innerHTML, xt = ne ? ne[rd] : void 0;
                  if (xt != null) {
                    var Pt = JI(e, xt);
                    Pt !== Je && Mf(Q, Je, Pt);
                  }
                } else if (Q === uE) {
                  if (p.delete(Q), zI) {
                    var X = $S(ne);
                    He = e.getAttribute("style"), X !== He && Mf(Q, He, X);
                  }
                } else if (S && !Ye)
                  p.delete(Q.toLowerCase()), He = hi(e, Q, ne), ne !== He && Mf(Q, He, ne);
                else if (!mn(Q, tt, S) && !tn(Q, ne, tt, S)) {
                  var re = !1;
                  if (tt !== null)
                    p.delete(tt.attributeName), He = Ca(e, Q, ne, tt);
                  else {
                    var k = i;
                    if (k === zi && (k = BE(t)), k === zi)
                      p.delete(Q.toLowerCase());
                    else {
                      var de = py(Q);
                      de !== null && de !== Q && (re = !0, p.delete(de)), p.delete(Q);
                    }
                    He = hi(e, Q, ne);
                  }
                  var Be = Ye;
                  !Be && ne !== He && !re && Mf(Q, He, ne);
                }
              }
            }
          }
        }
      switch (A && // $FlowFixMe - Should be inferred as not undefined.
      p.size > 0 && a[Xs] !== !0 && jI(p), t) {
        case "input":
          wa(e), Ce(e, a, !0);
          break;
        case "textarea":
          wa(e), WA(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof a.onClick == "function" && sd(e);
          break;
      }
      return z;
    }
    function Iy(e, t, a) {
      var i = e.nodeValue !== t;
      return i;
    }
    function gN(e, t) {
      {
        if (Qa)
          return;
        Qa = !0, d("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function PN(e, t) {
      {
        if (Qa)
          return;
        Qa = !0, d('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function MN(e, t, a) {
      {
        if (Qa)
          return;
        Qa = !0, d("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function UN(e, t) {
      {
        if (t === "" || Qa)
          return;
        Qa = !0, d('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function Cy(e, t, a) {
      switch (t) {
        case "input":
          at(e, a);
          return;
        case "textarea":
          pT(e, a);
          return;
        case "select":
          KS(e, a);
          return;
      }
    }
    var Uf = function() {
    }, _f = function() {
    };
    {
      var hy = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], ZI = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], vy = ZI.concat(["button"]), my = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], qI = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      _f = function(e, t) {
        var a = Dt({}, e || qI), i = {
          tag: t
        };
        return ZI.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), vy.indexOf(t) !== -1 && (a.pTagInButtonScope = null), hy.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = i, t === "form" && (a.formTag = i), t === "a" && (a.aTagInScope = i), t === "button" && (a.buttonTagInScope = i), t === "nobr" && (a.nobrTagInScope = i), t === "p" && (a.pTagInButtonScope = i), t === "li" && (a.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = i), a;
      };
      var Ly = function(e, t) {
        switch (t) {
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          case "option":
            return e === "#text";
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          case "colgroup":
            return e === "col" || e === "template";
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return my.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, yy = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, $I = {};
      Uf = function(e, t, a) {
        a = a || qI;
        var i = a.current, s = i && i.tag;
        t != null && (e != null && d("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var c = Ly(e, s) ? null : i, A = c ? null : yy(e, a), S = c || A;
        if (S) {
          var p = S.tag, L = !!c + "|" + e + "|" + p;
          if (!$I[L]) {
            $I[L] = !0;
            var y = e, F = "";
            if (e === "#text" ? /\S/.test(t) ? y = "Text nodes" : (y = "Whitespace text nodes", F = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : y = "<" + e + ">", c) {
              var H = "";
              p === "table" && e === "tr" && (H += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), d("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", y, p, F, H);
            } else
              d("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", y, p);
          }
        }
      };
    }
    var ud = "suppressHydrationWarning", Ed = "$", cd = "/$", Gf = "$?", xf = "$!", Dy = "style", _N = null, GN = null;
    function gy(e) {
      var t, a, i = e.nodeType;
      switch (i) {
        case li:
        case yl: {
          t = i === li ? "#document" : "#fragment";
          var s = e.documentElement;
          a = s ? s.namespaceURI : IT(null, "");
          break;
        }
        default: {
          var c = i === Wn ? e.parentNode : e, A = c.namespaceURI || null;
          t = c.tagName, a = IT(A, t);
          break;
        }
      }
      {
        var S = t.toLowerCase(), p = _f(null, S);
        return {
          namespace: a,
          ancestorInfo: p
        };
      }
    }
    function Py(e, t, a) {
      {
        var i = e, s = IT(i.namespace, t), c = _f(i.ancestorInfo, t);
        return {
          namespace: s,
          ancestorInfo: c
        };
      }
    }
    function GH(e) {
      return e;
    }
    function My(e) {
      _N = BR(), GN = R();
      var t = null;
      return pc(!1), t;
    }
    function Uy(e) {
      C(GN), pc(_N), _N = null, GN = null;
    }
    function _y(e, t, a, i, s) {
      var c;
      {
        var A = i;
        if (Uf(e, null, A.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var S = "" + t.children, p = _f(A.ancestorInfo, e);
          Uf(null, S, p);
        }
        c = A.namespace;
      }
      var L = Ay(e, t, a, c);
      return Bf(s, L), VN(L, t), L;
    }
    function Gy(e, t) {
      e.appendChild(t);
    }
    function xy(e, t, a, i, s) {
      switch (dy(e, t, a, i), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!a.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function by(e, t, a, i, s, c) {
      {
        var A = c;
        if (typeof i.children != typeof a.children && (typeof i.children == "string" || typeof i.children == "number")) {
          var S = "" + i.children, p = _f(A.ancestorInfo, t);
          Uf(null, S, p);
        }
      }
      return Sy(e, t, a, i);
    }
    function xN(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function Hy(e, t, a, i) {
      {
        var s = a;
        Uf(null, e, s.ancestorInfo);
      }
      var c = Ry(e, t);
      return Bf(i, c), c;
    }
    function By() {
      var e = window.event;
      return e === void 0 ? _i : Cc(e.type);
    }
    var bN = typeof setTimeout == "function" ? setTimeout : void 0, Fy = typeof clearTimeout == "function" ? clearTimeout : void 0, HN = -1, eC = typeof Promise == "function" ? Promise : void 0, wy = typeof queueMicrotask == "function" ? queueMicrotask : typeof eC < "u" ? function(e) {
      return eC.resolve(null).then(e).catch(Yy);
    } : bN;
    function Yy(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function Vy(e, t, a, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          return;
        case "img": {
          a.src && (e.src = a.src);
          return;
        }
      }
    }
    function Wy(e, t, a, i, s, c) {
      Ny(e, t, a, i, s), VN(e, s);
    }
    function tC(e) {
      wE(e, "");
    }
    function Xy(e, t, a) {
      e.nodeValue = a;
    }
    function ky(e, t) {
      e.appendChild(t);
    }
    function Ky(e, t) {
      var a;
      e.nodeType === Wn ? (a = e.parentNode, a.insertBefore(t, e)) : (a = e, a.appendChild(t));
      var i = e._reactRootContainer;
      i == null && a.onclick === null && sd(a);
    }
    function jy(e, t, a) {
      e.insertBefore(t, a);
    }
    function zy(e, t, a) {
      e.nodeType === Wn ? e.parentNode.insertBefore(t, a) : e.insertBefore(t, a);
    }
    function Jy(e, t) {
      e.removeChild(t);
    }
    function Qy(e, t) {
      e.nodeType === Wn ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function BN(e, t) {
      var a = t, i = 0;
      do {
        var s = a.nextSibling;
        if (e.removeChild(a), s && s.nodeType === Wn) {
          var c = s.data;
          if (c === cd)
            if (i === 0) {
              e.removeChild(s), Wu(t);
              return;
            } else
              i--;
          else
            (c === Ed || c === Gf || c === xf) && i++;
        }
        a = s;
      } while (a);
      Wu(t);
    }
    function Zy(e, t) {
      e.nodeType === Wn ? BN(e.parentNode, t) : e.nodeType === aa && BN(e, t), Wu(e);
    }
    function qy(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function $y(e) {
      e.nodeValue = "";
    }
    function eD(e, t) {
      e = e;
      var a = t[Dy], i = a != null && a.hasOwnProperty("display") ? a.display : null;
      e.style.display = YE("display", i);
    }
    function tD(e, t) {
      e.nodeValue = t;
    }
    function nD(e) {
      e.nodeType === aa ? e.textContent = "" : e.nodeType === li && e.documentElement && e.removeChild(e.documentElement);
    }
    function rD(e, t, a) {
      return e.nodeType !== aa || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function aD(e, t) {
      return t === "" || e.nodeType !== Ji ? null : e;
    }
    function iD(e) {
      return e.nodeType !== Wn ? null : e;
    }
    function nC(e) {
      return e.data === Gf;
    }
    function FN(e) {
      return e.data === xf;
    }
    function oD(e) {
      var t = e.nextSibling && e.nextSibling.dataset, a, i, s;
      return t && (a = t.dgst, i = t.msg, s = t.stck), {
        message: i,
        digest: a,
        stack: s
      };
    }
    function lD(e, t) {
      e._reactRetry = t;
    }
    function Td(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === aa || t === Ji)
          break;
        if (t === Wn) {
          var a = e.data;
          if (a === Ed || a === xf || a === Gf)
            break;
          if (a === cd)
            return null;
        }
      }
      return e;
    }
    function bf(e) {
      return Td(e.nextSibling);
    }
    function sD(e) {
      return Td(e.firstChild);
    }
    function uD(e) {
      return Td(e.firstChild);
    }
    function ED(e) {
      return Td(e.nextSibling);
    }
    function cD(e, t, a, i, s, c, A) {
      Bf(c, e), VN(e, a);
      var S;
      {
        var p = s;
        S = p.namespace;
      }
      var L = (c.mode & St) !== ze;
      return Oy(e, t, a, S, i, L, A);
    }
    function TD(e, t, a, i) {
      return Bf(a, e), a.mode & St, Iy(e, t);
    }
    function fD(e, t) {
      Bf(t, e);
    }
    function AD(e) {
      for (var t = e.nextSibling, a = 0; t; ) {
        if (t.nodeType === Wn) {
          var i = t.data;
          if (i === cd) {
            if (a === 0)
              return bf(t);
            a--;
          } else
            (i === Ed || i === xf || i === Gf) && a++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function rC(e) {
      for (var t = e.previousSibling, a = 0; t; ) {
        if (t.nodeType === Wn) {
          var i = t.data;
          if (i === Ed || i === xf || i === Gf) {
            if (a === 0)
              return t;
            a--;
          } else
            i === cd && a++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function RD(e) {
      Wu(e);
    }
    function dD(e) {
      Wu(e);
    }
    function SD(e) {
      return e !== "head" && e !== "body";
    }
    function ND(e, t, a, i) {
      var s = !0;
      ld(t.nodeValue, a, i, s);
    }
    function pD(e, t, a, i, s, c) {
      if (t[ud] !== !0) {
        var A = !0;
        ld(i.nodeValue, s, c, A);
      }
    }
    function OD(e, t) {
      t.nodeType === aa ? gN(e, t) : t.nodeType === Wn || PN(e, t);
    }
    function ID(e, t) {
      {
        var a = e.parentNode;
        a !== null && (t.nodeType === aa ? gN(a, t) : t.nodeType === Wn || PN(a, t));
      }
    }
    function CD(e, t, a, i, s) {
      (s || t[ud] !== !0) && (i.nodeType === aa ? gN(a, i) : i.nodeType === Wn || PN(a, i));
    }
    function hD(e, t, a) {
      MN(e, t);
    }
    function vD(e, t) {
      UN(e, t);
    }
    function mD(e, t, a) {
      {
        var i = e.parentNode;
        i !== null && MN(i, t);
      }
    }
    function LD(e, t) {
      {
        var a = e.parentNode;
        a !== null && UN(a, t);
      }
    }
    function yD(e, t, a, i, s, c) {
      (c || t[ud] !== !0) && MN(a, i);
    }
    function DD(e, t, a, i, s) {
      (s || t[ud] !== !0) && UN(a, i);
    }
    function gD(e) {
      d("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function PD(e) {
      Df(e);
    }
    var bc = Math.random().toString(36).slice(2), Hc = "__reactFiber$" + bc, wN = "__reactProps$" + bc, Hf = "__reactContainer$" + bc, YN = "__reactEvents$" + bc, MD = "__reactListeners$" + bc, UD = "__reactHandles$" + bc;
    function _D(e) {
      delete e[Hc], delete e[wN], delete e[YN], delete e[MD], delete e[UD];
    }
    function Bf(e, t) {
      t[Hc] = e;
    }
    function fd(e, t) {
      t[Hf] = e;
    }
    function aC(e) {
      e[Hf] = null;
    }
    function Ff(e) {
      return !!e[Hf];
    }
    function EE(e) {
      var t = e[Hc];
      if (t)
        return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[Hf] || a[Hc], t) {
          var i = t.alternate;
          if (t.child !== null || i !== null && i.child !== null)
            for (var s = rC(e); s !== null; ) {
              var c = s[Hc];
              if (c)
                return c;
              s = rC(s);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function ks(e) {
      var t = e[Hc] || e[Hf];
      return t && (t.tag === Y || t.tag === j || t.tag === ye || t.tag === g) ? t : null;
    }
    function Bc(e) {
      if (e.tag === Y || e.tag === j)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Ad(e) {
      return e[wN] || null;
    }
    function VN(e, t) {
      e[wN] = t;
    }
    function GD(e) {
      var t = e[YN];
      return t === void 0 && (t = e[YN] = /* @__PURE__ */ new Set()), t;
    }
    var iC = {}, oC = T.ReactDebugCurrentFrame;
    function Rd(e) {
      if (e) {
        var t = e._owner, a = Di(e.type, e._source, t ? t.type : null);
        oC.setExtraStackFrame(a);
      } else
        oC.setExtraStackFrame(null);
    }
    function fo(e, t, a, i, s) {
      {
        var c = Function.call.bind(nr);
        for (var A in e)
          if (c(e, A)) {
            var S = void 0;
            try {
              if (typeof e[A] != "function") {
                var p = Error((i || "React class") + ": " + a + " type `" + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[A] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw p.name = "Invariant Violation", p;
              }
              S = e[A](t, A, i, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              S = L;
            }
            S && !(S instanceof Error) && (Rd(s), d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", a, A, typeof S), Rd(null)), S instanceof Error && !(S.message in iC) && (iC[S.message] = !0, Rd(s), d("Failed %s type: %s", a, S.message), Rd(null));
          }
      }
    }
    var WN = [], dd;
    dd = [];
    var zl = -1;
    function Ks(e) {
      return {
        current: e
      };
    }
    function Aa(e, t) {
      if (zl < 0) {
        d("Unexpected pop.");
        return;
      }
      t !== dd[zl] && d("Unexpected Fiber popped."), e.current = WN[zl], WN[zl] = null, dd[zl] = null, zl--;
    }
    function Ra(e, t, a) {
      zl++, WN[zl] = e.current, dd[zl] = a, e.current = t;
    }
    var XN;
    XN = {};
    var Si = {};
    Object.freeze(Si);
    var Jl = Ks(Si), Tl = Ks(!1), kN = Si;
    function Fc(e, t, a) {
      return a && fl(t) ? kN : Jl.current;
    }
    function lC(e, t, a) {
      {
        var i = e.stateNode;
        i.__reactInternalMemoizedUnmaskedChildContext = t, i.__reactInternalMemoizedMaskedChildContext = a;
      }
    }
    function wc(e, t) {
      {
        var a = e.type, i = a.contextTypes;
        if (!i)
          return Si;
        var s = e.stateNode;
        if (s && s.__reactInternalMemoizedUnmaskedChildContext === t)
          return s.__reactInternalMemoizedMaskedChildContext;
        var c = {};
        for (var A in i)
          c[A] = t[A];
        {
          var S = ct(e) || "Unknown";
          fo(i, c, "context", S);
        }
        return s && lC(e, t, c), c;
      }
    }
    function Sd() {
      return Tl.current;
    }
    function fl(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function Nd(e) {
      Aa(Tl, e), Aa(Jl, e);
    }
    function KN(e) {
      Aa(Tl, e), Aa(Jl, e);
    }
    function sC(e, t, a) {
      {
        if (Jl.current !== Si)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Ra(Jl, t, e), Ra(Tl, a, e);
      }
    }
    function uC(e, t, a) {
      {
        var i = e.stateNode, s = t.childContextTypes;
        if (typeof i.getChildContext != "function") {
          {
            var c = ct(e) || "Unknown";
            XN[c] || (XN[c] = !0, d("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", c, c));
          }
          return a;
        }
        var A = i.getChildContext();
        for (var S in A)
          if (!(S in s))
            throw new Error((ct(e) || "Unknown") + '.getChildContext(): key "' + S + '" is not defined in childContextTypes.');
        {
          var p = ct(e) || "Unknown";
          fo(s, A, "child context", p);
        }
        return Dt({}, a, A);
      }
    }
    function pd(e) {
      {
        var t = e.stateNode, a = t && t.__reactInternalMemoizedMergedChildContext || Si;
        return kN = Jl.current, Ra(Jl, a, e), Ra(Tl, Tl.current, e), !0;
      }
    }
    function EC(e, t, a) {
      {
        var i = e.stateNode;
        if (!i)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (a) {
          var s = uC(e, t, kN);
          i.__reactInternalMemoizedMergedChildContext = s, Aa(Tl, e), Aa(Jl, e), Ra(Jl, s, e), Ra(Tl, a, e);
        } else
          Aa(Tl, e), Ra(Tl, a, e);
      }
    }
    function xD(e) {
      {
        if (!YT(e) || e.tag !== v)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case g:
              return t.stateNode.context;
            case v: {
              var a = t.type;
              if (fl(a))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var js = 0, Od = 1, Ql = null, jN = !1, zN = !1;
    function cC(e) {
      Ql === null ? Ql = [e] : Ql.push(e);
    }
    function bD(e) {
      jN = !0, cC(e);
    }
    function TC() {
      jN && zs();
    }
    function zs() {
      if (!zN && Ql !== null) {
        zN = !0;
        var e = 0, t = Ja();
        try {
          var a = !0, i = Ql;
          for ($n(Tr); e < i.length; e++) {
            var s = i[e];
            do
              s = s(a);
            while (s !== null);
          }
          Ql = null, jN = !1;
        } catch (c) {
          throw Ql !== null && (Ql = Ql.slice(e + 1)), qE(XT, zs), c;
        } finally {
          $n(t), zN = !1;
        }
      }
      return null;
    }
    var Yc = [], Vc = 0, Id = null, Cd = 0, xi = [], bi = 0, cE = null, Zl = 1, ql = "";
    function HD(e) {
      return fE(), (e.flags & BT) !== qe;
    }
    function BD(e) {
      return fE(), Cd;
    }
    function FD() {
      var e = ql, t = Zl, a = t & ~wD(t);
      return a.toString(32) + e;
    }
    function TE(e, t) {
      fE(), Yc[Vc++] = Cd, Yc[Vc++] = Id, Id = e, Cd = t;
    }
    function fC(e, t, a) {
      fE(), xi[bi++] = Zl, xi[bi++] = ql, xi[bi++] = cE, cE = e;
      var i = Zl, s = ql, c = hd(i) - 1, A = i & ~(1 << c), S = a + 1, p = hd(t) + c;
      if (p > 30) {
        var L = c - c % 5, y = (1 << L) - 1, F = (A & y).toString(32), H = A >> L, z = c - L, Q = hd(t) + z, ne = S << z, He = ne | H, tt = F + s;
        Zl = 1 << Q | He, ql = tt;
      } else {
        var Je = S << c, xt = Je | A, Pt = s;
        Zl = 1 << p | xt, ql = Pt;
      }
    }
    function JN(e) {
      fE();
      var t = e.return;
      if (t !== null) {
        var a = 1, i = 0;
        TE(e, a), fC(e, a, i);
      }
    }
    function hd(e) {
      return 32 - to(e);
    }
    function wD(e) {
      return 1 << hd(e) - 1;
    }
    function QN(e) {
      for (; e === Id; )
        Id = Yc[--Vc], Yc[Vc] = null, Cd = Yc[--Vc], Yc[Vc] = null;
      for (; e === cE; )
        cE = xi[--bi], xi[bi] = null, ql = xi[--bi], xi[bi] = null, Zl = xi[--bi], xi[bi] = null;
    }
    function YD() {
      return fE(), cE !== null ? {
        id: Zl,
        overflow: ql
      } : null;
    }
    function VD(e, t) {
      fE(), xi[bi++] = Zl, xi[bi++] = ql, xi[bi++] = cE, Zl = t.id, ql = t.overflow, cE = e;
    }
    function fE() {
      Yr() || d("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var wr = null, Hi = null, Ao = !1, AE = !1, Js = null;
    function WD() {
      Ao && d("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function AC() {
      AE = !0;
    }
    function XD() {
      return AE;
    }
    function kD(e) {
      var t = e.stateNode.containerInfo;
      return Hi = uD(t), wr = e, Ao = !0, Js = null, AE = !1, !0;
    }
    function KD(e, t, a) {
      return Hi = ED(t), wr = e, Ao = !0, Js = null, AE = !1, a !== null && VD(e, a), !0;
    }
    function RC(e, t) {
      switch (e.tag) {
        case g: {
          OD(e.stateNode.containerInfo, t);
          break;
        }
        case Y: {
          var a = (e.mode & St) !== ze;
          CD(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            a
          );
          break;
        }
        case ye: {
          var i = e.memoizedState;
          i.dehydrated !== null && ID(i.dehydrated, t);
          break;
        }
      }
    }
    function dC(e, t) {
      RC(e, t);
      var a = JM();
      a.stateNode = t, a.return = e;
      var i = e.deletions;
      i === null ? (e.deletions = [a], e.flags |= jt) : i.push(a);
    }
    function ZN(e, t) {
      {
        if (AE)
          return;
        switch (e.tag) {
          case g: {
            var a = e.stateNode.containerInfo;
            switch (t.tag) {
              case Y:
                var i = t.type;
                t.pendingProps, hD(a, i);
                break;
              case j:
                var s = t.pendingProps;
                vD(a, s);
                break;
            }
            break;
          }
          case Y: {
            var c = e.type, A = e.memoizedProps, S = e.stateNode;
            switch (t.tag) {
              case Y: {
                var p = t.type, L = t.pendingProps, y = (e.mode & St) !== ze;
                yD(
                  c,
                  A,
                  S,
                  p,
                  L,
                  // TODO: Delete this argument when we remove the legacy root API.
                  y
                );
                break;
              }
              case j: {
                var F = t.pendingProps, H = (e.mode & St) !== ze;
                DD(
                  c,
                  A,
                  S,
                  F,
                  // TODO: Delete this argument when we remove the legacy root API.
                  H
                );
                break;
              }
            }
            break;
          }
          case ye: {
            var z = e.memoizedState, Q = z.dehydrated;
            if (Q !== null)
              switch (t.tag) {
                case Y:
                  var ne = t.type;
                  t.pendingProps, mD(Q, ne);
                  break;
                case j:
                  var He = t.pendingProps;
                  LD(Q, He);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function SC(e, t) {
      t.flags = t.flags & ~Xa | dn, ZN(e, t);
    }
    function NC(e, t) {
      switch (e.tag) {
        case Y: {
          var a = e.type;
          e.pendingProps;
          var i = rD(t, a);
          return i !== null ? (e.stateNode = i, wr = e, Hi = sD(i), !0) : !1;
        }
        case j: {
          var s = e.pendingProps, c = aD(t, s);
          return c !== null ? (e.stateNode = c, wr = e, Hi = null, !0) : !1;
        }
        case ye: {
          var A = iD(t);
          if (A !== null) {
            var S = {
              dehydrated: A,
              treeContext: YD(),
              retryLane: cn
            };
            e.memoizedState = S;
            var p = QM(A);
            return p.return = e, e.child = p, wr = e, Hi = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function qN(e) {
      return (e.mode & St) !== ze && (e.flags & Tt) === qe;
    }
    function $N(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function ep(e) {
      if (Ao) {
        var t = Hi;
        if (!t) {
          qN(e) && (ZN(wr, e), $N()), SC(wr, e), Ao = !1, wr = e;
          return;
        }
        var a = t;
        if (!NC(e, t)) {
          qN(e) && (ZN(wr, e), $N()), t = bf(a);
          var i = wr;
          if (!t || !NC(e, t)) {
            SC(wr, e), Ao = !1, wr = e;
            return;
          }
          dC(i, a);
        }
      }
    }
    function jD(e, t, a) {
      var i = e.stateNode, s = !AE, c = cD(i, e.type, e.memoizedProps, t, a, e, s);
      return e.updateQueue = c, c !== null;
    }
    function zD(e) {
      var t = e.stateNode, a = e.memoizedProps, i = TD(t, a, e);
      if (i) {
        var s = wr;
        if (s !== null)
          switch (s.tag) {
            case g: {
              var c = s.stateNode.containerInfo, A = (s.mode & St) !== ze;
              ND(
                c,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                A
              );
              break;
            }
            case Y: {
              var S = s.type, p = s.memoizedProps, L = s.stateNode, y = (s.mode & St) !== ze;
              pD(
                S,
                p,
                L,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                y
              );
              break;
            }
          }
      }
      return i;
    }
    function JD(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      fD(a, e);
    }
    function QD(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return AD(a);
    }
    function pC(e) {
      for (var t = e.return; t !== null && t.tag !== Y && t.tag !== g && t.tag !== ye; )
        t = t.return;
      wr = t;
    }
    function vd(e) {
      if (e !== wr)
        return !1;
      if (!Ao)
        return pC(e), Ao = !0, !1;
      if (e.tag !== g && (e.tag !== Y || SD(e.type) && !xN(e.type, e.memoizedProps))) {
        var t = Hi;
        if (t)
          if (qN(e))
            OC(e), $N();
          else
            for (; t; )
              dC(e, t), t = bf(t);
      }
      return pC(e), e.tag === ye ? Hi = QD(e) : Hi = wr ? bf(e.stateNode) : null, !0;
    }
    function ZD() {
      return Ao && Hi !== null;
    }
    function OC(e) {
      for (var t = Hi; t; )
        RC(e, t), t = bf(t);
    }
    function Wc() {
      wr = null, Hi = null, Ao = !1, AE = !1;
    }
    function IC() {
      Js !== null && (Av(Js), Js = null);
    }
    function Yr() {
      return Ao;
    }
    function tp(e) {
      Js === null ? Js = [e] : Js.push(e);
    }
    var qD = T.ReactCurrentBatchConfig, $D = null;
    function eg() {
      return qD.transition;
    }
    var Ro = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var tg = function(e) {
        for (var t = null, a = e; a !== null; )
          a.mode & bn && (t = a), a = a.return;
        return t;
      }, RE = function(e) {
        var t = [];
        return e.forEach(function(a) {
          t.push(a);
        }), t.sort().join(", ");
      }, wf = [], Yf = [], Vf = [], Wf = [], Xf = [], kf = [], dE = /* @__PURE__ */ new Set();
      Ro.recordUnsafeLifecycleWarnings = function(e, t) {
        dE.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && wf.push(e), e.mode & bn && typeof t.UNSAFE_componentWillMount == "function" && Yf.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Vf.push(e), e.mode & bn && typeof t.UNSAFE_componentWillReceiveProps == "function" && Wf.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && Xf.push(e), e.mode & bn && typeof t.UNSAFE_componentWillUpdate == "function" && kf.push(e));
      }, Ro.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        wf.length > 0 && (wf.forEach(function(H) {
          e.add(ct(H) || "Component"), dE.add(H.type);
        }), wf = []);
        var t = /* @__PURE__ */ new Set();
        Yf.length > 0 && (Yf.forEach(function(H) {
          t.add(ct(H) || "Component"), dE.add(H.type);
        }), Yf = []);
        var a = /* @__PURE__ */ new Set();
        Vf.length > 0 && (Vf.forEach(function(H) {
          a.add(ct(H) || "Component"), dE.add(H.type);
        }), Vf = []);
        var i = /* @__PURE__ */ new Set();
        Wf.length > 0 && (Wf.forEach(function(H) {
          i.add(ct(H) || "Component"), dE.add(H.type);
        }), Wf = []);
        var s = /* @__PURE__ */ new Set();
        Xf.length > 0 && (Xf.forEach(function(H) {
          s.add(ct(H) || "Component"), dE.add(H.type);
        }), Xf = []);
        var c = /* @__PURE__ */ new Set();
        if (kf.length > 0 && (kf.forEach(function(H) {
          c.add(ct(H) || "Component"), dE.add(H.type);
        }), kf = []), t.size > 0) {
          var A = RE(t);
          d(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, A);
        }
        if (i.size > 0) {
          var S = RE(i);
          d(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, S);
        }
        if (c.size > 0) {
          var p = RE(c);
          d(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, p);
        }
        if (e.size > 0) {
          var L = RE(e);
          h(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, L);
        }
        if (a.size > 0) {
          var y = RE(a);
          h(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, y);
        }
        if (s.size > 0) {
          var F = RE(s);
          h(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, F);
        }
      };
      var md = /* @__PURE__ */ new Map(), CC = /* @__PURE__ */ new Set();
      Ro.recordLegacyContextWarning = function(e, t) {
        var a = tg(e);
        if (a === null) {
          d("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!CC.has(e.type)) {
          var i = md.get(a);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], md.set(a, i)), i.push(e));
        }
      }, Ro.flushLegacyContextWarning = function() {
        md.forEach(function(e, t) {
          if (e.length !== 0) {
            var a = e[0], i = /* @__PURE__ */ new Set();
            e.forEach(function(c) {
              i.add(ct(c) || "Component"), CC.add(c.type);
            });
            var s = RE(i);
            try {
              Zt(a), d(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, s);
            } finally {
              Pn();
            }
          }
        });
      }, Ro.discardPendingWarnings = function() {
        wf = [], Yf = [], Vf = [], Wf = [], Xf = [], kf = [], md = /* @__PURE__ */ new Map();
      };
    }
    function So(e, t) {
      if (e && e.defaultProps) {
        var a = Dt({}, t), i = e.defaultProps;
        for (var s in i)
          a[s] === void 0 && (a[s] = i[s]);
        return a;
      }
      return t;
    }
    var np = Ks(null), rp;
    rp = {};
    var Ld = null, Xc = null, ap = null, yd = !1;
    function Dd() {
      Ld = null, Xc = null, ap = null, yd = !1;
    }
    function hC() {
      yd = !0;
    }
    function vC() {
      yd = !1;
    }
    function mC(e, t, a) {
      Ra(np, t._currentValue, e), t._currentValue = a, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== rp && d("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = rp;
    }
    function ip(e, t) {
      var a = np.current;
      Aa(np, t), e._currentValue = a;
    }
    function op(e, t, a) {
      for (var i = e; i !== null; ) {
        var s = i.alternate;
        if (Vl(i.childLanes, t) ? s !== null && !Vl(s.childLanes, t) && (s.childLanes = Nt(s.childLanes, t)) : (i.childLanes = Nt(i.childLanes, t), s !== null && (s.childLanes = Nt(s.childLanes, t))), i === a)
          break;
        i = i.return;
      }
      i !== a && d("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function ng(e, t, a) {
      rg(e, t, a);
    }
    function rg(e, t, a) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null; ) {
        var s = void 0, c = i.dependencies;
        if (c !== null) {
          s = i.child;
          for (var A = c.firstContext; A !== null; ) {
            if (A.context === t) {
              if (i.tag === v) {
                var S = Yl(a), p = $l(an, S);
                p.tag = Pd;
                var L = i.updateQueue;
                if (L !== null) {
                  var y = L.shared, F = y.pending;
                  F === null ? p.next = p : (p.next = F.next, F.next = p), y.pending = p;
                }
              }
              i.lanes = Nt(i.lanes, a);
              var H = i.alternate;
              H !== null && (H.lanes = Nt(H.lanes, a)), op(i.return, a, e), c.lanes = Nt(c.lanes, a);
              break;
            }
            A = A.next;
          }
        } else if (i.tag === Oe)
          s = i.type === e.type ? null : i.child;
        else if (i.tag === Qe) {
          var z = i.return;
          if (z === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          z.lanes = Nt(z.lanes, a);
          var Q = z.alternate;
          Q !== null && (Q.lanes = Nt(Q.lanes, a)), op(z, a, e), s = i.sibling;
        } else
          s = i.child;
        if (s !== null)
          s.return = i;
        else
          for (s = i; s !== null; ) {
            if (s === e) {
              s = null;
              break;
            }
            var ne = s.sibling;
            if (ne !== null) {
              ne.return = s.return, s = ne;
              break;
            }
            s = s.return;
          }
        i = s;
      }
    }
    function kc(e, t) {
      Ld = e, Xc = null, ap = null;
      var a = e.dependencies;
      if (a !== null) {
        var i = a.firstContext;
        i !== null && (ca(a.lanes, t) && iA(), a.firstContext = null);
      }
    }
    function sr(e) {
      yd && d("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (ap !== e) {
        var a = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (Xc === null) {
          if (Ld === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Xc = a, Ld.dependencies = {
            lanes: se,
            firstContext: a
          };
        } else
          Xc = Xc.next = a;
      }
      return t;
    }
    var SE = null;
    function lp(e) {
      SE === null ? SE = [e] : SE.push(e);
    }
    function ag() {
      if (SE !== null) {
        for (var e = 0; e < SE.length; e++) {
          var t = SE[e], a = t.interleaved;
          if (a !== null) {
            t.interleaved = null;
            var i = a.next, s = t.pending;
            if (s !== null) {
              var c = s.next;
              s.next = i, a.next = c;
            }
            t.pending = a;
          }
        }
        SE = null;
      }
    }
    function LC(e, t, a, i) {
      var s = t.interleaved;
      return s === null ? (a.next = a, lp(t)) : (a.next = s.next, s.next = a), t.interleaved = a, gd(e, i);
    }
    function ig(e, t, a, i) {
      var s = t.interleaved;
      s === null ? (a.next = a, lp(t)) : (a.next = s.next, s.next = a), t.interleaved = a;
    }
    function og(e, t, a, i) {
      var s = t.interleaved;
      return s === null ? (a.next = a, lp(t)) : (a.next = s.next, s.next = a), t.interleaved = a, gd(e, i);
    }
    function Za(e, t) {
      return gd(e, t);
    }
    var lg = gd;
    function gd(e, t) {
      e.lanes = Nt(e.lanes, t);
      var a = e.alternate;
      a !== null && (a.lanes = Nt(a.lanes, t)), a === null && (e.flags & (dn | Xa)) !== qe && Lv(e);
      for (var i = e, s = e.return; s !== null; )
        s.childLanes = Nt(s.childLanes, t), a = s.alternate, a !== null ? a.childLanes = Nt(a.childLanes, t) : (s.flags & (dn | Xa)) !== qe && Lv(e), i = s, s = s.return;
      if (i.tag === g) {
        var c = i.stateNode;
        return c;
      } else
        return null;
    }
    var yC = 0, DC = 1, Pd = 2, sp = 3, Md = !1, up, Ud;
    up = !1, Ud = null;
    function Ep(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: se
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function gC(e, t) {
      var a = t.updateQueue, i = e.updateQueue;
      if (a === i) {
        var s = {
          baseState: i.baseState,
          firstBaseUpdate: i.firstBaseUpdate,
          lastBaseUpdate: i.lastBaseUpdate,
          shared: i.shared,
          effects: i.effects
        };
        t.updateQueue = s;
      }
    }
    function $l(e, t) {
      var a = {
        eventTime: e,
        lane: t,
        tag: yC,
        payload: null,
        callback: null,
        next: null
      };
      return a;
    }
    function Qs(e, t, a) {
      var i = e.updateQueue;
      if (i === null)
        return null;
      var s = i.shared;
      if (Ud === s && !up && (d("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), up = !0), lM()) {
        var c = s.pending;
        return c === null ? t.next = t : (t.next = c.next, c.next = t), s.pending = t, lg(e, a);
      } else
        return og(e, s, t, a);
    }
    function _d(e, t, a) {
      var i = t.updateQueue;
      if (i !== null) {
        var s = i.shared;
        if (qT(a)) {
          var c = s.lanes;
          c = $T(c, e.pendingLanes);
          var A = Nt(c, a);
          s.lanes = A, cc(e, A);
        }
      }
    }
    function cp(e, t) {
      var a = e.updateQueue, i = e.alternate;
      if (i !== null) {
        var s = i.updateQueue;
        if (a === s) {
          var c = null, A = null, S = a.firstBaseUpdate;
          if (S !== null) {
            var p = S;
            do {
              var L = {
                eventTime: p.eventTime,
                lane: p.lane,
                tag: p.tag,
                payload: p.payload,
                callback: p.callback,
                next: null
              };
              A === null ? c = A = L : (A.next = L, A = L), p = p.next;
            } while (p !== null);
            A === null ? c = A = t : (A.next = t, A = t);
          } else
            c = A = t;
          a = {
            baseState: s.baseState,
            firstBaseUpdate: c,
            lastBaseUpdate: A,
            shared: s.shared,
            effects: s.effects
          }, e.updateQueue = a;
          return;
        }
      }
      var y = a.lastBaseUpdate;
      y === null ? a.firstBaseUpdate = t : y.next = t, a.lastBaseUpdate = t;
    }
    function sg(e, t, a, i, s, c) {
      switch (a.tag) {
        case DC: {
          var A = a.payload;
          if (typeof A == "function") {
            hC();
            var S = A.call(c, i, s);
            {
              if (e.mode & bn) {
                rn(!0);
                try {
                  A.call(c, i, s);
                } finally {
                  rn(!1);
                }
              }
              vC();
            }
            return S;
          }
          return A;
        }
        case sp:
          e.flags = e.flags & ~or | Tt;
        case yC: {
          var p = a.payload, L;
          if (typeof p == "function") {
            hC(), L = p.call(c, i, s);
            {
              if (e.mode & bn) {
                rn(!0);
                try {
                  p.call(c, i, s);
                } finally {
                  rn(!1);
                }
              }
              vC();
            }
          } else
            L = p;
          return L == null ? i : Dt({}, i, L);
        }
        case Pd:
          return Md = !0, i;
      }
      return i;
    }
    function Gd(e, t, a, i) {
      var s = e.updateQueue;
      Md = !1, Ud = s.shared;
      var c = s.firstBaseUpdate, A = s.lastBaseUpdate, S = s.shared.pending;
      if (S !== null) {
        s.shared.pending = null;
        var p = S, L = p.next;
        p.next = null, A === null ? c = L : A.next = L, A = p;
        var y = e.alternate;
        if (y !== null) {
          var F = y.updateQueue, H = F.lastBaseUpdate;
          H !== A && (H === null ? F.firstBaseUpdate = L : H.next = L, F.lastBaseUpdate = p);
        }
      }
      if (c !== null) {
        var z = s.baseState, Q = se, ne = null, He = null, tt = null, Je = c;
        do {
          var xt = Je.lane, Pt = Je.eventTime;
          if (Vl(i, xt)) {
            if (tt !== null) {
              var re = {
                eventTime: Pt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Xn,
                tag: Je.tag,
                payload: Je.payload,
                callback: Je.callback,
                next: null
              };
              tt = tt.next = re;
            }
            z = sg(e, s, Je, z, t, a);
            var k = Je.callback;
            if (k !== null && // If the update was already committed, we should not queue its
            // callback again.
            Je.lane !== Xn) {
              e.flags |= Mi;
              var de = s.effects;
              de === null ? s.effects = [Je] : de.push(Je);
            }
          } else {
            var X = {
              eventTime: Pt,
              lane: xt,
              tag: Je.tag,
              payload: Je.payload,
              callback: Je.callback,
              next: null
            };
            tt === null ? (He = tt = X, ne = z) : tt = tt.next = X, Q = Nt(Q, xt);
          }
          if (Je = Je.next, Je === null) {
            if (S = s.shared.pending, S === null)
              break;
            var Be = S, _e = Be.next;
            Be.next = null, Je = _e, s.lastBaseUpdate = Be, s.shared.pending = null;
          }
        } while (!0);
        tt === null && (ne = z), s.baseState = ne, s.firstBaseUpdate = He, s.lastBaseUpdate = tt;
        var st = s.shared.interleaved;
        if (st !== null) {
          var Rt = st;
          do
            Q = Nt(Q, Rt.lane), Rt = Rt.next;
          while (Rt !== st);
        } else
          c === null && (s.shared.lanes = se);
        SA(Q), e.lanes = Q, e.memoizedState = z;
      }
      Ud = null;
    }
    function ug(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function PC() {
      Md = !1;
    }
    function xd() {
      return Md;
    }
    function MC(e, t, a) {
      var i = t.effects;
      if (t.effects = null, i !== null)
        for (var s = 0; s < i.length; s++) {
          var c = i[s], A = c.callback;
          A !== null && (c.callback = null, ug(A, a));
        }
    }
    var Tp = {}, UC = new l.Component().refs, fp, Ap, Rp, dp, Sp, _C, bd, Np, pp, Op;
    {
      fp = /* @__PURE__ */ new Set(), Ap = /* @__PURE__ */ new Set(), Rp = /* @__PURE__ */ new Set(), dp = /* @__PURE__ */ new Set(), Np = /* @__PURE__ */ new Set(), Sp = /* @__PURE__ */ new Set(), pp = /* @__PURE__ */ new Set(), Op = /* @__PURE__ */ new Set();
      var GC = /* @__PURE__ */ new Set();
      bd = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var a = t + "_" + e;
          GC.has(a) || (GC.add(a), d("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, _C = function(e, t) {
        if (t === void 0) {
          var a = Bt(e) || "Component";
          Sp.has(a) || (Sp.add(a), d("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", a));
        }
      }, Object.defineProperty(Tp, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Tp);
    }
    function Ip(e, t, a, i) {
      var s = e.memoizedState, c = a(i, s);
      {
        if (e.mode & bn) {
          rn(!0);
          try {
            c = a(i, s);
          } finally {
            rn(!1);
          }
        }
        _C(t, c);
      }
      var A = c == null ? s : Dt({}, s, c);
      if (e.memoizedState = A, e.lanes === se) {
        var S = e.updateQueue;
        S.baseState = A;
      }
    }
    var Cp = {
      isMounted: ya,
      enqueueSetState: function(e, t, a) {
        var i = Va(e), s = xa(), c = au(i), A = $l(s, c);
        A.payload = t, a != null && (bd(a, "setState"), A.callback = a);
        var S = Qs(i, A, c);
        S !== null && (Or(S, i, c, s), _d(S, i, c));
      },
      enqueueReplaceState: function(e, t, a) {
        var i = Va(e), s = xa(), c = au(i), A = $l(s, c);
        A.tag = DC, A.payload = t, a != null && (bd(a, "replaceState"), A.callback = a);
        var S = Qs(i, A, c);
        S !== null && (Or(S, i, c, s), _d(S, i, c));
      },
      enqueueForceUpdate: function(e, t) {
        var a = Va(e), i = xa(), s = au(a), c = $l(i, s);
        c.tag = Pd, t != null && (bd(t, "forceUpdate"), c.callback = t);
        var A = Qs(a, c, s);
        A !== null && (Or(A, a, s, i), _d(A, a, s));
      }
    };
    function xC(e, t, a, i, s, c, A) {
      var S = e.stateNode;
      if (typeof S.shouldComponentUpdate == "function") {
        var p = S.shouldComponentUpdate(i, c, A);
        {
          if (e.mode & bn) {
            rn(!0);
            try {
              p = S.shouldComponentUpdate(i, c, A);
            } finally {
              rn(!1);
            }
          }
          p === void 0 && d("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Bt(t) || "Component");
        }
        return p;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !cl(a, i) || !cl(s, c) : !0;
    }
    function Eg(e, t, a) {
      var i = e.stateNode;
      {
        var s = Bt(t) || "Component", c = i.render;
        c || (t.prototype && typeof t.prototype.render == "function" ? d("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", s) : d("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", s)), i.getInitialState && !i.getInitialState.isReactClassApproved && !i.state && d("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", s), i.getDefaultProps && !i.getDefaultProps.isReactClassApproved && d("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", s), i.propTypes && d("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", s), i.contextType && d("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", s), i.contextTypes && d("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", s), t.contextType && t.contextTypes && !pp.has(t) && (pp.add(t), d("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", s)), typeof i.componentShouldUpdate == "function" && d("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", s), t.prototype && t.prototype.isPureReactComponent && typeof i.shouldComponentUpdate < "u" && d("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Bt(t) || "A pure component"), typeof i.componentDidUnmount == "function" && d("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", s), typeof i.componentDidReceiveProps == "function" && d("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", s), typeof i.componentWillRecieveProps == "function" && d("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", s), typeof i.UNSAFE_componentWillRecieveProps == "function" && d("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", s);
        var A = i.props !== a;
        i.props !== void 0 && A && d("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", s, s), i.defaultProps && d("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", s, s), typeof i.getSnapshotBeforeUpdate == "function" && typeof i.componentDidUpdate != "function" && !Rp.has(t) && (Rp.add(t), d("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Bt(t))), typeof i.getDerivedStateFromProps == "function" && d("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", s), typeof i.getDerivedStateFromError == "function" && d("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", s), typeof t.getSnapshotBeforeUpdate == "function" && d("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", s);
        var S = i.state;
        S && (typeof S != "object" || Ut(S)) && d("%s.state: must be set to an object or null", s), typeof i.getChildContext == "function" && typeof t.childContextTypes != "object" && d("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", s);
      }
    }
    function bC(e, t) {
      t.updater = Cp, e.stateNode = t, Ls(t, e), t._reactInternalInstance = Tp;
    }
    function HC(e, t, a) {
      var i = !1, s = Si, c = Si, A = t.contextType;
      if ("contextType" in t) {
        var S = (
          // Allow null for conditional declaration
          A === null || A !== void 0 && A.$$typeof === ge && A._context === void 0
        );
        if (!S && !Op.has(t)) {
          Op.add(t);
          var p = "";
          A === void 0 ? p = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof A != "object" ? p = " However, it is set to a " + typeof A + "." : A.$$typeof === Ee ? p = " Did you accidentally pass the Context.Provider instead?" : A._context !== void 0 ? p = " Did you accidentally pass the Context.Consumer instead?" : p = " However, it is set to an object with keys {" + Object.keys(A).join(", ") + "}.", d("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Bt(t) || "Component", p);
        }
      }
      if (typeof A == "object" && A !== null)
        c = sr(A);
      else {
        s = Fc(e, t, !0);
        var L = t.contextTypes;
        i = L != null, c = i ? wc(e, s) : Si;
      }
      var y = new t(a, c);
      if (e.mode & bn) {
        rn(!0);
        try {
          y = new t(a, c);
        } finally {
          rn(!1);
        }
      }
      var F = e.memoizedState = y.state !== null && y.state !== void 0 ? y.state : null;
      bC(e, y);
      {
        if (typeof t.getDerivedStateFromProps == "function" && F === null) {
          var H = Bt(t) || "Component";
          Ap.has(H) || (Ap.add(H), d("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", H, y.state === null ? "null" : "undefined", H));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof y.getSnapshotBeforeUpdate == "function") {
          var z = null, Q = null, ne = null;
          if (typeof y.componentWillMount == "function" && y.componentWillMount.__suppressDeprecationWarning !== !0 ? z = "componentWillMount" : typeof y.UNSAFE_componentWillMount == "function" && (z = "UNSAFE_componentWillMount"), typeof y.componentWillReceiveProps == "function" && y.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Q = "componentWillReceiveProps" : typeof y.UNSAFE_componentWillReceiveProps == "function" && (Q = "UNSAFE_componentWillReceiveProps"), typeof y.componentWillUpdate == "function" && y.componentWillUpdate.__suppressDeprecationWarning !== !0 ? ne = "componentWillUpdate" : typeof y.UNSAFE_componentWillUpdate == "function" && (ne = "UNSAFE_componentWillUpdate"), z !== null || Q !== null || ne !== null) {
            var He = Bt(t) || "Component", tt = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            dp.has(He) || (dp.add(He), d(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, He, tt, z !== null ? `
  ` + z : "", Q !== null ? `
  ` + Q : "", ne !== null ? `
  ` + ne : ""));
          }
        }
      }
      return i && lC(e, s, c), y;
    }
    function cg(e, t) {
      var a = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), a !== t.state && (d("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", ct(e) || "Component"), Cp.enqueueReplaceState(t, t.state, null));
    }
    function BC(e, t, a, i) {
      var s = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, i), t.state !== s) {
        {
          var c = ct(e) || "Component";
          fp.has(c) || (fp.add(c), d("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", c));
        }
        Cp.enqueueReplaceState(t, t.state, null);
      }
    }
    function hp(e, t, a, i) {
      Eg(e, t, a);
      var s = e.stateNode;
      s.props = a, s.state = e.memoizedState, s.refs = UC, Ep(e);
      var c = t.contextType;
      if (typeof c == "object" && c !== null)
        s.context = sr(c);
      else {
        var A = Fc(e, t, !0);
        s.context = wc(e, A);
      }
      {
        if (s.state === a) {
          var S = Bt(t) || "Component";
          Np.has(S) || (Np.add(S), d("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", S));
        }
        e.mode & bn && Ro.recordLegacyContextWarning(e, s), Ro.recordUnsafeLifecycleWarnings(e, s);
      }
      s.state = e.memoizedState;
      var p = t.getDerivedStateFromProps;
      if (typeof p == "function" && (Ip(e, t, p, a), s.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof s.getSnapshotBeforeUpdate != "function" && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function") && (cg(e, s), Gd(e, a, s, i), s.state = e.memoizedState), typeof s.componentDidMount == "function") {
        var L = Ct;
        L |= oa, (e.mode & lr) !== ze && (L |= la), e.flags |= L;
      }
    }
    function Tg(e, t, a, i) {
      var s = e.stateNode, c = e.memoizedProps;
      s.props = c;
      var A = s.context, S = t.contextType, p = Si;
      if (typeof S == "object" && S !== null)
        p = sr(S);
      else {
        var L = Fc(e, t, !0);
        p = wc(e, L);
      }
      var y = t.getDerivedStateFromProps, F = typeof y == "function" || typeof s.getSnapshotBeforeUpdate == "function";
      !F && (typeof s.UNSAFE_componentWillReceiveProps == "function" || typeof s.componentWillReceiveProps == "function") && (c !== a || A !== p) && BC(e, s, a, p), PC();
      var H = e.memoizedState, z = s.state = H;
      if (Gd(e, a, s, i), z = e.memoizedState, c === a && H === z && !Sd() && !xd()) {
        if (typeof s.componentDidMount == "function") {
          var Q = Ct;
          Q |= oa, (e.mode & lr) !== ze && (Q |= la), e.flags |= Q;
        }
        return !1;
      }
      typeof y == "function" && (Ip(e, t, y, a), z = e.memoizedState);
      var ne = xd() || xC(e, t, c, a, H, z, p);
      if (ne) {
        if (!F && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function") && (typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount()), typeof s.componentDidMount == "function") {
          var He = Ct;
          He |= oa, (e.mode & lr) !== ze && (He |= la), e.flags |= He;
        }
      } else {
        if (typeof s.componentDidMount == "function") {
          var tt = Ct;
          tt |= oa, (e.mode & lr) !== ze && (tt |= la), e.flags |= tt;
        }
        e.memoizedProps = a, e.memoizedState = z;
      }
      return s.props = a, s.state = z, s.context = p, ne;
    }
    function fg(e, t, a, i, s) {
      var c = t.stateNode;
      gC(e, t);
      var A = t.memoizedProps, S = t.type === t.elementType ? A : So(t.type, A);
      c.props = S;
      var p = t.pendingProps, L = c.context, y = a.contextType, F = Si;
      if (typeof y == "object" && y !== null)
        F = sr(y);
      else {
        var H = Fc(t, a, !0);
        F = wc(t, H);
      }
      var z = a.getDerivedStateFromProps, Q = typeof z == "function" || typeof c.getSnapshotBeforeUpdate == "function";
      !Q && (typeof c.UNSAFE_componentWillReceiveProps == "function" || typeof c.componentWillReceiveProps == "function") && (A !== p || L !== F) && BC(t, c, i, F), PC();
      var ne = t.memoizedState, He = c.state = ne;
      if (Gd(t, i, c, s), He = t.memoizedState, A === p && ne === He && !Sd() && !xd() && !Ae)
        return typeof c.componentDidUpdate == "function" && (A !== e.memoizedProps || ne !== e.memoizedState) && (t.flags |= Ct), typeof c.getSnapshotBeforeUpdate == "function" && (A !== e.memoizedProps || ne !== e.memoizedState) && (t.flags |= Wa), !1;
      typeof z == "function" && (Ip(t, a, z, i), He = t.memoizedState);
      var tt = xd() || xC(t, a, S, i, ne, He, F) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Ae;
      return tt ? (!Q && (typeof c.UNSAFE_componentWillUpdate == "function" || typeof c.componentWillUpdate == "function") && (typeof c.componentWillUpdate == "function" && c.componentWillUpdate(i, He, F), typeof c.UNSAFE_componentWillUpdate == "function" && c.UNSAFE_componentWillUpdate(i, He, F)), typeof c.componentDidUpdate == "function" && (t.flags |= Ct), typeof c.getSnapshotBeforeUpdate == "function" && (t.flags |= Wa)) : (typeof c.componentDidUpdate == "function" && (A !== e.memoizedProps || ne !== e.memoizedState) && (t.flags |= Ct), typeof c.getSnapshotBeforeUpdate == "function" && (A !== e.memoizedProps || ne !== e.memoizedState) && (t.flags |= Wa), t.memoizedProps = i, t.memoizedState = He), c.props = i, c.state = He, c.context = F, tt;
    }
    var vp, mp, Lp, yp, Dp, FC = function(e, t) {
    };
    vp = !1, mp = !1, Lp = {}, yp = {}, Dp = {}, FC = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var a = ct(t) || "Component";
        yp[a] || (yp[a] = !0, d('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function Kf(e, t, a) {
      var i = a.ref;
      if (i !== null && typeof i != "function" && typeof i != "object") {
        if ((e.mode & bn || We) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(a._owner && a._self && a._owner.stateNode !== a._self)) {
          var s = ct(e) || "Component";
          Lp[s] || (d('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', i), Lp[s] = !0);
        }
        if (a._owner) {
          var c = a._owner, A;
          if (c) {
            var S = c;
            if (S.tag !== v)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            A = S.stateNode;
          }
          if (!A)
            throw new Error("Missing owner for string ref " + i + ". This error is likely caused by a bug in React. Please file an issue.");
          var p = A;
          rr(i, "ref");
          var L = "" + i;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === L)
            return t.ref;
          var y = function(F) {
            var H = p.refs;
            H === UC && (H = p.refs = {}), F === null ? delete H[L] : H[L] = F;
          };
          return y._stringRef = L, y;
        } else {
          if (typeof i != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!a._owner)
            throw new Error("Element ref was specified as a string (" + i + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return i;
    }
    function Hd(e, t) {
      var a = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Bd(e) {
      {
        var t = ct(e) || "Component";
        if (Dp[t])
          return;
        Dp[t] = !0, d("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function wC(e) {
      var t = e._payload, a = e._init;
      return a(t);
    }
    function YC(e) {
      function t(X, re) {
        if (e) {
          var k = X.deletions;
          k === null ? (X.deletions = [re], X.flags |= jt) : k.push(re);
        }
      }
      function a(X, re) {
        if (!e)
          return null;
        for (var k = re; k !== null; )
          t(X, k), k = k.sibling;
        return null;
      }
      function i(X, re) {
        for (var k = /* @__PURE__ */ new Map(), de = re; de !== null; )
          de.key !== null ? k.set(de.key, de) : k.set(de.index, de), de = de.sibling;
        return k;
      }
      function s(X, re) {
        var k = mE(X, re);
        return k.index = 0, k.sibling = null, k;
      }
      function c(X, re, k) {
        if (X.index = k, !e)
          return X.flags |= BT, re;
        var de = X.alternate;
        if (de !== null) {
          var Be = de.index;
          return Be < re ? (X.flags |= dn, re) : Be;
        } else
          return X.flags |= dn, re;
      }
      function A(X) {
        return e && X.alternate === null && (X.flags |= dn), X;
      }
      function S(X, re, k, de) {
        if (re === null || re.tag !== j) {
          var Be = tI(k, X.mode, de);
          return Be.return = X, Be;
        } else {
          var _e = s(re, k);
          return _e.return = X, _e;
        }
      }
      function p(X, re, k, de) {
        var Be = k.type;
        if (Be === va)
          return y(X, re, k.props.children, de, k.key);
        if (re !== null && (re.elementType === Be || // Keep this check inline so it only runs on the false path:
        Pv(re, k) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Be == "object" && Be !== null && Be.$$typeof === et && wC(Be) === re.type)) {
          var _e = s(re, k.props);
          return _e.ref = Kf(X, re, k), _e.return = X, _e._debugSource = k._source, _e._debugOwner = k._owner, _e;
        }
        var st = eI(k, X.mode, de);
        return st.ref = Kf(X, re, k), st.return = X, st;
      }
      function L(X, re, k, de) {
        if (re === null || re.tag !== w || re.stateNode.containerInfo !== k.containerInfo || re.stateNode.implementation !== k.implementation) {
          var Be = nI(k, X.mode, de);
          return Be.return = X, Be;
        } else {
          var _e = s(re, k.children || []);
          return _e.return = X, _e;
        }
      }
      function y(X, re, k, de, Be) {
        if (re === null || re.tag !== oe) {
          var _e = ou(k, X.mode, de, Be);
          return _e.return = X, _e;
        } else {
          var st = s(re, k);
          return st.return = X, st;
        }
      }
      function F(X, re, k) {
        if (typeof re == "string" && re !== "" || typeof re == "number") {
          var de = tI("" + re, X.mode, k);
          return de.return = X, de;
        }
        if (typeof re == "object" && re !== null) {
          switch (re.$$typeof) {
            case vi: {
              var Be = eI(re, X.mode, k);
              return Be.ref = Kf(X, null, re), Be.return = X, Be;
            }
            case Ur: {
              var _e = nI(re, X.mode, k);
              return _e.return = X, _e;
            }
            case et: {
              var st = re._payload, Rt = re._init;
              return F(X, Rt(st), k);
            }
          }
          if (Ut(re) || ri(re)) {
            var ln = ou(re, X.mode, k, null);
            return ln.return = X, ln;
          }
          Hd(X, re);
        }
        return typeof re == "function" && Bd(X), null;
      }
      function H(X, re, k, de) {
        var Be = re !== null ? re.key : null;
        if (typeof k == "string" && k !== "" || typeof k == "number")
          return Be !== null ? null : S(X, re, "" + k, de);
        if (typeof k == "object" && k !== null) {
          switch (k.$$typeof) {
            case vi:
              return k.key === Be ? p(X, re, k, de) : null;
            case Ur:
              return k.key === Be ? L(X, re, k, de) : null;
            case et: {
              var _e = k._payload, st = k._init;
              return H(X, re, st(_e), de);
            }
          }
          if (Ut(k) || ri(k))
            return Be !== null ? null : y(X, re, k, de, null);
          Hd(X, k);
        }
        return typeof k == "function" && Bd(X), null;
      }
      function z(X, re, k, de, Be) {
        if (typeof de == "string" && de !== "" || typeof de == "number") {
          var _e = X.get(k) || null;
          return S(re, _e, "" + de, Be);
        }
        if (typeof de == "object" && de !== null) {
          switch (de.$$typeof) {
            case vi: {
              var st = X.get(de.key === null ? k : de.key) || null;
              return p(re, st, de, Be);
            }
            case Ur: {
              var Rt = X.get(de.key === null ? k : de.key) || null;
              return L(re, Rt, de, Be);
            }
            case et:
              var ln = de._payload, Xt = de._init;
              return z(X, re, k, Xt(ln), Be);
          }
          if (Ut(de) || ri(de)) {
            var tr = X.get(k) || null;
            return y(re, tr, de, Be, null);
          }
          Hd(re, de);
        }
        return typeof de == "function" && Bd(re), null;
      }
      function Q(X, re, k) {
        {
          if (typeof X != "object" || X === null)
            return re;
          switch (X.$$typeof) {
            case vi:
            case Ur:
              FC(X, k);
              var de = X.key;
              if (typeof de != "string")
                break;
              if (re === null) {
                re = /* @__PURE__ */ new Set(), re.add(de);
                break;
              }
              if (!re.has(de)) {
                re.add(de);
                break;
              }
              d("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", de);
              break;
            case et:
              var Be = X._payload, _e = X._init;
              Q(_e(Be), re, k);
              break;
          }
        }
        return re;
      }
      function ne(X, re, k, de) {
        for (var Be = null, _e = 0; _e < k.length; _e++) {
          var st = k[_e];
          Be = Q(st, Be, X);
        }
        for (var Rt = null, ln = null, Xt = re, tr = 0, kt = 0, zn = null; Xt !== null && kt < k.length; kt++) {
          Xt.index > kt ? (zn = Xt, Xt = null) : zn = Xt.sibling;
          var Sa = H(X, Xt, k[kt], de);
          if (Sa === null) {
            Xt === null && (Xt = zn);
            break;
          }
          e && Xt && Sa.alternate === null && t(X, Xt), tr = c(Sa, tr, kt), ln === null ? Rt = Sa : ln.sibling = Sa, ln = Sa, Xt = zn;
        }
        if (kt === k.length) {
          if (a(X, Xt), Yr()) {
            var jr = kt;
            TE(X, jr);
          }
          return Rt;
        }
        if (Xt === null) {
          for (; kt < k.length; kt++) {
            var Oi = F(X, k[kt], de);
            Oi !== null && (tr = c(Oi, tr, kt), ln === null ? Rt = Oi : ln.sibling = Oi, ln = Oi);
          }
          if (Yr()) {
            var ba = kt;
            TE(X, ba);
          }
          return Rt;
        }
        for (var Ha = i(X, Xt); kt < k.length; kt++) {
          var Na = z(Ha, X, kt, k[kt], de);
          Na !== null && (e && Na.alternate !== null && Ha.delete(Na.key === null ? kt : Na.key), tr = c(Na, tr, kt), ln === null ? Rt = Na : ln.sibling = Na, ln = Na);
        }
        if (e && Ha.forEach(function(uT) {
          return t(X, uT);
        }), Yr()) {
          var is = kt;
          TE(X, is);
        }
        return Rt;
      }
      function He(X, re, k, de) {
        var Be = ri(k);
        if (typeof Be != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          k[Symbol.toStringTag] === "Generator" && (mp || d("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), mp = !0), k.entries === Be && (vp || d("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), vp = !0);
          var _e = Be.call(k);
          if (_e)
            for (var st = null, Rt = _e.next(); !Rt.done; Rt = _e.next()) {
              var ln = Rt.value;
              st = Q(ln, st, X);
            }
        }
        var Xt = Be.call(k);
        if (Xt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var tr = null, kt = null, zn = re, Sa = 0, jr = 0, Oi = null, ba = Xt.next(); zn !== null && !ba.done; jr++, ba = Xt.next()) {
          zn.index > jr ? (Oi = zn, zn = null) : Oi = zn.sibling;
          var Ha = H(X, zn, ba.value, de);
          if (Ha === null) {
            zn === null && (zn = Oi);
            break;
          }
          e && zn && Ha.alternate === null && t(X, zn), Sa = c(Ha, Sa, jr), kt === null ? tr = Ha : kt.sibling = Ha, kt = Ha, zn = Oi;
        }
        if (ba.done) {
          if (a(X, zn), Yr()) {
            var Na = jr;
            TE(X, Na);
          }
          return tr;
        }
        if (zn === null) {
          for (; !ba.done; jr++, ba = Xt.next()) {
            var is = F(X, ba.value, de);
            is !== null && (Sa = c(is, Sa, jr), kt === null ? tr = is : kt.sibling = is, kt = is);
          }
          if (Yr()) {
            var uT = jr;
            TE(X, uT);
          }
          return tr;
        }
        for (var CA = i(X, zn); !ba.done; jr++, ba = Xt.next()) {
          var Il = z(CA, X, jr, ba.value, de);
          Il !== null && (e && Il.alternate !== null && CA.delete(Il.key === null ? jr : Il.key), Sa = c(Il, Sa, jr), kt === null ? tr = Il : kt.sibling = Il, kt = Il);
        }
        if (e && CA.forEach(function(yU) {
          return t(X, yU);
        }), Yr()) {
          var LU = jr;
          TE(X, LU);
        }
        return tr;
      }
      function tt(X, re, k, de) {
        if (re !== null && re.tag === j) {
          a(X, re.sibling);
          var Be = s(re, k);
          return Be.return = X, Be;
        }
        a(X, re);
        var _e = tI(k, X.mode, de);
        return _e.return = X, _e;
      }
      function Je(X, re, k, de) {
        for (var Be = k.key, _e = re; _e !== null; ) {
          if (_e.key === Be) {
            var st = k.type;
            if (st === va) {
              if (_e.tag === oe) {
                a(X, _e.sibling);
                var Rt = s(_e, k.props.children);
                return Rt.return = X, Rt._debugSource = k._source, Rt._debugOwner = k._owner, Rt;
              }
            } else if (_e.elementType === st || // Keep this check inline so it only runs on the false path:
            Pv(_e, k) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof st == "object" && st !== null && st.$$typeof === et && wC(st) === _e.type) {
              a(X, _e.sibling);
              var ln = s(_e, k.props);
              return ln.ref = Kf(X, _e, k), ln.return = X, ln._debugSource = k._source, ln._debugOwner = k._owner, ln;
            }
            a(X, _e);
            break;
          } else
            t(X, _e);
          _e = _e.sibling;
        }
        if (k.type === va) {
          var Xt = ou(k.props.children, X.mode, de, k.key);
          return Xt.return = X, Xt;
        } else {
          var tr = eI(k, X.mode, de);
          return tr.ref = Kf(X, re, k), tr.return = X, tr;
        }
      }
      function xt(X, re, k, de) {
        for (var Be = k.key, _e = re; _e !== null; ) {
          if (_e.key === Be)
            if (_e.tag === w && _e.stateNode.containerInfo === k.containerInfo && _e.stateNode.implementation === k.implementation) {
              a(X, _e.sibling);
              var st = s(_e, k.children || []);
              return st.return = X, st;
            } else {
              a(X, _e);
              break;
            }
          else
            t(X, _e);
          _e = _e.sibling;
        }
        var Rt = nI(k, X.mode, de);
        return Rt.return = X, Rt;
      }
      function Pt(X, re, k, de) {
        var Be = typeof k == "object" && k !== null && k.type === va && k.key === null;
        if (Be && (k = k.props.children), typeof k == "object" && k !== null) {
          switch (k.$$typeof) {
            case vi:
              return A(Je(X, re, k, de));
            case Ur:
              return A(xt(X, re, k, de));
            case et:
              var _e = k._payload, st = k._init;
              return Pt(X, re, st(_e), de);
          }
          if (Ut(k))
            return ne(X, re, k, de);
          if (ri(k))
            return He(X, re, k, de);
          Hd(X, k);
        }
        return typeof k == "string" && k !== "" || typeof k == "number" ? A(tt(X, re, "" + k, de)) : (typeof k == "function" && Bd(X), a(X, re));
      }
      return Pt;
    }
    var Kc = YC(!0), VC = YC(!1);
    function Ag(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var a = t.child, i = mE(a, a.pendingProps);
        for (t.child = i, i.return = t; a.sibling !== null; )
          a = a.sibling, i = i.sibling = mE(a, a.pendingProps), i.return = t;
        i.sibling = null;
      }
    }
    function Rg(e, t) {
      for (var a = e.child; a !== null; )
        XM(a, t), a = a.sibling;
    }
    var jf = {}, Zs = Ks(jf), zf = Ks(jf), Fd = Ks(jf);
    function wd(e) {
      if (e === jf)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function WC() {
      var e = wd(Fd.current);
      return e;
    }
    function gp(e, t) {
      Ra(Fd, t, e), Ra(zf, e, e), Ra(Zs, jf, e);
      var a = gy(t);
      Aa(Zs, e), Ra(Zs, a, e);
    }
    function jc(e) {
      Aa(Zs, e), Aa(zf, e), Aa(Fd, e);
    }
    function Pp() {
      var e = wd(Zs.current);
      return e;
    }
    function XC(e) {
      wd(Fd.current);
      var t = wd(Zs.current), a = Py(t, e.type);
      t !== a && (Ra(zf, e, e), Ra(Zs, a, e));
    }
    function Mp(e) {
      zf.current === e && (Aa(Zs, e), Aa(zf, e));
    }
    var dg = 0, kC = 1, KC = 1, Jf = 2, No = Ks(dg);
    function Up(e, t) {
      return (e & t) !== 0;
    }
    function zc(e) {
      return e & kC;
    }
    function _p(e, t) {
      return e & kC | t;
    }
    function Sg(e, t) {
      return e | t;
    }
    function qs(e, t) {
      Ra(No, t, e);
    }
    function Jc(e) {
      Aa(No, e);
    }
    function Ng(e, t) {
      var a = e.memoizedState;
      return a !== null ? a.dehydrated !== null : (e.memoizedProps, !0);
    }
    function Yd(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === ye) {
          var a = t.memoizedState;
          if (a !== null) {
            var i = a.dehydrated;
            if (i === null || nC(i) || FN(i))
              return t;
          }
        } else if (t.tag === gt && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var s = (t.flags & Tt) !== qe;
          if (s)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var Qc = (
      /*   */
      0
    ), Ar = (
      /* */
      1
    ), Al = (
      /*  */
      2
    ), Ua = (
      /*    */
      4
    ), Ni = (
      /*   */
      8
    ), Gp = [];
    function xp() {
      for (var e = 0; e < Gp.length; e++) {
        var t = Gp[e];
        t._workInProgressVersionPrimary = null;
      }
      Gp.length = 0;
    }
    function pg(e, t) {
      var a = t._getVersion, i = a(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, i] : e.mutableSourceEagerHydrationData.push(t, i);
    }
    var xe = T.ReactCurrentDispatcher, Qf = T.ReactCurrentBatchConfig, bp, Zc;
    bp = /* @__PURE__ */ new Set();
    var NE = se, on = null, Rr = null, dr = null, Vd = !1, Zf = !1, qf = 0, Og = 0, Ig = 25, ae = null, Bi = null, $s = -1, Hp = !1;
    function $t() {
      {
        var e = ae;
        Bi === null ? Bi = [e] : Bi.push(e);
      }
    }
    function Pe() {
      {
        var e = ae;
        Bi !== null && ($s++, Bi[$s] !== e && Cg(e));
      }
    }
    function qc(e) {
      e != null && !Ut(e) && d("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ae, typeof e);
    }
    function Cg(e) {
      {
        var t = ct(on);
        if (!bp.has(t) && (bp.add(t), Bi !== null)) {
          for (var a = "", i = 30, s = 0; s <= $s; s++) {
            for (var c = Bi[s], A = s === $s ? e : c, S = s + 1 + ". " + c; S.length < i; )
              S += " ";
            S += A + `
`, a += S;
          }
          d(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, a);
        }
      }
    }
    function da() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Bp(e, t) {
      if (Hp)
        return !1;
      if (t === null)
        return d("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ae), !1;
      e.length !== t.length && d(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ae, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!Fr(e[a], t[a]))
          return !1;
      return !0;
    }
    function $c(e, t, a, i, s, c) {
      NE = c, on = t, Bi = e !== null ? e._debugHookTypes : null, $s = -1, Hp = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = se, e !== null && e.memoizedState !== null ? xe.current = fh : Bi !== null ? xe.current = Th : xe.current = ch;
      var A = a(i, s);
      if (Zf) {
        var S = 0;
        do {
          if (Zf = !1, qf = 0, S >= Ig)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          S += 1, Hp = !1, Rr = null, dr = null, t.updateQueue = null, $s = -1, xe.current = Ah, A = a(i, s);
        } while (Zf);
      }
      xe.current = tS, t._debugHookTypes = Bi;
      var p = Rr !== null && Rr.next !== null;
      if (NE = se, on = null, Rr = null, dr = null, ae = null, Bi = null, $s = -1, e !== null && (e.flags & cr) !== (t.flags & cr) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & St) !== ze && d("Internal React error: Expected static flag was missing. Please notify the React team."), Vd = !1, p)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return A;
    }
    function eT() {
      var e = qf !== 0;
      return qf = 0, e;
    }
    function jC(e, t, a) {
      t.updateQueue = e.updateQueue, (t.mode & lr) !== ze ? t.flags &= ~(Gl | la | In | Ct) : t.flags &= ~(In | Ct), e.lanes = wu(e.lanes, a);
    }
    function zC() {
      if (xe.current = tS, Vd) {
        for (var e = on.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        Vd = !1;
      }
      NE = se, on = null, Rr = null, dr = null, Bi = null, $s = -1, ae = null, lh = !1, Zf = !1, qf = 0;
    }
    function Rl() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return dr === null ? on.memoizedState = dr = e : dr = dr.next = e, dr;
    }
    function Fi() {
      var e;
      if (Rr === null) {
        var t = on.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = Rr.next;
      var a;
      if (dr === null ? a = on.memoizedState : a = dr.next, a !== null)
        dr = a, a = dr.next, Rr = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Rr = e;
        var i = {
          memoizedState: Rr.memoizedState,
          baseState: Rr.baseState,
          baseQueue: Rr.baseQueue,
          queue: Rr.queue,
          next: null
        };
        dr === null ? on.memoizedState = dr = i : dr = dr.next = i;
      }
      return dr;
    }
    function JC() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Fp(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function wp(e, t, a) {
      var i = Rl(), s;
      a !== void 0 ? s = a(t) : s = t, i.memoizedState = i.baseState = s;
      var c = {
        pending: null,
        interleaved: null,
        lanes: se,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: s
      };
      i.queue = c;
      var A = c.dispatch = Lg.bind(null, on, c);
      return [i.memoizedState, A];
    }
    function Yp(e, t, a) {
      var i = Fi(), s = i.queue;
      if (s === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      s.lastRenderedReducer = e;
      var c = Rr, A = c.baseQueue, S = s.pending;
      if (S !== null) {
        if (A !== null) {
          var p = A.next, L = S.next;
          A.next = L, S.next = p;
        }
        c.baseQueue !== A && d("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), c.baseQueue = A = S, s.pending = null;
      }
      if (A !== null) {
        var y = A.next, F = c.baseState, H = null, z = null, Q = null, ne = y;
        do {
          var He = ne.lane;
          if (Vl(NE, He)) {
            if (Q !== null) {
              var Je = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Xn,
                action: ne.action,
                hasEagerState: ne.hasEagerState,
                eagerState: ne.eagerState,
                next: null
              };
              Q = Q.next = Je;
            }
            if (ne.hasEagerState)
              F = ne.eagerState;
            else {
              var xt = ne.action;
              F = e(F, xt);
            }
          } else {
            var tt = {
              lane: He,
              action: ne.action,
              hasEagerState: ne.hasEagerState,
              eagerState: ne.eagerState,
              next: null
            };
            Q === null ? (z = Q = tt, H = F) : Q = Q.next = tt, on.lanes = Nt(on.lanes, He), SA(He);
          }
          ne = ne.next;
        } while (ne !== null && ne !== y);
        Q === null ? H = F : Q.next = z, Fr(F, i.memoizedState) || iA(), i.memoizedState = F, i.baseState = H, i.baseQueue = Q, s.lastRenderedState = F;
      }
      var Pt = s.interleaved;
      if (Pt !== null) {
        var X = Pt;
        do {
          var re = X.lane;
          on.lanes = Nt(on.lanes, re), SA(re), X = X.next;
        } while (X !== Pt);
      } else
        A === null && (s.lanes = se);
      var k = s.dispatch;
      return [i.memoizedState, k];
    }
    function Vp(e, t, a) {
      var i = Fi(), s = i.queue;
      if (s === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      s.lastRenderedReducer = e;
      var c = s.dispatch, A = s.pending, S = i.memoizedState;
      if (A !== null) {
        s.pending = null;
        var p = A.next, L = p;
        do {
          var y = L.action;
          S = e(S, y), L = L.next;
        } while (L !== p);
        Fr(S, i.memoizedState) || iA(), i.memoizedState = S, i.baseQueue === null && (i.baseState = S), s.lastRenderedState = S;
      }
      return [S, c];
    }
    function xH(e, t, a) {
    }
    function bH(e, t, a) {
    }
    function Wp(e, t, a) {
      var i = on, s = Rl(), c, A = Yr();
      if (A) {
        if (a === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        c = a(), Zc || c !== a() && (d("The result of getServerSnapshot should be cached to avoid an infinite loop"), Zc = !0);
      } else {
        if (c = t(), !Zc) {
          var S = t();
          Fr(c, S) || (d("The result of getSnapshot should be cached to avoid an infinite loop"), Zc = !0);
        }
        var p = pS();
        if (p === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Hu(p, NE) || QC(i, t, c);
      }
      s.memoizedState = c;
      var L = {
        value: c,
        getSnapshot: t
      };
      return s.queue = L, jd(qC.bind(null, i, L, e), [e]), i.flags |= In, $f(Ar | Ni, ZC.bind(null, i, L, c, t), void 0, null), c;
    }
    function Wd(e, t, a) {
      var i = on, s = Fi(), c = t();
      if (!Zc) {
        var A = t();
        Fr(c, A) || (d("The result of getSnapshot should be cached to avoid an infinite loop"), Zc = !0);
      }
      var S = s.memoizedState, p = !Fr(S, c);
      p && (s.memoizedState = c, iA());
      var L = s.queue;
      if (tA(qC.bind(null, i, L, e), [e]), L.getSnapshot !== t || p || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      dr !== null && dr.memoizedState.tag & Ar) {
        i.flags |= In, $f(Ar | Ni, ZC.bind(null, i, L, c, t), void 0, null);
        var y = pS();
        if (y === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Hu(y, NE) || QC(i, t, c);
      }
      return c;
    }
    function QC(e, t, a) {
      e.flags |= Du;
      var i = {
        getSnapshot: t,
        value: a
      }, s = on.updateQueue;
      if (s === null)
        s = JC(), on.updateQueue = s, s.stores = [i];
      else {
        var c = s.stores;
        c === null ? s.stores = [i] : c.push(i);
      }
    }
    function ZC(e, t, a, i) {
      t.value = a, t.getSnapshot = i, $C(t) && eh(e);
    }
    function qC(e, t, a) {
      var i = function() {
        $C(t) && eh(e);
      };
      return a(i);
    }
    function $C(e) {
      var t = e.getSnapshot, a = e.value;
      try {
        var i = t();
        return !Fr(a, i);
      } catch {
        return !0;
      }
    }
    function eh(e) {
      var t = Za(e, ot);
      t !== null && Or(t, e, ot, an);
    }
    function Xd(e) {
      var t = Rl();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        interleaved: null,
        lanes: se,
        dispatch: null,
        lastRenderedReducer: Fp,
        lastRenderedState: e
      };
      t.queue = a;
      var i = a.dispatch = yg.bind(null, on, a);
      return [t.memoizedState, i];
    }
    function Xp(e) {
      return Yp(Fp);
    }
    function kp(e) {
      return Vp(Fp);
    }
    function $f(e, t, a, i) {
      var s = {
        tag: e,
        create: t,
        destroy: a,
        deps: i,
        // Circular
        next: null
      }, c = on.updateQueue;
      if (c === null)
        c = JC(), on.updateQueue = c, c.lastEffect = s.next = s;
      else {
        var A = c.lastEffect;
        if (A === null)
          c.lastEffect = s.next = s;
        else {
          var S = A.next;
          A.next = s, s.next = S, c.lastEffect = s;
        }
      }
      return s;
    }
    function Kp(e) {
      var t = Rl();
      {
        var a = {
          current: e
        };
        return t.memoizedState = a, a;
      }
    }
    function kd(e) {
      var t = Fi();
      return t.memoizedState;
    }
    function eA(e, t, a, i) {
      var s = Rl(), c = i === void 0 ? null : i;
      on.flags |= e, s.memoizedState = $f(Ar | t, a, void 0, c);
    }
    function Kd(e, t, a, i) {
      var s = Fi(), c = i === void 0 ? null : i, A = void 0;
      if (Rr !== null) {
        var S = Rr.memoizedState;
        if (A = S.destroy, c !== null) {
          var p = S.deps;
          if (Bp(c, p)) {
            s.memoizedState = $f(t, a, A, c);
            return;
          }
        }
      }
      on.flags |= e, s.memoizedState = $f(Ar | t, a, A, c);
    }
    function jd(e, t) {
      return (on.mode & lr) !== ze ? eA(Gl | In | jo, Ni, e, t) : eA(In | jo, Ni, e, t);
    }
    function tA(e, t) {
      return Kd(In, Ni, e, t);
    }
    function jp(e, t) {
      return eA(Ct, Al, e, t);
    }
    function zd(e, t) {
      return Kd(Ct, Al, e, t);
    }
    function zp(e, t) {
      var a = Ct;
      return a |= oa, (on.mode & lr) !== ze && (a |= la), eA(a, Ua, e, t);
    }
    function Jd(e, t) {
      return Kd(Ct, Ua, e, t);
    }
    function th(e, t) {
      if (typeof t == "function") {
        var a = t, i = e();
        return a(i), function() {
          a(null);
        };
      } else if (t != null) {
        var s = t;
        s.hasOwnProperty("current") || d("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(s).join(", ") + "}");
        var c = e();
        return s.current = c, function() {
          s.current = null;
        };
      }
    }
    function Jp(e, t, a) {
      typeof t != "function" && d("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null, s = Ct;
      return s |= oa, (on.mode & lr) !== ze && (s |= la), eA(s, Ua, th.bind(null, t, e), i);
    }
    function Qd(e, t, a) {
      typeof t != "function" && d("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null;
      return Kd(Ct, Ua, th.bind(null, t, e), i);
    }
    function hg(e, t) {
    }
    var Zd = hg;
    function Qp(e, t) {
      var a = Rl(), i = t === void 0 ? null : t;
      return a.memoizedState = [e, i], e;
    }
    function qd(e, t) {
      var a = Fi(), i = t === void 0 ? null : t, s = a.memoizedState;
      if (s !== null && i !== null) {
        var c = s[1];
        if (Bp(i, c))
          return s[0];
      }
      return a.memoizedState = [e, i], e;
    }
    function Zp(e, t) {
      var a = Rl(), i = t === void 0 ? null : t, s = e();
      return a.memoizedState = [s, i], s;
    }
    function $d(e, t) {
      var a = Fi(), i = t === void 0 ? null : t, s = a.memoizedState;
      if (s !== null && i !== null) {
        var c = s[1];
        if (Bp(i, c))
          return s[0];
      }
      var A = e();
      return a.memoizedState = [A, i], A;
    }
    function qp(e) {
      var t = Rl();
      return t.memoizedState = e, e;
    }
    function nh(e) {
      var t = Fi(), a = Rr, i = a.memoizedState;
      return ah(t, i, e);
    }
    function rh(e) {
      var t = Fi();
      if (Rr === null)
        return t.memoizedState = e, e;
      var a = Rr.memoizedState;
      return ah(t, a, e);
    }
    function ah(e, t, a) {
      var i = !vR(NE);
      if (i) {
        if (!Fr(a, t)) {
          var s = Fu();
          on.lanes = Nt(on.lanes, s), SA(s), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, iA()), e.memoizedState = a, a;
    }
    function vg(e, t, a) {
      var i = Ja();
      $n(MR(i, Ui)), e(!0);
      var s = Qf.transition;
      Qf.transition = {};
      var c = Qf.transition;
      Qf.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if ($n(i), Qf.transition = s, s === null && c._updatedFibers) {
          var A = c._updatedFibers.size;
          A > 10 && h("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), c._updatedFibers.clear();
        }
      }
    }
    function $p() {
      var e = Xd(!1), t = e[0], a = e[1], i = vg.bind(null, a), s = Rl();
      return s.memoizedState = i, [t, i];
    }
    function ih() {
      var e = Xp(), t = e[0], a = Fi(), i = a.memoizedState;
      return [t, i];
    }
    function oh() {
      var e = kp(), t = e[0], a = Fi(), i = a.memoizedState;
      return [t, i];
    }
    var lh = !1;
    function mg() {
      return lh;
    }
    function eO() {
      var e = Rl(), t = pS(), a = t.identifierPrefix, i;
      if (Yr()) {
        var s = FD();
        i = ":" + a + "R" + s;
        var c = qf++;
        c > 0 && (i += "H" + c.toString(32)), i += ":";
      } else {
        var A = Og++;
        i = ":" + a + "r" + A.toString(32) + ":";
      }
      return e.memoizedState = i, i;
    }
    function eS() {
      var e = Fi(), t = e.memoizedState;
      return t;
    }
    function Lg(e, t, a) {
      typeof arguments[3] == "function" && d("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = au(e), s = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (sh(e))
        uh(t, s);
      else {
        var c = LC(e, t, s, i);
        if (c !== null) {
          var A = xa();
          Or(c, e, i, A), Eh(c, t, i);
        }
      }
    }
    function yg(e, t, a) {
      typeof arguments[3] == "function" && d("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = au(e), s = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (sh(e))
        uh(t, s);
      else {
        var c = e.alternate;
        if (e.lanes === se && (c === null || c.lanes === se)) {
          var A = t.lastRenderedReducer;
          if (A !== null) {
            var S;
            S = xe.current, xe.current = po;
            try {
              var p = t.lastRenderedState, L = A(p, a);
              if (s.hasEagerState = !0, s.eagerState = L, Fr(L, p)) {
                ig(e, t, s, i);
                return;
              }
            } catch {
            } finally {
              xe.current = S;
            }
          }
        }
        var y = LC(e, t, s, i);
        if (y !== null) {
          var F = xa();
          Or(y, e, i, F), Eh(y, t, i);
        }
      }
    }
    function sh(e) {
      var t = e.alternate;
      return e === on || t !== null && t === on;
    }
    function uh(e, t) {
      Zf = Vd = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function Eh(e, t, a) {
      if (qT(a)) {
        var i = t.lanes;
        i = $T(i, e.pendingLanes);
        var s = Nt(i, a);
        t.lanes = s, cc(e, s);
      }
    }
    var tS = {
      readContext: sr,
      useCallback: da,
      useContext: da,
      useEffect: da,
      useImperativeHandle: da,
      useInsertionEffect: da,
      useLayoutEffect: da,
      useMemo: da,
      useReducer: da,
      useRef: da,
      useState: da,
      useDebugValue: da,
      useDeferredValue: da,
      useTransition: da,
      useMutableSource: da,
      useSyncExternalStore: da,
      useId: da,
      unstable_isNewReconciler: te
    }, ch = null, Th = null, fh = null, Ah = null, dl = null, po = null, nS = null;
    {
      var tO = function() {
        d("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, ft = function() {
        d("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      ch = {
        readContext: function(e) {
          return sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", $t(), qc(t), Qp(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", $t(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", $t(), qc(t), jd(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", $t(), qc(a), Jp(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", $t(), qc(t), jp(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", $t(), qc(t), zp(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", $t(), qc(t);
          var a = xe.current;
          xe.current = dl;
          try {
            return Zp(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", $t();
          var i = xe.current;
          xe.current = dl;
          try {
            return wp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", $t(), Kp(e);
        },
        useState: function(e) {
          ae = "useState", $t();
          var t = xe.current;
          xe.current = dl;
          try {
            return Xd(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", $t(), void 0;
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", $t(), qp(e);
        },
        useTransition: function() {
          return ae = "useTransition", $t(), $p();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", $t(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", $t(), Wp(e, t, a);
        },
        useId: function() {
          return ae = "useId", $t(), eO();
        },
        unstable_isNewReconciler: te
      }, Th = {
        readContext: function(e) {
          return sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", Pe(), Qp(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", Pe(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", Pe(), jd(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", Pe(), Jp(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", Pe(), jp(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", Pe(), zp(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", Pe();
          var a = xe.current;
          xe.current = dl;
          try {
            return Zp(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", Pe();
          var i = xe.current;
          xe.current = dl;
          try {
            return wp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", Pe(), Kp(e);
        },
        useState: function(e) {
          ae = "useState", Pe();
          var t = xe.current;
          xe.current = dl;
          try {
            return Xd(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", Pe(), void 0;
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", Pe(), qp(e);
        },
        useTransition: function() {
          return ae = "useTransition", Pe(), $p();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", Pe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", Pe(), Wp(e, t, a);
        },
        useId: function() {
          return ae = "useId", Pe(), eO();
        },
        unstable_isNewReconciler: te
      }, fh = {
        readContext: function(e) {
          return sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", Pe(), qd(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", Pe(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", Pe(), tA(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", Pe(), Qd(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", Pe(), zd(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", Pe(), Jd(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", Pe();
          var a = xe.current;
          xe.current = po;
          try {
            return $d(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", Pe();
          var i = xe.current;
          xe.current = po;
          try {
            return Yp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", Pe(), kd();
        },
        useState: function(e) {
          ae = "useState", Pe();
          var t = xe.current;
          xe.current = po;
          try {
            return Xp(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", Pe(), Zd();
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", Pe(), nh(e);
        },
        useTransition: function() {
          return ae = "useTransition", Pe(), ih();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", Pe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", Pe(), Wd(e, t);
        },
        useId: function() {
          return ae = "useId", Pe(), eS();
        },
        unstable_isNewReconciler: te
      }, Ah = {
        readContext: function(e) {
          return sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", Pe(), qd(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", Pe(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", Pe(), tA(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", Pe(), Qd(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", Pe(), zd(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", Pe(), Jd(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", Pe();
          var a = xe.current;
          xe.current = nS;
          try {
            return $d(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", Pe();
          var i = xe.current;
          xe.current = nS;
          try {
            return Vp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", Pe(), kd();
        },
        useState: function(e) {
          ae = "useState", Pe();
          var t = xe.current;
          xe.current = nS;
          try {
            return kp(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", Pe(), Zd();
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", Pe(), rh(e);
        },
        useTransition: function() {
          return ae = "useTransition", Pe(), oh();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", Pe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", Pe(), Wd(e, t);
        },
        useId: function() {
          return ae = "useId", Pe(), eS();
        },
        unstable_isNewReconciler: te
      }, dl = {
        readContext: function(e) {
          return tO(), sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", ft(), $t(), Qp(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", ft(), $t(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", ft(), $t(), jd(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", ft(), $t(), Jp(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", ft(), $t(), jp(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", ft(), $t(), zp(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", ft(), $t();
          var a = xe.current;
          xe.current = dl;
          try {
            return Zp(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", ft(), $t();
          var i = xe.current;
          xe.current = dl;
          try {
            return wp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", ft(), $t(), Kp(e);
        },
        useState: function(e) {
          ae = "useState", ft(), $t();
          var t = xe.current;
          xe.current = dl;
          try {
            return Xd(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", ft(), $t(), void 0;
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", ft(), $t(), qp(e);
        },
        useTransition: function() {
          return ae = "useTransition", ft(), $t(), $p();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", ft(), $t(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", ft(), $t(), Wp(e, t, a);
        },
        useId: function() {
          return ae = "useId", ft(), $t(), eO();
        },
        unstable_isNewReconciler: te
      }, po = {
        readContext: function(e) {
          return tO(), sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", ft(), Pe(), qd(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", ft(), Pe(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", ft(), Pe(), tA(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", ft(), Pe(), Qd(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", ft(), Pe(), zd(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", ft(), Pe(), Jd(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", ft(), Pe();
          var a = xe.current;
          xe.current = po;
          try {
            return $d(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", ft(), Pe();
          var i = xe.current;
          xe.current = po;
          try {
            return Yp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", ft(), Pe(), kd();
        },
        useState: function(e) {
          ae = "useState", ft(), Pe();
          var t = xe.current;
          xe.current = po;
          try {
            return Xp(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", ft(), Pe(), Zd();
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", ft(), Pe(), nh(e);
        },
        useTransition: function() {
          return ae = "useTransition", ft(), Pe(), ih();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", ft(), Pe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", ft(), Pe(), Wd(e, t);
        },
        useId: function() {
          return ae = "useId", ft(), Pe(), eS();
        },
        unstable_isNewReconciler: te
      }, nS = {
        readContext: function(e) {
          return tO(), sr(e);
        },
        useCallback: function(e, t) {
          return ae = "useCallback", ft(), Pe(), qd(e, t);
        },
        useContext: function(e) {
          return ae = "useContext", ft(), Pe(), sr(e);
        },
        useEffect: function(e, t) {
          return ae = "useEffect", ft(), Pe(), tA(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return ae = "useImperativeHandle", ft(), Pe(), Qd(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return ae = "useInsertionEffect", ft(), Pe(), zd(e, t);
        },
        useLayoutEffect: function(e, t) {
          return ae = "useLayoutEffect", ft(), Pe(), Jd(e, t);
        },
        useMemo: function(e, t) {
          ae = "useMemo", ft(), Pe();
          var a = xe.current;
          xe.current = po;
          try {
            return $d(e, t);
          } finally {
            xe.current = a;
          }
        },
        useReducer: function(e, t, a) {
          ae = "useReducer", ft(), Pe();
          var i = xe.current;
          xe.current = po;
          try {
            return Vp(e, t, a);
          } finally {
            xe.current = i;
          }
        },
        useRef: function(e) {
          return ae = "useRef", ft(), Pe(), kd();
        },
        useState: function(e) {
          ae = "useState", ft(), Pe();
          var t = xe.current;
          xe.current = po;
          try {
            return kp(e);
          } finally {
            xe.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return ae = "useDebugValue", ft(), Pe(), Zd();
        },
        useDeferredValue: function(e) {
          return ae = "useDeferredValue", ft(), Pe(), rh(e);
        },
        useTransition: function() {
          return ae = "useTransition", ft(), Pe(), oh();
        },
        useMutableSource: function(e, t, a) {
          return ae = "useMutableSource", ft(), Pe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return ae = "useSyncExternalStore", ft(), Pe(), Wd(e, t);
        },
        useId: function() {
          return ae = "useId", ft(), Pe(), eS();
        },
        unstable_isNewReconciler: te
      };
    }
    var eu = u.unstable_now, Rh = 0, rS = -1, nA = -1, aS = -1, nO = !1, iS = !1;
    function dh() {
      return nO;
    }
    function Dg() {
      iS = !0;
    }
    function gg() {
      nO = !1, iS = !1;
    }
    function Pg() {
      nO = iS, iS = !1;
    }
    function Sh() {
      return Rh;
    }
    function Nh() {
      Rh = eu();
    }
    function rO(e) {
      nA = eu(), e.actualStartTime < 0 && (e.actualStartTime = eu());
    }
    function ph(e) {
      nA = -1;
    }
    function oS(e, t) {
      if (nA >= 0) {
        var a = eu() - nA;
        e.actualDuration += a, t && (e.selfBaseDuration = a), nA = -1;
      }
    }
    function Sl(e) {
      if (rS >= 0) {
        var t = eu() - rS;
        rS = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case g:
              var i = a.stateNode;
              i.effectDuration += t;
              return;
            case Fe:
              var s = a.stateNode;
              s.effectDuration += t;
              return;
          }
          a = a.return;
        }
      }
    }
    function aO(e) {
      if (aS >= 0) {
        var t = eu() - aS;
        aS = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case g:
              var i = a.stateNode;
              i !== null && (i.passiveEffectDuration += t);
              return;
            case Fe:
              var s = a.stateNode;
              s !== null && (s.passiveEffectDuration += t);
              return;
          }
          a = a.return;
        }
      }
    }
    function Nl() {
      rS = eu();
    }
    function iO() {
      aS = eu();
    }
    function oO(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function pE(e, t) {
      return {
        value: e,
        source: t,
        stack: fs(t),
        digest: null
      };
    }
    function lO(e, t, a) {
      return {
        value: e,
        source: null,
        stack: a ?? null,
        digest: t ?? null
      };
    }
    function Mg(e, t) {
      return !0;
    }
    function sO(e, t) {
      try {
        var a = Mg(e, t);
        if (a === !1)
          return;
        var i = t.value, s = t.source, c = t.stack, A = c !== null ? c : "";
        if (i != null && i._suppressLogging) {
          if (e.tag === v)
            return;
          console.error(i);
        }
        var S = s ? ct(s) : null, p = S ? "The above error occurred in the <" + S + "> component:" : "The above error occurred in one of your React components:", L;
        if (e.tag === g)
          L = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var y = ct(e) || "Anonymous";
          L = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + y + ".");
        }
        var F = p + `
` + A + `

` + ("" + L);
        console.error(F);
      } catch (H) {
        setTimeout(function() {
          throw H;
        });
      }
    }
    var Ug = typeof WeakMap == "function" ? WeakMap : Map;
    function Oh(e, t, a) {
      var i = $l(an, a);
      i.tag = sp, i.payload = {
        element: null
      };
      var s = t.value;
      return i.callback = function() {
        vM(s), sO(e, t);
      }, i;
    }
    function uO(e, t, a) {
      var i = $l(an, a);
      i.tag = sp;
      var s = e.type.getDerivedStateFromError;
      if (typeof s == "function") {
        var c = t.value;
        i.payload = function() {
          return s(c);
        }, i.callback = function() {
          Mv(e), sO(e, t);
        };
      }
      var A = e.stateNode;
      return A !== null && typeof A.componentDidCatch == "function" && (i.callback = function() {
        Mv(e), sO(e, t), typeof s != "function" && CM(this);
        var p = t.value, L = t.stack;
        this.componentDidCatch(p, {
          componentStack: L !== null ? L : ""
        }), typeof s != "function" && (ca(e.lanes, ot) || d("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", ct(e) || "Unknown"));
      }), i;
    }
    function Ih(e, t, a) {
      var i = e.pingCache, s;
      if (i === null ? (i = e.pingCache = new Ug(), s = /* @__PURE__ */ new Set(), i.set(t, s)) : (s = i.get(t), s === void 0 && (s = /* @__PURE__ */ new Set(), i.set(t, s))), !s.has(a)) {
        s.add(a);
        var c = mM.bind(null, e, t, a);
        Da && NA(e, a), t.then(c, c);
      }
    }
    function _g(e, t, a, i) {
      var s = e.updateQueue;
      if (s === null) {
        var c = /* @__PURE__ */ new Set();
        c.add(a), e.updateQueue = c;
      } else
        s.add(a);
    }
    function Gg(e, t) {
      var a = e.tag;
      if ((e.mode & St) === ze && (a === D || a === he || a === Xe)) {
        var i = e.alternate;
        i ? (e.updateQueue = i.updateQueue, e.memoizedState = i.memoizedState, e.lanes = i.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function Ch(e) {
      var t = e;
      do {
        if (t.tag === ye && Ng(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function hh(e, t, a, i, s) {
      if ((e.mode & St) === ze) {
        if (e === t)
          e.flags |= or;
        else {
          if (e.flags |= Tt, a.flags |= gu, a.flags &= ~(JE | ma), a.tag === v) {
            var c = a.alternate;
            if (c === null)
              a.tag = ht;
            else {
              var A = $l(an, ot);
              A.tag = Pd, Qs(a, A, ot);
            }
          }
          a.lanes = Nt(a.lanes, ot);
        }
        return e;
      }
      return e.flags |= or, e.lanes = s, e;
    }
    function xg(e, t, a, i, s) {
      if (a.flags |= ma, Da && NA(e, s), i !== null && typeof i == "object" && typeof i.then == "function") {
        var c = i;
        Gg(a), Yr() && a.mode & St && AC();
        var A = Ch(t);
        if (A !== null) {
          A.flags &= ~Mn, hh(A, t, a, e, s), A.mode & St && Ih(e, c, s), _g(A, e, c);
          return;
        } else {
          if (!hR(s)) {
            Ih(e, c, s), VO();
            return;
          }
          var S = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          i = S;
        }
      } else if (Yr() && a.mode & St) {
        AC();
        var p = Ch(t);
        if (p !== null) {
          (p.flags & or) === qe && (p.flags |= Mn), hh(p, t, a, e, s), tp(pE(i, a));
          return;
        }
      }
      i = pE(i, a), AM(i);
      var L = t;
      do {
        switch (L.tag) {
          case g: {
            var y = i;
            L.flags |= or;
            var F = Yl(s);
            L.lanes = Nt(L.lanes, F);
            var H = Oh(L, y, F);
            cp(L, H);
            return;
          }
          case v:
            var z = i, Q = L.type, ne = L.stateNode;
            if ((L.flags & Tt) === qe && (typeof Q.getDerivedStateFromError == "function" || ne !== null && typeof ne.componentDidCatch == "function" && !Cv(ne))) {
              L.flags |= or;
              var He = Yl(s);
              L.lanes = Nt(L.lanes, He);
              var tt = uO(L, z, He);
              cp(L, tt);
              return;
            }
            break;
        }
        L = L.return;
      } while (L !== null);
    }
    function bg() {
      return null;
    }
    var rA = T.ReactCurrentOwner, Oo = !1, EO, aA, cO, TO, fO, OE, AO, lS;
    EO = {}, aA = {}, cO = {}, TO = {}, fO = {}, OE = !1, AO = {}, lS = {};
    function _a(e, t, a, i) {
      e === null ? t.child = VC(t, null, a, i) : t.child = Kc(t, e.child, a, i);
    }
    function Hg(e, t, a, i) {
      t.child = Kc(t, e.child, null, i), t.child = Kc(t, null, a, i);
    }
    function vh(e, t, a, i, s) {
      if (t.type !== t.elementType) {
        var c = a.propTypes;
        c && fo(
          c,
          i,
          // Resolved props
          "prop",
          Bt(a)
        );
      }
      var A = a.render, S = t.ref, p, L;
      kc(t, s);
      {
        if (rA.current = t, ra(!0), p = $c(e, t, A, i, S, s), L = eT(), t.mode & bn) {
          rn(!0);
          try {
            p = $c(e, t, A, i, S, s), L = eT();
          } finally {
            rn(!1);
          }
        }
        ra(!1);
      }
      return e !== null && !Oo ? (jC(e, t, s), es(e, t, s)) : (Yr() && L && JN(t), t.flags |= ko, _a(e, t, p, s), t.child);
    }
    function mh(e, t, a, i, s) {
      if (e === null) {
        var c = a.type;
        if (VM(c) && a.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        a.defaultProps === void 0) {
          var A = c;
          return A = sT(c), t.tag = Xe, t.type = A, SO(t, c), Lh(e, t, A, i, s);
        }
        {
          var S = c.propTypes;
          S && fo(
            S,
            i,
            // Resolved props
            "prop",
            Bt(c)
          );
        }
        var p = $O(a.type, null, i, t, t.mode, s);
        return p.ref = t.ref, p.return = t, t.child = p, p;
      }
      {
        var L = a.type, y = L.propTypes;
        y && fo(
          y,
          i,
          // Resolved props
          "prop",
          Bt(L)
        );
      }
      var F = e.child, H = hO(e, s);
      if (!H) {
        var z = F.memoizedProps, Q = a.compare;
        if (Q = Q !== null ? Q : cl, Q(z, i) && e.ref === t.ref)
          return es(e, t, s);
      }
      t.flags |= ko;
      var ne = mE(F, i);
      return ne.ref = t.ref, ne.return = t, t.child = ne, ne;
    }
    function Lh(e, t, a, i, s) {
      if (t.type !== t.elementType) {
        var c = t.elementType;
        if (c.$$typeof === et) {
          var A = c, S = A._payload, p = A._init;
          try {
            c = p(S);
          } catch {
            c = null;
          }
          var L = c && c.propTypes;
          L && fo(
            L,
            i,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Bt(c)
          );
        }
      }
      if (e !== null) {
        var y = e.memoizedProps;
        if (cl(y, i) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (Oo = !1, t.pendingProps = i = y, hO(e, s))
            (e.flags & gu) !== qe && (Oo = !0);
          else
            return t.lanes = e.lanes, es(e, t, s);
      }
      return RO(e, t, a, i, s);
    }
    function yh(e, t, a) {
      var i = t.pendingProps, s = i.children, c = e !== null ? e.memoizedState : null;
      if (i.mode === "hidden" || U)
        if ((t.mode & St) === ze) {
          var A = {
            baseLanes: se,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = A, OS(t, a);
        } else if (ca(a, cn)) {
          var F = {
            baseLanes: se,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = F;
          var H = c !== null ? c.baseLanes : a;
          OS(t, H);
        } else {
          var S = null, p;
          if (c !== null) {
            var L = c.baseLanes;
            p = Nt(L, a);
          } else
            p = a;
          t.lanes = t.childLanes = cn;
          var y = {
            baseLanes: p,
            cachePool: S,
            transitions: null
          };
          return t.memoizedState = y, t.updateQueue = null, OS(t, p), null;
        }
      else {
        var z;
        c !== null ? (z = Nt(c.baseLanes, a), t.memoizedState = null) : z = a, OS(t, z);
      }
      return _a(e, t, s, a), t.child;
    }
    function Bg(e, t, a) {
      var i = t.pendingProps;
      return _a(e, t, i, a), t.child;
    }
    function Fg(e, t, a) {
      var i = t.pendingProps.children;
      return _a(e, t, i, a), t.child;
    }
    function wg(e, t, a) {
      {
        t.flags |= Ct;
        {
          var i = t.stateNode;
          i.effectDuration = 0, i.passiveEffectDuration = 0;
        }
      }
      var s = t.pendingProps, c = s.children;
      return _a(e, t, c, a), t.child;
    }
    function Dh(e, t) {
      var a = t.ref;
      (e === null && a !== null || e !== null && e.ref !== a) && (t.flags |= ia, t.flags |= FT);
    }
    function RO(e, t, a, i, s) {
      if (t.type !== t.elementType) {
        var c = a.propTypes;
        c && fo(
          c,
          i,
          // Resolved props
          "prop",
          Bt(a)
        );
      }
      var A;
      {
        var S = Fc(t, a, !0);
        A = wc(t, S);
      }
      var p, L;
      kc(t, s);
      {
        if (rA.current = t, ra(!0), p = $c(e, t, a, i, A, s), L = eT(), t.mode & bn) {
          rn(!0);
          try {
            p = $c(e, t, a, i, A, s), L = eT();
          } finally {
            rn(!1);
          }
        }
        ra(!1);
      }
      return e !== null && !Oo ? (jC(e, t, s), es(e, t, s)) : (Yr() && L && JN(t), t.flags |= ko, _a(e, t, p, s), t.child);
    }
    function gh(e, t, a, i, s) {
      {
        switch (rU(t)) {
          case !1: {
            var c = t.stateNode, A = t.type, S = new A(t.memoizedProps, c.context), p = S.state;
            c.updater.enqueueSetState(c, p, null);
            break;
          }
          case !0: {
            t.flags |= Tt, t.flags |= or;
            var L = new Error("Simulated error coming from DevTools"), y = Yl(s);
            t.lanes = Nt(t.lanes, y);
            var F = uO(t, pE(L, t), y);
            cp(t, F);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var H = a.propTypes;
          H && fo(
            H,
            i,
            // Resolved props
            "prop",
            Bt(a)
          );
        }
      }
      var z;
      fl(a) ? (z = !0, pd(t)) : z = !1, kc(t, s);
      var Q = t.stateNode, ne;
      Q === null ? (uS(e, t), HC(t, a, i), hp(t, a, i, s), ne = !0) : e === null ? ne = Tg(t, a, i, s) : ne = fg(e, t, a, i, s);
      var He = dO(e, t, a, ne, z, s);
      {
        var tt = t.stateNode;
        ne && tt.props !== i && (OE || d("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", ct(t) || "a component"), OE = !0);
      }
      return He;
    }
    function dO(e, t, a, i, s, c) {
      Dh(e, t);
      var A = (t.flags & Tt) !== qe;
      if (!i && !A)
        return s && EC(t, a, !1), es(e, t, c);
      var S = t.stateNode;
      rA.current = t;
      var p;
      if (A && typeof a.getDerivedStateFromError != "function")
        p = null, ph();
      else {
        if (ra(!0), p = S.render(), t.mode & bn) {
          rn(!0);
          try {
            S.render();
          } finally {
            rn(!1);
          }
        }
        ra(!1);
      }
      return t.flags |= ko, e !== null && A ? Hg(e, t, p, c) : _a(e, t, p, c), t.memoizedState = S.state, s && EC(t, a, !0), t.child;
    }
    function Ph(e) {
      var t = e.stateNode;
      t.pendingContext ? sC(e, t.pendingContext, t.pendingContext !== t.context) : t.context && sC(e, t.context, !1), gp(e, t.containerInfo);
    }
    function Yg(e, t, a) {
      if (Ph(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var i = t.pendingProps, s = t.memoizedState, c = s.element;
      gC(e, t), Gd(t, i, null, a);
      var A = t.memoizedState;
      t.stateNode;
      var S = A.element;
      if (s.isDehydrated) {
        var p = {
          element: S,
          isDehydrated: !1,
          cache: A.cache,
          pendingSuspenseBoundaries: A.pendingSuspenseBoundaries,
          transitions: A.transitions
        }, L = t.updateQueue;
        if (L.baseState = p, t.memoizedState = p, t.flags & Mn) {
          var y = pE(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return Mh(e, t, S, a, y);
        } else if (S !== c) {
          var F = pE(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return Mh(e, t, S, a, F);
        } else {
          kD(t);
          var H = VC(t, null, S, a);
          t.child = H;
          for (var z = H; z; )
            z.flags = z.flags & ~dn | Xa, z = z.sibling;
        }
      } else {
        if (Wc(), S === c)
          return es(e, t, a);
        _a(e, t, S, a);
      }
      return t.child;
    }
    function Mh(e, t, a, i, s) {
      return Wc(), tp(s), t.flags |= Mn, _a(e, t, a, i), t.child;
    }
    function Vg(e, t, a) {
      XC(t), e === null && ep(t);
      var i = t.type, s = t.pendingProps, c = e !== null ? e.memoizedProps : null, A = s.children, S = xN(i, s);
      return S ? A = null : c !== null && xN(i, c) && (t.flags |= qt), Dh(e, t), _a(e, t, A, a), t.child;
    }
    function Wg(e, t) {
      return e === null && ep(t), null;
    }
    function Xg(e, t, a, i) {
      uS(e, t);
      var s = t.pendingProps, c = a, A = c._payload, S = c._init, p = S(A);
      t.type = p;
      var L = t.tag = WM(p), y = So(p, s), F;
      switch (L) {
        case D:
          return SO(t, p), t.type = p = sT(p), F = RO(null, t, p, y, i), F;
        case v:
          return t.type = p = jO(p), F = gh(null, t, p, y, i), F;
        case he:
          return t.type = p = zO(p), F = vh(null, t, p, y, i), F;
        case je: {
          if (t.type !== t.elementType) {
            var H = p.propTypes;
            H && fo(
              H,
              y,
              // Resolved for outer only
              "prop",
              Bt(p)
            );
          }
          return F = mh(
            null,
            t,
            p,
            So(p.type, y),
            // The inner type can have defaults too
            i
          ), F;
        }
      }
      var z = "";
      throw p !== null && typeof p == "object" && p.$$typeof === et && (z = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + p + ". " + ("Lazy element type must resolve to a class or function." + z));
    }
    function kg(e, t, a, i, s) {
      uS(e, t), t.tag = v;
      var c;
      return fl(a) ? (c = !0, pd(t)) : c = !1, kc(t, s), HC(t, a, i), hp(t, a, i, s), dO(null, t, a, !0, c, s);
    }
    function Kg(e, t, a, i) {
      uS(e, t);
      var s = t.pendingProps, c;
      {
        var A = Fc(t, a, !1);
        c = wc(t, A);
      }
      kc(t, i);
      var S, p;
      {
        if (a.prototype && typeof a.prototype.render == "function") {
          var L = Bt(a) || "Unknown";
          EO[L] || (d("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", L, L), EO[L] = !0);
        }
        t.mode & bn && Ro.recordLegacyContextWarning(t, null), ra(!0), rA.current = t, S = $c(null, t, a, s, c, i), p = eT(), ra(!1);
      }
      if (t.flags |= ko, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0) {
        var y = Bt(a) || "Unknown";
        aA[y] || (d("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", y, y, y), aA[y] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0
      ) {
        {
          var F = Bt(a) || "Unknown";
          aA[F] || (d("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", F, F, F), aA[F] = !0);
        }
        t.tag = v, t.memoizedState = null, t.updateQueue = null;
        var H = !1;
        return fl(a) ? (H = !0, pd(t)) : H = !1, t.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, Ep(t), bC(t, S), hp(t, a, s, i), dO(null, t, a, !0, H, i);
      } else {
        if (t.tag = D, t.mode & bn) {
          rn(!0);
          try {
            S = $c(null, t, a, s, c, i), p = eT();
          } finally {
            rn(!1);
          }
        }
        return Yr() && p && JN(t), _a(null, t, S, i), SO(t, a), t.child;
      }
    }
    function SO(e, t) {
      {
        if (t && t.childContextTypes && d("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var a = "", i = xr();
          i && (a += `

Check the render method of \`` + i + "`.");
          var s = i || "", c = e._debugSource;
          c && (s = c.fileName + ":" + c.lineNumber), fO[s] || (fO[s] = !0, d("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", a));
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var A = Bt(t) || "Unknown";
          TO[A] || (d("%s: Function components do not support getDerivedStateFromProps.", A), TO[A] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var S = Bt(t) || "Unknown";
          cO[S] || (d("%s: Function components do not support contextType.", S), cO[S] = !0);
        }
      }
    }
    var NO = {
      dehydrated: null,
      treeContext: null,
      retryLane: Xn
    };
    function pO(e) {
      return {
        baseLanes: e,
        cachePool: bg(),
        transitions: null
      };
    }
    function jg(e, t) {
      var a = null;
      return {
        baseLanes: Nt(e.baseLanes, t),
        cachePool: a,
        transitions: e.transitions
      };
    }
    function zg(e, t, a, i) {
      if (t !== null) {
        var s = t.memoizedState;
        if (s === null)
          return !1;
      }
      return Up(e, Jf);
    }
    function Jg(e, t) {
      return wu(e.childLanes, t);
    }
    function Uh(e, t, a) {
      var i = t.pendingProps;
      aU(t) && (t.flags |= Tt);
      var s = No.current, c = !1, A = (t.flags & Tt) !== qe;
      if (A || zg(s, e) ? (c = !0, t.flags &= ~Tt) : (e === null || e.memoizedState !== null) && (s = Sg(s, KC)), s = zc(s), qs(t, s), e === null) {
        ep(t);
        var S = t.memoizedState;
        if (S !== null) {
          var p = S.dehydrated;
          if (p !== null)
            return eP(t, p);
        }
        var L = i.children, y = i.fallback;
        if (c) {
          var F = Qg(t, L, y, a), H = t.child;
          return H.memoizedState = pO(a), t.memoizedState = NO, F;
        } else
          return OO(t, L);
      } else {
        var z = e.memoizedState;
        if (z !== null) {
          var Q = z.dehydrated;
          if (Q !== null)
            return tP(e, t, A, i, Q, z, a);
        }
        if (c) {
          var ne = i.fallback, He = i.children, tt = qg(e, t, He, ne, a), Je = t.child, xt = e.child.memoizedState;
          return Je.memoizedState = xt === null ? pO(a) : jg(xt, a), Je.childLanes = Jg(e, a), t.memoizedState = NO, tt;
        } else {
          var Pt = i.children, X = Zg(e, t, Pt, a);
          return t.memoizedState = null, X;
        }
      }
    }
    function OO(e, t, a) {
      var i = e.mode, s = {
        mode: "visible",
        children: t
      }, c = IO(s, i);
      return c.return = e, e.child = c, c;
    }
    function Qg(e, t, a, i) {
      var s = e.mode, c = e.child, A = {
        mode: "hidden",
        children: t
      }, S, p;
      return (s & St) === ze && c !== null ? (S = c, S.childLanes = se, S.pendingProps = A, e.mode & Wt && (S.actualDuration = 0, S.actualStartTime = -1, S.selfBaseDuration = 0, S.treeBaseDuration = 0), p = ou(a, s, i, null)) : (S = IO(A, s), p = ou(a, s, i, null)), S.return = e, p.return = e, S.sibling = p, e.child = S, p;
    }
    function IO(e, t, a) {
      return _v(e, t, se, null);
    }
    function _h(e, t) {
      return mE(e, t);
    }
    function Zg(e, t, a, i) {
      var s = e.child, c = s.sibling, A = _h(s, {
        mode: "visible",
        children: a
      });
      if ((t.mode & St) === ze && (A.lanes = i), A.return = t, A.sibling = null, c !== null) {
        var S = t.deletions;
        S === null ? (t.deletions = [c], t.flags |= jt) : S.push(c);
      }
      return t.child = A, A;
    }
    function qg(e, t, a, i, s) {
      var c = t.mode, A = e.child, S = A.sibling, p = {
        mode: "hidden",
        children: a
      }, L;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (c & St) === ze && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== A
      ) {
        var y = t.child;
        L = y, L.childLanes = se, L.pendingProps = p, t.mode & Wt && (L.actualDuration = 0, L.actualStartTime = -1, L.selfBaseDuration = A.selfBaseDuration, L.treeBaseDuration = A.treeBaseDuration), t.deletions = null;
      } else
        L = _h(A, p), L.subtreeFlags = A.subtreeFlags & cr;
      var F;
      return S !== null ? F = mE(S, i) : (F = ou(i, c, s, null), F.flags |= dn), F.return = t, L.return = t, L.sibling = F, t.child = L, F;
    }
    function sS(e, t, a, i) {
      i !== null && tp(i), Kc(t, e.child, null, a);
      var s = t.pendingProps, c = s.children, A = OO(t, c);
      return A.flags |= dn, t.memoizedState = null, A;
    }
    function $g(e, t, a, i, s) {
      var c = t.mode, A = {
        mode: "visible",
        children: a
      }, S = IO(A, c), p = ou(i, c, s, null);
      return p.flags |= dn, S.return = t, p.return = t, S.sibling = p, t.child = S, (t.mode & St) !== ze && Kc(t, e.child, null, s), p;
    }
    function eP(e, t, a) {
      return (e.mode & St) === ze ? (d("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = ot) : FN(t) ? e.lanes = bl : e.lanes = cn, null;
    }
    function tP(e, t, a, i, s, c, A) {
      if (a)
        if (t.flags & Mn) {
          t.flags &= ~Mn;
          var X = lO(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return sS(e, t, A, X);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= Tt, null;
          var re = i.children, k = i.fallback, de = $g(e, t, re, k, A), Be = t.child;
          return Be.memoizedState = pO(A), t.memoizedState = NO, de;
        }
      else {
        if (WD(), (t.mode & St) === ze)
          return sS(
            e,
            t,
            A,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (FN(s)) {
          var S, p, L;
          {
            var y = oD(s);
            S = y.digest, p = y.message, L = y.stack;
          }
          var F;
          p ? F = new Error(p) : F = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var H = lO(F, S, L);
          return sS(e, t, A, H);
        }
        var z = ca(A, e.childLanes);
        if (Oo || z) {
          var Q = pS();
          if (Q !== null) {
            var ne = Tc(Q, A);
            if (ne !== Xn && ne !== c.retryLane) {
              c.retryLane = ne;
              var He = an;
              Za(e, ne), Or(Q, e, ne, He);
            }
          }
          VO();
          var tt = lO(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return sS(e, t, A, tt);
        } else if (nC(s)) {
          t.flags |= Tt, t.child = e.child;
          var Je = LM.bind(null, e);
          return lD(s, Je), null;
        } else {
          KD(t, s, c.treeContext);
          var xt = i.children, Pt = OO(t, xt);
          return Pt.flags |= Xa, Pt;
        }
      }
    }
    function Gh(e, t, a) {
      e.lanes = Nt(e.lanes, t);
      var i = e.alternate;
      i !== null && (i.lanes = Nt(i.lanes, t)), op(e.return, t, a);
    }
    function nP(e, t, a) {
      for (var i = t; i !== null; ) {
        if (i.tag === ye) {
          var s = i.memoizedState;
          s !== null && Gh(i, a, e);
        } else if (i.tag === gt)
          Gh(i, a, e);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    function rP(e) {
      for (var t = e, a = null; t !== null; ) {
        var i = t.alternate;
        i !== null && Yd(i) === null && (a = t), t = t.sibling;
      }
      return a;
    }
    function aP(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !AO[e])
        if (AO[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              d('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              d('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              d('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          d('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function iP(e, t) {
      e !== void 0 && !lS[e] && (e !== "collapsed" && e !== "hidden" ? (lS[e] = !0, d('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (lS[e] = !0, d('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function xh(e, t) {
      {
        var a = Ut(e), i = !a && typeof ri(e) == "function";
        if (a || i) {
          var s = a ? "array" : "iterable";
          return d("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", s, t, s), !1;
        }
      }
      return !0;
    }
    function oP(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (Ut(e)) {
          for (var a = 0; a < e.length; a++)
            if (!xh(e[a], a))
              return;
        } else {
          var i = ri(e);
          if (typeof i == "function") {
            var s = i.call(e);
            if (s)
              for (var c = s.next(), A = 0; !c.done; c = s.next()) {
                if (!xh(c.value, A))
                  return;
                A++;
              }
          } else
            d('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function CO(e, t, a, i, s) {
      var c = e.memoizedState;
      c === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: a,
        tailMode: s
      } : (c.isBackwards = t, c.rendering = null, c.renderingStartTime = 0, c.last = i, c.tail = a, c.tailMode = s);
    }
    function bh(e, t, a) {
      var i = t.pendingProps, s = i.revealOrder, c = i.tail, A = i.children;
      aP(s), iP(c, s), oP(A, s), _a(e, t, A, a);
      var S = No.current, p = Up(S, Jf);
      if (p)
        S = _p(S, Jf), t.flags |= Tt;
      else {
        var L = e !== null && (e.flags & Tt) !== qe;
        L && nP(t, t.child, a), S = zc(S);
      }
      if (qs(t, S), (t.mode & St) === ze)
        t.memoizedState = null;
      else
        switch (s) {
          case "forwards": {
            var y = rP(t.child), F;
            y === null ? (F = t.child, t.child = null) : (F = y.sibling, y.sibling = null), CO(
              t,
              !1,
              // isBackwards
              F,
              y,
              c
            );
            break;
          }
          case "backwards": {
            var H = null, z = t.child;
            for (t.child = null; z !== null; ) {
              var Q = z.alternate;
              if (Q !== null && Yd(Q) === null) {
                t.child = z;
                break;
              }
              var ne = z.sibling;
              z.sibling = H, H = z, z = ne;
            }
            CO(
              t,
              !0,
              // isBackwards
              H,
              null,
              // last
              c
            );
            break;
          }
          case "together": {
            CO(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function lP(e, t, a) {
      gp(t, t.stateNode.containerInfo);
      var i = t.pendingProps;
      return e === null ? t.child = Kc(t, null, i, a) : _a(e, t, i, a), t.child;
    }
    var Hh = !1;
    function sP(e, t, a) {
      var i = t.type, s = i._context, c = t.pendingProps, A = t.memoizedProps, S = c.value;
      {
        "value" in c || Hh || (Hh = !0, d("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var p = t.type.propTypes;
        p && fo(p, c, "prop", "Context.Provider");
      }
      if (mC(t, s, S), A !== null) {
        var L = A.value;
        if (Fr(L, S)) {
          if (A.children === c.children && !Sd())
            return es(e, t, a);
        } else
          ng(t, s, a);
      }
      var y = c.children;
      return _a(e, t, y, a), t.child;
    }
    var Bh = !1;
    function uP(e, t, a) {
      var i = t.type;
      i._context === void 0 ? i !== i.Consumer && (Bh || (Bh = !0, d("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : i = i._context;
      var s = t.pendingProps, c = s.children;
      typeof c != "function" && d("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), kc(t, a);
      var A = sr(i), S;
      return rA.current = t, ra(!0), S = c(A), ra(!1), t.flags |= ko, _a(e, t, S, a), t.child;
    }
    function iA() {
      Oo = !0;
    }
    function uS(e, t) {
      (t.mode & St) === ze && e !== null && (e.alternate = null, t.alternate = null, t.flags |= dn);
    }
    function es(e, t, a) {
      return e !== null && (t.dependencies = e.dependencies), ph(), SA(t.lanes), ca(a, t.childLanes) ? (Ag(e, t), t.child) : null;
    }
    function EP(e, t, a) {
      {
        var i = t.return;
        if (i === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, t === i.child)
          i.child = a;
        else {
          var s = i.child;
          if (s === null)
            throw new Error("Expected parent to have a child.");
          for (; s.sibling !== t; )
            if (s = s.sibling, s === null)
              throw new Error("Expected to find the previous sibling.");
          s.sibling = a;
        }
        var c = i.deletions;
        return c === null ? (i.deletions = [e], i.flags |= jt) : c.push(e), a.flags |= dn, a;
      }
    }
    function hO(e, t) {
      var a = e.lanes;
      return !!ca(a, t);
    }
    function cP(e, t, a) {
      switch (t.tag) {
        case g:
          Ph(t), t.stateNode, Wc();
          break;
        case Y:
          XC(t);
          break;
        case v: {
          var i = t.type;
          fl(i) && pd(t);
          break;
        }
        case w:
          gp(t, t.stateNode.containerInfo);
          break;
        case Oe: {
          var s = t.memoizedProps.value, c = t.type._context;
          mC(t, c, s);
          break;
        }
        case Fe:
          {
            var A = ca(a, t.childLanes);
            A && (t.flags |= Ct);
            {
              var S = t.stateNode;
              S.effectDuration = 0, S.passiveEffectDuration = 0;
            }
          }
          break;
        case ye: {
          var p = t.memoizedState;
          if (p !== null) {
            if (p.dehydrated !== null)
              return qs(t, zc(No.current)), t.flags |= Tt, null;
            var L = t.child, y = L.childLanes;
            if (ca(a, y))
              return Uh(e, t, a);
            qs(t, zc(No.current));
            var F = es(e, t, a);
            return F !== null ? F.sibling : null;
          } else
            qs(t, zc(No.current));
          break;
        }
        case gt: {
          var H = (e.flags & Tt) !== qe, z = ca(a, t.childLanes);
          if (H) {
            if (z)
              return bh(e, t, a);
            t.flags |= Tt;
          }
          var Q = t.memoizedState;
          if (Q !== null && (Q.rendering = null, Q.tail = null, Q.lastEffect = null), qs(t, No.current), z)
            break;
          return null;
        }
        case Se:
        case le:
          return t.lanes = se, yh(e, t, a);
      }
      return es(e, t, a);
    }
    function Fh(e, t, a) {
      if (t._debugNeedsRemount && e !== null)
        return EP(e, t, $O(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var i = e.memoizedProps, s = t.pendingProps;
        if (i !== s || Sd() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          Oo = !0;
        else {
          var c = hO(e, a);
          if (!c && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & Tt) === qe)
            return Oo = !1, cP(e, t, a);
          (e.flags & gu) !== qe ? Oo = !0 : Oo = !1;
        }
      } else if (Oo = !1, Yr() && HD(t)) {
        var A = t.index, S = BD();
        fC(t, S, A);
      }
      switch (t.lanes = se, t.tag) {
        case M:
          return Kg(e, t, t.type, a);
        case yt: {
          var p = t.elementType;
          return Xg(e, t, p, a);
        }
        case D: {
          var L = t.type, y = t.pendingProps, F = t.elementType === L ? y : So(L, y);
          return RO(e, t, L, F, a);
        }
        case v: {
          var H = t.type, z = t.pendingProps, Q = t.elementType === H ? z : So(H, z);
          return gh(e, t, H, Q, a);
        }
        case g:
          return Yg(e, t, a);
        case Y:
          return Vg(e, t, a);
        case j:
          return Wg(e, t);
        case ye:
          return Uh(e, t, a);
        case w:
          return lP(e, t, a);
        case he: {
          var ne = t.type, He = t.pendingProps, tt = t.elementType === ne ? He : So(ne, He);
          return vh(e, t, ne, tt, a);
        }
        case oe:
          return Bg(e, t, a);
        case me:
          return Fg(e, t, a);
        case Fe:
          return wg(e, t, a);
        case Oe:
          return sP(e, t, a);
        case Le:
          return uP(e, t, a);
        case je: {
          var Je = t.type, xt = t.pendingProps, Pt = So(Je, xt);
          if (t.type !== t.elementType) {
            var X = Je.propTypes;
            X && fo(
              X,
              Pt,
              // Resolved for outer only
              "prop",
              Bt(Je)
            );
          }
          return Pt = So(Je.type, Pt), mh(e, t, Je, Pt, a);
        }
        case Xe:
          return Lh(e, t, t.type, t.pendingProps, a);
        case ht: {
          var re = t.type, k = t.pendingProps, de = t.elementType === re ? k : So(re, k);
          return kg(e, t, re, de, a);
        }
        case gt:
          return bh(e, t, a);
        case Rn:
          break;
        case Se:
          return yh(e, t, a);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function tT(e) {
      e.flags |= Ct;
    }
    function wh(e) {
      e.flags |= ia, e.flags |= FT;
    }
    var Yh, vO, Vh, Wh;
    Yh = function(e, t, a, i) {
      for (var s = t.child; s !== null; ) {
        if (s.tag === Y || s.tag === j)
          Gy(e, s.stateNode);
        else if (s.tag !== w) {
          if (s.child !== null) {
            s.child.return = s, s = s.child;
            continue;
          }
        }
        if (s === t)
          return;
        for (; s.sibling === null; ) {
          if (s.return === null || s.return === t)
            return;
          s = s.return;
        }
        s.sibling.return = s.return, s = s.sibling;
      }
    }, vO = function(e, t) {
    }, Vh = function(e, t, a, i, s) {
      var c = e.memoizedProps;
      if (c !== i) {
        var A = t.stateNode, S = Pp(), p = by(A, a, c, i, s, S);
        t.updateQueue = p, p && tT(t);
      }
    }, Wh = function(e, t, a, i) {
      a !== i && tT(t);
    };
    function oA(e, t) {
      if (!Yr())
        switch (e.tailMode) {
          case "hidden": {
            for (var a = e.tail, i = null; a !== null; )
              a.alternate !== null && (i = a), a = a.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          }
          case "collapsed": {
            for (var s = e.tail, c = null; s !== null; )
              s.alternate !== null && (c = s), s = s.sibling;
            c === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : c.sibling = null;
            break;
          }
        }
    }
    function Vr(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = se, i = qe;
      if (t) {
        if ((e.mode & Wt) !== ze) {
          for (var p = e.selfBaseDuration, L = e.child; L !== null; )
            a = Nt(a, Nt(L.lanes, L.childLanes)), i |= L.subtreeFlags & cr, i |= L.flags & cr, p += L.treeBaseDuration, L = L.sibling;
          e.treeBaseDuration = p;
        } else
          for (var y = e.child; y !== null; )
            a = Nt(a, Nt(y.lanes, y.childLanes)), i |= y.subtreeFlags & cr, i |= y.flags & cr, y.return = e, y = y.sibling;
        e.subtreeFlags |= i;
      } else {
        if ((e.mode & Wt) !== ze) {
          for (var s = e.actualDuration, c = e.selfBaseDuration, A = e.child; A !== null; )
            a = Nt(a, Nt(A.lanes, A.childLanes)), i |= A.subtreeFlags, i |= A.flags, s += A.actualDuration, c += A.treeBaseDuration, A = A.sibling;
          e.actualDuration = s, e.treeBaseDuration = c;
        } else
          for (var S = e.child; S !== null; )
            a = Nt(a, Nt(S.lanes, S.childLanes)), i |= S.subtreeFlags, i |= S.flags, S.return = e, S = S.sibling;
        e.subtreeFlags |= i;
      }
      return e.childLanes = a, t;
    }
    function TP(e, t, a) {
      if (ZD() && (t.mode & St) !== ze && (t.flags & Tt) === qe)
        return OC(t), Wc(), t.flags |= Mn | ma | or, !1;
      var i = vd(t);
      if (a !== null && a.dehydrated !== null)
        if (e === null) {
          if (!i)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (JD(t), Vr(t), (t.mode & Wt) !== ze) {
            var s = a !== null;
            if (s) {
              var c = t.child;
              c !== null && (t.treeBaseDuration -= c.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Wc(), (t.flags & Tt) === qe && (t.memoizedState = null), t.flags |= Ct, Vr(t), (t.mode & Wt) !== ze) {
            var A = a !== null;
            if (A) {
              var S = t.child;
              S !== null && (t.treeBaseDuration -= S.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return IC(), !0;
    }
    function Xh(e, t, a) {
      var i = t.pendingProps;
      switch (QN(t), t.tag) {
        case M:
        case yt:
        case Xe:
        case D:
        case he:
        case oe:
        case me:
        case Fe:
        case Le:
        case je:
          return Vr(t), null;
        case v: {
          var s = t.type;
          return fl(s) && Nd(t), Vr(t), null;
        }
        case g: {
          var c = t.stateNode;
          if (jc(t), KN(t), xp(), c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), e === null || e.child === null) {
            var A = vd(t);
            if (A)
              tT(t);
            else if (e !== null) {
              var S = e.memoizedState;
              // Check if this is a client root
              (!S.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & Mn) !== qe) && (t.flags |= Wa, IC());
            }
          }
          return vO(e, t), Vr(t), null;
        }
        case Y: {
          Mp(t);
          var p = WC(), L = t.type;
          if (e !== null && t.stateNode != null)
            Vh(e, t, L, i, p), e.ref !== t.ref && wh(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Vr(t), null;
            }
            var y = Pp(), F = vd(t);
            if (F)
              jD(t, p, y) && tT(t);
            else {
              var H = _y(L, i, p, y, t);
              Yh(H, t, !1, !1), t.stateNode = H, xy(H, L, i, p) && tT(t);
            }
            t.ref !== null && wh(t);
          }
          return Vr(t), null;
        }
        case j: {
          var z = i;
          if (e && t.stateNode != null) {
            var Q = e.memoizedProps;
            Wh(e, t, Q, z);
          } else {
            if (typeof z != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var ne = WC(), He = Pp(), tt = vd(t);
            tt ? zD(t) && tT(t) : t.stateNode = Hy(z, ne, He, t);
          }
          return Vr(t), null;
        }
        case ye: {
          Jc(t);
          var Je = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var xt = TP(e, t, Je);
            if (!xt)
              return t.flags & or ? t : null;
          }
          if ((t.flags & Tt) !== qe)
            return t.lanes = a, (t.mode & Wt) !== ze && oO(t), t;
          var Pt = Je !== null, X = e !== null && e.memoizedState !== null;
          if (Pt !== X && Pt) {
            var re = t.child;
            if (re.flags |= Ko, (t.mode & St) !== ze) {
              var k = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !q);
              k || Up(No.current, KC) ? fM() : VO();
            }
          }
          var de = t.updateQueue;
          if (de !== null && (t.flags |= Ct), Vr(t), (t.mode & Wt) !== ze && Pt) {
            var Be = t.child;
            Be !== null && (t.treeBaseDuration -= Be.treeBaseDuration);
          }
          return null;
        }
        case w:
          return jc(t), vO(e, t), e === null && PD(t.stateNode.containerInfo), Vr(t), null;
        case Oe:
          var _e = t.type._context;
          return ip(_e, t), Vr(t), null;
        case ht: {
          var st = t.type;
          return fl(st) && Nd(t), Vr(t), null;
        }
        case gt: {
          Jc(t);
          var Rt = t.memoizedState;
          if (Rt === null)
            return Vr(t), null;
          var ln = (t.flags & Tt) !== qe, Xt = Rt.rendering;
          if (Xt === null)
            if (ln)
              oA(Rt, !1);
            else {
              var tr = RM() && (e === null || (e.flags & Tt) === qe);
              if (!tr)
                for (var kt = t.child; kt !== null; ) {
                  var zn = Yd(kt);
                  if (zn !== null) {
                    ln = !0, t.flags |= Tt, oA(Rt, !1);
                    var Sa = zn.updateQueue;
                    return Sa !== null && (t.updateQueue = Sa, t.flags |= Ct), t.subtreeFlags = qe, Rg(t, a), qs(t, _p(No.current, Jf)), t.child;
                  }
                  kt = kt.sibling;
                }
              Rt.tail !== null && yn() > cv() && (t.flags |= Tt, ln = !0, oA(Rt, !1), t.lanes = qn);
            }
          else {
            if (!ln) {
              var jr = Yd(Xt);
              if (jr !== null) {
                t.flags |= Tt, ln = !0;
                var Oi = jr.updateQueue;
                if (Oi !== null && (t.updateQueue = Oi, t.flags |= Ct), oA(Rt, !0), Rt.tail === null && Rt.tailMode === "hidden" && !Xt.alternate && !Yr())
                  return Vr(t), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                yn() * 2 - Rt.renderingStartTime > cv() && a !== cn && (t.flags |= Tt, ln = !0, oA(Rt, !1), t.lanes = qn);
            }
            if (Rt.isBackwards)
              Xt.sibling = t.child, t.child = Xt;
            else {
              var ba = Rt.last;
              ba !== null ? ba.sibling = Xt : t.child = Xt, Rt.last = Xt;
            }
          }
          if (Rt.tail !== null) {
            var Ha = Rt.tail;
            Rt.rendering = Ha, Rt.tail = Ha.sibling, Rt.renderingStartTime = yn(), Ha.sibling = null;
            var Na = No.current;
            return ln ? Na = _p(Na, Jf) : Na = zc(Na), qs(t, Na), Ha;
          }
          return Vr(t), null;
        }
        case Rn:
          break;
        case Se:
        case le: {
          YO(t);
          var is = t.memoizedState, uT = is !== null;
          if (e !== null) {
            var CA = e.memoizedState, Il = CA !== null;
            Il !== uT && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !U && (t.flags |= Ko);
          }
          return !uT || (t.mode & St) === ze ? Vr(t) : ca(Ol, cn) && (Vr(t), t.subtreeFlags & (dn | Ct) && (t.flags |= Ko)), null;
        }
        case ce:
          return null;
        case ve:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function fP(e, t, a) {
      switch (QN(t), t.tag) {
        case v: {
          var i = t.type;
          fl(i) && Nd(t);
          var s = t.flags;
          return s & or ? (t.flags = s & ~or | Tt, (t.mode & Wt) !== ze && oO(t), t) : null;
        }
        case g: {
          t.stateNode, jc(t), KN(t), xp();
          var c = t.flags;
          return (c & or) !== qe && (c & Tt) === qe ? (t.flags = c & ~or | Tt, t) : null;
        }
        case Y:
          return Mp(t), null;
        case ye: {
          Jc(t);
          var A = t.memoizedState;
          if (A !== null && A.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Wc();
          }
          var S = t.flags;
          return S & or ? (t.flags = S & ~or | Tt, (t.mode & Wt) !== ze && oO(t), t) : null;
        }
        case gt:
          return Jc(t), null;
        case w:
          return jc(t), null;
        case Oe:
          var p = t.type._context;
          return ip(p, t), null;
        case Se:
        case le:
          return YO(t), null;
        case ce:
          return null;
        default:
          return null;
      }
    }
    function kh(e, t, a) {
      switch (QN(t), t.tag) {
        case v: {
          var i = t.type.childContextTypes;
          i != null && Nd(t);
          break;
        }
        case g: {
          t.stateNode, jc(t), KN(t), xp();
          break;
        }
        case Y: {
          Mp(t);
          break;
        }
        case w:
          jc(t);
          break;
        case ye:
          Jc(t);
          break;
        case gt:
          Jc(t);
          break;
        case Oe:
          var s = t.type._context;
          ip(s, t);
          break;
        case Se:
        case le:
          YO(t);
          break;
      }
    }
    var Kh = null;
    Kh = /* @__PURE__ */ new Set();
    var ES = !1, Wr = !1, AP = typeof WeakSet == "function" ? WeakSet : Set, Ve = null, nT = null, rT = null;
    function RP(e) {
      _l(null, function() {
        throw e;
      }), HT();
    }
    var dP = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Wt)
        try {
          Nl(), t.componentWillUnmount();
        } finally {
          Sl(e);
        }
      else
        t.componentWillUnmount();
    };
    function jh(e, t) {
      try {
        tu(Ua, e);
      } catch (a) {
        On(e, t, a);
      }
    }
    function mO(e, t, a) {
      try {
        dP(e, a);
      } catch (i) {
        On(e, t, i);
      }
    }
    function SP(e, t, a) {
      try {
        a.componentDidMount();
      } catch (i) {
        On(e, t, i);
      }
    }
    function zh(e, t) {
      try {
        Qh(e);
      } catch (a) {
        On(e, t, a);
      }
    }
    function aT(e, t) {
      var a = e.ref;
      if (a !== null)
        if (typeof a == "function") {
          var i;
          try {
            if (ut && Ot && e.mode & Wt)
              try {
                Nl(), i = a(null);
              } finally {
                Sl(e);
              }
            else
              i = a(null);
          } catch (s) {
            On(e, t, s);
          }
          typeof i == "function" && d("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", ct(e));
        } else
          a.current = null;
    }
    function cS(e, t, a) {
      try {
        a();
      } catch (i) {
        On(e, t, i);
      }
    }
    var Jh = !1;
    function NP(e, t) {
      My(e.containerInfo), Ve = t, pP();
      var a = Jh;
      return Jh = !1, a;
    }
    function pP() {
      for (; Ve !== null; ) {
        var e = Ve, t = e.child;
        (e.subtreeFlags & ys) !== qe && t !== null ? (t.return = e, Ve = t) : OP();
      }
    }
    function OP() {
      for (; Ve !== null; ) {
        var e = Ve;
        Zt(e);
        try {
          IP(e);
        } catch (a) {
          On(e, e.return, a);
        }
        Pn();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, Ve = t;
          return;
        }
        Ve = e.return;
      }
    }
    function IP(e) {
      var t = e.alternate, a = e.flags;
      if ((a & Wa) !== qe) {
        switch (Zt(e), e.tag) {
          case D:
          case he:
          case Xe:
            break;
          case v: {
            if (t !== null) {
              var i = t.memoizedProps, s = t.memoizedState, c = e.stateNode;
              e.type === e.elementType && !OE && (c.props !== e.memoizedProps && d("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ct(e) || "instance"), c.state !== e.memoizedState && d("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ct(e) || "instance"));
              var A = c.getSnapshotBeforeUpdate(e.elementType === e.type ? i : So(e.type, i), s);
              {
                var S = Kh;
                A === void 0 && !S.has(e.type) && (S.add(e.type), d("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", ct(e)));
              }
              c.__reactInternalSnapshotBeforeUpdate = A;
            }
            break;
          }
          case g: {
            {
              var p = e.stateNode;
              nD(p.containerInfo);
            }
            break;
          }
          case Y:
          case j:
          case w:
          case ht:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Pn();
      }
    }
    function Io(e, t, a) {
      var i = t.updateQueue, s = i !== null ? i.lastEffect : null;
      if (s !== null) {
        var c = s.next, A = c;
        do {
          if ((A.tag & e) === e) {
            var S = A.destroy;
            A.destroy = void 0, S !== void 0 && ((e & Al) !== Qc && pA(!0), cS(t, a, S), (e & Al) !== Qc && pA(!1));
          }
          A = A.next;
        } while (A !== c);
      }
    }
    function tu(e, t) {
      var a = t.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var s = i.next, c = s;
        do {
          if ((c.tag & e) === e) {
            var A = c.create;
            (e & Al) !== Qc && pA(!0), c.destroy = A(), (e & Al) !== Qc && pA(!1);
            {
              var S = c.destroy;
              if (S !== void 0 && typeof S != "function") {
                var p = void 0;
                (c.tag & Ua) !== qe ? p = "useLayoutEffect" : (c.tag & Al) !== qe ? p = "useInsertionEffect" : p = "useEffect";
                var L = void 0;
                S === null ? L = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof S.then == "function" ? L = `

It looks like you wrote ` + p + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + p + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : L = " You returned: " + S, d("%s must not return anything besides a function, which is used for clean-up.%s", p, L);
              }
            }
          }
          c = c.next;
        } while (c !== s);
      }
    }
    function CP(e, t) {
      if ((t.flags & Ct) !== qe)
        switch (t.tag) {
          case Fe: {
            var a = t.stateNode.passiveEffectDuration, i = t.memoizedProps, s = i.id, c = i.onPostCommit, A = Sh(), S = t.alternate === null ? "mount" : "update";
            dh() && (S = "nested-update"), typeof c == "function" && c(s, S, a, A);
            var p = t.return;
            e:
              for (; p !== null; ) {
                switch (p.tag) {
                  case g:
                    var L = p.stateNode;
                    L.passiveEffectDuration += a;
                    break e;
                  case Fe:
                    var y = p.stateNode;
                    y.passiveEffectDuration += a;
                    break e;
                }
                p = p.return;
              }
            break;
          }
        }
    }
    function hP(e, t, a, i) {
      if ((a.flags & vr) !== qe)
        switch (a.tag) {
          case D:
          case he:
          case Xe: {
            if (!Wr)
              if (a.mode & Wt)
                try {
                  Nl(), tu(Ua | Ar, a);
                } finally {
                  Sl(a);
                }
              else
                tu(Ua | Ar, a);
            break;
          }
          case v: {
            var s = a.stateNode;
            if (a.flags & Ct && !Wr)
              if (t === null)
                if (a.type === a.elementType && !OE && (s.props !== a.memoizedProps && d("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ct(a) || "instance"), s.state !== a.memoizedState && d("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ct(a) || "instance")), a.mode & Wt)
                  try {
                    Nl(), s.componentDidMount();
                  } finally {
                    Sl(a);
                  }
                else
                  s.componentDidMount();
              else {
                var c = a.elementType === a.type ? t.memoizedProps : So(a.type, t.memoizedProps), A = t.memoizedState;
                if (a.type === a.elementType && !OE && (s.props !== a.memoizedProps && d("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ct(a) || "instance"), s.state !== a.memoizedState && d("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ct(a) || "instance")), a.mode & Wt)
                  try {
                    Nl(), s.componentDidUpdate(c, A, s.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Sl(a);
                  }
                else
                  s.componentDidUpdate(c, A, s.__reactInternalSnapshotBeforeUpdate);
              }
            var S = a.updateQueue;
            S !== null && (a.type === a.elementType && !OE && (s.props !== a.memoizedProps && d("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ct(a) || "instance"), s.state !== a.memoizedState && d("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ct(a) || "instance")), MC(a, S, s));
            break;
          }
          case g: {
            var p = a.updateQueue;
            if (p !== null) {
              var L = null;
              if (a.child !== null)
                switch (a.child.tag) {
                  case Y:
                    L = a.child.stateNode;
                    break;
                  case v:
                    L = a.child.stateNode;
                    break;
                }
              MC(a, p, L);
            }
            break;
          }
          case Y: {
            var y = a.stateNode;
            if (t === null && a.flags & Ct) {
              var F = a.type, H = a.memoizedProps;
              Vy(y, F, H);
            }
            break;
          }
          case j:
            break;
          case w:
            break;
          case Fe: {
            {
              var z = a.memoizedProps, Q = z.onCommit, ne = z.onRender, He = a.stateNode.effectDuration, tt = Sh(), Je = t === null ? "mount" : "update";
              dh() && (Je = "nested-update"), typeof ne == "function" && ne(a.memoizedProps.id, Je, a.actualDuration, a.treeBaseDuration, a.actualStartTime, tt);
              {
                typeof Q == "function" && Q(a.memoizedProps.id, Je, He, tt), OM(a);
                var xt = a.return;
                e:
                  for (; xt !== null; ) {
                    switch (xt.tag) {
                      case g:
                        var Pt = xt.stateNode;
                        Pt.effectDuration += He;
                        break e;
                      case Fe:
                        var X = xt.stateNode;
                        X.effectDuration += He;
                        break e;
                    }
                    xt = xt.return;
                  }
              }
            }
            break;
          }
          case ye: {
            MP(e, a);
            break;
          }
          case gt:
          case ht:
          case Rn:
          case Se:
          case le:
          case ve:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Wr || a.flags & ia && Qh(a);
    }
    function vP(e) {
      switch (e.tag) {
        case D:
        case he:
        case Xe: {
          if (e.mode & Wt)
            try {
              Nl(), jh(e, e.return);
            } finally {
              Sl(e);
            }
          else
            jh(e, e.return);
          break;
        }
        case v: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && SP(e, e.return, t), zh(e, e.return);
          break;
        }
        case Y: {
          zh(e, e.return);
          break;
        }
      }
    }
    function mP(e, t) {
      for (var a = null, i = e; ; ) {
        if (i.tag === Y) {
          if (a === null) {
            a = i;
            try {
              var s = i.stateNode;
              t ? qy(s) : eD(i.stateNode, i.memoizedProps);
            } catch (A) {
              On(e, e.return, A);
            }
          }
        } else if (i.tag === j) {
          if (a === null)
            try {
              var c = i.stateNode;
              t ? $y(c) : tD(c, i.memoizedProps);
            } catch (A) {
              On(e, e.return, A);
            }
        } else if (!((i.tag === Se || i.tag === le) && i.memoizedState !== null && i !== e)) {
          if (i.child !== null) {
            i.child.return = i, i = i.child;
            continue;
          }
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          a === i && (a = null), i = i.return;
        }
        a === i && (a = null), i.sibling.return = i.return, i = i.sibling;
      }
    }
    function Qh(e) {
      var t = e.ref;
      if (t !== null) {
        var a = e.stateNode, i;
        switch (e.tag) {
          case Y:
            i = a;
            break;
          default:
            i = a;
        }
        if (typeof t == "function") {
          var s;
          if (e.mode & Wt)
            try {
              Nl(), s = t(i);
            } finally {
              Sl(e);
            }
          else
            s = t(i);
          typeof s == "function" && d("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", ct(e));
        } else
          t.hasOwnProperty("current") || d("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", ct(e)), t.current = i;
      }
    }
    function LP(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function Zh(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, Zh(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === Y) {
          var a = e.stateNode;
          a !== null && _D(a);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function yP(e) {
      for (var t = e.return; t !== null; ) {
        if (qh(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function qh(e) {
      return e.tag === Y || e.tag === g || e.tag === w;
    }
    function $h(e) {
      var t = e;
      e:
        for (; ; ) {
          for (; t.sibling === null; ) {
            if (t.return === null || qh(t.return))
              return null;
            t = t.return;
          }
          for (t.sibling.return = t.return, t = t.sibling; t.tag !== Y && t.tag !== j && t.tag !== Qe; ) {
            if (t.flags & dn || t.child === null || t.tag === w)
              continue e;
            t.child.return = t, t = t.child;
          }
          if (!(t.flags & dn))
            return t.stateNode;
        }
    }
    function DP(e) {
      var t = yP(e);
      switch (t.tag) {
        case Y: {
          var a = t.stateNode;
          t.flags & qt && (tC(a), t.flags &= ~qt);
          var i = $h(e);
          yO(e, i, a);
          break;
        }
        case g:
        case w: {
          var s = t.stateNode.containerInfo, c = $h(e);
          LO(e, c, s);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function LO(e, t, a) {
      var i = e.tag, s = i === Y || i === j;
      if (s) {
        var c = e.stateNode;
        t ? zy(a, c, t) : Ky(a, c);
      } else if (i !== w) {
        var A = e.child;
        if (A !== null) {
          LO(A, t, a);
          for (var S = A.sibling; S !== null; )
            LO(S, t, a), S = S.sibling;
        }
      }
    }
    function yO(e, t, a) {
      var i = e.tag, s = i === Y || i === j;
      if (s) {
        var c = e.stateNode;
        t ? jy(a, c, t) : ky(a, c);
      } else if (i !== w) {
        var A = e.child;
        if (A !== null) {
          yO(A, t, a);
          for (var S = A.sibling; S !== null; )
            yO(S, t, a), S = S.sibling;
        }
      }
    }
    var Xr = null, Co = !1;
    function gP(e, t, a) {
      {
        var i = t;
        e:
          for (; i !== null; ) {
            switch (i.tag) {
              case Y: {
                Xr = i.stateNode, Co = !1;
                break e;
              }
              case g: {
                Xr = i.stateNode.containerInfo, Co = !0;
                break e;
              }
              case w: {
                Xr = i.stateNode.containerInfo, Co = !0;
                break e;
              }
            }
            i = i.return;
          }
        if (Xr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        ev(e, t, a), Xr = null, Co = !1;
      }
      LP(a);
    }
    function nu(e, t, a) {
      for (var i = a.child; i !== null; )
        ev(e, t, i), i = i.sibling;
    }
    function ev(e, t, a) {
      switch (a.tag) {
        case Y:
          Wr || aT(a, t);
        case j: {
          {
            var i = Xr, s = Co;
            Xr = null, nu(e, t, a), Xr = i, Co = s, Xr !== null && (Co ? Qy(Xr, a.stateNode) : Jy(Xr, a.stateNode));
          }
          return;
        }
        case Qe: {
          Xr !== null && (Co ? Zy(Xr, a.stateNode) : BN(Xr, a.stateNode));
          return;
        }
        case w: {
          {
            var c = Xr, A = Co;
            Xr = a.stateNode.containerInfo, Co = !0, nu(e, t, a), Xr = c, Co = A;
          }
          return;
        }
        case D:
        case he:
        case je:
        case Xe: {
          if (!Wr) {
            var S = a.updateQueue;
            if (S !== null) {
              var p = S.lastEffect;
              if (p !== null) {
                var L = p.next, y = L;
                do {
                  var F = y, H = F.destroy, z = F.tag;
                  H !== void 0 && ((z & Al) !== Qc ? cS(a, t, H) : (z & Ua) !== Qc && (a.mode & Wt ? (Nl(), cS(a, t, H), Sl(a)) : cS(a, t, H))), y = y.next;
                } while (y !== L);
              }
            }
          }
          nu(e, t, a);
          return;
        }
        case v: {
          if (!Wr) {
            aT(a, t);
            var Q = a.stateNode;
            typeof Q.componentWillUnmount == "function" && mO(a, t, Q);
          }
          nu(e, t, a);
          return;
        }
        case Rn: {
          nu(e, t, a);
          return;
        }
        case Se: {
          if (
            // TODO: Remove this dead flag
            a.mode & St
          ) {
            var ne = Wr;
            Wr = ne || a.memoizedState !== null, nu(e, t, a), Wr = ne;
          } else
            nu(e, t, a);
          break;
        }
        default: {
          nu(e, t, a);
          return;
        }
      }
    }
    function PP(e) {
      e.memoizedState;
    }
    function MP(e, t) {
      var a = t.memoizedState;
      if (a === null) {
        var i = t.alternate;
        if (i !== null) {
          var s = i.memoizedState;
          if (s !== null) {
            var c = s.dehydrated;
            c !== null && dD(c);
          }
        }
      }
    }
    function tv(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var a = e.stateNode;
        a === null && (a = e.stateNode = new AP()), t.forEach(function(i) {
          var s = yM.bind(null, e, i);
          if (!a.has(i)) {
            if (a.add(i), Da)
              if (nT !== null && rT !== null)
                NA(rT, nT);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            i.then(s, s);
          }
        });
      }
    }
    function UP(e, t, a) {
      nT = a, rT = e, Zt(t), nv(t, e), Zt(t), nT = null, rT = null;
    }
    function ho(e, t, a) {
      var i = t.deletions;
      if (i !== null)
        for (var s = 0; s < i.length; s++) {
          var c = i[s];
          try {
            gP(e, t, c);
          } catch (p) {
            On(c, t, p);
          }
        }
      var A = xE();
      if (t.subtreeFlags & sa)
        for (var S = t.child; S !== null; )
          Zt(S), nv(S, e), S = S.sibling;
      Zt(A);
    }
    function nv(e, t, a) {
      var i = e.alternate, s = e.flags;
      switch (e.tag) {
        case D:
        case he:
        case je:
        case Xe: {
          if (ho(t, e), pl(e), s & Ct) {
            try {
              Io(Al | Ar, e, e.return), tu(Al | Ar, e);
            } catch (st) {
              On(e, e.return, st);
            }
            if (e.mode & Wt) {
              try {
                Nl(), Io(Ua | Ar, e, e.return);
              } catch (st) {
                On(e, e.return, st);
              }
              Sl(e);
            } else
              try {
                Io(Ua | Ar, e, e.return);
              } catch (st) {
                On(e, e.return, st);
              }
          }
          return;
        }
        case v: {
          ho(t, e), pl(e), s & ia && i !== null && aT(i, i.return);
          return;
        }
        case Y: {
          ho(t, e), pl(e), s & ia && i !== null && aT(i, i.return);
          {
            if (e.flags & qt) {
              var c = e.stateNode;
              try {
                tC(c);
              } catch (st) {
                On(e, e.return, st);
              }
            }
            if (s & Ct) {
              var A = e.stateNode;
              if (A != null) {
                var S = e.memoizedProps, p = i !== null ? i.memoizedProps : S, L = e.type, y = e.updateQueue;
                if (e.updateQueue = null, y !== null)
                  try {
                    Wy(A, y, L, p, S, e);
                  } catch (st) {
                    On(e, e.return, st);
                  }
              }
            }
          }
          return;
        }
        case j: {
          if (ho(t, e), pl(e), s & Ct) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var F = e.stateNode, H = e.memoizedProps, z = i !== null ? i.memoizedProps : H;
            try {
              Xy(F, z, H);
            } catch (st) {
              On(e, e.return, st);
            }
          }
          return;
        }
        case g: {
          if (ho(t, e), pl(e), s & Ct && i !== null) {
            var Q = i.memoizedState;
            if (Q.isDehydrated)
              try {
                RD(t.containerInfo);
              } catch (st) {
                On(e, e.return, st);
              }
          }
          return;
        }
        case w: {
          ho(t, e), pl(e);
          return;
        }
        case ye: {
          ho(t, e), pl(e);
          var ne = e.child;
          if (ne.flags & Ko) {
            var He = ne.stateNode, tt = ne.memoizedState, Je = tt !== null;
            if (He.isHidden = Je, Je) {
              var xt = ne.alternate !== null && ne.alternate.memoizedState !== null;
              xt || TM();
            }
          }
          if (s & Ct) {
            try {
              PP(e);
            } catch (st) {
              On(e, e.return, st);
            }
            tv(e);
          }
          return;
        }
        case Se: {
          var Pt = i !== null && i.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & St
          ) {
            var X = Wr;
            Wr = X || Pt, ho(t, e), Wr = X;
          } else
            ho(t, e);
          if (pl(e), s & Ko) {
            var re = e.stateNode, k = e.memoizedState, de = k !== null, Be = e;
            if (re.isHidden = de, de && !Pt && (Be.mode & St) !== ze) {
              Ve = Be;
              for (var _e = Be.child; _e !== null; )
                Ve = _e, GP(_e), _e = _e.sibling;
            }
            mP(Be, de);
          }
          return;
        }
        case gt: {
          ho(t, e), pl(e), s & Ct && tv(e);
          return;
        }
        case Rn:
          return;
        default: {
          ho(t, e), pl(e);
          return;
        }
      }
    }
    function pl(e) {
      var t = e.flags;
      if (t & dn) {
        try {
          DP(e);
        } catch (a) {
          On(e, e.return, a);
        }
        e.flags &= ~dn;
      }
      t & Xa && (e.flags &= ~Xa);
    }
    function _P(e, t, a) {
      nT = a, rT = t, Ve = e, rv(e, t, a), nT = null, rT = null;
    }
    function rv(e, t, a) {
      for (var i = (e.mode & St) !== ze; Ve !== null; ) {
        var s = Ve, c = s.child;
        if (s.tag === Se && i) {
          var A = s.memoizedState !== null, S = A || ES;
          if (S) {
            DO(e, t, a);
            continue;
          } else {
            var p = s.alternate, L = p !== null && p.memoizedState !== null, y = L || Wr, F = ES, H = Wr;
            ES = S, Wr = y, Wr && !H && (Ve = s, xP(s));
            for (var z = c; z !== null; )
              Ve = z, rv(
                z,
                // New root; bubble back up to here and stop.
                t,
                a
              ), z = z.sibling;
            Ve = s, ES = F, Wr = H, DO(e, t, a);
            continue;
          }
        }
        (s.subtreeFlags & vr) !== qe && c !== null ? (c.return = s, Ve = c) : DO(e, t, a);
      }
    }
    function DO(e, t, a) {
      for (; Ve !== null; ) {
        var i = Ve;
        if ((i.flags & vr) !== qe) {
          var s = i.alternate;
          Zt(i);
          try {
            hP(t, s, i, a);
          } catch (A) {
            On(i, i.return, A);
          }
          Pn();
        }
        if (i === e) {
          Ve = null;
          return;
        }
        var c = i.sibling;
        if (c !== null) {
          c.return = i.return, Ve = c;
          return;
        }
        Ve = i.return;
      }
    }
    function GP(e) {
      for (; Ve !== null; ) {
        var t = Ve, a = t.child;
        switch (t.tag) {
          case D:
          case he:
          case je:
          case Xe: {
            if (t.mode & Wt)
              try {
                Nl(), Io(Ua, t, t.return);
              } finally {
                Sl(t);
              }
            else
              Io(Ua, t, t.return);
            break;
          }
          case v: {
            aT(t, t.return);
            var i = t.stateNode;
            typeof i.componentWillUnmount == "function" && mO(t, t.return, i);
            break;
          }
          case Y: {
            aT(t, t.return);
            break;
          }
          case Se: {
            var s = t.memoizedState !== null;
            if (s) {
              av(e);
              continue;
            }
            break;
          }
        }
        a !== null ? (a.return = t, Ve = a) : av(e);
      }
    }
    function av(e) {
      for (; Ve !== null; ) {
        var t = Ve;
        if (t === e) {
          Ve = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, Ve = a;
          return;
        }
        Ve = t.return;
      }
    }
    function xP(e) {
      for (; Ve !== null; ) {
        var t = Ve, a = t.child;
        if (t.tag === Se) {
          var i = t.memoizedState !== null;
          if (i) {
            iv(e);
            continue;
          }
        }
        a !== null ? (a.return = t, Ve = a) : iv(e);
      }
    }
    function iv(e) {
      for (; Ve !== null; ) {
        var t = Ve;
        Zt(t);
        try {
          vP(t);
        } catch (i) {
          On(t, t.return, i);
        }
        if (Pn(), t === e) {
          Ve = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, Ve = a;
          return;
        }
        Ve = t.return;
      }
    }
    function bP(e, t, a, i) {
      Ve = t, HP(t, e, a, i);
    }
    function HP(e, t, a, i) {
      for (; Ve !== null; ) {
        var s = Ve, c = s.child;
        (s.subtreeFlags & ka) !== qe && c !== null ? (c.return = s, Ve = c) : BP(e, t, a, i);
      }
    }
    function BP(e, t, a, i) {
      for (; Ve !== null; ) {
        var s = Ve;
        if ((s.flags & In) !== qe) {
          Zt(s);
          try {
            FP(t, s, a, i);
          } catch (A) {
            On(s, s.return, A);
          }
          Pn();
        }
        if (s === e) {
          Ve = null;
          return;
        }
        var c = s.sibling;
        if (c !== null) {
          c.return = s.return, Ve = c;
          return;
        }
        Ve = s.return;
      }
    }
    function FP(e, t, a, i) {
      switch (t.tag) {
        case D:
        case he:
        case Xe: {
          if (t.mode & Wt) {
            iO();
            try {
              tu(Ni | Ar, t);
            } finally {
              aO(t);
            }
          } else
            tu(Ni | Ar, t);
          break;
        }
      }
    }
    function wP(e) {
      Ve = e, YP();
    }
    function YP() {
      for (; Ve !== null; ) {
        var e = Ve, t = e.child;
        if ((Ve.flags & jt) !== qe) {
          var a = e.deletions;
          if (a !== null) {
            for (var i = 0; i < a.length; i++) {
              var s = a[i];
              Ve = s, XP(s, e);
            }
            {
              var c = e.alternate;
              if (c !== null) {
                var A = c.child;
                if (A !== null) {
                  c.child = null;
                  do {
                    var S = A.sibling;
                    A.sibling = null, A = S;
                  } while (A !== null);
                }
              }
            }
            Ve = e;
          }
        }
        (e.subtreeFlags & ka) !== qe && t !== null ? (t.return = e, Ve = t) : VP();
      }
    }
    function VP() {
      for (; Ve !== null; ) {
        var e = Ve;
        (e.flags & In) !== qe && (Zt(e), WP(e), Pn());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, Ve = t;
          return;
        }
        Ve = e.return;
      }
    }
    function WP(e) {
      switch (e.tag) {
        case D:
        case he:
        case Xe: {
          e.mode & Wt ? (iO(), Io(Ni | Ar, e, e.return), aO(e)) : Io(Ni | Ar, e, e.return);
          break;
        }
      }
    }
    function XP(e, t) {
      for (; Ve !== null; ) {
        var a = Ve;
        Zt(a), KP(a, t), Pn();
        var i = a.child;
        i !== null ? (i.return = a, Ve = i) : kP(e);
      }
    }
    function kP(e) {
      for (; Ve !== null; ) {
        var t = Ve, a = t.sibling, i = t.return;
        if (Zh(t), t === e) {
          Ve = null;
          return;
        }
        if (a !== null) {
          a.return = i, Ve = a;
          return;
        }
        Ve = i;
      }
    }
    function KP(e, t) {
      switch (e.tag) {
        case D:
        case he:
        case Xe: {
          e.mode & Wt ? (iO(), Io(Ni, e, t), aO(e)) : Io(Ni, e, t);
          break;
        }
      }
    }
    function jP(e) {
      switch (e.tag) {
        case D:
        case he:
        case Xe: {
          try {
            tu(Ua | Ar, e);
          } catch (a) {
            On(e, e.return, a);
          }
          break;
        }
        case v: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (a) {
            On(e, e.return, a);
          }
          break;
        }
      }
    }
    function zP(e) {
      switch (e.tag) {
        case D:
        case he:
        case Xe: {
          try {
            tu(Ni | Ar, e);
          } catch (t) {
            On(e, e.return, t);
          }
          break;
        }
      }
    }
    function JP(e) {
      switch (e.tag) {
        case D:
        case he:
        case Xe: {
          try {
            Io(Ua | Ar, e, e.return);
          } catch (a) {
            On(e, e.return, a);
          }
          break;
        }
        case v: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && mO(e, e.return, t);
          break;
        }
      }
    }
    function QP(e) {
      switch (e.tag) {
        case D:
        case he:
        case Xe:
          try {
            Io(Ni | Ar, e, e.return);
          } catch (t) {
            On(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var lA = Symbol.for;
      lA("selector.component"), lA("selector.has_pseudo_class"), lA("selector.role"), lA("selector.test_id"), lA("selector.text");
    }
    var ZP = [];
    function qP() {
      ZP.forEach(function(e) {
        return e();
      });
    }
    var $P = T.ReactCurrentActQueue;
    function eM(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), a = typeof jest < "u";
        return a && t !== !1;
      }
    }
    function ov() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && $P.current !== null && d("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var tM = Math.ceil, gO = T.ReactCurrentDispatcher, PO = T.ReactCurrentOwner, kr = T.ReactCurrentBatchConfig, vo = T.ReactCurrentActQueue, Sr = (
      /*             */
      0
    ), lv = (
      /*               */
      1
    ), Kr = (
      /*                */
      2
    ), wi = (
      /*                */
      4
    ), ts = 0, sA = 1, IE = 2, TS = 3, uA = 4, sv = 5, MO = 6, Gt = Sr, Ga = null, wn = null, Nr = se, Ol = se, UO = Ks(se), pr = ts, EA = null, fS = se, cA = se, AS = se, TA = null, qa = null, _O = 0, uv = 500, Ev = 1 / 0, nM = 500, ns = null;
    function fA() {
      Ev = yn() + nM;
    }
    function cv() {
      return Ev;
    }
    var RS = !1, GO = null, iT = null, CE = !1, ru = null, AA = se, xO = [], bO = null, rM = 50, RA = 0, HO = null, BO = !1, dS = !1, aM = 50, oT = 0, SS = null, dA = an, NS = se, Tv = !1;
    function pS() {
      return Ga;
    }
    function xa() {
      return (Gt & (Kr | wi)) !== Sr ? yn() : (dA !== an || (dA = yn()), dA);
    }
    function au(e) {
      var t = e.mode;
      if ((t & St) === ze)
        return ot;
      if ((Gt & Kr) !== Sr && Nr !== se)
        return Yl(Nr);
      var a = eg() !== $D;
      if (a) {
        if (kr.transition !== null) {
          var i = kr.transition;
          i._updatedFibers || (i._updatedFibers = /* @__PURE__ */ new Set()), i._updatedFibers.add(e);
        }
        return NS === Xn && (NS = Fu()), NS;
      }
      var s = Ja();
      if (s !== Xn)
        return s;
      var c = By();
      return c;
    }
    function iM(e) {
      var t = e.mode;
      return (t & St) === ze ? ot : sc();
    }
    function Or(e, t, a, i) {
      gM(), Tv && d("useInsertionEffect must not schedule updates."), BO && (dS = !0), Yu(e, a, i), (Gt & Kr) !== se && e === Ga ? UM(t) : (Da && yR(e, t, a), _M(t), e === Ga && ((Gt & Kr) === Sr && (cA = Nt(cA, a)), pr === uA && iu(e, Nr)), $a(e, i), a === ot && Gt === Sr && (t.mode & St) === ze && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !vo.isBatchingLegacy && (fA(), TC()));
    }
    function oM(e, t, a) {
      var i = e.current;
      i.lanes = t, Yu(e, t, a), $a(e, a);
    }
    function lM(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Gt & Kr) !== Sr
      );
    }
    function $a(e, t) {
      var a = e.callbackNode;
      QT(e, t);
      var i = br(e, e === Ga ? Nr : se);
      if (i === se) {
        a !== null && Dv(a), e.callbackNode = null, e.callbackPriority = Xn;
        return;
      }
      var s = el(i), c = e.callbackPriority;
      if (c === s && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(vo.current !== null && a !== kO)) {
        a == null && c !== ot && d("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      a != null && Dv(a);
      var A;
      if (s === ot)
        e.tag === js ? (vo.isBatchingLegacy !== null && (vo.didScheduleLegacyUpdate = !0), bD(Rv.bind(null, e))) : cC(Rv.bind(null, e)), vo.current !== null ? vo.current.push(zs) : wy(function() {
          (Gt & (Kr | wi)) === Sr && zs();
        }), A = null;
      else {
        var S;
        switch (Lr(i)) {
          case Tr:
            S = XT;
            break;
          case Ui:
            S = ja;
            break;
          case _i:
            S = zo;
            break;
          case tf:
            S = xl;
            break;
          default:
            S = zo;
            break;
        }
        A = KO(S, fv.bind(null, e));
      }
      e.callbackPriority = s, e.callbackNode = A;
    }
    function fv(e, t) {
      if (gg(), dA = an, NS = se, (Gt & (Kr | wi)) !== Sr)
        throw new Error("Should not already be working.");
      var a = e.callbackNode, i = as();
      if (i && e.callbackNode !== a)
        return null;
      var s = br(e, e === Ga ? Nr : se);
      if (s === se)
        return null;
      var c = !Hu(e, s) && !Bu(e, s) && !t, A = c ? SM(e, s) : IS(e, s);
      if (A !== ts) {
        if (A === IE) {
          var S = oc(e);
          S !== se && (s = S, A = FO(e, S));
        }
        if (A === sA) {
          var p = EA;
          throw hE(e, se), iu(e, s), $a(e, yn()), p;
        }
        if (A === MO)
          iu(e, s);
        else {
          var L = !Hu(e, s), y = e.current.alternate;
          if (L && !uM(y)) {
            if (A = IS(e, s), A === IE) {
              var F = oc(e);
              F !== se && (s = F, A = FO(e, F));
            }
            if (A === sA) {
              var H = EA;
              throw hE(e, se), iu(e, s), $a(e, yn()), H;
            }
          }
          e.finishedWork = y, e.finishedLanes = s, sM(e, A, s);
        }
      }
      return $a(e, yn()), e.callbackNode === a ? fv.bind(null, e) : null;
    }
    function FO(e, t) {
      var a = TA;
      if (Vu(e)) {
        var i = hE(e, t);
        i.flags |= Mn, gD(e.containerInfo);
      }
      var s = IS(e, t);
      if (s !== IE) {
        var c = qa;
        qa = a, c !== null && Av(c);
      }
      return s;
    }
    function Av(e) {
      qa === null ? qa = e : qa.push.apply(qa, e);
    }
    function sM(e, t, a) {
      switch (t) {
        case ts:
        case sA:
          throw new Error("Root did not complete. This is a bug in React.");
        case IE: {
          vE(e, qa, ns);
          break;
        }
        case TS: {
          if (iu(e, a), ZT(a) && // do not delay if we're inside an act() scope
          !gv()) {
            var i = _O + uv - yn();
            if (i > 10) {
              var s = br(e, se);
              if (s !== se)
                break;
              var c = e.suspendedLanes;
              if (!Vl(c, a)) {
                xa(), ef(e, c);
                break;
              }
              e.timeoutHandle = bN(vE.bind(null, e, qa, ns), i);
              break;
            }
          }
          vE(e, qa, ns);
          break;
        }
        case uA: {
          if (iu(e, a), mR(a))
            break;
          if (!gv()) {
            var A = bu(e, a), S = A, p = yn() - S, L = DM(p) - p;
            if (L > 10) {
              e.timeoutHandle = bN(vE.bind(null, e, qa, ns), L);
              break;
            }
          }
          vE(e, qa, ns);
          break;
        }
        case sv: {
          vE(e, qa, ns);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function uM(e) {
      for (var t = e; ; ) {
        if (t.flags & Du) {
          var a = t.updateQueue;
          if (a !== null) {
            var i = a.stores;
            if (i !== null)
              for (var s = 0; s < i.length; s++) {
                var c = i[s], A = c.getSnapshot, S = c.value;
                try {
                  if (!Fr(A(), S))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var p = t.child;
        if (t.subtreeFlags & Du && p !== null) {
          p.return = t, t = p;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function iu(e, t) {
      t = wu(t, AS), t = wu(t, cA), uN(e, t);
    }
    function Rv(e) {
      if (Pg(), (Gt & (Kr | wi)) !== Sr)
        throw new Error("Should not already be working.");
      as();
      var t = br(e, se);
      if (!ca(t, ot))
        return $a(e, yn()), null;
      var a = IS(e, t);
      if (e.tag !== js && a === IE) {
        var i = oc(e);
        i !== se && (t = i, a = FO(e, i));
      }
      if (a === sA) {
        var s = EA;
        throw hE(e, se), iu(e, t), $a(e, yn()), s;
      }
      if (a === MO)
        throw new Error("Root did not complete. This is a bug in React.");
      var c = e.current.alternate;
      return e.finishedWork = c, e.finishedLanes = t, vE(e, qa, ns), $a(e, yn()), null;
    }
    function EM(e, t) {
      t !== se && (cc(e, Nt(t, ot)), $a(e, yn()), (Gt & (Kr | wi)) === Sr && (fA(), zs()));
    }
    function wO(e, t) {
      var a = Gt;
      Gt |= lv;
      try {
        return e(t);
      } finally {
        Gt = a, Gt === Sr && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !vo.isBatchingLegacy && (fA(), TC());
      }
    }
    function cM(e, t, a, i, s) {
      var c = Ja(), A = kr.transition;
      try {
        return kr.transition = null, $n(Tr), e(t, a, i, s);
      } finally {
        $n(c), kr.transition = A, Gt === Sr && fA();
      }
    }
    function rs(e) {
      ru !== null && ru.tag === js && (Gt & (Kr | wi)) === Sr && as();
      var t = Gt;
      Gt |= lv;
      var a = kr.transition, i = Ja();
      try {
        return kr.transition = null, $n(Tr), e ? e() : void 0;
      } finally {
        $n(i), kr.transition = a, Gt = t, (Gt & (Kr | wi)) === Sr && zs();
      }
    }
    function dv() {
      return (Gt & (Kr | wi)) !== Sr;
    }
    function OS(e, t) {
      Ra(UO, Ol, e), Ol = Nt(Ol, t);
    }
    function YO(e) {
      Ol = UO.current, Aa(UO, e);
    }
    function hE(e, t) {
      e.finishedWork = null, e.finishedLanes = se;
      var a = e.timeoutHandle;
      if (a !== HN && (e.timeoutHandle = HN, Fy(a)), wn !== null)
        for (var i = wn.return; i !== null; ) {
          var s = i.alternate;
          kh(s, i), i = i.return;
        }
      Ga = e;
      var c = mE(e.current, null);
      return wn = c, Nr = Ol = t, pr = ts, EA = null, fS = se, cA = se, AS = se, TA = null, qa = null, ag(), Ro.discardPendingWarnings(), c;
    }
    function Sv(e, t) {
      do {
        var a = wn;
        try {
          if (Dd(), zC(), Pn(), PO.current = null, a === null || a.return === null) {
            pr = sA, EA = t, wn = null;
            return;
          }
          if (ut && a.mode & Wt && oS(a, !0), vt)
            if (t !== null && typeof t == "object" && typeof t.then == "function") {
              var i = t;
            }
          xg(e, a.return, a, t, Nr), Iv(a);
        } catch (s) {
          t = s, wn === a && a !== null ? (a = a.return, wn = a) : a = wn;
          continue;
        }
        return;
      } while (!0);
    }
    function Nv() {
      var e = gO.current;
      return gO.current = tS, e === null ? tS : e;
    }
    function pv(e) {
      gO.current = e;
    }
    function TM() {
      _O = yn();
    }
    function SA(e) {
      fS = Nt(e, fS);
    }
    function fM() {
      pr === ts && (pr = TS);
    }
    function VO() {
      (pr === ts || pr === TS || pr === IE) && (pr = uA), Ga !== null && (lc(fS) || lc(cA)) && iu(Ga, Nr);
    }
    function AM(e) {
      pr !== uA && (pr = IE), TA === null ? TA = [e] : TA.push(e);
    }
    function RM() {
      return pr === ts;
    }
    function IS(e, t) {
      var a = Gt;
      Gt |= Kr;
      var i = Nv();
      if (Ga !== e || Nr !== t) {
        if (Da) {
          var s = e.memoizedUpdaters;
          s.size > 0 && (NA(e, Nr), s.clear()), DR(e, t);
        }
        ns = gR(), hE(e, t);
      }
      do
        try {
          dM();
          break;
        } catch (c) {
          Sv(e, c);
        }
      while (!0);
      if (Dd(), Gt = a, pv(i), wn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Ga = null, Nr = se, pr;
    }
    function dM() {
      for (; wn !== null; )
        Ov(wn);
    }
    function SM(e, t) {
      var a = Gt;
      Gt |= Kr;
      var i = Nv();
      if (Ga !== e || Nr !== t) {
        if (Da) {
          var s = e.memoizedUpdaters;
          s.size > 0 && (NA(e, Nr), s.clear()), DR(e, t);
        }
        ns = gR(), fA(), hE(e, t);
      }
      do
        try {
          NM();
          break;
        } catch (c) {
          Sv(e, c);
        }
      while (!0);
      return Dd(), pv(i), Gt = a, wn !== null ? ts : (Ga = null, Nr = se, pr);
    }
    function NM() {
      for (; wn !== null && !$E(); )
        Ov(wn);
    }
    function Ov(e) {
      var t = e.alternate;
      Zt(e);
      var a;
      (e.mode & Wt) !== ze ? (rO(e), a = WO(t, e, Ol), oS(e, !0)) : a = WO(t, e, Ol), Pn(), e.memoizedProps = e.pendingProps, a === null ? Iv(e) : wn = a, PO.current = null;
    }
    function Iv(e) {
      var t = e;
      do {
        var a = t.alternate, i = t.return;
        if ((t.flags & ma) === qe) {
          Zt(t);
          var s = void 0;
          if ((t.mode & Wt) === ze ? s = Xh(a, t, Ol) : (rO(t), s = Xh(a, t, Ol), oS(t, !1)), Pn(), s !== null) {
            wn = s;
            return;
          }
        } else {
          var c = fP(a, t);
          if (c !== null) {
            c.flags &= RR, wn = c;
            return;
          }
          if ((t.mode & Wt) !== ze) {
            oS(t, !1);
            for (var A = t.actualDuration, S = t.child; S !== null; )
              A += S.actualDuration, S = S.sibling;
            t.actualDuration = A;
          }
          if (i !== null)
            i.flags |= ma, i.subtreeFlags = qe, i.deletions = null;
          else {
            pr = MO, wn = null;
            return;
          }
        }
        var p = t.sibling;
        if (p !== null) {
          wn = p;
          return;
        }
        t = i, wn = t;
      } while (t !== null);
      pr === ts && (pr = sv);
    }
    function vE(e, t, a) {
      var i = Ja(), s = kr.transition;
      try {
        kr.transition = null, $n(Tr), pM(e, t, a, i);
      } finally {
        kr.transition = s, $n(i);
      }
      return null;
    }
    function pM(e, t, a, i) {
      do
        as();
      while (ru !== null);
      if (PM(), (Gt & (Kr | wi)) !== Sr)
        throw new Error("Should not already be working.");
      var s = e.finishedWork, c = e.finishedLanes;
      if (s === null)
        return null;
      if (c === se && d("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = se, s === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Xn;
      var A = Nt(s.lanes, s.childLanes);
      LR(e, A), e === Ga && (Ga = null, wn = null, Nr = se), ((s.subtreeFlags & ka) !== qe || (s.flags & ka) !== qe) && (CE || (CE = !0, bO = a, KO(zo, function() {
        return as(), null;
      })));
      var S = (s.subtreeFlags & (ys | sa | vr | ka)) !== qe, p = (s.flags & (ys | sa | vr | ka)) !== qe;
      if (S || p) {
        var L = kr.transition;
        kr.transition = null;
        var y = Ja();
        $n(Tr);
        var F = Gt;
        Gt |= wi, PO.current = null, NP(e, s), Nh(), UP(e, s, c), Uy(e.containerInfo), e.current = s, _P(s, e, c), NR(), Gt = F, $n(y), kr.transition = L;
      } else
        e.current = s, Nh();
      var H = CE;
      if (CE ? (CE = !1, ru = e, AA = c) : (oT = 0, SS = null), A = e.pendingLanes, A === se && (iT = null), H || mv(e.current, !1), s.stateNode, Da && e.memoizedUpdaters.clear(), qP(), $a(e, yn()), t !== null)
        for (var z = e.onRecoverableError, Q = 0; Q < t.length; Q++) {
          var ne = t[Q], He = ne.stack, tt = ne.digest;
          z(ne.value, {
            componentStack: He,
            digest: tt
          });
        }
      if (RS) {
        RS = !1;
        var Je = GO;
        throw GO = null, Je;
      }
      return ca(AA, ot) && e.tag !== js && as(), A = e.pendingLanes, ca(A, ot) ? (Dg(), e === HO ? RA++ : (RA = 0, HO = e)) : RA = 0, zs(), null;
    }
    function as() {
      if (ru !== null) {
        var e = Lr(AA), t = EN(_i, e), a = kr.transition, i = Ja();
        try {
          return kr.transition = null, $n(t), IM();
        } finally {
          $n(i), kr.transition = a;
        }
      }
      return !1;
    }
    function OM(e) {
      xO.push(e), CE || (CE = !0, KO(zo, function() {
        return as(), null;
      }));
    }
    function IM() {
      if (ru === null)
        return !1;
      var e = bO;
      bO = null;
      var t = ru, a = AA;
      if (ru = null, AA = se, (Gt & (Kr | wi)) !== Sr)
        throw new Error("Cannot flush passive effects while already rendering.");
      BO = !0, dS = !1;
      var i = Gt;
      Gt |= wi, wP(t.current), bP(t, t.current, a, e);
      {
        var s = xO;
        xO = [];
        for (var c = 0; c < s.length; c++) {
          var A = s[c];
          CP(t, A);
        }
      }
      mv(t.current, !0), Gt = i, zs(), dS ? t === SS ? oT++ : (oT = 0, SS = t) : oT = 0, BO = !1, dS = !1;
      {
        var S = t.current.stateNode;
        S.effectDuration = 0, S.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Cv(e) {
      return iT !== null && iT.has(e);
    }
    function CM(e) {
      iT === null ? iT = /* @__PURE__ */ new Set([e]) : iT.add(e);
    }
    function hM(e) {
      RS || (RS = !0, GO = e);
    }
    var vM = hM;
    function hv(e, t, a) {
      var i = pE(a, t), s = Oh(e, i, ot), c = Qs(e, s, ot), A = xa();
      c !== null && (Yu(c, ot, A), $a(c, A));
    }
    function On(e, t, a) {
      if (RP(a), pA(!1), e.tag === g) {
        hv(e, e, a);
        return;
      }
      var i = null;
      for (i = t; i !== null; ) {
        if (i.tag === g) {
          hv(i, e, a);
          return;
        } else if (i.tag === v) {
          var s = i.type, c = i.stateNode;
          if (typeof s.getDerivedStateFromError == "function" || typeof c.componentDidCatch == "function" && !Cv(c)) {
            var A = pE(a, e), S = uO(i, A, ot), p = Qs(i, S, ot), L = xa();
            p !== null && (Yu(p, ot, L), $a(p, L));
            return;
          }
        }
        i = i.return;
      }
      d(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, a);
    }
    function mM(e, t, a) {
      var i = e.pingCache;
      i !== null && i.delete(t);
      var s = xa();
      ef(e, a), GM(e), Ga === e && Vl(Nr, a) && (pr === uA || pr === TS && ZT(Nr) && yn() - _O < uv ? hE(e, se) : AS = Nt(AS, a)), $a(e, s);
    }
    function vv(e, t) {
      t === Xn && (t = iM(e));
      var a = xa(), i = Za(e, t);
      i !== null && (Yu(i, t, a), $a(i, a));
    }
    function LM(e) {
      var t = e.memoizedState, a = Xn;
      t !== null && (a = t.retryLane), vv(e, a);
    }
    function yM(e, t) {
      var a = Xn, i;
      switch (e.tag) {
        case ye:
          i = e.stateNode;
          var s = e.memoizedState;
          s !== null && (a = s.retryLane);
          break;
        case gt:
          i = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      i !== null && i.delete(t), vv(e, a);
    }
    function DM(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : tM(e / 1960) * 1960;
    }
    function gM() {
      if (RA > rM)
        throw RA = 0, HO = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      oT > aM && (oT = 0, SS = null, d("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function PM() {
      Ro.flushLegacyContextWarning(), Ro.flushPendingUnsafeLifecycleWarnings();
    }
    function mv(e, t) {
      Zt(e), CS(e, la, JP), t && CS(e, Gl, QP), CS(e, la, jP), t && CS(e, Gl, zP), Pn();
    }
    function CS(e, t, a) {
      for (var i = e, s = null; i !== null; ) {
        var c = i.subtreeFlags & t;
        i !== s && i.child !== null && c !== qe ? i = i.child : ((i.flags & t) !== qe && a(i), i.sibling !== null ? i = i.sibling : i = s = i.return);
      }
    }
    var hS = null;
    function Lv(e) {
      {
        if ((Gt & Kr) !== Sr || !(e.mode & St))
          return;
        var t = e.tag;
        if (t !== M && t !== g && t !== v && t !== D && t !== he && t !== je && t !== Xe)
          return;
        var a = ct(e) || "ReactComponent";
        if (hS !== null) {
          if (hS.has(a))
            return;
          hS.add(a);
        } else
          hS = /* @__PURE__ */ new Set([a]);
        var i = Ln;
        try {
          Zt(e), d("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          i ? Zt(e) : Pn();
        }
      }
    }
    var WO;
    {
      var MM = null;
      WO = function(e, t, a) {
        var i = Gv(MM, t);
        try {
          return Fh(e, t, a);
        } catch (c) {
          if (XD() || c !== null && typeof c == "object" && typeof c.then == "function")
            throw c;
          if (Dd(), zC(), kh(e, t), Gv(t, i), t.mode & Wt && rO(t), _l(null, Fh, null, e, t, a), iN()) {
            var s = HT();
            typeof s == "object" && s !== null && s._suppressLogging && typeof c == "object" && c !== null && !c._suppressLogging && (c._suppressLogging = !0);
          }
          throw c;
        }
      };
    }
    var yv = !1, XO;
    XO = /* @__PURE__ */ new Set();
    function UM(e) {
      if (na && !mg())
        switch (e.tag) {
          case D:
          case he:
          case Xe: {
            var t = wn && ct(wn) || "Unknown", a = t;
            if (!XO.has(a)) {
              XO.add(a);
              var i = ct(e) || "Unknown";
              d("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", i, t, t);
            }
            break;
          }
          case v: {
            yv || (d("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), yv = !0);
            break;
          }
        }
    }
    function NA(e, t) {
      if (Da) {
        var a = e.memoizedUpdaters;
        a.forEach(function(i) {
          yR(e, i, t);
        });
      }
    }
    var kO = {};
    function KO(e, t) {
      {
        var a = vo.current;
        return a !== null ? (a.push(t), kO) : qE(e, t);
      }
    }
    function Dv(e) {
      if (e !== kO)
        return SR(e);
    }
    function gv() {
      return vo.current !== null;
    }
    function _M(e) {
      {
        if (e.mode & St) {
          if (!ov())
            return;
        } else if (!eM() || Gt !== Sr || e.tag !== D && e.tag !== he && e.tag !== Xe)
          return;
        if (vo.current === null) {
          var t = Ln;
          try {
            Zt(e), d(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, ct(e));
          } finally {
            t ? Zt(e) : Pn();
          }
        }
      }
    }
    function GM(e) {
      e.tag !== js && ov() && vo.current === null && d(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function pA(e) {
      Tv = e;
    }
    var Yi = null, lT = null, xM = function(e) {
      Yi = e;
    };
    function sT(e) {
      {
        if (Yi === null)
          return e;
        var t = Yi(e);
        return t === void 0 ? e : t.current;
      }
    }
    function jO(e) {
      return sT(e);
    }
    function zO(e) {
      {
        if (Yi === null)
          return e;
        var t = Yi(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var a = sT(e.render);
            if (e.render !== a) {
              var i = {
                $$typeof: be,
                render: a
              };
              return e.displayName !== void 0 && (i.displayName = e.displayName), i;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function Pv(e, t) {
      {
        if (Yi === null)
          return !1;
        var a = e.elementType, i = t.type, s = !1, c = typeof i == "object" && i !== null ? i.$$typeof : null;
        switch (e.tag) {
          case v: {
            typeof i == "function" && (s = !0);
            break;
          }
          case D: {
            (typeof i == "function" || c === et) && (s = !0);
            break;
          }
          case he: {
            (c === be || c === et) && (s = !0);
            break;
          }
          case je:
          case Xe: {
            (c === It || c === et) && (s = !0);
            break;
          }
          default:
            return !1;
        }
        if (s) {
          var A = Yi(a);
          if (A !== void 0 && A === Yi(i))
            return !0;
        }
        return !1;
      }
    }
    function Mv(e) {
      {
        if (Yi === null || typeof WeakSet != "function")
          return;
        lT === null && (lT = /* @__PURE__ */ new WeakSet()), lT.add(e);
      }
    }
    var bM = function(e, t) {
      {
        if (Yi === null)
          return;
        var a = t.staleFamilies, i = t.updatedFamilies;
        as(), rs(function() {
          JO(e.current, i, a);
        });
      }
    }, HM = function(e, t) {
      {
        if (e.context !== Si)
          return;
        as(), rs(function() {
          OA(t, e, null, null);
        });
      }
    };
    function JO(e, t, a) {
      {
        var i = e.alternate, s = e.child, c = e.sibling, A = e.tag, S = e.type, p = null;
        switch (A) {
          case D:
          case Xe:
          case v:
            p = S;
            break;
          case he:
            p = S.render;
            break;
        }
        if (Yi === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var L = !1, y = !1;
        if (p !== null) {
          var F = Yi(p);
          F !== void 0 && (a.has(F) ? y = !0 : t.has(F) && (A === v ? y = !0 : L = !0));
        }
        if (lT !== null && (lT.has(e) || i !== null && lT.has(i)) && (y = !0), y && (e._debugNeedsRemount = !0), y || L) {
          var H = Za(e, ot);
          H !== null && Or(H, e, ot, an);
        }
        s !== null && !y && JO(s, t, a), c !== null && JO(c, t, a);
      }
    }
    var BM = function(e, t) {
      {
        var a = /* @__PURE__ */ new Set(), i = new Set(t.map(function(s) {
          return s.current;
        }));
        return QO(e.current, i, a), a;
      }
    };
    function QO(e, t, a) {
      {
        var i = e.child, s = e.sibling, c = e.tag, A = e.type, S = null;
        switch (c) {
          case D:
          case Xe:
          case v:
            S = A;
            break;
          case he:
            S = A.render;
            break;
        }
        var p = !1;
        S !== null && t.has(S) && (p = !0), p ? FM(e, a) : i !== null && QO(i, t, a), s !== null && QO(s, t, a);
      }
    }
    function FM(e, t) {
      {
        var a = wM(e, t);
        if (a)
          return;
        for (var i = e; ; ) {
          switch (i.tag) {
            case Y:
              t.add(i.stateNode);
              return;
            case w:
              t.add(i.stateNode.containerInfo);
              return;
            case g:
              t.add(i.stateNode.containerInfo);
              return;
          }
          if (i.return === null)
            throw new Error("Expected to reach root first.");
          i = i.return;
        }
      }
    }
    function wM(e, t) {
      for (var a = e, i = !1; ; ) {
        if (a.tag === Y)
          i = !0, t.add(a.stateNode);
        else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === e)
          return i;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e)
            return i;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !1;
    }
    var ZO;
    {
      ZO = !1;
      try {
        var Uv = Object.preventExtensions({});
      } catch {
        ZO = !0;
      }
    }
    function YM(e, t, a, i) {
      this.tag = e, this.key = a, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = i, this.flags = qe, this.subtreeFlags = qe, this.deletions = null, this.lanes = se, this.childLanes = se, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !ZO && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var pi = function(e, t, a, i) {
      return new YM(e, t, a, i);
    };
    function qO(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function VM(e) {
      return typeof e == "function" && !qO(e) && e.defaultProps === void 0;
    }
    function WM(e) {
      if (typeof e == "function")
        return qO(e) ? v : D;
      if (e != null) {
        var t = e.$$typeof;
        if (t === be)
          return he;
        if (t === It)
          return je;
      }
      return M;
    }
    function mE(e, t) {
      var a = e.alternate;
      a === null ? (a = pi(e.tag, t, e.key, e.mode), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugSource = e._debugSource, a._debugOwner = e._debugOwner, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = qe, a.subtreeFlags = qe, a.deletions = null, a.actualDuration = 0, a.actualStartTime = -1), a.flags = e.flags & cr, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue;
      var i = e.dependencies;
      switch (a.dependencies = i === null ? null : {
        lanes: i.lanes,
        firstContext: i.firstContext
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case M:
        case D:
        case Xe:
          a.type = sT(e.type);
          break;
        case v:
          a.type = jO(e.type);
          break;
        case he:
          a.type = zO(e.type);
          break;
      }
      return a;
    }
    function XM(e, t) {
      e.flags &= cr | dn;
      var a = e.alternate;
      if (a === null)
        e.childLanes = se, e.lanes = t, e.child = null, e.subtreeFlags = qe, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = qe, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type;
        var i = a.dependencies;
        e.dependencies = i === null ? null : {
          lanes: i.lanes,
          firstContext: i.firstContext
        }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration;
      }
      return e;
    }
    function kM(e, t, a) {
      var i;
      return e === Od ? (i = St, t === !0 && (i |= bn, i |= lr)) : i = ze, Da && (i |= Wt), pi(g, null, null, i);
    }
    function $O(e, t, a, i, s, c) {
      var A = M, S = e;
      if (typeof e == "function")
        qO(e) ? (A = v, S = jO(S)) : S = sT(S);
      else if (typeof e == "string")
        A = Y;
      else
        e:
          switch (e) {
            case va:
              return ou(a.children, s, c, t);
            case mi:
              A = me, s |= bn, (s & St) !== ze && (s |= lr);
              break;
            case x:
              return KM(a, s, c, t);
            case dt:
              return jM(a, s, c, t);
            case _t:
              return zM(a, s, c, t);
            case fn:
              return _v(a, s, c, t);
            case Er:
            case Vn:
            case Li:
            case ss:
            case Tn:
            default: {
              if (typeof e == "object" && e !== null)
                switch (e.$$typeof) {
                  case Ee:
                    A = Oe;
                    break e;
                  case ge:
                    A = Le;
                    break e;
                  case be:
                    A = he, S = zO(S);
                    break e;
                  case It:
                    A = je;
                    break e;
                  case et:
                    A = yt, S = null;
                    break e;
                }
              var p = "";
              {
                (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (p += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var L = i ? ct(i) : null;
                L && (p += `

Check the render method of \`` + L + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + p));
            }
          }
      var y = pi(A, a, t, s);
      return y.elementType = e, y.type = S, y.lanes = c, y._debugOwner = i, y;
    }
    function eI(e, t, a) {
      var i = null;
      i = e._owner;
      var s = e.type, c = e.key, A = e.props, S = $O(s, c, A, i, t, a);
      return S._debugSource = e._source, S._debugOwner = e._owner, S;
    }
    function ou(e, t, a, i) {
      var s = pi(oe, e, i, t);
      return s.lanes = a, s;
    }
    function KM(e, t, a, i) {
      typeof e.id != "string" && d('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var s = pi(Fe, e, i, t | Wt);
      return s.elementType = x, s.lanes = a, s.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, s;
    }
    function jM(e, t, a, i) {
      var s = pi(ye, e, i, t);
      return s.elementType = dt, s.lanes = a, s;
    }
    function zM(e, t, a, i) {
      var s = pi(gt, e, i, t);
      return s.elementType = _t, s.lanes = a, s;
    }
    function _v(e, t, a, i) {
      var s = pi(Se, e, i, t);
      s.elementType = fn, s.lanes = a;
      var c = {
        isHidden: !1
      };
      return s.stateNode = c, s;
    }
    function tI(e, t, a) {
      var i = pi(j, e, null, t);
      return i.lanes = a, i;
    }
    function JM() {
      var e = pi(Y, null, null, ze);
      return e.elementType = "DELETED", e;
    }
    function QM(e) {
      var t = pi(Qe, null, null, ze);
      return t.stateNode = e, t;
    }
    function nI(e, t, a) {
      var i = e.children !== null ? e.children : [], s = pi(w, i, e.key, t);
      return s.lanes = a, s.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, s;
    }
    function Gv(e, t) {
      return e === null && (e = pi(M, null, null, ze)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function ZM(e, t, a, i, s) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = HN, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Xn, this.eventTimes = Ec(se), this.expirationTimes = Ec(an), this.pendingLanes = se, this.suspendedLanes = se, this.pingedLanes = se, this.expiredLanes = se, this.mutableReadLanes = se, this.finishedLanes = se, this.entangledLanes = se, this.entanglements = Ec(se), this.identifierPrefix = i, this.onRecoverableError = s, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var c = this.pendingUpdatersLaneMap = [], A = 0; A < zT; A++)
          c.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case Od:
          this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
          break;
        case js:
          this._debugRootType = a ? "hydrate()" : "render()";
          break;
      }
    }
    function xv(e, t, a, i, s, c, A, S, p, L) {
      var y = new ZM(e, t, a, S, p), F = kM(t, c);
      y.current = F, F.stateNode = y;
      {
        var H = {
          element: i,
          isDehydrated: a,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        F.memoizedState = H;
      }
      return Ep(F), y;
    }
    var rI = "18.2.0";
    function qM(e, t, a) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return qr(i), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Ur,
        key: i == null ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: a
      };
    }
    var aI, iI;
    aI = !1, iI = {};
    function bv(e) {
      if (!e)
        return Si;
      var t = Va(e), a = xD(t);
      if (t.tag === v) {
        var i = t.type;
        if (fl(i))
          return uC(t, i, a);
      }
      return a;
    }
    function $M(e, t) {
      {
        var a = Va(e);
        if (a === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var i = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + i);
        }
        var s = Ka(a);
        if (s === null)
          return null;
        if (s.mode & bn) {
          var c = ct(a) || "Component";
          if (!iI[c]) {
            iI[c] = !0;
            var A = Ln;
            try {
              Zt(s), a.mode & bn ? d("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, c) : d("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, c);
            } finally {
              A ? Zt(A) : Pn();
            }
          }
        }
        return s.stateNode;
      }
    }
    function Hv(e, t, a, i, s, c, A, S) {
      var p = !1, L = null;
      return xv(e, t, p, L, a, i, s, c, A);
    }
    function Bv(e, t, a, i, s, c, A, S, p, L) {
      var y = !0, F = xv(a, i, y, e, s, c, A, S, p);
      F.context = bv(null);
      var H = F.current, z = xa(), Q = au(H), ne = $l(z, Q);
      return ne.callback = t ?? null, Qs(H, ne, Q), oM(F, Q, z), F;
    }
    function OA(e, t, a, i) {
      var s = t.current, c = xa(), A = au(s), S = bv(a);
      t.context === null ? t.context = S : t.pendingContext = S, na && Ln !== null && !aI && (aI = !0, d(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, ct(Ln) || "Unknown"));
      var p = $l(c, A);
      p.payload = {
        element: e
      }, i = i === void 0 ? null : i, i !== null && (typeof i != "function" && d("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i), p.callback = i);
      var L = Qs(s, p, A);
      return L !== null && (Or(L, s, A, c), _d(L, s, A)), A;
    }
    function vS(e) {
      var t = e.current;
      if (!t.child)
        return null;
      switch (t.child.tag) {
        case Y:
          return t.child.stateNode;
        default:
          return t.child.stateNode;
      }
    }
    function eU(e) {
      switch (e.tag) {
        case g: {
          var t = e.stateNode;
          if (Vu(t)) {
            var a = CR(t);
            EM(t, a);
          }
          break;
        }
        case ye: {
          rs(function() {
            var s = Za(e, ot);
            if (s !== null) {
              var c = xa();
              Or(s, e, ot, c);
            }
          });
          var i = ot;
          oI(e, i);
          break;
        }
      }
    }
    function Fv(e, t) {
      var a = e.memoizedState;
      a !== null && a.dehydrated !== null && (a.retryLane = sN(a.retryLane, t));
    }
    function oI(e, t) {
      Fv(e, t);
      var a = e.alternate;
      a && Fv(a, t);
    }
    function tU(e) {
      if (e.tag === ye) {
        var t = wl, a = Za(e, t);
        if (a !== null) {
          var i = xa();
          Or(a, e, t, i);
        }
        oI(e, t);
      }
    }
    function nU(e) {
      if (e.tag === ye) {
        var t = au(e), a = Za(e, t);
        if (a !== null) {
          var i = xa();
          Or(a, e, t, i);
        }
        oI(e, t);
      }
    }
    function wv(e) {
      var t = dR(e);
      return t === null ? null : t.stateNode;
    }
    var Yv = function(e) {
      return null;
    };
    function rU(e) {
      return Yv(e);
    }
    var Vv = function(e) {
      return !1;
    };
    function aU(e) {
      return Vv(e);
    }
    var Wv = null, Xv = null, kv = null, Kv = null, jv = null, zv = null, Jv = null, Qv = null, Zv = null;
    {
      var qv = function(e, t, a) {
        var i = t[a], s = Ut(e) ? e.slice() : Dt({}, e);
        return a + 1 === t.length ? (Ut(s) ? s.splice(i, 1) : delete s[i], s) : (s[i] = qv(e[i], t, a + 1), s);
      }, $v = function(e, t) {
        return qv(e, t, 0);
      }, em = function(e, t, a, i) {
        var s = t[i], c = Ut(e) ? e.slice() : Dt({}, e);
        if (i + 1 === t.length) {
          var A = a[i];
          c[A] = c[s], Ut(c) ? c.splice(s, 1) : delete c[s];
        } else
          c[s] = em(
            // $FlowFixMe number or string is fine here
            e[s],
            t,
            a,
            i + 1
          );
        return c;
      }, tm = function(e, t, a) {
        if (t.length !== a.length) {
          h("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var i = 0; i < a.length - 1; i++)
            if (t[i] !== a[i]) {
              h("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return em(e, t, a, 0);
      }, nm = function(e, t, a, i) {
        if (a >= t.length)
          return i;
        var s = t[a], c = Ut(e) ? e.slice() : Dt({}, e);
        return c[s] = nm(e[s], t, a + 1, i), c;
      }, rm = function(e, t, a) {
        return nm(e, t, 0, a);
      }, lI = function(e, t) {
        for (var a = e.memoizedState; a !== null && t > 0; )
          a = a.next, t--;
        return a;
      };
      Wv = function(e, t, a, i) {
        var s = lI(e, t);
        if (s !== null) {
          var c = rm(s.memoizedState, a, i);
          s.memoizedState = c, s.baseState = c, e.memoizedProps = Dt({}, e.memoizedProps);
          var A = Za(e, ot);
          A !== null && Or(A, e, ot, an);
        }
      }, Xv = function(e, t, a) {
        var i = lI(e, t);
        if (i !== null) {
          var s = $v(i.memoizedState, a);
          i.memoizedState = s, i.baseState = s, e.memoizedProps = Dt({}, e.memoizedProps);
          var c = Za(e, ot);
          c !== null && Or(c, e, ot, an);
        }
      }, kv = function(e, t, a, i) {
        var s = lI(e, t);
        if (s !== null) {
          var c = tm(s.memoizedState, a, i);
          s.memoizedState = c, s.baseState = c, e.memoizedProps = Dt({}, e.memoizedProps);
          var A = Za(e, ot);
          A !== null && Or(A, e, ot, an);
        }
      }, Kv = function(e, t, a) {
        e.pendingProps = rm(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Za(e, ot);
        i !== null && Or(i, e, ot, an);
      }, jv = function(e, t) {
        e.pendingProps = $v(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var a = Za(e, ot);
        a !== null && Or(a, e, ot, an);
      }, zv = function(e, t, a) {
        e.pendingProps = tm(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Za(e, ot);
        i !== null && Or(i, e, ot, an);
      }, Jv = function(e) {
        var t = Za(e, ot);
        t !== null && Or(t, e, ot, an);
      }, Qv = function(e) {
        Yv = e;
      }, Zv = function(e) {
        Vv = e;
      };
    }
    function iU(e) {
      var t = Ka(e);
      return t === null ? null : t.stateNode;
    }
    function oU(e) {
      return null;
    }
    function lU() {
      return Ln;
    }
    function sU(e) {
      var t = e.findFiberByHostInstance, a = T.ReactCurrentDispatcher;
      return jT({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: Wv,
        overrideHookStateDeletePath: Xv,
        overrideHookStateRenamePath: kv,
        overrideProps: Kv,
        overridePropsDeletePath: jv,
        overridePropsRenamePath: zv,
        setErrorHandler: Qv,
        setSuspenseHandler: Zv,
        scheduleUpdate: Jv,
        currentDispatcherRef: a,
        findHostInstanceByFiber: iU,
        findFiberByHostInstance: t || oU,
        // React Refresh
        findHostInstancesForRefresh: BM,
        scheduleRefresh: bM,
        scheduleRoot: HM,
        setRefreshHandler: xM,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: lU,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: rI
      });
    }
    var am = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function sI(e) {
      this._internalRoot = e;
    }
    mS.prototype.render = sI.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? d("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : LS(arguments[1]) ? d("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && d("You passed a second argument to root.render(...) but it only accepts one argument.");
        var a = t.containerInfo;
        if (a.nodeType !== Wn) {
          var i = wv(t.current);
          i && i.parentNode !== a && d("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      OA(e, t, null, null);
    }, mS.prototype.unmount = sI.prototype.unmount = function() {
      typeof arguments[0] == "function" && d("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        dv() && d("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), rs(function() {
          OA(null, e, null, null);
        }), aC(t);
      }
    };
    function uU(e, t) {
      if (!LS(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      im(e);
      var a = !1, i = !1, s = "", c = am;
      t != null && (t.hydrate ? h("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === vi && d(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (s = t.identifierPrefix), t.onRecoverableError !== void 0 && (c = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var A = Hv(e, Od, null, a, i, s, c);
      fd(A.current, e);
      var S = e.nodeType === Wn ? e.parentNode : e;
      return Df(S), new sI(A);
    }
    function mS(e) {
      this._internalRoot = e;
    }
    function EU(e) {
      e && yr(e);
    }
    mS.prototype.unstable_scheduleHydration = EU;
    function cU(e, t, a) {
      if (!LS(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      im(e), t === void 0 && d("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var i = a ?? null, s = a != null && a.hydratedSources || null, c = !1, A = !1, S = "", p = am;
      a != null && (a.unstable_strictMode === !0 && (c = !0), a.identifierPrefix !== void 0 && (S = a.identifierPrefix), a.onRecoverableError !== void 0 && (p = a.onRecoverableError));
      var L = Bv(t, null, e, Od, i, c, A, S, p);
      if (fd(L.current, e), Df(e), s)
        for (var y = 0; y < s.length; y++) {
          var F = s[y];
          pg(L, F);
        }
      return new mS(L);
    }
    function LS(e) {
      return !!(e && (e.nodeType === aa || e.nodeType === li || e.nodeType === yl || !Ie));
    }
    function IA(e) {
      return !!(e && (e.nodeType === aa || e.nodeType === li || e.nodeType === yl || e.nodeType === Wn && e.nodeValue === " react-mount-point-unstable "));
    }
    function im(e) {
      e.nodeType === aa && e.tagName && e.tagName.toUpperCase() === "BODY" && d("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Ff(e) && (e._reactRootContainer ? d("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : d("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var TU = T.ReactCurrentOwner, om;
    om = function(e) {
      if (e._reactRootContainer && e.nodeType !== Wn) {
        var t = wv(e._reactRootContainer.current);
        t && t.parentNode !== e && d("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var a = !!e._reactRootContainer, i = uI(e), s = !!(i && ks(i));
      s && !a && d("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === aa && e.tagName && e.tagName.toUpperCase() === "BODY" && d("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function uI(e) {
      return e ? e.nodeType === li ? e.documentElement : e.firstChild : null;
    }
    function lm() {
    }
    function fU(e, t, a, i, s) {
      if (s) {
        if (typeof i == "function") {
          var c = i;
          i = function() {
            var H = vS(A);
            c.call(H);
          };
        }
        var A = Bv(
          t,
          i,
          e,
          js,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          lm
        );
        e._reactRootContainer = A, fd(A.current, e);
        var S = e.nodeType === Wn ? e.parentNode : e;
        return Df(S), rs(), A;
      } else {
        for (var p; p = e.lastChild; )
          e.removeChild(p);
        if (typeof i == "function") {
          var L = i;
          i = function() {
            var H = vS(y);
            L.call(H);
          };
        }
        var y = Hv(
          e,
          js,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          lm
        );
        e._reactRootContainer = y, fd(y.current, e);
        var F = e.nodeType === Wn ? e.parentNode : e;
        return Df(F), rs(function() {
          OA(t, y, a, i);
        }), y;
      }
    }
    function AU(e, t) {
      e !== null && typeof e != "function" && d("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function yS(e, t, a, i, s) {
      om(a), AU(s === void 0 ? null : s, "render");
      var c = a._reactRootContainer, A;
      if (!c)
        A = fU(a, t, e, s, i);
      else {
        if (A = c, typeof s == "function") {
          var S = s;
          s = function() {
            var p = vS(A);
            S.call(p);
          };
        }
        OA(t, A, e, s);
      }
      return vS(A);
    }
    function RU(e) {
      {
        var t = TU.current;
        if (t !== null && t.stateNode !== null) {
          var a = t.stateNode._warnedAboutRefsInRender;
          a || d("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Bt(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === aa ? e : $M(e, "findDOMNode");
    }
    function dU(e, t, a) {
      if (d("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !IA(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = Ff(t) && t._reactRootContainer === void 0;
        i && d("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return yS(null, e, t, !0, a);
    }
    function SU(e, t, a) {
      if (d("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !IA(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = Ff(t) && t._reactRootContainer === void 0;
        i && d("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return yS(null, e, t, !1, a);
    }
    function NU(e, t, a, i) {
      if (d("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !IA(a))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !yu(e))
        throw new Error("parentComponent must be a valid React Component");
      return yS(e, t, a, !1, i);
    }
    function pU(e) {
      if (!IA(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = Ff(e) && e._reactRootContainer === void 0;
        t && d("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var a = uI(e), i = a && !ks(a);
          i && d("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return rs(function() {
          yS(null, null, e, !1, function() {
            e._reactRootContainer = null, aC(e);
          });
        }), !0;
      } else {
        {
          var s = uI(e), c = !!(s && ks(s)), A = e.nodeType === aa && IA(e.parentNode) && !!e.parentNode._reactRootContainer;
          c && d("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", A ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    UR(eU), rf(tU), of(nU), GR(Ja), sf(PR), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && d("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), fR(Cy), jE(wO, cM, rs);
    function OU(e, t) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!LS(t))
        throw new Error("Target container is not a DOM element.");
      return qM(e, t, null, a);
    }
    function IU(e, t, a, i) {
      return NU(e, t, a, i);
    }
    var EI = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [ks, Bc, Ad, KE, vu, wO]
    };
    function CU(e, t) {
      return EI.usingClientEntryPoint || d('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), uU(e, t);
    }
    function hU(e, t, a) {
      return EI.usingClientEntryPoint || d('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), cU(e, t, a);
    }
    function vU(e) {
      return dv() && d("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), rs(e);
    }
    var mU = sU({
      findFiberByHostInstance: EE,
      bundleType: 1,
      version: rI,
      rendererPackageName: "react-dom"
    });
    if (!mU && hn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var sm = window.location.protocol;
      /^(https?|file):$/.test(sm) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (sm === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ti.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = EI, ti.createPortal = OU, ti.createRoot = CU, ti.findDOMNode = RU, ti.flushSync = vU, ti.hydrate = dU, ti.hydrateRoot = hU, ti.render = SU, ti.unmountComponentAtNode = pU, ti.unstable_batchedUpdates = wO, ti.unstable_renderSubtreeIntoContainer = IU, ti.version = rI, typeof { isDisabled: !0 } < "u" && typeof { isDisabled: !0 }.registerInternalModuleStop == "function" && { isDisabled: !0 }.registerInternalModuleStop(new Error());
  }()), ti;
}
function aL() {
  if (!(typeof { isDisabled: !0 } > "u" || typeof { isDisabled: !0 }.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      ({ isDisabled: !0 }).checkDCE(aL);
    } catch (l) {
      console.error(l);
    }
  }
}
process.env.NODE_ENV === "production" ? (aL(), CI.exports = BU()) : CI.exports = FU();
var wU = CI.exports, mA = wU;
if (process.env.NODE_ENV === "production")
  gA.createRoot = mA.createRoot, gA.hydrateRoot = mA.hydrateRoot;
else {
  var PS = mA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  gA.createRoot = function(l, u) {
    PS.usingClientEntryPoint = !0;
    try {
      return mA.createRoot(l, u);
    } finally {
      PS.usingClientEntryPoint = !1;
    }
  }, gA.hydrateRoot = function(l, u, T) {
    PS.usingClientEntryPoint = !0;
    try {
      return mA.hydrateRoot(l, u, T);
    } finally {
      PS.usingClientEntryPoint = !1;
    }
  };
}
var W = GA();
const iL = /* @__PURE__ */ _A(W), YU = /* @__PURE__ */ PU({
  __proto__: null,
  default: iL
}, [W]);
/**
 * @remix-run/router v1.11.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function bS() {
  return bS = Object.assign ? Object.assign.bind() : function(l) {
    for (var u = 1; u < arguments.length; u++) {
      var T = arguments[u];
      for (var N in T)
        Object.prototype.hasOwnProperty.call(T, N) && (l[N] = T[N]);
    }
    return l;
  }, bS.apply(this, arguments);
}
var lu;
(function(l) {
  l.Pop = "POP", l.Push = "PUSH", l.Replace = "REPLACE";
})(lu || (lu = {}));
function VU(l) {
  l === void 0 && (l = {});
  let {
    initialEntries: u = ["/"],
    initialIndex: T,
    v5Compat: N = !1
  } = l, O;
  O = u.map((Y, j) => M(Y, typeof Y == "string" ? null : Y.state, j === 0 ? "default" : void 0));
  let h = D(T ?? O.length - 1), d = lu.Pop, G = null;
  function D(Y) {
    return Math.min(Math.max(Y, 0), O.length - 1);
  }
  function v() {
    return O[h];
  }
  function M(Y, j, oe) {
    j === void 0 && (j = null);
    let me = XU(O ? v().pathname : "/", Y, j, oe);
    return Wi(me.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(Y)), me;
  }
  function g(Y) {
    return typeof Y == "string" ? Y : HS(Y);
  }
  return {
    get index() {
      return h;
    },
    get action() {
      return d;
    },
    get location() {
      return v();
    },
    createHref: g,
    createURL(Y) {
      return new URL(g(Y), "http://localhost");
    },
    encodeLocation(Y) {
      let j = typeof Y == "string" ? ME(Y) : Y;
      return {
        pathname: j.pathname || "",
        search: j.search || "",
        hash: j.hash || ""
      };
    },
    push(Y, j) {
      d = lu.Push;
      let oe = M(Y, j);
      h += 1, O.splice(h, O.length, oe), N && G && G({
        action: d,
        location: oe,
        delta: 1
      });
    },
    replace(Y, j) {
      d = lu.Replace;
      let oe = M(Y, j);
      O[h] = oe, N && G && G({
        action: d,
        location: oe,
        delta: 0
      });
    },
    go(Y) {
      d = lu.Pop;
      let j = D(h + Y), oe = O[j];
      h = j, G && G({
        action: d,
        location: oe,
        delta: Y
      });
    },
    listen(Y) {
      return G = Y, () => {
        G = null;
      };
    }
  };
}
function Mt(l, u) {
  if (l === !1 || l === null || typeof l > "u")
    throw new Error(u);
}
function Wi(l, u) {
  if (!l) {
    typeof console < "u" && console.warn(u);
    try {
      throw new Error(u);
    } catch {
    }
  }
}
function WU() {
  return Math.random().toString(36).substr(2, 8);
}
function XU(l, u, T, N) {
  return T === void 0 && (T = null), bS({
    pathname: typeof l == "string" ? l : l.pathname,
    search: "",
    hash: ""
  }, typeof u == "string" ? ME(u) : u, {
    state: T,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: u && u.key || N || WU()
  });
}
function HS(l) {
  let {
    pathname: u = "/",
    search: T = "",
    hash: N = ""
  } = l;
  return T && T !== "?" && (u += T.charAt(0) === "?" ? T : "?" + T), N && N !== "#" && (u += N.charAt(0) === "#" ? N : "#" + N), u;
}
function ME(l) {
  let u = {};
  if (l) {
    let T = l.indexOf("#");
    T >= 0 && (u.hash = l.substr(T), l = l.substr(0, T));
    let N = l.indexOf("?");
    N >= 0 && (u.search = l.substr(N), l = l.substr(0, N)), l && (u.pathname = l);
  }
  return u;
}
var pm;
(function(l) {
  l.data = "data", l.deferred = "deferred", l.redirect = "redirect", l.error = "error";
})(pm || (pm = {}));
function kU(l, u, T) {
  T === void 0 && (T = "/");
  let N = typeof u == "string" ? ME(u) : u, O = DE(N.pathname || "/", T);
  if (O == null)
    return null;
  let h = oL(l);
  KU(h);
  let d = null;
  for (let G = 0; d == null && G < h.length; ++G)
    d = t1(
      h[G],
      // Incoming pathnames are generally encoded from either window.location
      // or from router.navigate, but we want to match against the unencoded
      // paths in the route definitions.  Memory router locations won't be
      // encoded here but there also shouldn't be anything to decode so this
      // should be a safe operation.  This avoids needing matchRoutes to be
      // history-aware.
      r1(O)
    );
  return d;
}
function oL(l, u, T, N) {
  u === void 0 && (u = []), T === void 0 && (T = []), N === void 0 && (N = "");
  let O = (h, d, G) => {
    let D = {
      relativePath: G === void 0 ? h.path || "" : G,
      caseSensitive: h.caseSensitive === !0,
      childrenIndex: d,
      route: h
    };
    D.relativePath.startsWith("/") && (Mt(D.relativePath.startsWith(N), 'Absolute route path "' + D.relativePath + '" nested under path ' + ('"' + N + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), D.relativePath = D.relativePath.slice(N.length));
    let v = os([N, D.relativePath]), M = T.concat(D);
    h.children && h.children.length > 0 && (Mt(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      h.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + v + '".')
    ), oL(h.children, u, M, v)), !(h.path == null && !h.index) && u.push({
      path: v,
      score: $U(v, h.index),
      routesMeta: M
    });
  };
  return l.forEach((h, d) => {
    var G;
    if (h.path === "" || !((G = h.path) != null && G.includes("?")))
      O(h, d);
    else
      for (let D of lL(h.path))
        O(h, d, D);
  }), u;
}
function lL(l) {
  let u = l.split("/");
  if (u.length === 0)
    return [];
  let [T, ...N] = u, O = T.endsWith("?"), h = T.replace(/\?$/, "");
  if (N.length === 0)
    return O ? [h, ""] : [h];
  let d = lL(N.join("/")), G = [];
  return G.push(...d.map((D) => D === "" ? h : [h, D].join("/"))), O && G.push(...d), G.map((D) => l.startsWith("/") && D === "" ? "/" : D);
}
function KU(l) {
  l.sort((u, T) => u.score !== T.score ? T.score - u.score : e1(u.routesMeta.map((N) => N.childrenIndex), T.routesMeta.map((N) => N.childrenIndex)));
}
const jU = /^:\w+$/, zU = 3, JU = 2, QU = 1, ZU = 10, qU = -2, Om = (l) => l === "*";
function $U(l, u) {
  let T = l.split("/"), N = T.length;
  return T.some(Om) && (N += qU), u && (N += JU), T.filter((O) => !Om(O)).reduce((O, h) => O + (jU.test(h) ? zU : h === "" ? QU : ZU), N);
}
function e1(l, u) {
  return l.length === u.length && l.slice(0, -1).every((N, O) => N === u[O]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    l[l.length - 1] - u[u.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function t1(l, u) {
  let {
    routesMeta: T
  } = l, N = {}, O = "/", h = [];
  for (let d = 0; d < T.length; ++d) {
    let G = T[d], D = d === T.length - 1, v = O === "/" ? u : u.slice(O.length) || "/", M = hI({
      path: G.relativePath,
      caseSensitive: G.caseSensitive,
      end: D
    }, v);
    if (!M)
      return null;
    Object.assign(N, M.params);
    let g = G.route;
    h.push({
      // TODO: Can this as be avoided?
      params: N,
      pathname: os([O, M.pathname]),
      pathnameBase: l1(os([O, M.pathnameBase])),
      route: g
    }), M.pathnameBase !== "/" && (O = os([O, M.pathnameBase]));
  }
  return h;
}
function hI(l, u) {
  typeof l == "string" && (l = {
    path: l,
    caseSensitive: !1,
    end: !0
  });
  let [T, N] = n1(l.path, l.caseSensitive, l.end), O = u.match(T);
  if (!O)
    return null;
  let h = O[0], d = h.replace(/(.)\/+$/, "$1"), G = O.slice(1);
  return {
    params: N.reduce((v, M, g) => {
      let {
        paramName: w,
        isOptional: Y
      } = M;
      if (w === "*") {
        let oe = G[g] || "";
        d = h.slice(0, h.length - oe.length).replace(/(.)\/+$/, "$1");
      }
      const j = G[g];
      return Y && !j ? v[w] = void 0 : v[w] = a1(j || "", w), v;
    }, {}),
    pathname: h,
    pathnameBase: d,
    pattern: l
  };
}
function n1(l, u, T) {
  u === void 0 && (u = !1), T === void 0 && (T = !0), Wi(l === "*" || !l.endsWith("*") || l.endsWith("/*"), 'Route path "' + l + '" will be treated as if it were ' + ('"' + l.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + l.replace(/\*$/, "/*") + '".'));
  let N = [], O = "^" + l.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:(\w+)(\?)?/g, (d, G, D) => (N.push({
    paramName: G,
    isOptional: D != null
  }), D ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return l.endsWith("*") ? (N.push({
    paramName: "*"
  }), O += l === "*" || l === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : T ? O += "\\/*$" : l !== "" && l !== "/" && (O += "(?:(?=\\/|$))"), [new RegExp(O, u ? void 0 : "i"), N];
}
function r1(l) {
  try {
    return decodeURI(l);
  } catch (u) {
    return Wi(!1, 'The URL path "' + l + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + u + ").")), l;
  }
}
function a1(l, u) {
  try {
    return decodeURIComponent(l);
  } catch (T) {
    return Wi(!1, 'The value for the URL param "' + u + '" will not be decoded because' + (' the string "' + l + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + T + ").")), l;
  }
}
function DE(l, u) {
  if (u === "/")
    return l;
  if (!l.toLowerCase().startsWith(u.toLowerCase()))
    return null;
  let T = u.endsWith("/") ? u.length - 1 : u.length, N = l.charAt(T);
  return N && N !== "/" ? null : l.slice(T) || "/";
}
function i1(l, u) {
  u === void 0 && (u = "/");
  let {
    pathname: T,
    search: N = "",
    hash: O = ""
  } = typeof l == "string" ? ME(l) : l;
  return {
    pathname: T ? T.startsWith("/") ? T : o1(T, u) : u,
    search: s1(N),
    hash: u1(O)
  };
}
function o1(l, u) {
  let T = u.replace(/\/+$/, "").split("/");
  return l.split("/").forEach((O) => {
    O === ".." ? T.length > 1 && T.pop() : O !== "." && T.push(O);
  }), T.length > 1 ? T.join("/") : "/";
}
function fI(l, u, T, N) {
  return "Cannot include a '" + l + "' character in a manually specified " + ("`to." + u + "` field [" + JSON.stringify(N) + "].  Please separate it out to the ") + ("`to." + T + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function sL(l) {
  return l.filter((u, T) => T === 0 || u.route.path && u.route.path.length > 0);
}
function uL(l, u, T, N) {
  N === void 0 && (N = !1);
  let O;
  typeof l == "string" ? O = ME(l) : (O = bS({}, l), Mt(!O.pathname || !O.pathname.includes("?"), fI("?", "pathname", "search", O)), Mt(!O.pathname || !O.pathname.includes("#"), fI("#", "pathname", "hash", O)), Mt(!O.search || !O.search.includes("#"), fI("#", "search", "hash", O)));
  let h = l === "" || O.pathname === "", d = h ? "/" : O.pathname, G;
  if (N || d == null)
    G = T;
  else {
    let g = u.length - 1;
    if (d.startsWith("..")) {
      let w = d.split("/");
      for (; w[0] === ".."; )
        w.shift(), g -= 1;
      O.pathname = w.join("/");
    }
    G = g >= 0 ? u[g] : "/";
  }
  let D = i1(O, G), v = d && d !== "/" && d.endsWith("/"), M = (h || d === ".") && T.endsWith("/");
  return !D.pathname.endsWith("/") && (v || M) && (D.pathname += "/"), D;
}
const os = (l) => l.join("/").replace(/\/\/+/g, "/"), l1 = (l) => l.replace(/\/+$/, "").replace(/^\/*/, "/"), s1 = (l) => !l || l === "?" ? "" : l.startsWith("?") ? l : "?" + l, u1 = (l) => !l || l === "#" ? "" : l.startsWith("#") ? l : "#" + l;
function E1(l) {
  return l != null && typeof l.status == "number" && typeof l.statusText == "string" && typeof l.internal == "boolean" && "data" in l;
}
const EL = ["post", "put", "patch", "delete"];
new Set(EL);
const c1 = ["get", ...EL];
new Set(c1);
/**
 * React Router v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function BS() {
  return BS = Object.assign ? Object.assign.bind() : function(l) {
    for (var u = 1; u < arguments.length; u++) {
      var T = arguments[u];
      for (var N in T)
        Object.prototype.hasOwnProperty.call(T, N) && (l[N] = T[N]);
    }
    return l;
  }, BS.apply(this, arguments);
}
const xA = /* @__PURE__ */ W.createContext(null);
process.env.NODE_ENV !== "production" && (xA.displayName = "DataRouter");
const DI = /* @__PURE__ */ W.createContext(null);
process.env.NODE_ENV !== "production" && (DI.displayName = "DataRouterState");
const T1 = /* @__PURE__ */ W.createContext(null);
process.env.NODE_ENV !== "production" && (T1.displayName = "Await");
const Cl = /* @__PURE__ */ W.createContext(null);
process.env.NODE_ENV !== "production" && (Cl.displayName = "Navigation");
const bA = /* @__PURE__ */ W.createContext(null);
process.env.NODE_ENV !== "production" && (bA.displayName = "Location");
const yo = /* @__PURE__ */ W.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (yo.displayName = "Route");
const gI = /* @__PURE__ */ W.createContext(null);
process.env.NODE_ENV !== "production" && (gI.displayName = "RouteError");
function f1(l, u) {
  let {
    relative: T
  } = u === void 0 ? {} : u;
  HA() || (process.env.NODE_ENV !== "production" ? Mt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : Mt(!1));
  let {
    basename: N,
    navigator: O
  } = W.useContext(Cl), {
    hash: h,
    pathname: d,
    search: G
  } = BA(l, {
    relative: T
  }), D = d;
  return N !== "/" && (D = d === "/" ? N : os([N, d])), O.createHref({
    pathname: D,
    search: G,
    hash: h
  });
}
function HA() {
  return W.useContext(bA) != null;
}
function UE() {
  return HA() || (process.env.NODE_ENV !== "production" ? Mt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : Mt(!1)), W.useContext(bA).location;
}
const cL = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function TL(l) {
  W.useContext(Cl).static || W.useLayoutEffect(l);
}
function PI() {
  let {
    isDataRoute: l
  } = W.useContext(yo);
  return l ? g1() : A1();
}
function A1() {
  HA() || (process.env.NODE_ENV !== "production" ? Mt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : Mt(!1));
  let l = W.useContext(xA), {
    basename: u,
    navigator: T
  } = W.useContext(Cl), {
    matches: N
  } = W.useContext(yo), {
    pathname: O
  } = UE(), h = JSON.stringify(sL(N).map((D) => D.pathnameBase)), d = W.useRef(!1);
  return TL(() => {
    d.current = !0;
  }), W.useCallback(function(D, v) {
    if (v === void 0 && (v = {}), process.env.NODE_ENV !== "production" && Wi(d.current, cL), !d.current)
      return;
    if (typeof D == "number") {
      T.go(D);
      return;
    }
    let M = uL(D, JSON.parse(h), O, v.relative === "path");
    l == null && u !== "/" && (M.pathname = M.pathname === "/" ? u : os([u, M.pathname])), (v.replace ? T.replace : T.push)(M, v.state, v);
  }, [u, T, h, O, l]);
}
const R1 = /* @__PURE__ */ W.createContext(null);
function d1(l) {
  let u = W.useContext(yo).outlet;
  return u && /* @__PURE__ */ W.createElement(R1.Provider, {
    value: l
  }, u);
}
function MI() {
  let {
    matches: l
  } = W.useContext(yo), u = l[l.length - 1];
  return u ? u.params : {};
}
function BA(l, u) {
  let {
    relative: T
  } = u === void 0 ? {} : u, {
    matches: N
  } = W.useContext(yo), {
    pathname: O
  } = UE(), h = JSON.stringify(sL(N).map((d) => d.pathnameBase));
  return W.useMemo(() => uL(l, JSON.parse(h), O, T === "path"), [l, h, O, T]);
}
function S1(l, u) {
  return N1(l, u);
}
function N1(l, u, T) {
  HA() || (process.env.NODE_ENV !== "production" ? Mt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : Mt(!1));
  let {
    navigator: N
  } = W.useContext(Cl), {
    matches: O
  } = W.useContext(yo), h = O[O.length - 1], d = h ? h.params : {}, G = h ? h.pathname : "/", D = h ? h.pathnameBase : "/", v = h && h.route;
  if (process.env.NODE_ENV !== "production") {
    let Le = v && v.path || "";
    P1(G, !v || Le.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + G + '" (under <Route path="' + Le + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + Le + '"> to <Route ') + ('path="' + (Le === "/" ? "*" : Le + "/*") + '">.'));
  }
  let M = UE(), g;
  if (u) {
    var w;
    let Le = typeof u == "string" ? ME(u) : u;
    D === "/" || (w = Le.pathname) != null && w.startsWith(D) || (process.env.NODE_ENV !== "production" ? Mt(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + D + '" ') + ('but pathname "' + Le.pathname + '" was given in the `location` prop.')) : Mt(!1)), g = Le;
  } else
    g = M;
  let Y = g.pathname || "/", j = D === "/" ? Y : Y.slice(D.length) || "/", oe = kU(l, {
    pathname: j
  });
  process.env.NODE_ENV !== "production" && (process.env.NODE_ENV !== "production" && Wi(v || oe != null, 'No routes matched location "' + g.pathname + g.search + g.hash + '" '), process.env.NODE_ENV !== "production" && Wi(oe == null || oe[oe.length - 1].route.element !== void 0 || oe[oe.length - 1].route.Component !== void 0, 'Matched leaf route at location "' + g.pathname + g.search + g.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
  let me = h1(oe && oe.map((Le) => Object.assign({}, Le, {
    params: Object.assign({}, d, Le.params),
    pathname: os([
      D,
      // Re-encode pathnames that were decoded inside matchRoutes
      N.encodeLocation ? N.encodeLocation(Le.pathname).pathname : Le.pathname
    ]),
    pathnameBase: Le.pathnameBase === "/" ? D : os([
      D,
      // Re-encode pathnames that were decoded inside matchRoutes
      N.encodeLocation ? N.encodeLocation(Le.pathnameBase).pathname : Le.pathnameBase
    ])
  })), O, T);
  return u && me ? /* @__PURE__ */ W.createElement(bA.Provider, {
    value: {
      location: BS({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, g),
      navigationType: lu.Pop
    }
  }, me) : me;
}
function p1() {
  let l = D1(), u = E1(l) ? l.status + " " + l.statusText : l instanceof Error ? l.message : JSON.stringify(l), T = l instanceof Error ? l.stack : null, N = "rgba(200,200,200, 0.5)", O = {
    padding: "0.5rem",
    backgroundColor: N
  }, h = {
    padding: "2px 4px",
    backgroundColor: N
  }, d = null;
  return process.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", l), d = /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ W.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ W.createElement("code", {
    style: h
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ W.createElement("code", {
    style: h
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ W.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, u), T ? /* @__PURE__ */ W.createElement("pre", {
    style: O
  }, T) : null, d);
}
const O1 = /* @__PURE__ */ W.createElement(p1, null);
class I1 extends W.Component {
  constructor(u) {
    super(u), this.state = {
      location: u.location,
      revalidation: u.revalidation,
      error: u.error
    };
  }
  static getDerivedStateFromError(u) {
    return {
      error: u
    };
  }
  static getDerivedStateFromProps(u, T) {
    return T.location !== u.location || T.revalidation !== "idle" && u.revalidation === "idle" ? {
      error: u.error,
      location: u.location,
      revalidation: u.revalidation
    } : {
      error: u.error || T.error,
      location: T.location,
      revalidation: u.revalidation || T.revalidation
    };
  }
  componentDidCatch(u, T) {
    console.error("React Router caught the following error during render", u, T);
  }
  render() {
    return this.state.error ? /* @__PURE__ */ W.createElement(yo.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ W.createElement(gI.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function C1(l) {
  let {
    routeContext: u,
    match: T,
    children: N
  } = l, O = W.useContext(xA);
  return O && O.static && O.staticContext && (T.route.errorElement || T.route.ErrorBoundary) && (O.staticContext._deepestRenderedBoundaryId = T.route.id), /* @__PURE__ */ W.createElement(yo.Provider, {
    value: u
  }, N);
}
function h1(l, u, T) {
  var N;
  if (u === void 0 && (u = []), T === void 0 && (T = null), l == null) {
    var O;
    if ((O = T) != null && O.errors)
      l = T.matches;
    else
      return null;
  }
  let h = l, d = (N = T) == null ? void 0 : N.errors;
  if (d != null) {
    let G = h.findIndex((D) => D.route.id && (d == null ? void 0 : d[D.route.id]));
    G >= 0 || (process.env.NODE_ENV !== "production" ? Mt(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(d).join(",")) : Mt(!1)), h = h.slice(0, Math.min(h.length, G + 1));
  }
  return h.reduceRight((G, D, v) => {
    let M = D.route.id ? d == null ? void 0 : d[D.route.id] : null, g = null;
    T && (g = D.route.errorElement || O1);
    let w = u.concat(h.slice(0, v + 1)), Y = () => {
      let j;
      return M ? j = g : D.route.Component ? j = /* @__PURE__ */ W.createElement(D.route.Component, null) : D.route.element ? j = D.route.element : j = G, /* @__PURE__ */ W.createElement(C1, {
        match: D,
        routeContext: {
          outlet: G,
          matches: w,
          isDataRoute: T != null
        },
        children: j
      });
    };
    return T && (D.route.ErrorBoundary || D.route.errorElement || v === 0) ? /* @__PURE__ */ W.createElement(I1, {
      location: T.location,
      revalidation: T.revalidation,
      component: g,
      error: M,
      children: Y(),
      routeContext: {
        outlet: null,
        matches: w,
        isDataRoute: !0
      }
    }) : Y();
  }, null);
}
var fL = /* @__PURE__ */ function(l) {
  return l.UseBlocker = "useBlocker", l.UseRevalidator = "useRevalidator", l.UseNavigateStable = "useNavigate", l;
}(fL || {}), MA = /* @__PURE__ */ function(l) {
  return l.UseBlocker = "useBlocker", l.UseLoaderData = "useLoaderData", l.UseActionData = "useActionData", l.UseRouteError = "useRouteError", l.UseNavigation = "useNavigation", l.UseRouteLoaderData = "useRouteLoaderData", l.UseMatches = "useMatches", l.UseRevalidator = "useRevalidator", l.UseNavigateStable = "useNavigate", l.UseRouteId = "useRouteId", l;
}(MA || {});
function UI(l) {
  return l + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function v1(l) {
  let u = W.useContext(xA);
  return u || (process.env.NODE_ENV !== "production" ? Mt(!1, UI(l)) : Mt(!1)), u;
}
function m1(l) {
  let u = W.useContext(DI);
  return u || (process.env.NODE_ENV !== "production" ? Mt(!1, UI(l)) : Mt(!1)), u;
}
function L1(l) {
  let u = W.useContext(yo);
  return u || (process.env.NODE_ENV !== "production" ? Mt(!1, UI(l)) : Mt(!1)), u;
}
function _I(l) {
  let u = L1(l), T = u.matches[u.matches.length - 1];
  return T.route.id || (process.env.NODE_ENV !== "production" ? Mt(!1, l + ' can only be used on routes that contain a unique "id"') : Mt(!1)), T.route.id;
}
function y1() {
  return _I(MA.UseRouteId);
}
function D1() {
  var l;
  let u = W.useContext(gI), T = m1(MA.UseRouteError), N = _I(MA.UseRouteError);
  return u || ((l = T.errors) == null ? void 0 : l[N]);
}
function g1() {
  let {
    router: l
  } = v1(fL.UseNavigateStable), u = _I(MA.UseNavigateStable), T = W.useRef(!1);
  return TL(() => {
    T.current = !0;
  }), W.useCallback(function(O, h) {
    h === void 0 && (h = {}), process.env.NODE_ENV !== "production" && Wi(T.current, cL), T.current && (typeof O == "number" ? l.navigate(O) : l.navigate(O, BS({
      fromRouteId: u
    }, h)));
  }, [l, u]);
}
const Im = {};
function P1(l, u, T) {
  !u && !Im[l] && (Im[l] = !0, process.env.NODE_ENV !== "production" && Wi(!1, T));
}
const M1 = "startTransition", Cm = YU[M1];
function U1(l) {
  let {
    basename: u,
    children: T,
    initialEntries: N,
    initialIndex: O,
    future: h
  } = l, d = W.useRef();
  d.current == null && (d.current = VU({
    initialEntries: N,
    initialIndex: O,
    v5Compat: !0
  }));
  let G = d.current, [D, v] = W.useState({
    action: G.action,
    location: G.location
  }), {
    v7_startTransition: M
  } = h || {}, g = W.useCallback((w) => {
    M && Cm ? Cm(() => v(w)) : v(w);
  }, [v, M]);
  return W.useLayoutEffect(() => G.listen(g), [G, g]), /* @__PURE__ */ W.createElement(G1, {
    basename: u,
    children: T,
    location: D.location,
    navigationType: D.action,
    navigator: G
  });
}
function _1(l) {
  return d1(l.context);
}
function Vi(l) {
  process.env.NODE_ENV !== "production" ? Mt(!1, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.") : Mt(!1);
}
function G1(l) {
  let {
    basename: u = "/",
    children: T = null,
    location: N,
    navigationType: O = lu.Pop,
    navigator: h,
    static: d = !1
  } = l;
  HA() && (process.env.NODE_ENV !== "production" ? Mt(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : Mt(!1));
  let G = u.replace(/^\/*/, "/"), D = W.useMemo(() => ({
    basename: G,
    navigator: h,
    static: d
  }), [G, h, d]);
  typeof N == "string" && (N = ME(N));
  let {
    pathname: v = "/",
    search: M = "",
    hash: g = "",
    state: w = null,
    key: Y = "default"
  } = N, j = W.useMemo(() => {
    let oe = DE(v, G);
    return oe == null ? null : {
      location: {
        pathname: oe,
        search: M,
        hash: g,
        state: w,
        key: Y
      },
      navigationType: O
    };
  }, [G, v, M, g, w, Y, O]);
  return process.env.NODE_ENV !== "production" && Wi(j != null, '<Router basename="' + G + '"> is not able to match the URL ' + ('"' + v + M + g + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), j == null ? null : /* @__PURE__ */ W.createElement(Cl.Provider, {
    value: D
  }, /* @__PURE__ */ W.createElement(bA.Provider, {
    children: T,
    value: j
  }));
}
function FA(l) {
  let {
    children: u,
    location: T
  } = l;
  return S1(vI(u), T);
}
new Promise(() => {
});
function vI(l, u) {
  u === void 0 && (u = []);
  let T = [];
  return W.Children.forEach(l, (N, O) => {
    if (!/* @__PURE__ */ W.isValidElement(N))
      return;
    let h = [...u, O];
    if (N.type === W.Fragment) {
      T.push.apply(T, vI(N.props.children, h));
      return;
    }
    N.type !== Vi && (process.env.NODE_ENV !== "production" ? Mt(!1, "[" + (typeof N.type == "string" ? N.type : N.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>") : Mt(!1)), !N.props.index || !N.props.children || (process.env.NODE_ENV !== "production" ? Mt(!1, "An index route cannot have child routes.") : Mt(!1));
    let d = {
      id: N.props.id || h.join("-"),
      caseSensitive: N.props.caseSensitive,
      element: N.props.element,
      Component: N.props.Component,
      index: N.props.index,
      path: N.props.path,
      loader: N.props.loader,
      action: N.props.action,
      errorElement: N.props.errorElement,
      ErrorBoundary: N.props.ErrorBoundary,
      hasErrorBoundary: N.props.ErrorBoundary != null || N.props.errorElement != null,
      shouldRevalidate: N.props.shouldRevalidate,
      handle: N.props.handle,
      lazy: N.props.lazy
    };
    N.props.children && (d.children = vI(N.props.children, h)), T.push(d);
  }), T;
}
/**
 * React Router DOM v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function cT() {
  return cT = Object.assign ? Object.assign.bind() : function(l) {
    for (var u = 1; u < arguments.length; u++) {
      var T = arguments[u];
      for (var N in T)
        Object.prototype.hasOwnProperty.call(T, N) && (l[N] = T[N]);
    }
    return l;
  }, cT.apply(this, arguments);
}
function GI(l, u) {
  if (l == null)
    return {};
  var T = {}, N = Object.keys(l), O, h;
  for (h = 0; h < N.length; h++)
    O = N[h], !(u.indexOf(O) >= 0) && (T[O] = l[O]);
  return T;
}
const GS = "get", xS = "application/x-www-form-urlencoded";
function VS(l) {
  return l != null && typeof l.tagName == "string";
}
function x1(l) {
  return VS(l) && l.tagName.toLowerCase() === "button";
}
function b1(l) {
  return VS(l) && l.tagName.toLowerCase() === "form";
}
function H1(l) {
  return VS(l) && l.tagName.toLowerCase() === "input";
}
function B1(l) {
  return !!(l.metaKey || l.altKey || l.ctrlKey || l.shiftKey);
}
function F1(l, u) {
  return l.button === 0 && // Ignore everything but left clicks
  (!u || u === "_self") && // Let browser handle "target=_blank" etc.
  !B1(l);
}
let MS = null;
function w1() {
  if (MS === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), MS = !1;
    } catch {
      MS = !0;
    }
  return MS;
}
const Y1 = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function AI(l) {
  return l != null && !Y1.has(l) ? (process.env.NODE_ENV !== "production" && Wi(!1, '"' + l + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + xS + '"')), null) : l;
}
function V1(l, u) {
  let T, N, O, h, d;
  if (b1(l)) {
    let G = l.getAttribute("action");
    N = G ? DE(G, u) : null, T = l.getAttribute("method") || GS, O = AI(l.getAttribute("enctype")) || xS, h = new FormData(l);
  } else if (x1(l) || H1(l) && (l.type === "submit" || l.type === "image")) {
    let G = l.form;
    if (G == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let D = l.getAttribute("formaction") || G.getAttribute("action");
    if (N = D ? DE(D, u) : null, T = l.getAttribute("formmethod") || G.getAttribute("method") || GS, O = AI(l.getAttribute("formenctype")) || AI(G.getAttribute("enctype")) || xS, h = new FormData(G, l), !w1()) {
      let {
        name: v,
        type: M,
        value: g
      } = l;
      if (M === "image") {
        let w = v ? v + "." : "";
        h.append(w + "x", "0"), h.append(w + "y", "0");
      } else
        v && h.append(v, g);
    }
  } else {
    if (VS(l))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    T = GS, N = null, O = xS, d = l;
  }
  return h && O === "text/plain" && (d = h, h = void 0), {
    action: N,
    method: T.toLowerCase(),
    encType: O,
    formData: h,
    body: d
  };
}
const W1 = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], X1 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], k1 = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"], AL = /* @__PURE__ */ W.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (AL.displayName = "ViewTransition");
const K1 = /* @__PURE__ */ W.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (K1.displayName = "Fetchers");
process.env.NODE_ENV;
const j1 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", z1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Lo = /* @__PURE__ */ W.forwardRef(function(u, T) {
  let {
    onClick: N,
    relative: O,
    reloadDocument: h,
    replace: d,
    state: G,
    target: D,
    to: v,
    preventScrollReset: M,
    unstable_viewTransition: g
  } = u, w = GI(u, W1), {
    basename: Y
  } = W.useContext(Cl), j, oe = !1;
  if (typeof v == "string" && z1.test(v) && (j = v, j1))
    try {
      let he = new URL(window.location.href), Fe = v.startsWith("//") ? new URL(he.protocol + v) : new URL(v), ye = DE(Fe.pathname, Y);
      Fe.origin === he.origin && ye != null ? v = ye + Fe.search + Fe.hash : oe = !0;
    } catch {
      process.env.NODE_ENV !== "production" && Wi(!1, '<Link to="' + v + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let me = f1(v, {
    relative: O
  }), Le = Z1(v, {
    replace: d,
    state: G,
    target: D,
    preventScrollReset: M,
    relative: O,
    unstable_viewTransition: g
  });
  function Oe(he) {
    N && N(he), he.defaultPrevented || Le(he);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ W.createElement("a", cT({}, w, {
      href: j || me,
      onClick: oe || h ? N : Oe,
      ref: T,
      target: D
    }))
  );
});
process.env.NODE_ENV !== "production" && (Lo.displayName = "Link");
const RL = /* @__PURE__ */ W.forwardRef(function(u, T) {
  let {
    "aria-current": N = "page",
    caseSensitive: O = !1,
    className: h = "",
    end: d = !1,
    style: G,
    to: D,
    unstable_viewTransition: v,
    children: M
  } = u, g = GI(u, X1), w = BA(D, {
    relative: g.relative
  }), Y = UE(), j = W.useContext(DI), {
    navigator: oe
  } = W.useContext(Cl), me = j != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  r_(w) && v === !0, Le = oe.encodeLocation ? oe.encodeLocation(w).pathname : w.pathname, Oe = Y.pathname, he = j && j.navigation && j.navigation.location ? j.navigation.location.pathname : null;
  O || (Oe = Oe.toLowerCase(), he = he ? he.toLowerCase() : null, Le = Le.toLowerCase());
  let Fe = Oe === Le || !d && Oe.startsWith(Le) && Oe.charAt(Le.length) === "/", ye = he != null && (he === Le || !d && he.startsWith(Le) && he.charAt(Le.length) === "/"), je = {
    isActive: Fe,
    isPending: ye,
    isTransitioning: me
  }, Xe = Fe ? N : void 0, yt;
  typeof h == "function" ? yt = h(je) : yt = [h, Fe ? "active" : null, ye ? "pending" : null, me ? "transitioning" : null].filter(Boolean).join(" ");
  let ht = typeof G == "function" ? G(je) : G;
  return /* @__PURE__ */ W.createElement(Lo, cT({}, g, {
    "aria-current": Xe,
    className: yt,
    ref: T,
    style: ht,
    to: D,
    unstable_viewTransition: v
  }), typeof M == "function" ? M(je) : M);
});
process.env.NODE_ENV !== "production" && (RL.displayName = "NavLink");
const J1 = /* @__PURE__ */ W.forwardRef((l, u) => {
  let {
    fetcherKey: T,
    navigate: N,
    reloadDocument: O,
    replace: h,
    state: d,
    method: G = GS,
    action: D,
    onSubmit: v,
    relative: M,
    preventScrollReset: g,
    unstable_viewTransition: w
  } = l, Y = GI(l, k1), j = t_(), oe = n_(D, {
    relative: M
  }), me = G.toLowerCase() === "get" ? "get" : "post", Le = (Oe) => {
    if (v && v(Oe), Oe.defaultPrevented)
      return;
    Oe.preventDefault();
    let he = Oe.nativeEvent.submitter, Fe = (he == null ? void 0 : he.getAttribute("formmethod")) || G;
    j(he || Oe.currentTarget, {
      fetcherKey: T,
      method: Fe,
      navigate: N,
      replace: h,
      state: d,
      relative: M,
      preventScrollReset: g,
      unstable_viewTransition: w
    });
  };
  return /* @__PURE__ */ W.createElement("form", cT({
    ref: u,
    method: me,
    action: oe,
    onSubmit: O ? v : Le
  }, Y));
});
process.env.NODE_ENV !== "production" && (J1.displayName = "Form");
process.env.NODE_ENV;
var FS;
(function(l) {
  l.UseScrollRestoration = "useScrollRestoration", l.UseSubmit = "useSubmit", l.UseSubmitFetcher = "useSubmitFetcher", l.UseFetcher = "useFetcher", l.useViewTransitionState = "useViewTransitionState";
})(FS || (FS = {}));
var hm;
(function(l) {
  l.UseFetcher = "useFetcher", l.UseFetchers = "useFetchers", l.UseScrollRestoration = "useScrollRestoration";
})(hm || (hm = {}));
function Q1(l) {
  return l + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function dL(l) {
  let u = W.useContext(xA);
  return u || (process.env.NODE_ENV !== "production" ? Mt(!1, Q1(l)) : Mt(!1)), u;
}
function Z1(l, u) {
  let {
    target: T,
    replace: N,
    state: O,
    preventScrollReset: h,
    relative: d,
    unstable_viewTransition: G
  } = u === void 0 ? {} : u, D = PI(), v = UE(), M = BA(l, {
    relative: d
  });
  return W.useCallback((g) => {
    if (F1(g, T)) {
      g.preventDefault();
      let w = N !== void 0 ? N : HS(v) === HS(M);
      D(l, {
        replace: w,
        state: O,
        preventScrollReset: h,
        relative: d,
        unstable_viewTransition: G
      });
    }
  }, [v, D, M, N, O, T, l, h, d, G]);
}
function q1() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $1 = 0, e_ = () => "__" + String(++$1) + "__";
function t_() {
  let {
    router: l
  } = dL(FS.UseSubmit), {
    basename: u
  } = W.useContext(Cl), T = y1();
  return W.useCallback(function(N, O) {
    O === void 0 && (O = {}), q1();
    let {
      action: h,
      method: d,
      encType: G,
      formData: D,
      body: v
    } = V1(N, u);
    if (O.navigate === !1) {
      let M = O.fetcherKey || e_();
      l.fetch(M, T, O.action || h, {
        preventScrollReset: O.preventScrollReset,
        formData: D,
        body: v,
        formMethod: O.method || d,
        formEncType: O.encType || G
      });
    } else
      l.navigate(O.action || h, {
        preventScrollReset: O.preventScrollReset,
        formData: D,
        body: v,
        formMethod: O.method || d,
        formEncType: O.encType || G,
        replace: O.replace,
        state: O.state,
        fromRouteId: T,
        unstable_viewTransition: O.unstable_viewTransition
      });
  }, [l, u, T]);
}
function n_(l, u) {
  let {
    relative: T
  } = u === void 0 ? {} : u, {
    basename: N
  } = W.useContext(Cl), O = W.useContext(yo);
  O || (process.env.NODE_ENV !== "production" ? Mt(!1, "useFormAction must be used inside a RouteContext") : Mt(!1));
  let [h] = O.matches.slice(-1), d = cT({}, BA(l || ".", {
    relative: T
  })), G = UE();
  if (l == null && (d.search = G.search, h.route.index)) {
    let D = new URLSearchParams(d.search);
    D.delete("index"), d.search = D.toString() ? "?" + D.toString() : "";
  }
  return (!l || l === ".") && h.route.index && (d.search = d.search ? d.search.replace(/^\?/, "?index&") : "?index"), N !== "/" && (d.pathname = d.pathname === "/" ? N : os([N, d.pathname])), HS(d);
}
function r_(l, u) {
  u === void 0 && (u = {});
  let T = W.useContext(AL);
  T == null && (process.env.NODE_ENV !== "production" ? Mt(!1, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : Mt(!1));
  let {
    basename: N
  } = dL(FS.useViewTransitionState), O = BA(l, {
    relative: u.relative
  });
  if (!T.isTransitioning)
    return !1;
  let h = DE(T.currentLocation.pathname, N) || T.currentLocation.pathname, d = DE(T.nextLocation.pathname, N) || T.nextLocation.pathname;
  return hI(O.pathname, d) != null || hI(O.pathname, h) != null;
}
const SL = (l) => /* @__PURE__ */ W.createElement("svg", { width: 256, height: 256, viewBox: "0 0 256 256", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: 256, height: 256, fill: "none" }), /* @__PURE__ */ W.createElement("path", { d: "M121.678 68.6777C140.081 50.2742 169.919 50.2742 188.322 68.6777C206.726 87.0811 206.726 116.919 188.322 135.322C169.919 153.726 140.081 153.726 121.678 135.322C120.734 134.378 119.733 133.525 118.686 132.764C108.865 124.59 94.2507 125.11 85.0381 134.322L57.5381 161.822C47.775 171.585 47.775 187.415 57.5381 197.178C67.3012 206.941 83.1303 206.941 92.8934 197.178L104.862 185.209C142.205 207.751 191.449 202.907 223.678 170.678C261.607 132.748 261.607 71.252 223.678 33.3223C185.748 -4.60732 124.252 -4.60732 86.3223 33.3223C77.5523 42.0923 70.7787 52.1712 66.0472 62.9564C60.5003 75.6003 66.2535 90.3468 78.8974 95.8938C91.5413 101.441 106.288 95.6875 111.835 83.0436C114.109 77.8604 117.374 72.9809 121.678 68.6777Z", fill: "currentColor" }), /* @__PURE__ */ W.createElement("path", { d: "M59 224C59 238.359 47.3594 250 33 250C18.6406 250 7 238.359 7 224C7 209.641 18.6406 198 33 198C47.3594 198 59 209.641 59 224Z", fill: "currentColor" }), /* @__PURE__ */ W.createElement("path", { d: "M155 130C170.464 130 183 117.464 183 102C183 86.536 170.464 74 155 74C139.536 74 127 86.536 127 102C127 117.464 139.536 130 155 130Z", fill: "currentColor" }));
function Ii(...l) {
  return l.filter(Boolean).join(" ");
}
function NL(l, u, T = !1) {
  W.useEffect(() => {
    function N(O) {
      T || O.stopPropagation(), l.every((h) => h in O ? O[h] : O.key.toLowerCase() === h.toLowerCase()) && u();
    }
    return window.addEventListener("keyup", N), () => {
      window.removeEventListener("keyup", N);
    };
  }, [l, u, T]);
}
function pL({ tabs: l, nested: u, setOpen: T }) {
  const N = PI(), O = UE();
  return NL(["Escape"], () => {
    T && O.pathname.split("/").length === 2 ? T(!1) : N(-1);
  }), /* @__PURE__ */ m.jsxs("div", { children: [
    /* @__PURE__ */ m.jsxs("div", { className: "sm:hidden", children: [
      /* @__PURE__ */ m.jsx("label", { htmlFor: "tabs", className: "sr-only", children: "Select a tab" }),
      /* @__PURE__ */ m.jsx(
        "select",
        {
          id: "tabs",
          name: "tabs",
          className: "focus:border-primary-500 focus:ring-primary-500 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:outline-none sm:text-sm",
          onChange: (h) => {
            const d = l.find((G) => G.id === h.target.value);
            d && d.onSelect && d.onSelect(), N(`${u ? "" : "/"}${(d == null ? void 0 : d.id) || "not-found"}`);
          },
          children: l.map((h, d) => {
            var G;
            return /* @__PURE__ */ m.jsxs("option", { value: h.id, children: [
              h.title,
              " ",
              (G = h.notificationCount) == null ? void 0 : G.count
            ] }, d);
          })
        }
      )
    ] }),
    /* @__PURE__ */ m.jsx("div", { className: "hidden sm:block", children: /* @__PURE__ */ m.jsx("nav", { className: "border-b-primary-700 flex space-x-8 border-b px-6", "aria-label": "Tabs", children: l.map((h) => {
      var d;
      return /* @__PURE__ */ m.jsxs(
        RL,
        {
          to: `${u ? "" : "/"}${h.id}`,
          replace: !0,
          className: ({ isActive: G }) => Ii(
            G ? "border-primary-200 text-primary-100 [&>.count]:bg-primary-100 [&>.count]:text-primary-600" : "text-primary-400 hover:border-primary-400 hover:text-primary-100 [&>.count]:bg-primary-700 [&>.count]:text-primary-200 border-transparent",
            "-m-y -mx-2 flex whitespace-nowrap border-b-2 px-2 py-3 text-sm font-medium"
          ),
          onClick: () => h.onSelect && h.onSelect(),
          children: [
            h.title,
            h.notificationCount !== void 0 ? /* @__PURE__ */ m.jsx("span", { className: "count ml-3 hidden rounded px-2.5 py-0.5 text-xs font-medium md:inline-block", children: (d = h.notificationCount) == null ? void 0 : d.count }) : null
          ]
        },
        h.id
      );
    }) }) })
  ] });
}
function a_({
  integrations: l,
  integrationData: u,
  setTriggerButtonCount: T,
  setOpen: N
}) {
  const [O, h] = W.useState({ count: 0, severe: !1 }), d = l.map((D) => {
    var v;
    if (D.tabs) {
      const M = ((v = u[D.name]) == null ? void 0 : v.map((g) => g.event)) || [];
      return D.tabs({ processedEvents: M }).map((g) => ({
        ...g,
        processedEvents: M
      }));
    }
    return [];
  }).flat(), G = d.reduce(
    (D, v) => {
      var M, g;
      return {
        count: D.count + (((M = v.notificationCount) == null ? void 0 : M.count) || 0),
        severe: D.severe || ((g = v.notificationCount) == null ? void 0 : g.severe) || !1
      };
    },
    { count: 0, severe: !1 }
  );
  return G.count !== O.count && h(G), W.useEffect(() => {
    T(O);
  }, [O, T]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(pL, { tabs: d, setOpen: N }),
    /* @__PURE__ */ m.jsxs(FA, { children: [
      /* @__PURE__ */ m.jsx(Vi, { path: "/not-found", element: /* @__PURE__ */ m.jsx("p", { children: "Not Found - How'd you manage to get here?" }) }, "not-found"),
      d.map((D) => {
        const v = D.content && D.content;
        return v ? /* @__PURE__ */ m.jsx(
          Vi,
          {
            path: `/${D.id}/*`,
            element: W.createElement(v, { processedEvents: D.processedEvents })
          },
          D.id
        ) : null;
      })
    ] })
  ] });
}
function i_({
  integrations: l,
  isOpen: u,
  setOpen: T,
  integrationData: N,
  isOnline: O,
  setTriggerButtonCount: h
}) {
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: Ii("fullscreen-blur", u ? "" : "!hidden"),
      onClick: (d) => {
        d.target === d.currentTarget && T(!1);
      },
      children: /* @__PURE__ */ m.jsxs("div", { className: "sentry-debugger", children: [
        /* @__PURE__ */ m.jsxs("div", { className: "text-primary-200 flex items-center gap-x-2 px-6 py-4", children: [
          /* @__PURE__ */ m.jsxs("h1", { className: "font-raleway flex flex-1 items-end gap-x-1 leading-7 opacity-80", children: [
            /* @__PURE__ */ m.jsxs("div", { className: "inline-flex items-center gap-x-4", children: [
              /* @__PURE__ */ m.jsx(SL, { height: 32, width: 32 }),
              /* @__PURE__ */ m.jsx("div", { className: "text-3xl font-light uppercase leading-7 tracking-widest", children: "Spotlight" })
            ] }),
            /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex items-center gap-x-1 text-sm", children: [
              /* @__PURE__ */ m.jsx("span", { children: "by" }),
              /* @__PURE__ */ m.jsx("a", { href: "https://sentry.io", target: "_blank", className: "font-semibold hover:underline", children: "Sentry" }),
              /* @__PURE__ */ m.jsxs("a", { href: "https://github.com/getsentry/spotlight", target: "_blank", rel: "me", className: "sl-flex ml-2", children: [
                /* @__PURE__ */ m.jsx("span", { className: "sr-only", children: "GitHub" }),
                /* @__PURE__ */ m.jsx(
                  "svg",
                  {
                    "aria-hidden": "true",
                    className: "astro-6byselsc",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    children: /* @__PURE__ */ m.jsx("path", { d: "M12 .3a12 12 0 0 0-3.8 23.38c.6.12.83-.26.83-.57L9 21.07c-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.08-.74.09-.73.09-.73 1.2.09 1.83 1.24 1.83 1.24 1.08 1.83 2.81 1.3 3.5 1 .1-.78.42-1.31.76-1.61-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.14-.3-.54-1.52.1-3.18 0 0 1-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.28-1.55 3.29-1.23 3.29-1.23.64 1.66.24 2.88.12 3.18a4.65 4.65 0 0 1 1.23 3.22c0 4.61-2.8 5.63-5.48 5.92.42.36.81 1.1.81 2.22l-.01 3.29c0 .31.2.69.82.57A12 12 0 0 0 12 .3Z" })
                  }
                )
              ] }),
              /* @__PURE__ */ m.jsxs(
                "div",
                {
                  className: Ii("ml-2 flex items-center gap-x-2 pl-2 text-xs", O ? "" : "text-red-400"),
                  children: [
                    /* @__PURE__ */ m.jsx(
                      "div",
                      {
                        className: Ii(
                          " block h-2 w-2 rounded-full",
                          O ? "bg-green-400" : "animate-pulse bg-red-400"
                        )
                      }
                    ),
                    O ? "Connected to Sidecar" : "Not connected to Sidecar"
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ m.jsx(
            "button",
            {
              className: "hover:bg-primary-900 -my-1 -mr-3 cursor-pointer rounded px-3 py-1 font-mono text-2xl",
              onClick: () => {
                T(!1);
              },
              children: "✕"
            }
          )
        ] }),
        /* @__PURE__ */ m.jsx(
          a_,
          {
            integrations: l,
            integrationData: N,
            setTriggerButtonCount: h,
            setOpen: T
          }
        )
      ] })
    }
  );
}
const o_ = "http://localhost:8969/stream", mI = {
  "sentry:focus-local-events": !0
}, OL = "bottomRight";
function l_(l) {
  switch (l) {
    case "centerRight":
      return "bottom-[45%] right-4";
    case "centerLeft":
      return "bottom-[45%] left-4";
    case "topLeft":
      return "top-4 left-4";
    case "topRight":
      return "top-4 right-4";
    case "bottomLeft":
      return "bottom-4 left-4";
    case "bottomRight":
    default:
      return "bottom-4 right-4";
  }
}
function s_({
  count: l,
  children: u,
  severe: T = !1,
  ...N
}) {
  return /* @__PURE__ */ m.jsxs("div", { className: "gap-x hover:bg-primary-400 relative flex items-center rounded p-3", ...N, children: [
    u,
    !!l && /* @__PURE__ */ m.jsx(
      "span",
      {
        className: Ii(
          T ? "bg-red-500" : "bg-primary-500",
          "absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full font-sans text-[0.65rem] font-medium"
        ),
        children: l
      }
    )
  ] });
}
function u_({
  isOpen: l,
  setOpen: u,
  notificationCount: T,
  anchor: N = OL
}) {
  const O = T.count, h = 24;
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: Ii(
        "z-[999999]",
        "fixed inline-flex items-center rounded font-medium",
        "font-raleway bg-primary-700 cursor-pointer text-white",
        "flex-col",
        l_(N),
        l ? "!hidden" : ""
      ),
      title: "Spotlight by Sentry",
      onClick: () => u(!l),
      children: /* @__PURE__ */ m.jsx(s_, { count: O, severe: !!T.severe, children: /* @__PURE__ */ m.jsx(SL, { height: h, width: h }) })
    }
  );
}
const E_ = new EventTarget();
function uu() {
  if (typeof window > "u")
    return E_;
  const l = window;
  return l.__spotlight || (l.__spotlight = {}), l.__spotlight.eventTarget || (l.__spotlight.eventTarget = new EventTarget()), l.__spotlight.eventTarget;
}
let IL = !1;
function c_() {
  IL = !0;
}
function Qr(...l) {
  IL && console.log("🔎 [Spotlight]", ...l);
}
function T_(l, u, T, N) {
  Qr("Connecting to sidecar at", l);
  const O = new EventSource(l), h = [];
  for (const [d, G] of u.entries()) {
    const D = (v) => {
      Qr(`Received new ${d} event`), G.forEach((M) => {
        if (M.processEvent) {
          const g = M.processEvent({
            contentType: d,
            data: v.data
          });
          g && T((w) => {
            const Y = M.name;
            return {
              ...w,
              [Y]: [...w[Y] || [], g]
            };
          });
        }
      });
    };
    Qr("Adding listener for", d, "sum", h.length), h.push([d, D]), O.addEventListener(d, D);
  }
  return O.addEventListener("open", () => {
    N(!0), Qr("Open");
  }), O.addEventListener("error", (d) => {
    N(!1), console.error("EventSource failed:", d);
  }), () => {
    Qr(`Removing ${h.length} listeners`), h.forEach((d) => {
      O.removeEventListener(d[0], d[1]), Qr("Removed listener for type", d[0]);
    });
  };
}
function f_({
  openOnInit: l = !1,
  showTriggerButton: u = !0,
  integrations: T = [],
  sidecarUrl: N,
  anchor: O
}) {
  Qr("App rerender");
  const [h, d] = W.useState({}), [G, D] = W.useState(!1), [v, M] = W.useState({ count: 0, severe: !1 }), [g, w] = W.useState(l);
  NL(["ctrlKey", "F12"], () => {
    w((oe) => !oe);
  }), W.useEffect(() => {
    const oe = /* @__PURE__ */ new Map();
    T.forEach(
      (Le) => {
        var Oe;
        return (Oe = Le.forwardedContentType) == null ? void 0 : Oe.forEach((he) => {
          const Fe = oe.get(he) || [];
          Fe.push(Le), oe.set(he, Fe);
        });
      }
    );
    const me = T_(N, oe, d, D);
    return () => {
      Qr("useEffect cleanup"), me();
    };
  }, [T, N]);
  const Y = uu(), j = PI();
  return W.useEffect(() => {
    const oe = (Oe) => {
      Qr("Open"), w(!0), Oe.detail.path && j(Oe.detail.path);
    }, me = () => {
      Qr("Close"), w(!1);
    }, Le = (Oe) => {
      Qr("Navigate"), j(Oe.detail);
    };
    return Y.addEventListener("open", oe), Y.addEventListener("close", me), Y.addEventListener("navigate", Le), () => {
      Y.removeEventListener("open", oe), Y.removeEventListener("close", me), Y.removeEventListener("navigate", Le);
    };
  }, [Y, j]), W.useEffect(() => {
    g ? (Y.dispatchEvent(new CustomEvent("opened")), document.body.style.overflow = "hidden") : (Y.dispatchEvent(new CustomEvent("closed")), document.body.style.overflow = "auto");
  }, [g, Y]), W.useEffect(() => {
    v.severe && Y.dispatchEvent(
      new CustomEvent("severeEventCount", { detail: { count: v.count } })
    );
  }, [v, Y]), Qr("Integration data:", h), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    u && /* @__PURE__ */ m.jsx(u_, { isOpen: g, setOpen: w, notificationCount: v, anchor: O }),
    /* @__PURE__ */ m.jsx(
      i_,
      {
        isOpen: g,
        setOpen: w,
        isOnline: G,
        integrations: T,
        integrationData: h,
        setTriggerButtonCount: M
      }
    )
  ] });
}
const A_ = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.-right-2{right:-.5rem}.-top-2{top:-.5rem}.bottom-0{bottom:0}.bottom-4{bottom:1rem}.bottom-\\[45\\%\\]{bottom:45%}.left-1\\/4{left:25%}.left-4{left:1rem}.right-0{right:0}.right-4{right:1rem}.top-0{top:0}.top-4{top:1rem}.z-\\[999999\\]{z-index:999999}.-m-0{margin:-0px}.-m-0\\.5{margin:-.125rem}.-m-2{margin:-.5rem}.-mx-2{margin-left:-.5rem;margin-right:-.5rem}.-my-1{margin-top:-.25rem;margin-bottom:-.25rem}.-mr-3{margin-right:-.75rem}.mb-2{margin-bottom:.5rem}.mb-4{margin-bottom:1rem}.ml-2{margin-left:.5rem}.ml-3{margin-left:.75rem}.ml-4{margin-left:1rem}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.\\!hidden{display:none!important}.hidden{display:none}.h-2{height:.5rem}.h-5{height:1.25rem}.h-8{height:2rem}.h-full{height:100%}.w-1\\/12{width:8.333333%}.w-16{width:4rem}.w-2{width:.5rem}.w-48{width:12rem}.w-5{width:1.25rem}.w-full{width:100%}.max-w-full{max-width:100%}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-none{flex:none}.grow{flex-grow:1}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}.cursor-pointer{cursor:pointer}.grid-cols-2-auto{grid-template-columns:minmax(auto,max-content) 1fr}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-center{justify-content:center}.gap-2{gap:.5rem}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}.space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(2rem * var(--tw-space-x-reverse));margin-left:calc(2rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}.divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse: 0;border-right-width:calc(1px * var(--tw-divide-x-reverse));border-left-width:calc(1px * calc(1 - var(--tw-divide-x-reverse)))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-primary-800>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(55 48 163 / var(--tw-divide-opacity))}.divide-primary-900>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(49 46 129 / var(--tw-divide-opacity))}.overflow-auto{overflow:auto}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.whitespace-nowrap{white-space:nowrap}.whitespace-pre-line{white-space:pre-line}.whitespace-pre-wrap{white-space:pre-wrap}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-md{border-radius:.375rem}.rounded-r-full{border-top-right-radius:9999px;border-bottom-right-radius:9999px}.border{border-width:1px}.border-y{border-top-width:1px;border-bottom-width:1px}.\\!border-t-0{border-top-width:0px!important}.border-b{border-bottom-width:1px}.border-b-2{border-bottom-width:2px}.border-l{border-left-width:1px}.border-gray-300{--tw-border-opacity: 1;border-color:rgb(209 213 219 / var(--tw-border-opacity))}.border-primary-200{--tw-border-opacity: 1;border-color:rgb(199 210 254 / var(--tw-border-opacity))}.border-primary-300{--tw-border-opacity: 1;border-color:rgb(165 180 252 / var(--tw-border-opacity))}.border-primary-500{--tw-border-opacity: 1;border-color:rgb(99 102 241 / var(--tw-border-opacity))}.border-primary-600{--tw-border-opacity: 1;border-color:rgb(79 70 229 / var(--tw-border-opacity))}.border-primary-800{--tw-border-opacity: 1;border-color:rgb(55 48 163 / var(--tw-border-opacity))}.border-primary-900{--tw-border-opacity: 1;border-color:rgb(49 46 129 / var(--tw-border-opacity))}.border-primary-950{--tw-border-opacity: 1;border-color:rgb(30 27 75 / var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-b-primary-400{--tw-border-opacity: 1;border-bottom-color:rgb(129 140 248 / var(--tw-border-opacity))}.border-b-primary-700{--tw-border-opacity: 1;border-bottom-color:rgb(67 56 202 / var(--tw-border-opacity))}.border-l-primary-400{--tw-border-opacity: 1;border-left-color:rgb(129 140 248 / var(--tw-border-opacity))}.bg-green-400{--tw-bg-opacity: 1;background-color:rgb(74 222 128 / var(--tw-bg-opacity))}.bg-primary-500{--tw-bg-opacity: 1;background-color:rgb(99 102 241 / var(--tw-bg-opacity))}.bg-primary-600{--tw-bg-opacity: 1;background-color:rgb(79 70 229 / var(--tw-bg-opacity))}.bg-primary-700{--tw-bg-opacity: 1;background-color:rgb(67 56 202 / var(--tw-bg-opacity))}.bg-primary-800{--tw-bg-opacity: 1;background-color:rgb(55 48 163 / var(--tw-bg-opacity))}.bg-primary-900{--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity))}.bg-primary-950{--tw-bg-opacity: 1;background-color:rgb(30 27 75 / var(--tw-bg-opacity))}.bg-red-400{--tw-bg-opacity: 1;background-color:rgb(248 113 113 / var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity: 1;background-color:rgb(239 68 68 / var(--tw-bg-opacity))}.bg-gradient-to-br{background-image:linear-gradient(to bottom right,var(--tw-gradient-stops))}.from-primary-900{--tw-gradient-from: #312e81 var(--tw-gradient-from-position);--tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)}.to-primary-950{--tw-gradient-to: #1e1b4b var(--tw-gradient-to-position)}.to-20\\%{--tw-gradient-to-position: 20%}.p-0{padding:0}.p-0\\.5{padding:.125rem}.p-1{padding:.25rem}.p-2{padding:.5rem}.p-3{padding:.75rem}.p-4{padding:1rem}.p-6{padding:1.5rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-4{padding-bottom:1rem}.pb-6{padding-bottom:1.5rem}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pl-4{padding-left:1rem}.pr-10{padding-right:2.5rem}.pr-4{padding-right:1rem}.pt-2{padding-top:.5rem}.text-left{text-align:left}.text-right{text-align:right}.\\!font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace!important}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.font-raleway{font-family:Raleway,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.font-sans{font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-\\[0\\.65rem\\]{font-size:.65rem}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.leading-7{line-height:1.75rem}.tracking-widest{letter-spacing:.1em}.text-green-400{--tw-text-opacity: 1;color:rgb(74 222 128 / var(--tw-text-opacity))}.text-orange-400{--tw-text-opacity: 1;color:rgb(251 146 60 / var(--tw-text-opacity))}.text-primary-100{--tw-text-opacity: 1;color:rgb(224 231 255 / var(--tw-text-opacity))}.text-primary-200{--tw-text-opacity: 1;color:rgb(199 210 254 / var(--tw-text-opacity))}.text-primary-300{--tw-text-opacity: 1;color:rgb(165 180 252 / var(--tw-text-opacity))}.text-primary-400{--tw-text-opacity: 1;color:rgb(129 140 248 / var(--tw-text-opacity))}.text-primary-500{--tw-text-opacity: 1;color:rgb(99 102 241 / var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248 113 113 / var(--tw-text-opacity))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.text-yellow-400{--tw-text-opacity: 1;color:rgb(250 204 21 / var(--tw-text-opacity))}.underline{text-decoration-line:underline}.opacity-80{opacity:.8}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.fullscreen-blur{position:fixed;display:flex;height:100vh;width:100vw;flex-direction:column;overflow:auto;background-color:rgb(0 0 0 / var(--tw-bg-opacity));--tw-bg-opacity: .5;--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);z-index:999998;padding:2.5vh}.sentry-debugger{display:flex;height:100%;flex-direction:column;overflow:auto;overflow-x:hidden;border-radius:.5rem;background-image:linear-gradient(to bottom right,var(--tw-gradient-stops));--tw-gradient-from: #312e81 var(--tw-gradient-from-position);--tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);--tw-gradient-to: #1e1b4b var(--tw-gradient-to-position);--tw-gradient-to-position: 20%;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity));--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}ul.tree{position:relative}ul.tree ul.tree{position:static}ul.tree,ul.tree ul{list-style:none;margin:0;padding:0}ul.tree ul{margin-left:8px}ul.tree li{border-left-width:1px;--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}ul.tree li:last-child{border-width:0px}ul.tree>li:first-child:before{display:none}ul.tree>li:before,ul.tree ul.tree>li:before{border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity));position:absolute;margin-top:-2px;height:15px;width:12px;content:"";display:inline-block;margin-left:-16px}ul.tree li:last-child:before{border-left-width:1px;--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}.tree .node{display:flex;width:65%;align-items:center;-moz-column-gap:.25rem;column-gap:.25rem;overflow:auto;padding-top:.25rem;padding-bottom:.25rem;padding-left:.25rem}.tree .waterfall{position:absolute;left:45%;right:0;height:1.75rem;border-left-width:1px;--tw-border-opacity: 1;border-left-color:rgb(55 48 163 / var(--tw-border-opacity));--tw-bg-opacity: 1;background-color:rgb(30 27 75 / var(--tw-bg-opacity));padding-top:.25rem;padding-bottom:.25rem;padding-left:.25rem}.table-values{border-collapse:collapse;--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity));font-size:.875rem;line-height:1.25rem}.table-values tbody th{width:8.333333%;border-top-width:1px;border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(30 27 75 / var(--tw-border-opacity));padding:.25rem .5rem;text-align:right;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-weight:400;--tw-text-opacity: 1;color:rgb(165 180 252 / var(--tw-text-opacity))}.table-values tbody td{border-top-width:1px;border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(30 27 75 / var(--tw-border-opacity));padding:.25rem .5rem}.last\\:border-b-0:last-child{border-bottom-width:0px}.hover\\:border-primary-400:hover{--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}.hover\\:border-primary-700:hover{--tw-border-opacity: 1;border-color:rgb(67 56 202 / var(--tw-border-opacity))}.hover\\:bg-primary-400:hover{--tw-bg-opacity: 1;background-color:rgb(129 140 248 / var(--tw-bg-opacity))}.hover\\:bg-primary-800:hover{--tw-bg-opacity: 1;background-color:rgb(55 48 163 / var(--tw-bg-opacity))}.hover\\:bg-primary-900:hover{--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity))}.hover\\:text-primary-100:hover{--tw-text-opacity: 1;color:rgb(224 231 255 / var(--tw-text-opacity))}.hover\\:underline:hover{text-decoration-line:underline}.focus\\:border-primary-500:focus{--tw-border-opacity: 1;border-color:rgb(99 102 241 / var(--tw-border-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-primary-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity))}@media (min-width: 640px){.sm\\:block{display:block}.sm\\:hidden{display:none}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}}@media (min-width: 768px){.md\\:inline-block{display:inline-block}}.\\[\\&\\>\\.count\\]\\:bg-primary-100>.count{--tw-bg-opacity: 1;background-color:rgb(224 231 255 / var(--tw-bg-opacity))}.\\[\\&\\>\\.count\\]\\:bg-primary-700>.count{--tw-bg-opacity: 1;background-color:rgb(67 56 202 / var(--tw-bg-opacity))}.\\[\\&\\>\\.count\\]\\:text-primary-200>.count{--tw-text-opacity: 1;color:rgb(199 210 254 / var(--tw-text-opacity))}.\\[\\&\\>\\.count\\]\\:text-primary-600>.count{--tw-text-opacity: 1;color:rgb(79 70 229 / var(--tw-text-opacity))}
`;
async function CL(l = [], u) {
  if (!l)
    return [[], []];
  const T = [], N = [];
  for (const O of l)
    if (Array.isArray(O)) {
      const h = await CL(O, u);
      T.push(...h[0]), N.push(...h[1]);
    } else if (O) {
      if (O.setup) {
        const h = await O.setup(u);
        h && N.push(h);
      }
      T.push(O);
    }
  return [T, N];
}
function vm() {
  let l = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(u) {
    let T = Math.random() * 16;
    return T = (l + T) % 16 | 0, l = Math.floor(l / 16), (u === "x" ? T : T & 3 | 8).toString(16);
  });
}
function hL(l) {
  return l.includes("javascript.astro") ? "javascript.astro" : l.includes("javascript") ? "javascript" : l.includes("python") ? "python" : l.includes("php") ? "php" : l.includes("ruby") ? "ruby" : "unknown";
}
function R_(l) {
  const u = [], T = /* @__PURE__ */ new Map(), N = [...l].sort((O) => O.parent_span_id ? 1 : 0);
  return N.forEach((O) => {
    let h = d_(O, T, N);
    if (O.children || (O.children = []), h)
      h.children || (h.children = []), h.children.push(O);
    else if (O.parent_span_id) {
      const d = N.find((G) => !G.parent_span_id);
      Qr(d ? `Creating orphan for parent (${O.parent_span_id}) for span (${O.span_id})` : `Root span (${O.parent_span_id}) for span (${O.span_id}). Creating orphan.`), h = {
        trace_id: O.trace_id,
        span_id: O.parent_span_id,
        parent_span_id: d ? d.span_id : null,
        op: "orphan",
        description: "missing or unknown parent span",
        children: [O],
        start_timestamp: O.start_timestamp,
        timestamp: O.timestamp,
        status: "unknown"
      }, T.set(h.span_id, h), d ? (d.children || (d.children = []), d.children.push(h)) : u.push(h);
    } else
      u.push(O);
    T.set(O.span_id, O);
  }), u;
}
function d_(l, u, T) {
  if (l.parent_span_id)
    return u.has(l.parent_span_id) ? u.get(l.parent_span_id) : T.find((N) => N.span_id === l.parent_span_id);
}
function US(l) {
  return typeof l == "string" ? new Date(l).getTime() : l * 1e3;
}
class S_ {
  constructor(u = []) {
    Yn(this, "events", []);
    Yn(this, "eventIds", /* @__PURE__ */ new Set());
    Yn(this, "sdks", []);
    Yn(this, "traces", []);
    Yn(this, "tracesById", {});
    Yn(this, "localTraceIds", /* @__PURE__ */ new Set());
    Yn(this, "subscribers", /* @__PURE__ */ new Map());
    u.forEach((T) => this.pushEvent(T));
  }
  inferSdkFromEvent(u) {
    const T = {
      name: "unknown",
      version: "unknown",
      lastSeen: (/* @__PURE__ */ new Date()).getTime()
    };
    return u.sdk ? (T.name = u.sdk.name || T.name, T.version = u.sdk.version || T.version) : u.platform && (T.name = u.platform), T;
  }
  pushEnvelope(u) {
    const [T, N] = u;
    let O;
    T.sdk && T.sdk.name && T.sdk.version ? O = {
      name: T.sdk.name,
      version: T.sdk.version,
      lastSeen: new Date(T.sent_at).getTime()
    } : O = this.inferSdkFromEvent(N[0][1]);
    const h = this.sdks.find((d) => d.name === O.name && d.version === O.version);
    h ? h.lastSeen = new Date(T.sent_at).getTime() : this.sdks.push({
      name: O.name,
      version: O.version,
      lastSeen: new Date(T.sent_at).getTime()
    }), N.forEach(([d, G]) => {
      (d.type === "event" || d.type === "transaction") && (G.platform = hL(O.name), this.pushEvent(G));
    });
  }
  pushEvent(u) {
    var N;
    if (u.event_id || (u.event_id = vm()), this.eventIds.has(u.event_id))
      return;
    N_(u) && p_(u), u.timestamp = US(u.timestamp), u.start_timestamp && (u.start_timestamp = US(u.start_timestamp));
    const T = (N = u.contexts) == null ? void 0 : N.trace;
    if (this.events.push(u), T) {
      const O = this.tracesById[T.trace_id], h = u.start_timestamp ? u.start_timestamp : (/* @__PURE__ */ new Date()).getTime(), d = O ?? {
        ...T,
        spans: [],
        transactions: [],
        errors: 0,
        timestamp: u.timestamp,
        start_timestamp: h,
        status: T.status,
        rootTransactionName: u.transaction || "(unknown transaction)",
        rootTransaction: null
      };
      if (u.type === "transaction") {
        d.transactions.push(u), d.transactions.sort((v, M) => v.start_timestamp - M.start_timestamp);
        const D = [];
        d.transactions.forEach((v) => {
          D.push(
            {
              ...v.contexts.trace,
              start_timestamp: v.start_timestamp,
              timestamp: v.timestamp,
              description: T.description || v.transaction,
              transaction: v
            },
            ...v.spans.map((M) => ({
              ...M,
              timestamp: US(M.timestamp),
              start_timestamp: US(M.start_timestamp)
            }))
          );
        }), d.spans = D, d.spanTree = R_(d.spans);
      } else
        d.errors += 1;
      d.start_timestamp = Math.min(h, d.start_timestamp), d.timestamp = Math.max(u.timestamp, d.timestamp), T.status !== "ok" && (d.status = T.status);
      const G = d.transactions.filter((D) => !D.contexts.trace.parent_span_id);
      G.length === 1 ? (d.rootTransaction = G[0], d.rootTransactionName = G[0].transaction || "(unknown transaction)") : G.length > 1 ? d.rootTransactionName = "(multiple root transactions)" : d.rootTransactionName = "(missing root transaction)", O || (this.traces.unshift(d), this.tracesById[d.trace_id] = d), this.subscribers.forEach(([D, v]) => D === "trace" && v(d));
    }
    this.subscribers.forEach(([O, h]) => O === "event" && h(u)), this.eventIds.add(u.event_id);
  }
  getEvents() {
    return [...this.events];
  }
  getTraces() {
    return [...this.traces];
  }
  getSdks() {
    return [...this.sdks];
  }
  getEventById(u) {
    return this.events.find((T) => T.event_id === u);
  }
  getTraceById(u) {
    return this.tracesById[u];
  }
  getEventsByTrace(u, T) {
    return this.events.filter(
      (N) => {
        var O, h, d, G;
        return ((h = (O = N.contexts) == null ? void 0 : O.trace) == null ? void 0 : h.trace_id) === u && (!T || ((G = (d = N.contexts) == null ? void 0 : d.trace) == null ? void 0 : G.span_id) === T);
      }
    );
  }
  getSpanById(u, T) {
    const N = this.tracesById[u];
    if (N)
      return N.spans.find((O) => O.span_id === T);
  }
  subscribe(...u) {
    const T = vm();
    return this.subscribers.set(T, u), () => {
      this.subscribers.delete(T);
    };
  }
  /**
   * Mark a traceId as being seen in the local session.
   *
   * @param traceId
   */
  trackLocalTrace(u) {
    this.localTraceIds.add(u);
  }
  /**
   * Determine if a traceId was seen in the local session.
   *
   * A result of `null` means "unknown", which implies there is no known
   * information about any session-initiated traces.
   */
  isTraceLocal(u) {
    return this.localTraceIds.has(u) ? !0 : this.localTraceIds.size > 0 ? !1 : null;
  }
}
const pa = new S_();
function N_(l) {
  return l.type != "transaction";
}
function p_(l) {
  !l.exception || !l.exception.values || l.platform && (l.platform.includes("php") || l.platform.includes("python")) || l.exception.values.forEach((u) => {
    u.stacktrace && u.stacktrace.frames.reverse();
  });
}
const vL = Object.prototype.toString;
function O_(l) {
  switch (vL.call(l)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return WS(l, Error);
  }
}
function mL(l, u) {
  return vL.call(l) === `[object ${u}]`;
}
function I_(l) {
  return mL(l, "String");
}
function C_(l) {
  return mL(l, "Object");
}
function h_(l) {
  return typeof Event < "u" && WS(l, Event);
}
function v_(l) {
  return typeof Element < "u" && WS(l, Element);
}
function m_(l) {
  return C_(l) && "nativeEvent" in l && "preventDefault" in l && "stopPropagation" in l;
}
function L_(l) {
  return typeof l == "number" && l !== l;
}
function WS(l, u) {
  try {
    return l instanceof u;
  } catch {
    return !1;
  }
}
function y_(l) {
  return !!(typeof l == "object" && l !== null && (l.__isVue || l._isVue));
}
function _S(l) {
  return l && l.Math == Math ? l : void 0;
}
const D_ = typeof globalThis == "object" && _S(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && _S(window) || typeof self == "object" && _S(self) || typeof global == "object" && _S(global) || function() {
  return this;
}() || {};
function g_() {
  return D_;
}
g_();
const P_ = 80;
function M_(l, u = {}) {
  if (!l)
    return "<unknown>";
  try {
    let T = l;
    const N = 5, O = [];
    let h = 0, d = 0;
    const G = " > ", D = G.length;
    let v;
    const M = Array.isArray(u) ? u : u.keyAttrs, g = !Array.isArray(u) && u.maxStringLength || P_;
    for (; T && h++ < N && (v = U_(T, M), !(v === "html" || h > 1 && d + O.length * D + v.length >= g)); )
      O.push(v), d += v.length, T = T.parentNode;
    return O.reverse().join(G);
  } catch {
    return "<unknown>";
  }
}
function U_(l, u) {
  const T = l, N = [];
  let O, h, d, G, D;
  if (!T || !T.tagName)
    return "";
  N.push(T.tagName.toLowerCase());
  const v = u && u.length ? u.filter((g) => T.getAttribute(g)).map((g) => [g, T.getAttribute(g)]) : null;
  if (v && v.length)
    v.forEach((g) => {
      N.push(`[${g[0]}="${g[1]}"]`);
    });
  else if (T.id && N.push(`#${T.id}`), O = T.className, O && I_(O))
    for (h = O.split(/\s+/), D = 0; D < h.length; D++)
      N.push(`.${h[D]}`);
  const M = ["aria-label", "type", "name", "title", "alt"];
  for (D = 0; D < M.length; D++)
    d = M[D], G = T.getAttribute(d), G && N.push(`[${d}="${G}"]`);
  return N.join("");
}
function __(l) {
  if (O_(l))
    return {
      message: l.message,
      name: l.name,
      stack: l.stack,
      ...Lm(l)
    };
  if (h_(l)) {
    const u = {
      type: l.type,
      target: mm(l.target),
      currentTarget: mm(l.currentTarget),
      ...Lm(l)
    };
    return typeof CustomEvent < "u" && WS(l, CustomEvent) && (u.detail = l.detail), u;
  } else
    return l;
}
function mm(l) {
  try {
    return v_(l) ? M_(l) : Object.prototype.toString.call(l);
  } catch {
    return "<unknown>";
  }
}
function Lm(l) {
  if (typeof l == "object" && l !== null) {
    const u = {};
    for (const T in l)
      Object.prototype.hasOwnProperty.call(l, T) && (u[T] = l[T]);
    return u;
  } else
    return {};
}
const RI = "<anonymous>";
function G_(l) {
  try {
    return !l || typeof l != "function" ? RI : l.name || RI;
  } catch {
    return RI;
  }
}
function x_() {
  const l = typeof WeakSet == "function", u = l ? /* @__PURE__ */ new WeakSet() : [];
  function T(O) {
    if (l)
      return u.has(O) ? !0 : (u.add(O), !1);
    for (let h = 0; h < u.length; h++)
      if (u[h] === O)
        return !0;
    return u.push(O), !1;
  }
  function N(O) {
    if (l)
      u.delete(O);
    else
      for (let h = 0; h < u.length; h++)
        if (u[h] === O) {
          u.splice(h, 1);
          break;
        }
  }
  return [T, N];
}
function b_(l, u = 100, T = 1 / 0) {
  try {
    return LI("", l, u, T);
  } catch (N) {
    return { ERROR: `**non-serializable** (${N})` };
  }
}
function LI(l, u, T = 1 / 0, N = 1 / 0, O = x_()) {
  const [h, d] = O;
  if (u == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof u) && !L_(u))
    return u;
  const G = H_(l, u);
  if (!G.startsWith("[object "))
    return G;
  if (u.__sentry_skip_normalization__)
    return u;
  const D = typeof u.__sentry_override_normalization_depth__ == "number" ? u.__sentry_override_normalization_depth__ : T;
  if (D === 0)
    return G.replace("object ", "");
  if (h(u))
    return "[Circular ~]";
  const v = u;
  if (v && typeof v.toJSON == "function")
    try {
      const Y = v.toJSON();
      return LI("", Y, D - 1, N, O);
    } catch {
    }
  const M = Array.isArray(u) ? [] : {};
  let g = 0;
  const w = __(u);
  for (const Y in w) {
    if (!Object.prototype.hasOwnProperty.call(w, Y))
      continue;
    if (g >= N) {
      M[Y] = "[MaxProperties ~]";
      break;
    }
    const j = w[Y];
    M[Y] = LI(Y, j, D - 1, N, O), g++;
  }
  return d(u), M;
}
function H_(l, u) {
  try {
    if (l === "domain" && u && typeof u == "object" && u._events)
      return "[Domain]";
    if (l === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && u === global)
      return "[Global]";
    if (typeof window < "u" && u === window)
      return "[Window]";
    if (typeof document < "u" && u === document)
      return "[Document]";
    if (y_(u))
      return "[VueViewModel]";
    if (m_(u))
      return "[SyntheticEvent]";
    if (typeof u == "number" && u !== u)
      return "[NaN]";
    if (typeof u == "function")
      return `[Function: ${G_(u)}]`;
    if (typeof u == "symbol")
      return `[${String(u)}]`;
    if (typeof u == "bigint")
      return `[BigInt: ${String(u)}]`;
    const T = B_(u);
    return /^HTML(\w*)Element$/.test(T) ? `[HTMLElement: ${T}]` : `[object ${T}]`;
  } catch (T) {
    return `**non-serializable** (${T})`;
  }
}
function B_(l) {
  const u = Object.getPrototypeOf(l);
  return u ? u.constructor.name : "null prototype";
}
function ym(l, u) {
  return (u || new TextEncoder()).encode(l);
}
function F_(l, u) {
  const [T, N] = l;
  let O = JSON.stringify(T);
  function h(d) {
    typeof O == "string" ? O = typeof d == "string" ? O + d : [ym(O, u), d] : O.push(typeof d == "string" ? ym(d, u) : d);
  }
  for (const d of N) {
    const [G, D] = d;
    if (h(`
${JSON.stringify(G)}
`), typeof D == "string" || D instanceof Uint8Array)
      h(D);
    else {
      let v;
      try {
        v = JSON.stringify(D);
      } catch {
        v = JSON.stringify(b_(D));
      }
      h(v);
    }
  }
  return typeof O == "string" ? O : w_(O);
}
function w_(l) {
  const u = l.reduce((O, h) => O + h.length, 0), T = new Uint8Array(u);
  let N = 0;
  for (const O of l)
    T.set(O, N), N += O.length;
  return T;
}
class Y_ {
  constructor(u) {
    Yn(this, "name", "DevServerContextLines");
    Yn(this, "_sidecarUrl");
    this._sidecarUrl = (u == null ? void 0 : u.sidecarUrl) ?? "http://localhost:8969/stream", Qr("Using Sidecar URL", this._sidecarUrl);
  }
  setupOnce(u, T) {
    u(async (O) => {
      var d, G;
      const h = (G = (d = O.contexts) == null ? void 0 : d.trace) == null ? void 0 : G.trace_id;
      if (h && pa.trackLocalTrace(h), O.type || !O.exception || !O.exception.values)
        return O;
      for (const D of O.exception.values ?? [])
        try {
          const v = await fetch("/spotlight/contextlines", {
            method: "PUT",
            body: JSON.stringify(D.stacktrace)
          });
          if (!v.ok || v.status !== 200)
            continue;
          const M = await v.json();
          D.stacktrace = M;
        } catch {
        }
      return O;
    });
    const N = T().getClient();
    N && V_(N, this._sidecarUrl);
  }
}
function V_(l, u) {
  l == null || l.setupIntegrations(!0), l.on && (l == null || l.on("beforeEnvelope", (T) => {
    fetch(u, {
      method: "POST",
      body: F_(T),
      headers: {
        "Content-Type": "application/x-sentry-envelope"
      },
      mode: "cors"
    }).catch((N) => {
      console.error(
        "Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/",
        N
      );
    });
  }));
}
const LL = W.createContext({
  open: () => {
  },
  close: () => {
  },
  experiments: mI
}), W_ = ({ children: l, context: u }) => /* @__PURE__ */ m.jsx(LL.Provider, { value: u, children: l }), yL = () => W.useContext(LL);
function DL(l) {
  return /* @__PURE__ */ m.jsx("span", { className: "bg-primary-800 inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium", ...l });
}
function xI(l) {
  return /* @__PURE__ */ m.jsx("div", { className: "divide-primary-900 border-primary-900 bg-primary-950 divide-y border-y", ...l });
}
var gL = { exports: {} };
(function(l, u) {
  (function(T, N) {
    l.exports = N();
  })(YS, function() {
    var T = 1e3, N = 6e4, O = 36e5, h = "millisecond", d = "second", G = "minute", D = "hour", v = "day", M = "week", g = "month", w = "quarter", Y = "year", j = "date", oe = "Invalid Date", me = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Le = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, Oe = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(Se) {
      var le = ["th", "st", "nd", "rd"], ce = Se % 100;
      return "[" + Se + (le[(ce - 20) % 10] || le[ce] || le[0]) + "]";
    } }, he = function(Se, le, ce) {
      var ve = String(Se);
      return !ve || ve.length >= le ? Se : "" + Array(le + 1 - ve.length).join(ce) + Se;
    }, Fe = { s: he, z: function(Se) {
      var le = -Se.utcOffset(), ce = Math.abs(le), ve = Math.floor(ce / 60), ee = ce % 60;
      return (le <= 0 ? "+" : "-") + he(ve, 2, "0") + ":" + he(ee, 2, "0");
    }, m: function Se(le, ce) {
      if (le.date() < ce.date())
        return -Se(ce, le);
      var ve = 12 * (ce.year() - le.year()) + (ce.month() - le.month()), ee = le.clone().add(ve, g), te = ce - ee < 0, Ae = le.clone().add(ve + (te ? -1 : 1), g);
      return +(-(ve + (ce - ee) / (te ? ee - Ae : Ae - ee)) || 0);
    }, a: function(Se) {
      return Se < 0 ? Math.ceil(Se) || 0 : Math.floor(Se);
    }, p: function(Se) {
      return { M: g, y: Y, w: M, d: v, D: j, h: D, m: G, s: d, ms: h, Q: w }[Se] || String(Se || "").toLowerCase().replace(/s$/, "");
    }, u: function(Se) {
      return Se === void 0;
    } }, ye = "en", je = {};
    je[ye] = Oe;
    var Xe = function(Se) {
      return Se instanceof gt;
    }, yt = function Se(le, ce, ve) {
      var ee;
      if (!le)
        return ye;
      if (typeof le == "string") {
        var te = le.toLowerCase();
        je[te] && (ee = te), ce && (je[te] = ce, ee = te);
        var Ae = le.split("-");
        if (!ee && Ae.length > 1)
          return Se(Ae[0]);
      } else {
        var U = le.name;
        je[U] = le, ee = U;
      }
      return !ve && ee && (ye = ee), ee || !ve && ye;
    }, ht = function(Se, le) {
      if (Xe(Se))
        return Se.clone();
      var ce = typeof le == "object" ? le : {};
      return ce.date = Se, ce.args = arguments, new gt(ce);
    }, Qe = Fe;
    Qe.l = yt, Qe.i = Xe, Qe.w = function(Se, le) {
      return ht(Se, { locale: le.$L, utc: le.$u, x: le.$x, $offset: le.$offset });
    };
    var gt = function() {
      function Se(ce) {
        this.$L = yt(ce.locale, null, !0), this.parse(ce);
      }
      var le = Se.prototype;
      return le.parse = function(ce) {
        this.$d = function(ve) {
          var ee = ve.date, te = ve.utc;
          if (ee === null)
            return /* @__PURE__ */ new Date(NaN);
          if (Qe.u(ee))
            return /* @__PURE__ */ new Date();
          if (ee instanceof Date)
            return new Date(ee);
          if (typeof ee == "string" && !/Z$/i.test(ee)) {
            var Ae = ee.match(me);
            if (Ae) {
              var U = Ae[2] - 1 || 0, q = (Ae[7] || "0").substring(0, 3);
              return te ? new Date(Date.UTC(Ae[1], U, Ae[3] || 1, Ae[4] || 0, Ae[5] || 0, Ae[6] || 0, q)) : new Date(Ae[1], U, Ae[3] || 1, Ae[4] || 0, Ae[5] || 0, Ae[6] || 0, q);
            }
          }
          return new Date(ee);
        }(ce), this.$x = ce.x || {}, this.init();
      }, le.init = function() {
        var ce = this.$d;
        this.$y = ce.getFullYear(), this.$M = ce.getMonth(), this.$D = ce.getDate(), this.$W = ce.getDay(), this.$H = ce.getHours(), this.$m = ce.getMinutes(), this.$s = ce.getSeconds(), this.$ms = ce.getMilliseconds();
      }, le.$utils = function() {
        return Qe;
      }, le.isValid = function() {
        return this.$d.toString() !== oe;
      }, le.isSame = function(ce, ve) {
        var ee = ht(ce);
        return this.startOf(ve) <= ee && ee <= this.endOf(ve);
      }, le.isAfter = function(ce, ve) {
        return ht(ce) < this.startOf(ve);
      }, le.isBefore = function(ce, ve) {
        return this.endOf(ve) < ht(ce);
      }, le.$g = function(ce, ve, ee) {
        return Qe.u(ce) ? this[ve] : this.set(ee, ce);
      }, le.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, le.valueOf = function() {
        return this.$d.getTime();
      }, le.startOf = function(ce, ve) {
        var ee = this, te = !!Qe.u(ve) || ve, Ae = Qe.p(ce), U = function(lt, At) {
          var Cn = Qe.w(ee.$u ? Date.UTC(ee.$y, At, lt) : new Date(ee.$y, At, lt), ee);
          return te ? Cn : Cn.endOf(v);
        }, q = function(lt, At) {
          return Qe.w(ee.toDate()[lt].apply(ee.toDate("s"), (te ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(At)), ee);
        }, Ie = this.$W, Ye = this.$M, We = this.$D, vt = "set" + (this.$u ? "UTC" : "");
        switch (Ae) {
          case Y:
            return te ? U(1, 0) : U(31, 11);
          case g:
            return te ? U(1, Ye) : U(0, Ye + 1);
          case M:
            var ut = this.$locale().weekStart || 0, Ot = (Ie < ut ? Ie + 7 : Ie) - ut;
            return U(te ? We - Ot : We + (6 - Ot), Ye);
          case v:
          case j:
            return q(vt + "Hours", 0);
          case D:
            return q(vt + "Minutes", 1);
          case G:
            return q(vt + "Seconds", 2);
          case d:
            return q(vt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, le.endOf = function(ce) {
        return this.startOf(ce, !1);
      }, le.$set = function(ce, ve) {
        var ee, te = Qe.p(ce), Ae = "set" + (this.$u ? "UTC" : ""), U = (ee = {}, ee[v] = Ae + "Date", ee[j] = Ae + "Date", ee[g] = Ae + "Month", ee[Y] = Ae + "FullYear", ee[D] = Ae + "Hours", ee[G] = Ae + "Minutes", ee[d] = Ae + "Seconds", ee[h] = Ae + "Milliseconds", ee)[te], q = te === v ? this.$D + (ve - this.$W) : ve;
        if (te === g || te === Y) {
          var Ie = this.clone().set(j, 1);
          Ie.$d[U](q), Ie.init(), this.$d = Ie.set(j, Math.min(this.$D, Ie.daysInMonth())).$d;
        } else
          U && this.$d[U](q);
        return this.init(), this;
      }, le.set = function(ce, ve) {
        return this.clone().$set(ce, ve);
      }, le.get = function(ce) {
        return this[Qe.p(ce)]();
      }, le.add = function(ce, ve) {
        var ee, te = this;
        ce = Number(ce);
        var Ae = Qe.p(ve), U = function(Ye) {
          var We = ht(te);
          return Qe.w(We.date(We.date() + Math.round(Ye * ce)), te);
        };
        if (Ae === g)
          return this.set(g, this.$M + ce);
        if (Ae === Y)
          return this.set(Y, this.$y + ce);
        if (Ae === v)
          return U(1);
        if (Ae === M)
          return U(7);
        var q = (ee = {}, ee[G] = N, ee[D] = O, ee[d] = T, ee)[Ae] || 1, Ie = this.$d.getTime() + ce * q;
        return Qe.w(Ie, this);
      }, le.subtract = function(ce, ve) {
        return this.add(-1 * ce, ve);
      }, le.format = function(ce) {
        var ve = this, ee = this.$locale();
        if (!this.isValid())
          return ee.invalidDate || oe;
        var te = ce || "YYYY-MM-DDTHH:mm:ssZ", Ae = Qe.z(this), U = this.$H, q = this.$m, Ie = this.$M, Ye = ee.weekdays, We = ee.months, vt = ee.meridiem, ut = function(At, Cn, gn, Jn) {
          return At && (At[Cn] || At(ve, te)) || gn[Cn].slice(0, Jn);
        }, Ot = function(At) {
          return Qe.s(U % 12 || 12, At, "0");
        }, lt = vt || function(At, Cn, gn) {
          var Jn = At < 12 ? "AM" : "PM";
          return gn ? Jn.toLowerCase() : Jn;
        };
        return te.replace(Le, function(At, Cn) {
          return Cn || function(gn) {
            switch (gn) {
              case "YY":
                return String(ve.$y).slice(-2);
              case "YYYY":
                return Qe.s(ve.$y, 4, "0");
              case "M":
                return Ie + 1;
              case "MM":
                return Qe.s(Ie + 1, 2, "0");
              case "MMM":
                return ut(ee.monthsShort, Ie, We, 3);
              case "MMMM":
                return ut(We, Ie);
              case "D":
                return ve.$D;
              case "DD":
                return Qe.s(ve.$D, 2, "0");
              case "d":
                return String(ve.$W);
              case "dd":
                return ut(ee.weekdaysMin, ve.$W, Ye, 2);
              case "ddd":
                return ut(ee.weekdaysShort, ve.$W, Ye, 3);
              case "dddd":
                return Ye[ve.$W];
              case "H":
                return String(U);
              case "HH":
                return Qe.s(U, 2, "0");
              case "h":
                return Ot(1);
              case "hh":
                return Ot(2);
              case "a":
                return lt(U, q, !0);
              case "A":
                return lt(U, q, !1);
              case "m":
                return String(q);
              case "mm":
                return Qe.s(q, 2, "0");
              case "s":
                return String(ve.$s);
              case "ss":
                return Qe.s(ve.$s, 2, "0");
              case "SSS":
                return Qe.s(ve.$ms, 3, "0");
              case "Z":
                return Ae;
            }
            return null;
          }(At) || Ae.replace(":", "");
        });
      }, le.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, le.diff = function(ce, ve, ee) {
        var te, Ae = this, U = Qe.p(ve), q = ht(ce), Ie = (q.utcOffset() - this.utcOffset()) * N, Ye = this - q, We = function() {
          return Qe.m(Ae, q);
        };
        switch (U) {
          case Y:
            te = We() / 12;
            break;
          case g:
            te = We();
            break;
          case w:
            te = We() / 3;
            break;
          case M:
            te = (Ye - Ie) / 6048e5;
            break;
          case v:
            te = (Ye - Ie) / 864e5;
            break;
          case D:
            te = Ye / O;
            break;
          case G:
            te = Ye / N;
            break;
          case d:
            te = Ye / T;
            break;
          default:
            te = Ye;
        }
        return ee ? te : Qe.a(te);
      }, le.daysInMonth = function() {
        return this.endOf(g).$D;
      }, le.$locale = function() {
        return je[this.$L];
      }, le.locale = function(ce, ve) {
        if (!ce)
          return this.$L;
        var ee = this.clone(), te = yt(ce, ve, !0);
        return te && (ee.$L = te), ee;
      }, le.clone = function() {
        return Qe.w(this.$d, this);
      }, le.toDate = function() {
        return new Date(this.valueOf());
      }, le.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, le.toISOString = function() {
        return this.$d.toISOString();
      }, le.toString = function() {
        return this.$d.toUTCString();
      }, Se;
    }(), Rn = gt.prototype;
    return ht.prototype = Rn, [["$ms", h], ["$s", d], ["$m", G], ["$H", D], ["$W", v], ["$M", g], ["$y", Y], ["$D", j]].forEach(function(Se) {
      Rn[Se[1]] = function(le) {
        return this.$g(le, Se[0], Se[1]);
      };
    }), ht.extend = function(Se, le) {
      return Se.$i || (Se(le, gt, ht), Se.$i = !0), ht;
    }, ht.locale = yt, ht.isDayjs = Xe, ht.unix = function(Se) {
      return ht(1e3 * Se);
    }, ht.en = je[ye], ht.Ls = je, ht.p = {}, ht;
  });
})(gL);
var X_ = gL.exports;
const gE = /* @__PURE__ */ _A(X_);
var PL = { exports: {} };
(function(l, u) {
  (function(T, N) {
    l.exports = N();
  })(YS, function() {
    return function(T, N, O) {
      T = T || {};
      var h = N.prototype, d = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function G(v, M, g, w) {
        return h.fromToBase(v, M, g, w);
      }
      O.en.relativeTime = d, h.fromToBase = function(v, M, g, w, Y) {
        for (var j, oe, me, Le = g.$locale().relativeTime || d, Oe = T.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], he = Oe.length, Fe = 0; Fe < he; Fe += 1) {
          var ye = Oe[Fe];
          ye.d && (j = w ? O(v).diff(g, ye.d, !0) : g.diff(v, ye.d, !0));
          var je = (T.rounding || Math.round)(Math.abs(j));
          if (me = j > 0, je <= ye.r || !ye.r) {
            je <= 1 && Fe > 0 && (ye = Oe[Fe - 1]);
            var Xe = Le[ye.l];
            Y && (je = Y("" + je)), oe = typeof Xe == "string" ? Xe.replace("%d", je) : Xe(je, M, ye.l, me);
            break;
          }
        }
        if (M)
          return oe;
        var yt = me ? Le.future : Le.past;
        return typeof yt == "function" ? yt(oe) : yt.replace("%s", oe);
      }, h.to = function(v, M) {
        return G(v, M, this, !0);
      }, h.from = function(v, M) {
        return G(v, M, this);
      };
      var D = function(v) {
        return v.$u ? O.utc() : O();
      };
      h.toNow = function(v) {
        return this.to(D(this), v);
      }, h.fromNow = function(v) {
        return this.from(D(this), v);
      };
    };
  });
})(PL);
var k_ = PL.exports;
const K_ = /* @__PURE__ */ _A(k_);
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
const j_ = typeof window < "u" ? W.useLayoutEffect : W.useEffect;
function z_(l, u) {
  const T = W.useRef(l);
  j_(() => {
    T.current = l;
  }, [l]), W.useEffect(() => {
    if (!u && u !== 0)
      return;
    const N = setTimeout(() => T.current(), u);
    return () => clearTimeout(N);
  }, [u]);
}
gE.extend(K_);
function bI({ date: l, ...u }) {
  const [T, N] = W.useState(l ? gE(l).fromNow() : null);
  return z_(() => {
    l || N(null), N(gE(l).fromNow());
  }, 5e3), l ? /* @__PURE__ */ m.jsx("time", { dateTime: l instanceof Date ? l.toISOString() : `${l}`, ...u, children: T }) : null;
}
const wA = iL.createContext([]);
function J_(l, u) {
  return [u, ...l];
}
const HI = ({ children: l }) => {
  const [u, T] = W.useReducer(J_, pa.getEvents());
  return W.useEffect(() => {
    const N = pa.subscribe("event", (O) => {
      T(O);
    });
    return () => {
      N();
    };
  }), /* @__PURE__ */ m.jsx(wA.Provider, { value: u, children: l });
}, Q_ = () => W.useContext(wA), ML = () => (W.useContext(wA), {
  isLocalToSession: (l) => pa.isTraceLocal(l)
});
function Z_(l) {
  return l.indexOf("/node_modules/") === -1 ? l : `npm:${l.replace(/\/node_modules\//gi, "npm:").split("npm:").pop()}`;
}
function q_({ vars: l }) {
  return /* @__PURE__ */ m.jsx("table", { className: "table-values w-full", children: /* @__PURE__ */ m.jsx("tbody", { children: Object.entries(l).map(([u, T]) => /* @__PURE__ */ m.jsxs("tr", { children: [
    /* @__PURE__ */ m.jsx("th", { children: /* @__PURE__ */ m.jsx("div", { className: "w-full truncate", children: u }) }),
    /* @__PURE__ */ m.jsx("td", { children: /* @__PURE__ */ m.jsx("pre", { className: "whitespace-nowrap font-mono", children: T }) })
  ] }, u)) }) });
}
function $_({ frame: l, defaultExpand: u = !1 }) {
  const [T, N] = W.useState(u), O = !!l.context_line;
  return /* @__PURE__ */ m.jsxs("li", { className: "border-primary-900 bg-primary-900 border-b last:border-b-0", children: [
    /* @__PURE__ */ m.jsxs(
      "div",
      {
        className: Ii(
          O ? "hover:bg-primary-800 cursor-pointer" : "",
          "border-primary-950 text-primary-400 border-b px-2 py-1"
        ),
        onClick: () => N(!T),
        children: [
          /* @__PURE__ */ m.jsx("span", { className: "text-primary-100", children: Z_(l.filename) }),
          " in",
          " ",
          /* @__PURE__ */ m.jsx("span", { className: "text-primary-100", children: l.function }),
          l.lineno !== void 0 && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
            " ",
            "at line",
            " ",
            /* @__PURE__ */ m.jsxs("span", { className: "text-primary-100", children: [
              l.lineno,
              l.colno !== void 0 && `:${l.colno}`
            ] })
          ] })
        ]
      }
    ),
    T && /* @__PURE__ */ m.jsxs("div", { className: "bg-primary-950", children: [
      l.pre_context && l.pre_context.map((h, d) => /* @__PURE__ */ m.jsxs("div", { className: "flex items-center", children: [
        l.lineno !== void 0 && /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 w-16 text-right", children: l.lineno - l.pre_context.length + d }),
        /* @__PURE__ */ m.jsx("pre", { className: "text-primary-100 flex-1  whitespace-pre-wrap px-2 py-1", children: h })
      ] }, d)),
      !!l.context_line && /* @__PURE__ */ m.jsxs(
        "div",
        {
          className: Ii(
            l.pre_context || l.post_context ? "bg-primary-600" : "bg-primary-900",
            "flex items-center"
          ),
          children: [
            l.lineno !== void 0 && /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 w-16 text-right", children: l.lineno }),
            /* @__PURE__ */ m.jsx("pre", { className: "text-primary-100 whitespace-pre-wrap px-2 py-1", children: l.context_line })
          ]
        }
      ),
      l.post_context && l.post_context.map((h, d) => /* @__PURE__ */ m.jsxs("div", { className: "flex items-center", children: [
        l.lineno !== void 0 && /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 w-16 text-right", children: l.lineno + 1 + d }),
        /* @__PURE__ */ m.jsx("pre", { className: "text-primary-100 flex-1  whitespace-pre-wrap px-2 py-1", children: h })
      ] }, d)),
      l.vars && /* @__PURE__ */ m.jsx(q_, { vars: l.vars })
    ] })
  ] });
}
function UL({ event: l }) {
  const u = BI(l.exception);
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsxs("strong", { className: "font-bold", children: [
      u[0].type,
      ":"
    ] }),
    " ",
    u[0].value
  ] });
}
function e0({ event: l }) {
  const u = BI(l.exception);
  return /* @__PURE__ */ m.jsx("div", { className: "space-y-4 font-mono", children: /* @__PURE__ */ m.jsxs("h3", { className: "flex flex-col", children: [
    /* @__PURE__ */ m.jsx("strong", { className: "text-xl", children: u[0].type }),
    /* @__PURE__ */ m.jsx("span", { className: "", children: u[0].value })
  ] }) });
}
function t0({ event: l }) {
  const u = BI(l.exception);
  return /* @__PURE__ */ m.jsx(m.Fragment, { children: /* @__PURE__ */ m.jsx("ol", { className: "space-y-4", children: u.map((T, N) => {
    var O;
    return /* @__PURE__ */ m.jsxs("li", { className: "space-y-4 font-mono", children: [
      /* @__PURE__ */ m.jsxs("h3", { className: "bg-primary-950 flex flex-col", children: [
        /* @__PURE__ */ m.jsx("strong", { className: "text-xl", children: T.type }),
        /* @__PURE__ */ m.jsx("pre", { children: T.value })
      ] }),
      /* @__PURE__ */ m.jsx("ul", { className: "border-primary-600 border", children: (O = T.stacktrace) == null ? void 0 : O.frames.map((h, d) => /* @__PURE__ */ m.jsx($_, { frame: h, defaultExpand: N === 0 && d === 0 }, d)) })
    ] }, N);
  }) }) });
}
function BI(l) {
  return l.value ? [l.value] : l.values;
}
function n0({ event: l }) {
  return "exception" in l ? /* @__PURE__ */ m.jsx(UL, { event: l }) : /* @__PURE__ */ m.jsx(m.Fragment, { children: /* @__PURE__ */ m.jsx("strong", { className: "font-bold", children: l.message }) });
}
function r0({ event: l }) {
  return "exception" in l ? /* @__PURE__ */ m.jsx(e0, { event: l }) : /* @__PURE__ */ m.jsx("div", { className: "space-y-4 font-mono", children: /* @__PURE__ */ m.jsx("h3", { className: "flex flex-col", children: /* @__PURE__ */ m.jsx("strong", { className: "text-xl", children: l.message }) }) });
}
function a0({ event: l }) {
  return "exception" in l ? /* @__PURE__ */ m.jsx(t0, { event: l }) : /* @__PURE__ */ m.jsxs("h3", { className: "bg-primary-950 flex flex-col", children: [
    /* @__PURE__ */ m.jsx("strong", { className: "text-xl", children: "Message:" }),
    /* @__PURE__ */ m.jsx("pre", { children: l.message })
  ] });
}
function _L({
  itemCount: l,
  ...u
}) {
  return /* @__PURE__ */ m.jsxs(
    "button",
    {
      className: "bg-primary-900 hover:bg-primary-800 text-primary-200 flex w-full cursor-pointer items-center gap-x-4 px-6 py-2 text-sm",
      ...u,
      children: [
        /* @__PURE__ */ m.jsxs("strong", { children: [
          l.toLocaleString(),
          " ",
          l !== 1 ? "items were" : "item was",
          " hidden from different sessions."
        ] }),
        /* @__PURE__ */ m.jsx("button", { className: "hover:bg-primary-900 border-primary-500 rounded border px-1.5 py-0.5", children: "Reveal" })
      ]
    }
  );
}
const i0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "#1C1E24" }), /* @__PURE__ */ W.createElement("path", { d: "M7.34904 16.6227C6.46072 15.8193 6.20237 14.1347 6.57044 12.9137C7.21456 13.6852 8.10288 13.9294 9.02659 14.0675C10.4493 14.2798 11.8473 14.1984 13.1674 13.5578C13.3196 13.4835 13.4576 13.3844 13.6239 13.2888C13.7478 13.6428 13.7796 14.0002 13.7372 14.3647C13.631 15.2531 13.1815 15.9396 12.4702 16.4599C12.187 16.6687 11.8827 16.8563 11.5889 17.0509C10.6864 17.6561 10.4422 18.3604 10.782 19.3903C10.7891 19.4151 10.7962 19.4398 10.8138 19.5C10.3538 19.2983 10.014 19.001 9.75919 18.6117C9.48668 18.1976 9.35573 17.7411 9.35219 17.2491C9.34865 17.0085 9.34865 16.7678 9.31326 16.5307C9.2354 15.9538 8.95935 15.6954 8.44263 15.6813C7.91176 15.6671 7.49415 15.9892 7.3809 16.4988C7.37382 16.5378 7.35966 16.5767 7.34904 16.6227Z", fill: "url(#paint0_linear_24_21)" }), /* @__PURE__ */ W.createElement("path", { d: "M2.87915 13.2888C2.87915 13.2888 5.31053 12.1068 7.74899 12.1068L9.5858 6.43354C9.65304 6.16103 9.85477 5.97346 10.0813 5.97346C10.3078 5.97346 10.5095 6.16103 10.5768 6.43354L12.4171 12.1068C15.3015 12.1068 17.2834 13.2888 17.2834 13.2888C17.2834 13.2888 13.1568 2.0698 13.1462 2.04503C13.0294 1.71589 12.8276 1.5 12.5587 1.5H7.60389C7.33491 1.5 7.1438 1.71589 7.01639 2.04503C7.00577 2.0698 2.87915 13.2888 2.87915 13.2888Z", fill: "white" }), /* @__PURE__ */ W.createElement("linearGradient", { id: "paint0_linear_24_21", x1: 6.40822, y1: 19.5017, x2: 14.9504, y2: 15.4119, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ W.createElement("stop", { stopColor: "#D83333" }), /* @__PURE__ */ W.createElement("stop", { offset: 1, stopColor: "#F041FF" }))), o0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "black" }), /* @__PURE__ */ W.createElement("path", { d: "M3.87808 10.1069L6.25501 11.7126C6.33425 11.7696 6.40847 11.8332 6.47686 11.9028C6.54902 11.972 6.59081 12.0669 6.59306 12.1669V13.0648C6.59379 13.0942 6.58855 13.1233 6.57765 13.1506C6.56676 13.1778 6.55045 13.2026 6.5297 13.2233C6.50895 13.2441 6.48421 13.2604 6.45696 13.2713C6.42972 13.2822 6.40055 13.2874 6.37122 13.2867H6.32368C6.29977 13.2808 6.2767 13.2719 6.25501 13.2603L2.55756 10.7671C2.47383 10.7161 2.39742 10.6539 2.33043 10.5823C2.27192 10.5072 2.24365 10.413 2.2512 10.3182V9.88503C2.24365 9.79018 2.27192 9.69595 2.33043 9.62092C2.39742 9.5493 2.47383 9.4871 2.55756 9.43605L6.25501 6.94291C6.2767 6.93126 6.29977 6.92239 6.32368 6.9165H6.37122C6.40055 6.91578 6.42972 6.92102 6.45696 6.93191C6.48421 6.94281 6.50895 6.95912 6.5297 6.97987C6.55045 7.00061 6.56676 7.02536 6.57765 7.0526C6.58855 7.07985 6.59379 7.10902 6.59306 7.13835V8.0363C6.59081 8.13625 6.54902 8.23122 6.47686 8.30041C6.40847 8.37 6.33425 8.43362 6.25501 8.49056L3.87808 10.1069ZM11.0591 5.81783C11.0968 5.73571 11.1506 5.66205 11.2175 5.60127C11.3029 5.52964 11.4126 5.4937 11.5239 5.50091H12.3162C12.3776 5.50159 12.4363 5.5263 12.4798 5.56974C12.5232 5.61318 12.5479 5.67189 12.5486 5.73332C12.5475 5.76605 12.5403 5.79829 12.5275 5.8284L8.94623 14.3748C8.91106 14.4541 8.86083 14.5259 8.79833 14.5861C8.75521 14.6239 8.70496 14.6527 8.65053 14.6709C8.59611 14.689 8.53861 14.6961 8.4814 14.6917H7.72343C7.6929 14.692 7.66263 14.6861 7.63448 14.6743C7.60632 14.6624 7.58087 14.645 7.55968 14.623C7.53795 14.6017 7.52068 14.5762 7.50889 14.5481C7.4971 14.52 7.49103 14.4898 7.49102 14.4593C7.4921 14.4266 7.49927 14.3943 7.51214 14.3642L11.0591 5.81783ZM13.745 8.50905C13.6658 8.4521 13.5915 8.38849 13.5231 8.31889C13.4869 8.285 13.458 8.24413 13.438 8.19874C13.418 8.15335 13.4075 8.10438 13.4069 8.05479V7.15684C13.4062 7.12751 13.4115 7.09833 13.4223 7.07109C13.4332 7.04385 13.4496 7.0191 13.4703 6.99835C13.491 6.97761 13.5158 6.96129 13.543 6.9504C13.5703 6.93951 13.5995 6.93427 13.6288 6.93499H13.6763C13.7001 6.94131 13.7231 6.95016 13.745 6.9614L17.4424 9.45454C17.5262 9.50559 17.6026 9.56779 17.6696 9.63941C17.7281 9.71443 17.7564 9.80867 17.7488 9.90351V10.3472C17.7564 10.4421 17.7281 10.5363 17.6696 10.6113C17.6026 10.6829 17.5262 10.7451 17.4424 10.7962L13.745 13.2629C13.7231 13.2741 13.7001 13.283 13.6763 13.2893H13.6288C13.5995 13.29 13.5703 13.2848 13.543 13.2739C13.5158 13.263 13.491 13.2467 13.4703 13.226C13.4496 13.2052 13.4332 13.1805 13.4223 13.1532C13.4115 13.126 13.4062 13.0968 13.4069 13.0675V12.1695C13.4075 12.1199 13.418 12.071 13.438 12.0256C13.458 11.9802 13.4869 11.9393 13.5231 11.9054C13.5915 11.8358 13.6658 11.7722 13.745 11.7153L16.1219 10.1095L13.745 8.50905Z", fill: "white" })), l0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "#F6DE1E" }), /* @__PURE__ */ W.createElement("path", { d: "M9.81752 13.2758L11.6447 12.2074C11.7364 12.3528 11.8364 12.4928 11.9442 12.6268C12.2279 13.0135 12.6219 13.3054 13.0746 13.464C13.5272 13.6226 14.0173 13.6405 14.4803 13.5154C14.6427 13.4775 14.7978 13.4134 14.9396 13.3257C15.0846 13.2473 15.2079 13.1343 15.2986 12.9968C15.3892 12.8592 15.4444 12.7013 15.4593 12.5372C15.4741 12.3731 15.4481 12.2078 15.3835 12.0562C15.319 11.9046 15.2179 11.7713 15.0894 11.6683C14.9535 11.5416 14.7985 11.4371 14.6301 11.3587C14.1907 11.1391 13.7315 10.9394 13.2822 10.7397C12.6436 10.4966 12.0447 10.1601 11.5049 9.74124C11.133 9.40822 10.8477 8.98966 10.6737 8.52171C10.4998 8.05376 10.4424 7.5505 10.5065 7.05539C10.5548 6.3807 10.8362 5.74381 11.3025 5.25382C11.7688 4.76382 12.391 4.45122 13.0625 4.36955C13.6856 4.25973 14.3247 4.28012 14.9396 4.42946C15.3959 4.54452 15.8221 4.75659 16.1891 5.05122C16.5561 5.34586 16.8553 5.71613 17.0663 6.13682L15.2891 7.22513C15.1992 7.09533 15.1193 6.96553 15.0295 6.84572C14.8594 6.60603 14.6195 6.42467 14.3425 6.32639C14.0655 6.22811 13.765 6.21769 13.4818 6.29657C13.3128 6.33745 13.1573 6.42178 13.0309 6.54122C12.9045 6.66065 12.8114 6.81104 12.761 6.97749C12.7105 7.14394 12.7045 7.32069 12.7433 7.49021C12.7822 7.65974 12.8647 7.81617 12.9826 7.94402C13.1498 8.12085 13.3499 8.26331 13.5717 8.36337C14.061 8.61298 14.5702 8.81268 15.0694 9.04232C15.6152 9.27894 16.1286 9.58427 16.597 9.95091C17.0075 10.2711 17.3274 10.6927 17.5252 11.1742C17.7231 11.6557 17.792 12.1804 17.7253 12.6967C17.6998 13.3291 17.467 13.9356 17.0629 14.4228C16.6587 14.9099 16.1056 15.2506 15.4887 15.3925C14.2474 15.7651 12.9128 15.6728 11.7346 15.1329C10.8937 14.7634 10.2135 14.1044 9.81752 13.2758ZM1.75 13.5254L3.58716 12.4071L3.9466 12.9363C4.10704 13.1976 4.35176 13.3963 4.64037 13.4998C4.92899 13.6033 5.24425 13.6052 5.53414 13.5054C5.67198 13.4791 5.80061 13.4175 5.9074 13.3264C6.01418 13.2354 6.09545 13.1182 6.1432 12.9862C6.20173 12.8037 6.24514 12.6167 6.273 12.4271C6.28299 12.2608 6.28299 12.0941 6.273 11.9279V4.40949H8.52951C8.53396 4.47931 8.53396 4.54934 8.52951 4.61916V12.1375C8.5401 12.575 8.48969 13.0119 8.37974 13.4355C8.26201 13.9195 8.01345 14.3618 7.66126 14.7139C7.30906 15.0661 6.8668 15.3147 6.38283 15.4324C5.35267 15.732 4.24743 15.6322 3.28762 15.1529C2.60433 14.8018 2.06173 14.2275 1.75 13.5254Z", fill: "black" })), s0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "#333333" }), /* @__PURE__ */ W.createElement("path", { d: "M10.3823 2.103C10.1375 1.96909 9.84695 1.96909 9.60227 2.103L3.16359 5.7199C2.9189 5.85389 2.78125 6.10687 2.78125 6.37485V13.6234C2.78125 13.8914 2.93417 14.1444 3.16359 14.2784L9.60227 17.8953C9.84695 18.0292 10.1375 18.0292 10.3823 17.8953L16.8209 14.2784C17.0657 14.1444 17.2032 13.8914 17.2032 13.6234V6.37485C17.2032 6.10687 17.0503 5.85389 16.8209 5.7199L10.3823 2.103Z", fill: "url(#paint0_linear_58_1395)" }), /* @__PURE__ */ W.createElement("path", { d: "M16.8363 5.71985L10.367 2.10294C10.3059 2.07318 10.2294 2.04341 10.1682 2.02856L2.91901 14.0997C2.98016 14.1741 3.05666 14.2336 3.13308 14.2783L9.60237 17.8952C9.78591 17.9994 9.99998 18.0291 10.1988 17.9696L17.0045 5.85384C16.9586 5.79431 16.8975 5.74962 16.8363 5.71985Z", fill: "url(#paint1_linear_58_1395)" }), /* @__PURE__ */ W.createElement("path", { d: "M16.8365 14.2782C17.02 14.174 17.1577 13.9954 17.2188 13.8019L10.1378 2.01355C9.9543 1.98378 9.75542 1.99863 9.58723 2.10285L3.16382 5.70484L10.0919 17.9993C10.1836 17.9844 10.2908 17.9546 10.3825 17.91L16.8365 14.2782Z", fill: "url(#paint2_linear_58_1395)" }), /* @__PURE__ */ W.createElement("linearGradient", { id: "paint0_linear_58_1395", x1: 12.6145, y1: 4.79675, x2: 7.0435, y2: 16.4743, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ W.createElement("stop", { stopColor: "#3F873F" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.3296, stopColor: "#3F8B3D" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.6367, stopColor: "#3E9638" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.9341, stopColor: "#3DA92E" }), /* @__PURE__ */ W.createElement("stop", { offset: 1, stopColor: "#3DAE2B" })), /* @__PURE__ */ W.createElement("linearGradient", { id: "paint1_linear_58_1395", x1: 9.0138, y1: 10.8455, x2: 25.0331, y2: -1.31604, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ W.createElement("stop", { offset: 0.1376, stopColor: "#3F873F" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.4016, stopColor: "#52A044" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.7129, stopColor: "#64B749" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.9081, stopColor: "#6ABF4B" })), /* @__PURE__ */ W.createElement("linearGradient", { id: "paint2_linear_58_1395", x1: 2.54543, y1: 9.99663, x2: 17.4441, y2: 9.99663, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ W.createElement("stop", { offset: 0.0919165, stopColor: "#6ABF4B" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.2871, stopColor: "#64B749" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.5984, stopColor: "#52A044" }), /* @__PURE__ */ W.createElement("stop", { offset: 0.8624, stopColor: "#3F873F" }))), u0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "#5C669A" }), /* @__PURE__ */ W.createElement("path", { d: "M3.05693 7.48484H5.50324C6.22329 7.48484 6.744 7.6902 7.06537 8.10093C7.38673 8.51165 7.49328 9.06587 7.38501 9.76359C7.34016 10.0917 7.24449 10.4109 7.10146 10.7096C6.9598 11.0219 6.76139 11.3051 6.5163 11.5448C6.25472 11.8343 5.91568 12.0427 5.53933 12.1455C5.18656 12.2308 4.82477 12.2733 4.46182 12.2718H3.36626L3.02084 13.9989H1.75L3.05693 7.48484V7.48484ZM4.12413 8.51595L3.57764 11.2458C3.61368 11.2483 3.64986 11.2483 3.68591 11.2458H3.8148C4.30799 11.264 4.80103 11.2058 5.27639 11.0731C5.66564 10.9468 5.92599 10.5034 6.04972 9.74812C6.16057 9.11141 6.04972 8.74537 5.72235 8.64742C5.32643 8.54311 4.91742 8.49708 4.50822 8.51079C4.43781 8.51446 4.36725 8.51446 4.29684 8.51079H4.10608L4.12413 8.51595ZM8.83114 5.75H10.0865L9.73078 7.48484H10.8598C11.3521 7.45801 11.8397 7.59191 12.2493 7.86635C12.5586 8.10866 12.6514 8.5675 12.5225 9.24804L11.9167 12.2769H10.6278L11.213 9.38724C11.2479 9.28161 11.2609 9.16998 11.2511 9.05916C11.2414 8.94835 11.2091 8.8407 11.1563 8.74279C11.0719 8.66675 10.9718 8.61024 10.8631 8.57727C10.7544 8.5443 10.6397 8.53569 10.5273 8.55204H9.51425L8.77443 12.2769H7.50874L8.82341 5.75516L8.83114 5.75ZM13.881 7.48484H16.3273C17.0474 7.48484 17.5681 7.6902 17.8894 8.10093C18.2108 8.51165 18.3173 9.06587 18.2091 9.76359C18.1642 10.0917 18.0686 10.4109 17.9255 10.7096C17.7839 11.0219 17.5855 11.3051 17.3404 11.5448C17.0788 11.8343 16.7397 12.0427 16.3634 12.1455C16.0106 12.2308 15.6488 12.2733 15.2859 12.2718H14.1903L13.8449 13.9989H12.5741L13.881 7.48484V7.48484ZM14.9482 8.51595L14.4017 11.2458C14.4378 11.2483 14.4739 11.2483 14.51 11.2458H14.6389C15.1321 11.264 15.6251 11.2058 16.1005 11.0731C16.4897 10.9468 16.7501 10.5034 16.8738 9.74812C16.9846 9.11141 16.8738 8.74537 16.5464 8.64742C16.1506 8.54278 15.7415 8.49675 15.3323 8.51079C15.2619 8.51446 15.1913 8.51446 15.1209 8.51079H14.9301", fill: "white" })), E0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "#5A9FD4" }), /* @__PURE__ */ W.createElement("path", { d: "M9.90587 1.99998C9.29457 2.00073 8.68442 2.05292 8.08187 2.15598C6.46587 2.44198 6.17387 3.03798 6.17387 4.13998V5.59998H9.99987V6.07998H4.73987C3.63187 6.07998 2.65987 6.74598 2.35587 8.01398C1.99987 9.46798 1.99987 10.376 2.35587 11.894C2.62787 13.024 3.27587 13.83 4.38387 13.83H5.69787V12.086C5.71173 11.4592 5.96772 10.8621 6.41217 10.4199C6.85661 9.97765 7.455 9.72468 8.08187 9.71398H11.8939C12.1464 9.71189 12.3961 9.66003 12.6286 9.56138C12.8612 9.46273 13.072 9.31921 13.249 9.13904C13.426 8.95886 13.5658 8.74557 13.6603 8.51134C13.7548 8.27711 13.8022 8.02655 13.7999 7.77398V4.13998C13.7999 3.10598 12.9279 2.32798 11.8919 2.15598C11.2354 2.04868 10.5711 1.9965 9.90587 1.99998V1.99998ZM7.84187 3.16998C7.98625 3.1676 8.12809 3.20821 8.24933 3.28666C8.37057 3.3651 8.46574 3.47783 8.52275 3.61051C8.57975 3.74319 8.596 3.88983 8.56944 4.03177C8.54289 4.17371 8.47471 4.30455 8.3736 4.40765C8.27248 4.51074 8.14299 4.58143 8.00158 4.61074C7.86018 4.64004 7.71326 4.62662 7.5795 4.5722C7.44574 4.51778 7.33119 4.42481 7.25041 4.30511C7.16964 4.18541 7.12628 4.04439 7.12587 3.89998C7.12427 3.7083 7.19874 3.52382 7.33296 3.38697C7.46718 3.25013 7.6502 3.17209 7.84187 3.16998V3.16998Z", fill: "white" }), /* @__PURE__ */ W.createElement("path", { d: "M14.2778 6.08002V7.77402C14.2723 8.40851 14.0207 9.01609 13.576 9.46867C13.1312 9.92124 12.5281 10.1835 11.8938 10.2H8.08183C7.57353 10.2105 7.08946 10.4192 6.73296 10.7817C6.37647 11.1441 6.17581 11.6316 6.17383 12.14V15.77C6.17383 16.804 7.07183 17.412 8.08183 17.708C9.32274 18.0969 10.6529 18.0969 11.8938 17.708C12.8558 17.43 13.7998 16.87 13.7998 15.77V14.314H9.99983V13.83H15.7118C16.8198 13.83 17.2338 13.056 17.6198 11.894C18.0198 10.694 18.0018 9.54802 17.6198 8.01402C17.3458 6.91002 16.8198 6.08002 15.7118 6.08002H14.2778ZM12.1338 15.28C12.2784 15.2776 12.4204 15.3183 12.5417 15.397C12.663 15.4756 12.7582 15.5886 12.8151 15.7215C12.872 15.8544 12.888 16.0012 12.8611 16.1433C12.8342 16.2853 12.7657 16.4162 12.6642 16.5191C12.5626 16.622 12.4328 16.6924 12.2911 16.7213C12.1494 16.7501 12.0024 16.7361 11.8687 16.6811C11.735 16.6261 11.6207 16.5325 11.5404 16.4122C11.4601 16.292 11.4175 16.1506 11.4178 16.006C11.4173 15.8154 11.4924 15.6324 11.6266 15.497C11.7608 15.3617 11.9432 15.2851 12.1338 15.284V15.28Z", fill: "white" })), c0 = (l) => /* @__PURE__ */ W.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...l }, /* @__PURE__ */ W.createElement("rect", { width: "100%", height: "100%", fill: "#BD0012" }), /* @__PURE__ */ W.createElement("path", { d: "M6.63437 15.6819L13.1969 11.4725L16.5625 17.0507L6.63437 15.7007V15.6819ZM17.5 5.2944V5.38815C17.5 5.81003 17.4531 6.24128 17.4344 6.66315V7.49753C17.4344 8.06003 17.3687 8.62253 17.3406 9.1944V10.0382L17.2562 11.6975V12.56C17.2562 12.8507 17.2094 13.4225 17.1906 13.8538C17.1906 14.135 17.1906 14.4163 17.1438 14.6882C17.1438 15.1382 17.0969 15.5788 17.0781 16.0194C17.0594 16.46 17.0781 16.6475 17.0312 16.9569L16.9844 16.91L16.4406 16.0757L13.5812 11.4819C13.4594 11.2757 13.4594 11.2757 13.5812 11.0694L16.7125 6.3819C16.9469 6.03503 17.1719 5.68815 17.4062 5.35065L17.5 5.2944ZM3.60625 9.6069L4.75 7.89128C4.91269 7.66377 5.10148 7.4561 5.3125 7.27253L7.32813 5.39753C7.59404 5.15315 7.88649 4.93931 8.2 4.76003L10.3188 3.5694C10.3611 3.5487 10.4076 3.53794 10.4547 3.53794C10.5018 3.53794 10.5483 3.5487 10.5906 3.5694C10.8906 3.69128 11.2 3.7944 11.5281 3.9069H11.5937V3.9819C11.3125 4.52565 11.0406 5.0694 10.7687 5.61315C10.7257 5.70241 10.6651 5.78211 10.5906 5.84753L7.9375 8.24753C7.77813 8.39753 7.6375 8.5569 7.47812 8.69753C7.38874 8.77898 7.29137 8.85122 7.1875 8.91315C6.30625 9.39128 5.40625 9.85065 4.50625 10.2632C4.47089 10.289 4.4282 10.303 4.38438 10.303C4.34055 10.303 4.29786 10.289 4.2625 10.2632L3.60625 9.6069ZM7.62812 9.48503L12.8125 11.1538L6.25 15.3725C6.25 15.2975 7.5625 9.67253 7.62812 9.48503V9.48503ZM16.8906 5.2944L13.2063 10.8257L11.3313 6.2319C11.3781 6.2319 16.2063 5.36003 16.8906 5.2944ZM7.70313 9.0444L10.9375 6.16628L12.8125 10.7225L7.70313 9.0444ZM5.89375 15.5225L2.5 15.6069L4.27188 11.3694L5.89375 15.5225ZM5.94063 14.5382L4.49688 10.7882L7.1875 9.4194C7.12187 9.7194 7.05625 10.0007 6.98125 10.2819L6.78438 11.135C6.70938 11.4257 6.64375 11.7069 6.56875 11.9975L6.37188 12.8413C6.29688 13.1225 6.23125 13.4132 6.16562 13.6944C6.1 13.9757 6.03437 14.2569 5.95 14.5382H5.94063ZM11.1906 5.79128C11.1825 5.75105 11.1825 5.70962 11.1906 5.6694C11.4531 5.12565 11.725 4.5819 11.9969 4.04753C12.0531 3.93503 12.0906 3.91628 12.2031 3.95378L13.4031 4.26315L16.0562 4.96628H16.1875C16.1406 5.05065 11.7719 5.72565 11.1906 5.79128V5.79128ZM13.075 3.71003L16.7219 2.90378L17.5 4.92878L13.075 3.71003ZM3.15625 16.1225C3.18018 16.1009 3.20847 16.0847 3.2392 16.075C3.26993 16.0653 3.30239 16.0623 3.33438 16.0663H4.01875L5.66875 16.0194C5.95107 16.0148 6.23329 16.0336 6.5125 16.0757L7.45 16.1882L8.58437 16.3382L9.70937 16.4975L10.7687 16.6475L11.7719 16.7882L13.1781 16.9756L14.2937 17.1257H14.3969H14.3406L13.5719 17.0507L12.7 16.9756L11.5937 16.8725L10.7312 16.7882L9.6625 16.6944L8.8 16.61L7.72188 16.5444L6.85938 16.4694L5.8 16.3663L4.92813 16.2913L3.99062 16.2069L3.15625 16.1225ZM2.5 14.4257C2.79063 12.9819 3.08125 11.5382 3.38125 10.0757L3.70937 10.4225L3.98125 10.6944C4.08437 10.8069 4.10313 10.8632 4.0375 11.0038L3.35313 12.5882L2.62188 14.2944L2.5 14.435V14.4257ZM11.2094 3.26003C11.6312 3.17565 14.6687 2.7819 14.7531 2.80065H14.6781L13.9938 2.96003L12.1563 3.4194C11.9123 3.48295 11.6538 3.45976 11.425 3.35378L11.2094 3.26003Z", fill: "white" }));
function TT({
  platform: l,
  event: u,
  size: T = 42,
  ...N
}) {
  switch (l || (u == null ? void 0 : u.platform) || "unknown") {
    case "ruby":
      return /* @__PURE__ */ m.jsx(c0, { width: T, height: T, ...N });
    case "python":
      return /* @__PURE__ */ m.jsx(E0, { width: T, height: T, ...N });
    case "javascript.astro":
      return /* @__PURE__ */ m.jsx(i0, { width: T, height: T, ...N });
    case "javascript":
      return /* @__PURE__ */ m.jsx(l0, { width: T, height: T, ...N });
    case "node":
      return /* @__PURE__ */ m.jsx(s0, { width: T, height: T, ...N });
    case "php":
      return /* @__PURE__ */ m.jsx(u0, { width: T, height: T, ...N });
    default:
      return /* @__PURE__ */ m.jsx(o0, { width: T, height: T, ...N });
  }
}
function T0(l) {
  return /* @__PURE__ */ m.jsx(r0, { event: l });
}
function f0() {
  const l = Q_(), u = ML(), T = yL(), N = l.filter((D) => D.type !== "transaction"), [O, h] = W.useState(!T.experiments["sentry:focus-local-events"]), d = O ? N : N.filter(
    (D) => {
      var v, M, g, w;
      return ((M = (v = D.contexts) == null ? void 0 : v.trace) != null && M.trace_id ? u.isLocalToSession((w = (g = D.contexts) == null ? void 0 : g.trace) == null ? void 0 : w.trace_id) : null) !== !1;
    }
  ), G = N.length - d.length;
  return N.length !== 0 ? /* @__PURE__ */ m.jsxs(xI, { children: [
    G > 0 && /* @__PURE__ */ m.jsx(
      _L,
      {
        itemCount: G,
        onClick: () => {
          h(!0);
        }
      }
    ),
    d.map((D) => {
      var M, g;
      const v = (g = (M = D.contexts) == null ? void 0 : M.trace) == null ? void 0 : g.trace_id;
      return /* @__PURE__ */ m.jsxs(
        Lo,
        {
          className: "hover:bg-primary-900 flex cursor-pointer items-center gap-x-4 px-6 py-2",
          to: `${D.event_id}/details`,
          children: [
            /* @__PURE__ */ m.jsx(TT, { event: D, className: "text-primary-300" }),
            /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex w-48 flex-col truncate font-mono text-sm", children: [
              /* @__PURE__ */ m.jsxs("div", { className: "flex items-center gap-x-2", children: [
                /* @__PURE__ */ m.jsx("div", { children: (D.event_id || "").substring(0, 8) }),
                v && u.isLocalToSession(v) ? /* @__PURE__ */ m.jsx(DL, { title: "This event is part of your local session.", children: "Local" }) : null
              ] }),
              /* @__PURE__ */ m.jsx("span", {}),
              /* @__PURE__ */ m.jsx(bI, { date: D.timestamp })
            ] }),
            /* @__PURE__ */ m.jsx("div", { className: "flex-1", children: T0(D) })
          ]
        },
        D.event_id
      );
    })
  ] }) : /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 p-6", children: "Looks like there's no events recorded matching this query. 🤔" });
}
var GL = { exports: {} };
(function(l, u) {
  (function(T, N) {
    l.exports = N();
  })(YS, function() {
    var T = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(N, O, h) {
      var d = O.prototype, G = d.format;
      h.en.formats = T, d.format = function(D) {
        D === void 0 && (D = "YYYY-MM-DDTHH:mm:ssZ");
        var v = this.$locale().formats, M = function(g, w) {
          return g.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(Y, j, oe) {
            var me = oe && oe.toUpperCase();
            return j || w[oe] || T[oe] || w[me].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(Le, Oe, he) {
              return Oe || he.slice(1);
            });
          });
        }(D, v === void 0 ? {} : v);
        return G.call(this, M);
      };
    };
  });
})(GL);
var A0 = GL.exports;
const xL = /* @__PURE__ */ _A(A0);
gE.extend(xL);
function R0({
  date: l,
  ...u
}) {
  return l ? /* @__PURE__ */ m.jsx("time", { dateTime: l instanceof Date ? l.toISOString() : `${l}`, ...u, children: gE(l).format(u.format ? u.format : "LTS") }) : null;
}
const d0 = `Sentry.addBreadcrumb({
  category: "auth",
  message: "Authenticated user " + user.email,
  level: "info",
});`;
function S0(l) {
  if (!l.breadcrumbs)
    return [];
  if (Array.isArray(l.breadcrumbs))
    return l.breadcrumbs;
  if (Array.isArray(l.breadcrumbs.values))
    return l.breadcrumbs.values;
}
function N0({ event: l }) {
  const u = S0(l);
  return !u || !u.length ? /* @__PURE__ */ m.jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ m.jsx("div", { className: "text-primary-300", children: "No breadcrumbs available for this event. Try adding some to make debugging easier." }),
    /* @__PURE__ */ m.jsx("pre", { className: "whitespace-pre-wrap ", children: d0 })
  ] }) : /* @__PURE__ */ m.jsx("div", { className: "divide-primary-800 grid-cols-2-auto -mx-2 grid space-y-2 divide-y", children: u.map((T, N) => T.message ? /* @__PURE__ */ m.jsxs(W.Fragment, { children: [
    /* @__PURE__ */ m.jsxs("div", { className: "flex flex-none flex-col p-2", children: [
      /* @__PURE__ */ m.jsx("div", { className: "text-lg font-semibold", children: T.category || " " }),
      /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 text-xs", children: /* @__PURE__ */ m.jsx(R0, { date: T.timestamp, format: "HH:mm:ss" }) })
    ] }),
    /* @__PURE__ */ m.jsx(
      "pre",
      {
        className: Ii(
          "flex grow items-center whitespace-pre-line p-2 !font-mono",
          N === 0 ? "!border-t-0" : ""
        ),
        children: T.message
      }
    )
  ] }, N) : null) });
}
function p0({ tags: l }) {
  return /* @__PURE__ */ m.jsx("div", { className: "flex flex-row flex-wrap gap-2 pt-2", children: Object.keys(l).map((u) => /* @__PURE__ */ m.jsx(O0, { tagKey: u, value: l[u] }, u)) });
}
function O0({ tagKey: l, value: u }) {
  return /* @__PURE__ */ m.jsxs("div", { className: "border-primary-300 bg-primary-900 divide-x-primary-300 inline-flex divide-x whitespace-nowrap rounded-full border font-mono text-sm", children: [
    /* @__PURE__ */ m.jsx("div", { className: "px-2 py-1 font-semibold", children: l }),
    /* @__PURE__ */ m.jsx("div", { className: "bg-primary-800 rounded-r-full px-2 py-1", children: u })
  ] });
}
const I0 = `Sentry.setContext("character", {
  name: "Mighty Fighter",
  age: 19,
  attack_type: "melee",
});`;
function C0({ event: l }) {
  const u = { extra: l.extra, ...l.contexts }, T = l.tags;
  return (!u || !Object.values(u).find((N) => !!N)) && !T ? /* @__PURE__ */ m.jsxs("div", { className: "space-y-4 px-6", children: [
    /* @__PURE__ */ m.jsx("div", { className: "text-primary-300", children: "No context available for this event. Try adding some to make debugging easier." }),
    /* @__PURE__ */ m.jsx("pre", { className: "whitespace-pre-wrap ", children: I0 })
  ] }) : /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    T && /* @__PURE__ */ m.jsxs("div", { className: "pb-4", children: [
      /* @__PURE__ */ m.jsx("h2", { className: "font-bold uppercase", children: "Tags" }),
      /* @__PURE__ */ m.jsx(p0, { tags: T })
    ] }),
    /* @__PURE__ */ m.jsx("div", { className: "space-y-6", children: Object.entries(u).map(([N, O]) => O ? /* @__PURE__ */ m.jsxs("div", { children: [
      /* @__PURE__ */ m.jsx("h2", { className: "font-bold uppercase", children: N }),
      /* @__PURE__ */ m.jsx("table", { className: "w-full", children: /* @__PURE__ */ m.jsx("tbody", { children: Object.entries(O).map(([h, d]) => /* @__PURE__ */ m.jsxs("tr", { children: [
        /* @__PURE__ */ m.jsx("th", { className: "text-primary-300 w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ m.jsx("div", { className: "w-full truncate", children: h }) }),
        /* @__PURE__ */ m.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ m.jsx("pre", { className: "text-primary-300 whitespace-nowrap font-mono", children: JSON.stringify(d, void 0, 2) }) })
      ] }, h)) }) })
    ] }, N) : null) })
  ] });
}
function h0(l) {
  return /* @__PURE__ */ m.jsx(a0, { event: l });
}
function v0(l) {
  return /* @__PURE__ */ m.jsx(n0, { event: l });
}
function m0() {
  var d;
  const { eventId: l } = MI(), [u, T] = W.useState("details");
  if (!l)
    return /* @__PURE__ */ m.jsx("p", { children: "Unknown event id" });
  const N = pa.getEventById(l);
  if (!N)
    return /* @__PURE__ */ m.jsx("p", { children: "Event not found" });
  const O = [
    {
      id: "details",
      title: "Details",
      active: u === "details",
      onSelect: () => T("details")
    },
    {
      id: "breadcrumbs",
      title: "Breadcrumbs",
      active: u === "breadcrumbs",
      onSelect: () => T("breadcrumbs")
    },
    {
      id: "contexts",
      title: "Context",
      active: u === "contexts",
      onSelect: () => T("contexts")
    }
  ], h = (d = N.contexts) == null ? void 0 : d.trace;
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsxs("div", { className: "bg-primary-950 flex items-center gap-x-2 px-6 py-4", children: [
      /* @__PURE__ */ m.jsx(TT, { event: N }),
      /* @__PURE__ */ m.jsx("h1", { className: "max-w-full flex-1 truncate text-2xl", children: v0(N) }),
      !!h && /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 font-mono", children: [
        /* @__PURE__ */ m.jsxs("div", { children: [
          "T:",
          " ",
          /* @__PURE__ */ m.jsx(Lo, { className: "cursor-pointer underline", to: `/traces/${h.trace_id}`, children: h.trace_id })
        ] }),
        /* @__PURE__ */ m.jsxs("div", { children: [
          "S:",
          " ",
          /* @__PURE__ */ m.jsx(Lo, { className: "cursor-pointer underline", to: `/traces/${h.trace_id}/${h.span_id}`, children: h.span_id })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(pL, { tabs: O, nested: !0 }),
    /* @__PURE__ */ m.jsxs("div", { className: "flex-1 px-6 py-4", children: [
      /* @__PURE__ */ m.jsxs(FA, { children: [
        /* @__PURE__ */ m.jsx(Vi, { path: "breadcrumbs", element: /* @__PURE__ */ m.jsx(N0, { event: N }) }),
        /* @__PURE__ */ m.jsx(Vi, { path: "contexts", element: /* @__PURE__ */ m.jsx(C0, { event: N }) }),
        /* @__PURE__ */ m.jsx(Vi, { path: "*", element: h0(N) })
      ] }),
      /* @__PURE__ */ m.jsx(_1, {})
    ] })
  ] });
}
function L0() {
  return /* @__PURE__ */ m.jsx(HI, { children: /* @__PURE__ */ m.jsxs(FA, { children: [
    /* @__PURE__ */ m.jsx(Vi, { path: "/", element: /* @__PURE__ */ m.jsx(f0, {}) }),
    /* @__PURE__ */ m.jsx(Vi, { path: "/:eventId/*", element: /* @__PURE__ */ m.jsx(m0, {}) })
  ] }) });
}
const y0 = () => (W.useContext(wA), pa.getSdks());
function D0() {
  const l = y0();
  return /* @__PURE__ */ m.jsx(m.Fragment, { children: l.length !== 0 ? /* @__PURE__ */ m.jsx(xI, { children: l.map((u) => /* @__PURE__ */ m.jsxs("div", { className: "flex items-center gap-x-4 px-6 py-2", children: [
    /* @__PURE__ */ m.jsx(TT, { platform: hL(u.name) }),
    /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex flex-col truncate font-mono text-sm", children: [
      /* @__PURE__ */ m.jsx("div", { children: u.name }),
      /* @__PURE__ */ m.jsx("div", { children: u.version }),
      /* @__PURE__ */ m.jsx(bI, { date: u.lastSeen })
    ] })
  ] }, `${u.name}-${u.version}`)) }) : /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 p-6", children: "Looks like there's no SDKs that have reported yet. 🤔" }) });
}
function g0() {
  return /* @__PURE__ */ m.jsx(HI, { children: /* @__PURE__ */ m.jsx(FA, { children: /* @__PURE__ */ m.jsx(Vi, { path: "/", element: /* @__PURE__ */ m.jsx(D0, {}) }) }) });
}
function UA(l, u) {
  const T = typeof l == "string" ? new Date(l).getTime() : l, N = typeof u == "string" ? new Date(u).getTime() : u;
  return Math.floor(N - T);
}
function P0(l) {
  if (l > 1e3)
    return "text-red-400";
  if (l > 500)
    return "text-orange-400";
  if (l > 100)
    return "text-yellow-400";
}
gE.extend(xL);
function bL({ date: l, ...u }) {
  return l ? /* @__PURE__ */ m.jsx("time", { dateTime: l instanceof Date ? l.toISOString() : `${l}`, ...u, children: gE(l).format("LL LTS") }) : null;
}
let Re;
(function(l) {
  l.QUOTED_IDENTIFIER = "QUOTED_IDENTIFIER", l.IDENTIFIER = "IDENTIFIER", l.STRING = "STRING", l.VARIABLE = "VARIABLE", l.RESERVED_KEYWORD = "RESERVED_KEYWORD", l.RESERVED_FUNCTION_NAME = "RESERVED_FUNCTION_NAME", l.RESERVED_PHRASE = "RESERVED_PHRASE", l.RESERVED_SET_OPERATION = "RESERVED_SET_OPERATION", l.RESERVED_CLAUSE = "RESERVED_CLAUSE", l.RESERVED_SELECT = "RESERVED_SELECT", l.RESERVED_JOIN = "RESERVED_JOIN", l.ARRAY_IDENTIFIER = "ARRAY_IDENTIFIER", l.ARRAY_KEYWORD = "ARRAY_KEYWORD", l.CASE = "CASE", l.END = "END", l.WHEN = "WHEN", l.ELSE = "ELSE", l.THEN = "THEN", l.LIMIT = "LIMIT", l.BETWEEN = "BETWEEN", l.AND = "AND", l.OR = "OR", l.XOR = "XOR", l.OPERATOR = "OPERATOR", l.COMMA = "COMMA", l.ASTERISK = "ASTERISK", l.DOT = "DOT", l.OPEN_PAREN = "OPEN_PAREN", l.CLOSE_PAREN = "CLOSE_PAREN", l.LINE_COMMENT = "LINE_COMMENT", l.BLOCK_COMMENT = "BLOCK_COMMENT", l.NUMBER = "NUMBER", l.NAMED_PARAMETER = "NAMED_PARAMETER", l.QUOTED_PARAMETER = "QUOTED_PARAMETER", l.NUMBERED_PARAMETER = "NUMBERED_PARAMETER", l.POSITIONAL_PARAMETER = "POSITIONAL_PARAMETER", l.CUSTOM_PARAMETER = "CUSTOM_PARAMETER", l.DELIMITER = "DELIMITER", l.EOF = "EOF";
})(Re || (Re = {}));
const HL = (l) => ({
  type: Re.EOF,
  raw: "«EOF»",
  text: "«EOF»",
  start: l
}), PE = HL(1 / 0), LA = (l) => (u) => u.type === l.type && u.text === l.text, su = {
  ARRAY: LA({
    text: "ARRAY",
    type: Re.RESERVED_KEYWORD
  }),
  BY: LA({
    text: "BY",
    type: Re.RESERVED_KEYWORD
  }),
  SET: LA({
    text: "SET",
    type: Re.RESERVED_CLAUSE
  }),
  STRUCT: LA({
    text: "STRUCT",
    type: Re.RESERVED_KEYWORD
  }),
  WINDOW: LA({
    text: "WINDOW",
    type: Re.RESERVED_CLAUSE
  })
}, BL = (l) => l === Re.RESERVED_KEYWORD || l === Re.RESERVED_FUNCTION_NAME || l === Re.RESERVED_PHRASE || l === Re.RESERVED_CLAUSE || l === Re.RESERVED_SELECT || l === Re.RESERVED_SET_OPERATION || l === Re.RESERVED_JOIN || l === Re.ARRAY_KEYWORD || l === Re.CASE || l === Re.END || l === Re.WHEN || l === Re.ELSE || l === Re.THEN || l === Re.LIMIT || l === Re.BETWEEN || l === Re.AND || l === Re.OR || l === Re.XOR, M0 = (l) => l === Re.AND || l === Re.OR || l === Re.XOR, pe = (l) => l.flatMap(U0), U0 = (l) => FL(_0(l)).map((u) => u.trim()), Dm = /[^[\]{}]+/y, gm = /\{.*?\}/y, Pm = /\[.*?\]/y, _0 = (l) => {
  let u = 0;
  const T = [];
  for (; u < l.length; ) {
    Dm.lastIndex = u;
    const N = Dm.exec(l);
    N && (T.push([N[0].trim()]), u += N[0].length), Pm.lastIndex = u;
    const O = Pm.exec(l);
    if (O) {
      const d = O[0].slice(1, -1).split("|").map((G) => G.trim());
      T.push(["", ...d]), u += O[0].length;
    }
    gm.lastIndex = u;
    const h = gm.exec(l);
    if (h) {
      const d = h[0].slice(1, -1).split("|").map((G) => G.trim());
      T.push(d), u += h[0].length;
    }
    if (!N && !O && !h)
      throw new Error(`Unbalanced parenthesis in: ${l}`);
  }
  return T;
}, FL = ([l, ...u]) => l === void 0 ? [""] : FL(u).flatMap((T) => l.map((N) => N.trim() + " " + T.trim())), G0 = (l) => [...new Set(l)], PA = (l) => l[l.length - 1], wL = (l) => l.sort((u, T) => T.length - u.length || u.localeCompare(T)), YL = (l) => l.reduce((u, T) => Math.max(u, T.length), 0), VL = (l) => l.replace(/\s+/gu, " "), en = (l) => G0(Object.values(l).flat()), dI = (l) => /\n/.test(l), x0 = en({
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/lexical#reserved_keywords
  keywords: ["ALL", "AND", "ANY", "ARRAY", "AS", "ASC", "ASSERT_ROWS_MODIFIED", "AT", "BETWEEN", "BY", "CASE", "CAST", "COLLATE", "CONTAINS", "CREATE", "CROSS", "CUBE", "CURRENT", "DEFAULT", "DEFINE", "DESC", "DISTINCT", "ELSE", "END", "ENUM", "ESCAPE", "EXCEPT", "EXCLUDE", "EXISTS", "EXTRACT", "FALSE", "FETCH", "FOLLOWING", "FOR", "FROM", "FULL", "GROUP", "GROUPING", "GROUPS", "HASH", "HAVING", "IF", "IGNORE", "IN", "INNER", "INTERSECT", "INTERVAL", "INTO", "IS", "JOIN", "LATERAL", "LEFT", "LIKE", "LIMIT", "LOOKUP", "MERGE", "NATURAL", "NEW", "NO", "NOT", "NULL", "NULLS", "OF", "ON", "OR", "ORDER", "OUTER", "OVER", "PARTITION", "PRECEDING", "PROTO", "RANGE", "RECURSIVE", "RESPECT", "RIGHT", "ROLLUP", "ROWS", "SELECT", "SET", "SOME", "STRUCT", "TABLE", "TABLESAMPLE", "THEN", "TO", "TREAT", "TRUE", "UNBOUNDED", "UNION", "UNNEST", "USING", "WHEN", "WHERE", "WINDOW", "WITH", "WITHIN"],
  datatypes: [
    "ARRAY",
    // parametric, ARRAY<T>
    "BOOL",
    "BYTES",
    // parameterised, BYTES(Length)
    "DATE",
    "DATETIME",
    "GEOGRAPHY",
    "INTERVAL",
    "INT64",
    "INT",
    "SMALLINT",
    "INTEGER",
    "BIGINT",
    "TINYINT",
    "BYTEINT",
    "NUMERIC",
    // parameterised, NUMERIC(Precision[, Scale])
    "DECIMAL",
    // parameterised, DECIMAL(Precision[, Scale])
    "BIGNUMERIC",
    // parameterised, BIGNUMERIC(Precision[, Scale])
    "BIGDECIMAL",
    // parameterised, BIGDECIMAL(Precision[, Scale])
    "FLOAT64",
    "STRING",
    // parameterised, STRING(Length)
    "STRUCT",
    // parametric, STRUCT<T>
    "TIME",
    "TIMEZONE"
  ],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/conversion_functions#formatting_syntax
  stringFormat: ["HEX", "BASEX", "BASE64M", "ASCII", "UTF-8", "UTF8"],
  misc: ["SAFE"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/data-definition-language
  ddl: [
    "LIKE",
    // CREATE TABLE LIKE
    "COPY",
    // CREATE TABLE COPY
    "CLONE",
    // CREATE TABLE CLONE
    "IN",
    "OUT",
    "INOUT",
    "RETURNS",
    "LANGUAGE",
    "CASCADE",
    "RESTRICT",
    "DETERMINISTIC"
  ]
}), b0 = en({
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/aead_encryption_functions
  aead: ["KEYS.NEW_KEYSET", "KEYS.ADD_KEY_FROM_RAW_BYTES", "AEAD.DECRYPT_BYTES", "AEAD.DECRYPT_STRING", "AEAD.ENCRYPT", "KEYS.KEYSET_CHAIN", "KEYS.KEYSET_FROM_JSON", "KEYS.KEYSET_TO_JSON", "KEYS.ROTATE_KEYSET", "KEYS.KEYSET_LENGTH"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_analytic_functions
  aggregateAnalytic: ["ANY_VALUE", "ARRAY_AGG", "AVG", "CORR", "COUNT", "COUNTIF", "COVAR_POP", "COVAR_SAMP", "MAX", "MIN", "ST_CLUSTERDBSCAN", "STDDEV_POP", "STDDEV_SAMP", "STRING_AGG", "SUM", "VAR_POP", "VAR_SAMP"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
  aggregate: ["ANY_VALUE", "ARRAY_AGG", "ARRAY_CONCAT_AGG", "AVG", "BIT_AND", "BIT_OR", "BIT_XOR", "COUNT", "COUNTIF", "LOGICAL_AND", "LOGICAL_OR", "MAX", "MIN", "STRING_AGG", "SUM"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/approximate_aggregate_functions
  approximateAggregate: ["APPROX_COUNT_DISTINCT", "APPROX_QUANTILES", "APPROX_TOP_COUNT", "APPROX_TOP_SUM"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/array_functions
  array: [
    // 'ARRAY',
    "ARRAY_CONCAT",
    "ARRAY_LENGTH",
    "ARRAY_TO_STRING",
    "GENERATE_ARRAY",
    "GENERATE_DATE_ARRAY",
    "GENERATE_TIMESTAMP_ARRAY",
    "ARRAY_REVERSE",
    "OFFSET",
    "SAFE_OFFSET",
    "ORDINAL",
    "SAFE_ORDINAL"
  ],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/bit_functions
  bitwise: ["BIT_COUNT"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/conversion_functions
  conversion: [
    // 'CASE',
    "PARSE_BIGNUMERIC",
    "PARSE_NUMERIC",
    "SAFE_CAST"
  ],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
  date: ["CURRENT_DATE", "EXTRACT", "DATE", "DATE_ADD", "DATE_SUB", "DATE_DIFF", "DATE_TRUNC", "DATE_FROM_UNIX_DATE", "FORMAT_DATE", "LAST_DAY", "PARSE_DATE", "UNIX_DATE"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/datetime_functions
  datetime: ["CURRENT_DATETIME", "DATETIME", "EXTRACT", "DATETIME_ADD", "DATETIME_SUB", "DATETIME_DIFF", "DATETIME_TRUNC", "FORMAT_DATETIME", "LAST_DAY", "PARSE_DATETIME"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/debugging_functions
  debugging: ["ERROR"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/federated_query_functions
  federatedQuery: ["EXTERNAL_QUERY"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
  geography: ["S2_CELLIDFROMPOINT", "S2_COVERINGCELLIDS", "ST_ANGLE", "ST_AREA", "ST_ASBINARY", "ST_ASGEOJSON", "ST_ASTEXT", "ST_AZIMUTH", "ST_BOUNDARY", "ST_BOUNDINGBOX", "ST_BUFFER", "ST_BUFFERWITHTOLERANCE", "ST_CENTROID", "ST_CENTROID_AGG", "ST_CLOSESTPOINT", "ST_CLUSTERDBSCAN", "ST_CONTAINS", "ST_CONVEXHULL", "ST_COVEREDBY", "ST_COVERS", "ST_DIFFERENCE", "ST_DIMENSION", "ST_DISJOINT", "ST_DISTANCE", "ST_DUMP", "ST_DWITHIN", "ST_ENDPOINT", "ST_EQUALS", "ST_EXTENT", "ST_EXTERIORRING", "ST_GEOGFROM", "ST_GEOGFROMGEOJSON", "ST_GEOGFROMTEXT", "ST_GEOGFROMWKB", "ST_GEOGPOINT", "ST_GEOGPOINTFROMGEOHASH", "ST_GEOHASH", "ST_GEOMETRYTYPE", "ST_INTERIORRINGS", "ST_INTERSECTION", "ST_INTERSECTS", "ST_INTERSECTSBOX", "ST_ISCOLLECTION", "ST_ISEMPTY", "ST_LENGTH", "ST_MAKELINE", "ST_MAKEPOLYGON", "ST_MAKEPOLYGONORIENTED", "ST_MAXDISTANCE", "ST_NPOINTS", "ST_NUMGEOMETRIES", "ST_NUMPOINTS", "ST_PERIMETER", "ST_POINTN", "ST_SIMPLIFY", "ST_SNAPTOGRID", "ST_STARTPOINT", "ST_TOUCHES", "ST_UNION", "ST_UNION_AGG", "ST_WITHIN", "ST_X", "ST_Y"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/hash_functions
  hash: ["FARM_FINGERPRINT", "MD5", "SHA1", "SHA256", "SHA512"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/hll_functions
  hll: ["HLL_COUNT.INIT", "HLL_COUNT.MERGE", "HLL_COUNT.MERGE_PARTIAL", "HLL_COUNT.EXTRACT"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/interval_functions
  interval: ["MAKE_INTERVAL", "EXTRACT", "JUSTIFY_DAYS", "JUSTIFY_HOURS", "JUSTIFY_INTERVAL"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
  json: ["JSON_EXTRACT", "JSON_QUERY", "JSON_EXTRACT_SCALAR", "JSON_VALUE", "JSON_EXTRACT_ARRAY", "JSON_QUERY_ARRAY", "JSON_EXTRACT_STRING_ARRAY", "JSON_VALUE_ARRAY", "TO_JSON_STRING"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
  math: ["ABS", "SIGN", "IS_INF", "IS_NAN", "IEEE_DIVIDE", "RAND", "SQRT", "POW", "POWER", "EXP", "LN", "LOG", "LOG10", "GREATEST", "LEAST", "DIV", "SAFE_DIVIDE", "SAFE_MULTIPLY", "SAFE_NEGATE", "SAFE_ADD", "SAFE_SUBTRACT", "MOD", "ROUND", "TRUNC", "CEIL", "CEILING", "FLOOR", "COS", "COSH", "ACOS", "ACOSH", "SIN", "SINH", "ASIN", "ASINH", "TAN", "TANH", "ATAN", "ATANH", "ATAN2", "RANGE_BUCKET"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/navigation_functions
  navigation: ["FIRST_VALUE", "LAST_VALUE", "NTH_VALUE", "LEAD", "LAG", "PERCENTILE_CONT", "PERCENTILE_DISC"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/net_functions
  net: ["NET.IP_FROM_STRING", "NET.SAFE_IP_FROM_STRING", "NET.IP_TO_STRING", "NET.IP_NET_MASK", "NET.IP_TRUNC", "NET.IPV4_FROM_INT64", "NET.IPV4_TO_INT64", "NET.HOST", "NET.PUBLIC_SUFFIX", "NET.REG_DOMAIN"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/numbering_functions
  numbering: ["RANK", "DENSE_RANK", "PERCENT_RANK", "CUME_DIST", "NTILE", "ROW_NUMBER"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/security_functions
  security: ["SESSION_USER"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/statistical_aggregate_functions
  statisticalAggregate: ["CORR", "COVAR_POP", "COVAR_SAMP", "STDDEV_POP", "STDDEV_SAMP", "STDDEV", "VAR_POP", "VAR_SAMP", "VARIANCE"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
  string: ["ASCII", "BYTE_LENGTH", "CHAR_LENGTH", "CHARACTER_LENGTH", "CHR", "CODE_POINTS_TO_BYTES", "CODE_POINTS_TO_STRING", "CONCAT", "CONTAINS_SUBSTR", "ENDS_WITH", "FORMAT", "FROM_BASE32", "FROM_BASE64", "FROM_HEX", "INITCAP", "INSTR", "LEFT", "LENGTH", "LPAD", "LOWER", "LTRIM", "NORMALIZE", "NORMALIZE_AND_CASEFOLD", "OCTET_LENGTH", "REGEXP_CONTAINS", "REGEXP_EXTRACT", "REGEXP_EXTRACT_ALL", "REGEXP_INSTR", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPLACE", "REPEAT", "REVERSE", "RIGHT", "RPAD", "RTRIM", "SAFE_CONVERT_BYTES_TO_STRING", "SOUNDEX", "SPLIT", "STARTS_WITH", "STRPOS", "SUBSTR", "SUBSTRING", "TO_BASE32", "TO_BASE64", "TO_CODE_POINTS", "TO_HEX", "TRANSLATE", "TRIM", "UNICODE", "UPPER"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
  time: ["CURRENT_TIME", "TIME", "EXTRACT", "TIME_ADD", "TIME_SUB", "TIME_DIFF", "TIME_TRUNC", "FORMAT_TIME", "PARSE_TIME"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
  timestamp: ["CURRENT_TIMESTAMP", "EXTRACT", "STRING", "TIMESTAMP", "TIMESTAMP_ADD", "TIMESTAMP_SUB", "TIMESTAMP_DIFF", "TIMESTAMP_TRUNC", "FORMAT_TIMESTAMP", "PARSE_TIMESTAMP", "TIMESTAMP_SECONDS", "TIMESTAMP_MILLIS", "TIMESTAMP_MICROS", "UNIX_SECONDS", "UNIX_MILLIS", "UNIX_MICROS"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/uuid_functions
  uuid: ["GENERATE_UUID"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/conditional_expressions
  conditional: ["COALESCE", "IF", "IFNULL", "NULLIF"],
  // https://cloud.google.com/bigquery/docs/reference/legacy-sql
  legacyAggregate: ["AVG", "BIT_AND", "BIT_OR", "BIT_XOR", "CORR", "COUNT", "COVAR_POP", "COVAR_SAMP", "EXACT_COUNT_DISTINCT", "FIRST", "GROUP_CONCAT", "GROUP_CONCAT_UNQUOTED", "LAST", "MAX", "MIN", "NEST", "NTH", "QUANTILES", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "SUM", "TOP", "UNIQUE", "VARIANCE", "VAR_POP", "VAR_SAMP"],
  legacyBitwise: ["BIT_COUNT"],
  legacyCasting: ["BOOLEAN", "BYTES", "CAST", "FLOAT", "HEX_STRING", "INTEGER", "STRING"],
  legacyComparison: [
    // expr 'IN',
    "COALESCE",
    "GREATEST",
    "IFNULL",
    "IS_INF",
    "IS_NAN",
    "IS_EXPLICITLY_DEFINED",
    "LEAST",
    "NVL"
  ],
  legacyDatetime: ["CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DATE", "DATE_ADD", "DATEDIFF", "DAY", "DAYOFWEEK", "DAYOFYEAR", "FORMAT_UTC_USEC", "HOUR", "MINUTE", "MONTH", "MSEC_TO_TIMESTAMP", "NOW", "PARSE_UTC_USEC", "QUARTER", "SEC_TO_TIMESTAMP", "SECOND", "STRFTIME_UTC_USEC", "TIME", "TIMESTAMP", "TIMESTAMP_TO_MSEC", "TIMESTAMP_TO_SEC", "TIMESTAMP_TO_USEC", "USEC_TO_TIMESTAMP", "UTC_USEC_TO_DAY", "UTC_USEC_TO_HOUR", "UTC_USEC_TO_MONTH", "UTC_USEC_TO_WEEK", "UTC_USEC_TO_YEAR", "WEEK", "YEAR"],
  legacyIp: ["FORMAT_IP", "PARSE_IP", "FORMAT_PACKED_IP", "PARSE_PACKED_IP"],
  legacyJson: ["JSON_EXTRACT", "JSON_EXTRACT_SCALAR"],
  legacyMath: ["ABS", "ACOS", "ACOSH", "ASIN", "ASINH", "ATAN", "ATANH", "ATAN2", "CEIL", "COS", "COSH", "DEGREES", "EXP", "FLOOR", "LN", "LOG", "LOG2", "LOG10", "PI", "POW", "RADIANS", "RAND", "ROUND", "SIN", "SINH", "SQRT", "TAN", "TANH"],
  legacyRegex: ["REGEXP_MATCH", "REGEXP_EXTRACT", "REGEXP_REPLACE"],
  legacyString: [
    "CONCAT",
    // expr CONTAINS 'str'
    "INSTR",
    "LEFT",
    "LENGTH",
    "LOWER",
    "LPAD",
    "LTRIM",
    "REPLACE",
    "RIGHT",
    "RPAD",
    "RTRIM",
    "SPLIT",
    "SUBSTR",
    "UPPER"
  ],
  legacyTableWildcard: ["TABLE_DATE_RANGE", "TABLE_DATE_RANGE_STRICT", "TABLE_QUERY"],
  legacyUrl: ["HOST", "DOMAIN", "TLD"],
  legacyWindow: ["AVG", "COUNT", "MAX", "MIN", "STDDEV", "SUM", "CUME_DIST", "DENSE_RANK", "FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "NTH_VALUE", "NTILE", "PERCENT_RANK", "PERCENTILE_CONT", "PERCENTILE_DISC", "RANK", "RATIO_TO_REPORT", "ROW_NUMBER"],
  legacyMisc: ["CURRENT_USER", "EVERY", "FROM_BASE64", "HASH", "FARM_FINGERPRINT", "IF", "POSITION", "SHA1", "SOME", "TO_BASE64"],
  other: ["BQ.JOBS.CANCEL", "BQ.REFRESH_MATERIALIZED_VIEW"],
  ddl: ["OPTIONS"],
  pivot: ["PIVOT", "UNPIVOT"],
  // Data types with parameters like VARCHAR(100)
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/data-types#parameterized_data_types
  dataTypes: ["BYTES", "NUMERIC", "DECIMAL", "BIGNUMERIC", "BIGDECIMAL", "STRING"]
}), H0 = pe(["SELECT [ALL | DISTINCT] [AS STRUCT | AS VALUE]"]), B0 = pe([
  // Queries: https://cloud.google.com/bigquery/docs/reference/standard-sql/query-syntax
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "QUALIFY",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "OMIT RECORD IF",
  // legacy
  // Data modification: https://cloud.google.com/bigquery/docs/reference/standard-sql/dml-syntax
  // - insert:
  "INSERT [INTO]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE [INTO]",
  "WHEN [NOT] MATCHED [BY SOURCE | BY TARGET] [THEN]",
  "UPDATE SET",
  // Data definition, https://cloud.google.com/bigquery/docs/reference/standard-sql/data-definition-language
  "CREATE [OR REPLACE] [MATERIALIZED] VIEW [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [TEMP|TEMPORARY|SNAPSHOT|EXTERNAL] TABLE [IF NOT EXISTS]",
  "CLUSTER BY",
  "FOR SYSTEM_TIME AS OF",
  // CREATE SNAPSHOT TABLE
  "WITH CONNECTION",
  "WITH PARTITION COLUMNS",
  "REMOTE WITH CONNECTION"
]), Mm = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP [SNAPSHOT | EXTERNAL] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS]",
  "ADD COLUMN [IF NOT EXISTS]",
  "DROP COLUMN [IF EXISTS]",
  "RENAME TO",
  "ALTER COLUMN [IF EXISTS]",
  "SET DEFAULT COLLATE",
  // for alter column
  "SET OPTIONS",
  // for alter column
  "DROP NOT NULL",
  // for alter column
  "SET DATA TYPE",
  // for alter column
  // - alter schema
  "ALTER SCHEMA [IF EXISTS]",
  // - alter view
  "ALTER [MATERIALIZED] VIEW [IF EXISTS]",
  // - alter bi_capacity
  "ALTER BI_CAPACITY",
  // - truncate:
  "TRUNCATE TABLE",
  // - create schema
  "CREATE SCHEMA [IF NOT EXISTS]",
  "DEFAULT COLLATE",
  // stored procedures
  "CREATE [OR REPLACE] [TEMP|TEMPORARY|TABLE] FUNCTION [IF NOT EXISTS]",
  "CREATE [OR REPLACE] PROCEDURE [IF NOT EXISTS]",
  // row access policy
  "CREATE [OR REPLACE] ROW ACCESS POLICY [IF NOT EXISTS]",
  "GRANT TO",
  "FILTER USING",
  // capacity
  "CREATE CAPACITY",
  "AS JSON",
  // reservation
  "CREATE RESERVATION",
  // assignment
  "CREATE ASSIGNMENT",
  // search index
  "CREATE SEARCH INDEX [IF NOT EXISTS]",
  // drop
  "DROP SCHEMA [IF EXISTS]",
  "DROP [MATERIALIZED] VIEW [IF EXISTS]",
  "DROP [TABLE] FUNCTION [IF EXISTS]",
  "DROP PROCEDURE [IF EXISTS]",
  "DROP ROW ACCESS POLICY",
  "DROP ALL ROW ACCESS POLICIES",
  "DROP CAPACITY [IF EXISTS]",
  "DROP RESERVATION [IF EXISTS]",
  "DROP ASSIGNMENT [IF EXISTS]",
  "DROP SEARCH INDEX [IF EXISTS]",
  "DROP [IF EXISTS]",
  // DCL, https://cloud.google.com/bigquery/docs/reference/standard-sql/data-control-language
  "GRANT",
  "REVOKE",
  // Script, https://cloud.google.com/bigquery/docs/reference/standard-sql/scripting
  "DECLARE",
  "EXECUTE IMMEDIATE",
  "LOOP",
  "END LOOP",
  "REPEAT",
  "END REPEAT",
  "WHILE",
  "END WHILE",
  "BREAK",
  "LEAVE",
  "CONTINUE",
  "ITERATE",
  "FOR",
  "END FOR",
  "BEGIN",
  "BEGIN TRANSACTION",
  "COMMIT TRANSACTION",
  "ROLLBACK TRANSACTION",
  "RAISE",
  "RETURN",
  "CALL",
  // Debug, https://cloud.google.com/bigquery/docs/reference/standard-sql/debugging-statements
  "ASSERT",
  // Other, https://cloud.google.com/bigquery/docs/reference/standard-sql/other-statements
  "EXPORT DATA"
]), F0 = pe(["UNION {ALL | DISTINCT}", "EXCEPT DISTINCT", "INTERSECT DISTINCT"]), w0 = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN"]), Y0 = pe([
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/query-syntax#tablesample_operator
  "TABLESAMPLE SYSTEM",
  // From DDL: https://cloud.google.com/bigquery/docs/reference/standard-sql/data-definition-language
  "ANY TYPE",
  "ALL COLUMNS",
  "NOT DETERMINISTIC",
  // inside window definitions
  "{ROWS | RANGE} BETWEEN",
  // comparison operator
  "IS [NOT] DISTINCT FROM"
]), V0 = {
  tokenizerOptions: {
    reservedSelect: H0,
    reservedClauses: [...B0, ...Mm],
    reservedSetOperations: F0,
    reservedJoins: w0,
    reservedPhrases: Y0,
    reservedKeywords: x0,
    reservedFunctionNames: b0,
    extraParens: ["[]"],
    stringTypes: [
      // The triple-quoted strings are listed first, so they get matched first.
      // Otherwise the first two quotes of """ will get matched as an empty "" string.
      {
        quote: '""".."""',
        prefixes: ["R", "B", "RB", "BR"]
      },
      {
        quote: "'''..'''",
        prefixes: ["R", "B", "RB", "BR"]
      },
      '""-bs',
      "''-bs",
      {
        quote: '""-raw',
        prefixes: ["R", "B", "RB", "BR"],
        requirePrefix: !0
      },
      {
        quote: "''-raw",
        prefixes: ["R", "B", "RB", "BR"],
        requirePrefix: !0
      }
    ],
    identTypes: ["``"],
    identChars: {
      dashes: !0
    },
    paramTypes: {
      positional: !0,
      named: ["@"],
      quoted: ["@"]
    },
    variableTypes: [{
      regex: String.raw`@@\w+`
    }],
    lineCommentTypes: ["--", "#"],
    operators: ["&", "|", "^", "~", ">>", "<<", "||", "=>"],
    postProcess: W0
  },
  formatOptions: {
    onelineClauses: Mm
  }
};
function W0(l) {
  return X0(k0(l));
}
function X0(l) {
  let u = PE;
  return l.map((T) => T.text === "OFFSET" && u.text === "[" ? (u = T, {
    ...T,
    type: Re.RESERVED_FUNCTION_NAME
  }) : (u = T, T));
}
function k0(l) {
  const u = [];
  for (let N = 0; N < l.length; N++) {
    var T;
    const O = l[N];
    if ((su.ARRAY(O) || su.STRUCT(O)) && ((T = l[N + 1]) === null || T === void 0 ? void 0 : T.text) === "<") {
      const h = K0(l, N + 1), d = l.slice(N, h + 1);
      u.push({
        type: Re.IDENTIFIER,
        raw: d.map(Um("raw")).join(""),
        text: d.map(Um("text")).join(""),
        start: O.start
      }), N = h;
    } else
      u.push(O);
  }
  return u;
}
const Um = (l) => (u) => u.type === Re.IDENTIFIER || u.type === Re.COMMA ? u[l] + " " : u[l];
function K0(l, u) {
  let T = 0;
  for (let N = u; N < l.length; N++) {
    const O = l[N];
    if (O.text === "<" ? T++ : O.text === ">" ? T-- : O.text === ">>" && (T -= 2), T === 0)
      return N;
  }
  return l.length - 1;
}
const j0 = en({
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-aggregate
  aggregate: ["ARRAY_AGG", "AVG", "CORR", "CORRELATION", "COUNT", "COUNT_BIG", "COVAR_POP", "COVARIANCE", "COVAR", "COVAR_SAMP", "COVARIANCE_SAMP", "CUME_DIST", "GROUPING", "LISTAGG", "MAX", "MEDIAN", "MIN", "PERCENTILE_CONT", "PERCENTILE_DISC", "PERCENT_RANK", "REGR_AVGX", "REGR_AVGY", "REGR_COUNT", "REGR_INTERCEPT", "REGR_ICPT", "REGR_R2", "REGR_SLOPE", "REGR_SXX", "REGR_SXY", "REGR_SYY", "STDDEV_POP", "STDDEV", "STDDEV_SAMP", "SUM", "VAR_POP", "VARIANCE", "VAR", "VAR_SAMP", "VARIANCE_SAMP", "XMLAGG"],
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-scalar
  scalar: ["ABS", "ABSVAL", "ACOS", "ADD_DAYS", "ADD_MONTHS", "ARRAY_DELETE", "ARRAY_FIRST", "ARRAY_LAST", "ARRAY_NEXT", "ARRAY_PRIOR", "ARRAY_TRIM", "ASCII", "ASCII_CHR", "ASCII_STR", "ASCIISTR", "ASIN", "ATAN", "ATANH", "ATAN2", "BIGINT", "BINARY", "BITAND", "BITANDNOT", "BITOR", "BITXOR", "BITNOT", "BLOB", "BTRIM", "CARDINALITY", "CCSID_ENCODING", "CEILING", "CEIL", "CHAR", "CHAR9", "CHARACTER_LENGTH", "CHAR_LENGTH", "CHR", "CLOB", "COALESCE", "COLLATION_KEY", "COMPARE_DECFLOAT", "CONCAT", "CONTAINS", "COS", "COSH", "DATE", "DAY", "DAYOFMONTH", "DAYOFWEEK", "DAYOFWEEK_ISO", "DAYOFYEAR", "DAYS", "DAYS_BETWEEN", "DBCLOB", "DECFLOAT", "DECFLOAT_FORMAT", "DECFLOAT_SORTKEY", "DECIMAL", "DEC", "DECODE", "DECRYPT_BINARY", "DECRYPT_BIT", "DECRYPT_CHAR", "DECRYPT_DB", "DECRYPT_DATAKEY_BIGINT", "DECRYPT_DATAKEY_BIT", "DECRYPT_DATAKEY_CLOB", "DECRYPT_DATAKEY_DBCLOB", "DECRYPT_DATAKEY_DECIMAL", "DECRYPT_DATAKEY_INTEGER", "DECRYPT_DATAKEY_VARCHAR", "DECRYPT_DATAKEY_VARGRAPHIC", "DEGREES", "DIFFERENCE", "DIGITS", "DOUBLE_PRECISION", "DOUBLE", "DSN_XMLVALIDATE", "EBCDIC_CHR", "EBCDIC_STR", "ENCRYPT_DATAKEY", "ENCRYPT_TDES", "EXP", "EXTRACT", "FLOAT", "FLOOR", "GENERATE_UNIQUE", "GENERATE_UNIQUE_BINARY", "GETHINT", "GETVARIABLE", "GRAPHIC", "GREATEST", "HASH", "HASH_CRC32", "HASH_MD5", "HASH_SHA1", "HASH_SHA256", "HEX", "HOUR", "IDENTITY_VAL_LOCAL", "IFNULL", "INSERT", "INSTR", "INTEGER", "INT", "JULIAN_DAY", "LAST_DAY", "LCASE", "LEAST", "LEFT", "LENGTH", "LN", "LOCATE", "LOCATE_IN_STRING", "LOG10", "LOWER", "LPAD", "LTRIM", "MAX", "MAX_CARDINALITY", "MICROSECOND", "MIDNIGHT_SECONDS", "MIN", "MINUTE", "MOD", "MONTH", "MONTHS_BETWEEN", "MQREAD", "MQREADCLOB", "MQRECEIVE", "MQRECEIVECLOB", "MQSEND", "MULTIPLY_ALT", "NEXT_DAY", "NEXT_MONTH", "NORMALIZE_DECFLOAT", "NORMALIZE_STRING", "NULLIF", "NVL", "OVERLAY", "PACK", "POSITION", "POSSTR", "POWER", "POW", "QUANTIZE", "QUARTER", "RADIANS", "RAISE_ERROR", "RANDOM", "RAND", "REAL", "REGEXP_COUNT", "REGEXP_INSTR", "REGEXP_LIKE", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPEAT", "REPLACE", "RID", "RIGHT", "ROUND", "ROUND_TIMESTAMP", "ROWID", "RPAD", "RTRIM", "SCORE", "SECOND", "SIGN", "SIN", "SINH", "SMALLINT", "SOUNDEX", "SOAPHTTPC", "SOAPHTTPV", "SOAPHTTPNC", "SOAPHTTPNV", "SPACE", "SQRT", "STRIP", "STRLEFT", "STRPOS", "STRRIGHT", "SUBSTR", "SUBSTRING", "TAN", "TANH", "TIME", "TIMESTAMP", "TIMESTAMPADD", "TIMESTAMPDIFF", "TIMESTAMP_FORMAT", "TIMESTAMP_ISO", "TIMESTAMP_TZ", "TO_CHAR", "TO_CLOB", "TO_DATE", "TO_NUMBER", "TOTALORDER", "TO_TIMESTAMP", "TRANSLATE", "TRIM", "TRIM_ARRAY", "TRUNCATE", "TRUNC", "TRUNC_TIMESTAMP", "UCASE", "UNICODE", "UNICODE_STR", "UNISTR", "UPPER", "VALUE", "VARBINARY", "VARCHAR", "VARCHAR9", "VARCHAR_BIT_FORMAT", "VARCHAR_FORMAT", "VARGRAPHIC", "VERIFY_GROUP_FOR_USER", "VERIFY_ROLE_FOR_USER", "VERIFY_TRUSTED_CONTEXT_ROLE_FOR_USER", "WEEK", "WEEK_ISO", "WRAP", "XMLATTRIBUTES", "XMLCOMMENT", "XMLCONCAT", "XMLDOCUMENT", "XMLELEMENT", "XMLFOREST", "XMLMODIFY", "XMLNAMESPACES", "XMLPARSE", "XMLPI", "XMLQUERY", "XMLSERIALIZE", "XMLTEXT", "XMLXSROBJECTID", "XSLTRANSFORM", "YEAR"],
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-table
  table: ["ADMIN_TASK_LIST", "ADMIN_TASK_OUTPUT", "ADMIN_TASK_STATUS", "BLOCKING_THREADS", "MQREADALL", "MQREADALLCLOB", "MQRECEIVEALL", "MQRECEIVEALLCLOB", "XMLTABLE"],
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-row
  row: ["UNPACK"],
  // https://www.ibm.com/docs/en/db2-for-zos/12?topic=expressions-olap-specification
  olap: ["CUME_DIST", "PERCENT_RANK", "RANK", "DENSE_RANK", "NTILE", "LAG", "LEAD", "ROW_NUMBER", "FIRST_VALUE", "LAST_VALUE", "NTH_VALUE", "RATIO_TO_REPORT"],
  // Type casting
  cast: ["CAST"]
}), z0 = en({
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=words-reserved#db2z_reservedwords__newresword
  standard: ["ALL", "ALLOCATE", "ALLOW", "ALTERAND", "ANY", "AS", "ARRAY", "ARRAY_EXISTS", "ASENSITIVE", "ASSOCIATE", "ASUTIME", "AT", "AUDIT", "AUX", "AUXILIARY", "BEFORE", "BEGIN", "BETWEEN", "BUFFERPOOL", "BY", "CAPTURE", "CASCADED", "CAST", "CCSID", "CHARACTER", "CHECK", "CLONE", "CLUSTER", "COLLECTION", "COLLID", "COLUMN", "CONDITION", "CONNECTION", "CONSTRAINT", "CONTENT", "CONTINUE", "CREATE", "CUBE", "CURRENT", "CURRENT_DATE", "CURRENT_LC_CTYPE", "CURRENT_PATH", "CURRENT_SCHEMA", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRVAL", "CURSOR", "DATA", "DATABASE", "DBINFO", "DECLARE", "DEFAULT", "DESCRIPTOR", "DETERMINISTIC", "DISABLE", "DISALLOW", "DISTINCT", "DO", "DOCUMENT", "DSSIZE", "DYNAMIC", "EDITPROC", "ELSE", "ELSEIF", "ENCODING", "ENCRYPTION", "ENDING", "END-EXEC", "ERASE", "ESCAPE", "EXCEPTION", "EXISTS", "EXIT", "EXTERNAL", "FENCED", "FIELDPROC", "FINAL", "FIRST", "FOR", "FREE", "FULL", "FUNCTION", "GENERATED", "GET", "GLOBAL", "GOTO", "GROUP", "HANDLER", "HOLD", "HOURS", "IF", "IMMEDIATE", "IN", "INCLUSIVE", "INDEX", "INHERIT", "INNER", "INOUT", "INSENSITIVE", "INTO", "IS", "ISOBID", "ITERATE", "JAR", "KEEP", "KEY", "LANGUAGE", "LAST", "LC_CTYPE", "LEAVE", "LIKE", "LOCAL", "LOCALE", "LOCATOR", "LOCATORS", "LOCK", "LOCKMAX", "LOCKSIZE", "LONG", "LOOP", "MAINTAINED", "MATERIALIZED", "MICROSECONDS", "MINUTEMINUTES", "MODIFIES", "MONTHS", "NEXT", "NEXTVAL", "NO", "NONE", "NOT", "NULL", "NULLS", "NUMPARTS", "OBID", "OF", "OLD", "ON", "OPTIMIZATION", "OPTIMIZE", "ORDER", "ORGANIZATION", "OUT", "OUTER", "PACKAGE", "PARAMETER", "PART", "PADDED", "PARTITION", "PARTITIONED", "PARTITIONING", "PATH", "PIECESIZE", "PERIOD", "PLAN", "PRECISION", "PREVVAL", "PRIOR", "PRIQTY", "PRIVILEGES", "PROCEDURE", "PROGRAM", "PSID", "PUBLIC", "QUERY", "QUERYNO", "READS", "REFERENCES", "RESIGNAL", "RESTRICT", "RESULT", "RESULT_SET_LOCATOR", "RETURN", "RETURNS", "ROLE", "ROLLUP", "ROUND_CEILING", "ROUND_DOWN", "ROUND_FLOOR", "ROUND_HALF_DOWN", "ROUND_HALF_EVEN", "ROUND_HALF_UP", "ROUND_UP", "ROW", "ROWSET", "SCHEMA", "SCRATCHPAD", "SECONDS", "SECQTY", "SECURITY", "SEQUENCE", "SENSITIVE", "SESSION_USER", "SIMPLE", "SOME", "SOURCE", "SPECIFIC", "STANDARD", "STATIC", "STATEMENT", "STAY", "STOGROUP", "STORES", "STYLE", "SUMMARY", "SYNONYM", "SYSDATE", "SYSTEM", "SYSTIMESTAMP", "TABLE", "TABLESPACE", "THEN", "TO", "TRIGGER", "TYPE", "UNDO", "UNIQUE", "UNTIL", "USER", "USING", "VALIDPROC", "VARIABLE", "VARIANT", "VCAT", "VERSIONING", "VIEW", "VOLATILE", "VOLUMES", "WHILE", "WLM", "XMLEXISTS", "XMLCAST", "YEARS", "ZONE"]
}), J0 = pe(["SELECT [ALL | DISTINCT]"]), Q0 = pe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY [INPUT SEQUENCE]",
  "FETCH FIRST",
  // Data modification
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE INTO",
  "WHEN [NOT] MATCHED [THEN]",
  "UPDATE SET",
  "INSERT",
  // Data definition
  "CREATE [OR REPLACE] VIEW",
  "CREATE [GLOBAL TEMPORARY] TABLE"
]), _m = pe([
  // - update:
  "UPDATE",
  "WHERE CURRENT OF",
  "WITH {RR | RS | CS | UR}",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [HIERARCHY]",
  // alter table:
  "ALTER TABLE",
  "ADD [COLUMN]",
  "DROP [COLUMN]",
  "RENAME [COLUMN]",
  "ALTER [COLUMN]",
  "SET DATA TYPE",
  // for alter column
  "SET NOT NULL",
  // for alter column
  "DROP {IDENTITY | EXPRESSION | DEFAULT | NOT NULL}",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // other
  "SET [CURRENT] SCHEMA",
  "AFTER",
  "GO",
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=statements-list-supported
  "ALLOCATE CURSOR",
  "ALTER DATABASE",
  "ALTER FUNCTION",
  "ALTER INDEX",
  "ALTER MASK",
  "ALTER PERMISSION",
  "ALTER PROCEDURE",
  "ALTER SEQUENCE",
  "ALTER STOGROUP",
  "ALTER TABLESPACE",
  "ALTER TRIGGER",
  "ALTER TRUSTED CONTEXT",
  "ALTER VIEW",
  "ASSOCIATE LOCATORS",
  "BEGIN DECLARE SECTION",
  "CALL",
  "CLOSE",
  "COMMENT",
  "COMMIT",
  "CONNECT",
  "CREATE ALIAS",
  "CREATE AUXILIARY TABLE",
  "CREATE DATABASE",
  "CREATE FUNCTION",
  "CREATE GLOBAL TEMPORARY TABLE",
  "CREATE INDEX",
  "CREATE LOB TABLESPACE",
  "CREATE MASK",
  "CREATE PERMISSION",
  "CREATE PROCEDURE",
  "CREATE ROLE",
  "CREATE SEQUENCE",
  "CREATE STOGROUP",
  "CREATE SYNONYM",
  "CREATE TABLESPACE",
  "CREATE TRIGGER",
  "CREATE TRUSTED CONTEXT",
  "CREATE TYPE",
  "CREATE VARIABLE",
  "DECLARE CURSOR",
  "DECLARE GLOBAL TEMPORARY TABLE",
  "DECLARE STATEMENT",
  "DECLARE TABLE",
  "DECLARE VARIABLE",
  "DESCRIBE CURSOR",
  "DESCRIBE INPUT",
  "DESCRIBE OUTPUT",
  "DESCRIBE PROCEDURE",
  "DESCRIBE TABLE",
  "DROP",
  "END DECLARE SECTION",
  "EXCHANGE",
  "EXECUTE",
  "EXECUTE IMMEDIATE",
  "EXPLAIN",
  "FETCH",
  "FREE LOCATOR",
  "GET DIAGNOSTICS",
  "GRANT",
  "HOLD LOCATOR",
  "INCLUDE",
  "LABEL",
  "LOCK TABLE",
  "OPEN",
  "PREPARE",
  "REFRESH",
  "RELEASE",
  "RELEASE SAVEPOINT",
  "RENAME",
  "REVOKE",
  "ROLLBACK",
  "SAVEPOINT",
  "SELECT INTO",
  "SET CONNECTION",
  "SET CURRENT ACCELERATOR",
  "SET CURRENT APPLICATION COMPATIBILITY",
  "SET CURRENT APPLICATION ENCODING SCHEME",
  "SET CURRENT DEBUG MODE",
  "SET CURRENT DECFLOAT ROUNDING MODE",
  "SET CURRENT DEGREE",
  "SET CURRENT EXPLAIN MODE",
  "SET CURRENT GET_ACCEL_ARCHIVE",
  "SET CURRENT LOCALE LC_CTYPE",
  "SET CURRENT MAINTAINED TABLE TYPES FOR OPTIMIZATION",
  "SET CURRENT OPTIMIZATION HINT",
  "SET CURRENT PACKAGE PATH",
  "SET CURRENT PACKAGESET",
  "SET CURRENT PRECISION",
  "SET CURRENT QUERY ACCELERATION",
  "SET CURRENT QUERY ACCELERATION WAITFORDATA",
  "SET CURRENT REFRESH AGE",
  "SET CURRENT ROUTINE VERSION",
  "SET CURRENT RULES",
  "SET CURRENT SQLID",
  "SET CURRENT TEMPORAL BUSINESS_TIME",
  "SET CURRENT TEMPORAL SYSTEM_TIME",
  "SET ENCRYPTION PASSWORD",
  "SET PATH",
  "SET SESSION TIME ZONE",
  "SIGNAL",
  "VALUES INTO",
  "WHENEVER"
]), Z0 = pe(["UNION [ALL]", "EXCEPT [ALL]", "INTERSECT [ALL]"]), q0 = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN"]), $0 = pe(["ON DELETE", "ON UPDATE", "SET NULL", "{ROWS | RANGE} BETWEEN"]), eG = {
  tokenizerOptions: {
    reservedSelect: J0,
    reservedClauses: [...Q0, ..._m],
    reservedSetOperations: Z0,
    reservedJoins: q0,
    reservedPhrases: $0,
    reservedKeywords: z0,
    reservedFunctionNames: j0,
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["G", "N", "U&"]
    }, {
      quote: "''-raw",
      prefixes: ["X", "BX", "GX", "UX"],
      requirePrefix: !0
    }],
    identTypes: ['""-qq'],
    identChars: {
      first: "@#$"
    },
    paramTypes: {
      positional: !0,
      named: [":"]
    },
    paramChars: {
      first: "@#$",
      rest: "@#$"
    },
    operators: ["**", "¬=", "¬>", "¬<", "!>", "!<", "||"]
  },
  formatOptions: {
    onelineClauses: _m
  }
}, tG = en({
  // https://cwiki.apache.org/confluence/display/Hive/LanguageManual+UDF
  math: [
    "ABS",
    "ACOS",
    "ASIN",
    "ATAN",
    "BIN",
    "BROUND",
    "CBRT",
    "CEIL",
    "CEILING",
    "CONV",
    "COS",
    "DEGREES",
    // 'E',
    "EXP",
    "FACTORIAL",
    "FLOOR",
    "GREATEST",
    "HEX",
    "LEAST",
    "LN",
    "LOG",
    "LOG10",
    "LOG2",
    "NEGATIVE",
    "PI",
    "PMOD",
    "POSITIVE",
    "POW",
    "POWER",
    "RADIANS",
    "RAND",
    "ROUND",
    "SHIFTLEFT",
    "SHIFTRIGHT",
    "SHIFTRIGHTUNSIGNED",
    "SIGN",
    "SIN",
    "SQRT",
    "TAN",
    "UNHEX",
    "WIDTH_BUCKET"
  ],
  array: ["ARRAY_CONTAINS", "MAP_KEYS", "MAP_VALUES", "SIZE", "SORT_ARRAY"],
  conversion: ["BINARY", "CAST"],
  date: ["ADD_MONTHS", "DATE", "DATE_ADD", "DATE_FORMAT", "DATE_SUB", "DATEDIFF", "DAY", "DAYNAME", "DAYOFMONTH", "DAYOFYEAR", "EXTRACT", "FROM_UNIXTIME", "FROM_UTC_TIMESTAMP", "HOUR", "LAST_DAY", "MINUTE", "MONTH", "MONTHS_BETWEEN", "NEXT_DAY", "QUARTER", "SECOND", "TIMESTAMP", "TO_DATE", "TO_UTC_TIMESTAMP", "TRUNC", "UNIX_TIMESTAMP", "WEEKOFYEAR", "YEAR"],
  conditional: ["ASSERT_TRUE", "COALESCE", "IF", "ISNOTNULL", "ISNULL", "NULLIF", "NVL"],
  string: ["ASCII", "BASE64", "CHARACTER_LENGTH", "CHR", "CONCAT", "CONCAT_WS", "CONTEXT_NGRAMS", "DECODE", "ELT", "ENCODE", "FIELD", "FIND_IN_SET", "FORMAT_NUMBER", "GET_JSON_OBJECT", "IN_FILE", "INITCAP", "INSTR", "LCASE", "LENGTH", "LEVENSHTEIN", "LOCATE", "LOWER", "LPAD", "LTRIM", "NGRAMS", "OCTET_LENGTH", "PARSE_URL", "PRINTF", "QUOTE", "REGEXP_EXTRACT", "REGEXP_REPLACE", "REPEAT", "REVERSE", "RPAD", "RTRIM", "SENTENCES", "SOUNDEX", "SPACE", "SPLIT", "STR_TO_MAP", "SUBSTR", "SUBSTRING", "TRANSLATE", "TRIM", "UCASE", "UNBASE64", "UPPER"],
  masking: ["MASK", "MASK_FIRST_N", "MASK_HASH", "MASK_LAST_N", "MASK_SHOW_FIRST_N", "MASK_SHOW_LAST_N"],
  misc: ["AES_DECRYPT", "AES_ENCRYPT", "CRC32", "CURRENT_DATABASE", "CURRENT_USER", "HASH", "JAVA_METHOD", "LOGGED_IN_USER", "MD5", "REFLECT", "SHA", "SHA1", "SHA2", "SURROGATE_KEY", "VERSION"],
  aggregate: ["AVG", "COLLECT_LIST", "COLLECT_SET", "CORR", "COUNT", "COVAR_POP", "COVAR_SAMP", "HISTOGRAM_NUMERIC", "MAX", "MIN", "NTILE", "PERCENTILE", "PERCENTILE_APPROX", "REGR_AVGX", "REGR_AVGY", "REGR_COUNT", "REGR_INTERCEPT", "REGR_R2", "REGR_SLOPE", "REGR_SXX", "REGR_SXY", "REGR_SYY", "STDDEV_POP", "STDDEV_SAMP", "SUM", "VAR_POP", "VAR_SAMP", "VARIANCE"],
  table: ["EXPLODE", "INLINE", "JSON_TUPLE", "PARSE_URL_TUPLE", "POSEXPLODE", "STACK"],
  // https://cwiki.apache.org/confluence/display/Hive/LanguageManual+WindowingAndAnalytics
  window: ["LEAD", "LAG", "FIRST_VALUE", "LAST_VALUE", "RANK", "ROW_NUMBER", "DENSE_RANK", "CUME_DIST", "PERCENT_RANK", "NTILE"],
  // Parameterized data types
  // https://cwiki.apache.org/confluence/pages/viewpage.action?pageId=82706456
  // Though in reality Hive only supports parameters for DECIMAL(),
  // it doesn't hurt to allow others in here as well.
  dataTypes: ["DECIMAL", "NUMERIC", "VARCHAR", "CHAR"]
}), nG = en({
  // https://cwiki.apache.org/confluence/display/hive/languagemanual+ddl
  // Non-reserved keywords have proscribed meanings in. HiveQL, but can still be used as table or column names
  nonReserved: ["ADD", "ADMIN", "AFTER", "ANALYZE", "ARCHIVE", "ASC", "BEFORE", "BUCKET", "BUCKETS", "CASCADE", "CHANGE", "CLUSTER", "CLUSTERED", "CLUSTERSTATUS", "COLLECTION", "COLUMNS", "COMMENT", "COMPACT", "COMPACTIONS", "COMPUTE", "CONCATENATE", "CONTINUE", "DATA", "DATABASES", "DATETIME", "DAY", "DBPROPERTIES", "DEFERRED", "DEFINED", "DELIMITED", "DEPENDENCY", "DESC", "DIRECTORIES", "DIRECTORY", "DISABLE", "DISTRIBUTE", "ELEM_TYPE", "ENABLE", "ESCAPED", "EXCLUSIVE", "EXPLAIN", "EXPORT", "FIELDS", "FILE", "FILEFORMAT", "FIRST", "FORMAT", "FORMATTED", "FUNCTIONS", "HOLD_DDLTIME", "HOUR", "IDXPROPERTIES", "IGNORE", "INDEX", "INDEXES", "INPATH", "INPUTDRIVER", "INPUTFORMAT", "ITEMS", "JAR", "KEYS", "KEY_TYPE", "LIMIT", "LINES", "LOAD", "LOCATION", "LOCK", "LOCKS", "LOGICAL", "LONG", "MAPJOIN", "MATERIALIZED", "METADATA", "MINUS", "MINUTE", "MONTH", "MSCK", "NOSCAN", "NO_DROP", "OFFLINE", "OPTION", "OUTPUTDRIVER", "OUTPUTFORMAT", "OVERWRITE", "OWNER", "PARTITIONED", "PARTITIONS", "PLUS", "PRETTY", "PRINCIPALS", "PROTECTION", "PURGE", "READ", "READONLY", "REBUILD", "RECORDREADER", "RECORDWRITER", "RELOAD", "RENAME", "REPAIR", "REPLACE", "REPLICATION", "RESTRICT", "REWRITE", "ROLE", "ROLES", "SCHEMA", "SCHEMAS", "SECOND", "SEMI", "SERDE", "SERDEPROPERTIES", "SERVER", "SETS", "SHARED", "SHOW", "SHOW_DATABASE", "SKEWED", "SORT", "SORTED", "SSL", "STATISTICS", "STORED", "STREAMTABLE", "STRING", "STRUCT", "TABLES", "TBLPROPERTIES", "TEMPORARY", "TERMINATED", "TINYINT", "TOUCH", "TRANSACTIONS", "UNARCHIVE", "UNDO", "UNIONTYPE", "UNLOCK", "UNSET", "UNSIGNED", "URI", "USE", "UTC", "UTCTIMESTAMP", "VALUE_TYPE", "VIEW", "WHILE", "YEAR", "AUTOCOMMIT", "ISOLATION", "LEVEL", "OFFSET", "SNAPSHOT", "TRANSACTION", "WORK", "WRITE", "ABORT", "KEY", "LAST", "NORELY", "NOVALIDATE", "NULLS", "RELY", "VALIDATE", "DETAIL", "DOW", "EXPRESSION", "OPERATOR", "QUARTER", "SUMMARY", "VECTORIZATION", "WEEK", "YEARS", "MONTHS", "WEEKS", "DAYS", "HOURS", "MINUTES", "SECONDS", "TIMESTAMPTZ", "ZONE"],
  reserved: ["ALL", "ALTER", "AND", "ARRAY", "AS", "AUTHORIZATION", "BETWEEN", "BIGINT", "BINARY", "BOOLEAN", "BOTH", "BY", "CASE", "CAST", "CHAR", "COLUMN", "CONF", "CREATE", "CROSS", "CUBE", "CURRENT", "CURRENT_DATE", "CURRENT_TIMESTAMP", "CURSOR", "DATABASE", "DATE", "DECIMAL", "DELETE", "DESCRIBE", "DISTINCT", "DOUBLE", "DROP", "ELSE", "END", "EXCHANGE", "EXISTS", "EXTENDED", "EXTERNAL", "FALSE", "FETCH", "FLOAT", "FOLLOWING", "FOR", "FROM", "FULL", "FUNCTION", "GRANT", "GROUP", "GROUPING", "HAVING", "IF", "IMPORT", "IN", "INNER", "INSERT", "INT", "INTERSECT", "INTERVAL", "INTO", "IS", "JOIN", "LATERAL", "LEFT", "LESS", "LIKE", "LOCAL", "MACRO", "MAP", "MORE", "NONE", "NOT", "NULL", "OF", "ON", "OR", "ORDER", "OUT", "OUTER", "OVER", "PARTIALSCAN", "PARTITION", "PERCENT", "PRECEDING", "PRESERVE", "PROCEDURE", "RANGE", "READS", "REDUCE", "REVOKE", "RIGHT", "ROLLUP", "ROW", "ROWS", "SELECT", "SET", "SMALLINT", "TABLE", "TABLESAMPLE", "THEN", "TIMESTAMP", "TO", "TRANSFORM", "TRIGGER", "TRUE", "TRUNCATE", "UNBOUNDED", "UNION", "UNIQUEJOIN", "UPDATE", "USER", "USING", "UTC_TMESTAMP", "VALUES", "VARCHAR", "WHEN", "WHERE", "WINDOW", "WITH", "COMMIT", "ONLY", "REGEXP", "RLIKE", "ROLLBACK", "START", "CACHE", "CONSTRAINT", "FOREIGN", "PRIMARY", "REFERENCES", "DAYOFWEEK", "EXTRACT", "FLOOR", "INTEGER", "PRECISION", "VIEWS", "TIME", "NUMERIC", "SYNC"],
  fileTypes: ["TEXTFILE", "SEQUENCEFILE", "ORC", "CSV", "TSV", "PARQUET", "AVRO", "RCFILE", "JSONFILE", "INPUTFORMAT", "OUTPUTFORMAT"]
}), rG = pe(["SELECT [ALL | DISTINCT]"]), aG = pe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "SORT BY",
  "CLUSTER BY",
  "DISTRIBUTE BY",
  "LIMIT",
  // Data manipulation
  // - insert:
  //   Hive does not actually support plain INSERT INTO, only INSERT INTO TABLE
  //   but it's a nuisance to not support it, as all other dialects do.
  "INSERT INTO [TABLE]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE INTO",
  "WHEN [NOT] MATCHED [THEN]",
  "UPDATE SET",
  "INSERT [VALUES]",
  // - insert overwrite directory:
  //   https://cwiki.apache.org/confluence/display/Hive/LanguageManual+DML#LanguageManualDML-Writingdataintothefilesystemfromqueries
  "INSERT OVERWRITE [LOCAL] DIRECTORY",
  // - load:
  //   https://cwiki.apache.org/confluence/display/Hive/LanguageManual+DML#LanguageManualDML-Loadingfilesintotables
  "LOAD DATA [LOCAL] INPATH",
  "[OVERWRITE] INTO TABLE",
  // Data definition
  "CREATE [MATERIALIZED] VIEW [IF NOT EXISTS]",
  "CREATE [TEMPORARY] [EXTERNAL] TABLE [IF NOT EXISTS]"
]), Gm = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "RENAME TO",
  // - truncate:
  "TRUNCATE [TABLE]",
  // other
  "ALTER",
  "CREATE",
  "USE",
  "DESCRIBE",
  "DROP",
  "FETCH",
  "SHOW",
  "STORED AS",
  "STORED BY",
  "ROW FORMAT"
]), iG = pe(["UNION [ALL | DISTINCT]"]), oG = pe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  // non-standard joins
  "LEFT SEMI JOIN"
]), lG = pe(["{ROWS | RANGE} BETWEEN"]), sG = {
  tokenizerOptions: {
    reservedSelect: rG,
    reservedClauses: [...aG, ...Gm],
    reservedSetOperations: iG,
    reservedJoins: oG,
    reservedPhrases: lG,
    reservedKeywords: nG,
    reservedFunctionNames: tG,
    extraParens: ["[]"],
    stringTypes: ['""-bs', "''-bs"],
    identTypes: ["``"],
    variableTypes: [{
      quote: "{}",
      prefixes: ["$"],
      requirePrefix: !0
    }],
    operators: ["%", "~", "^", "|", "&", "<=>", "==", "!", "||"]
  },
  formatOptions: {
    onelineClauses: Gm
  }
}, uG = en({
  // https://mariadb.com/kb/en/information-schema-keywords-table/
  all: [
    "ACCESSIBLE",
    "ACCOUNT",
    "ACTION",
    "ADD",
    "ADMIN",
    "AFTER",
    "AGAINST",
    "AGGREGATE",
    "ALL",
    "ALGORITHM",
    "ALTER",
    "ALWAYS",
    "ANALYZE",
    "AND",
    "ANY",
    "AS",
    "ASC",
    "ASCII",
    "ASENSITIVE",
    "AT",
    "ATOMIC",
    "AUTHORS",
    "AUTO_INCREMENT",
    "AUTOEXTEND_SIZE",
    "AUTO",
    "AVG",
    "AVG_ROW_LENGTH",
    "BACKUP",
    "BEFORE",
    "BEGIN",
    "BETWEEN",
    "BIGINT",
    "BINARY",
    "BINLOG",
    "BIT",
    "BLOB",
    "BLOCK",
    "BODY",
    "BOOL",
    "BOOLEAN",
    "BOTH",
    "BTREE",
    "BY",
    "BYTE",
    "CACHE",
    "CALL",
    "CASCADE",
    "CASCADED",
    "CASE",
    "CATALOG_NAME",
    "CHAIN",
    "CHANGE",
    "CHANGED",
    "CHAR",
    "CHARACTER",
    "CHARSET",
    "CHECK",
    "CHECKPOINT",
    "CHECKSUM",
    "CIPHER",
    "CLASS_ORIGIN",
    "CLIENT",
    "CLOB",
    "CLOSE",
    "COALESCE",
    "CODE",
    "COLLATE",
    "COLLATION",
    "COLUMN",
    "COLUMN_NAME",
    "COLUMNS",
    "COLUMN_ADD",
    "COLUMN_CHECK",
    "COLUMN_CREATE",
    "COLUMN_DELETE",
    "COLUMN_GET",
    "COMMENT",
    "COMMIT",
    "COMMITTED",
    "COMPACT",
    "COMPLETION",
    "COMPRESSED",
    "CONCURRENT",
    "CONDITION",
    "CONNECTION",
    "CONSISTENT",
    "CONSTRAINT",
    "CONSTRAINT_CATALOG",
    "CONSTRAINT_NAME",
    "CONSTRAINT_SCHEMA",
    "CONTAINS",
    "CONTEXT",
    "CONTINUE",
    "CONTRIBUTORS",
    "CONVERT",
    "CPU",
    "CREATE",
    "CROSS",
    "CUBE",
    "CURRENT",
    "CURRENT_DATE",
    "CURRENT_POS",
    "CURRENT_ROLE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "CURSOR",
    "CURSOR_NAME",
    "CYCLE",
    "DATA",
    "DATABASE",
    "DATABASES",
    "DATAFILE",
    "DATE",
    "DATETIME",
    "DAY",
    "DAY_HOUR",
    "DAY_MICROSECOND",
    "DAY_MINUTE",
    "DAY_SECOND",
    "DEALLOCATE",
    "DEC",
    "DECIMAL",
    "DECLARE",
    "DEFAULT",
    "DEFINER",
    "DELAYED",
    "DELAY_KEY_WRITE",
    "DELETE",
    "DELETE_DOMAIN_ID",
    "DESC",
    "DESCRIBE",
    "DES_KEY_FILE",
    "DETERMINISTIC",
    "DIAGNOSTICS",
    "DIRECTORY",
    "DISABLE",
    "DISCARD",
    "DISK",
    "DISTINCT",
    "DISTINCTROW",
    "DIV",
    "DO",
    "DOUBLE",
    "DO_DOMAIN_IDS",
    "DROP",
    "DUAL",
    "DUMPFILE",
    "DUPLICATE",
    "DYNAMIC",
    "EACH",
    "ELSE",
    "ELSEIF",
    "ELSIF",
    "EMPTY",
    "ENABLE",
    "ENCLOSED",
    "END",
    "ENDS",
    "ENGINE",
    "ENGINES",
    "ENUM",
    "ERROR",
    "ERRORS",
    "ESCAPE",
    "ESCAPED",
    "EVENT",
    "EVENTS",
    "EVERY",
    "EXAMINED",
    "EXCEPT",
    "EXCHANGE",
    "EXCLUDE",
    "EXECUTE",
    "EXCEPTION",
    "EXISTS",
    "EXIT",
    "EXPANSION",
    "EXPIRE",
    "EXPORT",
    "EXPLAIN",
    "EXTENDED",
    "EXTENT_SIZE",
    "FALSE",
    "FAST",
    "FAULTS",
    "FEDERATED",
    "FETCH",
    "FIELDS",
    "FILE",
    "FIRST",
    "FIXED",
    "FLOAT",
    "FLOAT4",
    "FLOAT8",
    "FLUSH",
    "FOLLOWING",
    "FOLLOWS",
    "FOR",
    "FORCE",
    "FOREIGN",
    "FORMAT",
    "FOUND",
    "FROM",
    "FULL",
    "FULLTEXT",
    "FUNCTION",
    "GENERAL",
    "GENERATED",
    "GET_FORMAT",
    "GET",
    "GLOBAL",
    "GOTO",
    "GRANT",
    "GRANTS",
    "GROUP",
    "HANDLER",
    "HARD",
    "HASH",
    "HAVING",
    "HELP",
    "HIGH_PRIORITY",
    "HISTORY",
    "HOST",
    "HOSTS",
    "HOUR",
    "HOUR_MICROSECOND",
    "HOUR_MINUTE",
    "HOUR_SECOND",
    // 'ID', // conflicts with common column name
    "IDENTIFIED",
    "IF",
    "IGNORE",
    "IGNORED",
    "IGNORE_DOMAIN_IDS",
    "IGNORE_SERVER_IDS",
    "IMMEDIATE",
    "IMPORT",
    "INTERSECT",
    "IN",
    "INCREMENT",
    "INDEX",
    "INDEXES",
    "INFILE",
    "INITIAL_SIZE",
    "INNER",
    "INOUT",
    "INSENSITIVE",
    "INSERT",
    "INSERT_METHOD",
    "INSTALL",
    "INT",
    "INT1",
    "INT2",
    "INT3",
    "INT4",
    "INT8",
    "INTEGER",
    "INTERVAL",
    "INVISIBLE",
    "INTO",
    "IO",
    "IO_THREAD",
    "IPC",
    "IS",
    "ISOLATION",
    "ISOPEN",
    "ISSUER",
    "ITERATE",
    "INVOKER",
    "JOIN",
    "JSON",
    "JSON_TABLE",
    "KEY",
    "KEYS",
    "KEY_BLOCK_SIZE",
    "KILL",
    "LANGUAGE",
    "LAST",
    "LAST_VALUE",
    "LASTVAL",
    "LEADING",
    "LEAVE",
    "LEAVES",
    "LEFT",
    "LESS",
    "LEVEL",
    "LIKE",
    "LIMIT",
    "LINEAR",
    "LINES",
    "LIST",
    "LOAD",
    "LOCAL",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "LOCK",
    "LOCKED",
    "LOCKS",
    "LOGFILE",
    "LOGS",
    "LONG",
    "LONGBLOB",
    "LONGTEXT",
    "LOOP",
    "LOW_PRIORITY",
    "MASTER",
    "MASTER_CONNECT_RETRY",
    "MASTER_DELAY",
    "MASTER_GTID_POS",
    "MASTER_HOST",
    "MASTER_LOG_FILE",
    "MASTER_LOG_POS",
    "MASTER_PASSWORD",
    "MASTER_PORT",
    "MASTER_SERVER_ID",
    "MASTER_SSL",
    "MASTER_SSL_CA",
    "MASTER_SSL_CAPATH",
    "MASTER_SSL_CERT",
    "MASTER_SSL_CIPHER",
    "MASTER_SSL_CRL",
    "MASTER_SSL_CRLPATH",
    "MASTER_SSL_KEY",
    "MASTER_SSL_VERIFY_SERVER_CERT",
    "MASTER_USER",
    "MASTER_USE_GTID",
    "MASTER_HEARTBEAT_PERIOD",
    "MATCH",
    "MAX_CONNECTIONS_PER_HOUR",
    "MAX_QUERIES_PER_HOUR",
    "MAX_ROWS",
    "MAX_SIZE",
    "MAX_STATEMENT_TIME",
    "MAX_UPDATES_PER_HOUR",
    "MAX_USER_CONNECTIONS",
    "MAXVALUE",
    "MEDIUM",
    "MEDIUMBLOB",
    "MEDIUMINT",
    "MEDIUMTEXT",
    "MEMORY",
    "MERGE",
    "MESSAGE_TEXT",
    "MICROSECOND",
    "MIDDLEINT",
    "MIGRATE",
    "MINUS",
    "MINUTE",
    "MINUTE_MICROSECOND",
    "MINUTE_SECOND",
    "MINVALUE",
    "MIN_ROWS",
    "MOD",
    "MODE",
    "MODIFIES",
    "MODIFY",
    "MONITOR",
    "MONTH",
    "MUTEX",
    "MYSQL",
    "MYSQL_ERRNO",
    "NAME",
    "NAMES",
    "NATIONAL",
    "NATURAL",
    "NCHAR",
    "NESTED",
    "NEVER",
    "NEW",
    "NEXT",
    "NEXTVAL",
    "NO",
    "NOMAXVALUE",
    "NOMINVALUE",
    "NOCACHE",
    "NOCYCLE",
    "NO_WAIT",
    "NOWAIT",
    "NODEGROUP",
    "NONE",
    "NOT",
    "NOTFOUND",
    "NO_WRITE_TO_BINLOG",
    "NULL",
    "NUMBER",
    "NUMERIC",
    "NVARCHAR",
    "OF",
    "OFFSET",
    "OLD_PASSWORD",
    "ON",
    "ONE",
    "ONLINE",
    "ONLY",
    "OPEN",
    "OPTIMIZE",
    "OPTIONS",
    "OPTION",
    "OPTIONALLY",
    "OR",
    "ORDER",
    "ORDINALITY",
    "OTHERS",
    "OUT",
    "OUTER",
    "OUTFILE",
    "OVER",
    "OVERLAPS",
    "OWNER",
    "PACKAGE",
    "PACK_KEYS",
    "PAGE",
    "PAGE_CHECKSUM",
    "PARSER",
    "PARSE_VCOL_EXPR",
    "PATH",
    "PERIOD",
    "PARTIAL",
    "PARTITION",
    "PARTITIONING",
    "PARTITIONS",
    "PASSWORD",
    "PERSISTENT",
    "PHASE",
    "PLUGIN",
    "PLUGINS",
    "PORT",
    "PORTION",
    "PRECEDES",
    "PRECEDING",
    "PRECISION",
    "PREPARE",
    "PRESERVE",
    "PREV",
    "PREVIOUS",
    "PRIMARY",
    "PRIVILEGES",
    "PROCEDURE",
    "PROCESS",
    "PROCESSLIST",
    "PROFILE",
    "PROFILES",
    "PROXY",
    "PURGE",
    "QUARTER",
    "QUERY",
    "QUICK",
    "RAISE",
    "RANGE",
    "RAW",
    "READ",
    "READ_ONLY",
    "READ_WRITE",
    "READS",
    "REAL",
    "REBUILD",
    "RECOVER",
    "RECURSIVE",
    "REDO_BUFFER_SIZE",
    "REDOFILE",
    "REDUNDANT",
    "REFERENCES",
    "REGEXP",
    "RELAY",
    "RELAYLOG",
    "RELAY_LOG_FILE",
    "RELAY_LOG_POS",
    "RELAY_THREAD",
    "RELEASE",
    "RELOAD",
    "REMOVE",
    "RENAME",
    "REORGANIZE",
    "REPAIR",
    "REPEATABLE",
    "REPLACE",
    "REPLAY",
    "REPLICA",
    "REPLICAS",
    "REPLICA_POS",
    "REPLICATION",
    "REPEAT",
    "REQUIRE",
    "RESET",
    "RESIGNAL",
    "RESTART",
    "RESTORE",
    "RESTRICT",
    "RESUME",
    "RETURNED_SQLSTATE",
    "RETURN",
    "RETURNING",
    "RETURNS",
    "REUSE",
    "REVERSE",
    "REVOKE",
    "RIGHT",
    "RLIKE",
    "ROLE",
    "ROLLBACK",
    "ROLLUP",
    "ROUTINE",
    "ROW",
    "ROWCOUNT",
    "ROWNUM",
    "ROWS",
    "ROWTYPE",
    "ROW_COUNT",
    "ROW_FORMAT",
    "RTREE",
    "SAVEPOINT",
    "SCHEDULE",
    "SCHEMA",
    "SCHEMA_NAME",
    "SCHEMAS",
    "SECOND",
    "SECOND_MICROSECOND",
    "SECURITY",
    "SELECT",
    "SENSITIVE",
    "SEPARATOR",
    "SEQUENCE",
    "SERIAL",
    "SERIALIZABLE",
    "SESSION",
    "SERVER",
    "SET",
    "SETVAL",
    "SHARE",
    "SHOW",
    "SHUTDOWN",
    "SIGNAL",
    "SIGNED",
    "SIMPLE",
    "SKIP",
    "SLAVE",
    "SLAVES",
    "SLAVE_POS",
    "SLOW",
    "SNAPSHOT",
    "SMALLINT",
    "SOCKET",
    "SOFT",
    "SOME",
    "SONAME",
    "SOUNDS",
    "SOURCE",
    "STAGE",
    "STORED",
    "SPATIAL",
    "SPECIFIC",
    "REF_SYSTEM_ID",
    "SQL",
    "SQLEXCEPTION",
    "SQLSTATE",
    "SQLWARNING",
    "SQL_BIG_RESULT",
    "SQL_BUFFER_RESULT",
    "SQL_CACHE",
    "SQL_CALC_FOUND_ROWS",
    "SQL_NO_CACHE",
    "SQL_SMALL_RESULT",
    "SQL_THREAD",
    "SQL_TSI_SECOND",
    "SQL_TSI_MINUTE",
    "SQL_TSI_HOUR",
    "SQL_TSI_DAY",
    "SQL_TSI_WEEK",
    "SQL_TSI_MONTH",
    "SQL_TSI_QUARTER",
    "SQL_TSI_YEAR",
    "SSL",
    "START",
    "STARTING",
    "STARTS",
    "STATEMENT",
    "STATS_AUTO_RECALC",
    "STATS_PERSISTENT",
    "STATS_SAMPLE_PAGES",
    "STATUS",
    "STOP",
    "STORAGE",
    "STRAIGHT_JOIN",
    "STRING",
    "SUBCLASS_ORIGIN",
    "SUBJECT",
    "SUBPARTITION",
    "SUBPARTITIONS",
    "SUPER",
    "SUSPEND",
    "SWAPS",
    "SWITCHES",
    "SYSDATE",
    "SYSTEM",
    "SYSTEM_TIME",
    "TABLE",
    "TABLE_NAME",
    "TABLES",
    "TABLESPACE",
    "TABLE_CHECKSUM",
    "TEMPORARY",
    "TEMPTABLE",
    "TERMINATED",
    "TEXT",
    "THAN",
    "THEN",
    "TIES",
    "TIME",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TINYBLOB",
    "TINYINT",
    "TINYTEXT",
    "TO",
    "TRAILING",
    "TRANSACTION",
    "TRANSACTIONAL",
    "THREADS",
    "TRIGGER",
    "TRIGGERS",
    "TRUE",
    "TRUNCATE",
    "TYPE",
    "TYPES",
    "UNBOUNDED",
    "UNCOMMITTED",
    "UNDEFINED",
    "UNDO_BUFFER_SIZE",
    "UNDOFILE",
    "UNDO",
    "UNICODE",
    "UNION",
    "UNIQUE",
    "UNKNOWN",
    "UNLOCK",
    "UNINSTALL",
    "UNSIGNED",
    "UNTIL",
    "UPDATE",
    "UPGRADE",
    "USAGE",
    "USE",
    "USER",
    "USER_RESOURCES",
    "USE_FRM",
    "USING",
    "UTC_DATE",
    "UTC_TIME",
    "UTC_TIMESTAMP",
    "VALUE",
    "VALUES",
    "VARBINARY",
    "VARCHAR",
    "VARCHARACTER",
    "VARCHAR2",
    "VARIABLES",
    "VARYING",
    "VIA",
    "VIEW",
    "VIRTUAL",
    "VISIBLE",
    "VERSIONING",
    "WAIT",
    "WARNINGS",
    "WEEK",
    "WEIGHT_STRING",
    "WHEN",
    "WHERE",
    "WHILE",
    "WINDOW",
    "WITH",
    "WITHIN",
    "WITHOUT",
    "WORK",
    "WRAPPER",
    "WRITE",
    "X509",
    "XOR",
    "XA",
    "XML",
    "YEAR",
    "YEAR_MONTH",
    "ZEROFILL"
  ]
}), EG = en({
  // https://mariadb.com/kb/en/information-schema-sql_functions-table/
  all: [
    "ADDDATE",
    "ADD_MONTHS",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "CAST",
    "COUNT",
    "CUME_DIST",
    "CURDATE",
    "CURTIME",
    "DATE_ADD",
    "DATE_SUB",
    "DATE_FORMAT",
    "DECODE",
    "DENSE_RANK",
    "EXTRACT",
    "FIRST_VALUE",
    "GROUP_CONCAT",
    "JSON_ARRAYAGG",
    "JSON_OBJECTAGG",
    "LAG",
    "LEAD",
    "MAX",
    "MEDIAN",
    "MID",
    "MIN",
    "NOW",
    "NTH_VALUE",
    "NTILE",
    "POSITION",
    "PERCENT_RANK",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "RANK",
    "ROW_NUMBER",
    "SESSION_USER",
    "STD",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "SUBDATE",
    "SUBSTR",
    "SUBSTRING",
    "SUM",
    "SYSTEM_USER",
    "TRIM",
    "TRIM_ORACLE",
    "VARIANCE",
    "VAR_POP",
    "VAR_SAMP",
    "ABS",
    "ACOS",
    "ADDTIME",
    "AES_DECRYPT",
    "AES_ENCRYPT",
    "ASIN",
    "ATAN",
    "ATAN2",
    "BENCHMARK",
    "BIN",
    "BINLOG_GTID_POS",
    "BIT_COUNT",
    "BIT_LENGTH",
    "CEIL",
    "CEILING",
    "CHARACTER_LENGTH",
    "CHAR_LENGTH",
    "CHR",
    "COERCIBILITY",
    "COLUMN_CHECK",
    "COLUMN_EXISTS",
    "COLUMN_LIST",
    "COLUMN_JSON",
    "COMPRESS",
    "CONCAT",
    "CONCAT_OPERATOR_ORACLE",
    "CONCAT_WS",
    "CONNECTION_ID",
    "CONV",
    "CONVERT_TZ",
    "COS",
    "COT",
    "CRC32",
    "DATEDIFF",
    "DAYNAME",
    "DAYOFMONTH",
    "DAYOFWEEK",
    "DAYOFYEAR",
    "DEGREES",
    "DECODE_HISTOGRAM",
    "DECODE_ORACLE",
    "DES_DECRYPT",
    "DES_ENCRYPT",
    "ELT",
    "ENCODE",
    "ENCRYPT",
    "EXP",
    "EXPORT_SET",
    "EXTRACTVALUE",
    "FIELD",
    "FIND_IN_SET",
    "FLOOR",
    "FORMAT",
    "FOUND_ROWS",
    "FROM_BASE64",
    "FROM_DAYS",
    "FROM_UNIXTIME",
    "GET_LOCK",
    "GREATEST",
    "HEX",
    "IFNULL",
    "INSTR",
    "ISNULL",
    "IS_FREE_LOCK",
    "IS_USED_LOCK",
    "JSON_ARRAY",
    "JSON_ARRAY_APPEND",
    "JSON_ARRAY_INSERT",
    "JSON_COMPACT",
    "JSON_CONTAINS",
    "JSON_CONTAINS_PATH",
    "JSON_DEPTH",
    "JSON_DETAILED",
    "JSON_EXISTS",
    "JSON_EXTRACT",
    "JSON_INSERT",
    "JSON_KEYS",
    "JSON_LENGTH",
    "JSON_LOOSE",
    "JSON_MERGE",
    "JSON_MERGE_PATCH",
    "JSON_MERGE_PRESERVE",
    "JSON_QUERY",
    "JSON_QUOTE",
    "JSON_OBJECT",
    "JSON_REMOVE",
    "JSON_REPLACE",
    "JSON_SET",
    "JSON_SEARCH",
    "JSON_TYPE",
    "JSON_UNQUOTE",
    "JSON_VALID",
    "JSON_VALUE",
    "LAST_DAY",
    "LAST_INSERT_ID",
    "LCASE",
    "LEAST",
    "LENGTH",
    "LENGTHB",
    "LN",
    "LOAD_FILE",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG2",
    "LOWER",
    "LPAD",
    "LPAD_ORACLE",
    "LTRIM",
    "LTRIM_ORACLE",
    "MAKEDATE",
    "MAKETIME",
    "MAKE_SET",
    "MASTER_GTID_WAIT",
    "MASTER_POS_WAIT",
    "MD5",
    "MONTHNAME",
    "NAME_CONST",
    "NVL",
    "NVL2",
    "OCT",
    "OCTET_LENGTH",
    "ORD",
    "PERIOD_ADD",
    "PERIOD_DIFF",
    "PI",
    "POW",
    "POWER",
    "QUOTE",
    "REGEXP_INSTR",
    "REGEXP_REPLACE",
    "REGEXP_SUBSTR",
    "RADIANS",
    "RAND",
    "RELEASE_ALL_LOCKS",
    "RELEASE_LOCK",
    "REPLACE_ORACLE",
    "REVERSE",
    "ROUND",
    "RPAD",
    "RPAD_ORACLE",
    "RTRIM",
    "RTRIM_ORACLE",
    "SEC_TO_TIME",
    "SHA",
    "SHA1",
    "SHA2",
    "SIGN",
    "SIN",
    "SLEEP",
    "SOUNDEX",
    "SPACE",
    "SQRT",
    "STRCMP",
    "STR_TO_DATE",
    "SUBSTR_ORACLE",
    "SUBSTRING_INDEX",
    "SUBTIME",
    "SYS_GUID",
    "TAN",
    "TIMEDIFF",
    "TIME_FORMAT",
    "TIME_TO_SEC",
    "TO_BASE64",
    "TO_CHAR",
    "TO_DAYS",
    "TO_SECONDS",
    "UCASE",
    "UNCOMPRESS",
    "UNCOMPRESSED_LENGTH",
    "UNHEX",
    "UNIX_TIMESTAMP",
    "UPDATEXML",
    "UPPER",
    "UUID",
    "UUID_SHORT",
    "VERSION",
    "WEEKDAY",
    "WEEKOFYEAR",
    "WSREP_LAST_WRITTEN_GTID",
    "WSREP_LAST_SEEN_GTID",
    "WSREP_SYNC_WAIT_UPTO_GTID",
    "YEARWEEK",
    // CASE expression shorthands
    "COALESCE",
    "NULLIF",
    // Data types with parameters
    // https://mariadb.com/kb/en/data-types/
    "TINYINT",
    "SMALLINT",
    "MEDIUMINT",
    "INT",
    "INTEGER",
    "BIGINT",
    "DECIMAL",
    "DEC",
    "NUMERIC",
    "FIXED",
    // 'NUMBER', // ?? In oracle mode only
    "FLOAT",
    "DOUBLE",
    "DOUBLE PRECISION",
    "REAL",
    "BIT",
    "BINARY",
    "BLOB",
    "CHAR",
    "NATIONAL CHAR",
    "CHAR BYTE",
    "ENUM",
    "VARBINARY",
    "VARCHAR",
    "NATIONAL VARCHAR",
    // 'SET' // handled as special-case in postProcess
    "TIME",
    "DATETIME",
    "TIMESTAMP",
    "YEAR"
  ]
}), cG = pe(["SELECT [ALL | DISTINCT | DISTINCTROW]"]), TG = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT [LOW_PRIORITY | DELAYED | HIGH_PRIORITY] [IGNORE] [INTO]",
  "REPLACE [LOW_PRIORITY | DELAYED] [INTO]",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [SQL SECURITY DEFINER | SQL SECURITY INVOKER] VIEW [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [TEMPORARY] TABLE [IF NOT EXISTS]",
  // other
  "RETURNING"
]), xm = pe([
  // - update:
  "UPDATE [LOW_PRIORITY] [IGNORE]",
  // - delete:
  "DELETE [LOW_PRIORITY] [QUICK] [IGNORE] FROM",
  // - drop table:
  "DROP [TEMPORARY] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER [ONLINE] [IGNORE] TABLE [IF EXISTS]",
  "ADD [COLUMN] [IF NOT EXISTS]",
  "{CHANGE | MODIFY} [COLUMN] [IF EXISTS]",
  "DROP [COLUMN] [IF EXISTS]",
  "RENAME [TO]",
  "RENAME COLUMN",
  "ALTER [COLUMN]",
  "{SET | DROP} DEFAULT",
  // for alter column
  "SET {VISIBLE | INVISIBLE}",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://mariadb.com/docs/reference/mdb/sql-statements/
  "ALTER DATABASE",
  "ALTER DATABASE COMMENT",
  "ALTER EVENT",
  "ALTER FUNCTION",
  "ALTER PROCEDURE",
  "ALTER SCHEMA",
  "ALTER SCHEMA COMMENT",
  "ALTER SEQUENCE",
  "ALTER SERVER",
  "ALTER USER",
  "ALTER VIEW",
  "ANALYZE",
  "ANALYZE TABLE",
  "BACKUP LOCK",
  "BACKUP STAGE",
  "BACKUP UNLOCK",
  "BEGIN",
  "BINLOG",
  "CACHE INDEX",
  "CALL",
  "CHANGE MASTER TO",
  "CHECK TABLE",
  "CHECK VIEW",
  "CHECKSUM TABLE",
  "COMMIT",
  "CREATE AGGREGATE FUNCTION",
  "CREATE DATABASE",
  "CREATE EVENT",
  "CREATE FUNCTION",
  "CREATE INDEX",
  "CREATE PROCEDURE",
  "CREATE ROLE",
  "CREATE SEQUENCE",
  "CREATE SERVER",
  "CREATE SPATIAL INDEX",
  "CREATE TRIGGER",
  "CREATE UNIQUE INDEX",
  "CREATE USER",
  "DEALLOCATE PREPARE",
  "DESCRIBE",
  "DROP DATABASE",
  "DROP EVENT",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP PREPARE",
  "DROP PROCEDURE",
  "DROP ROLE",
  "DROP SEQUENCE",
  "DROP SERVER",
  "DROP TRIGGER",
  "DROP USER",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FLUSH",
  "GET DIAGNOSTICS",
  "GET DIAGNOSTICS CONDITION",
  "GRANT",
  "HANDLER",
  "HELP",
  "INSTALL PLUGIN",
  "INSTALL SONAME",
  "KILL",
  "LOAD DATA INFILE",
  "LOAD INDEX INTO CACHE",
  "LOAD XML INFILE",
  "LOCK TABLE",
  "OPTIMIZE TABLE",
  "PREPARE",
  "PURGE BINARY LOGS",
  "PURGE MASTER LOGS",
  "RELEASE SAVEPOINT",
  "RENAME TABLE",
  "RENAME USER",
  "REPAIR TABLE",
  "REPAIR VIEW",
  "RESET MASTER",
  "RESET QUERY CACHE",
  "RESET REPLICA",
  "RESET SLAVE",
  "RESIGNAL",
  "REVOKE",
  "ROLLBACK",
  "SAVEPOINT",
  "SET CHARACTER SET",
  "SET DEFAULT ROLE",
  "SET GLOBAL TRANSACTION",
  "SET NAMES",
  "SET PASSWORD",
  "SET ROLE",
  "SET STATEMENT",
  "SET TRANSACTION",
  "SHOW",
  "SHOW ALL REPLICAS STATUS",
  "SHOW ALL SLAVES STATUS",
  "SHOW AUTHORS",
  "SHOW BINARY LOGS",
  "SHOW BINLOG EVENTS",
  "SHOW BINLOG STATUS",
  "SHOW CHARACTER SET",
  "SHOW CLIENT_STATISTICS",
  "SHOW COLLATION",
  "SHOW COLUMNS",
  "SHOW CONTRIBUTORS",
  "SHOW CREATE DATABASE",
  "SHOW CREATE EVENT",
  "SHOW CREATE FUNCTION",
  "SHOW CREATE PACKAGE",
  "SHOW CREATE PACKAGE BODY",
  "SHOW CREATE PROCEDURE",
  "SHOW CREATE SEQUENCE",
  "SHOW CREATE TABLE",
  "SHOW CREATE TRIGGER",
  "SHOW CREATE USER",
  "SHOW CREATE VIEW",
  "SHOW DATABASES",
  "SHOW ENGINE",
  "SHOW ENGINE INNODB STATUS",
  "SHOW ENGINES",
  "SHOW ERRORS",
  "SHOW EVENTS",
  "SHOW EXPLAIN",
  "SHOW FUNCTION CODE",
  "SHOW FUNCTION STATUS",
  "SHOW GRANTS",
  "SHOW INDEX",
  "SHOW INDEXES",
  "SHOW INDEX_STATISTICS",
  "SHOW KEYS",
  "SHOW LOCALES",
  "SHOW MASTER LOGS",
  "SHOW MASTER STATUS",
  "SHOW OPEN TABLES",
  "SHOW PACKAGE BODY CODE",
  "SHOW PACKAGE BODY STATUS",
  "SHOW PACKAGE STATUS",
  "SHOW PLUGINS",
  "SHOW PLUGINS SONAME",
  "SHOW PRIVILEGES",
  "SHOW PROCEDURE CODE",
  "SHOW PROCEDURE STATUS",
  "SHOW PROCESSLIST",
  "SHOW PROFILE",
  "SHOW PROFILES",
  "SHOW QUERY_RESPONSE_TIME",
  "SHOW RELAYLOG EVENTS",
  "SHOW REPLICA",
  "SHOW REPLICA HOSTS",
  "SHOW REPLICA STATUS",
  "SHOW SCHEMAS",
  "SHOW SLAVE",
  "SHOW SLAVE HOSTS",
  "SHOW SLAVE STATUS",
  "SHOW STATUS",
  "SHOW STORAGE ENGINES",
  "SHOW TABLE STATUS",
  "SHOW TABLES",
  "SHOW TRIGGERS",
  "SHOW USER_STATISTICS",
  "SHOW VARIABLES",
  "SHOW WARNINGS",
  "SHOW WSREP_MEMBERSHIP",
  "SHOW WSREP_STATUS",
  "SHUTDOWN",
  "SIGNAL",
  "START ALL REPLICAS",
  "START ALL SLAVES",
  "START REPLICA",
  "START SLAVE",
  "START TRANSACTION",
  "STOP ALL REPLICAS",
  "STOP ALL SLAVES",
  "STOP REPLICA",
  "STOP SLAVE",
  "UNINSTALL PLUGIN",
  "UNINSTALL SONAME",
  "UNLOCK TABLE",
  "USE",
  "XA BEGIN",
  "XA COMMIT",
  "XA END",
  "XA PREPARE",
  "XA RECOVER",
  "XA ROLLBACK",
  "XA START"
]), fG = pe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]", "MINUS [ALL | DISTINCT]"]), AG = pe([
  "JOIN",
  "{LEFT | RIGHT} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL JOIN",
  "NATURAL {LEFT | RIGHT} [OUTER] JOIN",
  // non-standard joins
  "STRAIGHT_JOIN"
]), RG = pe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "CHARACTER SET", "{ROWS | RANGE} BETWEEN"]), dG = {
  tokenizerOptions: {
    reservedSelect: cG,
    reservedClauses: [...TG, ...xm],
    reservedSetOperations: fG,
    reservedJoins: AG,
    reservedPhrases: RG,
    supportsXor: !0,
    reservedKeywords: uG,
    reservedFunctionNames: EG,
    // TODO: support _ char set prefixes such as _utf8, _latin1, _binary, _utf8mb4, etc.
    stringTypes: ['""-qq-bs', "''-qq-bs", {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    identChars: {
      first: "$",
      rest: "$",
      allowFirstCharNumber: !0
    },
    variableTypes: [{
      regex: "@@?[A-Za-z0-9_.$]+"
    }, {
      quote: '""-qq-bs',
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "''-qq-bs",
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "``",
      prefixes: ["@"],
      requirePrefix: !0
    }],
    paramTypes: {
      positional: !0
    },
    lineCommentTypes: ["--", "#"],
    operators: ["%", ":=", "&", "|", "^", "~", "<<", ">>", "<=>", "&&", "||", "!"],
    postProcess: SG
  },
  formatOptions: {
    onelineClauses: xm
  }
};
function SG(l) {
  return l.map((u, T) => {
    const N = l[T + 1] || PE;
    return su.SET(u) && N.text === "(" ? {
      ...u,
      type: Re.RESERVED_FUNCTION_NAME
    } : u;
  });
}
const NG = en({
  // https://dev.mysql.com/doc/refman/8.0/en/keywords.html
  all: [
    "ACCESSIBLE",
    // (R)
    "ACCOUNT",
    "ACTION",
    "ACTIVE",
    "ADD",
    // (R)
    "ADMIN",
    "AFTER",
    "AGAINST",
    "AGGREGATE",
    "ALGORITHM",
    "ALL",
    // (R)
    "ALTER",
    // (R)
    "ALWAYS",
    "ANALYZE",
    // (R)
    "AND",
    // (R)
    "ANY",
    "ARRAY",
    "AS",
    // (R)
    "ASC",
    // (R)
    "ASCII",
    "ASENSITIVE",
    // (R)
    "AT",
    "ATTRIBUTE",
    "AUTHENTICATION",
    "AUTOEXTEND_SIZE",
    "AUTO_INCREMENT",
    "AVG",
    "AVG_ROW_LENGTH",
    "BACKUP",
    "BEFORE",
    // (R)
    "BEGIN",
    "BETWEEN",
    // (R)
    "BIGINT",
    // (R)
    "BINARY",
    // (R)
    "BINLOG",
    "BIT",
    "BLOB",
    // (R)
    "BLOCK",
    "BOOL",
    "BOOLEAN",
    "BOTH",
    // (R)
    "BTREE",
    "BUCKETS",
    "BY",
    // (R)
    "BYTE",
    "CACHE",
    "CALL",
    // (R)
    "CASCADE",
    // (R)
    "CASCADED",
    "CASE",
    // (R)
    "CATALOG_NAME",
    "CHAIN",
    "CHALLENGE_RESPONSE",
    "CHANGE",
    // (R)
    "CHANGED",
    "CHANNEL",
    "CHAR",
    // (R)
    "CHARACTER",
    // (R)
    "CHARSET",
    "CHECK",
    // (R)
    "CHECKSUM",
    "CIPHER",
    "CLASS_ORIGIN",
    "CLIENT",
    "CLONE",
    "CLOSE",
    "COALESCE",
    "CODE",
    "COLLATE",
    // (R)
    "COLLATION",
    "COLUMN",
    // (R)
    "COLUMNS",
    "COLUMN_FORMAT",
    "COLUMN_NAME",
    "COMMENT",
    "COMMIT",
    "COMMITTED",
    "COMPACT",
    "COMPLETION",
    "COMPONENT",
    "COMPRESSED",
    "COMPRESSION",
    "CONCURRENT",
    "CONDITION",
    // (R)
    "CONNECTION",
    "CONSISTENT",
    "CONSTRAINT",
    // (R)
    "CONSTRAINT_CATALOG",
    "CONSTRAINT_NAME",
    "CONSTRAINT_SCHEMA",
    "CONTAINS",
    "CONTEXT",
    "CONTINUE",
    // (R)
    "CONVERT",
    // (R)
    "CPU",
    "CREATE",
    // (R)
    "CROSS",
    // (R)
    "CUBE",
    // (R)
    "CUME_DIST",
    // (R)
    "CURRENT",
    "CURRENT_DATE",
    // (R)
    "CURRENT_TIME",
    // (R)
    "CURRENT_TIMESTAMP",
    // (R)
    "CURRENT_USER",
    // (R)
    "CURSOR",
    // (R)
    "CURSOR_NAME",
    "DATA",
    "DATABASE",
    // (R)
    "DATABASES",
    // (R)
    "DATAFILE",
    "DATE",
    "DATETIME",
    "DAY",
    "DAY_HOUR",
    // (R)
    "DAY_MICROSECOND",
    // (R)
    "DAY_MINUTE",
    // (R)
    "DAY_SECOND",
    // (R)
    "DEALLOCATE",
    "DEC",
    // (R)
    "DECIMAL",
    // (R)
    "DECLARE",
    // (R)
    "DEFAULT",
    // (R)
    "DEFAULT_AUTH",
    "DEFINER",
    "DEFINITION",
    "DELAYED",
    // (R)
    "DELAY_KEY_WRITE",
    "DELETE",
    // (R)
    "DENSE_RANK",
    // (R)
    "DESC",
    // (R)
    "DESCRIBE",
    // (R)
    "DESCRIPTION",
    "DETERMINISTIC",
    // (R)
    "DIAGNOSTICS",
    "DIRECTORY",
    "DISABLE",
    "DISCARD",
    "DISK",
    "DISTINCT",
    // (R)
    "DISTINCTROW",
    // (R)
    "DIV",
    // (R)
    "DO",
    "DOUBLE",
    // (R)
    "DROP",
    // (R)
    "DUAL",
    // (R)
    "DUMPFILE",
    "DUPLICATE",
    "DYNAMIC",
    "EACH",
    // (R)
    "ELSE",
    // (R)
    "ELSEIF",
    // (R)
    "EMPTY",
    // (R)
    "ENABLE",
    "ENCLOSED",
    // (R)
    "ENCRYPTION",
    "END",
    "ENDS",
    "ENFORCED",
    "ENGINE",
    "ENGINES",
    "ENGINE_ATTRIBUTE",
    "ENUM",
    "ERROR",
    "ERRORS",
    "ESCAPE",
    "ESCAPED",
    // (R)
    "EVENT",
    "EVENTS",
    "EVERY",
    "EXCEPT",
    // (R)
    "EXCHANGE",
    "EXCLUDE",
    "EXECUTE",
    "EXISTS",
    // (R)
    "EXIT",
    // (R)
    "EXPANSION",
    "EXPIRE",
    "EXPLAIN",
    // (R)
    "EXPORT",
    "EXTENDED",
    "EXTENT_SIZE",
    "FACTOR",
    "FAILED_LOGIN_ATTEMPTS",
    "FALSE",
    // (R)
    "FAST",
    "FAULTS",
    "FETCH",
    // (R)
    "FIELDS",
    "FILE",
    "FILE_BLOCK_SIZE",
    "FILTER",
    "FINISH",
    "FIRST",
    "FIRST_VALUE",
    // (R)
    "FIXED",
    "FLOAT",
    // (R)
    "FLOAT4",
    // (R)
    "FLOAT8",
    // (R)
    "FLUSH",
    "FOLLOWING",
    "FOLLOWS",
    "FOR",
    // (R)
    "FORCE",
    // (R)
    "FOREIGN",
    // (R)
    "FORMAT",
    "FOUND",
    "FROM",
    // (R)
    "FULL",
    "FULLTEXT",
    // (R)
    "FUNCTION",
    // (R)
    "GENERAL",
    "GENERATED",
    // (R)
    "GEOMCOLLECTION",
    "GEOMETRY",
    "GEOMETRYCOLLECTION",
    "GET",
    // (R)
    "GET_FORMAT",
    "GET_MASTER_PUBLIC_KEY",
    "GET_SOURCE_PUBLIC_KEY",
    "GLOBAL",
    "GRANT",
    // (R)
    "GRANTS",
    "GROUP",
    // (R)
    "GROUPING",
    // (R)
    "GROUPS",
    // (R)
    "GROUP_REPLICATION",
    "GTID_ONLY",
    "HANDLER",
    "HASH",
    "HAVING",
    // (R)
    "HELP",
    "HIGH_PRIORITY",
    // (R)
    "HISTOGRAM",
    "HISTORY",
    "HOST",
    "HOSTS",
    "HOUR",
    "HOUR_MICROSECOND",
    // (R)
    "HOUR_MINUTE",
    // (R)
    "HOUR_SECOND",
    // (R)
    "IDENTIFIED",
    "IF",
    // (R)
    "IGNORE",
    // (R)
    "IGNORE_SERVER_IDS",
    "IMPORT",
    "IN",
    // (R)
    "INACTIVE",
    "INDEX",
    // (R)
    "INDEXES",
    "INFILE",
    // (R)
    "INITIAL",
    "INITIAL_SIZE",
    "INITIATE",
    "INNER",
    // (R)
    "INOUT",
    // (R)
    "INSENSITIVE",
    // (R)
    "INSERT",
    // (R)
    "INSERT_METHOD",
    "INSTALL",
    "INSTANCE",
    "IN",
    // <-- moved over from functions
    "INT",
    // (R)
    "INT1",
    // (R)
    "INT2",
    // (R)
    "INT3",
    // (R)
    "INT4",
    // (R)
    "INT8",
    // (R)
    "INTEGER",
    // (R)
    "INTERSECT",
    // (R)
    "INTERVAL",
    // (R)
    "INTO",
    // (R)
    "INVISIBLE",
    "INVOKER",
    "IO",
    "IO_AFTER_GTIDS",
    // (R)
    "IO_BEFORE_GTIDS",
    // (R)
    "IO_THREAD",
    "IPC",
    "IS",
    // (R)
    "ISOLATION",
    "ISSUER",
    "ITERATE",
    // (R)
    "JOIN",
    // (R)
    "JSON",
    "JSON_TABLE",
    // (R)
    "JSON_VALUE",
    "KEY",
    // (R)
    "KEYRING",
    "KEYS",
    // (R)
    "KEY_BLOCK_SIZE",
    "KILL",
    // (R)
    "LAG",
    // (R)
    "LANGUAGE",
    "LAST",
    "LAST_VALUE",
    // (R)
    "LATERAL",
    // (R)
    "LEAD",
    // (R)
    "LEADING",
    // (R)
    "LEAVE",
    // (R)
    "LEAVES",
    "LEFT",
    // (R)
    "LESS",
    "LEVEL",
    "LIKE",
    // (R)
    "LIMIT",
    // (R)
    "LINEAR",
    // (R)
    "LINES",
    // (R)
    "LINESTRING",
    "LIST",
    "LOAD",
    // (R)
    "LOCAL",
    "LOCALTIME",
    // (R)
    "LOCALTIMESTAMP",
    // (R)
    "LOCK",
    // (R)
    "LOCKED",
    "LOCKS",
    "LOGFILE",
    "LOGS",
    "LONG",
    // (R)
    "LONGBLOB",
    // (R)
    "LONGTEXT",
    // (R)
    "LOOP",
    // (R)
    "LOW_PRIORITY",
    // (R)
    "MASTER",
    "MASTER_AUTO_POSITION",
    "MASTER_BIND",
    // (R)
    "MASTER_COMPRESSION_ALGORITHMS",
    "MASTER_CONNECT_RETRY",
    "MASTER_DELAY",
    "MASTER_HEARTBEAT_PERIOD",
    "MASTER_HOST",
    "MASTER_LOG_FILE",
    "MASTER_LOG_POS",
    "MASTER_PASSWORD",
    "MASTER_PORT",
    "MASTER_PUBLIC_KEY_PATH",
    "MASTER_RETRY_COUNT",
    "MASTER_SSL",
    "MASTER_SSL_CA",
    "MASTER_SSL_CAPATH",
    "MASTER_SSL_CERT",
    "MASTER_SSL_CIPHER",
    "MASTER_SSL_CRL",
    "MASTER_SSL_CRLPATH",
    "MASTER_SSL_KEY",
    "MASTER_SSL_VERIFY_SERVER_CERT",
    // (R)
    "MASTER_TLS_CIPHERSUITES",
    "MASTER_TLS_VERSION",
    "MASTER_USER",
    "MASTER_ZSTD_COMPRESSION_LEVEL",
    "MATCH",
    // (R)
    "MAXVALUE",
    // (R)
    "MAX_CONNECTIONS_PER_HOUR",
    "MAX_QUERIES_PER_HOUR",
    "MAX_ROWS",
    "MAX_SIZE",
    "MAX_UPDATES_PER_HOUR",
    "MAX_USER_CONNECTIONS",
    "MEDIUM",
    "MEDIUMBLOB",
    // (R)
    "MEDIUMINT",
    // (R)
    "MEDIUMTEXT",
    // (R)
    "MEMBER",
    "MEMORY",
    "MERGE",
    "MESSAGE_TEXT",
    "MICROSECOND",
    "MIDDLEINT",
    // (R)
    "MIGRATE",
    "MINUTE",
    "MINUTE_MICROSECOND",
    // (R)
    "MINUTE_SECOND",
    // (R)
    "MIN_ROWS",
    "MOD",
    // (R)
    "MODE",
    "MODIFIES",
    // (R)
    "MODIFY",
    "MONTH",
    "MULTILINESTRING",
    "MULTIPOINT",
    "MULTIPOLYGON",
    "MUTEX",
    "MYSQL_ERRNO",
    "NAME",
    "NAMES",
    "NATIONAL",
    "NATURAL",
    // (R)
    "NCHAR",
    "NDB",
    "NDBCLUSTER",
    "NESTED",
    "NETWORK_NAMESPACE",
    "NEVER",
    "NEW",
    "NEXT",
    "NO",
    "NODEGROUP",
    "NONE",
    "NOT",
    // (R)
    "NOWAIT",
    "NO_WAIT",
    "NO_WRITE_TO_BINLOG",
    // (R)
    "NTH_VALUE",
    // (R)
    "NTILE",
    // (R)
    "NULL",
    // (R)
    "NULLS",
    "NUMBER",
    "NUMERIC",
    // (R)
    "NVARCHAR",
    "OF",
    // (R)
    "OFF",
    "OFFSET",
    "OJ",
    "OLD",
    "ON",
    // (R)
    "ONE",
    "ONLY",
    "OPEN",
    "OPTIMIZE",
    // (R)
    "OPTIMIZER_COSTS",
    // (R)
    "OPTION",
    // (R)
    "OPTIONAL",
    "OPTIONALLY",
    // (R)
    "OPTIONS",
    "OR",
    // (R)
    "ORDER",
    // (R)
    "ORDINALITY",
    "ORGANIZATION",
    "OTHERS",
    "OUT",
    // (R)
    "OUTER",
    // (R)
    "OUTFILE",
    // (R)
    "OVER",
    // (R)
    "OWNER",
    "PACK_KEYS",
    "PAGE",
    "PARSER",
    "PARTIAL",
    "PARTITION",
    // (R)
    "PARTITIONING",
    "PARTITIONS",
    "PASSWORD",
    "PASSWORD_LOCK_TIME",
    "PATH",
    "PERCENT_RANK",
    // (R)
    "PERSIST",
    "PERSIST_ONLY",
    "PHASE",
    "PLUGIN",
    "PLUGINS",
    "PLUGIN_DIR",
    "POINT",
    "POLYGON",
    "PORT",
    "PRECEDES",
    "PRECEDING",
    "PRECISION",
    // (R)
    "PREPARE",
    "PRESERVE",
    "PREV",
    "PRIMARY",
    // (R)
    "PRIVILEGES",
    "PRIVILEGE_CHECKS_USER",
    "PROCEDURE",
    // (R)
    "PROCESS",
    "PROCESSLIST",
    "PROFILE",
    "PROFILES",
    "PROXY",
    "PURGE",
    // (R)
    "QUARTER",
    "QUERY",
    "QUICK",
    "RANDOM",
    "RANGE",
    // (R)
    "RANK",
    // (R)
    "READ",
    // (R)
    "READS",
    // (R)
    "READ_ONLY",
    "READ_WRITE",
    // (R)
    "REAL",
    // (R)
    "REBUILD",
    "RECOVER",
    "RECURSIVE",
    // (R)
    "REDO_BUFFER_SIZE",
    "REDUNDANT",
    "REFERENCE",
    "REFERENCES",
    // (R)
    "REGEXP",
    // (R)
    "REGISTRATION",
    "RELAY",
    "RELAYLOG",
    "RELAY_LOG_FILE",
    "RELAY_LOG_POS",
    "RELAY_THREAD",
    "RELEASE",
    // (R)
    "RELOAD",
    "REMOVE",
    "RENAME",
    // (R)
    "REORGANIZE",
    "REPAIR",
    "REPEAT",
    // (R)
    "REPEATABLE",
    "REPLACE",
    // (R)
    "REPLICA",
    "REPLICAS",
    "REPLICATE_DO_DB",
    "REPLICATE_DO_TABLE",
    "REPLICATE_IGNORE_DB",
    "REPLICATE_IGNORE_TABLE",
    "REPLICATE_REWRITE_DB",
    "REPLICATE_WILD_DO_TABLE",
    "REPLICATE_WILD_IGNORE_TABLE",
    "REPLICATION",
    "REQUIRE",
    // (R)
    "REQUIRE_ROW_FORMAT",
    "RESET",
    "RESIGNAL",
    // (R)
    "RESOURCE",
    "RESPECT",
    "RESTART",
    "RESTORE",
    "RESTRICT",
    // (R)
    "RESUME",
    "RETAIN",
    "RETURN",
    // (R)
    "RETURNED_SQLSTATE",
    "RETURNING",
    "RETURNS",
    "REUSE",
    "REVERSE",
    "REVOKE",
    // (R)
    "RIGHT",
    // (R)
    "RLIKE",
    // (R)
    "ROLE",
    "ROLLBACK",
    "ROLLUP",
    "ROTATE",
    "ROUTINE",
    "ROW",
    // (R)
    "ROWS",
    // (R)
    "ROW_COUNT",
    "ROW_FORMAT",
    "ROW_NUMBER",
    // (R)
    "RTREE",
    "SAVEPOINT",
    "SCHEDULE",
    "SCHEMA",
    // (R)
    "SCHEMAS",
    // (R)
    "SCHEMA_NAME",
    "SECOND",
    "SECONDARY",
    "SECONDARY_ENGINE",
    "SECONDARY_ENGINE_ATTRIBUTE",
    "SECONDARY_LOAD",
    "SECONDARY_UNLOAD",
    "SECOND_MICROSECOND",
    // (R)
    "SECURITY",
    "SELECT",
    // (R)
    "SENSITIVE",
    // (R)
    "SEPARATOR",
    // (R)
    "SERIAL",
    "SERIALIZABLE",
    "SERVER",
    "SESSION",
    "SET",
    // (R)
    "SHARE",
    "SHOW",
    // (R)
    "SHUTDOWN",
    "SIGNAL",
    // (R)
    "SIGNED",
    "SIMPLE",
    "SKIP",
    "SLAVE",
    "SLOW",
    "SMALLINT",
    // (R)
    "SNAPSHOT",
    "SOCKET",
    "SOME",
    "SONAME",
    "SOUNDS",
    "SOURCE",
    "SOURCE_AUTO_POSITION",
    "SOURCE_BIND",
    "SOURCE_COMPRESSION_ALGORITHMS",
    "SOURCE_CONNECT_RETRY",
    "SOURCE_DELAY",
    "SOURCE_HEARTBEAT_PERIOD",
    "SOURCE_HOST",
    "SOURCE_LOG_FILE",
    "SOURCE_LOG_POS",
    "SOURCE_PASSWORD",
    "SOURCE_PORT",
    "SOURCE_PUBLIC_KEY_PATH",
    "SOURCE_RETRY_COUNT",
    "SOURCE_SSL",
    "SOURCE_SSL_CA",
    "SOURCE_SSL_CAPATH",
    "SOURCE_SSL_CERT",
    "SOURCE_SSL_CIPHER",
    "SOURCE_SSL_CRL",
    "SOURCE_SSL_CRLPATH",
    "SOURCE_SSL_KEY",
    "SOURCE_SSL_VERIFY_SERVER_CERT",
    "SOURCE_TLS_CIPHERSUITES",
    "SOURCE_TLS_VERSION",
    "SOURCE_USER",
    "SOURCE_ZSTD_COMPRESSION_LEVEL",
    "SPATIAL",
    // (R)
    "SPECIFIC",
    // (R)
    "SQL",
    // (R)
    "SQLEXCEPTION",
    // (R)
    "SQLSTATE",
    // (R)
    "SQLWARNING",
    // (R)
    "SQL_AFTER_GTIDS",
    "SQL_AFTER_MTS_GAPS",
    "SQL_BEFORE_GTIDS",
    "SQL_BIG_RESULT",
    // (R)
    "SQL_BUFFER_RESULT",
    "SQL_CALC_FOUND_ROWS",
    // (R)
    "SQL_NO_CACHE",
    "SQL_SMALL_RESULT",
    // (R)
    "SQL_THREAD",
    "SQL_TSI_DAY",
    "SQL_TSI_HOUR",
    "SQL_TSI_MINUTE",
    "SQL_TSI_MONTH",
    "SQL_TSI_QUARTER",
    "SQL_TSI_SECOND",
    "SQL_TSI_WEEK",
    "SQL_TSI_YEAR",
    "SRID",
    "SSL",
    // (R)
    "STACKED",
    "START",
    "STARTING",
    // (R)
    "STARTS",
    "STATS_AUTO_RECALC",
    "STATS_PERSISTENT",
    "STATS_SAMPLE_PAGES",
    "STATUS",
    "STOP",
    "STORAGE",
    "STORED",
    // (R)
    "STRAIGHT_JOIN",
    // (R)
    "STREAM",
    "STRING",
    "SUBCLASS_ORIGIN",
    "SUBJECT",
    "SUBPARTITION",
    "SUBPARTITIONS",
    "SUPER",
    "SUSPEND",
    "SWAPS",
    "SWITCHES",
    "SYSTEM",
    // (R)
    "TABLE",
    // (R)
    "TABLES",
    "TABLESPACE",
    "TABLE_CHECKSUM",
    "TABLE_NAME",
    "TEMPORARY",
    "TEMPTABLE",
    "TERMINATED",
    // (R)
    "TEXT",
    "THAN",
    "THEN",
    // (R)
    "THREAD_PRIORITY",
    "TIES",
    "TIME",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TINYBLOB",
    // (R)
    "TINYINT",
    // (R)
    "TINYTEXT",
    // (R)
    "TLS",
    "TO",
    // (R)
    "TRAILING",
    // (R)
    "TRANSACTION",
    "TRIGGER",
    // (R)
    "TRIGGERS",
    "TRUE",
    // (R)
    "TRUNCATE",
    "TYPE",
    "TYPES",
    "UNBOUNDED",
    "UNCOMMITTED",
    "UNDEFINED",
    "UNDO",
    // (R)
    "UNDOFILE",
    "UNDO_BUFFER_SIZE",
    "UNICODE",
    "UNINSTALL",
    "UNION",
    // (R)
    "UNIQUE",
    // (R)
    "UNKNOWN",
    "UNLOCK",
    // (R)
    "UNREGISTER",
    "UNSIGNED",
    // (R)
    "UNTIL",
    "UPDATE",
    // (R)
    "UPGRADE",
    "USAGE",
    // (R)
    "USE",
    // (R)
    "USER",
    "USER_RESOURCES",
    "USE_FRM",
    "USING",
    // (R)
    "UTC_DATE",
    // (R)
    "UTC_TIME",
    // (R)
    "UTC_TIMESTAMP",
    // (R)
    "VALIDATION",
    "VALUE",
    "VALUES",
    // (R)
    "VARBINARY",
    // (R)
    "VARCHAR",
    // (R)
    "VARCHARACTER",
    // (R)
    "VARIABLES",
    "VARYING",
    // (R)
    "VCPU",
    "VIEW",
    "VIRTUAL",
    // (R)
    "VISIBLE",
    "WAIT",
    "WARNINGS",
    "WEEK",
    "WEIGHT_STRING",
    "WHEN",
    // (R)
    "WHERE",
    // (R)
    "WHILE",
    // (R)
    "WINDOW",
    // (R)
    "WITH",
    // (R)
    "WITHOUT",
    "WORK",
    "WRAPPER",
    "WRITE",
    // (R)
    "X509",
    "XA",
    "XID",
    "XML",
    "XOR",
    // (R)
    "YEAR",
    "YEAR_MONTH",
    // (R)
    "ZEROFILL",
    // (R)
    "ZONE"
  ]
}), pG = en({
  // https://dev.mysql.com/doc/refman/8.0/en/built-in-function-reference.html
  all: [
    "ABS",
    "ACOS",
    "ADDDATE",
    "ADDTIME",
    "AES_DECRYPT",
    "AES_ENCRYPT",
    // 'AND',
    "ANY_VALUE",
    "ASCII",
    "ASIN",
    "ATAN",
    "ATAN2",
    "AVG",
    "BENCHMARK",
    "BIN",
    "BIN_TO_UUID",
    "BINARY",
    "BIT_AND",
    "BIT_COUNT",
    "BIT_LENGTH",
    "BIT_OR",
    "BIT_XOR",
    "CAN_ACCESS_COLUMN",
    "CAN_ACCESS_DATABASE",
    "CAN_ACCESS_TABLE",
    "CAN_ACCESS_USER",
    "CAN_ACCESS_VIEW",
    "CAST",
    "CEIL",
    "CEILING",
    "CHAR",
    "CHAR_LENGTH",
    "CHARACTER_LENGTH",
    "CHARSET",
    "COALESCE",
    "COERCIBILITY",
    "COLLATION",
    "COMPRESS",
    "CONCAT",
    "CONCAT_WS",
    "CONNECTION_ID",
    "CONV",
    "CONVERT",
    "CONVERT_TZ",
    "COS",
    "COT",
    "COUNT",
    "CRC32",
    "CUME_DIST",
    "CURDATE",
    "CURRENT_DATE",
    "CURRENT_ROLE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "CURTIME",
    "DATABASE",
    "DATE",
    "DATE_ADD",
    "DATE_FORMAT",
    "DATE_SUB",
    "DATEDIFF",
    "DAY",
    "DAYNAME",
    "DAYOFMONTH",
    "DAYOFWEEK",
    "DAYOFYEAR",
    "DEFAULT",
    "DEGREES",
    "DENSE_RANK",
    "DIV",
    "ELT",
    "EXP",
    "EXPORT_SET",
    "EXTRACT",
    "EXTRACTVALUE",
    "FIELD",
    "FIND_IN_SET",
    "FIRST_VALUE",
    "FLOOR",
    "FORMAT",
    "FORMAT_BYTES",
    "FORMAT_PICO_TIME",
    "FOUND_ROWS",
    "FROM_BASE64",
    "FROM_DAYS",
    "FROM_UNIXTIME",
    "GEOMCOLLECTION",
    "GEOMETRYCOLLECTION",
    "GET_DD_COLUMN_PRIVILEGES",
    "GET_DD_CREATE_OPTIONS",
    "GET_DD_INDEX_SUB_PART_LENGTH",
    "GET_FORMAT",
    "GET_LOCK",
    "GREATEST",
    "GROUP_CONCAT",
    "GROUPING",
    "GTID_SUBSET",
    "GTID_SUBTRACT",
    "HEX",
    "HOUR",
    "ICU_VERSION",
    "IF",
    "IFNULL",
    // 'IN',
    "INET_ATON",
    "INET_NTOA",
    "INET6_ATON",
    "INET6_NTOA",
    "INSERT",
    "INSTR",
    "INTERNAL_AUTO_INCREMENT",
    "INTERNAL_AVG_ROW_LENGTH",
    "INTERNAL_CHECK_TIME",
    "INTERNAL_CHECKSUM",
    "INTERNAL_DATA_FREE",
    "INTERNAL_DATA_LENGTH",
    "INTERNAL_DD_CHAR_LENGTH",
    "INTERNAL_GET_COMMENT_OR_ERROR",
    "INTERNAL_GET_ENABLED_ROLE_JSON",
    "INTERNAL_GET_HOSTNAME",
    "INTERNAL_GET_USERNAME",
    "INTERNAL_GET_VIEW_WARNING_OR_ERROR",
    "INTERNAL_INDEX_COLUMN_CARDINALITY",
    "INTERNAL_INDEX_LENGTH",
    "INTERNAL_IS_ENABLED_ROLE",
    "INTERNAL_IS_MANDATORY_ROLE",
    "INTERNAL_KEYS_DISABLED",
    "INTERNAL_MAX_DATA_LENGTH",
    "INTERNAL_TABLE_ROWS",
    "INTERNAL_UPDATE_TIME",
    "INTERVAL",
    "IS",
    "IS_FREE_LOCK",
    "IS_IPV4",
    "IS_IPV4_COMPAT",
    "IS_IPV4_MAPPED",
    "IS_IPV6",
    "IS NOT",
    "IS NOT NULL",
    "IS NULL",
    "IS_USED_LOCK",
    "IS_UUID",
    "ISNULL",
    "JSON_ARRAY",
    "JSON_ARRAY_APPEND",
    "JSON_ARRAY_INSERT",
    "JSON_ARRAYAGG",
    "JSON_CONTAINS",
    "JSON_CONTAINS_PATH",
    "JSON_DEPTH",
    "JSON_EXTRACT",
    "JSON_INSERT",
    "JSON_KEYS",
    "JSON_LENGTH",
    "JSON_MERGE",
    "JSON_MERGE_PATCH",
    "JSON_MERGE_PRESERVE",
    "JSON_OBJECT",
    "JSON_OBJECTAGG",
    "JSON_OVERLAPS",
    "JSON_PRETTY",
    "JSON_QUOTE",
    "JSON_REMOVE",
    "JSON_REPLACE",
    "JSON_SCHEMA_VALID",
    "JSON_SCHEMA_VALIDATION_REPORT",
    "JSON_SEARCH",
    "JSON_SET",
    "JSON_STORAGE_FREE",
    "JSON_STORAGE_SIZE",
    "JSON_TABLE",
    "JSON_TYPE",
    "JSON_UNQUOTE",
    "JSON_VALID",
    "JSON_VALUE",
    "LAG",
    "LAST_DAY",
    "LAST_INSERT_ID",
    "LAST_VALUE",
    "LCASE",
    "LEAD",
    "LEAST",
    "LEFT",
    "LENGTH",
    "LIKE",
    "LINESTRING",
    "LN",
    "LOAD_FILE",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG2",
    "LOWER",
    "LPAD",
    "LTRIM",
    "MAKE_SET",
    "MAKEDATE",
    "MAKETIME",
    "MASTER_POS_WAIT",
    "MATCH",
    "MAX",
    "MBRCONTAINS",
    "MBRCOVEREDBY",
    "MBRCOVERS",
    "MBRDISJOINT",
    "MBREQUALS",
    "MBRINTERSECTS",
    "MBROVERLAPS",
    "MBRTOUCHES",
    "MBRWITHIN",
    "MD5",
    "MEMBER OF",
    "MICROSECOND",
    "MID",
    "MIN",
    "MINUTE",
    "MOD",
    "MONTH",
    "MONTHNAME",
    "MULTILINESTRING",
    "MULTIPOINT",
    "MULTIPOLYGON",
    "NAME_CONST",
    "NOT",
    "NOT IN",
    "NOT LIKE",
    "NOT REGEXP",
    "NOW",
    "NTH_VALUE",
    "NTILE",
    "NULLIF",
    "OCT",
    "OCTET_LENGTH",
    // 'OR',
    "ORD",
    "PERCENT_RANK",
    "PERIOD_ADD",
    "PERIOD_DIFF",
    "PI",
    "POINT",
    "POLYGON",
    "POSITION",
    "POW",
    "POWER",
    "PS_CURRENT_THREAD_ID",
    "PS_THREAD_ID",
    "QUARTER",
    "QUOTE",
    "RADIANS",
    "RAND",
    "RANDOM_BYTES",
    "RANK",
    "REGEXP",
    "REGEXP_INSTR",
    "REGEXP_LIKE",
    "REGEXP_REPLACE",
    "REGEXP_SUBSTR",
    "RELEASE_ALL_LOCKS",
    "RELEASE_LOCK",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "RIGHT",
    "RLIKE",
    "ROLES_GRAPHML",
    "ROUND",
    "ROW_COUNT",
    "ROW_NUMBER",
    "RPAD",
    "RTRIM",
    "SCHEMA",
    "SEC_TO_TIME",
    "SECOND",
    "SESSION_USER",
    "SHA1",
    "SHA2",
    "SIGN",
    "SIN",
    "SLEEP",
    "SOUNDEX",
    "SOUNDS LIKE",
    "SOURCE_POS_WAIT",
    "SPACE",
    "SQRT",
    "ST_AREA",
    "ST_ASBINARY",
    "ST_ASGEOJSON",
    "ST_ASTEXT",
    "ST_BUFFER",
    "ST_BUFFER_STRATEGY",
    "ST_CENTROID",
    "ST_COLLECT",
    "ST_CONTAINS",
    "ST_CONVEXHULL",
    "ST_CROSSES",
    "ST_DIFFERENCE",
    "ST_DIMENSION",
    "ST_DISJOINT",
    "ST_DISTANCE",
    "ST_DISTANCE_SPHERE",
    "ST_ENDPOINT",
    "ST_ENVELOPE",
    "ST_EQUALS",
    "ST_EXTERIORRING",
    "ST_FRECHETDISTANCE",
    "ST_GEOHASH",
    "ST_GEOMCOLLFROMTEXT",
    "ST_GEOMCOLLFROMWKB",
    "ST_GEOMETRYN",
    "ST_GEOMETRYTYPE",
    "ST_GEOMFROMGEOJSON",
    "ST_GEOMFROMTEXT",
    "ST_GEOMFROMWKB",
    "ST_HAUSDORFFDISTANCE",
    "ST_INTERIORRINGN",
    "ST_INTERSECTION",
    "ST_INTERSECTS",
    "ST_ISCLOSED",
    "ST_ISEMPTY",
    "ST_ISSIMPLE",
    "ST_ISVALID",
    "ST_LATFROMGEOHASH",
    "ST_LATITUDE",
    "ST_LENGTH",
    "ST_LINEFROMTEXT",
    "ST_LINEFROMWKB",
    "ST_LINEINTERPOLATEPOINT",
    "ST_LINEINTERPOLATEPOINTS",
    "ST_LONGFROMGEOHASH",
    "ST_LONGITUDE",
    "ST_MAKEENVELOPE",
    "ST_MLINEFROMTEXT",
    "ST_MLINEFROMWKB",
    "ST_MPOINTFROMTEXT",
    "ST_MPOINTFROMWKB",
    "ST_MPOLYFROMTEXT",
    "ST_MPOLYFROMWKB",
    "ST_NUMGEOMETRIES",
    "ST_NUMINTERIORRING",
    "ST_NUMPOINTS",
    "ST_OVERLAPS",
    "ST_POINTATDISTANCE",
    "ST_POINTFROMGEOHASH",
    "ST_POINTFROMTEXT",
    "ST_POINTFROMWKB",
    "ST_POINTN",
    "ST_POLYFROMTEXT",
    "ST_POLYFROMWKB",
    "ST_SIMPLIFY",
    "ST_SRID",
    "ST_STARTPOINT",
    "ST_SWAPXY",
    "ST_SYMDIFFERENCE",
    "ST_TOUCHES",
    "ST_TRANSFORM",
    "ST_UNION",
    "ST_VALIDATE",
    "ST_WITHIN",
    "ST_X",
    "ST_Y",
    "STATEMENT_DIGEST",
    "STATEMENT_DIGEST_TEXT",
    "STD",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STR_TO_DATE",
    "STRCMP",
    "SUBDATE",
    "SUBSTR",
    "SUBSTRING",
    "SUBSTRING_INDEX",
    "SUBTIME",
    "SUM",
    "SYSDATE",
    "SYSTEM_USER",
    "TAN",
    "TIME",
    "TIME_FORMAT",
    "TIME_TO_SEC",
    "TIMEDIFF",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TO_BASE64",
    "TO_DAYS",
    "TO_SECONDS",
    "TRIM",
    "TRUNCATE",
    "UCASE",
    "UNCOMPRESS",
    "UNCOMPRESSED_LENGTH",
    "UNHEX",
    "UNIX_TIMESTAMP",
    "UPDATEXML",
    "UPPER",
    "USER",
    "UTC_DATE",
    "UTC_TIME",
    "UTC_TIMESTAMP",
    "UUID",
    "UUID_SHORT",
    "UUID_TO_BIN",
    "VALIDATE_PASSWORD_STRENGTH",
    "VALUES",
    "VAR_POP",
    "VAR_SAMP",
    "VARIANCE",
    "VERSION",
    "WAIT_FOR_EXECUTED_GTID_SET",
    "WAIT_UNTIL_SQL_THREAD_AFTER_GTIDS",
    "WEEK",
    "WEEKDAY",
    "WEEKOFYEAR",
    "WEIGHT_STRING",
    // 'XOR',
    "YEAR",
    "YEARWEEK",
    // Data types with parameters
    // https://dev.mysql.com/doc/refman/8.0/en/data-types.html
    "BIT",
    "TINYINT",
    "SMALLINT",
    "MEDIUMINT",
    "INT",
    "INTEGER",
    "BIGINT",
    "DECIMAL",
    "DEC",
    "NUMERIC",
    "FIXED",
    "FLOAT",
    "DOUBLE",
    "DOUBLE PRECISION",
    "REAL",
    "DATETIME",
    "TIMESTAMP",
    "TIME",
    "YEAR",
    "CHAR",
    "NATIONAL CHAR",
    "VARCHAR",
    "NATIONAL VARCHAR",
    "BINARY",
    "VARBINARY",
    "BLOB",
    "TEXT",
    "ENUM"
    // 'SET' // handled as special-case in postProcess
  ]
}), OG = pe(["SELECT [ALL | DISTINCT | DISTINCTROW]"]), IG = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT [LOW_PRIORITY | DELAYED | HIGH_PRIORITY] [IGNORE] [INTO]",
  "REPLACE [LOW_PRIORITY | DELAYED] [INTO]",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [SQL SECURITY DEFINER | SQL SECURITY INVOKER] VIEW [IF NOT EXISTS]",
  "CREATE [TEMPORARY] TABLE [IF NOT EXISTS]"
]), bm = pe([
  // - update:
  "UPDATE [LOW_PRIORITY] [IGNORE]",
  // - delete:
  "DELETE [LOW_PRIORITY] [QUICK] [IGNORE] FROM",
  // - drop table:
  "DROP [TEMPORARY] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD [COLUMN]",
  "{CHANGE | MODIFY} [COLUMN]",
  "DROP [COLUMN]",
  "RENAME [TO | AS]",
  "RENAME COLUMN",
  "ALTER [COLUMN]",
  "{SET | DROP} DEFAULT",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://dev.mysql.com/doc/refman/8.0/en/sql-statements.html
  "ALTER DATABASE",
  "ALTER EVENT",
  "ALTER FUNCTION",
  "ALTER INSTANCE",
  "ALTER LOGFILE GROUP",
  "ALTER PROCEDURE",
  "ALTER RESOURCE GROUP",
  "ALTER SERVER",
  "ALTER TABLESPACE",
  "ALTER USER",
  "ALTER VIEW",
  "ANALYZE TABLE",
  "BINLOG",
  "CACHE INDEX",
  "CALL",
  "CHANGE MASTER TO",
  "CHANGE REPLICATION FILTER",
  "CHANGE REPLICATION SOURCE TO",
  "CHECK TABLE",
  "CHECKSUM TABLE",
  "CLONE",
  "COMMIT",
  "CREATE DATABASE",
  "CREATE EVENT",
  "CREATE FUNCTION",
  "CREATE FUNCTION",
  "CREATE INDEX",
  "CREATE LOGFILE GROUP",
  "CREATE PROCEDURE",
  "CREATE RESOURCE GROUP",
  "CREATE ROLE",
  "CREATE SERVER",
  "CREATE SPATIAL REFERENCE SYSTEM",
  "CREATE TABLESPACE",
  "CREATE TRIGGER",
  "CREATE USER",
  "DEALLOCATE PREPARE",
  "DESCRIBE",
  "DROP DATABASE",
  "DROP EVENT",
  "DROP FUNCTION",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP LOGFILE GROUP",
  "DROP PROCEDURE",
  "DROP RESOURCE GROUP",
  "DROP ROLE",
  "DROP SERVER",
  "DROP SPATIAL REFERENCE SYSTEM",
  "DROP TABLESPACE",
  "DROP TRIGGER",
  "DROP USER",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FLUSH",
  "GRANT",
  "HANDLER",
  "HELP",
  "IMPORT TABLE",
  "INSTALL COMPONENT",
  "INSTALL PLUGIN",
  "KILL",
  "LOAD DATA",
  "LOAD INDEX INTO CACHE",
  "LOAD XML",
  "LOCK INSTANCE FOR BACKUP",
  "LOCK TABLES",
  "MASTER_POS_WAIT",
  "OPTIMIZE TABLE",
  "PREPARE",
  "PURGE BINARY LOGS",
  "RELEASE SAVEPOINT",
  "RENAME TABLE",
  "RENAME USER",
  "REPAIR TABLE",
  "RESET",
  "RESET MASTER",
  "RESET PERSIST",
  "RESET REPLICA",
  "RESET SLAVE",
  "RESTART",
  "REVOKE",
  "ROLLBACK",
  "ROLLBACK TO SAVEPOINT",
  "SAVEPOINT",
  "SET CHARACTER SET",
  "SET DEFAULT ROLE",
  "SET NAMES",
  "SET PASSWORD",
  "SET RESOURCE GROUP",
  "SET ROLE",
  "SET TRANSACTION",
  "SHOW",
  "SHOW BINARY LOGS",
  "SHOW BINLOG EVENTS",
  "SHOW CHARACTER SET",
  "SHOW COLLATION",
  "SHOW COLUMNS",
  "SHOW CREATE DATABASE",
  "SHOW CREATE EVENT",
  "SHOW CREATE FUNCTION",
  "SHOW CREATE PROCEDURE",
  "SHOW CREATE TABLE",
  "SHOW CREATE TRIGGER",
  "SHOW CREATE USER",
  "SHOW CREATE VIEW",
  "SHOW DATABASES",
  "SHOW ENGINE",
  "SHOW ENGINES",
  "SHOW ERRORS",
  "SHOW EVENTS",
  "SHOW FUNCTION CODE",
  "SHOW FUNCTION STATUS",
  "SHOW GRANTS",
  "SHOW INDEX",
  "SHOW MASTER STATUS",
  "SHOW OPEN TABLES",
  "SHOW PLUGINS",
  "SHOW PRIVILEGES",
  "SHOW PROCEDURE CODE",
  "SHOW PROCEDURE STATUS",
  "SHOW PROCESSLIST",
  "SHOW PROFILE",
  "SHOW PROFILES",
  "SHOW RELAYLOG EVENTS",
  "SHOW REPLICA STATUS",
  "SHOW REPLICAS",
  "SHOW SLAVE",
  "SHOW SLAVE HOSTS",
  "SHOW STATUS",
  "SHOW TABLE STATUS",
  "SHOW TABLES",
  "SHOW TRIGGERS",
  "SHOW VARIABLES",
  "SHOW WARNINGS",
  "SHUTDOWN",
  "SOURCE_POS_WAIT",
  "START GROUP_REPLICATION",
  "START REPLICA",
  "START SLAVE",
  "START TRANSACTION",
  "STOP GROUP_REPLICATION",
  "STOP REPLICA",
  "STOP SLAVE",
  "TABLE",
  "UNINSTALL COMPONENT",
  "UNINSTALL PLUGIN",
  "UNLOCK INSTANCE",
  "UNLOCK TABLES",
  "USE",
  "XA",
  // flow control
  // 'IF',
  "ITERATE",
  "LEAVE",
  "LOOP",
  "REPEAT",
  "RETURN",
  "WHILE"
]), CG = pe(["UNION [ALL | DISTINCT]"]), hG = pe([
  "JOIN",
  "{LEFT | RIGHT} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL [INNER] JOIN",
  "NATURAL {LEFT | RIGHT} [OUTER] JOIN",
  // non-standard joins
  "STRAIGHT_JOIN"
]), vG = pe(["ON {UPDATE | DELETE} [SET NULL]", "CHARACTER SET", "{ROWS | RANGE} BETWEEN"]), mG = {
  tokenizerOptions: {
    reservedSelect: OG,
    reservedClauses: [...IG, ...bm],
    reservedSetOperations: CG,
    reservedJoins: hG,
    reservedPhrases: vG,
    supportsXor: !0,
    reservedKeywords: NG,
    reservedFunctionNames: pG,
    // TODO: support _ char set prefixes such as _utf8, _latin1, _binary, _utf8mb4, etc.
    stringTypes: ['""-qq-bs', {
      quote: "''-qq-bs",
      prefixes: ["N"]
    }, {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    identChars: {
      first: "$",
      rest: "$",
      allowFirstCharNumber: !0
    },
    variableTypes: [{
      regex: "@@?[A-Za-z0-9_.$]+"
    }, {
      quote: '""-qq-bs',
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "''-qq-bs",
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "``",
      prefixes: ["@"],
      requirePrefix: !0
    }],
    paramTypes: {
      positional: !0
    },
    lineCommentTypes: ["--", "#"],
    operators: ["%", ":=", "&", "|", "^", "~", "<<", ">>", "<=>", "->", "->>", "&&", "||", "!"],
    postProcess: LG
  },
  formatOptions: {
    onelineClauses: bm
  }
};
function LG(l) {
  return l.map((u, T) => {
    const N = l[T + 1] || PE;
    return su.SET(u) && N.text === "(" ? {
      ...u,
      type: Re.RESERVED_FUNCTION_NAME
    } : u;
  });
}
const yG = en({
  // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/functions.html
  all: [
    "ABORT",
    "ABS",
    "ACOS",
    "ADVISOR",
    "ARRAY_AGG",
    "ARRAY_AGG",
    "ARRAY_APPEND",
    "ARRAY_AVG",
    "ARRAY_BINARY_SEARCH",
    "ARRAY_CONCAT",
    "ARRAY_CONTAINS",
    "ARRAY_COUNT",
    "ARRAY_DISTINCT",
    "ARRAY_EXCEPT",
    "ARRAY_FLATTEN",
    "ARRAY_IFNULL",
    "ARRAY_INSERT",
    "ARRAY_INTERSECT",
    "ARRAY_LENGTH",
    "ARRAY_MAX",
    "ARRAY_MIN",
    "ARRAY_MOVE",
    "ARRAY_POSITION",
    "ARRAY_PREPEND",
    "ARRAY_PUT",
    "ARRAY_RANGE",
    "ARRAY_REMOVE",
    "ARRAY_REPEAT",
    "ARRAY_REPLACE",
    "ARRAY_REVERSE",
    "ARRAY_SORT",
    "ARRAY_STAR",
    "ARRAY_SUM",
    "ARRAY_SYMDIFF",
    "ARRAY_SYMDIFF1",
    "ARRAY_SYMDIFFN",
    "ARRAY_UNION",
    "ASIN",
    "ATAN",
    "ATAN2",
    "AVG",
    "BASE64",
    "BASE64_DECODE",
    "BASE64_ENCODE",
    "BITAND ",
    "BITCLEAR ",
    "BITNOT ",
    "BITOR ",
    "BITSET ",
    "BITSHIFT ",
    "BITTEST ",
    "BITXOR ",
    "CEIL",
    "CLOCK_LOCAL",
    "CLOCK_MILLIS",
    "CLOCK_STR",
    "CLOCK_TZ",
    "CLOCK_UTC",
    "COALESCE",
    "CONCAT",
    "CONCAT2",
    "CONTAINS",
    "CONTAINS_TOKEN",
    "CONTAINS_TOKEN_LIKE",
    "CONTAINS_TOKEN_REGEXP",
    "COS",
    "COUNT",
    "COUNT",
    "COUNTN",
    "CUME_DIST",
    "CURL",
    "DATE_ADD_MILLIS",
    "DATE_ADD_STR",
    "DATE_DIFF_MILLIS",
    "DATE_DIFF_STR",
    "DATE_FORMAT_STR",
    "DATE_PART_MILLIS",
    "DATE_PART_STR",
    "DATE_RANGE_MILLIS",
    "DATE_RANGE_STR",
    "DATE_TRUNC_MILLIS",
    "DATE_TRUNC_STR",
    "DECODE",
    "DECODE_JSON",
    "DEGREES",
    "DENSE_RANK",
    "DURATION_TO_STR",
    // 'E',
    "ENCODED_SIZE",
    "ENCODE_JSON",
    "EXP",
    "FIRST_VALUE",
    "FLOOR",
    "GREATEST",
    "HAS_TOKEN",
    "IFINF",
    "IFMISSING",
    "IFMISSINGORNULL",
    "IFNAN",
    "IFNANORINF",
    "IFNULL",
    "INITCAP",
    "ISARRAY",
    "ISATOM",
    "ISBITSET",
    "ISBOOLEAN",
    "ISNUMBER",
    "ISOBJECT",
    "ISSTRING",
    "LAG",
    "LAST_VALUE",
    "LEAD",
    "LEAST",
    "LENGTH",
    "LN",
    "LOG",
    "LOWER",
    "LTRIM",
    "MAX",
    "MEAN",
    "MEDIAN",
    "META",
    "MILLIS",
    "MILLIS_TO_LOCAL",
    "MILLIS_TO_STR",
    "MILLIS_TO_TZ",
    "MILLIS_TO_UTC",
    "MILLIS_TO_ZONE_NAME",
    "MIN",
    "MISSINGIF",
    "NANIF",
    "NEGINFIF",
    "NOW_LOCAL",
    "NOW_MILLIS",
    "NOW_STR",
    "NOW_TZ",
    "NOW_UTC",
    "NTH_VALUE",
    "NTILE",
    "NULLIF",
    "NVL",
    "NVL2",
    "OBJECT_ADD",
    "OBJECT_CONCAT",
    "OBJECT_INNER_PAIRS",
    "OBJECT_INNER_VALUES",
    "OBJECT_LENGTH",
    "OBJECT_NAMES",
    "OBJECT_PAIRS",
    "OBJECT_PUT",
    "OBJECT_REMOVE",
    "OBJECT_RENAME",
    "OBJECT_REPLACE",
    "OBJECT_UNWRAP",
    "OBJECT_VALUES",
    "PAIRS",
    "PERCENT_RANK",
    "PI",
    "POLY_LENGTH",
    "POSINFIF",
    "POSITION",
    "POWER",
    "RADIANS",
    "RANDOM",
    "RANK",
    "RATIO_TO_REPORT",
    "REGEXP_CONTAINS",
    "REGEXP_LIKE",
    "REGEXP_MATCHES",
    "REGEXP_POSITION",
    "REGEXP_REPLACE",
    "REGEXP_SPLIT",
    "REGEX_CONTAINS",
    "REGEX_LIKE",
    "REGEX_MATCHES",
    "REGEX_POSITION",
    "REGEX_REPLACE",
    "REGEX_SPLIT",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "ROUND",
    "ROW_NUMBER",
    "RTRIM",
    "SEARCH",
    "SEARCH_META",
    "SEARCH_SCORE",
    "SIGN",
    "SIN",
    "SPLIT",
    "SQRT",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STR_TO_DURATION",
    "STR_TO_MILLIS",
    "STR_TO_TZ",
    "STR_TO_UTC",
    "STR_TO_ZONE_NAME",
    "SUBSTR",
    "SUFFIXES",
    "SUM",
    "TAN",
    "TITLE",
    "TOARRAY",
    "TOATOM",
    "TOBOOLEAN",
    "TOKENS",
    "TOKENS",
    "TONUMBER",
    "TOOBJECT",
    "TOSTRING",
    "TRIM",
    "TRUNC",
    // 'TYPE', // disabled
    "UPPER",
    "UUID",
    "VARIANCE",
    "VARIANCE_POP",
    "VARIANCE_SAMP",
    "VAR_POP",
    "VAR_SAMP",
    "WEEKDAY_MILLIS",
    "WEEKDAY_STR",
    // type casting
    // not implemented in N1QL, but added here now for the sake of tests
    // https://docs.couchbase.com/server/current/analytics/3_query.html#Vs_SQL-92
    "CAST"
  ]
}), DG = en({
  // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html
  all: ["ADVISE", "ALL", "ALTER", "ANALYZE", "AND", "ANY", "ARRAY", "AS", "ASC", "AT", "BEGIN", "BETWEEN", "BINARY", "BOOLEAN", "BREAK", "BUCKET", "BUILD", "BY", "CALL", "CASE", "CAST", "CLUSTER", "COLLATE", "COLLECTION", "COMMIT", "COMMITTED", "CONNECT", "CONTINUE", "CORRELATED", "COVER", "CREATE", "CURRENT", "DATABASE", "DATASET", "DATASTORE", "DECLARE", "DECREMENT", "DELETE", "DERIVED", "DESC", "DESCRIBE", "DISTINCT", "DO", "DROP", "EACH", "ELEMENT", "ELSE", "END", "EVERY", "EXCEPT", "EXCLUDE", "EXECUTE", "EXISTS", "EXPLAIN", "FALSE", "FETCH", "FILTER", "FIRST", "FLATTEN", "FLUSH", "FOLLOWING", "FOR", "FORCE", "FROM", "FTS", "FUNCTION", "GOLANG", "GRANT", "GROUP", "GROUPS", "GSI", "HASH", "HAVING", "IF", "ISOLATION", "IGNORE", "ILIKE", "IN", "INCLUDE", "INCREMENT", "INDEX", "INFER", "INLINE", "INNER", "INSERT", "INTERSECT", "INTO", "IS", "JAVASCRIPT", "JOIN", "KEY", "KEYS", "KEYSPACE", "KNOWN", "LANGUAGE", "LAST", "LEFT", "LET", "LETTING", "LEVEL", "LIKE", "LIMIT", "LSM", "MAP", "MAPPING", "MATCHED", "MATERIALIZED", "MERGE", "MINUS", "MISSING", "NAMESPACE", "NEST", "NL", "NO", "NOT", "NTH_VALUE", "NULL", "NULLS", "NUMBER", "OBJECT", "OFFSET", "ON", "OPTION", "OPTIONS", "OR", "ORDER", "OTHERS", "OUTER", "OVER", "PARSE", "PARTITION", "PASSWORD", "PATH", "POOL", "PRECEDING", "PREPARE", "PRIMARY", "PRIVATE", "PRIVILEGE", "PROBE", "PROCEDURE", "PUBLIC", "RANGE", "RAW", "REALM", "REDUCE", "RENAME", "RESPECT", "RETURN", "RETURNING", "REVOKE", "RIGHT", "ROLE", "ROLLBACK", "ROW", "ROWS", "SATISFIES", "SAVEPOINT", "SCHEMA", "SCOPE", "SELECT", "SELF", "SEMI", "SET", "SHOW", "SOME", "START", "STATISTICS", "STRING", "SYSTEM", "THEN", "TIES", "TO", "TRAN", "TRANSACTION", "TRIGGER", "TRUE", "TRUNCATE", "UNBOUNDED", "UNDER", "UNION", "UNIQUE", "UNKNOWN", "UNNEST", "UNSET", "UPDATE", "UPSERT", "USE", "USER", "USING", "VALIDATE", "VALUE", "VALUED", "VALUES", "VIA", "VIEW", "WHEN", "WHERE", "WHILE", "WINDOW", "WITH", "WITHIN", "WORK", "XOR"]
}), gG = pe(["SELECT [ALL | DISTINCT]"]), PG = pe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE INTO",
  "WHEN [NOT] MATCHED THEN",
  "UPDATE SET",
  "INSERT",
  // other
  "NEST",
  "UNNEST",
  "RETURNING"
]), Hm = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - set schema:
  "SET SCHEMA",
  // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html
  "ADVISE",
  "ALTER INDEX",
  "BEGIN TRANSACTION",
  "BUILD INDEX",
  "COMMIT TRANSACTION",
  "CREATE COLLECTION",
  "CREATE FUNCTION",
  "CREATE INDEX",
  "CREATE PRIMARY INDEX",
  "CREATE SCOPE",
  "DROP COLLECTION",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP PRIMARY INDEX",
  "DROP SCOPE",
  "EXECUTE",
  "EXECUTE FUNCTION",
  "EXPLAIN",
  "GRANT",
  "INFER",
  "PREPARE",
  "REVOKE",
  "ROLLBACK TRANSACTION",
  "SAVEPOINT",
  "SET TRANSACTION",
  "UPDATE STATISTICS",
  "UPSERT",
  // other
  "LET",
  "SET CURRENT SCHEMA",
  "SHOW",
  "USE [PRIMARY] KEYS"
]), MG = pe(["UNION [ALL]", "EXCEPT [ALL]", "INTERSECT [ALL]"]), UG = pe(["JOIN", "{LEFT | RIGHT} [OUTER] JOIN", "INNER JOIN"]), _G = pe(["{ROWS | RANGE | GROUPS} BETWEEN"]), GG = {
  tokenizerOptions: {
    reservedSelect: gG,
    reservedClauses: [...PG, ...Hm],
    reservedSetOperations: MG,
    reservedJoins: UG,
    reservedPhrases: _G,
    supportsXor: !0,
    reservedKeywords: DG,
    reservedFunctionNames: yG,
    // NOTE: single quotes are actually not supported in N1QL,
    // but we support them anyway as all other SQL dialects do,
    // which simplifies writing tests that are shared between all dialects.
    stringTypes: ['""-bs', "''-bs"],
    identTypes: ["``"],
    extraParens: ["[]", "{}"],
    paramTypes: {
      positional: !0,
      numbered: ["$"],
      named: ["$"]
    },
    lineCommentTypes: ["#", "--"],
    operators: ["%", "==", ":", "||"]
  },
  formatOptions: {
    onelineClauses: Hm
  }
}, xG = en({
  // https://docs.oracle.com/cd/B19306_01/appdev.102/b14261/reservewords.htm
  all: [
    // 'A',
    "ADD",
    "AGENT",
    "AGGREGATE",
    "ALL",
    "ALTER",
    "AND",
    "ANY",
    "ARRAY",
    "ARROW",
    "AS",
    "ASC",
    "AT",
    "ATTRIBUTE",
    "AUTHID",
    "AVG",
    "BEGIN",
    "BETWEEN",
    "BFILE_BASE",
    "BINARY",
    "BLOB_BASE",
    "BLOCK",
    "BODY",
    "BOTH",
    "BOUND",
    "BULK",
    "BY",
    "BYTE",
    // 'C',
    "CALL",
    "CALLING",
    "CASCADE",
    "CASE",
    "CHAR",
    "CHAR_BASE",
    "CHARACTER",
    "CHARSET",
    "CHARSETFORM",
    "CHARSETID",
    "CHECK",
    "CLOB_BASE",
    "CLOSE",
    "CLUSTER",
    "CLUSTERS",
    "COLAUTH",
    "COLLECT",
    "COLUMNS",
    "COMMENT",
    "COMMIT",
    "COMMITTED",
    "COMPILED",
    "COMPRESS",
    "CONNECT",
    "CONSTANT",
    "CONSTRUCTOR",
    "CONTEXT",
    "CONVERT",
    "COUNT",
    "CRASH",
    "CREATE",
    "CURRENT",
    "CURSOR",
    "CUSTOMDATUM",
    "DANGLING",
    "DATA",
    "DATE",
    "DATE_BASE",
    "DAY",
    "DECIMAL",
    "DECLARE",
    "DEFAULT",
    "DEFINE",
    "DELETE",
    "DESC",
    "DETERMINISTIC",
    "DISTINCT",
    "DOUBLE",
    "DROP",
    "DURATION",
    "ELEMENT",
    "ELSE",
    "ELSIF",
    "EMPTY",
    "END",
    "ESCAPE",
    "EXCEPT",
    "EXCEPTION",
    "EXCEPTIONS",
    "EXCLUSIVE",
    "EXECUTE",
    "EXISTS",
    "EXIT",
    "EXTERNAL",
    "FETCH",
    "FINAL",
    "FIXED",
    "FLOAT",
    "FOR",
    "FORALL",
    "FORCE",
    "FORM",
    "FROM",
    "FUNCTION",
    "GENERAL",
    "GOTO",
    "GRANT",
    "GROUP",
    "HASH",
    "HAVING",
    "HEAP",
    "HIDDEN",
    "HOUR",
    "IDENTIFIED",
    "IF",
    "IMMEDIATE",
    "IN",
    "INCLUDING",
    "INDEX",
    "INDEXES",
    "INDICATOR",
    "INDICES",
    "INFINITE",
    "INSERT",
    "INSTANTIABLE",
    "INT",
    "INTERFACE",
    "INTERSECT",
    "INTERVAL",
    "INTO",
    "INVALIDATE",
    "IS",
    "ISOLATION",
    "JAVA",
    "LANGUAGE",
    "LARGE",
    "LEADING",
    "LENGTH",
    "LEVEL",
    "LIBRARY",
    "LIKE",
    "LIKE2",
    "LIKE4",
    "LIKEC",
    "LIMIT",
    "LIMITED",
    "LOCAL",
    "LOCK",
    "LONG",
    "LOOP",
    "MAP",
    "MAX",
    "MAXLEN",
    "MEMBER",
    "MERGE",
    "MIN",
    "MINUS",
    "MINUTE",
    "MOD",
    "MODE",
    "MODIFY",
    "MONTH",
    "MULTISET",
    "NAME",
    "NAN",
    "NATIONAL",
    "NATIVE",
    "NCHAR",
    "NEW",
    "NOCOMPRESS",
    "NOCOPY",
    "NOT",
    "NOWAIT",
    "NULL",
    "NUMBER_BASE",
    "OBJECT",
    "OCICOLL",
    "OCIDATE",
    "OCIDATETIME",
    "OCIDURATION",
    "OCIINTERVAL",
    "OCILOBLOCATOR",
    "OCINUMBER",
    "OCIRAW",
    "OCIREF",
    "OCIREFCURSOR",
    "OCIROWID",
    "OCISTRING",
    "OCITYPE",
    "OF",
    "ON",
    "ONLY",
    "OPAQUE",
    "OPEN",
    "OPERATOR",
    "OPTION",
    "OR",
    "ORACLE",
    "ORADATA",
    "ORDER",
    "OVERLAPS",
    "ORGANIZATION",
    "ORLANY",
    "ORLVARY",
    "OTHERS",
    "OUT",
    "OVERRIDING",
    "PACKAGE",
    "PARALLEL_ENABLE",
    "PARAMETER",
    "PARAMETERS",
    "PARTITION",
    "PASCAL",
    "PIPE",
    "PIPELINED",
    "PRAGMA",
    "PRECISION",
    "PRIOR",
    "PRIVATE",
    "PROCEDURE",
    "PUBLIC",
    "RAISE",
    "RANGE",
    "RAW",
    "READ",
    "RECORD",
    "REF",
    "REFERENCE",
    "REM",
    "REMAINDER",
    "RENAME",
    "RESOURCE",
    "RESULT",
    "RETURN",
    "RETURNING",
    "REVERSE",
    "REVOKE",
    "ROLLBACK",
    "ROW",
    "SAMPLE",
    "SAVE",
    "SAVEPOINT",
    "SB1",
    "SB2",
    "SB4",
    "SECOND",
    "SEGMENT",
    "SELECT",
    "SELF",
    "SEPARATE",
    "SEQUENCE",
    "SERIALIZABLE",
    "SET",
    "SHARE",
    "SHORT",
    "SIZE",
    "SIZE_T",
    "SOME",
    "SPARSE",
    "SQL",
    "SQLCODE",
    "SQLDATA",
    "SQLNAME",
    "SQLSTATE",
    "STANDARD",
    "START",
    "STATIC",
    "STDDEV",
    "STORED",
    "STRING",
    "STRUCT",
    "STYLE",
    "SUBMULTISET",
    "SUBPARTITION",
    "SUBSTITUTABLE",
    "SUBTYPE",
    "SUM",
    "SYNONYM",
    "TABAUTH",
    "TABLE",
    "TDO",
    "THE",
    "THEN",
    "TIME",
    "TIMESTAMP",
    "TIMEZONE_ABBR",
    "TIMEZONE_HOUR",
    "TIMEZONE_MINUTE",
    "TIMEZONE_REGION",
    "TO",
    "TRAILING",
    "TRANSAC",
    "TRANSACTIONAL",
    "TRUSTED",
    "TYPE",
    "UB1",
    "UB2",
    "UB4",
    "UNDER",
    "UNION",
    "UNIQUE",
    "UNSIGNED",
    "UNTRUSTED",
    "UPDATE",
    "USE",
    "USING",
    "VALIST",
    "VALUE",
    "VALUES",
    "VARIABLE",
    "VARIANCE",
    "VARRAY",
    "VARYING",
    "VIEW",
    "VIEWS",
    "VOID",
    "WHEN",
    "WHERE",
    "WHILE",
    "WITH",
    "WORK",
    "WRAPPED",
    "WRITE",
    "YEAR",
    "ZONE"
  ]
}), bG = en({
  // https://docs.oracle.com/cd/B19306_01/server.102/b14200/functions001.htm
  numeric: ["ABS", "ACOS", "ASIN", "ATAN", "ATAN2", "BITAND", "CEIL", "COS", "COSH", "EXP", "FLOOR", "LN", "LOG", "MOD", "NANVL", "POWER", "REMAINDER", "ROUND", "SIGN", "SIN", "SINH", "SQRT", "TAN", "TANH", "TRUNC", "WIDTH_BUCKET"],
  character: ["CHR", "CONCAT", "INITCAP", "LOWER", "LPAD", "LTRIM", "NLS_INITCAP", "NLS_LOWER", "NLSSORT", "NLS_UPPER", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPLACE", "RPAD", "RTRIM", "SOUNDEX", "SUBSTR", "TRANSLATE", "TREAT", "TRIM", "UPPER", "NLS_CHARSET_DECL_LEN", "NLS_CHARSET_ID", "NLS_CHARSET_NAME", "ASCII", "INSTR", "LENGTH", "REGEXP_INSTR"],
  datetime: ["ADD_MONTHS", "CURRENT_DATE", "CURRENT_TIMESTAMP", "DBTIMEZONE", "EXTRACT", "FROM_TZ", "LAST_DAY", "LOCALTIMESTAMP", "MONTHS_BETWEEN", "NEW_TIME", "NEXT_DAY", "NUMTODSINTERVAL", "NUMTOYMINTERVAL", "ROUND", "SESSIONTIMEZONE", "SYS_EXTRACT_UTC", "SYSDATE", "SYSTIMESTAMP", "TO_CHAR", "TO_TIMESTAMP", "TO_TIMESTAMP_TZ", "TO_DSINTERVAL", "TO_YMINTERVAL", "TRUNC", "TZ_OFFSET"],
  comparison: ["GREATEST", "LEAST"],
  conversion: ["ASCIISTR", "BIN_TO_NUM", "CAST", "CHARTOROWID", "COMPOSE", "CONVERT", "DECOMPOSE", "HEXTORAW", "NUMTODSINTERVAL", "NUMTOYMINTERVAL", "RAWTOHEX", "RAWTONHEX", "ROWIDTOCHAR", "ROWIDTONCHAR", "SCN_TO_TIMESTAMP", "TIMESTAMP_TO_SCN", "TO_BINARY_DOUBLE", "TO_BINARY_FLOAT", "TO_CHAR", "TO_CLOB", "TO_DATE", "TO_DSINTERVAL", "TO_LOB", "TO_MULTI_BYTE", "TO_NCHAR", "TO_NCLOB", "TO_NUMBER", "TO_DSINTERVAL", "TO_SINGLE_BYTE", "TO_TIMESTAMP", "TO_TIMESTAMP_TZ", "TO_YMINTERVAL", "TO_YMINTERVAL", "TRANSLATE", "UNISTR"],
  largeObject: ["BFILENAME", "EMPTY_BLOB,", "EMPTY_CLOB"],
  collection: ["CARDINALITY", "COLLECT", "POWERMULTISET", "POWERMULTISET_BY_CARDINALITY", "SET"],
  hierarchical: ["SYS_CONNECT_BY_PATH"],
  dataMining: ["CLUSTER_ID", "CLUSTER_PROBABILITY", "CLUSTER_SET", "FEATURE_ID", "FEATURE_SET", "FEATURE_VALUE", "PREDICTION", "PREDICTION_COST", "PREDICTION_DETAILS", "PREDICTION_PROBABILITY", "PREDICTION_SET"],
  xml: ["APPENDCHILDXML", "DELETEXML", "DEPTH", "EXTRACT", "EXISTSNODE", "EXTRACTVALUE", "INSERTCHILDXML", "INSERTXMLBEFORE", "PATH", "SYS_DBURIGEN", "SYS_XMLAGG", "SYS_XMLGEN", "UPDATEXML", "XMLAGG", "XMLCDATA", "XMLCOLATTVAL", "XMLCOMMENT", "XMLCONCAT", "XMLFOREST", "XMLPARSE", "XMLPI", "XMLQUERY", "XMLROOT", "XMLSEQUENCE", "XMLSERIALIZE", "XMLTABLE", "XMLTRANSFORM"],
  encoding: ["DECODE", "DUMP", "ORA_HASH", "VSIZE"],
  nullRelated: ["COALESCE", "LNNVL", "NULLIF", "NVL", "NVL2"],
  env: ["SYS_CONTEXT", "SYS_GUID", "SYS_TYPEID", "UID", "USER", "USERENV"],
  aggregate: ["AVG", "COLLECT", "CORR", "CORR_S", "CORR_K", "COUNT", "COVAR_POP", "COVAR_SAMP", "CUME_DIST", "DENSE_RANK", "FIRST", "GROUP_ID", "GROUPING", "GROUPING_ID", "LAST", "MAX", "MEDIAN", "MIN", "PERCENTILE_CONT", "PERCENTILE_DISC", "PERCENT_RANK", "RANK", "REGR_SLOPE", "REGR_INTERCEPT", "REGR_COUNT", "REGR_R2", "REGR_AVGX", "REGR_AVGY", "REGR_SXX", "REGR_SYY", "REGR_SXY", "STATS_BINOMIAL_TEST", "STATS_CROSSTAB", "STATS_F_TEST", "STATS_KS_TEST", "STATS_MODE", "STATS_MW_TEST", "STATS_ONE_WAY_ANOVA", "STATS_T_TEST_ONE", "STATS_T_TEST_PAIRED", "STATS_T_TEST_INDEP", "STATS_T_TEST_INDEPU", "STATS_WSR_TEST", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "SUM", "VAR_POP", "VAR_SAMP", "VARIANCE"],
  // Windowing functions (minus the ones already listed in aggregates)
  window: ["FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "NTILE", "RATIO_TO_REPORT", "ROW_NUMBER"],
  objectReference: ["DEREF", "MAKE_REF", "REF", "REFTOHEX", "VALUE"],
  model: ["CV", "ITERATION_NUMBER", "PRESENTNNV", "PRESENTV", "PREVIOUS"],
  // Parameterized data types
  // https://docs.oracle.com/en/database/oracle/oracle-database/19/sqlrf/Data-Types.html
  dataTypes: [
    // Oracle builtin data types
    "VARCHAR2",
    "NVARCHAR2",
    "NUMBER",
    "FLOAT",
    "TIMESTAMP",
    "INTERVAL YEAR",
    "INTERVAL DAY",
    "RAW",
    "UROWID",
    "NCHAR",
    // ANSI Data Types
    "CHARACTER",
    "CHAR",
    "CHARACTER VARYING",
    "CHAR VARYING",
    "NATIONAL CHARACTER",
    "NATIONAL CHAR",
    "NATIONAL CHARACTER VARYING",
    "NATIONAL CHAR VARYING",
    "NCHAR VARYING",
    "NUMERIC",
    "DECIMAL",
    "FLOAT",
    // SQL/DS and DB2 Data Types
    "VARCHAR"
  ]
}), HG = pe(["SELECT [ALL | DISTINCT | UNIQUE]"]), BG = pe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER [SIBLINGS] BY",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  "FOR UPDATE [OF]",
  // Data manipulation
  // - insert:
  "INSERT [INTO | ALL INTO]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE [INTO]",
  "WHEN [NOT] MATCHED [THEN]",
  "UPDATE SET",
  // Data definition
  "CREATE [OR REPLACE] [NO FORCE | FORCE] [EDITIONING | EDITIONABLE | EDITIONABLE EDITIONING | NONEDITIONABLE] VIEW",
  "CREATE MATERIALIZED VIEW",
  "CREATE [GLOBAL TEMPORARY | PRIVATE TEMPORARY | SHARDED | DUPLICATED | IMMUTABLE BLOCKCHAIN | BLOCKCHAIN | IMMUTABLE] TABLE",
  // other
  "RETURNING"
]), Bm = pe([
  // - update:
  "UPDATE [ONLY]",
  // - delete:
  "DELETE FROM [ONLY]",
  // - drop table:
  "DROP TABLE",
  // - alter table:
  "ALTER TABLE",
  "ADD",
  "DROP {COLUMN | UNUSED COLUMNS | COLUMNS CONTINUE}",
  "MODIFY",
  "RENAME TO",
  "RENAME COLUMN",
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "SET SCHEMA",
  "BEGIN",
  "CONNECT BY",
  "DECLARE",
  "EXCEPT",
  "EXCEPTION",
  "LOOP",
  "START WITH"
]), FG = pe(["UNION [ALL]", "EXCEPT", "INTERSECT"]), wG = pe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL [INNER] JOIN",
  "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN",
  // non-standard joins
  "{CROSS | OUTER} APPLY"
]), YG = pe(["ON {UPDATE | DELETE} [SET NULL]", "ON COMMIT", "{ROWS | RANGE} BETWEEN"]), VG = {
  tokenizerOptions: {
    reservedSelect: HG,
    reservedClauses: [...BG, ...Bm],
    reservedSetOperations: FG,
    reservedJoins: wG,
    reservedPhrases: YG,
    supportsXor: !0,
    reservedKeywords: xG,
    reservedFunctionNames: bG,
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["N"]
    }, {
      quote: "q''",
      prefixes: ["N"]
    }],
    // PL/SQL doesn't actually support escaping of quotes in identifiers,
    // but for the sake of simpler testing we'll support this anyway
    // as all other SQL dialects with "identifiers" do.
    identTypes: ['""-qq'],
    identChars: {
      rest: "$#"
    },
    variableTypes: [{
      regex: "&{1,2}[A-Za-z][A-Za-z0-9_$#]*"
    }],
    paramTypes: {
      numbered: [":"],
      named: [":"]
    },
    paramChars: {},
    // Empty object used on purpose to not allow $ and # chars as specified in identChars
    operators: [
      "**",
      ":=",
      "%",
      "~=",
      "^=",
      // '..', // Conflicts with float followed by dot (so "2..3" gets parsed as ["2.", ".", "3"])
      ">>",
      "<<",
      "=>",
      "@",
      "||"
    ],
    postProcess: WG
  },
  formatOptions: {
    alwaysDenseOperators: ["@"],
    onelineClauses: Bm
  }
};
function WG(l) {
  let u = PE;
  return l.map((T) => su.SET(T) && su.BY(u) ? {
    ...T,
    type: Re.RESERVED_KEYWORD
  } : (BL(T.type) && (u = T), T));
}
const XG = en({
  // https://www.postgresql.org/docs/14/functions.html
  //
  // https://www.postgresql.org/docs/14/functions-math.html
  math: ["ABS", "ACOS", "ACOSD", "ACOSH", "ASIN", "ASIND", "ASINH", "ATAN", "ATAN2", "ATAN2D", "ATAND", "ATANH", "CBRT", "CEIL", "CEILING", "COS", "COSD", "COSH", "COT", "COTD", "DEGREES", "DIV", "EXP", "FACTORIAL", "FLOOR", "GCD", "LCM", "LN", "LOG", "LOG10", "MIN_SCALE", "MOD", "PI", "POWER", "RADIANS", "RANDOM", "ROUND", "SCALE", "SETSEED", "SIGN", "SIN", "SIND", "SINH", "SQRT", "TAN", "TAND", "TANH", "TRIM_SCALE", "TRUNC", "WIDTH_BUCKET"],
  // https://www.postgresql.org/docs/14/functions-string.html
  string: ["ABS", "ASCII", "BIT_LENGTH", "BTRIM", "CHARACTER_LENGTH", "CHAR_LENGTH", "CHR", "CONCAT", "CONCAT_WS", "FORMAT", "INITCAP", "LEFT", "LENGTH", "LOWER", "LPAD", "LTRIM", "MD5", "NORMALIZE", "OCTET_LENGTH", "OVERLAY", "PARSE_IDENT", "PG_CLIENT_ENCODING", "POSITION", "QUOTE_IDENT", "QUOTE_LITERAL", "QUOTE_NULLABLE", "REGEXP_MATCH", "REGEXP_MATCHES", "REGEXP_REPLACE", "REGEXP_SPLIT_TO_ARRAY", "REGEXP_SPLIT_TO_TABLE", "REPEAT", "REPLACE", "REVERSE", "RIGHT", "RPAD", "RTRIM", "SPLIT_PART", "SPRINTF", "STARTS_WITH", "STRING_AGG", "STRING_TO_ARRAY", "STRING_TO_TABLE", "STRPOS", "SUBSTR", "SUBSTRING", "TO_ASCII", "TO_HEX", "TRANSLATE", "TRIM", "UNISTR", "UPPER"],
  // https://www.postgresql.org/docs/14/functions-binarystring.html
  binary: ["BIT_COUNT", "BIT_LENGTH", "BTRIM", "CONVERT", "CONVERT_FROM", "CONVERT_TO", "DECODE", "ENCODE", "GET_BIT", "GET_BYTE", "LENGTH", "LTRIM", "MD5", "OCTET_LENGTH", "OVERLAY", "POSITION", "RTRIM", "SET_BIT", "SET_BYTE", "SHA224", "SHA256", "SHA384", "SHA512", "STRING_AGG", "SUBSTR", "SUBSTRING", "TRIM"],
  // https://www.postgresql.org/docs/14/functions-bitstring.html
  bitstring: ["BIT_COUNT", "BIT_LENGTH", "GET_BIT", "LENGTH", "OCTET_LENGTH", "OVERLAY", "POSITION", "SET_BIT", "SUBSTRING"],
  // https://www.postgresql.org/docs/14/functions-matching.html
  pattern: ["REGEXP_MATCH", "REGEXP_MATCHES", "REGEXP_REPLACE", "REGEXP_SPLIT_TO_ARRAY", "REGEXP_SPLIT_TO_TABLE"],
  // https://www.postgresql.org/docs/14/functions-formatting.html
  datatype: ["TO_CHAR", "TO_DATE", "TO_NUMBER", "TO_TIMESTAMP"],
  // https://www.postgresql.org/docs/14/functions-datetime.html
  datetime: [
    // 'AGE',
    "CLOCK_TIMESTAMP",
    "CURRENT_DATE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "DATE_BIN",
    "DATE_PART",
    "DATE_TRUNC",
    "EXTRACT",
    "ISFINITE",
    "JUSTIFY_DAYS",
    "JUSTIFY_HOURS",
    "JUSTIFY_INTERVAL",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "MAKE_DATE",
    "MAKE_INTERVAL",
    "MAKE_TIME",
    "MAKE_TIMESTAMP",
    "MAKE_TIMESTAMPTZ",
    "NOW",
    "PG_SLEEP",
    "PG_SLEEP_FOR",
    "PG_SLEEP_UNTIL",
    "STATEMENT_TIMESTAMP",
    "TIMEOFDAY",
    "TO_TIMESTAMP",
    "TRANSACTION_TIMESTAMP"
  ],
  // https://www.postgresql.org/docs/14/functions-enum.html
  enum: ["ENUM_FIRST", "ENUM_LAST", "ENUM_RANGE"],
  // https://www.postgresql.org/docs/14/functions-geometry.html
  geometry: ["AREA", "BOUND_BOX", "BOX", "CENTER", "CIRCLE", "DIAGONAL", "DIAMETER", "HEIGHT", "ISCLOSED", "ISOPEN", "LENGTH", "LINE", "LSEG", "NPOINTS", "PATH", "PCLOSE", "POINT", "POLYGON", "POPEN", "RADIUS", "SLOPE", "WIDTH"],
  // https://www.postgresql.org/docs/14/functions-net.html
  network: ["ABBREV", "BROADCAST", "FAMILY", "HOST", "HOSTMASK", "INET_MERGE", "INET_SAME_FAMILY", "MACADDR8_SET7BIT", "MASKLEN", "NETMASK", "NETWORK", "SET_MASKLEN", "TEXT", "TRUNC"],
  // https://www.postgresql.org/docs/14/functions-textsearch.html
  textsearch: ["ARRAY_TO_TSVECTOR", "GET_CURRENT_TS_CONFIG", "JSONB_TO_TSVECTOR", "JSON_TO_TSVECTOR", "LENGTH", "NUMNODE", "PHRASETO_TSQUERY", "PLAINTO_TSQUERY", "QUERYTREE", "SETWEIGHT", "STRIP", "TO_TSQUERY", "TO_TSVECTOR", "TSQUERY_PHRASE", "TSVECTOR_TO_ARRAY", "TS_DEBUG", "TS_DELETE", "TS_FILTER", "TS_HEADLINE", "TS_LEXIZE", "TS_PARSE", "TS_RANK", "TS_RANK_CD", "TS_REWRITE", "TS_STAT", "TS_TOKEN_TYPE", "WEBSEARCH_TO_TSQUERY"],
  // https://www.postgresql.org/docs/14/functions-uuid.html
  uuid: ["UUID"],
  // https://www.postgresql.org/docs/14/functions-xml.html
  xml: ["CURSOR_TO_XML", "CURSOR_TO_XMLSCHEMA", "DATABASE_TO_XML", "DATABASE_TO_XMLSCHEMA", "DATABASE_TO_XML_AND_XMLSCHEMA", "NEXTVAL", "QUERY_TO_XML", "QUERY_TO_XMLSCHEMA", "QUERY_TO_XML_AND_XMLSCHEMA", "SCHEMA_TO_XML", "SCHEMA_TO_XMLSCHEMA", "SCHEMA_TO_XML_AND_XMLSCHEMA", "STRING", "TABLE_TO_XML", "TABLE_TO_XMLSCHEMA", "TABLE_TO_XML_AND_XMLSCHEMA", "XMLAGG", "XMLCOMMENT", "XMLCONCAT", "XMLELEMENT", "XMLEXISTS", "XMLFOREST", "XMLPARSE", "XMLPI", "XMLROOT", "XMLSERIALIZE", "XMLTABLE", "XML_IS_WELL_FORMED", "XML_IS_WELL_FORMED_CONTENT", "XML_IS_WELL_FORMED_DOCUMENT", "XPATH", "XPATH_EXISTS"],
  // https://www.postgresql.org/docs/14/functions-json.html
  json: ["ARRAY_TO_JSON", "JSONB_AGG", "JSONB_ARRAY_ELEMENTS", "JSONB_ARRAY_ELEMENTS_TEXT", "JSONB_ARRAY_LENGTH", "JSONB_BUILD_ARRAY", "JSONB_BUILD_OBJECT", "JSONB_EACH", "JSONB_EACH_TEXT", "JSONB_EXTRACT_PATH", "JSONB_EXTRACT_PATH_TEXT", "JSONB_INSERT", "JSONB_OBJECT", "JSONB_OBJECT_AGG", "JSONB_OBJECT_KEYS", "JSONB_PATH_EXISTS", "JSONB_PATH_EXISTS_TZ", "JSONB_PATH_MATCH", "JSONB_PATH_MATCH_TZ", "JSONB_PATH_QUERY", "JSONB_PATH_QUERY_ARRAY", "JSONB_PATH_QUERY_ARRAY_TZ", "JSONB_PATH_QUERY_FIRST", "JSONB_PATH_QUERY_FIRST_TZ", "JSONB_PATH_QUERY_TZ", "JSONB_POPULATE_RECORD", "JSONB_POPULATE_RECORDSET", "JSONB_PRETTY", "JSONB_SET", "JSONB_SET_LAX", "JSONB_STRIP_NULLS", "JSONB_TO_RECORD", "JSONB_TO_RECORDSET", "JSONB_TYPEOF", "JSON_AGG", "JSON_ARRAY_ELEMENTS", "JSON_ARRAY_ELEMENTS_TEXT", "JSON_ARRAY_LENGTH", "JSON_BUILD_ARRAY", "JSON_BUILD_OBJECT", "JSON_EACH", "JSON_EACH_TEXT", "JSON_EXTRACT_PATH", "JSON_EXTRACT_PATH_TEXT", "JSON_OBJECT", "JSON_OBJECT_AGG", "JSON_OBJECT_KEYS", "JSON_POPULATE_RECORD", "JSON_POPULATE_RECORDSET", "JSON_STRIP_NULLS", "JSON_TO_RECORD", "JSON_TO_RECORDSET", "JSON_TYPEOF", "ROW_TO_JSON", "TO_JSON", "TO_JSONB", "TO_TIMESTAMP"],
  // https://www.postgresql.org/docs/14/functions-sequence.html
  sequence: ["CURRVAL", "LASTVAL", "NEXTVAL", "SETVAL"],
  // https://www.postgresql.org/docs/14/functions-conditional.html
  conditional: [
    // 'CASE',
    "COALESCE",
    "GREATEST",
    "LEAST",
    "NULLIF"
  ],
  // https://www.postgresql.org/docs/14/functions-array.html
  array: ["ARRAY_AGG", "ARRAY_APPEND", "ARRAY_CAT", "ARRAY_DIMS", "ARRAY_FILL", "ARRAY_LENGTH", "ARRAY_LOWER", "ARRAY_NDIMS", "ARRAY_POSITION", "ARRAY_POSITIONS", "ARRAY_PREPEND", "ARRAY_REMOVE", "ARRAY_REPLACE", "ARRAY_TO_STRING", "ARRAY_UPPER", "CARDINALITY", "STRING_TO_ARRAY", "TRIM_ARRAY", "UNNEST"],
  // https://www.postgresql.org/docs/14/functions-range.html
  range: ["ISEMPTY", "LOWER", "LOWER_INC", "LOWER_INF", "MULTIRANGE", "RANGE_MERGE", "UPPER", "UPPER_INC", "UPPER_INF"],
  // https://www.postgresql.org/docs/14/functions-aggregate.html
  aggregate: [
    // 'ANY',
    "ARRAY_AGG",
    "AVG",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "BOOL_AND",
    "BOOL_OR",
    "COALESCE",
    "CORR",
    "COUNT",
    "COVAR_POP",
    "COVAR_SAMP",
    "CUME_DIST",
    "DENSE_RANK",
    "EVERY",
    "GROUPING",
    "JSONB_AGG",
    "JSONB_OBJECT_AGG",
    "JSON_AGG",
    "JSON_OBJECT_AGG",
    "MAX",
    "MIN",
    "MODE",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "PERCENT_RANK",
    "RANGE_AGG",
    "RANGE_INTERSECT_AGG",
    "RANK",
    "REGR_AVGX",
    "REGR_AVGY",
    "REGR_COUNT",
    "REGR_INTERCEPT",
    "REGR_R2",
    "REGR_SLOPE",
    "REGR_SXX",
    "REGR_SXY",
    "REGR_SYY",
    // 'SOME',
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STRING_AGG",
    "SUM",
    "TO_JSON",
    "TO_JSONB",
    "VARIANCE",
    "VAR_POP",
    "VAR_SAMP",
    "XMLAGG"
  ],
  // https://www.postgresql.org/docs/14/functions-window.html
  window: ["CUME_DIST", "DENSE_RANK", "FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "NTH_VALUE", "NTILE", "PERCENT_RANK", "RANK", "ROW_NUMBER"],
  // https://www.postgresql.org/docs/14/functions-srf.html
  set: ["GENERATE_SERIES", "GENERATE_SUBSCRIPTS"],
  // https://www.postgresql.org/docs/14/functions-info.html
  sysInfo: ["ACLDEFAULT", "ACLEXPLODE", "COL_DESCRIPTION", "CURRENT_CATALOG", "CURRENT_DATABASE", "CURRENT_QUERY", "CURRENT_ROLE", "CURRENT_SCHEMA", "CURRENT_SCHEMAS", "CURRENT_USER", "FORMAT_TYPE", "HAS_ANY_COLUMN_PRIVILEGE", "HAS_COLUMN_PRIVILEGE", "HAS_DATABASE_PRIVILEGE", "HAS_FOREIGN_DATA_WRAPPER_PRIVILEGE", "HAS_FUNCTION_PRIVILEGE", "HAS_LANGUAGE_PRIVILEGE", "HAS_SCHEMA_PRIVILEGE", "HAS_SEQUENCE_PRIVILEGE", "HAS_SERVER_PRIVILEGE", "HAS_TABLESPACE_PRIVILEGE", "HAS_TABLE_PRIVILEGE", "HAS_TYPE_PRIVILEGE", "INET_CLIENT_ADDR", "INET_CLIENT_PORT", "INET_SERVER_ADDR", "INET_SERVER_PORT", "MAKEACLITEM", "OBJ_DESCRIPTION", "PG_BACKEND_PID", "PG_BLOCKING_PIDS", "PG_COLLATION_IS_VISIBLE", "PG_CONF_LOAD_TIME", "PG_CONTROL_CHECKPOINT", "PG_CONTROL_INIT", "PG_CONTROL_SYSTEM", "PG_CONVERSION_IS_VISIBLE", "PG_CURRENT_LOGFILE", "PG_CURRENT_SNAPSHOT", "PG_CURRENT_XACT_ID", "PG_CURRENT_XACT_ID_IF_ASSIGNED", "PG_DESCRIBE_OBJECT", "PG_FUNCTION_IS_VISIBLE", "PG_GET_CATALOG_FOREIGN_KEYS", "PG_GET_CONSTRAINTDEF", "PG_GET_EXPR", "PG_GET_FUNCTIONDEF", "PG_GET_FUNCTION_ARGUMENTS", "PG_GET_FUNCTION_IDENTITY_ARGUMENTS", "PG_GET_FUNCTION_RESULT", "PG_GET_INDEXDEF", "PG_GET_KEYWORDS", "PG_GET_OBJECT_ADDRESS", "PG_GET_OWNED_SEQUENCE", "PG_GET_RULEDEF", "PG_GET_SERIAL_SEQUENCE", "PG_GET_STATISTICSOBJDEF", "PG_GET_TRIGGERDEF", "PG_GET_USERBYID", "PG_GET_VIEWDEF", "PG_HAS_ROLE", "PG_IDENTIFY_OBJECT", "PG_IDENTIFY_OBJECT_AS_ADDRESS", "PG_INDEXAM_HAS_PROPERTY", "PG_INDEX_COLUMN_HAS_PROPERTY", "PG_INDEX_HAS_PROPERTY", "PG_IS_OTHER_TEMP_SCHEMA", "PG_JIT_AVAILABLE", "PG_LAST_COMMITTED_XACT", "PG_LISTENING_CHANNELS", "PG_MY_TEMP_SCHEMA", "PG_NOTIFICATION_QUEUE_USAGE", "PG_OPCLASS_IS_VISIBLE", "PG_OPERATOR_IS_VISIBLE", "PG_OPFAMILY_IS_VISIBLE", "PG_OPTIONS_TO_TABLE", "PG_POSTMASTER_START_TIME", "PG_SAFE_SNAPSHOT_BLOCKING_PIDS", "PG_SNAPSHOT_XIP", "PG_SNAPSHOT_XMAX", "PG_SNAPSHOT_XMIN", "PG_STATISTICS_OBJ_IS_VISIBLE", "PG_TABLESPACE_DATABASES", "PG_TABLESPACE_LOCATION", "PG_TABLE_IS_VISIBLE", "PG_TRIGGER_DEPTH", "PG_TS_CONFIG_IS_VISIBLE", "PG_TS_DICT_IS_VISIBLE", "PG_TS_PARSER_IS_VISIBLE", "PG_TS_TEMPLATE_IS_VISIBLE", "PG_TYPEOF", "PG_TYPE_IS_VISIBLE", "PG_VISIBLE_IN_SNAPSHOT", "PG_XACT_COMMIT_TIMESTAMP", "PG_XACT_COMMIT_TIMESTAMP_ORIGIN", "PG_XACT_STATUS", "PQSERVERVERSION", "ROW_SECURITY_ACTIVE", "SESSION_USER", "SHOBJ_DESCRIPTION", "TO_REGCLASS", "TO_REGCOLLATION", "TO_REGNAMESPACE", "TO_REGOPER", "TO_REGOPERATOR", "TO_REGPROC", "TO_REGPROCEDURE", "TO_REGROLE", "TO_REGTYPE", "TXID_CURRENT", "TXID_CURRENT_IF_ASSIGNED", "TXID_CURRENT_SNAPSHOT", "TXID_SNAPSHOT_XIP", "TXID_SNAPSHOT_XMAX", "TXID_SNAPSHOT_XMIN", "TXID_STATUS", "TXID_VISIBLE_IN_SNAPSHOT", "USER", "VERSION"],
  // https://www.postgresql.org/docs/14/functions-admin.html
  sysAdmin: ["BRIN_DESUMMARIZE_RANGE", "BRIN_SUMMARIZE_NEW_VALUES", "BRIN_SUMMARIZE_RANGE", "CONVERT_FROM", "CURRENT_SETTING", "GIN_CLEAN_PENDING_LIST", "PG_ADVISORY_LOCK", "PG_ADVISORY_LOCK_SHARED", "PG_ADVISORY_UNLOCK", "PG_ADVISORY_UNLOCK_ALL", "PG_ADVISORY_UNLOCK_SHARED", "PG_ADVISORY_XACT_LOCK", "PG_ADVISORY_XACT_LOCK_SHARED", "PG_BACKUP_START_TIME", "PG_CANCEL_BACKEND", "PG_COLLATION_ACTUAL_VERSION", "PG_COLUMN_COMPRESSION", "PG_COLUMN_SIZE", "PG_COPY_LOGICAL_REPLICATION_SLOT", "PG_COPY_PHYSICAL_REPLICATION_SLOT", "PG_CREATE_LOGICAL_REPLICATION_SLOT", "PG_CREATE_PHYSICAL_REPLICATION_SLOT", "PG_CREATE_RESTORE_POINT", "PG_CURRENT_WAL_FLUSH_LSN", "PG_CURRENT_WAL_INSERT_LSN", "PG_CURRENT_WAL_LSN", "PG_DATABASE_SIZE", "PG_DROP_REPLICATION_SLOT", "PG_EXPORT_SNAPSHOT", "PG_FILENODE_RELATION", "PG_GET_WAL_REPLAY_PAUSE_STATE", "PG_IMPORT_SYSTEM_COLLATIONS", "PG_INDEXES_SIZE", "PG_IS_IN_BACKUP", "PG_IS_IN_RECOVERY", "PG_IS_WAL_REPLAY_PAUSED", "PG_LAST_WAL_RECEIVE_LSN", "PG_LAST_WAL_REPLAY_LSN", "PG_LAST_XACT_REPLAY_TIMESTAMP", "PG_LOGICAL_EMIT_MESSAGE", "PG_LOGICAL_SLOT_GET_BINARY_CHANGES", "PG_LOGICAL_SLOT_GET_CHANGES", "PG_LOGICAL_SLOT_PEEK_BINARY_CHANGES", "PG_LOGICAL_SLOT_PEEK_CHANGES", "PG_LOG_BACKEND_MEMORY_CONTEXTS", "PG_LS_ARCHIVE_STATUSDIR", "PG_LS_DIR", "PG_LS_LOGDIR", "PG_LS_TMPDIR", "PG_LS_WALDIR", "PG_PARTITION_ANCESTORS", "PG_PARTITION_ROOT", "PG_PARTITION_TREE", "PG_PROMOTE", "PG_READ_BINARY_FILE", "PG_READ_FILE", "PG_RELATION_FILENODE", "PG_RELATION_FILEPATH", "PG_RELATION_SIZE", "PG_RELOAD_CONF", "PG_REPLICATION_ORIGIN_ADVANCE", "PG_REPLICATION_ORIGIN_CREATE", "PG_REPLICATION_ORIGIN_DROP", "PG_REPLICATION_ORIGIN_OID", "PG_REPLICATION_ORIGIN_PROGRESS", "PG_REPLICATION_ORIGIN_SESSION_IS_SETUP", "PG_REPLICATION_ORIGIN_SESSION_PROGRESS", "PG_REPLICATION_ORIGIN_SESSION_RESET", "PG_REPLICATION_ORIGIN_SESSION_SETUP", "PG_REPLICATION_ORIGIN_XACT_RESET", "PG_REPLICATION_ORIGIN_XACT_SETUP", "PG_REPLICATION_SLOT_ADVANCE", "PG_ROTATE_LOGFILE", "PG_SIZE_BYTES", "PG_SIZE_PRETTY", "PG_START_BACKUP", "PG_STAT_FILE", "PG_STOP_BACKUP", "PG_SWITCH_WAL", "PG_TABLESPACE_SIZE", "PG_TABLE_SIZE", "PG_TERMINATE_BACKEND", "PG_TOTAL_RELATION_SIZE", "PG_TRY_ADVISORY_LOCK", "PG_TRY_ADVISORY_LOCK_SHARED", "PG_TRY_ADVISORY_XACT_LOCK", "PG_TRY_ADVISORY_XACT_LOCK_SHARED", "PG_WALFILE_NAME", "PG_WALFILE_NAME_OFFSET", "PG_WAL_LSN_DIFF", "PG_WAL_REPLAY_PAUSE", "PG_WAL_REPLAY_RESUME", "SET_CONFIG"],
  // https://www.postgresql.org/docs/14/functions-trigger.html
  trigger: ["SUPPRESS_REDUNDANT_UPDATES_TRIGGER", "TSVECTOR_UPDATE_TRIGGER", "TSVECTOR_UPDATE_TRIGGER_COLUMN"],
  // https://www.postgresql.org/docs/14/functions-event-triggers.html
  eventTrigger: ["PG_EVENT_TRIGGER_DDL_COMMANDS", "PG_EVENT_TRIGGER_DROPPED_OBJECTS", "PG_EVENT_TRIGGER_TABLE_REWRITE_OID", "PG_EVENT_TRIGGER_TABLE_REWRITE_REASON", "PG_GET_OBJECT_ADDRESS"],
  // https://www.postgresql.org/docs/14/functions-statistics.html
  stats: ["PG_MCV_LIST_ITEMS"],
  cast: ["CAST"],
  // Parameterized data types
  // https://www.postgresql.org/docs/current/datatype.html
  dataTypes: ["BIT", "BIT VARYING", "CHARACTER", "CHARACTER VARYING", "VARCHAR", "CHAR", "DECIMAL", "NUMERIC", "TIME", "TIMESTAMP", "ENUM"]
}), kG = en({
  // https://www.postgresql.org/docs/14/sql-keywords-appendix.html
  all: [
    "ABORT",
    "ABSOLUTE",
    "ACCESS",
    "ACTION",
    "ADD",
    "ADMIN",
    "AFTER",
    "AGGREGATE",
    "ALL",
    // reserved
    "ALSO",
    "ALTER",
    "ALWAYS",
    "ANALYSE",
    // reserved
    "ANALYZE",
    // reserved
    "AND",
    // reserved
    "ANY",
    // reserved
    "ARRAY",
    // reserved, requires AS
    "AS",
    // reserved, requires AS
    "ASC",
    // reserved
    "ASENSITIVE",
    "ASSERTION",
    "ASSIGNMENT",
    "ASYMMETRIC",
    // reserved
    "AT",
    "ATOMIC",
    "ATTACH",
    "ATTRIBUTE",
    "AUTHORIZATION",
    // reserved (can be function or type)
    "BACKWARD",
    "BEFORE",
    "BEGIN",
    "BETWEEN",
    // (cannot be function or type)
    "BIGINT",
    // (cannot be function or type)
    "BINARY",
    // reserved (can be function or type)
    "BIT",
    // (cannot be function or type)
    "BOOLEAN",
    // (cannot be function or type)
    "BOTH",
    // reserved
    "BREADTH",
    "BY",
    "CACHE",
    "CALL",
    "CALLED",
    "CASCADE",
    "CASCADED",
    "CASE",
    // reserved
    "CAST",
    // reserved
    "CATALOG",
    "CHAIN",
    "CHAR",
    // (cannot be function or type), requires AS
    "CHARACTER",
    // (cannot be function or type), requires AS
    "CHARACTERISTICS",
    "CHECK",
    // reserved
    "CHECKPOINT",
    "CLASS",
    "CLOSE",
    "CLUSTER",
    "COALESCE",
    // (cannot be function or type)
    "COLLATE",
    // reserved
    "COLLATION",
    // reserved (can be function or type)
    "COLUMN",
    // reserved
    "COLUMNS",
    "COMMENT",
    "COMMENTS",
    "COMMIT",
    "COMMITTED",
    "COMPRESSION",
    "CONCURRENTLY",
    // reserved (can be function or type)
    "CONFIGURATION",
    "CONFLICT",
    "CONNECTION",
    "CONSTRAINT",
    // reserved
    "CONSTRAINTS",
    "CONTENT",
    "CONTINUE",
    "CONVERSION",
    "COPY",
    "COST",
    "CREATE",
    // reserved, requires AS
    "CROSS",
    // reserved (can be function or type)
    "CSV",
    "CUBE",
    "CURRENT",
    "CURRENT_CATALOG",
    // reserved
    "CURRENT_DATE",
    // reserved
    "CURRENT_ROLE",
    // reserved
    "CURRENT_SCHEMA",
    // reserved (can be function or type)
    "CURRENT_TIME",
    // reserved
    "CURRENT_TIMESTAMP",
    // reserved
    "CURRENT_USER",
    // reserved
    "CURSOR",
    "CYCLE",
    "DATA",
    "DATABASE",
    "DAY",
    // requires AS
    "DEALLOCATE",
    "DEC",
    // (cannot be function or type)
    "DECIMAL",
    // (cannot be function or type)
    "DECLARE",
    "DEFAULT",
    // reserved
    "DEFAULTS",
    "DEFERRABLE",
    // reserved
    "DEFERRED",
    "DEFINER",
    "DELETE",
    "DELIMITER",
    "DELIMITERS",
    "DEPENDS",
    "DEPTH",
    "DESC",
    // reserved
    "DETACH",
    "DICTIONARY",
    "DISABLE",
    "DISCARD",
    "DISTINCT",
    // reserved
    "DO",
    // reserved
    "DOCUMENT",
    "DOMAIN",
    "DOUBLE",
    "DROP",
    "EACH",
    "ELSE",
    // reserved
    "ENABLE",
    "ENCODING",
    "ENCRYPTED",
    "END",
    // reserved
    "ENUM",
    "ESCAPE",
    "EVENT",
    "EXCEPT",
    // reserved, requires AS
    "EXCLUDE",
    "EXCLUDING",
    "EXCLUSIVE",
    "EXECUTE",
    "EXISTS",
    // (cannot be function or type)
    "EXPLAIN",
    "EXPRESSION",
    "EXTENSION",
    "EXTERNAL",
    "EXTRACT",
    // (cannot be function or type)
    "FALSE",
    // reserved
    "FAMILY",
    "FETCH",
    // reserved, requires AS
    "FILTER",
    // requires AS
    "FINALIZE",
    "FIRST",
    "FLOAT",
    // (cannot be function or type)
    "FOLLOWING",
    "FOR",
    // reserved, requires AS
    "FORCE",
    "FOREIGN",
    // reserved
    "FORWARD",
    "FREEZE",
    // reserved (can be function or type)
    "FROM",
    // reserved, requires AS
    "FULL",
    // reserved (can be function or type)
    "FUNCTION",
    "FUNCTIONS",
    "GENERATED",
    "GLOBAL",
    "GRANT",
    // reserved, requires AS
    "GRANTED",
    "GREATEST",
    // (cannot be function or type)
    "GROUP",
    // reserved, requires AS
    "GROUPING",
    // (cannot be function or type)
    "GROUPS",
    "HANDLER",
    "HAVING",
    // reserved, requires AS
    "HEADER",
    "HOLD",
    "HOUR",
    // requires AS
    "IDENTITY",
    "IF",
    "ILIKE",
    // reserved (can be function or type)
    "IMMEDIATE",
    "IMMUTABLE",
    "IMPLICIT",
    "IMPORT",
    "IN",
    // reserved
    "INCLUDE",
    "INCLUDING",
    "INCREMENT",
    "INDEX",
    "INDEXES",
    "INHERIT",
    "INHERITS",
    "INITIALLY",
    // reserved
    "INLINE",
    "INNER",
    // reserved (can be function or type)
    "INOUT",
    // (cannot be function or type)
    "INPUT",
    "INSENSITIVE",
    "INSERT",
    "INSTEAD",
    "INT",
    // (cannot be function or type)
    "INTEGER",
    // (cannot be function or type)
    "INTERSECT",
    // reserved, requires AS
    "INTERVAL",
    // (cannot be function or type)
    "INTO",
    // reserved, requires AS
    "INVOKER",
    "IS",
    // reserved (can be function or type)
    "ISNULL",
    // reserved (can be function or type), requires AS
    "ISOLATION",
    "JOIN",
    // reserved (can be function or type)
    "KEY",
    "LABEL",
    "LANGUAGE",
    "LARGE",
    "LAST",
    "LATERAL",
    // reserved
    "LEADING",
    // reserved
    "LEAKPROOF",
    "LEAST",
    // (cannot be function or type)
    "LEFT",
    // reserved (can be function or type)
    "LEVEL",
    "LIKE",
    // reserved (can be function or type)
    "LIMIT",
    // reserved, requires AS
    "LISTEN",
    "LOAD",
    "LOCAL",
    "LOCALTIME",
    // reserved
    "LOCALTIMESTAMP",
    // reserved
    "LOCATION",
    "LOCK",
    "LOCKED",
    "LOGGED",
    "MAPPING",
    "MATCH",
    "MATERIALIZED",
    "MAXVALUE",
    "METHOD",
    "MINUTE",
    // requires AS
    "MINVALUE",
    "MODE",
    "MONTH",
    // requires AS
    "MOVE",
    "NAME",
    "NAMES",
    "NATIONAL",
    // (cannot be function or type)
    "NATURAL",
    // reserved (can be function or type)
    "NCHAR",
    // (cannot be function or type)
    "NEW",
    "NEXT",
    "NFC",
    "NFD",
    "NFKC",
    "NFKD",
    "NO",
    "NONE",
    // (cannot be function or type)
    "NORMALIZE",
    // (cannot be function or type)
    "NORMALIZED",
    "NOT",
    // reserved
    "NOTHING",
    "NOTIFY",
    "NOTNULL",
    // reserved (can be function or type), requires AS
    "NOWAIT",
    "NULL",
    // reserved
    "NULLIF",
    // (cannot be function or type)
    "NULLS",
    "NUMERIC",
    // (cannot be function or type)
    "OBJECT",
    "OF",
    "OFF",
    "OFFSET",
    // reserved, requires AS
    "OIDS",
    "OLD",
    "ON",
    // reserved, requires AS
    "ONLY",
    // reserved
    "OPERATOR",
    "OPTION",
    "OPTIONS",
    "OR",
    // reserved
    "ORDER",
    // reserved, requires AS
    "ORDINALITY",
    "OTHERS",
    "OUT",
    // (cannot be function or type)
    "OUTER",
    // reserved (can be function or type)
    "OVER",
    // requires AS
    "OVERLAPS",
    // reserved (can be function or type), requires AS
    "OVERLAY",
    // (cannot be function or type)
    "OVERRIDING",
    "OWNED",
    "OWNER",
    "PARALLEL",
    "PARSER",
    "PARTIAL",
    "PARTITION",
    "PASSING",
    "PASSWORD",
    "PLACING",
    // reserved
    "PLANS",
    "POLICY",
    "POSITION",
    // (cannot be function or type)
    "PRECEDING",
    "PRECISION",
    // (cannot be function or type), requires AS
    "PREPARE",
    "PREPARED",
    "PRESERVE",
    "PRIMARY",
    // reserved
    "PRIOR",
    "PRIVILEGES",
    "PROCEDURAL",
    "PROCEDURE",
    "PROCEDURES",
    "PROGRAM",
    "PUBLICATION",
    "QUOTE",
    "RANGE",
    "READ",
    "REAL",
    // (cannot be function or type)
    "REASSIGN",
    "RECHECK",
    "RECURSIVE",
    "REF",
    "REFERENCES",
    // reserved
    "REFERENCING",
    "REFRESH",
    "REINDEX",
    "RELATIVE",
    "RELEASE",
    "RENAME",
    "REPEATABLE",
    "REPLACE",
    "REPLICA",
    "RESET",
    "RESTART",
    "RESTRICT",
    "RETURN",
    "RETURNING",
    // reserved, requires AS
    "RETURNS",
    "REVOKE",
    "RIGHT",
    // reserved (can be function or type)
    "ROLE",
    "ROLLBACK",
    "ROLLUP",
    "ROUTINE",
    "ROUTINES",
    "ROW",
    // (cannot be function or type)
    "ROWS",
    "RULE",
    "SAVEPOINT",
    "SCHEMA",
    "SCHEMAS",
    "SCROLL",
    "SEARCH",
    "SECOND",
    // requires AS
    "SECURITY",
    "SELECT",
    // reserved
    "SEQUENCE",
    "SEQUENCES",
    "SERIALIZABLE",
    "SERVER",
    "SESSION",
    "SESSION_USER",
    // reserved
    "SET",
    "SETOF",
    // (cannot be function or type)
    "SETS",
    "SHARE",
    "SHOW",
    "SIMILAR",
    // reserved (can be function or type)
    "SIMPLE",
    "SKIP",
    "SMALLINT",
    // (cannot be function or type)
    "SNAPSHOT",
    "SOME",
    // reserved
    "SQL",
    "STABLE",
    "STANDALONE",
    "START",
    "STATEMENT",
    "STATISTICS",
    "STDIN",
    "STDOUT",
    "STORAGE",
    "STORED",
    "STRICT",
    "STRIP",
    "SUBSCRIPTION",
    "SUBSTRING",
    // (cannot be function or type)
    "SUPPORT",
    "SYMMETRIC",
    // reserved
    "SYSID",
    "SYSTEM",
    "TABLE",
    // reserved
    "TABLES",
    "TABLESAMPLE",
    // reserved (can be function or type)
    "TABLESPACE",
    "TEMP",
    "TEMPLATE",
    "TEMPORARY",
    "TEXT",
    "THEN",
    // reserved
    "TIES",
    "TIME",
    // (cannot be function or type)
    "TIMESTAMP",
    // (cannot be function or type)
    "TO",
    // reserved, requires AS
    "TRAILING",
    // reserved
    "TRANSACTION",
    "TRANSFORM",
    "TREAT",
    // (cannot be function or type)
    "TRIGGER",
    "TRIM",
    // (cannot be function or type)
    "TRUE",
    // reserved
    "TRUNCATE",
    "TRUSTED",
    "TYPE",
    "TYPES",
    "UESCAPE",
    "UNBOUNDED",
    "UNCOMMITTED",
    "UNENCRYPTED",
    "UNION",
    // reserved, requires AS
    "UNIQUE",
    // reserved
    "UNKNOWN",
    "UNLISTEN",
    "UNLOGGED",
    "UNTIL",
    "UPDATE",
    "USER",
    // reserved
    "USING",
    // reserved
    "VACUUM",
    "VALID",
    "VALIDATE",
    "VALIDATOR",
    "VALUE",
    "VALUES",
    // (cannot be function or type)
    "VARCHAR",
    // (cannot be function or type)
    "VARIADIC",
    // reserved
    "VARYING",
    // requires AS
    "VERBOSE",
    // reserved (can be function or type)
    "VERSION",
    "VIEW",
    "VIEWS",
    "VOLATILE",
    "WHEN",
    // reserved
    "WHERE",
    // reserved, requires AS
    "WHITESPACE",
    "WINDOW",
    // reserved, requires AS
    "WITH",
    // reserved, requires AS
    "WITHIN",
    // requires AS
    "WITHOUT",
    // requires AS
    "WORK",
    "WRAPPER",
    "WRITE",
    "XML",
    "XMLATTRIBUTES",
    // (cannot be function or type)
    "XMLCONCAT",
    // (cannot be function or type)
    "XMLELEMENT",
    // (cannot be function or type)
    "XMLEXISTS",
    // (cannot be function or type)
    "XMLFOREST",
    // (cannot be function or type)
    "XMLNAMESPACES",
    // (cannot be function or type)
    "XMLPARSE",
    // (cannot be function or type)
    "XMLPI",
    // (cannot be function or type)
    "XMLROOT",
    // (cannot be function or type)
    "XMLSERIALIZE",
    // (cannot be function or type)
    "XMLTABLE",
    // (cannot be function or type)
    "YEAR",
    // requires AS
    "YES",
    "ZONE"
  ]
}), KG = pe(["SELECT [ALL | DISTINCT]"]), jG = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY [ALL | DISTINCT]",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  "FOR {UPDATE | NO KEY UPDATE | SHARE | KEY SHARE} [OF]",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [TEMP | TEMPORARY] [RECURSIVE] VIEW",
  "CREATE MATERIALIZED VIEW [IF NOT EXISTS]",
  "CREATE [GLOBAL | LOCAL] [TEMPORARY | TEMP | UNLOGGED] TABLE [IF NOT EXISTS]",
  // other
  "RETURNING"
]), Fm = pe([
  // - update:
  "UPDATE [ONLY]",
  "WHERE CURRENT OF",
  // - insert:
  "ON CONFLICT",
  // - delete:
  "DELETE FROM [ONLY]",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS] [ONLY]",
  "ALTER TABLE ALL IN TABLESPACE",
  "RENAME [COLUMN]",
  "RENAME TO",
  "ADD [COLUMN] [IF NOT EXISTS]",
  "DROP [COLUMN] [IF EXISTS]",
  "ALTER [COLUMN]",
  "[SET DATA] TYPE",
  // for alter column
  "{SET | DROP} DEFAULT",
  // for alter column
  "{SET | DROP} NOT NULL",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE] [ONLY]",
  // other
  "SET SCHEMA",
  "AFTER",
  // https://www.postgresql.org/docs/14/sql-commands.html
  "ABORT",
  "ALTER AGGREGATE",
  "ALTER COLLATION",
  "ALTER CONVERSION",
  "ALTER DATABASE",
  "ALTER DEFAULT PRIVILEGES",
  "ALTER DOMAIN",
  "ALTER EVENT TRIGGER",
  "ALTER EXTENSION",
  "ALTER FOREIGN DATA WRAPPER",
  "ALTER FOREIGN TABLE",
  "ALTER FUNCTION",
  "ALTER GROUP",
  "ALTER INDEX",
  "ALTER LANGUAGE",
  "ALTER LARGE OBJECT",
  "ALTER MATERIALIZED VIEW",
  "ALTER OPERATOR",
  "ALTER OPERATOR CLASS",
  "ALTER OPERATOR FAMILY",
  "ALTER POLICY",
  "ALTER PROCEDURE",
  "ALTER PUBLICATION",
  "ALTER ROLE",
  "ALTER ROUTINE",
  "ALTER RULE",
  "ALTER SCHEMA",
  "ALTER SEQUENCE",
  "ALTER SERVER",
  "ALTER STATISTICS",
  "ALTER SUBSCRIPTION",
  "ALTER SYSTEM",
  "ALTER TABLESPACE",
  "ALTER TEXT SEARCH CONFIGURATION",
  "ALTER TEXT SEARCH DICTIONARY",
  "ALTER TEXT SEARCH PARSER",
  "ALTER TEXT SEARCH TEMPLATE",
  "ALTER TRIGGER",
  "ALTER TYPE",
  "ALTER USER",
  "ALTER USER MAPPING",
  "ALTER VIEW",
  "ANALYZE",
  "BEGIN",
  "CALL",
  "CHECKPOINT",
  "CLOSE",
  "CLUSTER",
  "COMMENT",
  "COMMIT",
  "COMMIT PREPARED",
  "COPY",
  "CREATE ACCESS METHOD",
  "CREATE AGGREGATE",
  "CREATE CAST",
  "CREATE COLLATION",
  "CREATE CONVERSION",
  "CREATE DATABASE",
  "CREATE DOMAIN",
  "CREATE EVENT TRIGGER",
  "CREATE EXTENSION",
  "CREATE FOREIGN DATA WRAPPER",
  "CREATE FOREIGN TABLE",
  "CREATE FUNCTION",
  "CREATE GROUP",
  "CREATE INDEX",
  "CREATE LANGUAGE",
  "CREATE OPERATOR",
  "CREATE OPERATOR CLASS",
  "CREATE OPERATOR FAMILY",
  "CREATE POLICY",
  "CREATE PROCEDURE",
  "CREATE PUBLICATION",
  "CREATE ROLE",
  "CREATE RULE",
  "CREATE SCHEMA",
  "CREATE SEQUENCE",
  "CREATE SERVER",
  "CREATE STATISTICS",
  "CREATE SUBSCRIPTION",
  "CREATE TABLESPACE",
  "CREATE TEXT SEARCH CONFIGURATION",
  "CREATE TEXT SEARCH DICTIONARY",
  "CREATE TEXT SEARCH PARSER",
  "CREATE TEXT SEARCH TEMPLATE",
  "CREATE TRANSFORM",
  "CREATE TRIGGER",
  "CREATE TYPE",
  "CREATE USER",
  "CREATE USER MAPPING",
  "DEALLOCATE",
  "DECLARE",
  "DISCARD",
  "DROP ACCESS METHOD",
  "DROP AGGREGATE",
  "DROP CAST",
  "DROP COLLATION",
  "DROP CONVERSION",
  "DROP DATABASE",
  "DROP DOMAIN",
  "DROP EVENT TRIGGER",
  "DROP EXTENSION",
  "DROP FOREIGN DATA WRAPPER",
  "DROP FOREIGN TABLE",
  "DROP FUNCTION",
  "DROP GROUP",
  "DROP INDEX",
  "DROP LANGUAGE",
  "DROP MATERIALIZED VIEW",
  "DROP OPERATOR",
  "DROP OPERATOR CLASS",
  "DROP OPERATOR FAMILY",
  "DROP OWNED",
  "DROP POLICY",
  "DROP PROCEDURE",
  "DROP PUBLICATION",
  "DROP ROLE",
  "DROP ROUTINE",
  "DROP RULE",
  "DROP SCHEMA",
  "DROP SEQUENCE",
  "DROP SERVER",
  "DROP STATISTICS",
  "DROP SUBSCRIPTION",
  "DROP TABLESPACE",
  "DROP TEXT SEARCH CONFIGURATION",
  "DROP TEXT SEARCH DICTIONARY",
  "DROP TEXT SEARCH PARSER",
  "DROP TEXT SEARCH TEMPLATE",
  "DROP TRANSFORM",
  "DROP TRIGGER",
  "DROP TYPE",
  "DROP USER",
  "DROP USER MAPPING",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FETCH",
  "GRANT",
  "IMPORT FOREIGN SCHEMA",
  "LISTEN",
  "LOAD",
  "LOCK",
  "MOVE",
  "NOTIFY",
  "PREPARE",
  "PREPARE TRANSACTION",
  "REASSIGN OWNED",
  "REFRESH MATERIALIZED VIEW",
  "REINDEX",
  "RELEASE SAVEPOINT",
  "RESET",
  "REVOKE",
  "ROLLBACK",
  "ROLLBACK PREPARED",
  "ROLLBACK TO SAVEPOINT",
  "SAVEPOINT",
  "SECURITY LABEL",
  "SELECT INTO",
  "SET CONSTRAINTS",
  "SET ROLE",
  "SET SESSION AUTHORIZATION",
  "SET TRANSACTION",
  "SHOW",
  "START TRANSACTION",
  "UNLISTEN",
  "VACUUM"
]), zG = pe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), JG = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), QG = pe([
  "ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]",
  "{ROWS | RANGE | GROUPS} BETWEEN",
  // https://www.postgresql.org/docs/current/datatype-datetime.html
  "{TIMESTAMP | TIME} {WITH | WITHOUT} TIME ZONE",
  // comparison operator
  "IS [NOT] DISTINCT FROM"
]), ZG = {
  tokenizerOptions: {
    reservedSelect: KG,
    reservedClauses: [...jG, ...Fm],
    reservedSetOperations: zG,
    reservedJoins: JG,
    reservedPhrases: QG,
    reservedKeywords: kG,
    reservedFunctionNames: XG,
    nestedBlockComments: !0,
    extraParens: ["[]"],
    stringTypes: ["$$", {
      quote: "''-qq",
      prefixes: ["U&"]
    }, {
      quote: "''-bs",
      prefixes: ["E"],
      requirePrefix: !0
    }, {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: [{
      quote: '""-qq',
      prefixes: ["U&"]
    }],
    identChars: {
      rest: "$"
    },
    paramTypes: {
      numbered: ["$"]
    },
    operators: [
      // Arithmetic
      "%",
      "^",
      "|/",
      "||/",
      "@",
      // Assignment
      ":=",
      // Bitwise
      "&",
      "|",
      "#",
      "~",
      "<<",
      ">>",
      // Byte comparison
      "~>~",
      "~<~",
      "~>=~",
      "~<=~",
      // Geometric
      "@-@",
      "@@",
      "##",
      "<->",
      "&&",
      "&<",
      "&>",
      "<<|",
      "&<|",
      "|>>",
      "|&>",
      "<^",
      "^>",
      "?#",
      "?-",
      "?|",
      "?-|",
      "?||",
      "@>",
      "<@",
      "~=",
      // JSON
      "?",
      "@?",
      "?&",
      "->",
      "->>",
      "#>",
      "#>>",
      "#-",
      // Named function params
      "=>",
      // Network address
      ">>=",
      "<<=",
      // Pattern matching
      "~~",
      "~~*",
      "!~~",
      "!~~*",
      // POSIX RegExp
      "~",
      "~*",
      "!~",
      "!~*",
      // Range/multirange
      "-|-",
      // String concatenation
      "||",
      // Text search
      "@@@",
      "!!",
      // Trigram/trigraph
      "<%",
      "%>",
      "<<%",
      "%>>",
      "<<->",
      "<->>",
      "<<<->",
      "<->>>",
      // Type cast
      "::"
    ]
  },
  formatOptions: {
    alwaysDenseOperators: ["::"],
    onelineClauses: Fm
  }
}, qG = en({
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Aggregate_Functions.html
  aggregate: ["ANY_VALUE", "APPROXIMATE PERCENTILE_DISC", "AVG", "COUNT", "LISTAGG", "MAX", "MEDIAN", "MIN", "PERCENTILE_CONT", "STDDEV_SAMP", "STDDEV_POP", "SUM", "VAR_SAMP", "VAR_POP"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Array_Functions.html
  array: ["array", "array_concat", "array_flatten", "get_array_length", "split_to_array", "subarray"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_bitwise_aggregate_functions.html
  bitwise: ["BIT_AND", "BIT_OR", "BOOL_AND", "BOOL_OR"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_conditional_expressions.html
  conditional: ["COALESCE", "DECODE", "GREATEST", "LEAST", "NVL", "NVL2", "NULLIF"],
  // https://docs.aws.amazon.com/redshift/latest/dg/Date_functions_header.html
  dateTime: ["ADD_MONTHS", "AT TIME ZONE", "CONVERT_TIMEZONE", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DATE_CMP", "DATE_CMP_TIMESTAMP", "DATE_CMP_TIMESTAMPTZ", "DATE_PART_YEAR", "DATEADD", "DATEDIFF", "DATE_PART", "DATE_TRUNC", "EXTRACT", "GETDATE", "INTERVAL_CMP", "LAST_DAY", "MONTHS_BETWEEN", "NEXT_DAY", "SYSDATE", "TIMEOFDAY", "TIMESTAMP_CMP", "TIMESTAMP_CMP_DATE", "TIMESTAMP_CMP_TIMESTAMPTZ", "TIMESTAMPTZ_CMP", "TIMESTAMPTZ_CMP_DATE", "TIMESTAMPTZ_CMP_TIMESTAMP", "TIMEZONE", "TO_TIMESTAMP", "TRUNC"],
  // https://docs.aws.amazon.com/redshift/latest/dg/geospatial-functions.html
  spatial: ["AddBBox", "DropBBox", "GeometryType", "ST_AddPoint", "ST_Angle", "ST_Area", "ST_AsBinary", "ST_AsEWKB", "ST_AsEWKT", "ST_AsGeoJSON", "ST_AsText", "ST_Azimuth", "ST_Boundary", "ST_Collect", "ST_Contains", "ST_ContainsProperly", "ST_ConvexHull", "ST_CoveredBy", "ST_Covers", "ST_Crosses", "ST_Dimension", "ST_Disjoint", "ST_Distance", "ST_DistanceSphere", "ST_DWithin", "ST_EndPoint", "ST_Envelope", "ST_Equals", "ST_ExteriorRing", "ST_Force2D", "ST_Force3D", "ST_Force3DM", "ST_Force3DZ", "ST_Force4D", "ST_GeometryN", "ST_GeometryType", "ST_GeomFromEWKB", "ST_GeomFromEWKT", "ST_GeomFromText", "ST_GeomFromWKB", "ST_InteriorRingN", "ST_Intersects", "ST_IsPolygonCCW", "ST_IsPolygonCW", "ST_IsClosed", "ST_IsCollection", "ST_IsEmpty", "ST_IsSimple", "ST_IsValid", "ST_Length", "ST_LengthSphere", "ST_Length2D", "ST_LineFromMultiPoint", "ST_LineInterpolatePoint", "ST_M", "ST_MakeEnvelope", "ST_MakeLine", "ST_MakePoint", "ST_MakePolygon", "ST_MemSize", "ST_MMax", "ST_MMin", "ST_Multi", "ST_NDims", "ST_NPoints", "ST_NRings", "ST_NumGeometries", "ST_NumInteriorRings", "ST_NumPoints", "ST_Perimeter", "ST_Perimeter2D", "ST_Point", "ST_PointN", "ST_Points", "ST_Polygon", "ST_RemovePoint", "ST_Reverse", "ST_SetPoint", "ST_SetSRID", "ST_Simplify", "ST_SRID", "ST_StartPoint", "ST_Touches", "ST_Within", "ST_X", "ST_XMax", "ST_XMin", "ST_Y", "ST_YMax", "ST_YMin", "ST_Z", "ST_ZMax", "ST_ZMin", "SupportsBBox"],
  // https://docs.aws.amazon.com/redshift/latest/dg/hash-functions.html
  hash: ["CHECKSUM", "FUNC_SHA1", "FNV_HASH", "MD5", "SHA", "SHA1", "SHA2"],
  // https://docs.aws.amazon.com/redshift/latest/dg/hyperloglog-functions.html
  hyperLogLog: ["HLL", "HLL_CREATE_SKETCH", "HLL_CARDINALITY", "HLL_COMBINE"],
  // https://docs.aws.amazon.com/redshift/latest/dg/json-functions.html
  json: ["IS_VALID_JSON", "IS_VALID_JSON_ARRAY", "JSON_ARRAY_LENGTH", "JSON_EXTRACT_ARRAY_ELEMENT_TEXT", "JSON_EXTRACT_PATH_TEXT", "JSON_PARSE", "JSON_SERIALIZE"],
  // https://docs.aws.amazon.com/redshift/latest/dg/Math_functions.html
  math: ["ABS", "ACOS", "ASIN", "ATAN", "ATAN2", "CBRT", "CEILING", "CEIL", "COS", "COT", "DEGREES", "DEXP", "DLOG1", "DLOG10", "EXP", "FLOOR", "LN", "LOG", "MOD", "PI", "POWER", "RADIANS", "RANDOM", "ROUND", "SIN", "SIGN", "SQRT", "TAN", "TO_HEX", "TRUNC"],
  // https://docs.aws.amazon.com/redshift/latest/dg/ml-function.html
  machineLearning: ["EXPLAIN_MODEL"],
  // https://docs.aws.amazon.com/redshift/latest/dg/String_functions_header.html
  string: ["ASCII", "BPCHARCMP", "BTRIM", "BTTEXT_PATTERN_CMP", "CHAR_LENGTH", "CHARACTER_LENGTH", "CHARINDEX", "CHR", "COLLATE", "CONCAT", "CRC32", "DIFFERENCE", "INITCAP", "LEFT", "RIGHT", "LEN", "LENGTH", "LOWER", "LPAD", "RPAD", "LTRIM", "OCTETINDEX", "OCTET_LENGTH", "POSITION", "QUOTE_IDENT", "QUOTE_LITERAL", "REGEXP_COUNT", "REGEXP_INSTR", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPEAT", "REPLACE", "REPLICATE", "REVERSE", "RTRIM", "SOUNDEX", "SPLIT_PART", "STRPOS", "STRTOL", "SUBSTRING", "TEXTLEN", "TRANSLATE", "TRIM", "UPPER"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Type_Info_Functions.html
  superType: ["decimal_precision", "decimal_scale", "is_array", "is_bigint", "is_boolean", "is_char", "is_decimal", "is_float", "is_integer", "is_object", "is_scalar", "is_smallint", "is_varchar", "json_typeof"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Window_functions.html
  window: ["AVG", "COUNT", "CUME_DIST", "DENSE_RANK", "FIRST_VALUE", "LAST_VALUE", "LAG", "LEAD", "LISTAGG", "MAX", "MEDIAN", "MIN", "NTH_VALUE", "NTILE", "PERCENT_RANK", "PERCENTILE_CONT", "PERCENTILE_DISC", "RANK", "RATIO_TO_REPORT", "ROW_NUMBER", "STDDEV_SAMP", "STDDEV_POP", "SUM", "VAR_SAMP", "VAR_POP"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_Data_type_formatting.html
  dataType: ["CAST", "CONVERT", "TO_CHAR", "TO_DATE", "TO_NUMBER", "TEXT_TO_INT_ALT", "TEXT_TO_NUMERIC_ALT"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_System_administration_functions.html
  sysAdmin: ["CHANGE_QUERY_PRIORITY", "CHANGE_SESSION_PRIORITY", "CHANGE_USER_PRIORITY", "CURRENT_SETTING", "PG_CANCEL_BACKEND", "PG_TERMINATE_BACKEND", "REBOOT_CLUSTER", "SET_CONFIG"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_System_information_functions.html
  sysInfo: ["CURRENT_AWS_ACCOUNT", "CURRENT_DATABASE", "CURRENT_NAMESPACE", "CURRENT_SCHEMA", "CURRENT_SCHEMAS", "CURRENT_USER", "CURRENT_USER_ID", "HAS_ASSUMEROLE_PRIVILEGE", "HAS_DATABASE_PRIVILEGE", "HAS_SCHEMA_PRIVILEGE", "HAS_TABLE_PRIVILEGE", "PG_BACKEND_PID", "PG_GET_COLS", "PG_GET_GRANTEE_BY_IAM_ROLE", "PG_GET_IAM_ROLE_BY_USER", "PG_GET_LATE_BINDING_VIEW_COLS", "PG_LAST_COPY_COUNT", "PG_LAST_COPY_ID", "PG_LAST_UNLOAD_ID", "PG_LAST_QUERY_ID", "PG_LAST_UNLOAD_COUNT", "SESSION_USER", "SLICE_NUM", "USER", "VERSION"],
  dataTypes: ["DECIMAL", "NUMERIC", "CHAR", "CHARACTER", "VARCHAR", "CHARACTER VARYING", "NCHAR", "NVARCHAR", "VARBYTE"]
}), $G = en({
  // https://docs.aws.amazon.com/redshift/latest/dg/r_pg_keywords.html
  standard: ["AES128", "AES256", "ALL", "ALLOWOVERWRITE", "ANY", "ARRAY", "AS", "ASC", "AUTHORIZATION", "BACKUP", "BETWEEN", "BINARY", "BOTH", "CHECK", "COLUMN", "CONSTRAINT", "CREATE", "CROSS", "DEFAULT", "DEFERRABLE", "DEFLATE", "DEFRAG", "DESC", "DISABLE", "DISTINCT", "DO", "ENABLE", "ENCODE", "ENCRYPT", "ENCRYPTION", "EXPLICIT", "FALSE", "FOR", "FOREIGN", "FREEZE", "FROM", "FULL", "GLOBALDICT256", "GLOBALDICT64K", "GROUP", "IDENTITY", "IGNORE", "ILIKE", "IN", "INITIALLY", "INNER", "INTO", "IS", "ISNULL", "LANGUAGE", "LEADING", "LIKE", "LIMIT", "LOCALTIME", "LOCALTIMESTAMP", "LUN", "LUNS", "MINUS", "NATURAL", "NEW", "NOT", "NOTNULL", "NULL", "NULLS", "OFF", "OFFLINE", "OFFSET", "OID", "OLD", "ON", "ONLY", "OPEN", "ORDER", "OUTER", "OVERLAPS", "PARALLEL", "PARTITION", "PERCENT", "PERMISSIONS", "PLACING", "PRIMARY", "RECOVER", "REFERENCES", "REJECTLOG", "RESORT", "RESPECT", "RESTORE", "SIMILAR", "SNAPSHOT", "SOME", "SYSTEM", "TABLE", "TAG", "TDES", "THEN", "TIMESTAMP", "TO", "TOP", "TRAILING", "TRUE", "UNIQUE", "USING", "VERBOSE", "WALLET", "WITHOUT"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-conversion.html
  dataConversionParams: ["ACCEPTANYDATE", "ACCEPTINVCHARS", "BLANKSASNULL", "DATEFORMAT", "EMPTYASNULL", "ENCODING", "ESCAPE", "EXPLICIT_IDS", "FILLRECORD", "IGNOREBLANKLINES", "IGNOREHEADER", "REMOVEQUOTES", "ROUNDEC", "TIMEFORMAT", "TRIMBLANKS", "TRUNCATECOLUMNS"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-load.html
  dataLoadParams: ["COMPROWS", "COMPUPDATE", "MAXERROR", "NOLOAD", "STATUPDATE"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-format.html
  dataFormatParams: ["FORMAT", "CSV", "DELIMITER", "FIXEDWIDTH", "SHAPEFILE", "AVRO", "JSON", "PARQUET", "ORC"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-authorization.html
  copyAuthParams: ["ACCESS_KEY_ID", "CREDENTIALS", "ENCRYPTED", "IAM_ROLE", "MASTER_SYMMETRIC_KEY", "SECRET_ACCESS_KEY", "SESSION_TOKEN"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-file-compression.html
  copyCompressionParams: ["BZIP2", "GZIP", "LZOP", "ZSTD"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_COPY-alphabetical-parm-list.html
  copyMiscParams: ["MANIFEST", "READRATIO", "REGION", "SSH"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Compression_encodings.html
  compressionEncodings: ["RAW", "AZ64", "BYTEDICT", "DELTA", "DELTA32K", "LZO", "MOSTLY8", "MOSTLY16", "MOSTLY32", "RUNLENGTH", "TEXT255", "TEXT32K"],
  misc: [
    // CREATE EXTERNAL SCHEMA (https://docs.aws.amazon.com/redshift/latest/dg/r_CREATE_EXTERNAL_SCHEMA.html)
    "CATALOG_ROLE",
    "SECRET_ARN",
    "EXTERNAL",
    // https://docs.aws.amazon.com/redshift/latest/dg/c_choosing_dist_sort.html
    "AUTO",
    "EVEN",
    "KEY",
    "PREDICATE",
    // ANALYZE | ANALYSE (https://docs.aws.amazon.com/redshift/latest/dg/r_ANALYZE.html)
    // unknown
    "COMPRESSION"
  ],
  /**
   * Other keywords not included:
   * STL: https://docs.aws.amazon.com/redshift/latest/dg/c_intro_STL_tables.html
   * SVCS: https://docs.aws.amazon.com/redshift/latest/dg/svcs_views.html
   * SVL: https://docs.aws.amazon.com/redshift/latest/dg/svl_views.html
   * SVV: https://docs.aws.amazon.com/redshift/latest/dg/svv_views.html
   */
  // https://docs.aws.amazon.com/redshift/latest/dg/r_Character_types.html#r_Character_types-text-and-bpchar-types
  dataTypes: ["BPCHAR", "TEXT"]
}), ex = pe(["SELECT [ALL | DISTINCT]"]), tx = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE | MATERIALIZED] VIEW",
  "CREATE [TEMPORARY | TEMP | LOCAL TEMPORARY | LOCAL TEMP] TABLE [IF NOT EXISTS]"
]), wm = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ALTER TABLE APPEND",
  "ADD [COLUMN]",
  "DROP [COLUMN]",
  "RENAME TO",
  "RENAME COLUMN",
  "ALTER COLUMN",
  "TYPE",
  // for alter column
  "ENCODE",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://docs.aws.amazon.com/redshift/latest/dg/c_SQL_commands.html
  "ABORT",
  "ALTER DATABASE",
  "ALTER DATASHARE",
  "ALTER DEFAULT PRIVILEGES",
  "ALTER GROUP",
  "ALTER MATERIALIZED VIEW",
  "ALTER PROCEDURE",
  "ALTER SCHEMA",
  "ALTER USER",
  "ANALYSE",
  "ANALYZE",
  "ANALYSE COMPRESSION",
  "ANALYZE COMPRESSION",
  "BEGIN",
  "CALL",
  "CANCEL",
  "CLOSE",
  "COMMENT",
  "COMMIT",
  "COPY",
  "CREATE DATABASE",
  "CREATE DATASHARE",
  "CREATE EXTERNAL FUNCTION",
  "CREATE EXTERNAL SCHEMA",
  "CREATE EXTERNAL TABLE",
  "CREATE FUNCTION",
  "CREATE GROUP",
  "CREATE LIBRARY",
  "CREATE MODEL",
  "CREATE PROCEDURE",
  "CREATE SCHEMA",
  "CREATE USER",
  "DEALLOCATE",
  "DECLARE",
  "DESC DATASHARE",
  "DROP DATABASE",
  "DROP DATASHARE",
  "DROP FUNCTION",
  "DROP GROUP",
  "DROP LIBRARY",
  "DROP MODEL",
  "DROP MATERIALIZED VIEW",
  "DROP PROCEDURE",
  "DROP SCHEMA",
  "DROP USER",
  "DROP VIEW",
  "DROP",
  "EXECUTE",
  "EXPLAIN",
  "FETCH",
  "GRANT",
  "LOCK",
  "PREPARE",
  "REFRESH MATERIALIZED VIEW",
  "RESET",
  "REVOKE",
  "ROLLBACK",
  "SELECT INTO",
  "SET SESSION AUTHORIZATION",
  "SET SESSION CHARACTERISTICS",
  "SHOW",
  "SHOW EXTERNAL TABLE",
  "SHOW MODEL",
  "SHOW DATASHARES",
  "SHOW PROCEDURE",
  "SHOW TABLE",
  "SHOW VIEW",
  "START TRANSACTION",
  "UNLOAD",
  "VACUUM"
]), nx = pe(["UNION [ALL]", "EXCEPT", "INTERSECT", "MINUS"]), rx = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), ax = pe([
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-conversion.html
  "NULL AS",
  // https://docs.aws.amazon.com/redshift/latest/dg/r_CREATE_EXTERNAL_SCHEMA.html
  "DATA CATALOG",
  "HIVE METASTORE",
  // in window specifications
  "{ROWS | RANGE} BETWEEN"
]), ix = {
  tokenizerOptions: {
    reservedSelect: ex,
    reservedClauses: [...tx, ...wm],
    reservedSetOperations: nx,
    reservedJoins: rx,
    reservedPhrases: ax,
    reservedKeywords: $G,
    reservedFunctionNames: qG,
    stringTypes: ["''-qq"],
    identTypes: ['""-qq'],
    identChars: {
      first: "#"
    },
    paramTypes: {
      numbered: ["$"]
    },
    operators: [
      "^",
      "%",
      "@",
      "|/",
      "||/",
      "&",
      "|",
      // '#', conflicts with first char of identifier
      "~",
      "<<",
      ">>",
      "||",
      "::"
    ]
  },
  formatOptions: {
    alwaysDenseOperators: ["::"],
    onelineClauses: wm
  }
}, ox = en({
  // https://deepkb.com/CO_000013/en/kb/IMPORT-fbfa59f0-2bf1-31fe-bb7b-0f9efe9932c6/spark-sql-keywords
  all: [
    "ADD",
    "AFTER",
    "ALL",
    "ALTER",
    "ANALYZE",
    "AND",
    "ANTI",
    "ANY",
    "ARCHIVE",
    "ARRAY",
    "AS",
    "ASC",
    "AT",
    "AUTHORIZATION",
    "BETWEEN",
    "BOTH",
    "BUCKET",
    "BUCKETS",
    "BY",
    "CACHE",
    "CASCADE",
    "CAST",
    "CHANGE",
    "CHECK",
    "CLEAR",
    "CLUSTER",
    "CLUSTERED",
    "CODEGEN",
    "COLLATE",
    "COLLECTION",
    "COLUMN",
    "COLUMNS",
    "COMMENT",
    "COMMIT",
    "COMPACT",
    "COMPACTIONS",
    "COMPUTE",
    "CONCATENATE",
    "CONSTRAINT",
    "COST",
    "CREATE",
    "CROSS",
    "CUBE",
    "CURRENT",
    "CURRENT_DATE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "DATA",
    "DATABASE",
    "DATABASES",
    "DAY",
    "DBPROPERTIES",
    "DEFINED",
    "DELETE",
    "DELIMITED",
    "DESC",
    "DESCRIBE",
    "DFS",
    "DIRECTORIES",
    "DIRECTORY",
    "DISTINCT",
    "DISTRIBUTE",
    "DIV",
    "DROP",
    "ESCAPE",
    "ESCAPED",
    "EXCEPT",
    "EXCHANGE",
    "EXISTS",
    "EXPORT",
    "EXTENDED",
    "EXTERNAL",
    "EXTRACT",
    "FALSE",
    "FETCH",
    "FIELDS",
    "FILTER",
    "FILEFORMAT",
    "FIRST",
    "FIRST_VALUE",
    "FOLLOWING",
    "FOR",
    "FOREIGN",
    "FORMAT",
    "FORMATTED",
    "FULL",
    "FUNCTION",
    "FUNCTIONS",
    "GLOBAL",
    "GRANT",
    "GROUP",
    "GROUPING",
    "HOUR",
    "IF",
    "IGNORE",
    "IMPORT",
    "IN",
    "INDEX",
    "INDEXES",
    "INNER",
    "INPATH",
    "INPUTFORMAT",
    "INTERSECT",
    "INTERVAL",
    "INTO",
    "IS",
    "ITEMS",
    "KEYS",
    "LAST",
    "LAST_VALUE",
    "LATERAL",
    "LAZY",
    "LEADING",
    "LEFT",
    "LIKE",
    "LINES",
    "LIST",
    "LOCAL",
    "LOCATION",
    "LOCK",
    "LOCKS",
    "LOGICAL",
    "MACRO",
    "MAP",
    "MATCHED",
    "MERGE",
    "MINUTE",
    "MONTH",
    "MSCK",
    "NAMESPACE",
    "NAMESPACES",
    "NATURAL",
    "NO",
    "NOT",
    "NULL",
    "NULLS",
    "OF",
    "ONLY",
    "OPTION",
    "OPTIONS",
    "OR",
    "ORDER",
    "OUT",
    "OUTER",
    "OUTPUTFORMAT",
    "OVER",
    "OVERLAPS",
    "OVERLAY",
    "OVERWRITE",
    "OWNER",
    "PARTITION",
    "PARTITIONED",
    "PARTITIONS",
    "PERCENT",
    "PLACING",
    "POSITION",
    "PRECEDING",
    "PRIMARY",
    "PRINCIPALS",
    "PROPERTIES",
    "PURGE",
    "QUERY",
    "RANGE",
    "RECORDREADER",
    "RECORDWRITER",
    "RECOVER",
    "REDUCE",
    "REFERENCES",
    "RENAME",
    "REPAIR",
    "REPLACE",
    "RESPECT",
    "RESTRICT",
    "REVOKE",
    "RIGHT",
    "RLIKE",
    "ROLE",
    "ROLES",
    "ROLLBACK",
    "ROLLUP",
    "ROW",
    "ROWS",
    "SCHEMA",
    "SECOND",
    "SELECT",
    "SEMI",
    "SEPARATED",
    "SERDE",
    "SERDEPROPERTIES",
    "SESSION_USER",
    "SETS",
    "SHOW",
    "SKEWED",
    "SOME",
    "SORT",
    "SORTED",
    "START",
    "STATISTICS",
    "STORED",
    "STRATIFY",
    "STRUCT",
    "SUBSTR",
    "SUBSTRING",
    "TABLE",
    "TABLES",
    "TBLPROPERTIES",
    "TEMPORARY",
    "TERMINATED",
    "THEN",
    "TO",
    "TOUCH",
    "TRAILING",
    "TRANSACTION",
    "TRANSACTIONS",
    "TRIM",
    "TRUE",
    "TRUNCATE",
    "UNARCHIVE",
    "UNBOUNDED",
    "UNCACHE",
    "UNIQUE",
    "UNKNOWN",
    "UNLOCK",
    "UNSET",
    "USE",
    "USER",
    "USING",
    "VIEW",
    "WINDOW",
    "YEAR",
    // other
    "ANALYSE",
    "ARRAY_ZIP",
    "COALESCE",
    "CONTAINS",
    "CONVERT",
    "DAYS",
    "DAY_HOUR",
    "DAY_MINUTE",
    "DAY_SECOND",
    "DECODE",
    "DEFAULT",
    "DISTINCTROW",
    "ENCODE",
    "EXPLODE",
    "EXPLODE_OUTER",
    "FIXED",
    "GREATEST",
    "GROUP_CONCAT",
    "HOURS",
    "HOUR_MINUTE",
    "HOUR_SECOND",
    "IFNULL",
    "LEAST",
    "LEVEL",
    "MINUTE_SECOND",
    "NULLIF",
    "OFFSET",
    "ON",
    "OPTIMIZE",
    "REGEXP",
    "SEPARATOR",
    "SIZE",
    "STRING",
    "TYPE",
    "TYPES",
    "UNSIGNED",
    "VARIABLES",
    "YEAR_MONTH"
  ]
}), lx = en({
  // http://spark.apache.org/docs/latest/sql-ref-functions.html
  //
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#aggregate-functions
  aggregate: [
    // 'ANY',
    "APPROX_COUNT_DISTINCT",
    "APPROX_PERCENTILE",
    "AVG",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "BOOL_AND",
    "BOOL_OR",
    "COLLECT_LIST",
    "COLLECT_SET",
    "CORR",
    "COUNT",
    "COUNT",
    "COUNT",
    "COUNT_IF",
    "COUNT_MIN_SKETCH",
    "COVAR_POP",
    "COVAR_SAMP",
    "EVERY",
    "FIRST",
    "FIRST_VALUE",
    "GROUPING",
    "GROUPING_ID",
    "KURTOSIS",
    "LAST",
    "LAST_VALUE",
    "MAX",
    "MAX_BY",
    "MEAN",
    "MIN",
    "MIN_BY",
    "PERCENTILE",
    "PERCENTILE",
    "PERCENTILE_APPROX",
    "SKEWNESS",
    // 'SOME',
    "STD",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "SUM",
    "VAR_POP",
    "VAR_SAMP",
    "VARIANCE"
  ],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#window-functions
  window: ["CUME_DIST", "DENSE_RANK", "LAG", "LEAD", "NTH_VALUE", "NTILE", "PERCENT_RANK", "RANK", "ROW_NUMBER"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#array-functions
  array: ["ARRAY", "ARRAY_CONTAINS", "ARRAY_DISTINCT", "ARRAY_EXCEPT", "ARRAY_INTERSECT", "ARRAY_JOIN", "ARRAY_MAX", "ARRAY_MIN", "ARRAY_POSITION", "ARRAY_REMOVE", "ARRAY_REPEAT", "ARRAY_UNION", "ARRAYS_OVERLAP", "ARRAYS_ZIP", "FLATTEN", "SEQUENCE", "SHUFFLE", "SLICE", "SORT_ARRAY"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#map-functions
  map: ["ELEMENT_AT", "ELEMENT_AT", "MAP", "MAP_CONCAT", "MAP_ENTRIES", "MAP_FROM_ARRAYS", "MAP_FROM_ENTRIES", "MAP_KEYS", "MAP_VALUES", "STR_TO_MAP"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#date-and-timestamp-functions
  datetime: ["ADD_MONTHS", "CURRENT_DATE", "CURRENT_DATE", "CURRENT_TIMESTAMP", "CURRENT_TIMESTAMP", "CURRENT_TIMEZONE", "DATE_ADD", "DATE_FORMAT", "DATE_FROM_UNIX_DATE", "DATE_PART", "DATE_SUB", "DATE_TRUNC", "DATEDIFF", "DAY", "DAYOFMONTH", "DAYOFWEEK", "DAYOFYEAR", "EXTRACT", "FROM_UNIXTIME", "FROM_UTC_TIMESTAMP", "HOUR", "LAST_DAY", "MAKE_DATE", "MAKE_DT_INTERVAL", "MAKE_INTERVAL", "MAKE_TIMESTAMP", "MAKE_YM_INTERVAL", "MINUTE", "MONTH", "MONTHS_BETWEEN", "NEXT_DAY", "NOW", "QUARTER", "SECOND", "SESSION_WINDOW", "TIMESTAMP_MICROS", "TIMESTAMP_MILLIS", "TIMESTAMP_SECONDS", "TO_DATE", "TO_TIMESTAMP", "TO_UNIX_TIMESTAMP", "TO_UTC_TIMESTAMP", "TRUNC", "UNIX_DATE", "UNIX_MICROS", "UNIX_MILLIS", "UNIX_SECONDS", "UNIX_TIMESTAMP", "WEEKDAY", "WEEKOFYEAR", "WINDOW", "YEAR"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#json-functions
  json: ["FROM_JSON", "GET_JSON_OBJECT", "JSON_ARRAY_LENGTH", "JSON_OBJECT_KEYS", "JSON_TUPLE", "SCHEMA_OF_JSON", "TO_JSON"],
  // http://spark.apache.org/docs/latest/api/sql/index.html
  misc: [
    "ABS",
    "ACOS",
    "ACOSH",
    "AGGREGATE",
    "ARRAY_SORT",
    "ASCII",
    "ASIN",
    "ASINH",
    "ASSERT_TRUE",
    "ATAN",
    "ATAN2",
    "ATANH",
    "BASE64",
    "BIGINT",
    "BIN",
    "BINARY",
    "BIT_COUNT",
    "BIT_GET",
    "BIT_LENGTH",
    "BOOLEAN",
    "BROUND",
    "BTRIM",
    "CARDINALITY",
    "CBRT",
    "CEIL",
    "CEILING",
    "CHAR",
    "CHAR_LENGTH",
    "CHARACTER_LENGTH",
    "CHR",
    "CONCAT",
    "CONCAT_WS",
    "CONV",
    "COS",
    "COSH",
    "COT",
    "CRC32",
    "CURRENT_CATALOG",
    "CURRENT_DATABASE",
    "CURRENT_USER",
    "DATE",
    "DECIMAL",
    "DEGREES",
    "DOUBLE",
    // 'E',
    "ELT",
    "EXP",
    "EXPM1",
    "FACTORIAL",
    "FIND_IN_SET",
    "FLOAT",
    "FLOOR",
    "FORALL",
    "FORMAT_NUMBER",
    "FORMAT_STRING",
    "FROM_CSV",
    "GETBIT",
    "HASH",
    "HEX",
    "HYPOT",
    "INITCAP",
    "INLINE",
    "INLINE_OUTER",
    "INPUT_FILE_BLOCK_LENGTH",
    "INPUT_FILE_BLOCK_START",
    "INPUT_FILE_NAME",
    "INSTR",
    "INT",
    "ISNAN",
    "ISNOTNULL",
    "ISNULL",
    "JAVA_METHOD",
    "LCASE",
    "LEFT",
    "LENGTH",
    "LEVENSHTEIN",
    "LN",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG1P",
    "LOG2",
    "LOWER",
    "LPAD",
    "LTRIM",
    "MAP_FILTER",
    "MAP_ZIP_WITH",
    "MD5",
    "MOD",
    "MONOTONICALLY_INCREASING_ID",
    "NAMED_STRUCT",
    "NANVL",
    "NEGATIVE",
    "NVL",
    "NVL2",
    "OCTET_LENGTH",
    "OVERLAY",
    "PARSE_URL",
    "PI",
    "PMOD",
    "POSEXPLODE",
    "POSEXPLODE_OUTER",
    "POSITION",
    "POSITIVE",
    "POW",
    "POWER",
    "PRINTF",
    "RADIANS",
    "RAISE_ERROR",
    "RAND",
    "RANDN",
    "RANDOM",
    "REFLECT",
    "REGEXP_EXTRACT",
    "REGEXP_EXTRACT_ALL",
    "REGEXP_LIKE",
    "REGEXP_REPLACE",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "RIGHT",
    "RINT",
    "ROUND",
    "RPAD",
    "RTRIM",
    "SCHEMA_OF_CSV",
    "SENTENCES",
    "SHA",
    "SHA1",
    "SHA2",
    "SHIFTLEFT",
    "SHIFTRIGHT",
    "SHIFTRIGHTUNSIGNED",
    "SIGN",
    "SIGNUM",
    "SIN",
    "SINH",
    "SMALLINT",
    "SOUNDEX",
    "SPACE",
    "SPARK_PARTITION_ID",
    "SPLIT",
    "SQRT",
    "STACK",
    "SUBSTR",
    "SUBSTRING",
    "SUBSTRING_INDEX",
    "TAN",
    "TANH",
    "TIMESTAMP",
    "TINYINT",
    "TO_CSV",
    "TRANSFORM_KEYS",
    "TRANSFORM_VALUES",
    "TRANSLATE",
    "TRIM",
    "TRY_ADD",
    "TRY_DIVIDE",
    "TYPEOF",
    "UCASE",
    "UNBASE64",
    "UNHEX",
    "UPPER",
    "UUID",
    "VERSION",
    "WIDTH_BUCKET",
    "XPATH",
    "XPATH_BOOLEAN",
    "XPATH_DOUBLE",
    "XPATH_FLOAT",
    "XPATH_INT",
    "XPATH_LONG",
    "XPATH_NUMBER",
    "XPATH_SHORT",
    "XPATH_STRING",
    "XXHASH64",
    "ZIP_WITH"
  ],
  cast: ["CAST"],
  // Shorthand functions to use in place of CASE expression
  caseAbbrev: ["COALESCE", "NULLIF"],
  // Parameterized data types
  // https://spark.apache.org/docs/latest/sql-ref-datatypes.html
  dataTypes: [
    "DECIMAL",
    "DEC",
    "NUMERIC",
    // No varchar type in Spark, only STRING. Added for the sake of tests
    "VARCHAR"
  ]
}), sx = pe(["SELECT [ALL | DISTINCT]"]), ux = pe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "SORT BY",
  "CLUSTER BY",
  "DISTRIBUTE BY",
  "LIMIT",
  // Data manipulation
  // - insert:
  "INSERT [INTO | OVERWRITE] [TABLE]",
  "VALUES",
  // - insert overwrite directory:
  //   https://spark.apache.org/docs/latest/sql-ref-syntax-dml-insert-overwrite-directory.html
  "INSERT OVERWRITE [LOCAL] DIRECTORY",
  // - load:
  //   https://spark.apache.org/docs/latest/sql-ref-syntax-dml-load.html
  "LOAD DATA [LOCAL] INPATH",
  "[OVERWRITE] INTO TABLE",
  // Data definition
  "CREATE [OR REPLACE] [GLOBAL TEMPORARY | TEMPORARY] VIEW [IF NOT EXISTS]",
  "CREATE [EXTERNAL] TABLE [IF NOT EXISTS]"
]), Ym = pe([
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD COLUMNS",
  "DROP {COLUMN | COLUMNS}",
  "RENAME TO",
  "RENAME COLUMN",
  "ALTER COLUMN",
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "LATERAL VIEW",
  "ALTER DATABASE",
  "ALTER VIEW",
  "CREATE DATABASE",
  "CREATE FUNCTION",
  "DROP DATABASE",
  "DROP FUNCTION",
  "DROP VIEW",
  "REPAIR TABLE",
  "USE DATABASE",
  // Data Retrieval
  "TABLESAMPLE",
  "PIVOT",
  "TRANSFORM",
  "EXPLAIN",
  // Auxiliary
  "ADD FILE",
  "ADD JAR",
  "ANALYZE TABLE",
  "CACHE TABLE",
  "CLEAR CACHE",
  "DESCRIBE DATABASE",
  "DESCRIBE FUNCTION",
  "DESCRIBE QUERY",
  "DESCRIBE TABLE",
  "LIST FILE",
  "LIST JAR",
  "REFRESH",
  "REFRESH TABLE",
  "REFRESH FUNCTION",
  "RESET",
  "SHOW COLUMNS",
  "SHOW CREATE TABLE",
  "SHOW DATABASES",
  "SHOW FUNCTIONS",
  "SHOW PARTITIONS",
  "SHOW TABLE EXTENDED",
  "SHOW TABLES",
  "SHOW TBLPROPERTIES",
  "SHOW VIEWS",
  "UNCACHE TABLE"
]), Ex = pe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), cx = pe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL [INNER] JOIN",
  "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN",
  // non-standard-joins
  "[LEFT] {ANTI | SEMI} JOIN",
  "NATURAL [LEFT] {ANTI | SEMI} JOIN"
]), Tx = pe(["ON DELETE", "ON UPDATE", "CURRENT ROW", "{ROWS | RANGE} BETWEEN"]), fx = {
  tokenizerOptions: {
    reservedSelect: sx,
    reservedClauses: [...ux, ...Ym],
    reservedSetOperations: Ex,
    reservedJoins: cx,
    reservedPhrases: Tx,
    supportsXor: !0,
    reservedKeywords: ox,
    reservedFunctionNames: lx,
    extraParens: ["[]"],
    stringTypes: ["''-bs", '""-bs', {
      quote: "''-raw",
      prefixes: ["R", "X"],
      requirePrefix: !0
    }, {
      quote: '""-raw',
      prefixes: ["R", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    variableTypes: [{
      quote: "{}",
      prefixes: ["$"],
      requirePrefix: !0
    }],
    operators: ["%", "~", "^", "|", "&", "<=>", "==", "!", "||", "->"],
    postProcess: Ax
  },
  formatOptions: {
    onelineClauses: Ym
  }
};
function Ax(l) {
  return l.map((u, T) => {
    const N = l[T - 1] || PE, O = l[T + 1] || PE;
    return su.WINDOW(u) && O.type === Re.OPEN_PAREN ? {
      ...u,
      type: Re.RESERVED_FUNCTION_NAME
    } : u.text === "ITEMS" && u.type === Re.RESERVED_KEYWORD && !(N.text === "COLLECTION" && O.text === "TERMINATED") ? {
      ...u,
      type: Re.IDENTIFIER,
      text: u.raw
    } : u;
  });
}
const Rx = en({
  // https://www.sqlite.org/lang_corefunc.html
  scalar: ["ABS", "CHANGES", "CHAR", "COALESCE", "FORMAT", "GLOB", "HEX", "IFNULL", "IIF", "INSTR", "LAST_INSERT_ROWID", "LENGTH", "LIKE", "LIKELIHOOD", "LIKELY", "LOAD_EXTENSION", "LOWER", "LTRIM", "NULLIF", "PRINTF", "QUOTE", "RANDOM", "RANDOMBLOB", "REPLACE", "ROUND", "RTRIM", "SIGN", "SOUNDEX", "SQLITE_COMPILEOPTION_GET", "SQLITE_COMPILEOPTION_USED", "SQLITE_OFFSET", "SQLITE_SOURCE_ID", "SQLITE_VERSION", "SUBSTR", "SUBSTRING", "TOTAL_CHANGES", "TRIM", "TYPEOF", "UNICODE", "UNLIKELY", "UPPER", "ZEROBLOB"],
  // https://www.sqlite.org/lang_aggfunc.html
  aggregate: ["AVG", "COUNT", "GROUP_CONCAT", "MAX", "MIN", "SUM", "TOTAL"],
  // https://www.sqlite.org/lang_datefunc.html
  datetime: ["DATE", "TIME", "DATETIME", "JULIANDAY", "UNIXEPOCH", "STRFTIME"],
  // https://www.sqlite.org/windowfunctions.html#biwinfunc
  window: ["row_number", "rank", "dense_rank", "percent_rank", "cume_dist", "ntile", "lag", "lead", "first_value", "last_value", "nth_value"],
  // https://www.sqlite.org/lang_mathfunc.html
  math: ["ACOS", "ACOSH", "ASIN", "ASINH", "ATAN", "ATAN2", "ATANH", "CEIL", "CEILING", "COS", "COSH", "DEGREES", "EXP", "FLOOR", "LN", "LOG", "LOG", "LOG10", "LOG2", "MOD", "PI", "POW", "POWER", "RADIANS", "SIN", "SINH", "SQRT", "TAN", "TANH", "TRUNC"],
  // https://www.sqlite.org/json1.html
  json: ["JSON", "JSON_ARRAY", "JSON_ARRAY_LENGTH", "JSON_ARRAY_LENGTH", "JSON_EXTRACT", "JSON_INSERT", "JSON_OBJECT", "JSON_PATCH", "JSON_REMOVE", "JSON_REPLACE", "JSON_SET", "JSON_TYPE", "JSON_TYPE", "JSON_VALID", "JSON_QUOTE", "JSON_GROUP_ARRAY", "JSON_GROUP_OBJECT", "JSON_EACH", "JSON_TREE"],
  cast: ["CAST"],
  // SQLite allows parameters for all data types
  // Well, in fact it allows any word as a data type, e.g. CREATE TABLE foo (col1 madeupname(123));
  // https://www.sqlite.org/datatype3.html
  dataTypes: ["CHARACTER", "VARCHAR", "VARYING CHARACTER", "NCHAR", "NATIVE CHARACTER", "NVARCHAR", "NUMERIC", "DECIMAL"]
}), dx = en({
  // https://www.sqlite.org/lang_keywords.html
  all: ["ABORT", "ACTION", "ADD", "AFTER", "ALL", "ALTER", "AND", "ANY", "ARE", "ARRAY", "ALWAYS", "ANALYZE", "AS", "ASC", "ATTACH", "AUTOINCREMENT", "BEFORE", "BEGIN", "BETWEEN", "BY", "CASCADE", "CASE", "CAST", "CHECK", "COLLATE", "COLUMN", "COMMIT", "CONFLICT", "CONSTRAINT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DATABASE", "DEFAULT", "DEFERRABLE", "DEFERRED", "DELETE", "DESC", "DETACH", "DISTINCT", "DO", "DROP", "EACH", "ELSE", "END", "ESCAPE", "EXCEPT", "EXCLUDE", "EXCLUSIVE", "EXISTS", "EXPLAIN", "FAIL", "FILTER", "FIRST", "FOLLOWING", "FOR", "FOREIGN", "FROM", "FULL", "GENERATED", "GLOB", "GROUP", "GROUPS", "HAVING", "IF", "IGNORE", "IMMEDIATE", "IN", "INDEX", "INDEXED", "INITIALLY", "INNER", "INSERT", "INSTEAD", "INTERSECT", "INTO", "IS", "ISNULL", "JOIN", "KEY", "LAST", "LEFT", "LIKE", "LIMIT", "MATCH", "MATERIALIZED", "NATURAL", "NO", "NOT", "NOTHING", "NOTNULL", "NULL", "NULLS", "OF", "OFFSET", "ON", "ONLY", "OPEN", "OR", "ORDER", "OTHERS", "OUTER", "OVER", "PARTITION", "PLAN", "PRAGMA", "PRECEDING", "PRIMARY", "QUERY", "RAISE", "RANGE", "RECURSIVE", "REFERENCES", "REGEXP", "REINDEX", "RELEASE", "RENAME", "REPLACE", "RESTRICT", "RETURNING", "RIGHT", "ROLLBACK", "ROW", "ROWS", "SAVEPOINT", "SELECT", "SET", "TABLE", "TEMP", "TEMPORARY", "THEN", "TIES", "TO", "TRANSACTION", "TRIGGER", "UNBOUNDED", "UNION", "UNIQUE", "UPDATE", "USING", "VACUUM", "VALUES", "VIEW", "VIRTUAL", "WHEN", "WHERE", "WINDOW", "WITH", "WITHOUT"]
}), Sx = pe(["SELECT [ALL | DISTINCT]"]), Nx = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT [OR ABORT | OR FAIL | OR IGNORE | OR REPLACE | OR ROLLBACK] INTO",
  "REPLACE INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [TEMPORARY | TEMP] VIEW [IF NOT EXISTS]",
  "CREATE [TEMPORARY | TEMP] TABLE [IF NOT EXISTS]"
]), Vm = pe([
  // - update:
  "UPDATE [OR ABORT | OR FAIL | OR IGNORE | OR REPLACE | OR ROLLBACK]",
  // - insert:
  "ON CONFLICT",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD [COLUMN]",
  "DROP [COLUMN]",
  "RENAME [COLUMN]",
  "RENAME TO",
  // - set schema
  "SET SCHEMA"
]), px = pe(["UNION [ALL]", "EXCEPT", "INTERSECT"]), Ox = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), Ix = pe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "{ROWS | RANGE | GROUPS} BETWEEN"]), Cx = {
  tokenizerOptions: {
    reservedSelect: Sx,
    reservedClauses: [...Nx, ...Vm],
    reservedSetOperations: px,
    reservedJoins: Ox,
    reservedPhrases: Ix,
    reservedKeywords: dx,
    reservedFunctionNames: Rx,
    stringTypes: [
      "''-qq",
      {
        quote: "''-raw",
        prefixes: ["X"],
        requirePrefix: !0
      }
      // Depending on context SQLite also supports double-quotes for strings,
      // and single-quotes for identifiers.
    ],
    identTypes: ['""-qq', "``", "[]"],
    // https://www.sqlite.org/lang_expr.html#parameters
    paramTypes: {
      positional: !0,
      numbered: ["?"],
      named: [":", "@", "$"]
    },
    operators: ["%", "~", "&", "|", "<<", ">>", "==", "->", "->>", "||"]
  },
  formatOptions: {
    onelineClauses: Vm
  }
}, hx = en({
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_9_set_function_specification
  set: ["GROUPING"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_10_window_function
  window: ["RANK", "DENSE_RANK", "PERCENT_RANK", "CUME_DIST", "ROW_NUMBER"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_27_numeric_value_function
  numeric: ["POSITION", "OCCURRENCES_REGEX", "POSITION_REGEX", "EXTRACT", "CHAR_LENGTH", "CHARACTER_LENGTH", "OCTET_LENGTH", "CARDINALITY", "ABS", "MOD", "LN", "EXP", "POWER", "SQRT", "FLOOR", "CEIL", "CEILING", "WIDTH_BUCKET"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_29_string_value_function
  string: ["SUBSTRING", "SUBSTRING_REGEX", "UPPER", "LOWER", "CONVERT", "TRANSLATE", "TRANSLATE_REGEX", "TRIM", "OVERLAY", "NORMALIZE", "SPECIFICTYPE"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_31_datetime_value_function
  datetime: ["CURRENT_DATE", "CURRENT_TIME", "LOCALTIME", "CURRENT_TIMESTAMP", "LOCALTIMESTAMP"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_38_multiset_value_function
  // SET serves multiple roles: a SET() function and a SET keyword e.g. in UPDATE table SET ...
  // multiset: ['SET'], (disabled for now)
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_10_9_aggregate_function
  aggregate: [
    "COUNT",
    "AVG",
    "MAX",
    "MIN",
    "SUM",
    // 'EVERY',
    // 'ANY',
    // 'SOME',
    "STDDEV_POP",
    "STDDEV_SAMP",
    "VAR_SAMP",
    "VAR_POP",
    "COLLECT",
    "FUSION",
    "INTERSECTION",
    "COVAR_POP",
    "COVAR_SAMP",
    "CORR",
    "REGR_SLOPE",
    "REGR_INTERCEPT",
    "REGR_COUNT",
    "REGR_R2",
    "REGR_AVGX",
    "REGR_AVGY",
    "REGR_SXX",
    "REGR_SYY",
    "REGR_SXY",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC"
  ],
  // CAST is a pretty complex case, involving multiple forms:
  // - CAST(col AS int)
  // - CAST(...) WITH ...
  // - CAST FROM int
  // - CREATE CAST(mycol AS int) WITH ...
  cast: ["CAST"],
  // Shorthand functions to use in place of CASE expression
  caseAbbrev: ["COALESCE", "NULLIF"],
  // Non-standard functions that have widespread support
  nonStandard: ["ROUND", "SIN", "COS", "TAN", "ASIN", "ACOS", "ATAN"],
  // Data types with parameters like VARCHAR(100)
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#predefined-type
  dataTypes: ["CHARACTER", "CHAR", "CHARACTER VARYING", "CHAR VARYING", "VARCHAR", "CHARACTER LARGE OBJECT", "CHAR LARGE OBJECT", "CLOB", "NATIONAL CHARACTER", "NATIONAL CHAR", "NCHAR", "NATIONAL CHARACTER VARYING", "NATIONAL CHAR VARYING", "NCHAR VARYING", "NATIONAL CHARACTER LARGE OBJECT", "NCHAR LARGE OBJECT", "NCLOB", "BINARY", "BINARY VARYING", "VARBINARY", "BINARY LARGE OBJECT", "BLOB", "NUMERIC", "DECIMAL", "DEC", "TIME", "TIMESTAMP"]
}), vx = en({
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#reserved-word
  all: [
    "ALL",
    "ALLOCATE",
    "ALTER",
    "ANY",
    // <- moved over from functions
    "ARE",
    "ARRAY",
    "AS",
    "ASENSITIVE",
    "ASYMMETRIC",
    "AT",
    "ATOMIC",
    "AUTHORIZATION",
    "BEGIN",
    "BETWEEN",
    "BIGINT",
    "BINARY",
    "BLOB",
    "BOOLEAN",
    "BOTH",
    "BY",
    "CALL",
    "CALLED",
    "CASCADED",
    "CAST",
    "CHAR",
    "CHARACTER",
    "CHECK",
    "CLOB",
    "CLOSE",
    "COALESCE",
    "COLLATE",
    "COLUMN",
    "COMMIT",
    "CONDITION",
    "CONNECT",
    "CONSTRAINT",
    "CORRESPONDING",
    "CREATE",
    "CROSS",
    "CUBE",
    "CURRENT",
    "CURRENT_CATALOG",
    "CURRENT_DEFAULT_TRANSFORM_GROUP",
    "CURRENT_PATH",
    "CURRENT_ROLE",
    "CURRENT_SCHEMA",
    "CURRENT_TRANSFORM_GROUP_FOR_TYPE",
    "CURRENT_USER",
    "CURSOR",
    "CYCLE",
    "DATE",
    "DAY",
    "DEALLOCATE",
    "DEC",
    "DECIMAL",
    "DECLARE",
    "DEFAULT",
    "DELETE",
    "DEREF",
    "DESCRIBE",
    "DETERMINISTIC",
    "DISCONNECT",
    "DISTINCT",
    "DOUBLE",
    "DROP",
    "DYNAMIC",
    "EACH",
    "ELEMENT",
    "END-EXEC",
    "ESCAPE",
    "EVERY",
    // <- moved over from functions
    "EXCEPT",
    "EXEC",
    "EXECUTE",
    "EXISTS",
    "EXTERNAL",
    "FALSE",
    "FETCH",
    "FILTER",
    "FLOAT",
    "FOR",
    "FOREIGN",
    "FREE",
    "FROM",
    "FULL",
    "FUNCTION",
    "GET",
    "GLOBAL",
    "GRANT",
    "GROUP",
    "HAVING",
    "HOLD",
    "HOUR",
    "IDENTITY",
    "IN",
    "INDICATOR",
    "INNER",
    "INOUT",
    "INSENSITIVE",
    "INSERT",
    "INT",
    "INTEGER",
    "INTERSECT",
    "INTERVAL",
    "INTO",
    "IS",
    "LANGUAGE",
    "LARGE",
    "LATERAL",
    "LEADING",
    "LEFT",
    "LIKE",
    "LIKE_REGEX",
    "LOCAL",
    "MATCH",
    "MEMBER",
    "MERGE",
    "METHOD",
    "MINUTE",
    "MODIFIES",
    "MODULE",
    "MONTH",
    "MULTISET",
    "NATIONAL",
    "NATURAL",
    "NCHAR",
    "NCLOB",
    "NEW",
    "NO",
    "NONE",
    "NOT",
    "NULL",
    "NULLIF",
    "NUMERIC",
    "OF",
    "OLD",
    "ON",
    "ONLY",
    "OPEN",
    "ORDER",
    "OUT",
    "OUTER",
    "OVER",
    "OVERLAPS",
    "PARAMETER",
    "PARTITION",
    "PRECISION",
    "PREPARE",
    "PRIMARY",
    "PROCEDURE",
    "RANGE",
    "READS",
    "REAL",
    "RECURSIVE",
    "REF",
    "REFERENCES",
    "REFERENCING",
    "RELEASE",
    "RESULT",
    "RETURN",
    "RETURNS",
    "REVOKE",
    "RIGHT",
    "ROLLBACK",
    "ROLLUP",
    "ROW",
    "ROWS",
    "SAVEPOINT",
    "SCOPE",
    "SCROLL",
    "SEARCH",
    "SECOND",
    "SELECT",
    "SENSITIVE",
    "SESSION_USER",
    "SET",
    "SIMILAR",
    "SMALLINT",
    "SOME",
    // <- moved over from functions
    "SPECIFIC",
    "SQL",
    "SQLEXCEPTION",
    "SQLSTATE",
    "SQLWARNING",
    "START",
    "STATIC",
    "SUBMULTISET",
    "SYMMETRIC",
    "SYSTEM",
    "SYSTEM_USER",
    "TABLE",
    "TABLESAMPLE",
    "THEN",
    "TIME",
    "TIMESTAMP",
    "TIMEZONE_HOUR",
    "TIMEZONE_MINUTE",
    "TO",
    "TRAILING",
    "TRANSLATION",
    "TREAT",
    "TRIGGER",
    "TRUE",
    "UESCAPE",
    "UNION",
    "UNIQUE",
    "UNKNOWN",
    "UNNEST",
    "UPDATE",
    "USER",
    "USING",
    "VALUE",
    "VALUES",
    "VARBINARY",
    "VARCHAR",
    "VARYING",
    "WHENEVER",
    "WINDOW",
    "WITHIN",
    "WITHOUT",
    "YEAR"
  ]
}), mx = pe(["SELECT [ALL | DISTINCT]"]), Lx = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY [ALL | DISTINCT]",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [RECURSIVE] VIEW",
  "CREATE [GLOBAL TEMPORARY | LOCAL TEMPORARY] TABLE"
]), Wm = pe([
  // - update:
  "UPDATE",
  "WHERE CURRENT OF",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE",
  // - alter table:
  "ALTER TABLE",
  "ADD COLUMN",
  "DROP [COLUMN]",
  "RENAME COLUMN",
  "RENAME TO",
  "ALTER [COLUMN]",
  "{SET | DROP} DEFAULT",
  // for alter column
  "ADD SCOPE",
  // for alter column
  "DROP SCOPE {CASCADE | RESTRICT}",
  // for alter column
  "RESTART WITH",
  // for alter column
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "SET SCHEMA"
]), yx = pe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), Dx = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), gx = pe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "{ROWS | RANGE} BETWEEN"]), Px = {
  tokenizerOptions: {
    reservedSelect: mx,
    reservedClauses: [...Lx, ...Wm],
    reservedSetOperations: yx,
    reservedJoins: Dx,
    reservedPhrases: gx,
    reservedKeywords: vx,
    reservedFunctionNames: hx,
    stringTypes: [{
      quote: "''-qq-bs",
      prefixes: ["N", "U&"]
    }, {
      quote: "''-raw",
      prefixes: ["X"],
      requirePrefix: !0
    }],
    identTypes: ['""-qq', "``"],
    paramTypes: {
      positional: !0
    },
    operators: ["||"]
  },
  formatOptions: {
    onelineClauses: Wm
  }
}, Mx = en({
  // https://github.com/trinodb/trino/tree/432d2897bdef99388c1a47188743a061c4ac1f34/docs/src/main/sphinx/functions
  // rg '^\.\. function::' ./docs/src/main/sphinx/functions | cut -d' ' -f 3 | cut -d '(' -f 1 | sort | uniq
  // rg '\* ' ./docs/src/main/sphinx/functions/list-by-topic.rst | grep    '\* :func:' | cut -d'`' -f 2
  // rg '\* ' ./docs/src/main/sphinx/functions/list-by-topic.rst | grep -v '\* :func:'
  // grep -e '^- ' ./docs/src/main/sphinx/functions/list.rst | grep  -e '^- :func:' | cut -d'`' -f2
  // grep -e '^- ' ./docs/src/main/sphinx/functions/list.rst | grep -ve '^- :func:'
  all: ["ABS", "ACOS", "ALL_MATCH", "ANY_MATCH", "APPROX_DISTINCT", "APPROX_MOST_FREQUENT", "APPROX_PERCENTILE", "APPROX_SET", "ARBITRARY", "ARRAYS_OVERLAP", "ARRAY_AGG", "ARRAY_DISTINCT", "ARRAY_EXCEPT", "ARRAY_INTERSECT", "ARRAY_JOIN", "ARRAY_MAX", "ARRAY_MIN", "ARRAY_POSITION", "ARRAY_REMOVE", "ARRAY_SORT", "ARRAY_UNION", "ASIN", "ATAN", "ATAN2", "AT_TIMEZONE", "AVG", "BAR", "BETA_CDF", "BING_TILE", "BING_TILES_AROUND", "BING_TILE_AT", "BING_TILE_COORDINATES", "BING_TILE_POLYGON", "BING_TILE_QUADKEY", "BING_TILE_ZOOM_LEVEL", "BITWISE_AND", "BITWISE_AND_AGG", "BITWISE_LEFT_SHIFT", "BITWISE_NOT", "BITWISE_OR", "BITWISE_OR_AGG", "BITWISE_RIGHT_SHIFT", "BITWISE_RIGHT_SHIFT_ARITHMETIC", "BITWISE_XOR", "BIT_COUNT", "BOOL_AND", "BOOL_OR", "CARDINALITY", "CAST", "CBRT", "CEIL", "CEILING", "CHAR2HEXINT", "CHECKSUM", "CHR", "CLASSIFY", "COALESCE", "CODEPOINT", "COLOR", "COMBINATIONS", "CONCAT", "CONCAT_WS", "CONTAINS", "CONTAINS_SEQUENCE", "CONVEX_HULL_AGG", "CORR", "COS", "COSH", "COSINE_SIMILARITY", "COUNT", "COUNT_IF", "COVAR_POP", "COVAR_SAMP", "CRC32", "CUME_DIST", "CURRENT_CATALOG", "CURRENT_DATE", "CURRENT_GROUPS", "CURRENT_SCHEMA", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_TIMEZONE", "CURRENT_USER", "DATE", "DATE_ADD", "DATE_DIFF", "DATE_FORMAT", "DATE_PARSE", "DATE_TRUNC", "DAY", "DAY_OF_MONTH", "DAY_OF_WEEK", "DAY_OF_YEAR", "DEGREES", "DENSE_RANK", "DOW", "DOY", "E", "ELEMENT_AT", "EMPTY_APPROX_SET", "EVALUATE_CLASSIFIER_PREDICTIONS", "EVERY", "EXP", "EXTRACT", "FEATURES", "FILTER", "FIRST_VALUE", "FLATTEN", "FLOOR", "FORMAT", "FORMAT_DATETIME", "FORMAT_NUMBER", "FROM_BASE", "FROM_BASE32", "FROM_BASE64", "FROM_BASE64URL", "FROM_BIG_ENDIAN_32", "FROM_BIG_ENDIAN_64", "FROM_ENCODED_POLYLINE", "FROM_GEOJSON_GEOMETRY", "FROM_HEX", "FROM_IEEE754_32", "FROM_IEEE754_64", "FROM_ISO8601_DATE", "FROM_ISO8601_TIMESTAMP", "FROM_ISO8601_TIMESTAMP_NANOS", "FROM_UNIXTIME", "FROM_UNIXTIME_NANOS", "FROM_UTF8", "GEOMETRIC_MEAN", "GEOMETRY_FROM_HADOOP_SHAPE", "GEOMETRY_INVALID_REASON", "GEOMETRY_NEAREST_POINTS", "GEOMETRY_TO_BING_TILES", "GEOMETRY_UNION", "GEOMETRY_UNION_AGG", "GREATEST", "GREAT_CIRCLE_DISTANCE", "HAMMING_DISTANCE", "HASH_COUNTS", "HISTOGRAM", "HMAC_MD5", "HMAC_SHA1", "HMAC_SHA256", "HMAC_SHA512", "HOUR", "HUMAN_READABLE_SECONDS", "IF", "INDEX", "INFINITY", "INTERSECTION_CARDINALITY", "INVERSE_BETA_CDF", "INVERSE_NORMAL_CDF", "IS_FINITE", "IS_INFINITE", "IS_JSON_SCALAR", "IS_NAN", "JACCARD_INDEX", "JSON_ARRAY_CONTAINS", "JSON_ARRAY_GET", "JSON_ARRAY_LENGTH", "JSON_EXISTS", "JSON_EXTRACT", "JSON_EXTRACT_SCALAR", "JSON_FORMAT", "JSON_PARSE", "JSON_QUERY", "JSON_SIZE", "JSON_VALUE", "KURTOSIS", "LAG", "LAST_DAY_OF_MONTH", "LAST_VALUE", "LEAD", "LEARN_CLASSIFIER", "LEARN_LIBSVM_CLASSIFIER", "LEARN_LIBSVM_REGRESSOR", "LEARN_REGRESSOR", "LEAST", "LENGTH", "LEVENSHTEIN_DISTANCE", "LINE_INTERPOLATE_POINT", "LINE_INTERPOLATE_POINTS", "LINE_LOCATE_POINT", "LISTAGG", "LN", "LOCALTIME", "LOCALTIMESTAMP", "LOG", "LOG10", "LOG2", "LOWER", "LPAD", "LTRIM", "LUHN_CHECK", "MAKE_SET_DIGEST", "MAP", "MAP_AGG", "MAP_CONCAT", "MAP_ENTRIES", "MAP_FILTER", "MAP_FROM_ENTRIES", "MAP_KEYS", "MAP_UNION", "MAP_VALUES", "MAP_ZIP_WITH", "MAX", "MAX_BY", "MD5", "MERGE", "MERGE_SET_DIGEST", "MILLISECOND", "MIN", "MINUTE", "MIN_BY", "MOD", "MONTH", "MULTIMAP_AGG", "MULTIMAP_FROM_ENTRIES", "MURMUR3", "NAN", "NGRAMS", "NONE_MATCH", "NORMALIZE", "NORMAL_CDF", "NOW", "NTH_VALUE", "NTILE", "NULLIF", "NUMERIC_HISTOGRAM", "OBJECTID", "OBJECTID_TIMESTAMP", "PARSE_DATA_SIZE", "PARSE_DATETIME", "PARSE_DURATION", "PERCENT_RANK", "PI", "POSITION", "POW", "POWER", "QDIGEST_AGG", "QUARTER", "RADIANS", "RAND", "RANDOM", "RANK", "REDUCE", "REDUCE_AGG", "REGEXP_COUNT", "REGEXP_EXTRACT", "REGEXP_EXTRACT_ALL", "REGEXP_LIKE", "REGEXP_POSITION", "REGEXP_REPLACE", "REGEXP_SPLIT", "REGRESS", "REGR_INTERCEPT", "REGR_SLOPE", "RENDER", "REPEAT", "REPLACE", "REVERSE", "RGB", "ROUND", "ROW_NUMBER", "RPAD", "RTRIM", "SECOND", "SEQUENCE", "SHA1", "SHA256", "SHA512", "SHUFFLE", "SIGN", "SIMPLIFY_GEOMETRY", "SIN", "SKEWNESS", "SLICE", "SOUNDEX", "SPATIAL_PARTITIONING", "SPATIAL_PARTITIONS", "SPLIT", "SPLIT_PART", "SPLIT_TO_MAP", "SPLIT_TO_MULTIMAP", "SPOOKY_HASH_V2_32", "SPOOKY_HASH_V2_64", "SQRT", "STARTS_WITH", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "STRPOS", "ST_AREA", "ST_ASBINARY", "ST_ASTEXT", "ST_BOUNDARY", "ST_BUFFER", "ST_CENTROID", "ST_CONTAINS", "ST_CONVEXHULL", "ST_COORDDIM", "ST_CROSSES", "ST_DIFFERENCE", "ST_DIMENSION", "ST_DISJOINT", "ST_DISTANCE", "ST_ENDPOINT", "ST_ENVELOPE", "ST_ENVELOPEASPTS", "ST_EQUALS", "ST_EXTERIORRING", "ST_GEOMETRIES", "ST_GEOMETRYFROMTEXT", "ST_GEOMETRYN", "ST_GEOMETRYTYPE", "ST_GEOMFROMBINARY", "ST_INTERIORRINGN", "ST_INTERIORRINGS", "ST_INTERSECTION", "ST_INTERSECTS", "ST_ISCLOSED", "ST_ISEMPTY", "ST_ISRING", "ST_ISSIMPLE", "ST_ISVALID", "ST_LENGTH", "ST_LINEFROMTEXT", "ST_LINESTRING", "ST_MULTIPOINT", "ST_NUMGEOMETRIES", "ST_NUMINTERIORRING", "ST_NUMPOINTS", "ST_OVERLAPS", "ST_POINT", "ST_POINTN", "ST_POINTS", "ST_POLYGON", "ST_RELATE", "ST_STARTPOINT", "ST_SYMDIFFERENCE", "ST_TOUCHES", "ST_UNION", "ST_WITHIN", "ST_X", "ST_XMAX", "ST_XMIN", "ST_Y", "ST_YMAX", "ST_YMIN", "SUBSTR", "SUBSTRING", "SUM", "TAN", "TANH", "TDIGEST_AGG", "TIMESTAMP_OBJECTID", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO_BASE", "TO_BASE32", "TO_BASE64", "TO_BASE64URL", "TO_BIG_ENDIAN_32", "TO_BIG_ENDIAN_64", "TO_CHAR", "TO_DATE", "TO_ENCODED_POLYLINE", "TO_GEOJSON_GEOMETRY", "TO_GEOMETRY", "TO_HEX", "TO_IEEE754_32", "TO_IEEE754_64", "TO_ISO8601", "TO_MILLISECONDS", "TO_SPHERICAL_GEOGRAPHY", "TO_TIMESTAMP", "TO_UNIXTIME", "TO_UTF8", "TRANSFORM", "TRANSFORM_KEYS", "TRANSFORM_VALUES", "TRANSLATE", "TRIM", "TRIM_ARRAY", "TRUNCATE", "TRY", "TRY_CAST", "TYPEOF", "UPPER", "URL_DECODE", "URL_ENCODE", "URL_EXTRACT_FRAGMENT", "URL_EXTRACT_HOST", "URL_EXTRACT_PARAMETER", "URL_EXTRACT_PATH", "URL_EXTRACT_PORT", "URL_EXTRACT_PROTOCOL", "URL_EXTRACT_QUERY", "UUID", "VALUES_AT_QUANTILES", "VALUE_AT_QUANTILE", "VARIANCE", "VAR_POP", "VAR_SAMP", "VERSION", "WEEK", "WEEK_OF_YEAR", "WIDTH_BUCKET", "WILSON_INTERVAL_LOWER", "WILSON_INTERVAL_UPPER", "WITH_TIMEZONE", "WORD_STEM", "XXHASH64", "YEAR", "YEAR_OF_WEEK", "YOW", "ZIP", "ZIP_WITH"],
  // https://trino.io/docs/current/sql/match-recognize.html#row-pattern-recognition-expressions
  rowPattern: ["CLASSIFIER", "FIRST", "LAST", "MATCH_NUMBER", "NEXT", "PERMUTE", "PREV"]
}), Ux = en({
  // https://github.com/trinodb/trino/blob/432d2897bdef99388c1a47188743a061c4ac1f34/core/trino-parser/src/main/antlr4/io/trino/sql/parser/SqlBase.g4#L858-L1128
  all: ["ABSENT", "ADD", "ADMIN", "AFTER", "ALL", "ALTER", "ANALYZE", "AND", "ANY", "ARRAY", "AS", "ASC", "AT", "AUTHORIZATION", "BERNOULLI", "BETWEEN", "BOTH", "BY", "CALL", "CASCADE", "CASE", "CATALOGS", "COLUMN", "COLUMNS", "COMMENT", "COMMIT", "COMMITTED", "CONDITIONAL", "CONSTRAINT", "COPARTITION", "CREATE", "CROSS", "CUBE", "CURRENT", "CURRENT_PATH", "CURRENT_ROLE", "DATA", "DEALLOCATE", "DEFAULT", "DEFINE", "DEFINER", "DELETE", "DENY", "DESC", "DESCRIBE", "DESCRIPTOR", "DISTINCT", "DISTRIBUTED", "DOUBLE", "DROP", "ELSE", "EMPTY", "ENCODING", "END", "ERROR", "ESCAPE", "EXCEPT", "EXCLUDING", "EXECUTE", "EXISTS", "EXPLAIN", "FALSE", "FETCH", "FINAL", "FIRST", "FOLLOWING", "FOR", "FROM", "FULL", "FUNCTIONS", "GRANT", "GRANTED", "GRANTS", "GRAPHVIZ", "GROUP", "GROUPING", "GROUPS", "HAVING", "IGNORE", "IN", "INCLUDING", "INITIAL", "INNER", "INPUT", "INSERT", "INTERSECT", "INTERVAL", "INTO", "INVOKER", "IO", "IS", "ISOLATION", "JOIN", "JSON", "JSON_ARRAY", "JSON_OBJECT", "KEEP", "KEY", "KEYS", "LAST", "LATERAL", "LEADING", "LEFT", "LEVEL", "LIKE", "LIMIT", "LOCAL", "LOGICAL", "MATCH", "MATCHED", "MATCHES", "MATCH_RECOGNIZE", "MATERIALIZED", "MEASURES", "NATURAL", "NEXT", "NFC", "NFD", "NFKC", "NFKD", "NO", "NONE", "NOT", "NULL", "NULLS", "OBJECT", "OF", "OFFSET", "OMIT", "ON", "ONE", "ONLY", "OPTION", "OR", "ORDER", "ORDINALITY", "OUTER", "OUTPUT", "OVER", "OVERFLOW", "PARTITION", "PARTITIONS", "PASSING", "PAST", "PATH", "PATTERN", "PER", "PERMUTE", "PRECEDING", "PRECISION", "PREPARE", "PRIVILEGES", "PROPERTIES", "PRUNE", "QUOTES", "RANGE", "READ", "RECURSIVE", "REFRESH", "RENAME", "REPEATABLE", "RESET", "RESPECT", "RESTRICT", "RETURNING", "REVOKE", "RIGHT", "ROLE", "ROLES", "ROLLBACK", "ROLLUP", "ROW", "ROWS", "RUNNING", "SCALAR", "SCHEMA", "SCHEMAS", "SECURITY", "SEEK", "SELECT", "SERIALIZABLE", "SESSION", "SET", "SETS", "SHOW", "SKIP", "SOME", "START", "STATS", "STRING", "SUBSET", "SYSTEM", "TABLE", "TABLES", "TABLESAMPLE", "TEXT", "THEN", "TIES", "TIME", "TIMESTAMP", "TO", "TRAILING", "TRANSACTION", "TRUE", "TYPE", "UESCAPE", "UNBOUNDED", "UNCOMMITTED", "UNCONDITIONAL", "UNION", "UNIQUE", "UNKNOWN", "UNMATCHED", "UNNEST", "UPDATE", "USE", "USER", "USING", "UTF16", "UTF32", "UTF8", "VALIDATE", "VALUE", "VALUES", "VERBOSE", "VIEW", "WHEN", "WHERE", "WINDOW", "WITH", "WITHIN", "WITHOUT", "WORK", "WRAPPER", "WRITE", "ZONE"],
  // https://github.com/trinodb/trino/blob/432d2897bdef99388c1a47188743a061c4ac1f34/core/trino-main/src/main/java/io/trino/metadata/TypeRegistry.java#L131-L168
  // or https://trino.io/docs/current/language/types.html
  types: ["BIGINT", "INT", "INTEGER", "SMALLINT", "TINYINT", "BOOLEAN", "DATE", "DECIMAL", "REAL", "DOUBLE", "HYPERLOGLOG", "QDIGEST", "TDIGEST", "P4HYPERLOGLOG", "INTERVAL", "TIMESTAMP", "TIME", "VARBINARY", "VARCHAR", "CHAR", "ROW", "ARRAY", "MAP", "JSON", "JSON2016", "IPADDRESS", "GEOMETRY", "UUID", "SETDIGEST", "JONIREGEXP", "RE2JREGEXP", "LIKEPATTERN", "COLOR", "CODEPOINTS", "FUNCTION", "JSONPATH"]
}), _x = pe(["SELECT [ALL | DISTINCT]"]), Gx = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY [ALL | DISTINCT]",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [MATERIALIZED] VIEW",
  "CREATE TABLE [IF NOT EXISTS]",
  // MATCH_RECOGNIZE
  "MATCH_RECOGNIZE",
  "MEASURES",
  "ONE ROW PER MATCH",
  "ALL ROWS PER MATCH",
  "AFTER MATCH",
  "PATTERN",
  "SUBSET",
  "DEFINE"
]), Xm = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS]",
  "ADD COLUMN [IF NOT EXISTS]",
  "DROP COLUMN [IF EXISTS]",
  "RENAME COLUMN [IF EXISTS]",
  "RENAME TO",
  "SET AUTHORIZATION [USER | ROLE]",
  "SET PROPERTIES",
  "EXECUTE",
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "ALTER SCHEMA",
  "ALTER MATERIALIZED VIEW",
  "ALTER VIEW",
  "CREATE SCHEMA",
  "CREATE ROLE",
  "DROP SCHEMA",
  "DROP MATERIALIZED VIEW",
  "DROP VIEW",
  "DROP ROLE",
  // Auxiliary
  "EXPLAIN",
  "ANALYZE",
  "EXPLAIN ANALYZE",
  "EXPLAIN ANALYZE VERBOSE",
  "USE",
  "COMMENT ON TABLE",
  "COMMENT ON COLUMN",
  "DESCRIBE INPUT",
  "DESCRIBE OUTPUT",
  "REFRESH MATERIALIZED VIEW",
  "RESET SESSION",
  "SET SESSION",
  "SET PATH",
  "SET TIME ZONE",
  "SHOW GRANTS",
  "SHOW CREATE TABLE",
  "SHOW CREATE SCHEMA",
  "SHOW CREATE VIEW",
  "SHOW CREATE MATERIALIZED VIEW",
  "SHOW TABLES",
  "SHOW SCHEMAS",
  "SHOW CATALOGS",
  "SHOW COLUMNS",
  "SHOW STATS FOR",
  "SHOW ROLES",
  "SHOW CURRENT ROLES",
  "SHOW ROLE GRANTS",
  "SHOW FUNCTIONS",
  "SHOW SESSION"
]), xx = pe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), bx = pe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), Hx = pe([
  "{ROWS | RANGE | GROUPS} BETWEEN",
  // comparison operator
  "IS [NOT] DISTINCT FROM"
]), Bx = {
  tokenizerOptions: {
    reservedSelect: _x,
    reservedClauses: [...Gx, ...Xm],
    reservedSetOperations: xx,
    reservedJoins: bx,
    reservedPhrases: Hx,
    reservedKeywords: Ux,
    reservedFunctionNames: Mx,
    // Trino also supports {- ... -} parenthesis.
    // The formatting of these currently works out as a result of { and -
    // not getting a space added in-between.
    // https://trino.io/docs/current/sql/match-recognize.html#row-pattern-syntax
    extraParens: ["[]", "{}"],
    // https://trino.io/docs/current/language/types.html#string
    // https://trino.io/docs/current/language/types.html#varbinary
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["U&"]
    }, {
      quote: "''-raw",
      prefixes: ["X"],
      requirePrefix: !0
    }],
    // https://trino.io/docs/current/language/reserved.html
    identTypes: ['""-qq'],
    paramTypes: {
      positional: !0
    },
    operators: [
      "%",
      "->",
      "=>",
      ":",
      "||",
      // Row pattern syntax
      "|",
      "^",
      "$"
      // '?', conflicts with positional placeholders
    ]
  },
  formatOptions: {
    onelineClauses: Xm
  }
}, Fx = en({
  // https://docs.microsoft.com/en-us/sql/t-sql/functions/functions?view=sql-server-ver15
  aggregate: ["APPROX_COUNT_DISTINCT", "AVG", "CHECKSUM_AGG", "COUNT", "COUNT_BIG", "GROUPING", "GROUPING_ID", "MAX", "MIN", "STDEV", "STDEVP", "SUM", "VAR", "VARP"],
  analytic: ["CUME_DIST", "FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "PERCENTILE_CONT", "PERCENTILE_DISC", "PERCENT_RANK", "Collation - COLLATIONPROPERTY", "Collation - TERTIARY_WEIGHTS"],
  configuration: ["@@DBTS", "@@LANGID", "@@LANGUAGE", "@@LOCK_TIMEOUT", "@@MAX_CONNECTIONS", "@@MAX_PRECISION", "@@NESTLEVEL", "@@OPTIONS", "@@REMSERVER", "@@SERVERNAME", "@@SERVICENAME", "@@SPID", "@@TEXTSIZE", "@@VERSION"],
  conversion: ["CAST", "CONVERT", "PARSE", "TRY_CAST", "TRY_CONVERT", "TRY_PARSE"],
  cryptographic: ["ASYMKEY_ID", "ASYMKEYPROPERTY", "CERTPROPERTY", "CERT_ID", "CRYPT_GEN_RANDOM", "DECRYPTBYASYMKEY", "DECRYPTBYCERT", "DECRYPTBYKEY", "DECRYPTBYKEYAUTOASYMKEY", "DECRYPTBYKEYAUTOCERT", "DECRYPTBYPASSPHRASE", "ENCRYPTBYASYMKEY", "ENCRYPTBYCERT", "ENCRYPTBYKEY", "ENCRYPTBYPASSPHRASE", "HASHBYTES", "IS_OBJECTSIGNED", "KEY_GUID", "KEY_ID", "KEY_NAME", "SIGNBYASYMKEY", "SIGNBYCERT", "SYMKEYPROPERTY", "VERIFYSIGNEDBYCERT", "VERIFYSIGNEDBYASYMKEY"],
  cursor: ["@@CURSOR_ROWS", "@@FETCH_STATUS", "CURSOR_STATUS"],
  dataType: ["DATALENGTH", "IDENT_CURRENT", "IDENT_INCR", "IDENT_SEED", "IDENTITY", "SQL_VARIANT_PROPERTY"],
  datetime: ["@@DATEFIRST", "CURRENT_TIMESTAMP", "CURRENT_TIMEZONE", "CURRENT_TIMEZONE_ID", "DATEADD", "DATEDIFF", "DATEDIFF_BIG", "DATEFROMPARTS", "DATENAME", "DATEPART", "DATETIME2FROMPARTS", "DATETIMEFROMPARTS", "DATETIMEOFFSETFROMPARTS", "DAY", "EOMONTH", "GETDATE", "GETUTCDATE", "ISDATE", "MONTH", "SMALLDATETIMEFROMPARTS", "SWITCHOFFSET", "SYSDATETIME", "SYSDATETIMEOFFSET", "SYSUTCDATETIME", "TIMEFROMPARTS", "TODATETIMEOFFSET", "YEAR", "JSON", "ISJSON", "JSON_VALUE", "JSON_QUERY", "JSON_MODIFY"],
  mathematical: ["ABS", "ACOS", "ASIN", "ATAN", "ATN2", "CEILING", "COS", "COT", "DEGREES", "EXP", "FLOOR", "LOG", "LOG10", "PI", "POWER", "RADIANS", "RAND", "ROUND", "SIGN", "SIN", "SQRT", "SQUARE", "TAN", "CHOOSE", "GREATEST", "IIF", "LEAST"],
  metadata: ["@@PROCID", "APP_NAME", "APPLOCK_MODE", "APPLOCK_TEST", "ASSEMBLYPROPERTY", "COL_LENGTH", "COL_NAME", "COLUMNPROPERTY", "DATABASEPROPERTYEX", "DB_ID", "DB_NAME", "FILE_ID", "FILE_IDEX", "FILE_NAME", "FILEGROUP_ID", "FILEGROUP_NAME", "FILEGROUPPROPERTY", "FILEPROPERTY", "FILEPROPERTYEX", "FULLTEXTCATALOGPROPERTY", "FULLTEXTSERVICEPROPERTY", "INDEX_COL", "INDEXKEY_PROPERTY", "INDEXPROPERTY", "NEXT VALUE FOR", "OBJECT_DEFINITION", "OBJECT_ID", "OBJECT_NAME", "OBJECT_SCHEMA_NAME", "OBJECTPROPERTY", "OBJECTPROPERTYEX", "ORIGINAL_DB_NAME", "PARSENAME", "SCHEMA_ID", "SCHEMA_NAME", "SCOPE_IDENTITY", "SERVERPROPERTY", "STATS_DATE", "TYPE_ID", "TYPE_NAME", "TYPEPROPERTY"],
  ranking: ["DENSE_RANK", "NTILE", "RANK", "ROW_NUMBER", "PUBLISHINGSERVERNAME"],
  security: ["CERTENCODED", "CERTPRIVATEKEY", "CURRENT_USER", "DATABASE_PRINCIPAL_ID", "HAS_DBACCESS", "HAS_PERMS_BY_NAME", "IS_MEMBER", "IS_ROLEMEMBER", "IS_SRVROLEMEMBER", "LOGINPROPERTY", "ORIGINAL_LOGIN", "PERMISSIONS", "PWDENCRYPT", "PWDCOMPARE", "SESSION_USER", "SESSIONPROPERTY", "SUSER_ID", "SUSER_NAME", "SUSER_SID", "SUSER_SNAME", "SYSTEM_USER", "USER", "USER_ID", "USER_NAME"],
  string: ["ASCII", "CHAR", "CHARINDEX", "CONCAT", "CONCAT_WS", "DIFFERENCE", "FORMAT", "LEFT", "LEN", "LOWER", "LTRIM", "NCHAR", "PATINDEX", "QUOTENAME", "REPLACE", "REPLICATE", "REVERSE", "RIGHT", "RTRIM", "SOUNDEX", "SPACE", "STR", "STRING_AGG", "STRING_ESCAPE", "STUFF", "SUBSTRING", "TRANSLATE", "TRIM", "UNICODE", "UPPER"],
  system: ["$PARTITION", "@@ERROR", "@@IDENTITY", "@@PACK_RECEIVED", "@@ROWCOUNT", "@@TRANCOUNT", "BINARY_CHECKSUM", "CHECKSUM", "COMPRESS", "CONNECTIONPROPERTY", "CONTEXT_INFO", "CURRENT_REQUEST_ID", "CURRENT_TRANSACTION_ID", "DECOMPRESS", "ERROR_LINE", "ERROR_MESSAGE", "ERROR_NUMBER", "ERROR_PROCEDURE", "ERROR_SEVERITY", "ERROR_STATE", "FORMATMESSAGE", "GET_FILESTREAM_TRANSACTION_CONTEXT", "GETANSINULL", "HOST_ID", "HOST_NAME", "ISNULL", "ISNUMERIC", "MIN_ACTIVE_ROWVERSION", "NEWID", "NEWSEQUENTIALID", "ROWCOUNT_BIG", "SESSION_CONTEXT", "XACT_STATE"],
  statistical: ["@@CONNECTIONS", "@@CPU_BUSY", "@@IDLE", "@@IO_BUSY", "@@PACK_SENT", "@@PACKET_ERRORS", "@@TIMETICKS", "@@TOTAL_ERRORS", "@@TOTAL_READ", "@@TOTAL_WRITE", "TEXTPTR", "TEXTVALID"],
  trigger: ["COLUMNS_UPDATED", "EVENTDATA", "TRIGGER_NESTLEVEL", "UPDATE"],
  // Shorthand functions to use in place of CASE expression
  caseAbbrev: ["COALESCE", "NULLIF"],
  // Parameterized types
  // https://docs.microsoft.com/en-us/sql/t-sql/data-types/data-types-transact-sql?view=sql-server-ver15
  dataTypes: ["DECIMAL", "NUMERIC", "FLOAT", "REAL", "DATETIME2", "DATETIMEOFFSET", "TIME", "CHAR", "VARCHAR", "NCHAR", "NVARCHAR", "BINARY", "VARBINARY"]
}), wx = en({
  // https://docs.microsoft.com/en-us/sql/t-sql/language-elements/reserved-keywords-transact-sql?view=sql-server-ver15
  standard: ["ADD", "ALL", "ALTER", "AND", "ANY", "AS", "ASC", "AUTHORIZATION", "BACKUP", "BEGIN", "BETWEEN", "BREAK", "BROWSE", "BULK", "BY", "CASCADE", "CHECK", "CHECKPOINT", "CLOSE", "CLUSTERED", "COALESCE", "COLLATE", "COLUMN", "COMMIT", "COMPUTE", "CONSTRAINT", "CONTAINS", "CONTAINSTABLE", "CONTINUE", "CONVERT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURSOR", "DATABASE", "DBCC", "DEALLOCATE", "DECLARE", "DEFAULT", "DELETE", "DENY", "DESC", "DISK", "DISTINCT", "DISTRIBUTED", "DOUBLE", "DROP", "DUMP", "ERRLVL", "ESCAPE", "EXEC", "EXECUTE", "EXISTS", "EXIT", "EXTERNAL", "FETCH", "FILE", "FILLFACTOR", "FOR", "FOREIGN", "FREETEXT", "FREETEXTTABLE", "FROM", "FULL", "FUNCTION", "GOTO", "GRANT", "GROUP", "HAVING", "HOLDLOCK", "IDENTITY", "IDENTITYCOL", "IDENTITY_INSERT", "IF", "IN", "INDEX", "INNER", "INSERT", "INTERSECT", "INTO", "IS", "JOIN", "KEY", "KILL", "LEFT", "LIKE", "LINENO", "LOAD", "MERGE", "NATIONAL", "NOCHECK", "NONCLUSTERED", "NOT", "NULL", "NULLIF", "OF", "OFF", "OFFSETS", "ON", "OPEN", "OPENDATASOURCE", "OPENQUERY", "OPENROWSET", "OPENXML", "OPTION", "OR", "ORDER", "OUTER", "OVER", "PERCENT", "PIVOT", "PLAN", "PRECISION", "PRIMARY", "PRINT", "PROC", "PROCEDURE", "PUBLIC", "RAISERROR", "READ", "READTEXT", "RECONFIGURE", "REFERENCES", "REPLICATION", "RESTORE", "RESTRICT", "RETURN", "REVERT", "REVOKE", "RIGHT", "ROLLBACK", "ROWCOUNT", "ROWGUIDCOL", "RULE", "SAVE", "SCHEMA", "SECURITYAUDIT", "SELECT", "SEMANTICKEYPHRASETABLE", "SEMANTICSIMILARITYDETAILSTABLE", "SEMANTICSIMILARITYTABLE", "SESSION_USER", "SET", "SETUSER", "SHUTDOWN", "SOME", "STATISTICS", "SYSTEM_USER", "TABLE", "TABLESAMPLE", "TEXTSIZE", "THEN", "TO", "TOP", "TRAN", "TRANSACTION", "TRIGGER", "TRUNCATE", "TRY_CONVERT", "TSEQUAL", "UNION", "UNIQUE", "UNPIVOT", "UPDATE", "UPDATETEXT", "USE", "USER", "VALUES", "VARYING", "VIEW", "WAITFOR", "WHERE", "WHILE", "WITH", "WITHIN GROUP", "WRITETEXT"],
  odbc: ["ABSOLUTE", "ACTION", "ADA", "ADD", "ALL", "ALLOCATE", "ALTER", "AND", "ANY", "ARE", "AS", "ASC", "ASSERTION", "AT", "AUTHORIZATION", "AVG", "BEGIN", "BETWEEN", "BIT", "BIT_LENGTH", "BOTH", "BY", "CASCADE", "CASCADED", "CAST", "CATALOG", "CHAR", "CHARACTER", "CHARACTER_LENGTH", "CHAR_LENGTH", "CHECK", "CLOSE", "COALESCE", "COLLATE", "COLLATION", "COLUMN", "COMMIT", "CONNECT", "CONNECTION", "CONSTRAINT", "CONSTRAINTS", "CONTINUE", "CONVERT", "CORRESPONDING", "COUNT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURSOR", "DATE", "DAY", "DEALLOCATE", "DEC", "DECIMAL", "DECLARE", "DEFAULT", "DEFERRABLE", "DEFERRED", "DELETE", "DESC", "DESCRIBE", "DESCRIPTOR", "DIAGNOSTICS", "DISCONNECT", "DISTINCT", "DOMAIN", "DOUBLE", "DROP", "END-EXEC", "ESCAPE", "EXCEPTION", "EXEC", "EXECUTE", "EXISTS", "EXTERNAL", "EXTRACT", "FALSE", "FETCH", "FIRST", "FLOAT", "FOR", "FOREIGN", "FORTRAN", "FOUND", "FROM", "FULL", "GET", "GLOBAL", "GO", "GOTO", "GRANT", "GROUP", "HAVING", "HOUR", "IDENTITY", "IMMEDIATE", "IN", "INCLUDE", "INDEX", "INDICATOR", "INITIALLY", "INNER", "INPUT", "INSENSITIVE", "INSERT", "INT", "INTEGER", "INTERSECT", "INTERVAL", "INTO", "IS", "ISOLATION", "JOIN", "KEY", "LANGUAGE", "LAST", "LEADING", "LEFT", "LEVEL", "LIKE", "LOCAL", "LOWER", "MATCH", "MAX", "MIN", "MINUTE", "MODULE", "MONTH", "NAMES", "NATIONAL", "NATURAL", "NCHAR", "NEXT", "NO", "NONE", "NOT", "NULL", "NULLIF", "NUMERIC", "OCTET_LENGTH", "OF", "ONLY", "OPEN", "OPTION", "OR", "ORDER", "OUTER", "OUTPUT", "OVERLAPS", "PAD", "PARTIAL", "PASCAL", "POSITION", "PRECISION", "PREPARE", "PRESERVE", "PRIMARY", "PRIOR", "PRIVILEGES", "PROCEDURE", "PUBLIC", "READ", "REAL", "REFERENCES", "RELATIVE", "RESTRICT", "REVOKE", "RIGHT", "ROLLBACK", "ROWS", "SCHEMA", "SCROLL", "SECOND", "SECTION", "SELECT", "SESSION", "SESSION_USER", "SET", "SIZE", "SMALLINT", "SOME", "SPACE", "SQL", "SQLCA", "SQLCODE", "SQLERROR", "SQLSTATE", "SQLWARNING", "SUBSTRING", "SUM", "SYSTEM_USER", "TABLE", "TEMPORARY", "TIME", "TIMESTAMP", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO", "TRAILING", "TRANSACTION", "TRANSLATE", "TRANSLATION", "TRIM", "TRUE", "UNION", "UNIQUE", "UNKNOWN", "UPDATE", "UPPER", "USAGE", "USER", "VALUE", "VALUES", "VARCHAR", "VARYING", "VIEW", "WHENEVER", "WHERE", "WITH", "WORK", "WRITE", "YEAR", "ZONE"]
}), Yx = pe(["SELECT [ALL | DISTINCT]"]), Vx = pe([
  // queries
  "WITH",
  "INTO",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT [INTO]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE [INTO]",
  "WHEN [NOT] MATCHED [BY TARGET | BY SOURCE] [THEN]",
  "UPDATE SET",
  // Data definition
  "CREATE [OR ALTER] [MATERIALIZED] VIEW",
  "CREATE TABLE",
  "CREATE [OR ALTER] {PROC | PROCEDURE}"
]), km = pe([
  // - update:
  "UPDATE",
  "WHERE CURRENT OF",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD",
  "DROP COLUMN [IF EXISTS]",
  "ALTER COLUMN",
  // - truncate:
  "TRUNCATE TABLE",
  // https://docs.microsoft.com/en-us/sql/t-sql/statements/statements?view=sql-server-ver15
  "ADD SENSITIVITY CLASSIFICATION",
  "ADD SIGNATURE",
  "AGGREGATE",
  "ANSI_DEFAULTS",
  "ANSI_NULLS",
  "ANSI_NULL_DFLT_OFF",
  "ANSI_NULL_DFLT_ON",
  "ANSI_PADDING",
  "ANSI_WARNINGS",
  "APPLICATION ROLE",
  "ARITHABORT",
  "ARITHIGNORE",
  "ASSEMBLY",
  "ASYMMETRIC KEY",
  "AUTHORIZATION",
  "AVAILABILITY GROUP",
  "BACKUP",
  "BACKUP CERTIFICATE",
  "BACKUP MASTER KEY",
  "BACKUP SERVICE MASTER KEY",
  "BEGIN CONVERSATION TIMER",
  "BEGIN DIALOG CONVERSATION",
  "BROKER PRIORITY",
  "BULK INSERT",
  "CERTIFICATE",
  "CLOSE MASTER KEY",
  "CLOSE SYMMETRIC KEY",
  "COLLATE",
  "COLUMN ENCRYPTION KEY",
  "COLUMN MASTER KEY",
  "COLUMNSTORE INDEX",
  "CONCAT_NULL_YIELDS_NULL",
  "CONTEXT_INFO",
  "CONTRACT",
  "CREDENTIAL",
  "CRYPTOGRAPHIC PROVIDER",
  "CURSOR_CLOSE_ON_COMMIT",
  "DATABASE",
  "DATABASE AUDIT SPECIFICATION",
  "DATABASE ENCRYPTION KEY",
  "DATABASE HADR",
  "DATABASE SCOPED CONFIGURATION",
  "DATABASE SCOPED CREDENTIAL",
  "DATABASE SET",
  "DATEFIRST",
  "DATEFORMAT",
  "DEADLOCK_PRIORITY",
  "DENY",
  "DENY XML",
  "DISABLE TRIGGER",
  "ENABLE TRIGGER",
  "END CONVERSATION",
  "ENDPOINT",
  "EVENT NOTIFICATION",
  "EVENT SESSION",
  "EXECUTE AS",
  "EXTERNAL DATA SOURCE",
  "EXTERNAL FILE FORMAT",
  "EXTERNAL LANGUAGE",
  "EXTERNAL LIBRARY",
  "EXTERNAL RESOURCE POOL",
  "EXTERNAL TABLE",
  "FIPS_FLAGGER",
  "FMTONLY",
  "FORCEPLAN",
  "FULLTEXT CATALOG",
  "FULLTEXT INDEX",
  "FULLTEXT STOPLIST",
  "FUNCTION",
  "GET CONVERSATION GROUP",
  "GET_TRANSMISSION_STATUS",
  "GRANT",
  "GRANT XML",
  "IDENTITY_INSERT",
  "IMPLICIT_TRANSACTIONS",
  "INDEX",
  "LANGUAGE",
  "LOCK_TIMEOUT",
  "LOGIN",
  "MASTER KEY",
  "MESSAGE TYPE",
  "MOVE CONVERSATION",
  "NOCOUNT",
  "NOEXEC",
  "NUMERIC_ROUNDABORT",
  "OFFSETS",
  "OPEN MASTER KEY",
  "OPEN SYMMETRIC KEY",
  "PARSEONLY",
  "PARTITION FUNCTION",
  "PARTITION SCHEME",
  "PROCEDURE",
  "QUERY_GOVERNOR_COST_LIMIT",
  "QUEUE",
  "QUOTED_IDENTIFIER",
  "RECEIVE",
  "REMOTE SERVICE BINDING",
  "REMOTE_PROC_TRANSACTIONS",
  "RESOURCE GOVERNOR",
  "RESOURCE POOL",
  "RESTORE",
  "RESTORE FILELISTONLY",
  "RESTORE HEADERONLY",
  "RESTORE LABELONLY",
  "RESTORE MASTER KEY",
  "RESTORE REWINDONLY",
  "RESTORE SERVICE MASTER KEY",
  "RESTORE VERIFYONLY",
  "REVERT",
  "REVOKE",
  "REVOKE XML",
  "ROLE",
  "ROUTE",
  "ROWCOUNT",
  "RULE",
  "SCHEMA",
  "SEARCH PROPERTY LIST",
  "SECURITY POLICY",
  "SELECTIVE XML INDEX",
  "SEND",
  "SENSITIVITY CLASSIFICATION",
  "SEQUENCE",
  "SERVER AUDIT",
  "SERVER AUDIT SPECIFICATION",
  "SERVER CONFIGURATION",
  "SERVER ROLE",
  "SERVICE",
  "SERVICE MASTER KEY",
  "SETUSER",
  "SHOWPLAN_ALL",
  "SHOWPLAN_TEXT",
  "SHOWPLAN_XML",
  "SIGNATURE",
  "SPATIAL INDEX",
  "STATISTICS",
  "STATISTICS IO",
  "STATISTICS PROFILE",
  "STATISTICS TIME",
  "STATISTICS XML",
  "SYMMETRIC KEY",
  "SYNONYM",
  "TABLE",
  "TABLE IDENTITY",
  "TEXTSIZE",
  "TRANSACTION ISOLATION LEVEL",
  "TRIGGER",
  "TYPE",
  "UPDATE STATISTICS",
  "USER",
  "WORKLOAD GROUP",
  "XACT_ABORT",
  "XML INDEX",
  "XML SCHEMA COLLECTION"
]), Wx = pe(["UNION [ALL]", "EXCEPT", "INTERSECT"]), Xx = pe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  // non-standard joins
  "{CROSS | OUTER} APPLY"
]), kx = pe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "{ROWS | RANGE} BETWEEN"]), Kx = {
  tokenizerOptions: {
    reservedSelect: Yx,
    reservedClauses: [...Vx, ...km],
    reservedSetOperations: Wx,
    reservedJoins: Xx,
    reservedPhrases: kx,
    reservedKeywords: wx,
    reservedFunctionNames: Fx,
    nestedBlockComments: !0,
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["N"]
    }],
    identTypes: ['""-qq', "[]"],
    identChars: {
      first: "#@",
      rest: "#@$"
    },
    paramTypes: {
      named: ["@"],
      quoted: ["@"]
    },
    operators: ["%", "&", "|", "^", "~", "!<", "!>", "+=", "-=", "*=", "/=", "%=", "|=", "&=", "^=", "::"]
    // TODO: Support for money constants
  },
  formatOptions: {
    alwaysDenseOperators: ["::"],
    onelineClauses: km
  }
}, jx = en({
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/restricted-keywords/list-of-restricted-keywords.html
  all: ["ABORT", "ABSOLUTE", "ACCESS", "ACCESSIBLE", "ACCOUNT", "ACTION", "ACTIVE", "ADD", "ADMIN", "AFTER", "AGAINST", "AGGREGATE", "AGGREGATES", "AGGREGATOR", "AGGREGATOR_ID", "AGGREGATOR_PLAN_HASH", "AGGREGATORS", "ALGORITHM", "ALL", "ALSO", "ALTER", "ALWAYS", "ANALYZE", "AND", "ANY", "ARGHISTORY", "ARRANGE", "ARRANGEMENT", "ARRAY", "AS", "ASC", "ASCII", "ASENSITIVE", "ASM", "ASSERTION", "ASSIGNMENT", "AST", "ASYMMETRIC", "ASYNC", "AT", "ATTACH", "ATTRIBUTE", "AUTHORIZATION", "AUTO", "AUTO_INCREMENT", "AUTO_REPROVISION", "AUTOSTATS", "AUTOSTATS_CARDINALITY_MODE", "AUTOSTATS_ENABLED", "AUTOSTATS_HISTOGRAM_MODE", "AUTOSTATS_SAMPLING", "AVAILABILITY", "AVG", "AVG_ROW_LENGTH", "AVRO", "AZURE", "BACKGROUND", "_BACKGROUND_THREADS_FOR_CLEANUP", "BACKUP", "BACKUP_HISTORY", "BACKUP_ID", "BACKWARD", "BATCH", "BATCHES", "BATCH_INTERVAL", "_BATCH_SIZE_LIMIT", "BEFORE", "BEGIN", "BETWEEN", "BIGINT", "BINARY", "_BINARY", "BIT", "BLOB", "BOOL", "BOOLEAN", "BOOTSTRAP", "BOTH", "_BT", "BTREE", "BUCKET_COUNT", "BUCKETS", "BY", "BYTE", "BYTE_LENGTH", "CACHE", "CALL", "CALL_FOR_PIPELINE", "CALLED", "CAPTURE", "CASCADE", "CASCADED", "CASE", "CATALOG", "CHAIN", "CHANGE", "CHAR", "CHARACTER", "CHARACTERISTICS", "CHARSET", "CHECK", "CHECKPOINT", "_CHECK_CAN_CONNECT", "_CHECK_CONSISTENCY", "CHECKSUM", "_CHECKSUM", "CLASS", "CLEAR", "CLIENT", "CLIENT_FOUND_ROWS", "CLOSE", "CLUSTER", "CLUSTERED", "CNF", "COALESCE", "COLLATE", "COLLATION", "COLUMN", "COLUMNAR", "COLUMNS", "COLUMNSTORE", "COLUMNSTORE_SEGMENT_ROWS", "COMMENT", "COMMENTS", "COMMIT", "COMMITTED", "_COMMIT_LOG_TAIL", "COMPACT", "COMPILE", "COMPRESSED", "COMPRESSION", "CONCURRENT", "CONCURRENTLY", "CONDITION", "CONFIGURATION", "CONNECTION", "CONNECTIONS", "CONFIG", "CONSTRAINT", "CONTAINS", "CONTENT", "CONTINUE", "_CONTINUE_REPLAY", "CONVERSION", "CONVERT", "COPY", "_CORE", "COST", "CREATE", "CREDENTIALS", "CROSS", "CUBE", "CSV", "CUME_DIST", "CURRENT", "CURRENT_CATALOG", "CURRENT_DATE", "CURRENT_SCHEMA", "CURRENT_SECURITY_GROUPS", "CURRENT_SECURITY_ROLES", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURSOR", "CYCLE", "DATA", "DATABASE", "DATABASES", "DATE", "DATETIME", "DAY", "DAY_HOUR", "DAY_MICROSECOND", "DAY_MINUTE", "DAY_SECOND", "DEALLOCATE", "DEC", "DECIMAL", "DECLARE", "DEFAULT", "DEFAULTS", "DEFERRABLE", "DEFERRED", "DEFINED", "DEFINER", "DELAYED", "DELAY_KEY_WRITE", "DELETE", "DELIMITER", "DELIMITERS", "DENSE_RANK", "DESC", "DESCRIBE", "DETACH", "DETERMINISTIC", "DICTIONARY", "DIFFERENTIAL", "DIRECTORY", "DISABLE", "DISCARD", "_DISCONNECT", "DISK", "DISTINCT", "DISTINCTROW", "DISTRIBUTED_JOINS", "DIV", "DO", "DOCUMENT", "DOMAIN", "DOUBLE", "DROP", "_DROP_PROFILE", "DUAL", "DUMP", "DUPLICATE", "DURABILITY", "DYNAMIC", "EARLIEST", "EACH", "ECHO", "ELECTION", "ELSE", "ELSEIF", "ENABLE", "ENCLOSED", "ENCODING", "ENCRYPTED", "END", "ENGINE", "ENGINES", "ENUM", "ERRORS", "ESCAPE", "ESCAPED", "ESTIMATE", "EVENT", "EVENTS", "EXCEPT", "EXCLUDE", "EXCLUDING", "EXCLUSIVE", "EXECUTE", "EXISTS", "EXIT", "EXPLAIN", "EXTENDED", "EXTENSION", "EXTERNAL", "EXTERNAL_HOST", "EXTERNAL_PORT", "EXTRACTOR", "EXTRACTORS", "EXTRA_JOIN", "_FAILOVER", "FAILED_LOGIN_ATTEMPTS", "FAILURE", "FALSE", "FAMILY", "FAULT", "FETCH", "FIELDS", "FILE", "FILES", "FILL", "FIX_ALTER", "FIXED", "FLOAT", "FLOAT4", "FLOAT8", "FLUSH", "FOLLOWING", "FOR", "FORCE", "FORCE_COMPILED_MODE", "FORCE_INTERPRETER_MODE", "FOREGROUND", "FOREIGN", "FORMAT", "FORWARD", "FREEZE", "FROM", "FS", "_FSYNC", "FULL", "FULLTEXT", "FUNCTION", "FUNCTIONS", "GC", "GCS", "GET_FORMAT", "_GC", "_GCX", "GENERATE", "GEOGRAPHY", "GEOGRAPHYPOINT", "GEOMETRY", "GEOMETRYPOINT", "GLOBAL", "_GLOBAL_VERSION_TIMESTAMP", "GRANT", "GRANTED", "GRANTS", "GROUP", "GROUPING", "GROUPS", "GZIP", "HANDLE", "HANDLER", "HARD_CPU_LIMIT_PERCENTAGE", "HASH", "HAS_TEMP_TABLES", "HAVING", "HDFS", "HEADER", "HEARTBEAT_NO_LOGGING", "HIGH_PRIORITY", "HISTOGRAM", "HOLD", "HOLDING", "HOST", "HOSTS", "HOUR", "HOUR_MICROSECOND", "HOUR_MINUTE", "HOUR_SECOND", "IDENTIFIED", "IDENTITY", "IF", "IGNORE", "ILIKE", "IMMEDIATE", "IMMUTABLE", "IMPLICIT", "IMPORT", "IN", "INCLUDING", "INCREMENT", "INCREMENTAL", "INDEX", "INDEXES", "INFILE", "INHERIT", "INHERITS", "_INIT_PROFILE", "INIT", "INITIALIZE", "INITIALLY", "INJECT", "INLINE", "INNER", "INOUT", "INPUT", "INSENSITIVE", "INSERT", "INSERT_METHOD", "INSTANCE", "INSTEAD", "IN", "INT", "INT1", "INT2", "INT3", "INT4", "INT8", "INTEGER", "_INTERNAL_DYNAMIC_TYPECAST", "INTERPRETER_MODE", "INTERSECT", "INTERVAL", "INTO", "INVOKER", "ISOLATION", "ITERATE", "JOIN", "JSON", "KAFKA", "KEY", "KEY_BLOCK_SIZE", "KEYS", "KILL", "KILLALL", "LABEL", "LAG", "LANGUAGE", "LARGE", "LAST", "LAST_VALUE", "LATERAL", "LATEST", "LC_COLLATE", "LC_CTYPE", "LEAD", "LEADING", "LEAF", "LEAKPROOF", "LEAVE", "LEAVES", "LEFT", "LEVEL", "LICENSE", "LIKE", "LIMIT", "LINES", "LISTEN", "LLVM", "LOADDATA_WHERE", "LOAD", "LOCAL", "LOCALTIME", "LOCALTIMESTAMP", "LOCATION", "LOCK", "LONG", "LONGBLOB", "LONGTEXT", "LOOP", "LOW_PRIORITY", "_LS", "LZ4", "MANAGEMENT", "_MANAGEMENT_THREAD", "MAPPING", "MASTER", "MATCH", "MATERIALIZED", "MAXVALUE", "MAX_CONCURRENCY", "MAX_ERRORS", "MAX_PARTITIONS_PER_BATCH", "MAX_QUEUE_DEPTH", "MAX_RETRIES_PER_BATCH_PARTITION", "MAX_ROWS", "MBC", "MPL", "MEDIUMBLOB", "MEDIUMINT", "MEDIUMTEXT", "MEMBER", "MEMORY", "MEMORY_PERCENTAGE", "_MEMSQL_TABLE_ID_LOOKUP", "MEMSQL", "MEMSQL_DESERIALIZE", "MEMSQL_IMITATING_KAFKA", "MEMSQL_SERIALIZE", "MERGE", "METADATA", "MICROSECOND", "MIDDLEINT", "MIN_ROWS", "MINUS", "MINUTE_MICROSECOND", "MINUTE_SECOND", "MINVALUE", "MOD", "MODE", "MODEL", "MODIFIES", "MODIFY", "MONTH", "MOVE", "MPL", "NAMES", "NAMED", "NAMESPACE", "NATIONAL", "NATURAL", "NCHAR", "NEXT", "NO", "NODE", "NONE", "NO_QUERY_REWRITE", "NOPARAM", "NOT", "NOTHING", "NOTIFY", "NOWAIT", "NO_WRITE_TO_BINLOG", "NO_QUERY_REWRITE", "NORELY", "NTH_VALUE", "NTILE", "NULL", "NULLCOLS", "NULLS", "NUMERIC", "NVARCHAR", "OBJECT", "OF", "OFF", "OFFLINE", "OFFSET", "OFFSETS", "OIDS", "ON", "ONLINE", "ONLY", "OPEN", "OPERATOR", "OPTIMIZATION", "OPTIMIZE", "OPTIMIZER", "OPTIMIZER_STATE", "OPTION", "OPTIONS", "OPTIONALLY", "OR", "ORDER", "ORDERED_SERIALIZE", "ORPHAN", "OUT", "OUT_OF_ORDER", "OUTER", "OUTFILE", "OVER", "OVERLAPS", "OVERLAY", "OWNED", "OWNER", "PACK_KEYS", "PAIRED", "PARSER", "PARQUET", "PARTIAL", "PARTITION", "PARTITION_ID", "PARTITIONING", "PARTITIONS", "PASSING", "PASSWORD", "PASSWORD_LOCK_TIME", "PAUSE", "_PAUSE_REPLAY", "PERIODIC", "PERSISTED", "PIPELINE", "PIPELINES", "PLACING", "PLAN", "PLANS", "PLANCACHE", "PLUGINS", "POOL", "POOLS", "PORT", "PRECEDING", "PRECISION", "PREPARE", "PRESERVE", "PRIMARY", "PRIOR", "PRIVILEGES", "PROCEDURAL", "PROCEDURE", "PROCEDURES", "PROCESS", "PROCESSLIST", "PROFILE", "PROFILES", "PROGRAM", "PROMOTE", "PROXY", "PURGE", "QUARTER", "QUERIES", "QUERY", "QUERY_TIMEOUT", "QUEUE", "RANGE", "RANK", "READ", "_READ", "READS", "REAL", "REASSIGN", "REBALANCE", "RECHECK", "RECORD", "RECURSIVE", "REDUNDANCY", "REDUNDANT", "REF", "REFERENCE", "REFERENCES", "REFRESH", "REGEXP", "REINDEX", "RELATIVE", "RELEASE", "RELOAD", "RELY", "REMOTE", "REMOVE", "RENAME", "REPAIR", "_REPAIR_TABLE", "REPEAT", "REPEATABLE", "_REPL", "_REPROVISIONING", "REPLACE", "REPLICA", "REPLICATE", "REPLICATING", "REPLICATION", "REQUIRE", "RESOURCE", "RESOURCE_POOL", "RESET", "RESTART", "RESTORE", "RESTRICT", "RESULT", "_RESURRECT", "RETRY", "RETURN", "RETURNING", "RETURNS", "REVERSE", "RG_POOL", "REVOKE", "RIGHT", "RIGHT_ANTI_JOIN", "RIGHT_SEMI_JOIN", "RIGHT_STRAIGHT_JOIN", "RLIKE", "ROLES", "ROLLBACK", "ROLLUP", "ROUTINE", "ROW", "ROW_COUNT", "ROW_FORMAT", "ROW_NUMBER", "ROWS", "ROWSTORE", "RULE", "_RPC", "RUNNING", "S3", "SAFE", "SAVE", "SAVEPOINT", "SCALAR", "SCHEMA", "SCHEMAS", "SCHEMA_BINDING", "SCROLL", "SEARCH", "SECOND", "SECOND_MICROSECOND", "SECURITY", "SELECT", "SEMI_JOIN", "_SEND_THREADS", "SENSITIVE", "SEPARATOR", "SEQUENCE", "SEQUENCES", "SERIAL", "SERIALIZABLE", "SERIES", "SERVICE_USER", "SERVER", "SESSION", "SESSION_USER", "SET", "SETOF", "SECURITY_LISTS_INTERSECT", "SHA", "SHARD", "SHARDED", "SHARDED_ID", "SHARE", "SHOW", "SHUTDOWN", "SIGNAL", "SIGNED", "SIMILAR", "SIMPLE", "SITE", "SKIP", "SKIPPED_BATCHES", "__SLEEP", "SMALLINT", "SNAPSHOT", "_SNAPSHOT", "_SNAPSHOTS", "SOFT_CPU_LIMIT_PERCENTAGE", "SOME", "SONAME", "SPARSE", "SPATIAL", "SPATIAL_CHECK_INDEX", "SPECIFIC", "SQL", "SQL_BIG_RESULT", "SQL_BUFFER_RESULT", "SQL_CACHE", "SQL_CALC_FOUND_ROWS", "SQLEXCEPTION", "SQL_MODE", "SQL_NO_CACHE", "SQL_NO_LOGGING", "SQL_SMALL_RESULT", "SQLSTATE", "SQLWARNING", "STDIN", "STDOUT", "STOP", "STORAGE", "STRAIGHT_JOIN", "STRICT", "STRING", "STRIP", "SUCCESS", "SUPER", "SYMMETRIC", "SYNC_SNAPSHOT", "SYNC", "_SYNC", "_SYNC2", "_SYNC_PARTITIONS", "_SYNC_SNAPSHOT", "SYNCHRONIZE", "SYSID", "SYSTEM", "TABLE", "TABLE_CHECKSUM", "TABLES", "TABLESPACE", "TAGS", "TARGET_SIZE", "TASK", "TEMP", "TEMPLATE", "TEMPORARY", "TEMPTABLE", "_TERM_BUMP", "TERMINATE", "TERMINATED", "TEXT", "THEN", "TIME", "TIMEOUT", "TIMESTAMP", "TIMESTAMPADD", "TIMESTAMPDIFF", "TIMEZONE", "TINYBLOB", "TINYINT", "TINYTEXT", "TO", "TRACELOGS", "TRADITIONAL", "TRAILING", "TRANSFORM", "TRANSACTION", "_TRANSACTIONS_EXPERIMENTAL", "TREAT", "TRIGGER", "TRIGGERS", "TRUE", "TRUNC", "TRUNCATE", "TRUSTED", "TWO_PHASE", "_TWOPCID", "TYPE", "TYPES", "UNBOUNDED", "UNCOMMITTED", "UNDEFINED", "UNDO", "UNENCRYPTED", "UNENFORCED", "UNHOLD", "UNICODE", "UNION", "UNIQUE", "_UNITTEST", "UNKNOWN", "UNLISTEN", "_UNLOAD", "UNLOCK", "UNLOGGED", "UNPIVOT", "UNSIGNED", "UNTIL", "UPDATE", "UPGRADE", "USAGE", "USE", "USER", "USERS", "USING", "UTC_DATE", "UTC_TIME", "UTC_TIMESTAMP", "_UTF8", "VACUUM", "VALID", "VALIDATE", "VALIDATOR", "VALUE", "VALUES", "VARBINARY", "VARCHAR", "VARCHARACTER", "VARIABLES", "VARIADIC", "VARYING", "VERBOSE", "VIEW", "VOID", "VOLATILE", "VOTING", "WAIT", "_WAKE", "WARNINGS", "WEEK", "WHEN", "WHERE", "WHILE", "WHITESPACE", "WINDOW", "WITH", "WITHOUT", "WITHIN", "_WM_HEARTBEAT", "WORK", "WORKLOAD", "WRAPPER", "WRITE", "XACT_ID", "XOR", "YEAR", "YEAR_MONTH", "YES", "ZEROFILL", "ZONE"]
}), zx = en({
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/vector-functions/vector-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/window-functions/window-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/string-functions/string-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/conditional-functions/conditional-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/numeric-functions/numeric-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/geospatial-functions/geospatial-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/json-functions/json-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/information-functions/information-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/aggregate-functions/aggregate-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/time-series-functions/time-series-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/identifier-generation-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/date-and-time-functions/date-and-time-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/distinct-count-estimation-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/full-text-search-functions/full-text-search-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/regular-expression-functions.html
  all: [
    "ABS",
    "ACOS",
    "ADDDATE",
    "ADDTIME",
    "AES_DECRYPT",
    "AES_ENCRYPT",
    "ANY_VALUE",
    "APPROX_COUNT_DISTINCT",
    "APPROX_COUNT_DISTINCT_ACCUMULATE",
    "APPROX_COUNT_DISTINCT_COMBINE",
    "APPROX_COUNT_DISTINCT_ESTIMATE",
    "APPROX_GEOGRAPHY_INTERSECTS",
    "APPROX_PERCENTILE",
    "ASCII",
    "ASIN",
    "ATAN",
    "ATAN2",
    "AVG",
    "BIN",
    "BINARY",
    "BIT_AND",
    "BIT_COUNT",
    "BIT_OR",
    "BIT_XOR",
    "CAST",
    "CEIL",
    "CEILING",
    "CHAR",
    "CHARACTER_LENGTH",
    "CHAR_LENGTH",
    "CHARSET",
    "COALESCE",
    "COERCIBILITY",
    "COLLATION",
    "COLLECT",
    "CONCAT",
    "CONCAT_WS",
    "CONNECTION_ID",
    "CONV",
    "CONVERT",
    "CONVERT_TZ",
    "COS",
    "COT",
    "COUNT",
    "CUME_DIST",
    "CURDATE",
    "CURRENT_DATE",
    "CURRENT_ROLE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "CURTIME",
    "DATABASE",
    "DATE",
    "DATE_ADD",
    "DATEDIFF",
    "DATE_FORMAT",
    "DATE_SUB",
    "DATE_TRUNC",
    "DAY",
    "DAYNAME",
    "DAYOFMONTH",
    "DAYOFWEEK",
    "DAYOFYEAR",
    "DECODE",
    "DEFAULT",
    "DEGREES",
    "DENSE_RANK",
    "DIV",
    "DOT_PRODUCT",
    "ELT",
    "EUCLIDEAN_DISTANCE",
    "EXP",
    "EXTRACT",
    "FIELD",
    "FIRST",
    "FIRST_VALUE",
    "FLOOR",
    "FORMAT",
    "FOUND_ROWS",
    "FROM_BASE64",
    "FROM_DAYS",
    "FROM_UNIXTIME",
    "GEOGRAPHY_AREA",
    "GEOGRAPHY_CONTAINS",
    "GEOGRAPHY_DISTANCE",
    "GEOGRAPHY_INTERSECTS",
    "GEOGRAPHY_LATITUDE",
    "GEOGRAPHY_LENGTH",
    "GEOGRAPHY_LONGITUDE",
    "GEOGRAPHY_POINT",
    "GEOGRAPHY_WITHIN_DISTANCE",
    "GEOMETRY_AREA",
    "GEOMETRY_CONTAINS",
    "GEOMETRY_DISTANCE",
    "GEOMETRY_FILTER",
    "GEOMETRY_INTERSECTS",
    "GEOMETRY_LENGTH",
    "GEOMETRY_POINT",
    "GEOMETRY_WITHIN_DISTANCE",
    "GEOMETRY_X",
    "GEOMETRY_Y",
    "GREATEST",
    "GROUPING",
    "GROUP_CONCAT",
    "HEX",
    "HIGHLIGHT",
    "HOUR",
    "ICU_VERSION",
    "IF",
    "IFNULL",
    "INET_ATON",
    "INET_NTOA",
    "INET6_ATON",
    "INET6_NTOA",
    "INITCAP",
    "INSERT",
    "INSTR",
    "INTERVAL",
    "IS",
    "IS NULL",
    "JSON_AGG",
    "JSON_ARRAY_CONTAINS_DOUBLE",
    "JSON_ARRAY_CONTAINS_JSON",
    "JSON_ARRAY_CONTAINS_STRING",
    "JSON_ARRAY_PUSH_DOUBLE",
    "JSON_ARRAY_PUSH_JSON",
    "JSON_ARRAY_PUSH_STRING",
    "JSON_DELETE_KEY",
    "JSON_EXTRACT_DOUBLE",
    "JSON_EXTRACT_JSON",
    "JSON_EXTRACT_STRING",
    "JSON_EXTRACT_BIGINT",
    "JSON_GET_TYPE",
    "JSON_LENGTH",
    "JSON_SET_DOUBLE",
    "JSON_SET_JSON",
    "JSON_SET_STRING",
    "JSON_SPLICE_DOUBLE",
    "JSON_SPLICE_JSON",
    "JSON_SPLICE_STRING",
    "LAG",
    "LAST_DAY",
    "LAST_VALUE",
    "LCASE",
    "LEAD",
    "LEAST",
    "LEFT",
    "LENGTH",
    "LIKE",
    "LN",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG2",
    "LPAD",
    "LTRIM",
    "MATCH",
    "MAX",
    "MD5",
    "MEDIAN",
    "MICROSECOND",
    "MIN",
    "MINUTE",
    "MOD",
    "MONTH",
    "MONTHNAME",
    "MONTHS_BETWEEN",
    "NOT",
    "NOW",
    "NTH_VALUE",
    "NTILE",
    "NULLIF",
    "OCTET_LENGTH",
    "PERCENT_RANK",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "PI",
    "PIVOT",
    "POSITION",
    "POW",
    "POWER",
    "QUARTER",
    "QUOTE",
    "RADIANS",
    "RAND",
    "RANK",
    "REGEXP",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "RIGHT",
    "RLIKE",
    "ROUND",
    "ROW_COUNT",
    "ROW_NUMBER",
    "RPAD",
    "RTRIM",
    "SCALAR",
    "SCHEMA",
    "SEC_TO_TIME",
    "SHA1",
    "SHA2",
    "SIGMOID",
    "SIGN",
    "SIN",
    "SLEEP",
    "SPLIT",
    "SOUNDEX",
    "SOUNDS LIKE",
    "SOURCE_POS_WAIT",
    "SPACE",
    "SQRT",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STR_TO_DATE",
    "SUBDATE",
    "SUBSTR",
    "SUBSTRING",
    "SUBSTRING_INDEX",
    "SUM",
    "SYS_GUID",
    "TAN",
    "TIME",
    "TIMEDIFF",
    "TIME_BUCKET",
    "TIME_FORMAT",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TIME_TO_SEC",
    "TO_BASE64",
    "TO_CHAR",
    "TO_DAYS",
    "TO_JSON",
    "TO_NUMBER",
    "TO_SECONDS",
    "TO_TIMESTAMP",
    "TRIM",
    "TRUNC",
    "TRUNCATE",
    "UCASE",
    "UNHEX",
    "UNIX_TIMESTAMP",
    "UPDATEXML",
    "UPPER",
    "USER",
    "UTC_DATE",
    "UTC_TIME",
    "UTC_TIMESTAMP",
    "UUID",
    "VALUES",
    "VARIANCE",
    "VAR_POP",
    "VAR_SAMP",
    "VECTOR_SUB",
    "VERSION",
    "WEEK",
    "WEEKDAY",
    "WEEKOFYEAR",
    "YEAR",
    // Data types with parameters
    // https://docs.singlestore.com/managed-service/en/reference/sql-reference/data-types.html
    "BIT",
    "TINYINT",
    "SMALLINT",
    "MEDIUMINT",
    "INT",
    "INTEGER",
    "BIGINT",
    "DECIMAL",
    "DEC",
    "NUMERIC",
    "FIXED",
    "FLOAT",
    "DOUBLE",
    "DOUBLE PRECISION",
    "REAL",
    "DATETIME",
    "TIMESTAMP",
    "TIME",
    "YEAR",
    "CHAR",
    "NATIONAL CHAR",
    "VARCHAR",
    "NATIONAL VARCHAR",
    "BINARY",
    "VARBINARY",
    "BLOB",
    "TEXT",
    "ENUM"
  ]
}), Jx = pe(["SELECT [ALL | DISTINCT | DISTINCTROW]"]), Qx = pe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT [IGNORE] [INTO]",
  "VALUES",
  "REPLACE [INTO]",
  // - update:
  "SET",
  // Data definition
  "CREATE VIEW",
  "CREATE [ROWSTORE] [REFERENCE | TEMPORARY | GLOBAL TEMPORARY] TABLE [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [TEMPORARY] PROCEDURE [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [EXTERNAL] FUNCTION"
]), Km = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP [TEMPORARY] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER [ONLINE] TABLE",
  "ADD [COLUMN]",
  "ADD [UNIQUE] {INDEX | KEY}",
  "DROP [COLUMN]",
  "MODIFY [COLUMN]",
  "CHANGE",
  "RENAME [TO | AS]",
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference.html
  "ADD AGGREGATOR",
  "ADD LEAF",
  "AGGREGATOR SET AS MASTER",
  "ALTER DATABASE",
  "ALTER PIPELINE",
  "ALTER RESOURCE POOL",
  "ALTER USER",
  "ALTER VIEW",
  "ANALYZE TABLE",
  "ATTACH DATABASE",
  "ATTACH LEAF",
  "ATTACH LEAF ALL",
  "BACKUP DATABASE",
  "BINLOG",
  "BOOTSTRAP AGGREGATOR",
  "CACHE INDEX",
  "CALL",
  "CHANGE",
  "CHANGE MASTER TO",
  "CHANGE REPLICATION FILTER",
  "CHANGE REPLICATION SOURCE TO",
  "CHECK BLOB CHECKSUM",
  "CHECK TABLE",
  "CHECKSUM TABLE",
  "CLEAR ORPHAN DATABASES",
  "CLONE",
  "COMMIT",
  "CREATE DATABASE",
  "CREATE GROUP",
  "CREATE INDEX",
  "CREATE LINK",
  "CREATE MILESTONE",
  "CREATE PIPELINE",
  "CREATE RESOURCE POOL",
  "CREATE ROLE",
  "CREATE USER",
  "DEALLOCATE PREPARE",
  "DESCRIBE",
  "DETACH DATABASE",
  "DETACH PIPELINE",
  "DROP DATABASE",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP LINK",
  "DROP PIPELINE",
  "DROP PROCEDURE",
  "DROP RESOURCE POOL",
  "DROP ROLE",
  "DROP USER",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FLUSH",
  "FORCE",
  "GRANT",
  "HANDLER",
  "HELP",
  "KILL CONNECTION",
  "KILLALL QUERIES",
  "LOAD DATA",
  "LOAD INDEX INTO CACHE",
  "LOAD XML",
  "LOCK INSTANCE FOR BACKUP",
  "LOCK TABLES",
  "MASTER_POS_WAIT",
  "OPTIMIZE TABLE",
  "PREPARE",
  "PURGE BINARY LOGS",
  "REBALANCE PARTITIONS",
  "RELEASE SAVEPOINT",
  "REMOVE AGGREGATOR",
  "REMOVE LEAF",
  "REPAIR TABLE",
  "REPLACE",
  "REPLICATE DATABASE",
  "RESET",
  "RESET MASTER",
  "RESET PERSIST",
  "RESET REPLICA",
  "RESET SLAVE",
  "RESTART",
  "RESTORE DATABASE",
  "RESTORE REDUNDANCY",
  "REVOKE",
  "ROLLBACK",
  "ROLLBACK TO SAVEPOINT",
  "SAVEPOINT",
  "SET CHARACTER SET",
  "SET DEFAULT ROLE",
  "SET NAMES",
  "SET PASSWORD",
  "SET RESOURCE GROUP",
  "SET ROLE",
  "SET TRANSACTION",
  "SHOW",
  "SHOW CHARACTER SET",
  "SHOW COLLATION",
  "SHOW COLUMNS",
  "SHOW CREATE DATABASE",
  "SHOW CREATE FUNCTION",
  "SHOW CREATE PIPELINE",
  "SHOW CREATE PROCEDURE",
  "SHOW CREATE TABLE",
  "SHOW CREATE USER",
  "SHOW CREATE VIEW",
  "SHOW DATABASES",
  "SHOW ENGINE",
  "SHOW ENGINES",
  "SHOW ERRORS",
  "SHOW FUNCTION CODE",
  "SHOW FUNCTION STATUS",
  "SHOW GRANTS",
  "SHOW INDEX",
  "SHOW MASTER STATUS",
  "SHOW OPEN TABLES",
  "SHOW PLUGINS",
  "SHOW PRIVILEGES",
  "SHOW PROCEDURE CODE",
  "SHOW PROCEDURE STATUS",
  "SHOW PROCESSLIST",
  "SHOW PROFILE",
  "SHOW PROFILES",
  "SHOW RELAYLOG EVENTS",
  "SHOW REPLICA STATUS",
  "SHOW REPLICAS",
  "SHOW SLAVE",
  "SHOW SLAVE HOSTS",
  "SHOW STATUS",
  "SHOW TABLE STATUS",
  "SHOW TABLES",
  "SHOW VARIABLES",
  "SHOW WARNINGS",
  "SHUTDOWN",
  "SNAPSHOT DATABASE",
  "SOURCE_POS_WAIT",
  "START GROUP_REPLICATION",
  "START PIPELINE",
  "START REPLICA",
  "START SLAVE",
  "START TRANSACTION",
  "STOP GROUP_REPLICATION",
  "STOP PIPELINE",
  "STOP REPLICA",
  "STOP REPLICATING",
  "STOP SLAVE",
  "TEST PIPELINE",
  "UNLOCK INSTANCE",
  "UNLOCK TABLES",
  "USE",
  "XA",
  // flow control
  "ITERATE",
  "LEAVE",
  "LOOP",
  "REPEAT",
  "RETURN",
  "WHILE"
]), Zx = pe(["UNION [ALL | DISTINCT]", "EXCEPT", "INTERSECT", "MINUS"]), qx = pe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL {LEFT | RIGHT} [OUTER] JOIN",
  // non-standard joins
  "STRAIGHT_JOIN"
]), $x = pe(["ON DELETE", "ON UPDATE", "CHARACTER SET", "{ROWS | RANGE} BETWEEN"]), eb = {
  tokenizerOptions: {
    reservedSelect: Jx,
    reservedClauses: [...Qx, ...Km],
    reservedSetOperations: Zx,
    reservedJoins: qx,
    reservedPhrases: $x,
    reservedKeywords: jx,
    reservedFunctionNames: zx,
    // TODO: support _binary"some string" prefix
    stringTypes: ['""-qq-bs', "''-qq-bs", {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    identChars: {
      first: "$",
      rest: "$",
      allowFirstCharNumber: !0
    },
    variableTypes: [{
      regex: "@@?[A-Za-z0-9_$]+"
    }, {
      quote: "``",
      prefixes: ["@"],
      requirePrefix: !0
    }],
    lineCommentTypes: ["--", "#"],
    operators: [":=", "&", "|", "^", "~", "<<", ">>", "<=>", "&&", "||", "::", "::$", "::%", ":>", "!:>"],
    postProcess: tb
  },
  formatOptions: {
    alwaysDenseOperators: ["::", "::$", "::%"],
    onelineClauses: Km
  }
};
function tb(l) {
  return l.map((u, T) => {
    const N = l[T + 1] || PE;
    return su.SET(u) && N.text === "(" ? {
      ...u,
      type: Re.RESERVED_FUNCTION_NAME
    } : u;
  });
}
const nb = en({
  // https://docs.snowflake.com/en/sql-reference-functions.html
  //
  // https://docs.snowflake.com/en/sql-reference/functions-all.html
  // 1. run in console on this page: $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue)
  // 2. split all lines that contain ',' or '/' into multiple lines
  // 3. remove all '— Deprecated' parts from the strings
  // 4. delete all strings that end with '<object_type>', they are already covered in the list
  // 5. remove all strings that contain '[', they are operators not functions
  // 6. fix all values that contain '*'
  // 7. delete operatos ':', '::', '||'
  //
  // Steps 1-5 can be combined by the following script in the developer console:
  // $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue) // Step 1
  //   .map(x => x.split(x.includes(',') ? ',' : '/')).flat().map(x => x.trim()) // Step 2
  //   .map(x => x.replace('— Deprecated', '')) // Step 3
  //   .filter(x => !x.endsWith('<object_type>')) // Step 4
  //   .filter(x => !x.includes('[')) // Step 5
  all: ["ABS", "ACOS", "ACOSH", "ADD_MONTHS", "ALL_USER_NAMES", "ANY_VALUE", "APPROX_COUNT_DISTINCT", "APPROX_PERCENTILE", "APPROX_PERCENTILE_ACCUMULATE", "APPROX_PERCENTILE_COMBINE", "APPROX_PERCENTILE_ESTIMATE", "APPROX_TOP_K", "APPROX_TOP_K_ACCUMULATE", "APPROX_TOP_K_COMBINE", "APPROX_TOP_K_ESTIMATE", "APPROXIMATE_JACCARD_INDEX", "APPROXIMATE_SIMILARITY", "ARRAY_AGG", "ARRAY_APPEND", "ARRAY_CAT", "ARRAY_COMPACT", "ARRAY_CONSTRUCT", "ARRAY_CONSTRUCT_COMPACT", "ARRAY_CONTAINS", "ARRAY_INSERT", "ARRAY_INTERSECTION", "ARRAY_POSITION", "ARRAY_PREPEND", "ARRAY_SIZE", "ARRAY_SLICE", "ARRAY_TO_STRING", "ARRAY_UNION_AGG", "ARRAY_UNIQUE_AGG", "ARRAYS_OVERLAP", "AS_ARRAY", "AS_BINARY", "AS_BOOLEAN", "AS_CHAR", "AS_VARCHAR", "AS_DATE", "AS_DECIMAL", "AS_NUMBER", "AS_DOUBLE", "AS_REAL", "AS_INTEGER", "AS_OBJECT", "AS_TIME", "AS_TIMESTAMP_LTZ", "AS_TIMESTAMP_NTZ", "AS_TIMESTAMP_TZ", "ASCII", "ASIN", "ASINH", "ATAN", "ATAN2", "ATANH", "AUTO_REFRESH_REGISTRATION_HISTORY", "AUTOMATIC_CLUSTERING_HISTORY", "AVG", "BASE64_DECODE_BINARY", "BASE64_DECODE_STRING", "BASE64_ENCODE", "BIT_LENGTH", "BITAND", "BITAND_AGG", "BITMAP_BIT_POSITION", "BITMAP_BUCKET_NUMBER", "BITMAP_CONSTRUCT_AGG", "BITMAP_COUNT", "BITMAP_OR_AGG", "BITNOT", "BITOR", "BITOR_AGG", "BITSHIFTLEFT", "BITSHIFTRIGHT", "BITXOR", "BITXOR_AGG", "BOOLAND", "BOOLAND_AGG", "BOOLNOT", "BOOLOR", "BOOLOR_AGG", "BOOLXOR", "BOOLXOR_AGG", "BUILD_SCOPED_FILE_URL", "BUILD_STAGE_FILE_URL", "CASE", "CAST", "CBRT", "CEIL", "CHARINDEX", "CHECK_JSON", "CHECK_XML", "CHR", "CHAR", "COALESCE", "COLLATE", "COLLATION", "COMPLETE_TASK_GRAPHS", "COMPRESS", "CONCAT", "CONCAT_WS", "CONDITIONAL_CHANGE_EVENT", "CONDITIONAL_TRUE_EVENT", "CONTAINS", "CONVERT_TIMEZONE", "COPY_HISTORY", "CORR", "COS", "COSH", "COT", "COUNT", "COUNT_IF", "COVAR_POP", "COVAR_SAMP", "CUME_DIST", "CURRENT_ACCOUNT", "CURRENT_AVAILABLE_ROLES", "CURRENT_CLIENT", "CURRENT_DATABASE", "CURRENT_DATE", "CURRENT_IP_ADDRESS", "CURRENT_REGION", "CURRENT_ROLE", "CURRENT_SCHEMA", "CURRENT_SCHEMAS", "CURRENT_SECONDARY_ROLES", "CURRENT_SESSION", "CURRENT_STATEMENT", "CURRENT_TASK_GRAPHS", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_TRANSACTION", "CURRENT_USER", "CURRENT_VERSION", "CURRENT_WAREHOUSE", "DATA_TRANSFER_HISTORY", "DATABASE_REFRESH_HISTORY", "DATABASE_REFRESH_PROGRESS", "DATABASE_REFRESH_PROGRESS_BY_JOB", "DATABASE_STORAGE_USAGE_HISTORY", "DATE_FROM_PARTS", "DATE_PART", "DATE_TRUNC", "DATEADD", "DATEDIFF", "DAYNAME", "DECODE", "DECOMPRESS_BINARY", "DECOMPRESS_STRING", "DECRYPT", "DECRYPT_RAW", "DEGREES", "DENSE_RANK", "DIV0", "EDITDISTANCE", "ENCRYPT", "ENCRYPT_RAW", "ENDSWITH", "EQUAL_NULL", "EXP", "EXPLAIN_JSON", "EXTERNAL_FUNCTIONS_HISTORY", "EXTERNAL_TABLE_FILES", "EXTERNAL_TABLE_FILE_REGISTRATION_HISTORY", "EXTRACT", "EXTRACT_SEMANTIC_CATEGORIES", "FACTORIAL", "FIRST_VALUE", "FLATTEN", "FLOOR", "GENERATE_COLUMN_DESCRIPTION", "GENERATOR", "GET", "GET_ABSOLUTE_PATH", "GET_DDL", "GET_IGNORE_CASE", "GET_OBJECT_REFERENCES", "GET_PATH", "GET_PRESIGNED_URL", "GET_RELATIVE_PATH", "GET_STAGE_LOCATION", "GETBIT", "GREATEST", "GROUPING", "GROUPING_ID", "HASH", "HASH_AGG", "HAVERSINE", "HEX_DECODE_BINARY", "HEX_DECODE_STRING", "HEX_ENCODE", "HLL", "HLL_ACCUMULATE", "HLL_COMBINE", "HLL_ESTIMATE", "HLL_EXPORT", "HLL_IMPORT", "HOUR", "MINUTE", "SECOND", "IFF", "IFNULL", "ILIKE", "ILIKE ANY", "INFER_SCHEMA", "INITCAP", "INSERT", "INVOKER_ROLE", "INVOKER_SHARE", "IS_ARRAY", "IS_BINARY", "IS_BOOLEAN", "IS_CHAR", "IS_VARCHAR", "IS_DATE", "IS_DATE_VALUE", "IS_DECIMAL", "IS_DOUBLE", "IS_REAL", "IS_GRANTED_TO_INVOKER_ROLE", "IS_INTEGER", "IS_NULL_VALUE", "IS_OBJECT", "IS_ROLE_IN_SESSION", "IS_TIME", "IS_TIMESTAMP_LTZ", "IS_TIMESTAMP_NTZ", "IS_TIMESTAMP_TZ", "JAROWINKLER_SIMILARITY", "JSON_EXTRACT_PATH_TEXT", "KURTOSIS", "LAG", "LAST_DAY", "LAST_QUERY_ID", "LAST_TRANSACTION", "LAST_VALUE", "LEAD", "LEAST", "LEFT", "LENGTH", "LEN", "LIKE", "LIKE ALL", "LIKE ANY", "LISTAGG", "LN", "LOCALTIME", "LOCALTIMESTAMP", "LOG", "LOGIN_HISTORY", "LOGIN_HISTORY_BY_USER", "LOWER", "LPAD", "LTRIM", "MATERIALIZED_VIEW_REFRESH_HISTORY", "MD5", "MD5_HEX", "MD5_BINARY", "MD5_NUMBER — Obsoleted", "MD5_NUMBER_LOWER64", "MD5_NUMBER_UPPER64", "MEDIAN", "MIN", "MAX", "MINHASH", "MINHASH_COMBINE", "MOD", "MODE", "MONTHNAME", "MONTHS_BETWEEN", "NEXT_DAY", "NORMAL", "NTH_VALUE", "NTILE", "NULLIF", "NULLIFZERO", "NVL", "NVL2", "OBJECT_AGG", "OBJECT_CONSTRUCT", "OBJECT_CONSTRUCT_KEEP_NULL", "OBJECT_DELETE", "OBJECT_INSERT", "OBJECT_KEYS", "OBJECT_PICK", "OCTET_LENGTH", "PARSE_IP", "PARSE_JSON", "PARSE_URL", "PARSE_XML", "PERCENT_RANK", "PERCENTILE_CONT", "PERCENTILE_DISC", "PI", "PIPE_USAGE_HISTORY", "POLICY_CONTEXT", "POLICY_REFERENCES", "POSITION", "POW", "POWER", "PREVIOUS_DAY", "QUERY_ACCELERATION_HISTORY", "QUERY_HISTORY", "QUERY_HISTORY_BY_SESSION", "QUERY_HISTORY_BY_USER", "QUERY_HISTORY_BY_WAREHOUSE", "RADIANS", "RANDOM", "RANDSTR", "RANK", "RATIO_TO_REPORT", "REGEXP", "REGEXP_COUNT", "REGEXP_INSTR", "REGEXP_LIKE", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REGEXP_SUBSTR_ALL", "REGR_AVGX", "REGR_AVGY", "REGR_COUNT", "REGR_INTERCEPT", "REGR_R2", "REGR_SLOPE", "REGR_SXX", "REGR_SXY", "REGR_SYY", "REGR_VALX", "REGR_VALY", "REPEAT", "REPLACE", "REPLICATION_GROUP_REFRESH_HISTORY", "REPLICATION_GROUP_REFRESH_PROGRESS", "REPLICATION_GROUP_REFRESH_PROGRESS_BY_JOB", "REPLICATION_GROUP_USAGE_HISTORY", "REPLICATION_USAGE_HISTORY", "REST_EVENT_HISTORY", "RESULT_SCAN", "REVERSE", "RIGHT", "RLIKE", "ROUND", "ROW_NUMBER", "RPAD", "RTRIM", "RTRIMMED_LENGTH", "SEARCH_OPTIMIZATION_HISTORY", "SEQ1", "SEQ2", "SEQ4", "SEQ8", "SERVERLESS_TASK_HISTORY", "SHA1", "SHA1_HEX", "SHA1_BINARY", "SHA2", "SHA2_HEX", "SHA2_BINARY", "SIGN", "SIN", "SINH", "SKEW", "SOUNDEX", "SPACE", "SPLIT", "SPLIT_PART", "SPLIT_TO_TABLE", "SQRT", "SQUARE", "ST_AREA", "ST_ASEWKB", "ST_ASEWKT", "ST_ASGEOJSON", "ST_ASWKB", "ST_ASBINARY", "ST_ASWKT", "ST_ASTEXT", "ST_AZIMUTH", "ST_CENTROID", "ST_COLLECT", "ST_CONTAINS", "ST_COVEREDBY", "ST_COVERS", "ST_DIFFERENCE", "ST_DIMENSION", "ST_DISJOINT", "ST_DISTANCE", "ST_DWITHIN", "ST_ENDPOINT", "ST_ENVELOPE", "ST_GEOGFROMGEOHASH", "ST_GEOGPOINTFROMGEOHASH", "ST_GEOGRAPHYFROMWKB", "ST_GEOGRAPHYFROMWKT", "ST_GEOHASH", "ST_GEOMETRYFROMWKB", "ST_GEOMETRYFROMWKT", "ST_HAUSDORFFDISTANCE", "ST_INTERSECTION", "ST_INTERSECTS", "ST_LENGTH", "ST_MAKEGEOMPOINT", "ST_GEOM_POINT", "ST_MAKELINE", "ST_MAKEPOINT", "ST_POINT", "ST_MAKEPOLYGON", "ST_POLYGON", "ST_NPOINTS", "ST_NUMPOINTS", "ST_PERIMETER", "ST_POINTN", "ST_SETSRID", "ST_SIMPLIFY", "ST_SRID", "ST_STARTPOINT", "ST_SYMDIFFERENCE", "ST_UNION", "ST_WITHIN", "ST_X", "ST_XMAX", "ST_XMIN", "ST_Y", "ST_YMAX", "ST_YMIN", "STAGE_DIRECTORY_FILE_REGISTRATION_HISTORY", "STAGE_STORAGE_USAGE_HISTORY", "STARTSWITH", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "STRIP_NULL_VALUE", "STRTOK", "STRTOK_SPLIT_TO_TABLE", "STRTOK_TO_ARRAY", "SUBSTR", "SUBSTRING", "SUM", "SYSDATE", "SYSTEM$ABORT_SESSION", "SYSTEM$ABORT_TRANSACTION", "SYSTEM$AUTHORIZE_PRIVATELINK", "SYSTEM$AUTHORIZE_STAGE_PRIVATELINK_ACCESS", "SYSTEM$BEHAVIOR_CHANGE_BUNDLE_STATUS", "SYSTEM$CANCEL_ALL_QUERIES", "SYSTEM$CANCEL_QUERY", "SYSTEM$CLUSTERING_DEPTH", "SYSTEM$CLUSTERING_INFORMATION", "SYSTEM$CLUSTERING_RATIO ", "SYSTEM$CURRENT_USER_TASK_NAME", "SYSTEM$DATABASE_REFRESH_HISTORY ", "SYSTEM$DATABASE_REFRESH_PROGRESS", "SYSTEM$DATABASE_REFRESH_PROGRESS_BY_JOB ", "SYSTEM$DISABLE_BEHAVIOR_CHANGE_BUNDLE", "SYSTEM$DISABLE_DATABASE_REPLICATION", "SYSTEM$ENABLE_BEHAVIOR_CHANGE_BUNDLE", "SYSTEM$ESTIMATE_QUERY_ACCELERATION", "SYSTEM$ESTIMATE_SEARCH_OPTIMIZATION_COSTS", "SYSTEM$EXPLAIN_JSON_TO_TEXT", "SYSTEM$EXPLAIN_PLAN_JSON", "SYSTEM$EXTERNAL_TABLE_PIPE_STATUS", "SYSTEM$GENERATE_SAML_CSR", "SYSTEM$GENERATE_SCIM_ACCESS_TOKEN", "SYSTEM$GET_AWS_SNS_IAM_POLICY", "SYSTEM$GET_PREDECESSOR_RETURN_VALUE", "SYSTEM$GET_PRIVATELINK", "SYSTEM$GET_PRIVATELINK_AUTHORIZED_ENDPOINTS", "SYSTEM$GET_PRIVATELINK_CONFIG", "SYSTEM$GET_SNOWFLAKE_PLATFORM_INFO", "SYSTEM$GET_TAG", "SYSTEM$GET_TAG_ALLOWED_VALUES", "SYSTEM$GET_TAG_ON_CURRENT_COLUMN", "SYSTEM$GET_TAG_ON_CURRENT_TABLE", "SYSTEM$GLOBAL_ACCOUNT_SET_PARAMETER", "SYSTEM$LAST_CHANGE_COMMIT_TIME", "SYSTEM$LINK_ACCOUNT_OBJECTS_BY_NAME", "SYSTEM$MIGRATE_SAML_IDP_REGISTRATION", "SYSTEM$PIPE_FORCE_RESUME", "SYSTEM$PIPE_STATUS", "SYSTEM$REVOKE_PRIVATELINK", "SYSTEM$REVOKE_STAGE_PRIVATELINK_ACCESS", "SYSTEM$SET_RETURN_VALUE", "SYSTEM$SHOW_OAUTH_CLIENT_SECRETS", "SYSTEM$STREAM_GET_TABLE_TIMESTAMP", "SYSTEM$STREAM_HAS_DATA", "SYSTEM$TASK_DEPENDENTS_ENABLE", "SYSTEM$TYPEOF", "SYSTEM$USER_TASK_CANCEL_ONGOING_EXECUTIONS", "SYSTEM$VERIFY_EXTERNAL_OAUTH_TOKEN", "SYSTEM$WAIT", "SYSTEM$WHITELIST", "SYSTEM$WHITELIST_PRIVATELINK", "TAG_REFERENCES", "TAG_REFERENCES_ALL_COLUMNS", "TAG_REFERENCES_WITH_LINEAGE", "TAN", "TANH", "TASK_DEPENDENTS", "TASK_HISTORY", "TIME_FROM_PARTS", "TIME_SLICE", "TIMEADD", "TIMEDIFF", "TIMESTAMP_FROM_PARTS", "TIMESTAMPADD", "TIMESTAMPDIFF", "TO_ARRAY", "TO_BINARY", "TO_BOOLEAN", "TO_CHAR", "TO_VARCHAR", "TO_DATE", "DATE", "TO_DECIMAL", "TO_NUMBER", "TO_NUMERIC", "TO_DOUBLE", "TO_GEOGRAPHY", "TO_GEOMETRY", "TO_JSON", "TO_OBJECT", "TO_TIME", "TIME", "TO_TIMESTAMP", "TO_TIMESTAMP_LTZ", "TO_TIMESTAMP_NTZ", "TO_TIMESTAMP_TZ", "TO_VARIANT", "TO_XML", "TRANSLATE", "TRIM", "TRUNCATE", "TRUNC", "TRUNC", "TRY_BASE64_DECODE_BINARY", "TRY_BASE64_DECODE_STRING", "TRY_CAST", "TRY_HEX_DECODE_BINARY", "TRY_HEX_DECODE_STRING", "TRY_PARSE_JSON", "TRY_TO_BINARY", "TRY_TO_BOOLEAN", "TRY_TO_DATE", "TRY_TO_DECIMAL", "TRY_TO_NUMBER", "TRY_TO_NUMERIC", "TRY_TO_DOUBLE", "TRY_TO_GEOGRAPHY", "TRY_TO_GEOMETRY", "TRY_TO_TIME", "TRY_TO_TIMESTAMP", "TRY_TO_TIMESTAMP_LTZ", "TRY_TO_TIMESTAMP_NTZ", "TRY_TO_TIMESTAMP_TZ", "TYPEOF", "UNICODE", "UNIFORM", "UPPER", "UUID_STRING", "VALIDATE", "VALIDATE_PIPE_LOAD", "VAR_POP", "VAR_SAMP", "VARIANCE", "VARIANCE_SAMP", "VARIANCE_POP", "WAREHOUSE_LOAD_HISTORY", "WAREHOUSE_METERING_HISTORY", "WIDTH_BUCKET", "XMLGET", "YEAR", "YEAROFWEEK", "YEAROFWEEKISO", "DAY", "DAYOFMONTH", "DAYOFWEEK", "DAYOFWEEKISO", "DAYOFYEAR", "WEEK", "WEEK", "WEEKOFYEAR", "WEEKISO", "MONTH", "QUARTER", "ZEROIFNULL", "ZIPF"]
}), rb = en({
  // https://docs.snowflake.com/en/sql-reference/reserved-keywords.html
  //
  // run in console on this page: $x('//tbody/tr/*[1]/p/text()').map(x => x.nodeValue)
  all: ["ACCOUNT", "ALL", "ALTER", "AND", "ANY", "AS", "BETWEEN", "BY", "CASE", "CAST", "CHECK", "COLUMN", "CONNECT", "CONNECTION", "CONSTRAINT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "DATABASE", "DELETE", "DISTINCT", "DROP", "ELSE", "EXISTS", "FALSE", "FOLLOWING", "FOR", "FROM", "FULL", "GRANT", "GROUP", "GSCLUSTER", "HAVING", "ILIKE", "IN", "INCREMENT", "INNER", "INSERT", "INTERSECT", "INTO", "IS", "ISSUE", "JOIN", "LATERAL", "LEFT", "LIKE", "LOCALTIME", "LOCALTIMESTAMP", "MINUS", "NATURAL", "NOT", "NULL", "OF", "ON", "OR", "ORDER", "ORGANIZATION", "QUALIFY", "REGEXP", "REVOKE", "RIGHT", "RLIKE", "ROW", "ROWS", "SAMPLE", "SCHEMA", "SELECT", "SET", "SOME", "START", "TABLE", "TABLESAMPLE", "THEN", "TO", "TRIGGER", "TRUE", "TRY_CAST", "UNION", "UNIQUE", "UPDATE", "USING", "VALUES", "VIEW", "WHEN", "WHENEVER", "WHERE", "WITH"]
}), ab = pe(["SELECT [ALL | DISTINCT]"]), ib = pe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "QUALIFY",
  "LIMIT",
  "OFFSET",
  "FETCH [FIRST | NEXT]",
  // Data manipulation
  // - insert:
  "INSERT [OVERWRITE] [ALL INTO | INTO | ALL | FIRST]",
  "{THEN | ELSE} INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  // - view
  "CREATE [OR REPLACE] [SECURE] [RECURSIVE] VIEW [IF NOT EXISTS]",
  // - create/drop/merge table
  "CREATE [OR REPLACE] [VOLATILE] TABLE [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [LOCAL | GLOBAL] {TEMP|TEMPORARY} TABLE [IF NOT EXISTS]",
  "CLUSTER BY",
  "[WITH] {MASKING POLICY | TAG | ROW ACCESS POLICY}",
  "COPY GRANTS",
  "USING TEMPLATE",
  "MERGE INTO",
  "WHEN MATCHED [AND]",
  "THEN {UPDATE SET | DELETE}",
  "WHEN NOT MATCHED THEN INSERT"
]), jm = pe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS]",
  "RENAME TO",
  "SWAP WITH",
  "[SUSPEND | RESUME] RECLUSTER",
  "DROP CLUSTERING KEY",
  "ADD [COLUMN]",
  "RENAME COLUMN",
  "{ALTER | MODIFY} [COLUMN]",
  "DROP [COLUMN]",
  "{ADD | ALTER | MODIFY | DROP} [CONSTRAINT]",
  "RENAME CONSTRAINT",
  "{ADD | DROP} SEARCH OPTIMIZATION",
  "{SET | UNSET} TAG",
  // Actually TAG is optional, but that conflicts with UPDATE..SET statement
  "{ADD | DROP} ROW ACCESS POLICY",
  "DROP ALL ROW ACCESS POLICIES",
  "{SET | DROP} DEFAULT",
  // for alter column
  "{SET | DROP} NOT NULL",
  // for alter column
  "[SET DATA] TYPE",
  // for alter column
  "[UNSET] COMMENT",
  // for alter column
  "{SET | UNSET} MASKING POLICY",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE] [IF EXISTS]",
  // other
  // https://docs.snowflake.com/en/sql-reference/sql-all.html
  //
  // 1. run in console on this page: $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue)
  // 2. delete all lines that contain a sting like '(.*)', they are already covered in the list
  // 3. delete all lines that contain a sting like '<.*>', they are already covered in the list
  // 4. delete all lines that contain '…', they are part of a regex statement that can't be covered here
  // 5. Manually add 'COPY INTO'
  // 6. Remove all lines that are already in `reservedClauses`
  //
  // Steps 1-4 can be combined by the following script in the developer console:
  // $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue) // Step 1
  //   filter(x => !x.match(/\(.*\)/) && !x.match(/…/) && !x.match(/<.*>/)) // Step 2-4
  "ALTER ACCOUNT",
  "ALTER API INTEGRATION",
  "ALTER CONNECTION",
  "ALTER DATABASE",
  "ALTER EXTERNAL TABLE",
  "ALTER FAILOVER GROUP",
  "ALTER FILE FORMAT",
  "ALTER FUNCTION",
  "ALTER INTEGRATION",
  "ALTER MASKING POLICY",
  "ALTER MATERIALIZED VIEW",
  "ALTER NETWORK POLICY",
  "ALTER NOTIFICATION INTEGRATION",
  "ALTER PIPE",
  "ALTER PROCEDURE",
  "ALTER REPLICATION GROUP",
  "ALTER RESOURCE MONITOR",
  "ALTER ROLE",
  "ALTER ROW ACCESS POLICY",
  "ALTER SCHEMA",
  "ALTER SECURITY INTEGRATION",
  "ALTER SEQUENCE",
  "ALTER SESSION",
  "ALTER SESSION POLICY",
  "ALTER SHARE",
  "ALTER STAGE",
  "ALTER STORAGE INTEGRATION",
  "ALTER STREAM",
  "ALTER TAG",
  "ALTER TASK",
  "ALTER USER",
  "ALTER VIEW",
  "ALTER WAREHOUSE",
  "BEGIN",
  "CALL",
  "COMMIT",
  "COPY INTO",
  "CREATE ACCOUNT",
  "CREATE API INTEGRATION",
  "CREATE CONNECTION",
  "CREATE DATABASE",
  "CREATE EXTERNAL FUNCTION",
  "CREATE EXTERNAL TABLE",
  "CREATE FAILOVER GROUP",
  "CREATE FILE FORMAT",
  "CREATE FUNCTION",
  "CREATE INTEGRATION",
  "CREATE MANAGED ACCOUNT",
  "CREATE MASKING POLICY",
  "CREATE MATERIALIZED VIEW",
  "CREATE NETWORK POLICY",
  "CREATE NOTIFICATION INTEGRATION",
  "CREATE PIPE",
  "CREATE PROCEDURE",
  "CREATE REPLICATION GROUP",
  "CREATE RESOURCE MONITOR",
  "CREATE ROLE",
  "CREATE ROW ACCESS POLICY",
  "CREATE SCHEMA",
  "CREATE SECURITY INTEGRATION",
  "CREATE SEQUENCE",
  "CREATE SESSION POLICY",
  "CREATE SHARE",
  "CREATE STAGE",
  "CREATE STORAGE INTEGRATION",
  "CREATE STREAM",
  "CREATE TAG",
  "CREATE TASK",
  "CREATE USER",
  "CREATE WAREHOUSE",
  "DELETE",
  "DESCRIBE DATABASE",
  "DESCRIBE EXTERNAL TABLE",
  "DESCRIBE FILE FORMAT",
  "DESCRIBE FUNCTION",
  "DESCRIBE INTEGRATION",
  "DESCRIBE MASKING POLICY",
  "DESCRIBE MATERIALIZED VIEW",
  "DESCRIBE NETWORK POLICY",
  "DESCRIBE PIPE",
  "DESCRIBE PROCEDURE",
  "DESCRIBE RESULT",
  "DESCRIBE ROW ACCESS POLICY",
  "DESCRIBE SCHEMA",
  "DESCRIBE SEQUENCE",
  "DESCRIBE SESSION POLICY",
  "DESCRIBE SHARE",
  "DESCRIBE STAGE",
  "DESCRIBE STREAM",
  "DESCRIBE TABLE",
  "DESCRIBE TASK",
  "DESCRIBE TRANSACTION",
  "DESCRIBE USER",
  "DESCRIBE VIEW",
  "DESCRIBE WAREHOUSE",
  "DROP CONNECTION",
  "DROP DATABASE",
  "DROP EXTERNAL TABLE",
  "DROP FAILOVER GROUP",
  "DROP FILE FORMAT",
  "DROP FUNCTION",
  "DROP INTEGRATION",
  "DROP MANAGED ACCOUNT",
  "DROP MASKING POLICY",
  "DROP MATERIALIZED VIEW",
  "DROP NETWORK POLICY",
  "DROP PIPE",
  "DROP PROCEDURE",
  "DROP REPLICATION GROUP",
  "DROP RESOURCE MONITOR",
  "DROP ROLE",
  "DROP ROW ACCESS POLICY",
  "DROP SCHEMA",
  "DROP SEQUENCE",
  "DROP SESSION POLICY",
  "DROP SHARE",
  "DROP STAGE",
  "DROP STREAM",
  "DROP TAG",
  "DROP TASK",
  "DROP USER",
  "DROP VIEW",
  "DROP WAREHOUSE",
  "EXECUTE IMMEDIATE",
  "EXECUTE TASK",
  "EXPLAIN",
  "GET",
  "GRANT OWNERSHIP",
  "GRANT ROLE",
  "INSERT",
  "LIST",
  "MERGE",
  "PUT",
  "REMOVE",
  "REVOKE ROLE",
  "ROLLBACK",
  "SHOW COLUMNS",
  "SHOW CONNECTIONS",
  "SHOW DATABASES",
  "SHOW DATABASES IN FAILOVER GROUP",
  "SHOW DATABASES IN REPLICATION GROUP",
  "SHOW DELEGATED AUTHORIZATIONS",
  "SHOW EXTERNAL FUNCTIONS",
  "SHOW EXTERNAL TABLES",
  "SHOW FAILOVER GROUPS",
  "SHOW FILE FORMATS",
  "SHOW FUNCTIONS",
  "SHOW GLOBAL ACCOUNTS",
  "SHOW GRANTS",
  "SHOW INTEGRATIONS",
  "SHOW LOCKS",
  "SHOW MANAGED ACCOUNTS",
  "SHOW MASKING POLICIES",
  "SHOW MATERIALIZED VIEWS",
  "SHOW NETWORK POLICIES",
  "SHOW OBJECTS",
  "SHOW ORGANIZATION ACCOUNTS",
  "SHOW PARAMETERS",
  "SHOW PIPES",
  "SHOW PRIMARY KEYS",
  "SHOW PROCEDURES",
  "SHOW REGIONS",
  "SHOW REPLICATION ACCOUNTS",
  "SHOW REPLICATION DATABASES",
  "SHOW REPLICATION GROUPS",
  "SHOW RESOURCE MONITORS",
  "SHOW ROLES",
  "SHOW ROW ACCESS POLICIES",
  "SHOW SCHEMAS",
  "SHOW SEQUENCES",
  "SHOW SESSION POLICIES",
  "SHOW SHARES",
  "SHOW SHARES IN FAILOVER GROUP",
  "SHOW SHARES IN REPLICATION GROUP",
  "SHOW STAGES",
  "SHOW STREAMS",
  "SHOW TABLES",
  "SHOW TAGS",
  "SHOW TASKS",
  "SHOW TRANSACTIONS",
  "SHOW USER FUNCTIONS",
  "SHOW USERS",
  "SHOW VARIABLES",
  "SHOW VIEWS",
  "SHOW WAREHOUSES",
  "TRUNCATE MATERIALIZED VIEW",
  "UNDROP DATABASE",
  "UNDROP SCHEMA",
  "UNDROP TABLE",
  "UNDROP TAG",
  "UNSET",
  "USE DATABASE",
  "USE ROLE",
  "USE SCHEMA",
  "USE SECONDARY ROLES",
  "USE WAREHOUSE"
]), ob = pe(["UNION [ALL]", "MINUS", "EXCEPT", "INTERSECT"]), lb = pe(["[INNER] JOIN", "[NATURAL] {LEFT | RIGHT | FULL} [OUTER] JOIN", "{CROSS | NATURAL} JOIN"]), sb = pe(["{ROWS | RANGE} BETWEEN", "ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]"]), ub = {
  tokenizerOptions: {
    reservedSelect: ab,
    reservedClauses: [...ib, ...jm],
    reservedSetOperations: ob,
    reservedJoins: lb,
    reservedPhrases: sb,
    reservedKeywords: rb,
    reservedFunctionNames: nb,
    stringTypes: ["$$", "''-qq-bs"],
    identTypes: ['""-qq'],
    variableTypes: [
      // for accessing columns at certain positons in the table
      {
        regex: "[$][1-9]\\d*"
      },
      // identifier style syntax
      {
        regex: "[$][_a-zA-Z][_a-zA-Z0-9$]*"
      }
    ],
    extraParens: ["[]"],
    identChars: {
      rest: "$"
    },
    lineCommentTypes: ["--", "//"],
    operators: [
      // Modulo
      "%",
      // Type cast
      "::",
      // String concat
      "||",
      // Get Path
      ":",
      // Generators: https://docs.snowflake.com/en/sql-reference/functions/generator.html#generator
      "=>"
    ]
  },
  formatOptions: {
    alwaysDenseOperators: [":", "::"],
    onelineClauses: jm
  }
}, Eb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bigquery: V0,
  db2: eG,
  hive: sG,
  mariadb: dG,
  mysql: mG,
  n1ql: GG,
  plsql: VG,
  postgresql: ZG,
  redshift: ix,
  singlestoredb: eb,
  snowflake: ub,
  spark: fx,
  sql: Px,
  sqlite: Cx,
  transactsql: Kx,
  trino: Bx
}, Symbol.toStringTag, { value: "Module" })), mo = (l) => l.replace(/[.*+?^${}()|[\]\\]/gu, "\\$&"), zm = /\s+/uy, _E = (l) => new RegExp(`(?:${l})`, "uy"), cb = (l) => l.split("").map((u) => / /gu.test(u) ? "\\s+" : `[${u.toUpperCase()}${u.toLowerCase()}]`).join(""), Tb = (l) => l + "(?:-" + l + ")*", fb = ({
  prefixes: l,
  requirePrefix: u
}) => `(?:${l.map(cb).join("|")}${u ? "" : "|"})`, Ab = (l) => new RegExp(`(?:${l.map(mo).join("|")}).*?(?=\r
|\r|
|$)`, "uy"), Jm = (l, u = []) => {
  const T = l === "open" ? 0 : 1, N = ["()", ...u].map((O) => O[T]);
  return _E(N.map(mo).join("|"));
}, Rb = (l) => _E(`${wL(l).map(mo).join("|")}`), db = ({
  rest: l,
  dashes: u
}) => l || u ? `(?![${l || ""}${u ? "-" : ""}])` : "", LE = (l, u = {}) => {
  if (l.length === 0)
    return /^\b$/u;
  const T = db(u), N = wL(l).map(mo).join("|").replace(/ /gu, "\\s+");
  return new RegExp(`(?:${N})${T}\\b`, "iuy");
}, SI = (l, u) => {
  if (!l.length)
    return;
  const T = l.map(mo).join("|");
  return _E(`(?:${T})(?:${u})`);
}, Sb = () => {
  const l = {
    "<": ">",
    "[": "]",
    "(": ")",
    "{": "}"
  }, u = "{left}(?:(?!{right}').)*?{right}", T = Object.entries(l).map(([d, G]) => u.replace(/{left}/g, mo(d)).replace(/{right}/g, mo(G))), N = mo(Object.keys(l).join(""));
  return `[Qq]'(?:${String.raw`(?<tag>[^\s${N}])(?:(?!\k<tag>').)*?\k<tag>`}|${T.join("|")})'`;
}, Qm = {
  // - backtick quoted (using `` to escape)
  "``": "(?:`[^`]*`)+",
  // - Transact-SQL square bracket quoted (using ]] to escape)
  "[]": String.raw`(?:\[[^\]]*\])(?:\][^\]]*\])*`,
  // double-quoted
  '""-qq': String.raw`(?:"[^"]*")+`,
  // with repeated quote escapes
  '""-bs': String.raw`(?:"[^"\\]*(?:\\.[^"\\]*)*")`,
  // with backslash escapes
  '""-qq-bs': String.raw`(?:"[^"\\]*(?:\\.[^"\\]*)*")+`,
  // with repeated quote or backslash escapes
  '""-raw': String.raw`(?:"[^"]*")`,
  // no escaping
  // single-quoted
  "''-qq": String.raw`(?:'[^']*')+`,
  // with repeated quote escapes
  "''-bs": String.raw`(?:'[^'\\]*(?:\\.[^'\\]*)*')`,
  // with backslash escapes
  "''-qq-bs": String.raw`(?:'[^'\\]*(?:\\.[^'\\]*)*')+`,
  // with repeated quote or backslash escapes
  "''-raw": String.raw`(?:'[^']*')`,
  // no escaping
  // PostgreSQL dollar-quoted
  $$: String.raw`(?<tag>\$\w*\$)[\s\S]*?\k<tag>`,
  // BigQuery '''triple-quoted''' (using \' to escape)
  "'''..'''": String.raw`'''[^\\]*?(?:\\.[^\\]*?)*?'''`,
  // BigQuery """triple-quoted""" (using \" to escape)
  '""".."""': String.raw`"""[^\\]*?(?:\\.[^\\]*?)*?"""`,
  // Hive and Spark variables: ${name}
  "{}": String.raw`(?:\{[^\}]*\})`,
  // Oracle q'' strings: q'<text>' q'|text|' ...
  "q''": Sb()
}, WL = (l) => typeof l == "string" ? Qm[l] : "regex" in l ? l.regex : fb(l) + Qm[l.quote], Nb = (l) => _E(l.map((u) => "regex" in u ? u.regex : WL(u)).join("|")), XL = (l) => l.map(WL).join("|"), Zm = (l) => _E(XL(l)), pb = (l = {}) => _E(kL(l)), kL = ({
  first: l,
  rest: u,
  dashes: T,
  allowFirstCharNumber: N
} = {}) => {
  const O = "\\p{Alphabetic}\\p{Mark}_", h = "\\p{Decimal_Number}", d = mo(l ?? ""), G = mo(u ?? ""), D = N ? `[${O}${h}${d}][${O}${h}${G}]*` : `[${O}${d}][${O}${h}${G}]*`;
  return T ? Tb(D) : D;
};
function KL(l, u) {
  const T = l.slice(0, u).split(/\n/);
  return {
    line: T.length,
    col: T[T.length - 1].length + 1
  };
}
class Ob {
  // Current position in string
  constructor(u) {
    Yn(this, "input", "");
    // The input SQL string to process
    Yn(this, "index", 0);
    this.rules = u;
  }
  /**
   * Takes a SQL string and breaks it into tokens.
   * Each token is an object with type and value.
   *
   * @param {string} input - The SQL string
   * @returns {Token[]} output token stream
   */
  tokenize(u) {
    this.input = u, this.index = 0;
    const T = [];
    let N;
    for (; this.index < this.input.length; ) {
      const O = this.getWhitespace();
      if (this.index < this.input.length) {
        if (N = this.getNextToken(), !N)
          throw this.createParseError();
        T.push({
          ...N,
          precedingWhitespace: O
        });
      }
    }
    return T;
  }
  createParseError() {
    const u = this.input.slice(this.index, this.index + 10), {
      line: T,
      col: N
    } = KL(this.input, this.index);
    return new Error(`Parse error: Unexpected "${u}" at line ${T} column ${N}`);
  }
  getWhitespace() {
    zm.lastIndex = this.index;
    const u = zm.exec(this.input);
    if (u)
      return this.index += u[0].length, u[0];
  }
  getNextToken() {
    for (const u of this.rules) {
      const T = this.match(u);
      if (T)
        return T;
    }
  }
  // Attempts to match token rule regex at current position in input
  match(u) {
    u.regex.lastIndex = this.index;
    const T = u.regex.exec(this.input);
    if (T) {
      const N = T[0], O = {
        type: u.type,
        raw: N,
        text: u.text ? u.text(N) : N,
        start: this.index
      };
      return u.key && (O.key = u.key(N)), this.index += N.length, O;
    }
  }
}
const qm = /\/\*/uy, Ib = /([^/*]|\*[^/]|\/[^*])+/uy, Cb = /\*\//uy;
class hb {
  constructor() {
    Yn(this, "lastIndex", 0);
  }
  exec(u) {
    let T = "", N, O = 0;
    if (N = this.matchSection(qm, u))
      T += N, O++;
    else
      return null;
    for (; O > 0; )
      if (N = this.matchSection(qm, u))
        T += N, O++;
      else if (N = this.matchSection(Cb, u))
        T += N, O--;
      else if (N = this.matchSection(Ib, u))
        T += N;
      else
        return null;
    return [T];
  }
  matchSection(u, T) {
    u.lastIndex = this.lastIndex;
    const N = u.exec(T);
    return N && (this.lastIndex += N[0].length), N ? N[0] : null;
  }
}
class vb {
  constructor(u) {
    this.cfg = u, this.rulesBeforeParams = this.buildRulesBeforeParams(u), this.rulesAfterParams = this.buildRulesAfterParams(u);
  }
  tokenize(u, T) {
    const N = [...this.rulesBeforeParams, ...this.buildParamRules(this.cfg, T), ...this.rulesAfterParams], O = new Ob(N).tokenize(u);
    return this.cfg.postProcess ? this.cfg.postProcess(O) : O;
  }
  // These rules can be cached as they only depend on
  // the Tokenizer config options specified for each SQL dialect
  buildRulesBeforeParams(u) {
    return this.validRules([
      {
        type: Re.BLOCK_COMMENT,
        regex: u.nestedBlockComments ? new hb() : /(\/\*[^]*?\*\/)/uy
      },
      {
        type: Re.LINE_COMMENT,
        regex: Ab(u.lineCommentTypes ?? ["--"])
      },
      {
        type: Re.QUOTED_IDENTIFIER,
        regex: Zm(u.identTypes)
      },
      {
        type: Re.NUMBER,
        regex: /(?:0x[0-9a-fA-F]+|0b[01]+|(?:-\s*)?[0-9]+(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+(?:\.[0-9]+)?)?)(?!\w)/uy
      },
      // RESERVED_PHRASE is matched before all other keyword tokens
      // to e.g. prioritize matching "TIMESTAMP WITH TIME ZONE" phrase over "WITH" clause.
      {
        type: Re.RESERVED_PHRASE,
        regex: LE(u.reservedPhrases ?? [], u.identChars),
        text: zr
      },
      {
        type: Re.CASE,
        regex: /CASE\b/iuy,
        text: zr
      },
      {
        type: Re.END,
        regex: /END\b/iuy,
        text: zr
      },
      {
        type: Re.BETWEEN,
        regex: /BETWEEN\b/iuy,
        text: zr
      },
      {
        type: Re.LIMIT,
        regex: u.reservedClauses.includes("LIMIT") ? /LIMIT\b/iuy : void 0,
        text: zr
      },
      {
        type: Re.RESERVED_CLAUSE,
        regex: LE(u.reservedClauses, u.identChars),
        text: zr
      },
      {
        type: Re.RESERVED_SELECT,
        regex: LE(u.reservedSelect, u.identChars),
        text: zr
      },
      {
        type: Re.RESERVED_SET_OPERATION,
        regex: LE(u.reservedSetOperations, u.identChars),
        text: zr
      },
      {
        type: Re.WHEN,
        regex: /WHEN\b/iuy,
        text: zr
      },
      {
        type: Re.ELSE,
        regex: /ELSE\b/iuy,
        text: zr
      },
      {
        type: Re.THEN,
        regex: /THEN\b/iuy,
        text: zr
      },
      {
        type: Re.RESERVED_JOIN,
        regex: LE(u.reservedJoins, u.identChars),
        text: zr
      },
      {
        type: Re.AND,
        regex: /AND\b/iuy,
        text: zr
      },
      {
        type: Re.OR,
        regex: /OR\b/iuy,
        text: zr
      },
      {
        type: Re.XOR,
        regex: u.supportsXor ? /XOR\b/iuy : void 0,
        text: zr
      },
      {
        type: Re.RESERVED_FUNCTION_NAME,
        regex: LE(u.reservedFunctionNames, u.identChars),
        text: zr
      },
      {
        type: Re.RESERVED_KEYWORD,
        regex: LE(u.reservedKeywords, u.identChars),
        text: zr
      }
    ]);
  }
  // These rules can also be cached as they only depend on
  // the Tokenizer config options specified for each SQL dialect
  buildRulesAfterParams(u) {
    return this.validRules([{
      type: Re.VARIABLE,
      regex: u.variableTypes ? Nb(u.variableTypes) : void 0
    }, {
      type: Re.STRING,
      regex: Zm(u.stringTypes)
    }, {
      type: Re.IDENTIFIER,
      regex: pb(u.identChars)
    }, {
      type: Re.DELIMITER,
      regex: /[;]/uy
    }, {
      type: Re.COMMA,
      regex: /[,]/y
    }, {
      type: Re.OPEN_PAREN,
      regex: Jm("open", u.extraParens)
    }, {
      type: Re.CLOSE_PAREN,
      regex: Jm("close", u.extraParens)
    }, {
      type: Re.OPERATOR,
      regex: Rb([
        // standard operators
        "+",
        "-",
        "/",
        ">",
        "<",
        "=",
        "<>",
        "<=",
        ">=",
        "!=",
        ...u.operators ?? []
      ])
    }, {
      type: Re.ASTERISK,
      regex: /[*]/uy
    }, {
      type: Re.DOT,
      regex: /[.]/uy
    }]);
  }
  // These rules can't be blindly cached as the paramTypesOverrides object
  // can differ on each invocation of the format() function.
  buildParamRules(u, T) {
    var N, O, h, d, G;
    const D = {
      named: (T == null ? void 0 : T.named) || ((N = u.paramTypes) === null || N === void 0 ? void 0 : N.named) || [],
      quoted: (T == null ? void 0 : T.quoted) || ((O = u.paramTypes) === null || O === void 0 ? void 0 : O.quoted) || [],
      numbered: (T == null ? void 0 : T.numbered) || ((h = u.paramTypes) === null || h === void 0 ? void 0 : h.numbered) || [],
      positional: typeof (T == null ? void 0 : T.positional) == "boolean" ? T.positional : (d = u.paramTypes) === null || d === void 0 ? void 0 : d.positional,
      custom: (T == null ? void 0 : T.custom) || ((G = u.paramTypes) === null || G === void 0 ? void 0 : G.custom) || []
    };
    return this.validRules([{
      type: Re.NAMED_PARAMETER,
      regex: SI(D.named, kL(u.paramChars || u.identChars)),
      key: (v) => v.slice(1)
    }, {
      type: Re.QUOTED_PARAMETER,
      regex: SI(D.quoted, XL(u.identTypes)),
      key: (v) => (({
        tokenKey: M,
        quoteChar: g
      }) => M.replace(new RegExp(mo("\\" + g), "gu"), g))({
        tokenKey: v.slice(2, -1),
        quoteChar: v.slice(-1)
      })
    }, {
      type: Re.NUMBERED_PARAMETER,
      regex: SI(D.numbered, "[0-9]+"),
      key: (v) => v.slice(1)
    }, {
      type: Re.POSITIONAL_PARAMETER,
      regex: D.positional ? /[?]/y : void 0
    }, ...D.custom.map((v) => ({
      type: Re.CUSTOM_PARAMETER,
      regex: _E(v.regex),
      key: v.key ?? ((M) => M)
    }))]);
  }
  // filters out rules for token types whose regex is undefined
  validRules(u) {
    return u.filter((T) => !!T.regex);
  }
}
const zr = (l) => VL(l.toUpperCase()), $m = /* @__PURE__ */ new Map(), mb = (l) => {
  let u = $m.get(l);
  return u || (u = Lb(l), $m.set(l, u)), u;
}, Lb = (l) => ({
  tokenizer: new vb(l.tokenizerOptions),
  formatOptions: yb(l.formatOptions)
}), yb = (l) => ({
  alwaysDenseOperators: l.alwaysDenseOperators || [],
  onelineClauses: Object.fromEntries(l.onelineClauses.map((u) => [u, !0]))
});
function eL(l) {
  return l.indentStyle === "tabularLeft" || l.indentStyle === "tabularRight" ? " ".repeat(10) : l.useTabs ? "	" : " ".repeat(l.tabWidth);
}
function yA(l) {
  return l.indentStyle === "tabularLeft" || l.indentStyle === "tabularRight";
}
class Db {
  constructor(u) {
    this.params = u, this.index = 0;
  }
  /**
   * Returns param value that matches given placeholder with param key.
   */
  get({
    key: u,
    text: T
  }) {
    return this.params ? u ? this.params[u] : this.params[this.index++] : T;
  }
  /**
   * Returns index of current positional parameter.
   */
  getPositionalParameterIndex() {
    return this.index;
  }
  /**
   * Sets index of current positional parameter.
   */
  setPositionalParameterIndex(u) {
    this.index = u;
  }
}
var jL = { exports: {} };
(function(l) {
  (function(u, T) {
    l.exports ? l.exports = T() : u.nearley = T();
  })(YS, function() {
    function u(v, M, g) {
      return this.id = ++u.highestId, this.name = v, this.symbols = M, this.postprocess = g, this;
    }
    u.highestId = 0, u.prototype.toString = function(v) {
      var M = typeof v > "u" ? this.symbols.map(D).join(" ") : this.symbols.slice(0, v).map(D).join(" ") + " ● " + this.symbols.slice(v).map(D).join(" ");
      return this.name + " → " + M;
    };
    function T(v, M, g, w) {
      this.rule = v, this.dot = M, this.reference = g, this.data = [], this.wantedBy = w, this.isComplete = this.dot === v.symbols.length;
    }
    T.prototype.toString = function() {
      return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    }, T.prototype.nextState = function(v) {
      var M = new T(this.rule, this.dot + 1, this.reference, this.wantedBy);
      return M.left = this, M.right = v, M.isComplete && (M.data = M.build(), M.right = void 0), M;
    }, T.prototype.build = function() {
      var v = [], M = this;
      do
        v.push(M.right.data), M = M.left;
      while (M.left);
      return v.reverse(), v;
    }, T.prototype.finish = function() {
      this.rule.postprocess && (this.data = this.rule.postprocess(this.data, this.reference, d.fail));
    };
    function N(v, M) {
      this.grammar = v, this.index = M, this.states = [], this.wants = {}, this.scannable = [], this.completed = {};
    }
    N.prototype.process = function(v) {
      for (var M = this.states, g = this.wants, w = this.completed, Y = 0; Y < M.length; Y++) {
        var j = M[Y];
        if (j.isComplete) {
          if (j.finish(), j.data !== d.fail) {
            for (var oe = j.wantedBy, me = oe.length; me--; ) {
              var Le = oe[me];
              this.complete(Le, j);
            }
            if (j.reference === this.index) {
              var Oe = j.rule.name;
              (this.completed[Oe] = this.completed[Oe] || []).push(j);
            }
          }
        } else {
          var Oe = j.rule.symbols[j.dot];
          if (typeof Oe != "string") {
            this.scannable.push(j);
            continue;
          }
          if (g[Oe]) {
            if (g[Oe].push(j), w.hasOwnProperty(Oe))
              for (var he = w[Oe], me = 0; me < he.length; me++) {
                var Fe = he[me];
                this.complete(j, Fe);
              }
          } else
            g[Oe] = [j], this.predict(Oe);
        }
      }
    }, N.prototype.predict = function(v) {
      for (var M = this.grammar.byName[v] || [], g = 0; g < M.length; g++) {
        var w = M[g], Y = this.wants[v], j = new T(w, 0, this.index, Y);
        this.states.push(j);
      }
    }, N.prototype.complete = function(v, M) {
      var g = v.nextState(M);
      this.states.push(g);
    };
    function O(v, M) {
      this.rules = v, this.start = M || this.rules[0].name;
      var g = this.byName = {};
      this.rules.forEach(function(w) {
        g.hasOwnProperty(w.name) || (g[w.name] = []), g[w.name].push(w);
      });
    }
    O.fromCompiled = function(w, M) {
      var g = w.Lexer;
      w.ParserStart && (M = w.ParserStart, w = w.ParserRules);
      var w = w.map(function(j) {
        return new u(j.name, j.symbols, j.postprocess);
      }), Y = new O(w, M);
      return Y.lexer = g, Y;
    };
    function h() {
      this.reset("");
    }
    h.prototype.reset = function(v, M) {
      this.buffer = v, this.index = 0, this.line = M ? M.line : 1, this.lastLineBreak = M ? -M.col : 0;
    }, h.prototype.next = function() {
      if (this.index < this.buffer.length) {
        var v = this.buffer[this.index++];
        return v === `
` && (this.line += 1, this.lastLineBreak = this.index), { value: v };
      }
    }, h.prototype.save = function() {
      return {
        line: this.line,
        col: this.index - this.lastLineBreak
      };
    }, h.prototype.formatError = function(v, M) {
      var g = this.buffer;
      if (typeof g == "string") {
        var w = g.split(`
`).slice(
          Math.max(0, this.line - 5),
          this.line
        ), Y = g.indexOf(`
`, this.index);
        Y === -1 && (Y = g.length);
        var j = this.index - this.lastLineBreak, oe = String(this.line).length;
        return M += " at line " + this.line + " col " + j + `:

`, M += w.map(function(Le, Oe) {
          return me(this.line - w.length + Oe + 1, oe) + " " + Le;
        }, this).join(`
`), M += `
` + me("", oe + j) + `^
`, M;
      } else
        return M + " at index " + (this.index - 1);
      function me(Le, Oe) {
        var he = String(Le);
        return Array(Oe - he.length + 1).join(" ") + he;
      }
    };
    function d(v, M, g) {
      if (v instanceof O)
        var w = v, g = M;
      else
        var w = O.fromCompiled(v, M);
      this.grammar = w, this.options = {
        keepHistory: !1,
        lexer: w.lexer || new h()
      };
      for (var Y in g || {})
        this.options[Y] = g[Y];
      this.lexer = this.options.lexer, this.lexerState = void 0;
      var j = new N(w, 0);
      this.table = [j], j.wants[w.start] = [], j.predict(w.start), j.process(), this.current = 0;
    }
    d.fail = {}, d.prototype.feed = function(v) {
      var M = this.lexer;
      M.reset(v, this.lexerState);
      for (var g; ; ) {
        try {
          if (g = M.next(), !g)
            break;
        } catch (Xe) {
          var oe = new N(this.grammar, this.current + 1);
          this.table.push(oe);
          var w = new Error(this.reportLexerError(Xe));
          throw w.offset = this.current, w.token = Xe.token, w;
        }
        var Y = this.table[this.current];
        this.options.keepHistory || delete this.table[this.current - 1];
        var j = this.current + 1, oe = new N(this.grammar, j);
        this.table.push(oe);
        for (var me = g.text !== void 0 ? g.text : g.value, Le = M.constructor === h ? g.value : g, Oe = Y.scannable, he = Oe.length; he--; ) {
          var Fe = Oe[he], ye = Fe.rule.symbols[Fe.dot];
          if (ye.test ? ye.test(Le) : ye.type ? ye.type === g.type : ye.literal === me) {
            var je = Fe.nextState({ data: Le, token: g, isToken: !0, reference: j - 1 });
            oe.states.push(je);
          }
        }
        if (oe.process(), oe.states.length === 0) {
          var w = new Error(this.reportError(g));
          throw w.offset = this.current, w.token = g, w;
        }
        this.options.keepHistory && (Y.lexerState = M.save()), this.current++;
      }
      return Y && (this.lexerState = M.save()), this.results = this.finish(), this;
    }, d.prototype.reportLexerError = function(v) {
      var M, g, w = v.token;
      return w ? (M = "input " + JSON.stringify(w.text[0]) + " (lexer error)", g = this.lexer.formatError(w, "Syntax error")) : (M = "input (lexer error)", g = v.message), this.reportErrorCommon(g, M);
    }, d.prototype.reportError = function(v) {
      var M = (v.type ? v.type + " token: " : "") + JSON.stringify(v.value !== void 0 ? v.value : v), g = this.lexer.formatError(v, "Syntax error");
      return this.reportErrorCommon(g, M);
    }, d.prototype.reportErrorCommon = function(v, M) {
      var g = [];
      g.push(v);
      var w = this.table.length - 2, Y = this.table[w], j = Y.states.filter(function(me) {
        var Le = me.rule.symbols[me.dot];
        return Le && typeof Le != "string";
      });
      if (j.length === 0)
        g.push("Unexpected " + M + `. I did not expect any more input. Here is the state of my parse table:
`), this.displayStateStack(Y.states, g);
      else {
        g.push("Unexpected " + M + `. Instead, I was expecting to see one of the following:
`);
        var oe = j.map(function(me) {
          return this.buildFirstStateStack(me, []) || [me];
        }, this);
        oe.forEach(function(me) {
          var Le = me[0], Oe = Le.rule.symbols[Le.dot], he = this.getSymbolDisplay(Oe);
          g.push("A " + he + " based on:"), this.displayStateStack(me, g);
        }, this);
      }
      return g.push(""), g.join(`
`);
    }, d.prototype.displayStateStack = function(v, M) {
      for (var g, w = 0, Y = 0; Y < v.length; Y++) {
        var j = v[Y], oe = j.rule.toString(j.dot);
        oe === g ? w++ : (w > 0 && M.push("    ^ " + w + " more lines identical to this"), w = 0, M.push("    " + oe)), g = oe;
      }
    }, d.prototype.getSymbolDisplay = function(v) {
      return G(v);
    }, d.prototype.buildFirstStateStack = function(v, M) {
      if (M.indexOf(v) !== -1)
        return null;
      if (v.wantedBy.length === 0)
        return [v];
      var g = v.wantedBy[0], w = [v].concat(M), Y = this.buildFirstStateStack(g, w);
      return Y === null ? null : [v].concat(Y);
    }, d.prototype.save = function() {
      var v = this.table[this.current];
      return v.lexerState = this.lexerState, v;
    }, d.prototype.restore = function(v) {
      var M = v.index;
      this.current = M, this.table[M] = v, this.table.splice(M + 1), this.lexerState = v.lexerState, this.results = this.finish();
    }, d.prototype.rewind = function(v) {
      if (!this.options.keepHistory)
        throw new Error("set option `keepHistory` to enable rewinding");
      this.restore(this.table[v]);
    }, d.prototype.finish = function() {
      var v = [], M = this.grammar.start, g = this.table[this.table.length - 1];
      return g.states.forEach(function(w) {
        w.rule.name === M && w.dot === w.rule.symbols.length && w.reference === 0 && w.data !== d.fail && v.push(w);
      }), v.map(function(w) {
        return w.data;
      });
    };
    function G(v) {
      var M = typeof v;
      if (M === "string")
        return v;
      if (M === "object") {
        if (v.literal)
          return JSON.stringify(v.literal);
        if (v instanceof RegExp)
          return "character matching " + v;
        if (v.type)
          return v.type + " token";
        if (v.test)
          return "token matching " + String(v.test);
        throw new Error("Unknown symbol type: " + v);
      }
    }
    function D(v) {
      var M = typeof v;
      if (M === "string")
        return v;
      if (M === "object") {
        if (v.literal)
          return JSON.stringify(v.literal);
        if (v instanceof RegExp)
          return v.toString();
        if (v.type)
          return "%" + v.type;
        if (v.test)
          return "<" + String(v.test) + ">";
        throw new Error("Unknown symbol type: " + v);
      }
    }
    return {
      Parser: d,
      Grammar: O,
      Rule: u
    };
  });
})(jL);
var gb = jL.exports;
const Pb = /* @__PURE__ */ _A(gb);
function Mb(l) {
  return l.map(Ub).map(_b).map(Gb).map(xb);
}
const Ub = (l, u, T) => {
  if (BL(l.type)) {
    const N = bb(T, u);
    if (N && N.text === ".")
      return {
        ...l,
        type: Re.IDENTIFIER,
        text: l.raw
      };
  }
  return l;
}, _b = (l, u, T) => {
  if (l.type === Re.RESERVED_FUNCTION_NAME) {
    const N = XS(T, u);
    if (!N || !Hb(N))
      return {
        ...l,
        type: Re.RESERVED_KEYWORD
      };
  }
  return l;
}, Gb = (l, u, T) => {
  if (l.type === Re.IDENTIFIER) {
    const N = XS(T, u);
    if (N && zL(N))
      return {
        ...l,
        type: Re.ARRAY_IDENTIFIER
      };
  }
  return l;
}, xb = (l, u, T) => {
  if (l.type === Re.RESERVED_KEYWORD) {
    const N = XS(T, u);
    if (N && zL(N))
      return {
        ...l,
        type: Re.ARRAY_KEYWORD
      };
  }
  return l;
}, bb = (l, u) => XS(l, u, -1), XS = (l, u, T = 1) => {
  let N = 1;
  for (; l[u + N * T] && Bb(l[u + N * T]); )
    N++;
  return l[u + N * T];
}, Hb = (l) => l.type === Re.OPEN_PAREN && l.text === "(", zL = (l) => l.type === Re.OPEN_PAREN && l.text === "[", Bb = (l) => l.type === Re.BLOCK_COMMENT || l.type === Re.LINE_COMMENT;
class JL {
  constructor(u) {
    Yn(this, "index", 0);
    Yn(this, "tokens", []);
    Yn(this, "input", "");
    this.tokenize = u;
  }
  reset(u, T) {
    this.input = u, this.index = 0, this.tokens = this.tokenize(u);
  }
  next() {
    return this.tokens[this.index++];
  }
  save() {
  }
  formatError(u) {
    const {
      line: T,
      col: N
    } = KL(this.input, u.start);
    return `Parse error at token: ${u.text} at line ${T} column ${N}`;
  }
  has(u) {
    return u in Re;
  }
}
let it;
(function(l) {
  l.statement = "statement", l.clause = "clause", l.set_operation = "set_operation", l.function_call = "function_call", l.array_subscript = "array_subscript", l.property_access = "property_access", l.parenthesis = "parenthesis", l.between_predicate = "between_predicate", l.case_expression = "case_expression", l.case_when = "case_when", l.case_else = "case_else", l.limit_clause = "limit_clause", l.all_columns_asterisk = "all_columns_asterisk", l.literal = "literal", l.identifier = "identifier", l.keyword = "keyword", l.parameter = "parameter", l.operator = "operator", l.comma = "comma", l.line_comment = "line_comment", l.block_comment = "block_comment";
})(it || (it = {}));
function NI(l) {
  return l[0];
}
const pt = new JL((l) => []), ET = ([[l]]) => l, gr = (l) => ({
  type: it.keyword,
  tokenType: l.type,
  text: l.text,
  raw: l.raw
}), Jr = (l, {
  leading: u,
  trailing: T
}) => (u != null && u.length && (l = {
  ...l,
  leadingComments: u
}), T != null && T.length && (l = {
  ...l,
  trailingComments: T
}), l), Fb = (l, {
  leading: u,
  trailing: T
}) => {
  if (u != null && u.length) {
    const [N, ...O] = l;
    l = [Jr(N, {
      leading: u
    }), ...O];
  }
  if (T != null && T.length) {
    const N = l.slice(0, -1), O = l[l.length - 1];
    l = [...N, Jr(O, {
      trailing: T
    })];
  }
  return l;
}, wb = {
  Lexer: pt,
  ParserRules: [{
    name: "main$ebnf$1",
    symbols: []
  }, {
    name: "main$ebnf$1",
    symbols: ["main$ebnf$1", "statement"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "main",
    symbols: ["main$ebnf$1"],
    postprocess: ([l]) => {
      const u = l[l.length - 1];
      return u && !u.hasSemicolon ? u.children.length > 0 ? l : l.slice(0, -1) : l;
    }
  }, {
    name: "statement$subexpression$1",
    symbols: [pt.has("DELIMITER") ? {
      type: "DELIMITER"
    } : DELIMITER]
  }, {
    name: "statement$subexpression$1",
    symbols: [pt.has("EOF") ? {
      type: "EOF"
    } : EOF]
  }, {
    name: "statement",
    symbols: ["expressions_or_clauses", "statement$subexpression$1"],
    postprocess: ([l, [u]]) => ({
      type: it.statement,
      children: l,
      hasSemicolon: u.type === Re.DELIMITER
    })
  }, {
    name: "expressions_or_clauses$ebnf$1",
    symbols: []
  }, {
    name: "expressions_or_clauses$ebnf$1",
    symbols: ["expressions_or_clauses$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "expressions_or_clauses$ebnf$2",
    symbols: []
  }, {
    name: "expressions_or_clauses$ebnf$2",
    symbols: ["expressions_or_clauses$ebnf$2", "clause"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "expressions_or_clauses",
    symbols: ["expressions_or_clauses$ebnf$1", "expressions_or_clauses$ebnf$2"],
    postprocess: ([l, u]) => [...l, ...u]
  }, {
    name: "clause$subexpression$1",
    symbols: ["limit_clause"]
  }, {
    name: "clause$subexpression$1",
    symbols: ["select_clause"]
  }, {
    name: "clause$subexpression$1",
    symbols: ["other_clause"]
  }, {
    name: "clause$subexpression$1",
    symbols: ["set_operation"]
  }, {
    name: "clause",
    symbols: ["clause$subexpression$1"],
    postprocess: ET
  }, {
    name: "limit_clause$ebnf$1$subexpression$1$ebnf$1",
    symbols: ["free_form_sql"]
  }, {
    name: "limit_clause$ebnf$1$subexpression$1$ebnf$1",
    symbols: ["limit_clause$ebnf$1$subexpression$1$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "limit_clause$ebnf$1$subexpression$1",
    symbols: [pt.has("COMMA") ? {
      type: "COMMA"
    } : COMMA, "limit_clause$ebnf$1$subexpression$1$ebnf$1"]
  }, {
    name: "limit_clause$ebnf$1",
    symbols: ["limit_clause$ebnf$1$subexpression$1"],
    postprocess: NI
  }, {
    name: "limit_clause$ebnf$1",
    symbols: [],
    postprocess: () => null
  }, {
    name: "limit_clause",
    symbols: [pt.has("LIMIT") ? {
      type: "LIMIT"
    } : LIMIT, "_", "expression_chain_", "limit_clause$ebnf$1"],
    postprocess: ([l, u, T, N]) => {
      if (N) {
        const [O, h] = N;
        return {
          type: it.limit_clause,
          limitKw: Jr(gr(l), {
            trailing: u
          }),
          offset: T,
          count: h
        };
      } else
        return {
          type: it.limit_clause,
          limitKw: Jr(gr(l), {
            trailing: u
          }),
          count: T
        };
    }
  }, {
    name: "select_clause$subexpression$1$ebnf$1",
    symbols: []
  }, {
    name: "select_clause$subexpression$1$ebnf$1",
    symbols: ["select_clause$subexpression$1$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "select_clause$subexpression$1",
    symbols: ["all_columns_asterisk", "select_clause$subexpression$1$ebnf$1"]
  }, {
    name: "select_clause$subexpression$1$ebnf$2",
    symbols: []
  }, {
    name: "select_clause$subexpression$1$ebnf$2",
    symbols: ["select_clause$subexpression$1$ebnf$2", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "select_clause$subexpression$1",
    symbols: ["asteriskless_free_form_sql", "select_clause$subexpression$1$ebnf$2"]
  }, {
    name: "select_clause",
    symbols: [pt.has("RESERVED_SELECT") ? {
      type: "RESERVED_SELECT"
    } : RESERVED_SELECT, "select_clause$subexpression$1"],
    postprocess: ([l, [u, T]]) => ({
      type: it.clause,
      nameKw: gr(l),
      children: [u, ...T]
    })
  }, {
    name: "select_clause",
    symbols: [pt.has("RESERVED_SELECT") ? {
      type: "RESERVED_SELECT"
    } : RESERVED_SELECT],
    postprocess: ([l]) => ({
      type: it.clause,
      nameKw: gr(l),
      children: []
    })
  }, {
    name: "all_columns_asterisk",
    symbols: [pt.has("ASTERISK") ? {
      type: "ASTERISK"
    } : ASTERISK],
    postprocess: () => ({
      type: it.all_columns_asterisk
    })
  }, {
    name: "other_clause$ebnf$1",
    symbols: []
  }, {
    name: "other_clause$ebnf$1",
    symbols: ["other_clause$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "other_clause",
    symbols: [pt.has("RESERVED_CLAUSE") ? {
      type: "RESERVED_CLAUSE"
    } : RESERVED_CLAUSE, "other_clause$ebnf$1"],
    postprocess: ([l, u]) => ({
      type: it.clause,
      nameKw: gr(l),
      children: u
    })
  }, {
    name: "set_operation$ebnf$1",
    symbols: []
  }, {
    name: "set_operation$ebnf$1",
    symbols: ["set_operation$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "set_operation",
    symbols: [pt.has("RESERVED_SET_OPERATION") ? {
      type: "RESERVED_SET_OPERATION"
    } : RESERVED_SET_OPERATION, "set_operation$ebnf$1"],
    postprocess: ([l, u]) => ({
      type: it.set_operation,
      nameKw: gr(l),
      children: u
    })
  }, {
    name: "expression_chain_$ebnf$1",
    symbols: ["expression_with_comments_"]
  }, {
    name: "expression_chain_$ebnf$1",
    symbols: ["expression_chain_$ebnf$1", "expression_with_comments_"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "expression_chain_",
    symbols: ["expression_chain_$ebnf$1"],
    postprocess: NI
  }, {
    name: "expression_chain$ebnf$1",
    symbols: []
  }, {
    name: "expression_chain$ebnf$1",
    symbols: ["expression_chain$ebnf$1", "_expression_with_comments"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "expression_chain",
    symbols: ["expression", "expression_chain$ebnf$1"],
    postprocess: ([l, u]) => [l, ...u]
  }, {
    name: "andless_expression_chain$ebnf$1",
    symbols: []
  }, {
    name: "andless_expression_chain$ebnf$1",
    symbols: ["andless_expression_chain$ebnf$1", "_andless_expression_with_comments"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "andless_expression_chain",
    symbols: ["andless_expression", "andless_expression_chain$ebnf$1"],
    postprocess: ([l, u]) => [l, ...u]
  }, {
    name: "expression_with_comments_",
    symbols: ["expression", "_"],
    postprocess: ([l, u]) => Jr(l, {
      trailing: u
    })
  }, {
    name: "_expression_with_comments",
    symbols: ["_", "expression"],
    postprocess: ([l, u]) => Jr(u, {
      leading: l
    })
  }, {
    name: "_andless_expression_with_comments",
    symbols: ["_", "andless_expression"],
    postprocess: ([l, u]) => Jr(u, {
      leading: l
    })
  }, {
    name: "free_form_sql$subexpression$1",
    symbols: ["asteriskless_free_form_sql"]
  }, {
    name: "free_form_sql$subexpression$1",
    symbols: ["asterisk"]
  }, {
    name: "free_form_sql",
    symbols: ["free_form_sql$subexpression$1"],
    postprocess: ET
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["asteriskless_andless_expression"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["logic_operator"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["between_predicate"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["comma"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["comment"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["other_keyword"]
  }, {
    name: "asteriskless_free_form_sql",
    symbols: ["asteriskless_free_form_sql$subexpression$1"],
    postprocess: ET
  }, {
    name: "expression$subexpression$1",
    symbols: ["andless_expression"]
  }, {
    name: "expression$subexpression$1",
    symbols: ["logic_operator"]
  }, {
    name: "expression",
    symbols: ["expression$subexpression$1"],
    postprocess: ET
  }, {
    name: "andless_expression$subexpression$1",
    symbols: ["asteriskless_andless_expression"]
  }, {
    name: "andless_expression$subexpression$1",
    symbols: ["asterisk"]
  }, {
    name: "andless_expression",
    symbols: ["andless_expression$subexpression$1"],
    postprocess: ET
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["array_subscript"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["case_expression"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["function_call"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["property_access"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["parenthesis"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["curly_braces"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["square_brackets"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["operator"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["identifier"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["parameter"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["literal"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["keyword"]
  }, {
    name: "asteriskless_andless_expression",
    symbols: ["asteriskless_andless_expression$subexpression$1"],
    postprocess: ET
  }, {
    name: "array_subscript",
    symbols: [pt.has("ARRAY_IDENTIFIER") ? {
      type: "ARRAY_IDENTIFIER"
    } : ARRAY_IDENTIFIER, "_", "square_brackets"],
    postprocess: ([l, u, T]) => ({
      type: it.array_subscript,
      array: Jr({
        type: it.identifier,
        text: l.text
      }, {
        trailing: u
      }),
      parenthesis: T
    })
  }, {
    name: "array_subscript",
    symbols: [pt.has("ARRAY_KEYWORD") ? {
      type: "ARRAY_KEYWORD"
    } : ARRAY_KEYWORD, "_", "square_brackets"],
    postprocess: ([l, u, T]) => ({
      type: it.array_subscript,
      array: Jr(gr(l), {
        trailing: u
      }),
      parenthesis: T
    })
  }, {
    name: "function_call",
    symbols: [pt.has("RESERVED_FUNCTION_NAME") ? {
      type: "RESERVED_FUNCTION_NAME"
    } : RESERVED_FUNCTION_NAME, "_", "parenthesis"],
    postprocess: ([l, u, T]) => ({
      type: it.function_call,
      nameKw: Jr(gr(l), {
        trailing: u
      }),
      parenthesis: T
    })
  }, {
    name: "parenthesis",
    symbols: [{
      literal: "("
    }, "expressions_or_clauses", {
      literal: ")"
    }],
    postprocess: ([l, u, T]) => ({
      type: it.parenthesis,
      children: u,
      openParen: "(",
      closeParen: ")"
    })
  }, {
    name: "curly_braces$ebnf$1",
    symbols: []
  }, {
    name: "curly_braces$ebnf$1",
    symbols: ["curly_braces$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "curly_braces",
    symbols: [{
      literal: "{"
    }, "curly_braces$ebnf$1", {
      literal: "}"
    }],
    postprocess: ([l, u, T]) => ({
      type: it.parenthesis,
      children: u,
      openParen: "{",
      closeParen: "}"
    })
  }, {
    name: "square_brackets$ebnf$1",
    symbols: []
  }, {
    name: "square_brackets$ebnf$1",
    symbols: ["square_brackets$ebnf$1", "free_form_sql"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "square_brackets",
    symbols: [{
      literal: "["
    }, "square_brackets$ebnf$1", {
      literal: "]"
    }],
    postprocess: ([l, u, T]) => ({
      type: it.parenthesis,
      children: u,
      openParen: "[",
      closeParen: "]"
    })
  }, {
    name: "property_access$subexpression$1",
    symbols: ["identifier"]
  }, {
    name: "property_access$subexpression$1",
    symbols: ["array_subscript"]
  }, {
    name: "property_access$subexpression$1",
    symbols: ["all_columns_asterisk"]
  }, {
    name: "property_access",
    symbols: ["expression", "_", pt.has("DOT") ? {
      type: "DOT"
    } : DOT, "_", "property_access$subexpression$1"],
    postprocess: (
      // Allowing property to be <array_subscript> is currently a hack.
      // A better way would be to allow <property_access> on the left side of array_subscript,
      // but we currently can't do that because of another hack that requires
      // %ARRAY_IDENTIFIER on the left side of <array_subscript>.
      ([l, u, T, N, [O]]) => ({
        type: it.property_access,
        object: Jr(l, {
          trailing: u
        }),
        property: Jr(O, {
          leading: N
        })
      })
    )
  }, {
    name: "between_predicate",
    symbols: [pt.has("BETWEEN") ? {
      type: "BETWEEN"
    } : BETWEEN, "_", "andless_expression_chain", "_", pt.has("AND") ? {
      type: "AND"
    } : AND, "_", "andless_expression"],
    postprocess: ([l, u, T, N, O, h, d]) => ({
      type: it.between_predicate,
      betweenKw: gr(l),
      expr1: Fb(T, {
        leading: u,
        trailing: N
      }),
      andKw: gr(O),
      expr2: [Jr(d, {
        leading: h
      })]
    })
  }, {
    name: "case_expression$ebnf$1",
    symbols: ["expression_chain_"],
    postprocess: NI
  }, {
    name: "case_expression$ebnf$1",
    symbols: [],
    postprocess: () => null
  }, {
    name: "case_expression$ebnf$2",
    symbols: []
  }, {
    name: "case_expression$ebnf$2",
    symbols: ["case_expression$ebnf$2", "case_clause"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "case_expression",
    symbols: [pt.has("CASE") ? {
      type: "CASE"
    } : CASE, "_", "case_expression$ebnf$1", "case_expression$ebnf$2", pt.has("END") ? {
      type: "END"
    } : END],
    postprocess: ([l, u, T, N, O]) => ({
      type: it.case_expression,
      caseKw: Jr(gr(l), {
        trailing: u
      }),
      endKw: gr(O),
      expr: T || [],
      clauses: N
    })
  }, {
    name: "case_clause",
    symbols: [pt.has("WHEN") ? {
      type: "WHEN"
    } : WHEN, "_", "expression_chain_", pt.has("THEN") ? {
      type: "THEN"
    } : THEN, "_", "expression_chain_"],
    postprocess: ([l, u, T, N, O, h]) => ({
      type: it.case_when,
      whenKw: Jr(gr(l), {
        trailing: u
      }),
      thenKw: Jr(gr(N), {
        trailing: O
      }),
      condition: T,
      result: h
    })
  }, {
    name: "case_clause",
    symbols: [pt.has("ELSE") ? {
      type: "ELSE"
    } : ELSE, "_", "expression_chain_"],
    postprocess: ([l, u, T]) => ({
      type: it.case_else,
      elseKw: Jr(gr(l), {
        trailing: u
      }),
      result: T
    })
  }, {
    name: "comma$subexpression$1",
    symbols: [pt.has("COMMA") ? {
      type: "COMMA"
    } : COMMA]
  }, {
    name: "comma",
    symbols: ["comma$subexpression$1"],
    postprocess: ([[l]]) => ({
      type: it.comma
    })
  }, {
    name: "asterisk$subexpression$1",
    symbols: [pt.has("ASTERISK") ? {
      type: "ASTERISK"
    } : ASTERISK]
  }, {
    name: "asterisk",
    symbols: ["asterisk$subexpression$1"],
    postprocess: ([[l]]) => ({
      type: it.operator,
      text: l.text
    })
  }, {
    name: "operator$subexpression$1",
    symbols: [pt.has("OPERATOR") ? {
      type: "OPERATOR"
    } : OPERATOR]
  }, {
    name: "operator",
    symbols: ["operator$subexpression$1"],
    postprocess: ([[l]]) => ({
      type: it.operator,
      text: l.text
    })
  }, {
    name: "identifier$subexpression$1",
    symbols: [pt.has("IDENTIFIER") ? {
      type: "IDENTIFIER"
    } : IDENTIFIER]
  }, {
    name: "identifier$subexpression$1",
    symbols: [pt.has("QUOTED_IDENTIFIER") ? {
      type: "QUOTED_IDENTIFIER"
    } : QUOTED_IDENTIFIER]
  }, {
    name: "identifier$subexpression$1",
    symbols: [pt.has("VARIABLE") ? {
      type: "VARIABLE"
    } : VARIABLE]
  }, {
    name: "identifier",
    symbols: ["identifier$subexpression$1"],
    postprocess: ([[l]]) => ({
      type: it.identifier,
      text: l.text
    })
  }, {
    name: "parameter$subexpression$1",
    symbols: [pt.has("NAMED_PARAMETER") ? {
      type: "NAMED_PARAMETER"
    } : NAMED_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [pt.has("QUOTED_PARAMETER") ? {
      type: "QUOTED_PARAMETER"
    } : QUOTED_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [pt.has("NUMBERED_PARAMETER") ? {
      type: "NUMBERED_PARAMETER"
    } : NUMBERED_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [pt.has("POSITIONAL_PARAMETER") ? {
      type: "POSITIONAL_PARAMETER"
    } : POSITIONAL_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [pt.has("CUSTOM_PARAMETER") ? {
      type: "CUSTOM_PARAMETER"
    } : CUSTOM_PARAMETER]
  }, {
    name: "parameter",
    symbols: ["parameter$subexpression$1"],
    postprocess: ([[l]]) => ({
      type: it.parameter,
      key: l.key,
      text: l.text
    })
  }, {
    name: "literal$subexpression$1",
    symbols: [pt.has("NUMBER") ? {
      type: "NUMBER"
    } : NUMBER]
  }, {
    name: "literal$subexpression$1",
    symbols: [pt.has("STRING") ? {
      type: "STRING"
    } : STRING]
  }, {
    name: "literal",
    symbols: ["literal$subexpression$1"],
    postprocess: ([[l]]) => ({
      type: it.literal,
      text: l.text
    })
  }, {
    name: "keyword$subexpression$1",
    symbols: [pt.has("RESERVED_KEYWORD") ? {
      type: "RESERVED_KEYWORD"
    } : RESERVED_KEYWORD]
  }, {
    name: "keyword$subexpression$1",
    symbols: [pt.has("RESERVED_PHRASE") ? {
      type: "RESERVED_PHRASE"
    } : RESERVED_PHRASE]
  }, {
    name: "keyword$subexpression$1",
    symbols: [pt.has("RESERVED_JOIN") ? {
      type: "RESERVED_JOIN"
    } : RESERVED_JOIN]
  }, {
    name: "keyword",
    symbols: ["keyword$subexpression$1"],
    postprocess: ([[l]]) => gr(l)
  }, {
    name: "logic_operator$subexpression$1",
    symbols: [pt.has("AND") ? {
      type: "AND"
    } : AND]
  }, {
    name: "logic_operator$subexpression$1",
    symbols: [pt.has("OR") ? {
      type: "OR"
    } : OR]
  }, {
    name: "logic_operator$subexpression$1",
    symbols: [pt.has("XOR") ? {
      type: "XOR"
    } : XOR]
  }, {
    name: "logic_operator",
    symbols: ["logic_operator$subexpression$1"],
    postprocess: ([[l]]) => gr(l)
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [pt.has("WHEN") ? {
      type: "WHEN"
    } : WHEN]
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [pt.has("THEN") ? {
      type: "THEN"
    } : THEN]
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [pt.has("ELSE") ? {
      type: "ELSE"
    } : ELSE]
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [pt.has("END") ? {
      type: "END"
    } : END]
  }, {
    name: "other_keyword",
    symbols: ["other_keyword$subexpression$1"],
    postprocess: ([[l]]) => gr(l)
  }, {
    name: "_$ebnf$1",
    symbols: []
  }, {
    name: "_$ebnf$1",
    symbols: ["_$ebnf$1", "comment"],
    postprocess: (l) => l[0].concat([l[1]])
  }, {
    name: "_",
    symbols: ["_$ebnf$1"],
    postprocess: ([l]) => l
  }, {
    name: "comment",
    symbols: [pt.has("LINE_COMMENT") ? {
      type: "LINE_COMMENT"
    } : LINE_COMMENT],
    postprocess: ([l]) => ({
      type: it.line_comment,
      text: l.text,
      precedingWhitespace: l.precedingWhitespace
    })
  }, {
    name: "comment",
    symbols: [pt.has("BLOCK_COMMENT") ? {
      type: "BLOCK_COMMENT"
    } : BLOCK_COMMENT],
    postprocess: ([l]) => ({
      type: it.block_comment,
      text: l.text,
      precedingWhitespace: l.precedingWhitespace
    })
  }],
  ParserStart: "main"
}, Yb = wb, {
  Parser: Vb,
  Grammar: Wb
} = Pb;
function Xb(l) {
  let u = {};
  const T = new JL((O) => [...Mb(l.tokenize(O, u)), HL(O.length)]), N = new Vb(Wb.fromCompiled(Yb), {
    lexer: T
  });
  return {
    parse: (O, h) => {
      u = h;
      const {
        results: d
      } = N.feed(O);
      if (d.length === 1)
        return d[0];
      throw d.length === 0 ? new Error("Parse error: Invalid SQL") : new Error(`Parse error: Ambiguous grammar
${JSON.stringify(d, void 0, 2)}`);
    }
  };
}
const kb = /^\s+/u;
function Kb(l, u, T) {
  return jb(l.split(`
`)).flatMap((N) => {
    if (N.length === 1)
      return N;
    if (u === "tabular")
      return zb(N);
    if (u === "before")
      return Qb(N, T);
    throw new Error(`Unexpected commaPosition: ${u}`);
  }).join(`
`);
}
function jb(l) {
  const u = [];
  for (let T = 0; T < l.length; T++) {
    const N = [l[T]];
    for (; l[T].match(/.*,(\s*(--.*)?$)/); )
      T++, N.push(l[T]);
    u.push(N);
  }
  return u;
}
function zb(l) {
  const u = YL($b(l)) - 1;
  return l.map((T, N) => N === l.length - 1 ? T : Jb(T, u));
}
function Jb(l, u) {
  const [, T, N] = l.match(/^(.*?),(\s*--.*)?$/) || [], O = " ".repeat(u - T.length);
  return `${T}${O},${N ?? ""}`;
}
function Qb(l, u) {
  return qb(l).map((T, N) => {
    if (N === 0)
      return T;
    const [O] = T.match(kb) || [""];
    return Zb(O, u) + u.replace(/ {2}$/, ", ") + // add comma to the end of last indent
    T.trimStart();
  });
}
function Zb(l, u) {
  return l.replace(new RegExp(u + "$"), "");
}
function qb(l) {
  return l.map((u) => u.replace(/,(\s*(--.*)?$)/, "$1"));
}
function $b(l) {
  return l.map((u) => u.replace(/\s*--.*/, ""));
}
function eH(l) {
  const u = l.split(`
`);
  let T = [];
  for (let N = 0; N < u.length; N++) {
    if (u[N].match(/^\s*SELECT/i)) {
      let O = [];
      if (u[N].match(/.*,$/))
        O = [u[N]];
      else {
        if (T.push(u[N]), u[N].match(/^\s*SELECT\s+.+(?!,$)/i))
          continue;
        O.push(u[++N]);
      }
      for (; u[N++].match(/.*,$/); )
        O.push(u[N]);
      const h = O.map((G) => ({
        line: G,
        matches: G.match(/(^.*?\S) (AS )?(\S+,?$)/i)
      })).map(({
        line: G,
        matches: D
      }) => D ? {
        precedingText: D[1],
        as: D[2],
        alias: D[3]
      } : {
        precedingText: G
      }), d = YL(h.map(({
        precedingText: G
      }) => G.replace(/\s*,\s*$/, "")));
      O = h.map(({
        precedingText: G,
        as: D,
        alias: v
      }) => G + (v ? " ".repeat(d - G.length + 1) + (D ?? "") + v : "")), T = [...T, ...O];
    }
    T.push(u[N]);
  }
  return T.join(`
`);
}
let ie;
(function(l) {
  l[l.SPACE = 0] = "SPACE", l[l.NO_SPACE = 1] = "NO_SPACE", l[l.NO_NEWLINE = 2] = "NO_NEWLINE", l[l.NEWLINE = 3] = "NEWLINE", l[l.MANDATORY_NEWLINE = 4] = "MANDATORY_NEWLINE", l[l.INDENT = 5] = "INDENT", l[l.SINGLE_INDENT = 6] = "SINGLE_INDENT";
})(ie || (ie = {}));
class QL {
  constructor(u) {
    Yn(this, "items", []);
    this.indentation = u;
  }
  /**
   * Appends token strings and whitespace modifications to SQL string.
   */
  add(...u) {
    for (const T of u)
      switch (T) {
        case ie.SPACE:
          this.items.push(ie.SPACE);
          break;
        case ie.NO_SPACE:
          this.trimHorizontalWhitespace();
          break;
        case ie.NO_NEWLINE:
          this.trimWhitespace();
          break;
        case ie.NEWLINE:
          this.trimHorizontalWhitespace(), this.addNewline(ie.NEWLINE);
          break;
        case ie.MANDATORY_NEWLINE:
          this.trimHorizontalWhitespace(), this.addNewline(ie.MANDATORY_NEWLINE);
          break;
        case ie.INDENT:
          this.addIndentation();
          break;
        case ie.SINGLE_INDENT:
          this.items.push(ie.SINGLE_INDENT);
          break;
        default:
          this.items.push(T);
      }
  }
  trimHorizontalWhitespace() {
    for (; tH(PA(this.items)); )
      this.items.pop();
  }
  trimWhitespace() {
    for (; nH(PA(this.items)); )
      this.items.pop();
  }
  addNewline(u) {
    if (this.items.length > 0)
      switch (PA(this.items)) {
        case ie.NEWLINE:
          this.items.pop(), this.items.push(u);
          break;
        case ie.MANDATORY_NEWLINE:
          break;
        default:
          this.items.push(u);
          break;
      }
  }
  addIndentation() {
    for (let u = 0; u < this.indentation.getLevel(); u++)
      this.items.push(ie.SINGLE_INDENT);
  }
  /**
   * Returns the final SQL string.
   */
  toString() {
    return this.items.map((u) => this.itemToString(u)).join("");
  }
  /**
   * Returns the internal layout data
   */
  getLayoutItems() {
    return this.items;
  }
  itemToString(u) {
    switch (u) {
      case ie.SPACE:
        return " ";
      case ie.NEWLINE:
      case ie.MANDATORY_NEWLINE:
        return `
`;
      case ie.SINGLE_INDENT:
        return this.indentation.getSingleIndent();
      default:
        return u;
    }
  }
}
const tH = (l) => l === ie.SPACE || l === ie.SINGLE_INDENT, nH = (l) => l === ie.SPACE || l === ie.SINGLE_INDENT || l === ie.NEWLINE;
function rH(l, u) {
  if (u === "standard")
    return l;
  let T = [];
  return l.length >= 10 && l.includes(" ") && ([l, ...T] = l.split(" ")), u === "tabularLeft" ? l = l.padEnd(9, " ") : l = l.padStart(9, " "), l + ["", ...T].join(" ");
}
function aH(l) {
  return M0(l) || l === Re.RESERVED_CLAUSE || l === Re.RESERVED_SELECT || l === Re.RESERVED_SET_OPERATION || l === Re.RESERVED_JOIN || l === Re.LIMIT;
}
const pI = "top-level", iH = "block-level";
class ZL {
  /**
   * @param {string} indent A string to indent with
   */
  constructor(u) {
    Yn(this, "indentTypes", []);
    this.indent = u;
  }
  /**
   * Returns indentation string for single indentation step.
   */
  getSingleIndent() {
    return this.indent;
  }
  /**
   * Returns current indentation level
   */
  getLevel() {
    return this.indentTypes.length;
  }
  /**
   * Increases indentation by one top-level indent.
   */
  increaseTopLevel() {
    this.indentTypes.push(pI);
  }
  /**
   * Increases indentation by one block-level indent.
   */
  increaseBlockLevel() {
    this.indentTypes.push(iH);
  }
  /**
   * Decreases indentation by one top-level indent.
   * Does nothing when the previous indent is not top-level.
   */
  decreaseTopLevel() {
    this.indentTypes.length > 0 && PA(this.indentTypes) === pI && this.indentTypes.pop();
  }
  /**
   * Decreases indentation by one block-level indent.
   * If there are top-level indents within the block-level indent,
   * throws away these as well.
   */
  decreaseBlockLevel() {
    for (; this.indentTypes.length > 0 && this.indentTypes.pop() === pI; )
      ;
  }
}
class oH extends QL {
  constructor(T) {
    super(new ZL(""));
    Yn(this, "length", 0);
    // Keeps track of the trailing whitespace,
    // so that we can decrease length when encountering WS.NO_SPACE,
    // but only when there actually is a space to remove.
    Yn(this, "trailingSpace", !1);
    this.expressionWidth = T;
  }
  add(...T) {
    if (T.forEach((N) => this.addToLength(N)), this.length > this.expressionWidth)
      throw new yI();
    super.add(...T);
  }
  addToLength(T) {
    if (typeof T == "string")
      this.length += T.length, this.trailingSpace = !1;
    else {
      if (T === ie.MANDATORY_NEWLINE || T === ie.NEWLINE)
        throw new yI();
      T === ie.INDENT || T === ie.SINGLE_INDENT || T === ie.SPACE ? this.trailingSpace || (this.length++, this.trailingSpace = !0) : (T === ie.NO_NEWLINE || T === ie.NO_SPACE) && this.trailingSpace && (this.trailingSpace = !1, this.length--);
    }
  }
}
class yI extends Error {
}
class wS {
  constructor({
    cfg: u,
    dialectCfg: T,
    params: N,
    layout: O,
    inline: h = !1
  }) {
    Yn(this, "inline", !1);
    Yn(this, "nodes", []);
    Yn(this, "index", -1);
    this.cfg = u, this.dialectCfg = T, this.inline = h, this.params = N, this.layout = O;
  }
  format(u) {
    for (this.nodes = u, this.index = 0; this.index < this.nodes.length; this.index++)
      this.formatNode(this.nodes[this.index]);
    return this.layout;
  }
  formatNode(u) {
    this.formatComments(u.leadingComments), this.formatNodeWithoutComments(u), this.formatComments(u.trailingComments);
  }
  formatNodeWithoutComments(u) {
    switch (u.type) {
      case it.function_call:
        return this.formatFunctionCall(u);
      case it.array_subscript:
        return this.formatArraySubscript(u);
      case it.property_access:
        return this.formatPropertyAccess(u);
      case it.parenthesis:
        return this.formatParenthesis(u);
      case it.between_predicate:
        return this.formatBetweenPredicate(u);
      case it.case_expression:
        return this.formatCaseExpression(u);
      case it.case_when:
        return this.formatCaseWhen(u);
      case it.case_else:
        return this.formatCaseElse(u);
      case it.clause:
        return this.formatClause(u);
      case it.set_operation:
        return this.formatSetOperation(u);
      case it.limit_clause:
        return this.formatLimitClause(u);
      case it.all_columns_asterisk:
        return this.formatAllColumnsAsterisk(u);
      case it.literal:
        return this.formatLiteral(u);
      case it.identifier:
        return this.formatIdentifier(u);
      case it.parameter:
        return this.formatParameter(u);
      case it.operator:
        return this.formatOperator(u);
      case it.comma:
        return this.formatComma(u);
      case it.line_comment:
        return this.formatLineComment(u);
      case it.block_comment:
        return this.formatBlockComment(u);
      case it.keyword:
        return this.formatKeywordNode(u);
    }
  }
  formatFunctionCall(u) {
    this.withComments(u.nameKw, () => {
      this.layout.add(this.showKw(u.nameKw));
    }), this.formatNode(u.parenthesis);
  }
  formatArraySubscript(u) {
    this.withComments(u.array, () => {
      this.layout.add(u.array.type === it.keyword ? this.showKw(u.array) : u.array.text);
    }), this.formatNode(u.parenthesis);
  }
  formatPropertyAccess(u) {
    this.formatNode(u.object), this.layout.add(ie.NO_SPACE, "."), this.formatNode(u.property);
  }
  formatParenthesis(u) {
    const T = this.formatInlineExpression(u.children);
    T ? (this.layout.add(u.openParen), this.layout.add(...T.getLayoutItems()), this.layout.add(ie.NO_SPACE, u.closeParen, ie.SPACE)) : (this.layout.add(u.openParen, ie.NEWLINE), yA(this.cfg) ? (this.layout.add(ie.INDENT), this.layout = this.formatSubExpression(u.children)) : (this.layout.indentation.increaseBlockLevel(), this.layout.add(ie.INDENT), this.layout = this.formatSubExpression(u.children), this.layout.indentation.decreaseBlockLevel()), this.layout.add(ie.NEWLINE, ie.INDENT, u.closeParen, ie.SPACE));
  }
  formatBetweenPredicate(u) {
    this.layout.add(this.showKw(u.betweenKw), ie.SPACE), this.layout = this.formatSubExpression(u.expr1), this.layout.add(ie.NO_SPACE, ie.SPACE, this.showNonTabularKw(u.andKw), ie.SPACE), this.layout = this.formatSubExpression(u.expr2), this.layout.add(ie.SPACE);
  }
  formatCaseExpression(u) {
    this.formatNode(u.caseKw), this.layout.indentation.increaseBlockLevel(), this.layout = this.formatSubExpression(u.expr), this.layout = this.formatSubExpression(u.clauses), this.layout.indentation.decreaseBlockLevel(), this.layout.add(ie.NEWLINE, ie.INDENT), this.formatNode(u.endKw);
  }
  formatCaseWhen(u) {
    this.layout.add(ie.NEWLINE, ie.INDENT), this.formatNode(u.whenKw), this.layout = this.formatSubExpression(u.condition), this.formatNode(u.thenKw), this.layout = this.formatSubExpression(u.result);
  }
  formatCaseElse(u) {
    this.layout.add(ie.NEWLINE, ie.INDENT), this.formatNode(u.elseKw), this.layout = this.formatSubExpression(u.result);
  }
  formatClause(u) {
    this.isOnelineClause(u) ? this.formatClauseInOnelineStyle(u) : yA(this.cfg) ? this.formatClauseInTabularStyle(u) : this.formatClauseInIndentedStyle(u);
  }
  isOnelineClause(u) {
    return this.dialectCfg.onelineClauses[u.nameKw.text];
  }
  formatClauseInIndentedStyle(u) {
    this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u.nameKw), ie.NEWLINE), this.layout.indentation.increaseTopLevel(), this.layout.add(ie.INDENT), this.layout = this.formatSubExpression(u.children), this.layout.indentation.decreaseTopLevel();
  }
  formatClauseInOnelineStyle(u) {
    this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u.nameKw), ie.SPACE), this.layout = this.formatSubExpression(u.children);
  }
  formatClauseInTabularStyle(u) {
    this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u.nameKw), ie.SPACE), this.layout.indentation.increaseTopLevel(), this.layout = this.formatSubExpression(u.children), this.layout.indentation.decreaseTopLevel();
  }
  formatSetOperation(u) {
    this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u.nameKw), ie.NEWLINE), this.layout.add(ie.INDENT), this.layout = this.formatSubExpression(u.children);
  }
  formatLimitClause(u) {
    this.withComments(u.limitKw, () => {
      this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u.limitKw));
    }), this.layout.indentation.increaseTopLevel(), yA(this.cfg) ? this.layout.add(ie.SPACE) : this.layout.add(ie.NEWLINE, ie.INDENT), u.offset ? (this.layout = this.formatSubExpression(u.offset), this.layout.add(ie.NO_SPACE, ",", ie.SPACE), this.layout = this.formatSubExpression(u.count)) : this.layout = this.formatSubExpression(u.count), this.layout.indentation.decreaseTopLevel();
  }
  formatAllColumnsAsterisk(u) {
    this.layout.add("*", ie.SPACE);
  }
  formatLiteral(u) {
    this.layout.add(u.text, ie.SPACE);
  }
  formatIdentifier(u) {
    this.layout.add(u.text, ie.SPACE);
  }
  formatParameter(u) {
    this.layout.add(this.params.get(u), ie.SPACE);
  }
  formatOperator({
    text: u
  }) {
    this.cfg.denseOperators || this.dialectCfg.alwaysDenseOperators.includes(u) ? this.layout.add(ie.NO_SPACE, u) : u === ":" ? this.layout.add(ie.NO_SPACE, u, ie.SPACE) : this.layout.add(u, ie.SPACE);
  }
  formatComma(u) {
    this.inline ? this.layout.add(ie.NO_SPACE, ",", ie.SPACE) : this.layout.add(ie.NO_SPACE, ",", ie.NEWLINE, ie.INDENT);
  }
  withComments(u, T) {
    this.formatComments(u.leadingComments), T(), this.formatComments(u.trailingComments);
  }
  formatComments(u) {
    u && u.forEach((T) => {
      T.type === it.line_comment ? this.formatLineComment(T) : this.formatBlockComment(T);
    });
  }
  formatLineComment(u) {
    dI(u.precedingWhitespace || "") ? this.layout.add(ie.NEWLINE, ie.INDENT, u.text, ie.MANDATORY_NEWLINE, ie.INDENT) : this.layout.getLayoutItems().length > 0 ? this.layout.add(ie.NO_NEWLINE, ie.SPACE, u.text, ie.MANDATORY_NEWLINE, ie.INDENT) : this.layout.add(u.text, ie.MANDATORY_NEWLINE, ie.INDENT);
  }
  formatBlockComment(u) {
    this.isMultilineBlockComment(u) ? (this.splitBlockComment(u.text).forEach((T) => {
      this.layout.add(ie.NEWLINE, ie.INDENT, T);
    }), this.layout.add(ie.NEWLINE, ie.INDENT)) : this.layout.add(u.text, ie.SPACE);
  }
  isMultilineBlockComment(u) {
    return dI(u.text) || dI(u.precedingWhitespace || "");
  }
  isDocComment(u) {
    const T = u.split(/\n/);
    return (
      // first line starts with /* or /**
      /^\/\*\*?$/.test(T[0]) && // intermediate lines start with *
      T.slice(1, T.length - 1).every((N) => /^\s*\*/.test(N)) && // last line ends with */
      /^\s*\*\/$/.test(PA(T))
    );
  }
  // Breaks up block comment to multiple lines.
  // For example this doc-comment (dots representing leading whitespace):
  //
  //   ..../**
  //   .....* Some description here
  //   .....* and here too
  //   .....*/
  //
  // gets broken to this array (note the leading single spaces):
  //
  //   [ '/**',
  //     '.* Some description here',
  //     '.* and here too',
  //     '.*/' ]
  //
  // However, a normal comment (non-doc-comment) like this:
  //
  //   ..../*
  //   ....Some description here
  //   ....*/
  //
  // gets broken to this array (no leading spaces):
  //
  //   [ '/*',
  //     'Some description here',
  //     '*/' ]
  //
  splitBlockComment(u) {
    return this.isDocComment(u) ? u.split(/\n/).map((T) => /^\s*\*/.test(T) ? " " + T.replace(/^\s*/, "") : T) : u.split(/\n/).map((T) => T.replace(/^\s*/, ""));
  }
  formatSubExpression(u) {
    return new wS({
      cfg: this.cfg,
      dialectCfg: this.dialectCfg,
      params: this.params,
      layout: this.layout,
      inline: this.inline
    }).format(u);
  }
  formatInlineExpression(u) {
    const T = this.params.getPositionalParameterIndex();
    try {
      return new wS({
        cfg: this.cfg,
        dialectCfg: this.dialectCfg,
        params: this.params,
        layout: new oH(this.cfg.expressionWidth),
        inline: !0
      }).format(u);
    } catch (N) {
      if (N instanceof yI) {
        this.params.setPositionalParameterIndex(T);
        return;
      } else
        throw N;
    }
  }
  formatKeywordNode(u) {
    switch (u.tokenType) {
      case Re.RESERVED_JOIN:
        return this.formatJoin(u);
      case Re.AND:
      case Re.OR:
      case Re.XOR:
        return this.formatLogicalOperator(u);
      default:
        return this.formatKeyword(u);
    }
  }
  formatJoin(u) {
    yA(this.cfg) ? (this.layout.indentation.decreaseTopLevel(), this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u), ie.SPACE), this.layout.indentation.increaseTopLevel()) : this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u), ie.SPACE);
  }
  formatKeyword(u) {
    this.layout.add(this.showKw(u), ie.SPACE);
  }
  formatLogicalOperator(u) {
    this.cfg.logicalOperatorNewline === "before" ? yA(this.cfg) ? (this.layout.indentation.decreaseTopLevel(), this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u), ie.SPACE), this.layout.indentation.increaseTopLevel()) : this.layout.add(ie.NEWLINE, ie.INDENT, this.showKw(u), ie.SPACE) : this.layout.add(this.showKw(u), ie.NEWLINE, ie.INDENT);
  }
  showKw(u) {
    return aH(u.tokenType) ? rH(this.showNonTabularKw(u), this.cfg.indentStyle) : this.showNonTabularKw(u);
  }
  // Like showKw(), but skips tabular formatting
  showNonTabularKw(u) {
    switch (this.cfg.keywordCase) {
      case "preserve":
        return VL(u.raw);
      case "upper":
        return u.text;
      case "lower":
        return u.text.toLowerCase();
    }
  }
}
class lH {
  constructor(u, T) {
    this.dialect = u, this.cfg = T, this.params = new Db(this.cfg.params);
  }
  /**
   * Formats an SQL query.
   * @param {string} query - The SQL query string to be formatted
   * @return {string} The formatter query
   */
  format(u) {
    const T = this.parse(u), N = this.formatAst(T);
    return this.postFormat(N).trimEnd();
  }
  parse(u) {
    return Xb(this.dialect.tokenizer).parse(u, this.cfg.paramTypes || {});
  }
  formatAst(u) {
    return u.map((T) => this.formatStatement(T)).join(`
`.repeat(this.cfg.linesBetweenQueries + 1));
  }
  formatStatement(u) {
    const T = new wS({
      cfg: this.cfg,
      dialectCfg: this.dialect.formatOptions,
      params: this.params,
      layout: new QL(new ZL(eL(this.cfg)))
    }).format(u.children);
    return u.hasSemicolon && (this.cfg.newlineBeforeSemicolon ? T.add(ie.NEWLINE, ";") : T.add(ie.NO_NEWLINE, ";")), T.toString();
  }
  postFormat(u) {
    return this.cfg.tabulateAlias && (u = eH(u)), (this.cfg.commaPosition === "before" || this.cfg.commaPosition === "tabular") && (u = Kb(u, this.cfg.commaPosition, eL(this.cfg))), u;
  }
}
class yE extends Error {
}
function sH(l) {
  if ("multilineLists" in l)
    throw new yE("multilineLists config is no more supported.");
  if ("newlineBeforeOpenParen" in l)
    throw new yE("newlineBeforeOpenParen config is no more supported.");
  if ("newlineBeforeCloseParen" in l)
    throw new yE("newlineBeforeCloseParen config is no more supported.");
  if ("aliasAs" in l)
    throw new yE("aliasAs config is no more supported.");
  if (l.expressionWidth <= 0)
    throw new yE(`expressionWidth config must be positive number. Received ${l.expressionWidth} instead.`);
  if (l.commaPosition === "before" && l.useTabs)
    throw new yE("commaPosition: before does not work when tabs are used for indentation.");
  return l.params && !uH(l.params) && console.warn('WARNING: All "params" option values should be strings.'), l;
}
function uH(l) {
  return (l instanceof Array ? l : Object.values(l)).every((T) => typeof T == "string");
}
const qL = {
  bigquery: "bigquery",
  db2: "db2",
  hive: "hive",
  mariadb: "mariadb",
  mysql: "mysql",
  n1ql: "n1ql",
  plsql: "plsql",
  postgresql: "postgresql",
  redshift: "redshift",
  spark: "spark",
  sqlite: "sqlite",
  sql: "sql",
  trino: "trino",
  transactsql: "transactsql",
  tsql: "transactsql",
  // alias for transactsq
  singlestoredb: "singlestoredb",
  snowflake: "snowflake"
}, EH = Object.keys(qL), cH = {
  tabWidth: 2,
  useTabs: !1,
  keywordCase: "preserve",
  indentStyle: "standard",
  logicalOperatorNewline: "before",
  tabulateAlias: !1,
  commaPosition: "after",
  expressionWidth: 50,
  linesBetweenQueries: 1,
  denseOperators: !1,
  newlineBeforeSemicolon: !1
}, TH = (l, u = {}) => {
  if (typeof u.language == "string" && !EH.includes(u.language))
    throw new yE(`Unsupported SQL dialect: ${u.language}`);
  const T = qL[u.language || "sql"];
  return fH(l, {
    ...u,
    dialect: Eb[T]
  });
}, fH = (l, {
  dialect: u,
  ...T
}) => {
  if (typeof l != "string")
    throw new Error("Invalid query argument. Expected string, instead got " + typeof l);
  const N = sH({
    ...cH,
    ...T
  });
  return new lH(mb(u), N).format(l);
};
function AH({
  title: l,
  subtitle: u,
  backTo: T
}) {
  return /* @__PURE__ */ m.jsxs("div", { className: "border-b-primary-400 mb-4 flex border-b pb-4", children: [
    /* @__PURE__ */ m.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ m.jsx("h2", { className: "text-primary-300 text-xl", children: l }),
      u && /* @__PURE__ */ m.jsx("h3", { className: "font-mono", children: u })
    ] }),
    /* @__PURE__ */ m.jsx(
      Lo,
      {
        className: "hover:bg-primary-900 -my-1 flex cursor-pointer items-center justify-center rounded px-6 py-1 font-mono text-2xl",
        to: T,
        children: "✕"
      }
    )
  ] });
}
function RH(l) {
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: "border-l-primary-400 from-primary-900 to-primary-950 fixed bottom-0 left-1/4 right-0 top-0 h-full overflow-auto border-l bg-gradient-to-br to-20% px-6 py-4",
      ...l
    }
  );
}
function dH(l, u = 2) {
  if (l == 0)
    return "0 B";
  const T = 1024, N = u, O = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], h = Math.floor(Math.log(l) / Math.log(T));
  return parseFloat((l / Math.pow(T, h)).toFixed(N)) + " " + O[h];
}
function FI({
  traceContext: l,
  tree: u,
  startTimestamp: T,
  totalDuration: N,
  depth: O = 1
}) {
  const { spanId: h } = MI();
  return !u || !u.length ? null : /* @__PURE__ */ m.jsx("ul", { className: "tree", children: u.map((d) => {
    const G = UA(d.start_timestamp, d.timestamp);
    return /* @__PURE__ */ m.jsxs("li", { className: "pl-4", children: [
      /* @__PURE__ */ m.jsxs(
        Lo,
        {
          className: Ii(
            "hover:bg-primary-900 flex cursor-pointer text-sm",
            h === d.span_id ? "bg-primary-900" : ""
          ),
          to: `/traces/${d.trace_id}/${d.span_id}`,
          children: [
            /* @__PURE__ */ m.jsxs("div", { className: Ii("node", d.status && d.status !== "ok" ? "text-red-400" : ""), children: [
              d.transaction && /* @__PURE__ */ m.jsx(TT, { size: 16, platform: d.transaction.platform }),
              d.op && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
                /* @__PURE__ */ m.jsx("span", { className: "font-bold", children: d.op }),
                /* @__PURE__ */ m.jsx("span", { className: "text-primary-400", children: "–" })
              ] }),
              /* @__PURE__ */ m.jsx("span", { className: "block max-w-sm truncate", title: d.description || d.span_id, children: d.description || d.span_id })
            ] }),
            /* @__PURE__ */ m.jsx("div", { className: "waterfall", children: /* @__PURE__ */ m.jsx(
              "div",
              {
                className: "bg-primary-900 absolute -m-0.5 w-full p-0.5",
                style: {
                  left: `min(${(d.start_timestamp - T) / N * 100}%, 95% - 1px)`,
                  width: `max(1px, ${G / N * 95}%)`
                },
                children: /* @__PURE__ */ m.jsxs("span", { className: Ii("whitespace-nowrap", P0(G)), children: [
                  G.toLocaleString(),
                  " ms"
                ] })
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ m.jsx(
        FI,
        {
          traceContext: l,
          tree: d.children || [],
          startTimestamp: T,
          totalDuration: N,
          depth: O + 1
        }
      )
    ] }, d.span_id);
  }) });
}
function SH(l) {
  if (l.match(/^(SELECT|INSERT|UPDATE|DELETE|TRUNCATE|ALTER) /i))
    try {
      return TH(l.replace(/([\s,(])(%[a-z])([\s,)])/gim, "$1?$3"));
    } catch (u) {
      console.error(u);
    }
  return l;
}
function NH(l, u) {
  return typeof u == "number" ? l.indexOf("size") !== -1 || l.indexOf("length") !== -1 ? dH(u) : u.toLocaleString() : u;
}
function pH({
  traceContext: l,
  span: u,
  startTimestamp: T,
  totalDuration: N
}) {
  var d, G;
  const O = UA(u.start_timestamp, u.timestamp), h = pa.getEventsByTrace(u.trace_id).filter((D) => D.type !== "transaction" && "exception" in D);
  return /* @__PURE__ */ m.jsxs(RH, { children: [
    /* @__PURE__ */ m.jsx(
      AH,
      {
        title: "Span Details",
        subtitle: /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
          u.op && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
            u.op,
            " ",
            /* @__PURE__ */ m.jsx("span", { className: "text-primary-500", children: "—" }),
            " "
          ] }),
          u.span_id
        ] }),
        backTo: `/traces/${u.trace_id}`
      }
    ),
    /* @__PURE__ */ m.jsxs("div", { className: "space-y-6", children: [
      /* @__PURE__ */ m.jsx("div", { children: /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col space-y-4", children: [
        /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex flex-1 items-center gap-x-1", children: [
          /* @__PURE__ */ m.jsx(bL, { date: u.start_timestamp }),
          /* @__PURE__ */ m.jsx("span", { children: "—" }),
          /* @__PURE__ */ m.jsxs("span", { children: [
            /* @__PURE__ */ m.jsxs("strong", { children: [
              UA(T, u.start_timestamp),
              " ms"
            ] }),
            " into trace"
          ] })
        ] }),
        /* @__PURE__ */ m.jsx("div", { className: "flex-1", children: /* @__PURE__ */ m.jsx("div", { className: "border-primary-800 relative h-8 border py-1", children: /* @__PURE__ */ m.jsx(
          "div",
          {
            className: "bg-primary-800 absolute bottom-0 top-0 -m-0.5 flex w-full items-center p-0.5",
            style: {
              left: `min(${(u.start_timestamp - T) / N * 100}%, 100% - 1px)`,
              width: `max(1px, ${O / N * 100}%)`
            },
            children: /* @__PURE__ */ m.jsxs("span", { className: "whitespace-nowrap", children: [
              O,
              " ms"
            ] })
          }
        ) }) })
      ] }) }),
      !!h.length && /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col items-start", children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Related Errors" }),
        h.map((D) => /* @__PURE__ */ m.jsx(Lo, { className: "cursor-pointer underline", to: `/errors/${D.event_id}`, children: /* @__PURE__ */ m.jsx(UL, { event: D }) }, D.event_id))
      ] }),
      /* @__PURE__ */ m.jsxs("div", { children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Description" }),
        u.description ? /* @__PURE__ */ m.jsx("pre", { className: "text-primary-300 whitespace-pre-wrap break-words font-mono text-sm", children: SH(u.description) }) : /* @__PURE__ */ m.jsx("div", { className: "text-primary-300", children: "No description recorded for this span." })
      ] }),
      u.op === "resource.img" && ((d = u.description) == null ? void 0 : d.indexOf("/")) === 0 && /* @__PURE__ */ m.jsxs("div", { children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Preview" }),
        /* @__PURE__ */ m.jsx(
          "a",
          {
            href: u.description,
            className: "border-primary-950 hover:border-primary-700 -m-2 inline-block max-w-sm cursor-pointer rounded border p-1",
            children: /* @__PURE__ */ m.jsx("img", { src: u.description, alt: "preview", style: { maxHeight: 300 } })
          }
        )
      ] }),
      /* @__PURE__ */ m.jsxs("div", { children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Tags" }),
        u.tags && Object.keys(u.tags).length ? /* @__PURE__ */ m.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ m.jsx("tbody", { children: Object.entries(u.tags).map(([D, v]) => /* @__PURE__ */ m.jsxs("tr", { className: "text-primary-300", children: [
          /* @__PURE__ */ m.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ m.jsx("div", { className: "w-full truncate", children: D }) }),
          /* @__PURE__ */ m.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ m.jsx("pre", { className: "whitespace-nowrap font-mono", children: JSON.stringify(v, void 0, 2) }) })
        ] }, D)) }) }) : /* @__PURE__ */ m.jsx("div", { className: "text-primary-300", children: "No tags recorded for this span." })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Context" }),
        /* @__PURE__ */ m.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ m.jsx("tbody", { children: [
          ["status", u.status || ""],
          ["trace", u.trace_id],
          ["span", u.span_id],
          [
            "parent",
            u.parent_span_id ? /* @__PURE__ */ m.jsx(Lo, { className: "underline", to: `/traces/${u.trace_id}/${u.parent_span_id}`, children: u.parent_span_id }) : ""
          ],
          ["op", u.op]
        ].map(([D, v]) => /* @__PURE__ */ m.jsxs("tr", { className: "text-primary-300", children: [
          /* @__PURE__ */ m.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ m.jsx("div", { className: "w-full truncate", children: D }) }),
          /* @__PURE__ */ m.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ m.jsx("pre", { className: "whitespace-nowrap font-mono", children: v }) })
        ] }, D)) }) })
      ] }),
      u.data && /* @__PURE__ */ m.jsxs("div", { children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Data" }),
        /* @__PURE__ */ m.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ m.jsx("tbody", { children: Object.entries(u.data).map(([D, v]) => /* @__PURE__ */ m.jsxs("tr", { className: "text-primary-300", children: [
          /* @__PURE__ */ m.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ m.jsx("div", { className: "w-full truncate", children: D }) }),
          /* @__PURE__ */ m.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ m.jsx("pre", { className: "whitespace-nowrap font-mono", children: NH(D, v) }) })
        ] }, D)) }) })
      ] }),
      !!((G = u.children) != null && G.length) && /* @__PURE__ */ m.jsxs("div", { children: [
        /* @__PURE__ */ m.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Sub-tree" }),
        /* @__PURE__ */ m.jsx(
          FI,
          {
            traceContext: l,
            tree: [u],
            startTimestamp: T,
            totalDuration: N
          }
        )
      ] })
    ] })
  ] });
}
function tL() {
  var d;
  const { traceId: l, spanId: u } = MI();
  if (!l)
    return /* @__PURE__ */ m.jsx("p", { children: "Unknown trace id" });
  const T = pa.getTraceById(l), N = u ? pa.getSpanById(T.trace_id, u) : void 0, O = T.start_timestamp, h = T.timestamp - O;
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsxs("div", { className: "border-b-primary-700 bg-primary-950 flex items-center gap-x-2 border-b px-6 py-4", children: [
      /* @__PURE__ */ m.jsx(TT, { platform: (d = T.rootTransaction) == null ? void 0 : d.platform }),
      /* @__PURE__ */ m.jsx("h1", { className: "max-w-full flex-1 truncate text-2xl", children: T.rootTransactionName }),
      /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 font-mono", children: [
        /* @__PURE__ */ m.jsxs("div", { children: [
          "T: ",
          T.trace_id
        ] }),
        /* @__PURE__ */ m.jsxs("div", { children: [
          "S:",
          " ",
          /* @__PURE__ */ m.jsx(Lo, { to: `/traces/${T.trace_id}/${T.span_id}`, className: "underline", children: T.span_id })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx("div", { className: "px-6 py-4", children: /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex flex-1 items-center gap-x-1", children: [
      /* @__PURE__ */ m.jsx("div", { className: "text-primary-200", children: /* @__PURE__ */ m.jsx(bL, { date: T.start_timestamp }) }),
      /* @__PURE__ */ m.jsx("span", { children: "—" }),
      /* @__PURE__ */ m.jsxs("span", { children: [
        /* @__PURE__ */ m.jsxs("strong", { className: "text-primary-200 font-bold", children: [
          UA(T.start_timestamp, T.timestamp).toLocaleString(),
          " ms"
        ] }),
        " ",
        "recorded in",
        " ",
        /* @__PURE__ */ m.jsxs("strong", { className: "text-primary-200 font-bold", children: [
          T.spans.length.toLocaleString(),
          " spans"
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ m.jsx("div", { className: "flex-1 px-2 pb-6", children: /* @__PURE__ */ m.jsx(
      FI,
      {
        traceContext: T,
        tree: T.spanTree,
        startTimestamp: O,
        totalDuration: h
      }
    ) }),
    N ? /* @__PURE__ */ m.jsx(pH, { traceContext: T, startTimestamp: O, totalDuration: h, span: N }) : null
  ] });
}
const OH = () => (W.useContext(wA), pa.getTraces());
function IH() {
  const l = OH(), u = ML(), T = yL(), [N, O] = W.useState(!T.experiments["sentry:focus-local-events"]), h = N ? l : l.filter((G) => u.isLocalToSession(G.trace_id) !== !1), d = l.length - h.length;
  return /* @__PURE__ */ m.jsx(m.Fragment, { children: l.length !== 0 ? /* @__PURE__ */ m.jsxs(xI, { children: [
    d > 0 && /* @__PURE__ */ m.jsx(
      _L,
      {
        itemCount: d,
        onClick: () => {
          O(!0);
        }
      }
    ),
    h.map((G) => {
      var v;
      const D = UA(G.start_timestamp, G.timestamp);
      return /* @__PURE__ */ m.jsxs(
        Lo,
        {
          className: "hover:bg-primary-900 flex cursor-pointer items-center gap-x-4 px-6 py-2",
          to: G.trace_id,
          children: [
            /* @__PURE__ */ m.jsx(TT, { platform: (v = G.rootTransaction) == null ? void 0 : v.platform }),
            /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex w-48 flex-col truncate font-mono text-sm", children: [
              /* @__PURE__ */ m.jsxs("div", { className: "flex items-center gap-x-2", children: [
                /* @__PURE__ */ m.jsx("div", { children: G.trace_id.substring(0, 8) }),
                u.isLocalToSession(G.trace_id) ? /* @__PURE__ */ m.jsx(DL, { title: "This trace is part of your local session.", children: "Local" }) : null
              ] }),
              /* @__PURE__ */ m.jsx(bI, { date: G.start_timestamp })
            ] }),
            /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col truncate font-mono", children: [
              /* @__PURE__ */ m.jsx("div", { children: G.rootTransactionName }),
              /* @__PURE__ */ m.jsxs("div", { className: "text-primary-300 flex space-x-2 text-sm", children: [
                /* @__PURE__ */ m.jsx(
                  "div",
                  {
                    className: Ii(
                      G.status === "ok" ? "text-green-400" : G.status ? "text-red-400" : ""
                    ),
                    children: G.status || ""
                  }
                ),
                /* @__PURE__ */ m.jsx("div", { children: "—" }),
                /* @__PURE__ */ m.jsxs("div", { children: [
                  D,
                  " ms"
                ] }),
                /* @__PURE__ */ m.jsx("div", { children: "—" }),
                /* @__PURE__ */ m.jsxs("div", { children: [
                  G.spans.length.toLocaleString(),
                  " spans, ",
                  G.transactions.length.toLocaleString(),
                  " txns"
                ] })
              ] })
            ] })
          ]
        },
        G.trace_id
      );
    })
  ] }) : /* @__PURE__ */ m.jsx("div", { className: "text-primary-300 p-6", children: "Looks like there's no traces recorded matching this query. 🤔" }) });
}
function CH() {
  return /* @__PURE__ */ m.jsx(HI, { children: /* @__PURE__ */ m.jsxs(FA, { children: [
    /* @__PURE__ */ m.jsx(Vi, { path: "/:traceId/:spanId", element: /* @__PURE__ */ m.jsx(tL, {}) }),
    /* @__PURE__ */ m.jsx(Vi, { path: "/:traceId", element: /* @__PURE__ */ m.jsx(tL, {}) }),
    /* @__PURE__ */ m.jsx(Vi, { path: "/", element: /* @__PURE__ */ m.jsx(IH, {}) })
  ] }) });
}
const hH = "application/x-sentry-envelope";
function vH(l) {
  return {
    name: "sentry",
    forwardedContentType: [hH],
    setup: ({ open: u }) => {
      LH(l);
      const T = uu(), N = (O) => {
        Qr("Sentry Event", O.detail.event_id), O.detail.event && pa.pushEvent(O.detail.event), u(`/errors/${O.detail.eventId}`);
      };
      return T.addEventListener("sentry:showError", N), () => {
        T.removeEventListener("sentry:showError", N);
      };
    },
    processEvent: (u) => mH(u),
    tabs: () => {
      const u = pa.getEvents().filter(
        (T) => {
          var N, O, h, d;
          return T.type != "transaction" && ((O = (N = T.contexts) == null ? void 0 : N.trace) != null && O.trace_id ? pa.isTraceLocal((d = (h = T.contexts) == null ? void 0 : h.trace) == null ? void 0 : d.trace_id) : null) !== !1;
        }
      ).length;
      return [
        {
          id: "errors",
          title: "Errors",
          notificationCount: {
            count: u,
            severe: u > 0
          },
          content: L0
        },
        {
          id: "traces",
          title: "Traces",
          notificationCount: {
            count: pa.getTraces().filter((T) => pa.isTraceLocal(T.trace_id) !== !1).length
          },
          content: CH
        },
        {
          id: "sdks",
          title: "SDKs",
          content: g0
        }
      ];
    }
  };
}
function mH({ data: l }) {
  const [u, ...T] = l.split(/\n/gm), N = JSON.parse(u), O = [];
  for (let d = 0; d < T.length; d += 2) {
    if (!T[d] || !T[d + 1])
      continue;
    const G = JSON.parse(T[d]), D = JSON.parse(T[d + 1]);
    G.type && (D.type = G.type), O.push([G, D]);
  }
  const h = [N, O];
  return pa.pushEnvelope(h), {
    event: h
  };
}
function LH(l) {
  var N;
  const u = (N = window.__SENTRY__) == null ? void 0 : N.hub, T = u == null ? void 0 : u.getClient();
  if (T) {
    const O = new Y_({
      sidecarUrl: l == null ? void 0 : l.sidecarUrl
    });
    T.addIntegration(O);
  }
}
function yH({ processedEvents: l }) {
  const u = l || [];
  return /* @__PURE__ */ m.jsxs("div", { className: "divide-primary-900 bg-primary-950 divide-y p-4", children: [
    /* @__PURE__ */ m.jsx("h1", { className: "mb-2 text-xl", children: "Console Logs" }),
    /* @__PURE__ */ m.jsx("div", { className: "flex flex-col gap-2", children: u.map((T, N) => /* @__PURE__ */ m.jsxs("div", { className: "bg-primary-500 py-4 pl-4", children: [
      /* @__PURE__ */ m.jsx("span", { className: "bg-primary-600 p-2 font-bold", children: T.type.toUpperCase() }),
      /* @__PURE__ */ m.jsx("span", { className: "ml-4 font-mono", children: T.msg })
    ] }, N)) })
  ] });
}
const $L = "application/x-spotlight-console", DH = 8969;
function BH() {
  const l = window.crypto.randomUUID();
  return {
    name: "console",
    forwardedContentType: [$L],
    tabs: ({ processedEvents: u }) => [
      {
        id: "console",
        title: "Browser Console Logs",
        notificationCount: { count: u.length },
        content: yH
      }
    ],
    setup: () => {
      OI("log", l), OI("warn", l), OI("error", l);
    },
    processEvent({ data: u }) {
      return {
        event: JSON.parse(u)
      };
    }
  };
}
function OI(l, u) {
  const T = window.console[l];
  window.console[l] = (...N) => {
    const O = gH(N);
    if (O.find((h) => h.toLowerCase().includes("spotlight")))
      return T(...N);
    try {
      fetch(`http://localhost:${DH}/stream`, {
        method: "POST",
        body: JSON.stringify({
          type: l,
          args: O,
          msg: O.join(" "),
          sessionId: u
        }),
        headers: {
          "Content-Type": $L
        },
        mode: "cors"
      }).catch(() => {
      });
    } catch {
    }
    return T(...N);
  };
}
function gH(l) {
  return l.map((u) => u === null ? "null" : u === void 0 ? "undefined" : typeof u == "string" ? u : PH(u));
}
function PH(l) {
  try {
    return JSON.stringify(l);
  } catch {
    return "[serialization error]";
  }
}
function MH() {
  return /* @__PURE__ */ m.jsx("div", { className: "divide-primary-900 bg-primary-950 h-full w-full divide-y", children: /* @__PURE__ */ m.jsx("div", { className: "flex h-full w-full flex-col gap-2", children: /* @__PURE__ */ m.jsx("iframe", { src: "http://localhost:4321/__inspect/", className: "h-full w-full" }) }) });
}
function FH() {
  return {
    name: "vite-inspect",
    tabs: () => [
      {
        id: "vite-inspect",
        title: "Vite Inspect",
        content: MH
      }
    ],
    setup: () => {
    }
  };
}
function nL(l) {
  const u = new CSSStyleSheet();
  return u.replaceSync(l), u;
}
async function UH(l) {
  uu().dispatchEvent(
    new CustomEvent("open", {
      detail: { path: l }
    })
  );
}
async function _H() {
  uu().dispatchEvent(new CustomEvent("close"));
}
async function wH(l) {
  uu().addEventListener("closed", l);
}
async function YH(l) {
  uu().addEventListener("opened", l);
}
async function VH(l) {
  uu().addEventListener("severeEventCount", (u) => {
    var T;
    l(((T = u.detail) == null ? void 0 : T.count) ?? 1);
  });
}
async function WH(l, u) {
  uu().dispatchEvent(
    new CustomEvent(l, {
      detail: u
    })
  );
}
async function XH({
  openOnInit: l = !1,
  showTriggerButton: u = !0,
  injectImmediately: T = !1,
  sidecarUrl: N = o_,
  anchor: O = OL,
  debug: h = !1,
  integrations: d,
  experiments: G = mI
} = {}) {
  if (typeof document > "u")
    return;
  const D = { ...mI, ...G };
  if (window.__spotlight)
    return;
  h && c_();
  const M = [vH({ sidecarUrl: N })], g = {
    open: UH,
    close: _H,
    experiments: D
  }, [w] = await CL(d ?? M, g), Y = document.createElement("div");
  Y.id = "sentry-spotlight-root";
  const j = Y.attachShadow({ mode: "open" }), oe = document.createElement("div");
  oe.style.position = "absolute", oe.style.top = "0", oe.style.left = "0", oe.style.right = "0", j.appendChild(oe);
  const me = nL(A_);
  j.adoptedStyleSheets = [nL(xU), me];
  const Le = w.map((Fe) => Fe.tabs ? Fe.tabs({ processedEvents: [] }).map((ye) => ({
    ...ye,
    processedEvents: []
  })) : []).flat(), Oe = Le.length ? `/${Le[0].id}` : "/no-tabs";
  gA.createRoot(oe).render(
    // <React.StrictMode>
    /* @__PURE__ */ m.jsx(U1, { initialEntries: [Oe], children: /* @__PURE__ */ m.jsx(W_, { context: g, children: /* @__PURE__ */ m.jsx(
      f_,
      {
        integrations: w,
        openOnInit: l,
        showTriggerButton: u,
        sidecarUrl: N,
        anchor: O
      }
    ) }) })
    // </React.StrictMode>
  );
  function he() {
    Qr("Injecting into application"), document.body.append(Y);
  }
  T ? he() : window.addEventListener("load", () => {
    he();
  });
}
export {
  _H as closeSpotlight,
  BH as console,
  XH as init,
  wH as onClose,
  YH as onOpen,
  VH as onSevereEvent,
  UH as openSpotlight,
  vH as sentry,
  WH as trigger,
  FH as viteInspect
};
//# sourceMappingURL=sentry-spotlight.js.map
